import BABYLON$1, { Color3, StandardMaterial, Vector3, BoundingInfo, AbstractMesh, SceneLoader, ShadowGenerator, Texture, PointerEventTypes } from 'babylonjs';
import 'babylonjs-loaders';
import * as GUI from 'babylonjs-gui';
import React, { createContext } from 'react';
var CUSTOM_COMPONENTS =
/*#__PURE__*/
Object.freeze({
  get AdvancedDynamicTextureLifecycleListener() {
    return AdvancedDynamicTextureLifecycleListener;
  },

  get CameraLifecycleListener() {
    return CameraLifecycleListener;
  },

  get EnvironmentHelperLifecycleListener() {
    return EnvironmentHelperLifecycleListener;
  },

  get GUI2DControlLifecycleListener() {
    return GUI2DControlLifecycleListener;
  },

  get GUI3DControlLifecycleListener() {
    return GUI3DControlLifecycleListener;
  },

  get GUI3DManagerLifecycleListener() {
    return GUI3DManagerLifecycleListener;
  },

  get MaterialsLifecycleListener() {
    return MaterialsLifecycleListener;
  },

  get MeshLifecycleListener() {
    return MeshLifecycleListener;
  },

  get ModelLifecycleListener() {
    return ModelLifecycleListener;
  },

  get ShadowGeneratorLifecycleListener() {
    return AdvancedDynamicTextureLifecycleListener$1;
  },

  get Skybox() {
    return Skybox;
  },

  get TargetPropsHandler() {
    return TargetPropsHandler;
  },

  get TexturesLifecycleListener() {
    return TexturesLifecycleListener;
  },

  get VRExperienceHelperLifecycleListener() {
    return VRExperienceHelperLifecycleListener;
  }

});

var __extends = undefined && undefined.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var FiberNodeProps =
/** @class */
function () {
  function FiberNodeProps() {}

  return FiberNodeProps;
}();

var FiberNodePropsHandler =
/** @class */
function () {
  function FiberNodePropsHandler() {}

  FiberNodePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: any property (not coded) BABYLON.Node.addToSceneRootNodes.
    // TODO: type: BABYLON.AnimationPropertiesOverride property (not coded) BABYLON.Node.animationPropertiesOverride.
    // TODO: type: BABYLON.Animation[] property (not coded) BABYLON.Node.animations.
    // BABYLON.Node.doNotSerialize of type 'boolean':

    if (oldProps.doNotSerialize !== newProps.doNotSerialize) {
      updates.push({
        propertyName: "doNotSerialize",
        value: newProps.doNotSerialize,
        type: "boolean"
      });
    } // BABYLON.Node.id of type 'string':


    if (oldProps.id !== newProps.id) {
      updates.push({
        propertyName: "id",
        value: newProps.id,
        type: "string"
      });
    } // TODO: type: any property (not coded) BABYLON.Node.metadata.
    // BABYLON.Node.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // BABYLON.Node.onDispose of type '() => void/fn':


    if (oldProps.onDispose === undefined && oldProps.onDispose !== newProps.onDispose) {
      updates.push({
        propertyName: "onDispose",
        value: newProps.onDispose,
        type: "() => void"
      });
    } // BABYLON.Node.onDisposeObservable of type 'BABYLON.Observable<BABYLON.Node>/fn':


    if (oldProps.onDisposeObservable === undefined && oldProps.onDisposeObservable !== newProps.onDisposeObservable) {
      updates.push({
        propertyName: "onDisposeObservable",
        value: newProps.onDisposeObservable,
        type: "BABYLON.Observable<BABYLON.Node>"
      });
    } // BABYLON.Node.onReady of type '(node: BABYLON.Node) => void/fn':


    if (oldProps.onReady === undefined && oldProps.onReady !== newProps.onReady) {
      updates.push({
        propertyName: "onReady",
        value: newProps.onReady,
        type: "(node: BABYLON.Node) => void"
      });
    } // TODO: type: BABYLON.Node property (not coded) BABYLON.Node.parent.
    // TODO: type: any property (not coded) BABYLON.Node.removeFromSceneRootNodes.
    // TODO: type: any property (not coded) BABYLON.Node.reservedDataStore.
    // BABYLON.Node.state of type 'string':


    if (oldProps.state !== newProps.state) {
      updates.push({
        propertyName: "state",
        value: newProps.state,
        type: "string"
      });
    } // BABYLON.Node.uniqueId of type 'number':


    if (oldProps.uniqueId !== newProps.uniqueId) {
      updates.push({
        propertyName: "uniqueId",
        value: newProps.uniqueId,
        type: "number"
      });
    } // BABYLON.Node.setEnabled of type '(value?: boolean)':


    if (oldProps.setEnabled !== newProps.setEnabled) {
      updates.push({
        propertyName: "setEnabled",
        value: newProps.setEnabled,
        type: "(value?: boolean)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberNodePropsHandler;
}();
/**
 * Node is the basic class for all scene objects (Mesh, Light, Camera.)
 *
 * This code has been generated
 */


var FiberNode =
/** @class */
function () {
  function FiberNode() {
    this.propsHandlers = [new FiberNodePropsHandler()];
  }

  FiberNode.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberNode.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberNode.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Node",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }, {
      name: "addToRootNodes",
      type: "boolean",
      optional: true
    }]
  };
  FiberNode.Metadata = {
    className: "FiberNode",
    isMesh: false
  };
  return FiberNode;
}();

var FiberTransformNodeProps =
/** @class */
function (_super) {
  __extends(FiberTransformNodeProps, _super);

  function FiberTransformNodeProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberTransformNodeProps;
}(FiberNodeProps);

var FiberTransformNodePropsHandler =
/** @class */
function () {
  function FiberTransformNodePropsHandler() {}

  FiberTransformNodePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.TransformNode.billboardMode of type 'number':

    if (oldProps.billboardMode !== newProps.billboardMode) {
      updates.push({
        propertyName: "billboardMode",
        value: newProps.billboardMode,
        type: "number"
      });
    } // BABYLON.TransformNode.ignoreNonUniformScaling of type 'boolean':


    if (oldProps.ignoreNonUniformScaling !== newProps.ignoreNonUniformScaling) {
      updates.push({
        propertyName: "ignoreNonUniformScaling",
        value: newProps.ignoreNonUniformScaling,
        type: "boolean"
      });
    } // BABYLON.TransformNode.infiniteDistance of type 'boolean':


    if (oldProps.infiniteDistance !== newProps.infiniteDistance) {
      updates.push({
        propertyName: "infiniteDistance",
        value: newProps.infiniteDistance,
        type: "boolean"
      });
    } // BABYLON.TransformNode.onAfterWorldMatrixUpdateObservable of type 'BABYLON.Observable<BABYLON.TransformNode>/fn':


    if (oldProps.onAfterWorldMatrixUpdateObservable === undefined && oldProps.onAfterWorldMatrixUpdateObservable !== newProps.onAfterWorldMatrixUpdateObservable) {
      updates.push({
        propertyName: "onAfterWorldMatrixUpdateObservable",
        value: newProps.onAfterWorldMatrixUpdateObservable,
        type: "BABYLON.Observable<BABYLON.TransformNode>"
      });
    } // BABYLON.TransformNode.position of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.position && (!oldProps.position || !oldProps.position.equals(newProps.position))) {
      updates.push({
        propertyName: "position",
        value: newProps.position,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.TransformNode.rotation of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.rotation && (!oldProps.rotation || !oldProps.rotation.equals(newProps.rotation))) {
      updates.push({
        propertyName: "rotation",
        value: newProps.rotation,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Quaternion property (not coded) BABYLON.TransformNode.rotationQuaternion.
    // BABYLON.TransformNode.scaling of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.scaling && (!oldProps.scaling || !oldProps.scaling.equals(newProps.scaling))) {
      updates.push({
        propertyName: "scaling",
        value: newProps.scaling,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.TransformNode.scalingDeterminant of type 'number':


    if (oldProps.scalingDeterminant !== newProps.scalingDeterminant) {
      updates.push({
        propertyName: "scalingDeterminant",
        value: newProps.scalingDeterminant,
        type: "number"
      });
    } // BABYLON.TransformNode.setAbsolutePosition of type '(absolutePosition?: BABYLON.Vector3)':


    if (oldProps.setAbsolutePosition !== newProps.setAbsolutePosition) {
      updates.push({
        propertyName: "setAbsolutePosition",
        value: newProps.setAbsolutePosition,
        type: "(absolutePosition?: BABYLON.Vector3)"
      });
    } // BABYLON.TransformNode.setDirection of type '(localAxis?: BABYLON.Vector3, yawCor?: number, pitchCor?: number, rollCor?: number)':


    if (oldProps.setDirection !== newProps.setDirection) {
      updates.push({
        propertyName: "setDirection",
        value: newProps.setDirection,
        type: "(localAxis?: BABYLON.Vector3, yawCor?: number, pitchCor?: number, rollCor?: number)"
      });
    } // BABYLON.TransformNode.setParent of type '(node?: BABYLON.Node)':


    if (oldProps.setParent !== newProps.setParent) {
      updates.push({
        propertyName: "setParent",
        value: newProps.setParent,
        type: "(node?: BABYLON.Node)"
      });
    } // BABYLON.TransformNode.setPivotMatrix of type '(matrix?: BABYLON.DeepImmutableObject<BABYLON.Matrix>, postMultiplyPivotMatrix?: boolean)':


    if (oldProps.setPivotMatrix !== newProps.setPivotMatrix) {
      updates.push({
        propertyName: "setPivotMatrix",
        value: newProps.setPivotMatrix,
        type: "(matrix?: BABYLON.DeepImmutableObject<BABYLON.Matrix>, postMultiplyPivotMatrix?: boolean)"
      });
    } // BABYLON.TransformNode.setPivotPoint of type '(point?: BABYLON.Vector3, space?: BABYLON.Space)':


    if (oldProps.setPivotPoint !== newProps.setPivotPoint) {
      updates.push({
        propertyName: "setPivotPoint",
        value: newProps.setPivotPoint,
        type: "(point?: BABYLON.Vector3, space?: BABYLON.Space)"
      });
    } // BABYLON.TransformNode.setPositionWithLocalVector of type '(vector3?: BABYLON.Vector3)':


    if (oldProps.setPositionWithLocalVector !== newProps.setPositionWithLocalVector) {
      updates.push({
        propertyName: "setPositionWithLocalVector",
        value: newProps.setPositionWithLocalVector,
        type: "(vector3?: BABYLON.Vector3)"
      });
    } // BABYLON.TransformNode.setPreTransformMatrix of type '(matrix?: BABYLON.Matrix)':


    if (oldProps.setPreTransformMatrix !== newProps.setPreTransformMatrix) {
      updates.push({
        propertyName: "setPreTransformMatrix",
        value: newProps.setPreTransformMatrix,
        type: "(matrix?: BABYLON.Matrix)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberTransformNodePropsHandler;
}();
/**
 * A TransformNode is an object that is not rendered but can be used as a center of transformation. This can decrease memory usage and increase rendering speed compared to using an empty mesh as a parent and is less complicated than using a pivot matrix.
 *
 * This code has been generated
 */


var FiberTransformNode =
/** @class */
function () {
  function FiberTransformNode() {
    this.propsHandlers = [new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTransformNode.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTransformNode.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTransformNode.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "TransformNode",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }, {
      name: "isPure",
      type: "boolean",
      optional: true
    }]
  };
  FiberTransformNode.Metadata = {
    className: "FiberTransformNode",
    isMesh: false
  };
  return FiberTransformNode;
}();

var FiberAbstractMeshProps =
/** @class */
function (_super) {
  __extends(FiberAbstractMeshProps, _super);

  function FiberAbstractMeshProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAbstractMeshProps;
}(FiberTransformNodeProps);

var FiberAbstractMeshPropsHandler =
/** @class */
function () {
  function FiberAbstractMeshPropsHandler() {}

  FiberAbstractMeshPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.ActionManager property (not coded) BABYLON.AbstractMesh.actionManager.
    // BABYLON.AbstractMesh.alphaIndex of type 'number':

    if (oldProps.alphaIndex !== newProps.alphaIndex) {
      updates.push({
        propertyName: "alphaIndex",
        value: newProps.alphaIndex,
        type: "number"
      });
    } // BABYLON.AbstractMesh.alwaysSelectAsActiveMesh of type 'boolean':


    if (oldProps.alwaysSelectAsActiveMesh !== newProps.alwaysSelectAsActiveMesh) {
      updates.push({
        propertyName: "alwaysSelectAsActiveMesh",
        value: newProps.alwaysSelectAsActiveMesh,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.applyFog of type 'boolean':


    if (oldProps.applyFog !== newProps.applyFog) {
      updates.push({
        propertyName: "applyFog",
        value: newProps.applyFog,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.checkCollisions of type 'boolean':


    if (oldProps.checkCollisions !== newProps.checkCollisions) {
      updates.push({
        propertyName: "checkCollisions",
        value: newProps.checkCollisions,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.collisionGroup of type 'number':


    if (oldProps.collisionGroup !== newProps.collisionGroup) {
      updates.push({
        propertyName: "collisionGroup",
        value: newProps.collisionGroup,
        type: "number"
      });
    } // BABYLON.AbstractMesh.collisionMask of type 'number':


    if (oldProps.collisionMask !== newProps.collisionMask) {
      updates.push({
        propertyName: "collisionMask",
        value: newProps.collisionMask,
        type: "number"
      });
    } // BABYLON.AbstractMesh.computeBonesUsingShaders of type 'boolean':


    if (oldProps.computeBonesUsingShaders !== newProps.computeBonesUsingShaders) {
      updates.push({
        propertyName: "computeBonesUsingShaders",
        value: newProps.computeBonesUsingShaders,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.cullingStrategy of type 'number':


    if (oldProps.cullingStrategy !== newProps.cullingStrategy) {
      updates.push({
        propertyName: "cullingStrategy",
        value: newProps.cullingStrategy,
        type: "number"
      });
    } // BABYLON.AbstractMesh.definedFacingForward of type 'boolean':


    if (oldProps.definedFacingForward !== newProps.definedFacingForward) {
      updates.push({
        propertyName: "definedFacingForward",
        value: newProps.definedFacingForward,
        type: "boolean"
      });
    } // TODO: type: BABYLON.Color4 property (not coded) BABYLON.AbstractMesh.edgesColor.
    // BABYLON.AbstractMesh.edgesWidth of type 'number':


    if (oldProps.edgesWidth !== newProps.edgesWidth) {
      updates.push({
        propertyName: "edgesWidth",
        value: newProps.edgesWidth,
        type: "number"
      });
    } // BABYLON.AbstractMesh.ellipsoid of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.ellipsoid && (!oldProps.ellipsoid || !oldProps.ellipsoid.equals(newProps.ellipsoid))) {
      updates.push({
        propertyName: "ellipsoid",
        value: newProps.ellipsoid,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.AbstractMesh.ellipsoidOffset of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.ellipsoidOffset && (!oldProps.ellipsoidOffset || !oldProps.ellipsoidOffset.equals(newProps.ellipsoidOffset))) {
      updates.push({
        propertyName: "ellipsoidOffset",
        value: newProps.ellipsoidOffset,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.AbstractMesh.enablePointerMoveEvents of type 'boolean':


    if (oldProps.enablePointerMoveEvents !== newProps.enablePointerMoveEvents) {
      updates.push({
        propertyName: "enablePointerMoveEvents",
        value: newProps.enablePointerMoveEvents,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.facetDepthSortFrom of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.facetDepthSortFrom && (!oldProps.facetDepthSortFrom || !oldProps.facetDepthSortFrom.equals(newProps.facetDepthSortFrom))) {
      updates.push({
        propertyName: "facetDepthSortFrom",
        value: newProps.facetDepthSortFrom,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.AbstractMesh.hasVertexAlpha of type 'boolean':


    if (oldProps.hasVertexAlpha !== newProps.hasVertexAlpha) {
      updates.push({
        propertyName: "hasVertexAlpha",
        value: newProps.hasVertexAlpha,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.isBlocker of type 'boolean':


    if (oldProps.isBlocker !== newProps.isBlocker) {
      updates.push({
        propertyName: "isBlocker",
        value: newProps.isBlocker,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.isPickable of type 'boolean':


    if (oldProps.isPickable !== newProps.isPickable) {
      updates.push({
        propertyName: "isPickable",
        value: newProps.isPickable,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.isVisible of type 'boolean':


    if (oldProps.isVisible !== newProps.isVisible) {
      updates.push({
        propertyName: "isVisible",
        value: newProps.isVisible,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.layerMask of type 'number':


    if (oldProps.layerMask !== newProps.layerMask) {
      updates.push({
        propertyName: "layerMask",
        value: newProps.layerMask,
        type: "number"
      });
    } // TODO: type: BABYLON.Material property (not coded) BABYLON.AbstractMesh.material.
    // BABYLON.AbstractMesh.mustDepthSortFacets of type 'boolean':


    if (oldProps.mustDepthSortFacets !== newProps.mustDepthSortFacets) {
      updates.push({
        propertyName: "mustDepthSortFacets",
        value: newProps.mustDepthSortFacets,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.numBoneInfluencers of type 'number':


    if (oldProps.numBoneInfluencers !== newProps.numBoneInfluencers) {
      updates.push({
        propertyName: "numBoneInfluencers",
        value: newProps.numBoneInfluencers,
        type: "number"
      });
    } // BABYLON.AbstractMesh.onCollide of type '() => void/fn':


    if (oldProps.onCollide === undefined && oldProps.onCollide !== newProps.onCollide) {
      updates.push({
        propertyName: "onCollide",
        value: newProps.onCollide,
        type: "() => void"
      });
    } // BABYLON.AbstractMesh.onCollideObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onCollideObservable === undefined && oldProps.onCollideObservable !== newProps.onCollideObservable) {
      updates.push({
        propertyName: "onCollideObservable",
        value: newProps.onCollideObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.AbstractMesh.onCollisionPositionChange of type '() => void/fn':


    if (oldProps.onCollisionPositionChange === undefined && oldProps.onCollisionPositionChange !== newProps.onCollisionPositionChange) {
      updates.push({
        propertyName: "onCollisionPositionChange",
        value: newProps.onCollisionPositionChange,
        type: "() => void"
      });
    } // BABYLON.AbstractMesh.onCollisionPositionChangeObservable of type 'BABYLON.Observable<BABYLON.Vector3>/fn':


    if (oldProps.onCollisionPositionChangeObservable === undefined && oldProps.onCollisionPositionChangeObservable !== newProps.onCollisionPositionChangeObservable) {
      updates.push({
        propertyName: "onCollisionPositionChangeObservable",
        value: newProps.onCollisionPositionChangeObservable,
        type: "BABYLON.Observable<BABYLON.Vector3>"
      });
    } // BABYLON.AbstractMesh.onMaterialChangedObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onMaterialChangedObservable === undefined && oldProps.onMaterialChangedObservable !== newProps.onMaterialChangedObservable) {
      updates.push({
        propertyName: "onMaterialChangedObservable",
        value: newProps.onMaterialChangedObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.AbstractMesh.onRebuildObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onRebuildObservable === undefined && oldProps.onRebuildObservable !== newProps.onRebuildObservable) {
      updates.push({
        propertyName: "onRebuildObservable",
        value: newProps.onRebuildObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.AbstractMesh.outlineColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.outlineColor && (!oldProps.outlineColor || !oldProps.outlineColor.equals(newProps.outlineColor))) {
      updates.push({
        propertyName: "outlineColor",
        value: newProps.outlineColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.AbstractMesh.outlineWidth of type 'number':


    if (oldProps.outlineWidth !== newProps.outlineWidth) {
      updates.push({
        propertyName: "outlineWidth",
        value: newProps.outlineWidth,
        type: "number"
      });
    } // BABYLON.AbstractMesh.overlayAlpha of type 'number':


    if (oldProps.overlayAlpha !== newProps.overlayAlpha) {
      updates.push({
        propertyName: "overlayAlpha",
        value: newProps.overlayAlpha,
        type: "number"
      });
    } // BABYLON.AbstractMesh.overlayColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.overlayColor && (!oldProps.overlayColor || !oldProps.overlayColor.equals(newProps.overlayColor))) {
      updates.push({
        propertyName: "overlayColor",
        value: newProps.overlayColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.AbstractMesh.partitioningBBoxRatio of type 'number':


    if (oldProps.partitioningBBoxRatio !== newProps.partitioningBBoxRatio) {
      updates.push({
        propertyName: "partitioningBBoxRatio",
        value: newProps.partitioningBBoxRatio,
        type: "number"
      });
    } // BABYLON.AbstractMesh.partitioningSubdivisions of type 'number':


    if (oldProps.partitioningSubdivisions !== newProps.partitioningSubdivisions) {
      updates.push({
        propertyName: "partitioningSubdivisions",
        value: newProps.partitioningSubdivisions,
        type: "number"
      });
    } // BABYLON.AbstractMesh.receiveShadows of type 'boolean':


    if (oldProps.receiveShadows !== newProps.receiveShadows) {
      updates.push({
        propertyName: "receiveShadows",
        value: newProps.receiveShadows,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.renderingGroupId of type 'number':


    if (oldProps.renderingGroupId !== newProps.renderingGroupId) {
      updates.push({
        propertyName: "renderingGroupId",
        value: newProps.renderingGroupId,
        type: "number"
      });
    } // BABYLON.AbstractMesh.scaling of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.scaling && (!oldProps.scaling || !oldProps.scaling.equals(newProps.scaling))) {
      updates.push({
        propertyName: "scaling",
        value: newProps.scaling,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.AbstractMesh.showSubMeshesBoundingBox of type 'boolean':


    if (oldProps.showSubMeshesBoundingBox !== newProps.showSubMeshesBoundingBox) {
      updates.push({
        propertyName: "showSubMeshesBoundingBox",
        value: newProps.showSubMeshesBoundingBox,
        type: "boolean"
      });
    } // TODO: type: BABYLON.Skeleton property (not coded) BABYLON.AbstractMesh.skeleton.
    // TODO: type: BABYLON.SubMesh[] property (not coded) BABYLON.AbstractMesh.subMeshes.
    // BABYLON.AbstractMesh.useOctreeForCollisions of type 'boolean':


    if (oldProps.useOctreeForCollisions !== newProps.useOctreeForCollisions) {
      updates.push({
        propertyName: "useOctreeForCollisions",
        value: newProps.useOctreeForCollisions,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.useOctreeForPicking of type 'boolean':


    if (oldProps.useOctreeForPicking !== newProps.useOctreeForPicking) {
      updates.push({
        propertyName: "useOctreeForPicking",
        value: newProps.useOctreeForPicking,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.useOctreeForRenderingSelection of type 'boolean':


    if (oldProps.useOctreeForRenderingSelection !== newProps.useOctreeForRenderingSelection) {
      updates.push({
        propertyName: "useOctreeForRenderingSelection",
        value: newProps.useOctreeForRenderingSelection,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.useVertexColors of type 'boolean':


    if (oldProps.useVertexColors !== newProps.useVertexColors) {
      updates.push({
        propertyName: "useVertexColors",
        value: newProps.useVertexColors,
        type: "boolean"
      });
    } // BABYLON.AbstractMesh.visibility of type 'number':


    if (oldProps.visibility !== newProps.visibility) {
      updates.push({
        propertyName: "visibility",
        value: newProps.visibility,
        type: "number"
      });
    } // BABYLON.AbstractMesh.setBoundingInfo of type '(boundingInfo?: BABYLON.BoundingInfo)':


    if (oldProps.setBoundingInfo !== newProps.setBoundingInfo) {
      updates.push({
        propertyName: "setBoundingInfo",
        value: newProps.setBoundingInfo,
        type: "(boundingInfo?: BABYLON.BoundingInfo)"
      });
    } // BABYLON.AbstractMesh.setIndices of type '(indices?: BABYLON.IndicesArray, totalVertices?: number)':


    if (oldProps.setIndices !== newProps.setIndices) {
      updates.push({
        propertyName: "setIndices",
        value: newProps.setIndices,
        type: "(indices?: BABYLON.IndicesArray, totalVertices?: number)"
      });
    } // BABYLON.AbstractMesh.setVerticesData of type '(kind?: string, data?: BABYLON.FloatArray, updatable?: boolean, stride?: number)':


    if (oldProps.setVerticesData !== newProps.setVerticesData) {
      updates.push({
        propertyName: "setVerticesData",
        value: newProps.setVerticesData,
        type: "(kind?: string, data?: BABYLON.FloatArray, updatable?: boolean, stride?: number)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberAbstractMeshPropsHandler;
}();
/**
 * Class used to store all common mesh properties
 *
 * This code has been generated
 */


var FiberAbstractMesh =
/** @class */
function () {
  function FiberAbstractMesh() {
    this.propsHandlers = [new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAbstractMesh.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAbstractMesh.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAbstractMesh.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AbstractMesh",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberAbstractMesh.Metadata = {
    className: "FiberAbstractMesh",
    isMesh: false
  };
  return FiberAbstractMesh;
}();

var FiberMeshProps =
/** @class */
function (_super) {
  __extends(FiberMeshProps, _super);

  function FiberMeshProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberMeshProps;
}(FiberAbstractMeshProps);

var FiberMeshPropsHandler =
/** @class */
function () {
  function FiberMeshPropsHandler() {}

  FiberMeshPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.Mesh.delayLoadingFile of type 'string':

    if (oldProps.delayLoadingFile !== newProps.delayLoadingFile) {
      updates.push({
        propertyName: "delayLoadingFile",
        value: newProps.delayLoadingFile,
        type: "string"
      });
    } // BABYLON.Mesh.delayLoadState of type 'number':


    if (oldProps.delayLoadState !== newProps.delayLoadState) {
      updates.push({
        propertyName: "delayLoadState",
        value: newProps.delayLoadState,
        type: "number"
      });
    } // TODO: type: BABYLON.InstancedMesh[] property (not coded) BABYLON.Mesh.instances.
    // BABYLON.Mesh.isUnIndexed of type 'boolean':


    if (oldProps.isUnIndexed !== newProps.isUnIndexed) {
      updates.push({
        propertyName: "isUnIndexed",
        value: newProps.isUnIndexed,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.Mesh.meshMap.
    // TODO: type: BABYLON.MorphTargetManager property (not coded) BABYLON.Mesh.morphTargetManager.
    // TODO: type: any property (not coded) BABYLON.Mesh.normalizeSkinFourWeights.
    // TODO: type: any property (not coded) BABYLON.Mesh.normalizeSkinWeightsAndExtra.
    // BABYLON.Mesh.onBeforeDraw of type '() => void/fn':


    if (oldProps.onBeforeDraw === undefined && oldProps.onBeforeDraw !== newProps.onBeforeDraw) {
      updates.push({
        propertyName: "onBeforeDraw",
        value: newProps.onBeforeDraw,
        type: "() => void"
      });
    } // BABYLON.Mesh.onLODLevelSelection of type '(distance: number, mesh: BABYLON.Mesh, selectedLevel: BABYLON.Mesh) => void/fn':


    if (oldProps.onLODLevelSelection === undefined && oldProps.onLODLevelSelection !== newProps.onLODLevelSelection) {
      updates.push({
        propertyName: "onLODLevelSelection",
        value: newProps.onLODLevelSelection,
        type: "(distance: number, mesh: BABYLON.Mesh, selectedLevel: BABYLON.Mesh) => void"
      });
    } // BABYLON.Mesh.overrideMaterialSideOrientation of type 'number':


    if (oldProps.overrideMaterialSideOrientation !== newProps.overrideMaterialSideOrientation) {
      updates.push({
        propertyName: "overrideMaterialSideOrientation",
        value: newProps.overrideMaterialSideOrientation,
        type: "number"
      });
    } // BABYLON.Mesh.overridenInstanceCount of type 'number':


    if (oldProps.overridenInstanceCount !== newProps.overridenInstanceCount) {
      updates.push({
        propertyName: "overridenInstanceCount",
        value: newProps.overridenInstanceCount,
        type: "number"
      });
    } // BABYLON.Mesh.setIndices of type '(indices?: BABYLON.IndicesArray, totalVertices?: number, updatable?: boolean)':


    if (oldProps.setIndices !== newProps.setIndices) {
      updates.push({
        propertyName: "setIndices",
        value: newProps.setIndices,
        type: "(indices?: BABYLON.IndicesArray, totalVertices?: number, updatable?: boolean)"
      });
    } // BABYLON.Mesh.setMaterialByID of type '(id?: string)':


    if (oldProps.setMaterialByID !== newProps.setMaterialByID) {
      updates.push({
        propertyName: "setMaterialByID",
        value: newProps.setMaterialByID,
        type: "(id?: string)"
      });
    } // BABYLON.Mesh.setVerticesBuffer of type '(buffer?: BABYLON.VertexBuffer)':


    if (oldProps.setVerticesBuffer !== newProps.setVerticesBuffer) {
      updates.push({
        propertyName: "setVerticesBuffer",
        value: newProps.setVerticesBuffer,
        type: "(buffer?: BABYLON.VertexBuffer)"
      });
    } // BABYLON.Mesh.setVerticesData of type '(kind?: string, data?: BABYLON.FloatArray, updatable?: boolean, stride?: number)':


    if (oldProps.setVerticesData !== newProps.setVerticesData) {
      updates.push({
        propertyName: "setVerticesData",
        value: newProps.setVerticesData,
        type: "(kind?: string, data?: BABYLON.FloatArray, updatable?: boolean, stride?: number)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberMeshPropsHandler;
}();
/**
 * Class used to represent renderable models
 *
 * This code has been generated
 */


var FiberMesh =
/** @class */
function () {
  function FiberMesh() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberMesh.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMesh.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMesh.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Mesh",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }, {
      name: "parent",
      type: "BABYLON.Node",
      optional: true
    }, {
      name: "source",
      type: "BABYLON.Mesh",
      optional: true
    }, {
      name: "doNotCloneChildren",
      type: "boolean",
      optional: true
    }, {
      name: "clonePhysicsImpostor",
      type: "boolean",
      optional: true
    }]
  };
  FiberMesh.Metadata = {
    className: "FiberMesh",
    isMesh: true
  };
  return FiberMesh;
}();

var FiberCameraProps =
/** @class */
function (_super) {
  __extends(FiberCameraProps, _super);

  function FiberCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberCameraProps;
}(FiberNodeProps);

var FiberCameraPropsHandler =
/** @class */
function () {
  function FiberCameraPropsHandler() {}

  FiberCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.Camera.cameraRigMode of type 'number':

    if (oldProps.cameraRigMode !== newProps.cameraRigMode) {
      updates.push({
        propertyName: "cameraRigMode",
        value: newProps.cameraRigMode,
        type: "number"
      });
    } // TODO: type: BABYLON.RenderTargetTexture[] property (not coded) BABYLON.Camera.customRenderTargets.
    // BABYLON.Camera.fov of type 'number':


    if (oldProps.fov !== newProps.fov) {
      updates.push({
        propertyName: "fov",
        value: newProps.fov,
        type: "number"
      });
    } // BABYLON.Camera.fovMode of type 'number':


    if (oldProps.fovMode !== newProps.fovMode) {
      updates.push({
        propertyName: "fovMode",
        value: newProps.fovMode,
        type: "number"
      });
    } // BABYLON.Camera.inertia of type 'number':


    if (oldProps.inertia !== newProps.inertia) {
      updates.push({
        propertyName: "inertia",
        value: newProps.inertia,
        type: "number"
      });
    } // TODO: type: BABYLON.CameraInputsManager<BABYLON.Camera> property (not coded) BABYLON.Camera.inputs.
    // BABYLON.Camera.interaxialDistance of type 'number':


    if (oldProps.interaxialDistance !== newProps.interaxialDistance) {
      updates.push({
        propertyName: "interaxialDistance",
        value: newProps.interaxialDistance,
        type: "number"
      });
    } // BABYLON.Camera.isIntermediate of type 'boolean':


    if (oldProps.isIntermediate !== newProps.isIntermediate) {
      updates.push({
        propertyName: "isIntermediate",
        value: newProps.isIntermediate,
        type: "boolean"
      });
    } // BABYLON.Camera.isStereoscopicSideBySide of type 'boolean':


    if (oldProps.isStereoscopicSideBySide !== newProps.isStereoscopicSideBySide) {
      updates.push({
        propertyName: "isStereoscopicSideBySide",
        value: newProps.isStereoscopicSideBySide,
        type: "boolean"
      });
    } // BABYLON.Camera.layerMask of type 'number':


    if (oldProps.layerMask !== newProps.layerMask) {
      updates.push({
        propertyName: "layerMask",
        value: newProps.layerMask,
        type: "number"
      });
    } // BABYLON.Camera.maxZ of type 'number':


    if (oldProps.maxZ !== newProps.maxZ) {
      updates.push({
        propertyName: "maxZ",
        value: newProps.maxZ,
        type: "number"
      });
    } // BABYLON.Camera.minZ of type 'number':


    if (oldProps.minZ !== newProps.minZ) {
      updates.push({
        propertyName: "minZ",
        value: newProps.minZ,
        type: "number"
      });
    } // BABYLON.Camera.mode of type 'number':


    if (oldProps.mode !== newProps.mode) {
      updates.push({
        propertyName: "mode",
        value: newProps.mode,
        type: "number"
      });
    } // BABYLON.Camera.onAfterCheckInputsObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onAfterCheckInputsObservable === undefined && oldProps.onAfterCheckInputsObservable !== newProps.onAfterCheckInputsObservable) {
      updates.push({
        propertyName: "onAfterCheckInputsObservable",
        value: newProps.onAfterCheckInputsObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Camera.onProjectionMatrixChangedObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onProjectionMatrixChangedObservable === undefined && oldProps.onProjectionMatrixChangedObservable !== newProps.onProjectionMatrixChangedObservable) {
      updates.push({
        propertyName: "onProjectionMatrixChangedObservable",
        value: newProps.onProjectionMatrixChangedObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Camera.onRestoreStateObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onRestoreStateObservable === undefined && oldProps.onRestoreStateObservable !== newProps.onRestoreStateObservable) {
      updates.push({
        propertyName: "onRestoreStateObservable",
        value: newProps.onRestoreStateObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Camera.onViewMatrixChangedObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onViewMatrixChangedObservable === undefined && oldProps.onViewMatrixChangedObservable !== newProps.onViewMatrixChangedObservable) {
      updates.push({
        propertyName: "onViewMatrixChangedObservable",
        value: newProps.onViewMatrixChangedObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Camera.orthoBottom of type 'number':


    if (oldProps.orthoBottom !== newProps.orthoBottom) {
      updates.push({
        propertyName: "orthoBottom",
        value: newProps.orthoBottom,
        type: "number"
      });
    } // BABYLON.Camera.orthoLeft of type 'number':


    if (oldProps.orthoLeft !== newProps.orthoLeft) {
      updates.push({
        propertyName: "orthoLeft",
        value: newProps.orthoLeft,
        type: "number"
      });
    } // BABYLON.Camera.orthoRight of type 'number':


    if (oldProps.orthoRight !== newProps.orthoRight) {
      updates.push({
        propertyName: "orthoRight",
        value: newProps.orthoRight,
        type: "number"
      });
    } // BABYLON.Camera.orthoTop of type 'number':


    if (oldProps.orthoTop !== newProps.orthoTop) {
      updates.push({
        propertyName: "orthoTop",
        value: newProps.orthoTop,
        type: "number"
      });
    } // TODO: type: BABYLON.RenderTargetTexture property (not coded) BABYLON.Camera.outputRenderTarget.
    // BABYLON.Camera.position of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.position && (!oldProps.position || !oldProps.position.equals(newProps.position))) {
      updates.push({
        propertyName: "position",
        value: newProps.position,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.Camera.upVector of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.upVector && (!oldProps.upVector || !oldProps.upVector.equals(newProps.upVector))) {
      updates.push({
        propertyName: "upVector",
        value: newProps.upVector,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Viewport property (not coded) BABYLON.Camera.viewport.
    // BABYLON.Camera.setCameraRigMode of type '(mode?: number, rigParams?: any)':


    if (oldProps.setCameraRigMode !== newProps.setCameraRigMode) {
      updates.push({
        propertyName: "setCameraRigMode",
        value: newProps.setCameraRigMode,
        type: "(mode?: number, rigParams?: any)"
      });
    } // BABYLON.Camera.setCameraRigParameter of type '(name?: string, value?: any)':


    if (oldProps.setCameraRigParameter !== newProps.setCameraRigParameter) {
      updates.push({
        propertyName: "setCameraRigParameter",
        value: newProps.setCameraRigParameter,
        type: "(name?: string, value?: any)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberCameraPropsHandler;
}();
/**
 * This is the base class of all the camera used in the application.
 *
 * This code has been generated
 */


var FiberCamera =
/** @class */
function () {
  function FiberCamera() {
    this.isTargetable = false;
    this.propsHandlers = [new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Camera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "setActiveOnSceneIfNoneActive",
      type: "boolean",
      optional: true
    }]
  };
  FiberCamera.Metadata = {
    isCamera: true,
    className: "FiberCamera"
  };
  return FiberCamera;
}();

var FiberTargetCameraProps =
/** @class */
function (_super) {
  __extends(FiberTargetCameraProps, _super);

  function FiberTargetCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberTargetCameraProps;
}(FiberCameraProps);

var FiberTargetCameraPropsHandler =
/** @class */
function () {
  function FiberTargetCameraPropsHandler() {}

  FiberTargetCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.TargetCamera.cameraDirection of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.cameraDirection && (!oldProps.cameraDirection || !oldProps.cameraDirection.equals(newProps.cameraDirection))) {
      updates.push({
        propertyName: "cameraDirection",
        value: newProps.cameraDirection,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Vector2 property (not coded) BABYLON.TargetCamera.cameraRotation.
    // TODO: type: any property (not coded) BABYLON.TargetCamera.lockedTarget.
    // BABYLON.TargetCamera.noRotationConstraint of type 'boolean':


    if (oldProps.noRotationConstraint !== newProps.noRotationConstraint) {
      updates.push({
        propertyName: "noRotationConstraint",
        value: newProps.noRotationConstraint,
        type: "boolean"
      });
    } // BABYLON.TargetCamera.rotation of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.rotation && (!oldProps.rotation || !oldProps.rotation.equals(newProps.rotation))) {
      updates.push({
        propertyName: "rotation",
        value: newProps.rotation,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Quaternion property (not coded) BABYLON.TargetCamera.rotationQuaternion.
    // BABYLON.TargetCamera.speed of type 'number':


    if (oldProps.speed !== newProps.speed) {
      updates.push({
        propertyName: "speed",
        value: newProps.speed,
        type: "number"
      });
    } // BABYLON.TargetCamera.updateUpVectorFromRotation of type 'boolean':


    if (oldProps.updateUpVectorFromRotation !== newProps.updateUpVectorFromRotation) {
      updates.push({
        propertyName: "updateUpVectorFromRotation",
        value: newProps.updateUpVectorFromRotation,
        type: "boolean"
      });
    } // BABYLON.TargetCamera.setTarget of type '(target?: BABYLON.Vector3)':


    if (oldProps.setTarget !== newProps.setTarget) {
      updates.push({
        propertyName: "setTarget",
        value: newProps.setTarget,
        type: "(target?: BABYLON.Vector3)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberTargetCameraPropsHandler;
}();
/**
 * A target camera takes a mesh or position as a target and continues to look at it while it moves.
 * This is the base of the follow, arc rotate cameras and Free camera
 *
 * This code has been generated
 */


var FiberTargetCamera =
/** @class */
function () {
  function FiberTargetCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTargetCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTargetCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTargetCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "TargetCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "setActiveOnSceneIfNoneActive",
      type: "boolean",
      optional: true
    }]
  };
  FiberTargetCamera.Metadata = {
    isCamera: true,
    className: "FiberTargetCamera"
  };
  return FiberTargetCamera;
}();

var FiberArcRotateCameraProps =
/** @class */
function (_super) {
  __extends(FiberArcRotateCameraProps, _super);

  function FiberArcRotateCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberArcRotateCameraProps;
}(FiberTargetCameraProps);

var FiberArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberArcRotateCameraPropsHandler() {}

  FiberArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.ArcRotateCamera.allowUpsideDown of type 'boolean':

    if (oldProps.allowUpsideDown !== newProps.allowUpsideDown) {
      updates.push({
        propertyName: "allowUpsideDown",
        value: newProps.allowUpsideDown,
        type: "boolean"
      });
    } // BABYLON.ArcRotateCamera.alpha of type 'number':


    if (oldProps.alpha !== newProps.alpha) {
      updates.push({
        propertyName: "alpha",
        value: newProps.alpha,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.angularSensibilityX of type 'number':


    if (oldProps.angularSensibilityX !== newProps.angularSensibilityX) {
      updates.push({
        propertyName: "angularSensibilityX",
        value: newProps.angularSensibilityX,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.angularSensibilityY of type 'number':


    if (oldProps.angularSensibilityY !== newProps.angularSensibilityY) {
      updates.push({
        propertyName: "angularSensibilityY",
        value: newProps.angularSensibilityY,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.beta of type 'number':


    if (oldProps.beta !== newProps.beta) {
      updates.push({
        propertyName: "beta",
        value: newProps.beta,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.checkCollisions of type 'boolean':


    if (oldProps.checkCollisions !== newProps.checkCollisions) {
      updates.push({
        propertyName: "checkCollisions",
        value: newProps.checkCollisions,
        type: "boolean"
      });
    } // BABYLON.ArcRotateCamera.collisionRadius of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.collisionRadius && (!oldProps.collisionRadius || !oldProps.collisionRadius.equals(newProps.collisionRadius))) {
      updates.push({
        propertyName: "collisionRadius",
        value: newProps.collisionRadius,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ArcRotateCamera.inertialAlphaOffset of type 'number':


    if (oldProps.inertialAlphaOffset !== newProps.inertialAlphaOffset) {
      updates.push({
        propertyName: "inertialAlphaOffset",
        value: newProps.inertialAlphaOffset,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.inertialBetaOffset of type 'number':


    if (oldProps.inertialBetaOffset !== newProps.inertialBetaOffset) {
      updates.push({
        propertyName: "inertialBetaOffset",
        value: newProps.inertialBetaOffset,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.inertialPanningX of type 'number':


    if (oldProps.inertialPanningX !== newProps.inertialPanningX) {
      updates.push({
        propertyName: "inertialPanningX",
        value: newProps.inertialPanningX,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.inertialPanningY of type 'number':


    if (oldProps.inertialPanningY !== newProps.inertialPanningY) {
      updates.push({
        propertyName: "inertialPanningY",
        value: newProps.inertialPanningY,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.inertialRadiusOffset of type 'number':


    if (oldProps.inertialRadiusOffset !== newProps.inertialRadiusOffset) {
      updates.push({
        propertyName: "inertialRadiusOffset",
        value: newProps.inertialRadiusOffset,
        type: "number"
      });
    } // TODO: type: BABYLON.ArcRotateCameraInputsManager property (not coded) BABYLON.ArcRotateCamera.inputs.
    // TODO: type: number[] property (not coded) BABYLON.ArcRotateCamera.keysDown.
    // TODO: type: number[] property (not coded) BABYLON.ArcRotateCamera.keysLeft.
    // TODO: type: number[] property (not coded) BABYLON.ArcRotateCamera.keysRight.
    // TODO: type: number[] property (not coded) BABYLON.ArcRotateCamera.keysUp.
    // BABYLON.ArcRotateCamera.lowerAlphaLimit of type 'number':


    if (oldProps.lowerAlphaLimit !== newProps.lowerAlphaLimit) {
      updates.push({
        propertyName: "lowerAlphaLimit",
        value: newProps.lowerAlphaLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.lowerBetaLimit of type 'number':


    if (oldProps.lowerBetaLimit !== newProps.lowerBetaLimit) {
      updates.push({
        propertyName: "lowerBetaLimit",
        value: newProps.lowerBetaLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.lowerRadiusLimit of type 'number':


    if (oldProps.lowerRadiusLimit !== newProps.lowerRadiusLimit) {
      updates.push({
        propertyName: "lowerRadiusLimit",
        value: newProps.lowerRadiusLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.onCollide of type '(collidedMesh: BABYLON.AbstractMesh) => void/fn':


    if (oldProps.onCollide === undefined && oldProps.onCollide !== newProps.onCollide) {
      updates.push({
        propertyName: "onCollide",
        value: newProps.onCollide,
        type: "(collidedMesh: BABYLON.AbstractMesh) => void"
      });
    } // BABYLON.ArcRotateCamera.onMeshTargetChangedObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onMeshTargetChangedObservable === undefined && oldProps.onMeshTargetChangedObservable !== newProps.onMeshTargetChangedObservable) {
      updates.push({
        propertyName: "onMeshTargetChangedObservable",
        value: newProps.onMeshTargetChangedObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.ArcRotateCamera.panningAxis of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.panningAxis && (!oldProps.panningAxis || !oldProps.panningAxis.equals(newProps.panningAxis))) {
      updates.push({
        propertyName: "panningAxis",
        value: newProps.panningAxis,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ArcRotateCamera.panningDistanceLimit of type 'number':


    if (oldProps.panningDistanceLimit !== newProps.panningDistanceLimit) {
      updates.push({
        propertyName: "panningDistanceLimit",
        value: newProps.panningDistanceLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.panningInertia of type 'number':


    if (oldProps.panningInertia !== newProps.panningInertia) {
      updates.push({
        propertyName: "panningInertia",
        value: newProps.panningInertia,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.panningOriginTarget of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.panningOriginTarget && (!oldProps.panningOriginTarget || !oldProps.panningOriginTarget.equals(newProps.panningOriginTarget))) {
      updates.push({
        propertyName: "panningOriginTarget",
        value: newProps.panningOriginTarget,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ArcRotateCamera.panningSensibility of type 'number':


    if (oldProps.panningSensibility !== newProps.panningSensibility) {
      updates.push({
        propertyName: "panningSensibility",
        value: newProps.panningSensibility,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.pinchDeltaPercentage of type 'number':


    if (oldProps.pinchDeltaPercentage !== newProps.pinchDeltaPercentage) {
      updates.push({
        propertyName: "pinchDeltaPercentage",
        value: newProps.pinchDeltaPercentage,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.pinchPrecision of type 'number':


    if (oldProps.pinchPrecision !== newProps.pinchPrecision) {
      updates.push({
        propertyName: "pinchPrecision",
        value: newProps.pinchPrecision,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.pinchToPanMaxDistance of type 'number':


    if (oldProps.pinchToPanMaxDistance !== newProps.pinchToPanMaxDistance) {
      updates.push({
        propertyName: "pinchToPanMaxDistance",
        value: newProps.pinchToPanMaxDistance,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.radius of type 'number':


    if (oldProps.radius !== newProps.radius) {
      updates.push({
        propertyName: "radius",
        value: newProps.radius,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.target of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.target && (!oldProps.target || !oldProps.target.equals(newProps.target))) {
      updates.push({
        propertyName: "target",
        value: newProps.target,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Vector2 property (not coded) BABYLON.ArcRotateCamera.targetScreenOffset.
    // BABYLON.ArcRotateCamera.upperAlphaLimit of type 'number':


    if (oldProps.upperAlphaLimit !== newProps.upperAlphaLimit) {
      updates.push({
        propertyName: "upperAlphaLimit",
        value: newProps.upperAlphaLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.upperBetaLimit of type 'number':


    if (oldProps.upperBetaLimit !== newProps.upperBetaLimit) {
      updates.push({
        propertyName: "upperBetaLimit",
        value: newProps.upperBetaLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.upperRadiusLimit of type 'number':


    if (oldProps.upperRadiusLimit !== newProps.upperRadiusLimit) {
      updates.push({
        propertyName: "upperRadiusLimit",
        value: newProps.upperRadiusLimit,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.useAutoRotationBehavior of type 'boolean':


    if (oldProps.useAutoRotationBehavior !== newProps.useAutoRotationBehavior) {
      updates.push({
        propertyName: "useAutoRotationBehavior",
        value: newProps.useAutoRotationBehavior,
        type: "boolean"
      });
    } // BABYLON.ArcRotateCamera.useBouncingBehavior of type 'boolean':


    if (oldProps.useBouncingBehavior !== newProps.useBouncingBehavior) {
      updates.push({
        propertyName: "useBouncingBehavior",
        value: newProps.useBouncingBehavior,
        type: "boolean"
      });
    } // BABYLON.ArcRotateCamera.useFramingBehavior of type 'boolean':


    if (oldProps.useFramingBehavior !== newProps.useFramingBehavior) {
      updates.push({
        propertyName: "useFramingBehavior",
        value: newProps.useFramingBehavior,
        type: "boolean"
      });
    } // BABYLON.ArcRotateCamera.useInputToRestoreState of type 'boolean':


    if (oldProps.useInputToRestoreState !== newProps.useInputToRestoreState) {
      updates.push({
        propertyName: "useInputToRestoreState",
        value: newProps.useInputToRestoreState,
        type: "boolean"
      });
    } // BABYLON.ArcRotateCamera.wheelDeltaPercentage of type 'number':


    if (oldProps.wheelDeltaPercentage !== newProps.wheelDeltaPercentage) {
      updates.push({
        propertyName: "wheelDeltaPercentage",
        value: newProps.wheelDeltaPercentage,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.wheelPrecision of type 'number':


    if (oldProps.wheelPrecision !== newProps.wheelPrecision) {
      updates.push({
        propertyName: "wheelPrecision",
        value: newProps.wheelPrecision,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.zoomOnFactor of type 'number':


    if (oldProps.zoomOnFactor !== newProps.zoomOnFactor) {
      updates.push({
        propertyName: "zoomOnFactor",
        value: newProps.zoomOnFactor,
        type: "number"
      });
    } // BABYLON.ArcRotateCamera.setPosition of type '(position?: BABYLON.Vector3)':


    if (oldProps.setPosition !== newProps.setPosition) {
      updates.push({
        propertyName: "setPosition",
        value: newProps.setPosition,
        type: "(position?: BABYLON.Vector3)"
      });
    } // BABYLON.ArcRotateCamera.setTarget of type '(target?: BABYLON.AbstractMesh | BABYLON.Vector3, toBoundingCenter?: boolean, allowSamePosition?: boolean)':


    if (oldProps.setTarget !== newProps.setTarget) {
      updates.push({
        propertyName: "setTarget",
        value: newProps.setTarget,
        type: "(target?: BABYLON.AbstractMesh | BABYLON.Vector3, toBoundingCenter?: boolean, allowSamePosition?: boolean)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberArcRotateCameraPropsHandler;
}();
/**
 * This represents an orbital type of camera.
 *
 * This camera always points towards a given target position and can be rotated around that target with the target as the centre of rotation. It can be controlled with cursors and mouse, or with touch events.
 * Think of this camera as one orbiting its target position, or more imaginatively as a spy satellite orbiting the earth. Its position relative to the target (earth) can be set by three parameters, alpha (radians) the longitudinal rotation, beta (radians) the latitudinal rotation and radius the distance from the target position.
 *
 * This code has been generated
 */


var FiberArcRotateCamera =
/** @class */
function () {
  function FiberArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberArcRotateCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ArcRotateCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "alpha",
      type: "number",
      optional: false
    }, {
      name: "beta",
      type: "number",
      optional: false
    }, {
      name: "radius",
      type: "number",
      optional: false
    }, {
      name: "target",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "setActiveOnSceneIfNoneActive",
      type: "boolean",
      optional: true
    }]
  };
  FiberArcRotateCamera.Metadata = {
    isCamera: true,
    className: "FiberArcRotateCamera"
  };
  return FiberArcRotateCamera;
}();

var FiberVRDeviceOrientationArcRotateCameraProps =
/** @class */
function (_super) {
  __extends(FiberVRDeviceOrientationArcRotateCameraProps, _super);

  function FiberVRDeviceOrientationArcRotateCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVRDeviceOrientationArcRotateCameraProps;
}(FiberArcRotateCameraProps);

var FiberVRDeviceOrientationArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberVRDeviceOrientationArcRotateCameraPropsHandler() {}

  FiberVRDeviceOrientationArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberVRDeviceOrientationArcRotateCameraPropsHandler;
}();
/**
 * Camera used to simulate VR rendering (based on ArcRotateCamera)
 *
 * This code has been generated
 */


var FiberVRDeviceOrientationArcRotateCamera =
/** @class */
function () {
  function FiberVRDeviceOrientationArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVRDeviceOrientationArcRotateCameraPropsHandler(), new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVRDeviceOrientationArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRDeviceOrientationArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRDeviceOrientationArcRotateCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VRDeviceOrientationArcRotateCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "alpha",
      type: "number",
      optional: false
    }, {
      name: "beta",
      type: "number",
      optional: false
    }, {
      name: "radius",
      type: "number",
      optional: false
    }, {
      name: "target",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "compensateDistortion",
      type: "boolean",
      optional: true
    }, {
      name: "vrCameraMetrics",
      type: "BABYLON.VRCameraMetrics",
      optional: true
    }]
  };
  FiberVRDeviceOrientationArcRotateCamera.Metadata = {
    isCamera: true,
    className: "FiberVRDeviceOrientationArcRotateCamera"
  };
  return FiberVRDeviceOrientationArcRotateCamera;
}();

var FiberAnaglyphArcRotateCameraProps =
/** @class */
function (_super) {
  __extends(FiberAnaglyphArcRotateCameraProps, _super);

  function FiberAnaglyphArcRotateCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAnaglyphArcRotateCameraProps;
}(FiberArcRotateCameraProps);

var FiberAnaglyphArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphArcRotateCameraPropsHandler() {}

  FiberAnaglyphArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberAnaglyphArcRotateCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on ArcRotateCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphArcRotateCamera =
/** @class */
function () {
  function FiberAnaglyphArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphArcRotateCameraPropsHandler(), new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphArcRotateCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AnaglyphArcRotateCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "alpha",
      type: "number",
      optional: false
    }, {
      name: "beta",
      type: "number",
      optional: false
    }, {
      name: "radius",
      type: "number",
      optional: false
    }, {
      name: "target",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberAnaglyphArcRotateCamera.Metadata = {
    isCamera: true,
    className: "FiberAnaglyphArcRotateCamera"
  };
  return FiberAnaglyphArcRotateCamera;
}();

var FiberStereoscopicArcRotateCameraProps =
/** @class */
function (_super) {
  __extends(FiberStereoscopicArcRotateCameraProps, _super);

  function FiberStereoscopicArcRotateCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStereoscopicArcRotateCameraProps;
}(FiberArcRotateCameraProps);

var FiberStereoscopicArcRotateCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicArcRotateCameraPropsHandler() {}

  FiberStereoscopicArcRotateCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberStereoscopicArcRotateCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on ArcRotateCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicArcRotateCamera =
/** @class */
function () {
  function FiberStereoscopicArcRotateCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicArcRotateCameraPropsHandler(), new FiberArcRotateCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicArcRotateCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicArcRotateCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicArcRotateCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StereoscopicArcRotateCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "alpha",
      type: "number",
      optional: false
    }, {
      name: "beta",
      type: "number",
      optional: false
    }, {
      name: "radius",
      type: "number",
      optional: false
    }, {
      name: "target",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "isStereoscopicSideBySide",
      type: "boolean",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberStereoscopicArcRotateCamera.Metadata = {
    isCamera: true,
    className: "FiberStereoscopicArcRotateCamera"
  };
  return FiberStereoscopicArcRotateCamera;
}();

var FiberFlyCameraProps =
/** @class */
function (_super) {
  __extends(FiberFlyCameraProps, _super);

  function FiberFlyCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberFlyCameraProps;
}(FiberTargetCameraProps);

var FiberFlyCameraPropsHandler =
/** @class */
function () {
  function FiberFlyCameraPropsHandler() {}

  FiberFlyCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.FlyCamera.angularSensibility of type 'number':

    if (oldProps.angularSensibility !== newProps.angularSensibility) {
      updates.push({
        propertyName: "angularSensibility",
        value: newProps.angularSensibility,
        type: "number"
      });
    } // BABYLON.FlyCamera.applyGravity of type 'boolean':


    if (oldProps.applyGravity !== newProps.applyGravity) {
      updates.push({
        propertyName: "applyGravity",
        value: newProps.applyGravity,
        type: "boolean"
      });
    } // BABYLON.FlyCamera.bankedTurn of type 'boolean':


    if (oldProps.bankedTurn !== newProps.bankedTurn) {
      updates.push({
        propertyName: "bankedTurn",
        value: newProps.bankedTurn,
        type: "boolean"
      });
    } // BABYLON.FlyCamera.bankedTurnLimit of type 'number':


    if (oldProps.bankedTurnLimit !== newProps.bankedTurnLimit) {
      updates.push({
        propertyName: "bankedTurnLimit",
        value: newProps.bankedTurnLimit,
        type: "number"
      });
    } // BABYLON.FlyCamera.bankedTurnMultiplier of type 'number':


    if (oldProps.bankedTurnMultiplier !== newProps.bankedTurnMultiplier) {
      updates.push({
        propertyName: "bankedTurnMultiplier",
        value: newProps.bankedTurnMultiplier,
        type: "number"
      });
    } // BABYLON.FlyCamera.cameraDirection of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.cameraDirection && (!oldProps.cameraDirection || !oldProps.cameraDirection.equals(newProps.cameraDirection))) {
      updates.push({
        propertyName: "cameraDirection",
        value: newProps.cameraDirection,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.FlyCamera.checkCollisions of type 'boolean':


    if (oldProps.checkCollisions !== newProps.checkCollisions) {
      updates.push({
        propertyName: "checkCollisions",
        value: newProps.checkCollisions,
        type: "boolean"
      });
    } // BABYLON.FlyCamera.collisionMask of type 'number':


    if (oldProps.collisionMask !== newProps.collisionMask) {
      updates.push({
        propertyName: "collisionMask",
        value: newProps.collisionMask,
        type: "number"
      });
    } // BABYLON.FlyCamera.ellipsoid of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.ellipsoid && (!oldProps.ellipsoid || !oldProps.ellipsoid.equals(newProps.ellipsoid))) {
      updates.push({
        propertyName: "ellipsoid",
        value: newProps.ellipsoid,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.FlyCamera.ellipsoidOffset of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.ellipsoidOffset && (!oldProps.ellipsoidOffset || !oldProps.ellipsoidOffset.equals(newProps.ellipsoidOffset))) {
      updates.push({
        propertyName: "ellipsoidOffset",
        value: newProps.ellipsoidOffset,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.FlyCameraInputsManager property (not coded) BABYLON.FlyCamera.inputs.
    // TODO: type: number[] property (not coded) BABYLON.FlyCamera.keysBackward.
    // TODO: type: number[] property (not coded) BABYLON.FlyCamera.keysDown.
    // TODO: type: number[] property (not coded) BABYLON.FlyCamera.keysForward.
    // TODO: type: number[] property (not coded) BABYLON.FlyCamera.keysLeft.
    // TODO: type: number[] property (not coded) BABYLON.FlyCamera.keysRight.
    // TODO: type: number[] property (not coded) BABYLON.FlyCamera.keysUp.
    // BABYLON.FlyCamera.onCollide of type '(collidedMesh: BABYLON.AbstractMesh) => void/fn':


    if (oldProps.onCollide === undefined && oldProps.onCollide !== newProps.onCollide) {
      updates.push({
        propertyName: "onCollide",
        value: newProps.onCollide,
        type: "(collidedMesh: BABYLON.AbstractMesh) => void"
      });
    } // BABYLON.FlyCamera.rollCorrect of type 'number':


    if (oldProps.rollCorrect !== newProps.rollCorrect) {
      updates.push({
        propertyName: "rollCorrect",
        value: newProps.rollCorrect,
        type: "number"
      });
    } // TODO: type: BABYLON.Quaternion property (not coded) BABYLON.FlyCamera.rotationQuaternion.


    return updates.length == 0 ? null : updates;
  };

  return FiberFlyCameraPropsHandler;
}();
/**
 * This is a flying camera, designed for 3D movement and rotation in all directions,
 * such as in a 3D Space Shooter or a Flight Simulator.
 *
 * This code has been generated
 */


var FiberFlyCamera =
/** @class */
function () {
  function FiberFlyCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberFlyCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberFlyCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFlyCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFlyCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "FlyCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "setActiveOnSceneIfNoneActive",
      type: "boolean",
      optional: true
    }]
  };
  FiberFlyCamera.Metadata = {
    isCamera: true,
    className: "FiberFlyCamera"
  };
  return FiberFlyCamera;
}();

var FiberFollowCameraProps =
/** @class */
function (_super) {
  __extends(FiberFollowCameraProps, _super);

  function FiberFollowCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberFollowCameraProps;
}(FiberTargetCameraProps);

var FiberFollowCameraPropsHandler =
/** @class */
function () {
  function FiberFollowCameraPropsHandler() {}

  FiberFollowCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.FollowCamera.cameraAcceleration of type 'number':

    if (oldProps.cameraAcceleration !== newProps.cameraAcceleration) {
      updates.push({
        propertyName: "cameraAcceleration",
        value: newProps.cameraAcceleration,
        type: "number"
      });
    } // BABYLON.FollowCamera.heightOffset of type 'number':


    if (oldProps.heightOffset !== newProps.heightOffset) {
      updates.push({
        propertyName: "heightOffset",
        value: newProps.heightOffset,
        type: "number"
      });
    } // TODO: type: BABYLON.AbstractMesh property (not coded) BABYLON.FollowCamera.lockedTarget.
    // BABYLON.FollowCamera.maxCameraSpeed of type 'number':


    if (oldProps.maxCameraSpeed !== newProps.maxCameraSpeed) {
      updates.push({
        propertyName: "maxCameraSpeed",
        value: newProps.maxCameraSpeed,
        type: "number"
      });
    } // BABYLON.FollowCamera.radius of type 'number':


    if (oldProps.radius !== newProps.radius) {
      updates.push({
        propertyName: "radius",
        value: newProps.radius,
        type: "number"
      });
    } // BABYLON.FollowCamera.rotationOffset of type 'number':


    if (oldProps.rotationOffset !== newProps.rotationOffset) {
      updates.push({
        propertyName: "rotationOffset",
        value: newProps.rotationOffset,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberFollowCameraPropsHandler;
}();
/**
 * A follow camera takes a mesh as a target and follows it as it moves. Both a free camera version followCamera and
 * an arc rotate version arcFollowCamera are available.
 *
 * This code has been generated
 */


var FiberFollowCamera =
/** @class */
function () {
  function FiberFollowCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberFollowCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberFollowCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFollowCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFollowCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "FollowCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "lockedTarget",
      type: "BABYLON.AbstractMesh",
      optional: true
    }]
  };
  FiberFollowCamera.Metadata = {
    isCamera: true,
    className: "FiberFollowCamera"
  };
  return FiberFollowCamera;
}();

var FiberArcFollowCameraProps =
/** @class */
function (_super) {
  __extends(FiberArcFollowCameraProps, _super);

  function FiberArcFollowCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberArcFollowCameraProps;
}(FiberTargetCameraProps);

var FiberArcFollowCameraPropsHandler =
/** @class */
function () {
  function FiberArcFollowCameraPropsHandler() {}

  FiberArcFollowCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.ArcFollowCamera.alpha of type 'number':

    if (oldProps.alpha !== newProps.alpha) {
      updates.push({
        propertyName: "alpha",
        value: newProps.alpha,
        type: "number"
      });
    } // BABYLON.ArcFollowCamera.beta of type 'number':


    if (oldProps.beta !== newProps.beta) {
      updates.push({
        propertyName: "beta",
        value: newProps.beta,
        type: "number"
      });
    } // BABYLON.ArcFollowCamera.radius of type 'number':


    if (oldProps.radius !== newProps.radius) {
      updates.push({
        propertyName: "radius",
        value: newProps.radius,
        type: "number"
      });
    } // TODO: type: BABYLON.AbstractMesh property (not coded) BABYLON.ArcFollowCamera.target.


    return updates.length == 0 ? null : updates;
  };

  return FiberArcFollowCameraPropsHandler;
}();
/**
 * Arc Rotate version of the follow camera.
 * It still follows a Defined mesh but in an Arc Rotate Camera fashion.
 *
 * This code has been generated
 */


var FiberArcFollowCamera =
/** @class */
function () {
  function FiberArcFollowCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberArcFollowCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberArcFollowCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberArcFollowCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberArcFollowCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ArcFollowCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "alpha",
      type: "number",
      optional: false
    }, {
      name: "beta",
      type: "number",
      optional: false
    }, {
      name: "radius",
      type: "number",
      optional: false
    }, {
      name: "target",
      type: "BABYLON.AbstractMesh",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberArcFollowCamera.Metadata = {
    isCamera: true,
    className: "FiberArcFollowCamera"
  };
  return FiberArcFollowCamera;
}();

var FiberFreeCameraProps =
/** @class */
function (_super) {
  __extends(FiberFreeCameraProps, _super);

  function FiberFreeCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberFreeCameraProps;
}(FiberTargetCameraProps);

var FiberFreeCameraPropsHandler =
/** @class */
function () {
  function FiberFreeCameraPropsHandler() {}

  FiberFreeCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.FreeCamera.angularSensibility of type 'number':

    if (oldProps.angularSensibility !== newProps.angularSensibility) {
      updates.push({
        propertyName: "angularSensibility",
        value: newProps.angularSensibility,
        type: "number"
      });
    } // BABYLON.FreeCamera.applyGravity of type 'boolean':


    if (oldProps.applyGravity !== newProps.applyGravity) {
      updates.push({
        propertyName: "applyGravity",
        value: newProps.applyGravity,
        type: "boolean"
      });
    } // BABYLON.FreeCamera.checkCollisions of type 'boolean':


    if (oldProps.checkCollisions !== newProps.checkCollisions) {
      updates.push({
        propertyName: "checkCollisions",
        value: newProps.checkCollisions,
        type: "boolean"
      });
    } // BABYLON.FreeCamera.collisionMask of type 'number':


    if (oldProps.collisionMask !== newProps.collisionMask) {
      updates.push({
        propertyName: "collisionMask",
        value: newProps.collisionMask,
        type: "number"
      });
    } // BABYLON.FreeCamera.ellipsoid of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.ellipsoid && (!oldProps.ellipsoid || !oldProps.ellipsoid.equals(newProps.ellipsoid))) {
      updates.push({
        propertyName: "ellipsoid",
        value: newProps.ellipsoid,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.FreeCamera.ellipsoidOffset of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.ellipsoidOffset && (!oldProps.ellipsoidOffset || !oldProps.ellipsoidOffset.equals(newProps.ellipsoidOffset))) {
      updates.push({
        propertyName: "ellipsoidOffset",
        value: newProps.ellipsoidOffset,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.FreeCameraInputsManager property (not coded) BABYLON.FreeCamera.inputs.
    // TODO: type: number[] property (not coded) BABYLON.FreeCamera.keysDown.
    // TODO: type: number[] property (not coded) BABYLON.FreeCamera.keysLeft.
    // TODO: type: number[] property (not coded) BABYLON.FreeCamera.keysRight.
    // TODO: type: number[] property (not coded) BABYLON.FreeCamera.keysUp.
    // BABYLON.FreeCamera.onCollide of type '(collidedMesh: BABYLON.AbstractMesh) => void/fn':


    if (oldProps.onCollide === undefined && oldProps.onCollide !== newProps.onCollide) {
      updates.push({
        propertyName: "onCollide",
        value: newProps.onCollide,
        type: "(collidedMesh: BABYLON.AbstractMesh) => void"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberFreeCameraPropsHandler;
}();
/**
 * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
 * Please consider using the new UniversalCamera instead as it adds more functionality like the gamepad.
 *
 * This code has been generated
 */


var FiberFreeCamera =
/** @class */
function () {
  function FiberFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberFreeCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "FreeCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "setActiveOnSceneIfNoneActive",
      type: "boolean",
      optional: true
    }]
  };
  FiberFreeCamera.Metadata = {
    isCamera: true,
    className: "FiberFreeCamera"
  };
  return FiberFreeCamera;
}();

var FiberDeviceOrientationCameraProps =
/** @class */
function (_super) {
  __extends(FiberDeviceOrientationCameraProps, _super);

  function FiberDeviceOrientationCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberDeviceOrientationCameraProps;
}(FiberFreeCameraProps);

var FiberDeviceOrientationCameraPropsHandler =
/** @class */
function () {
  function FiberDeviceOrientationCameraPropsHandler() {}

  FiberDeviceOrientationCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberDeviceOrientationCameraPropsHandler;
}();
/**
 * This is a camera specifically designed to react to device orientation events such as a modern mobile device
 * being tilted forward or back and left or right.
 *
 * This code has been generated
 */


var FiberDeviceOrientationCamera =
/** @class */
function () {
  function FiberDeviceOrientationCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberDeviceOrientationCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDeviceOrientationCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDeviceOrientationCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDeviceOrientationCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "DeviceOrientationCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberDeviceOrientationCamera.Metadata = {
    isCamera: true,
    className: "FiberDeviceOrientationCamera"
  };
  return FiberDeviceOrientationCamera;
}();

var FiberVRDeviceOrientationFreeCameraProps =
/** @class */
function (_super) {
  __extends(FiberVRDeviceOrientationFreeCameraProps, _super);

  function FiberVRDeviceOrientationFreeCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVRDeviceOrientationFreeCameraProps;
}(FiberDeviceOrientationCameraProps);

var FiberVRDeviceOrientationFreeCameraPropsHandler =
/** @class */
function () {
  function FiberVRDeviceOrientationFreeCameraPropsHandler() {}

  FiberVRDeviceOrientationFreeCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberVRDeviceOrientationFreeCameraPropsHandler;
}();
/**
 * Camera used to simulate VR rendering (based on FreeCamera)
 *
 * This code has been generated
 */


var FiberVRDeviceOrientationFreeCamera =
/** @class */
function () {
  function FiberVRDeviceOrientationFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVRDeviceOrientationFreeCameraPropsHandler(), new FiberDeviceOrientationCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVRDeviceOrientationFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRDeviceOrientationFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRDeviceOrientationFreeCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VRDeviceOrientationFreeCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "compensateDistortion",
      type: "boolean",
      optional: true
    }, {
      name: "vrCameraMetrics",
      type: "BABYLON.VRCameraMetrics",
      optional: true
    }]
  };
  FiberVRDeviceOrientationFreeCamera.Metadata = {
    isCamera: true,
    className: "FiberVRDeviceOrientationFreeCamera"
  };
  return FiberVRDeviceOrientationFreeCamera;
}();

var FiberVRDeviceOrientationGamepadCameraProps =
/** @class */
function (_super) {
  __extends(FiberVRDeviceOrientationGamepadCameraProps, _super);

  function FiberVRDeviceOrientationGamepadCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVRDeviceOrientationGamepadCameraProps;
}(FiberVRDeviceOrientationFreeCameraProps);

var FiberVRDeviceOrientationGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberVRDeviceOrientationGamepadCameraPropsHandler() {}

  FiberVRDeviceOrientationGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberVRDeviceOrientationGamepadCameraPropsHandler;
}();
/**
 * Camera used to simulate VR rendering (based on VRDeviceOrientationFreeCamera)
 *
 * This code has been generated
 */


var FiberVRDeviceOrientationGamepadCamera =
/** @class */
function () {
  function FiberVRDeviceOrientationGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVRDeviceOrientationGamepadCameraPropsHandler(), new FiberVRDeviceOrientationFreeCameraPropsHandler(), new FiberDeviceOrientationCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVRDeviceOrientationGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRDeviceOrientationGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRDeviceOrientationGamepadCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VRDeviceOrientationGamepadCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "compensateDistortion",
      type: "boolean",
      optional: true
    }, {
      name: "vrCameraMetrics",
      type: "BABYLON.VRCameraMetrics",
      optional: true
    }]
  };
  FiberVRDeviceOrientationGamepadCamera.Metadata = {
    isCamera: true,
    className: "FiberVRDeviceOrientationGamepadCamera"
  };
  return FiberVRDeviceOrientationGamepadCamera;
}();

var FiberTouchCameraProps =
/** @class */
function (_super) {
  __extends(FiberTouchCameraProps, _super);

  function FiberTouchCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberTouchCameraProps;
}(FiberFreeCameraProps);

var FiberTouchCameraPropsHandler =
/** @class */
function () {
  function FiberTouchCameraPropsHandler() {}

  FiberTouchCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.TouchCamera.touchAngularSensibility of type 'number':

    if (oldProps.touchAngularSensibility !== newProps.touchAngularSensibility) {
      updates.push({
        propertyName: "touchAngularSensibility",
        value: newProps.touchAngularSensibility,
        type: "number"
      });
    } // BABYLON.TouchCamera.touchMoveSensibility of type 'number':


    if (oldProps.touchMoveSensibility !== newProps.touchMoveSensibility) {
      updates.push({
        propertyName: "touchMoveSensibility",
        value: newProps.touchMoveSensibility,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberTouchCameraPropsHandler;
}();
/**
 * This represents a FPS type of camera controlled by touch.
 * This is like a universal camera minus the Gamepad controls.
 *
 * This code has been generated
 */


var FiberTouchCamera =
/** @class */
function () {
  function FiberTouchCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTouchCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTouchCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTouchCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "TouchCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberTouchCamera.Metadata = {
    isCamera: true,
    className: "FiberTouchCamera"
  };
  return FiberTouchCamera;
}();

var FiberUniversalCameraProps =
/** @class */
function (_super) {
  __extends(FiberUniversalCameraProps, _super);

  function FiberUniversalCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberUniversalCameraProps;
}(FiberTouchCameraProps);

var FiberUniversalCameraPropsHandler =
/** @class */
function () {
  function FiberUniversalCameraPropsHandler() {}

  FiberUniversalCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.UniversalCamera.gamepadAngularSensibility of type 'number':

    if (oldProps.gamepadAngularSensibility !== newProps.gamepadAngularSensibility) {
      updates.push({
        propertyName: "gamepadAngularSensibility",
        value: newProps.gamepadAngularSensibility,
        type: "number"
      });
    } // BABYLON.UniversalCamera.gamepadMoveSensibility of type 'number':


    if (oldProps.gamepadMoveSensibility !== newProps.gamepadMoveSensibility) {
      updates.push({
        propertyName: "gamepadMoveSensibility",
        value: newProps.gamepadMoveSensibility,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberUniversalCameraPropsHandler;
}();
/**
 * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
 * which still works and will still be found in many Playgrounds.
 *
 * This code has been generated
 */


var FiberUniversalCamera =
/** @class */
function () {
  function FiberUniversalCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberUniversalCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberUniversalCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberUniversalCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "UniversalCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberUniversalCamera.Metadata = {
    isCamera: true,
    className: "FiberUniversalCamera"
  };
  return FiberUniversalCamera;
}();

var FiberGamepadCameraProps =
/** @class */
function (_super) {
  __extends(FiberGamepadCameraProps, _super);

  function FiberGamepadCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberGamepadCameraProps;
}(FiberUniversalCameraProps);

var FiberGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberGamepadCameraPropsHandler() {}

  FiberGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberGamepadCameraPropsHandler;
}();
/**
 * This represents a FPS type of camera. This is only here for back compat purpose.
 * Please use the UniversalCamera instead as both are identical.
 *
 * This code has been generated
 */


var FiberGamepadCamera =
/** @class */
function () {
  function FiberGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberGamepadCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGamepadCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "GamepadCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberGamepadCamera.Metadata = {
    isCamera: true,
    className: "FiberGamepadCamera"
  };
  return FiberGamepadCamera;
}();

var FiberAnaglyphGamepadCameraProps =
/** @class */
function (_super) {
  __extends(FiberAnaglyphGamepadCameraProps, _super);

  function FiberAnaglyphGamepadCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAnaglyphGamepadCameraProps;
}(FiberGamepadCameraProps);

var FiberAnaglyphGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphGamepadCameraPropsHandler() {}

  FiberAnaglyphGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberAnaglyphGamepadCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on GamepadCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphGamepadCamera =
/** @class */
function () {
  function FiberAnaglyphGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphGamepadCameraPropsHandler(), new FiberGamepadCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphGamepadCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AnaglyphGamepadCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberAnaglyphGamepadCamera.Metadata = {
    isCamera: true,
    className: "FiberAnaglyphGamepadCamera"
  };
  return FiberAnaglyphGamepadCamera;
}();

var FiberStereoscopicGamepadCameraProps =
/** @class */
function (_super) {
  __extends(FiberStereoscopicGamepadCameraProps, _super);

  function FiberStereoscopicGamepadCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStereoscopicGamepadCameraProps;
}(FiberGamepadCameraProps);

var FiberStereoscopicGamepadCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicGamepadCameraPropsHandler() {}

  FiberStereoscopicGamepadCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberStereoscopicGamepadCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on GamepadCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicGamepadCamera =
/** @class */
function () {
  function FiberStereoscopicGamepadCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicGamepadCameraPropsHandler(), new FiberGamepadCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicGamepadCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicGamepadCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicGamepadCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StereoscopicGamepadCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "isStereoscopicSideBySide",
      type: "boolean",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberStereoscopicGamepadCamera.Metadata = {
    isCamera: true,
    className: "FiberStereoscopicGamepadCamera"
  };
  return FiberStereoscopicGamepadCamera;
}();

var FiberAnaglyphUniversalCameraProps =
/** @class */
function (_super) {
  __extends(FiberAnaglyphUniversalCameraProps, _super);

  function FiberAnaglyphUniversalCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAnaglyphUniversalCameraProps;
}(FiberUniversalCameraProps);

var FiberAnaglyphUniversalCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphUniversalCameraPropsHandler() {}

  FiberAnaglyphUniversalCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberAnaglyphUniversalCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on UniversalCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphUniversalCamera =
/** @class */
function () {
  function FiberAnaglyphUniversalCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphUniversalCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphUniversalCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphUniversalCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphUniversalCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AnaglyphUniversalCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberAnaglyphUniversalCamera.Metadata = {
    isCamera: true,
    className: "FiberAnaglyphUniversalCamera"
  };
  return FiberAnaglyphUniversalCamera;
}();

var FiberStereoscopicUniversalCameraProps =
/** @class */
function (_super) {
  __extends(FiberStereoscopicUniversalCameraProps, _super);

  function FiberStereoscopicUniversalCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStereoscopicUniversalCameraProps;
}(FiberUniversalCameraProps);

var FiberStereoscopicUniversalCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicUniversalCameraPropsHandler() {}

  FiberStereoscopicUniversalCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberStereoscopicUniversalCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on UniversalCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicUniversalCamera =
/** @class */
function () {
  function FiberStereoscopicUniversalCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicUniversalCameraPropsHandler(), new FiberUniversalCameraPropsHandler(), new FiberTouchCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicUniversalCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicUniversalCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicUniversalCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StereoscopicUniversalCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "isStereoscopicSideBySide",
      type: "boolean",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberStereoscopicUniversalCamera.Metadata = {
    isCamera: true,
    className: "FiberStereoscopicUniversalCamera"
  };
  return FiberStereoscopicUniversalCamera;
}();

var FiberVirtualJoysticksCameraProps =
/** @class */
function (_super) {
  __extends(FiberVirtualJoysticksCameraProps, _super);

  function FiberVirtualJoysticksCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVirtualJoysticksCameraProps;
}(FiberFreeCameraProps);

var FiberVirtualJoysticksCameraPropsHandler =
/** @class */
function () {
  function FiberVirtualJoysticksCameraPropsHandler() {}

  FiberVirtualJoysticksCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberVirtualJoysticksCameraPropsHandler;
}();
/**
 * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
 * It is identical to the Free Camera and simply adds by default a virtual joystick.
 * Virtual Joysticks are on-screen 2D graphics that are used to control the camera or other scene items.
 *
 * This code has been generated
 */


var FiberVirtualJoysticksCamera =
/** @class */
function () {
  function FiberVirtualJoysticksCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberVirtualJoysticksCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberVirtualJoysticksCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVirtualJoysticksCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVirtualJoysticksCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VirtualJoysticksCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberVirtualJoysticksCamera.Metadata = {
    isCamera: true,
    className: "FiberVirtualJoysticksCamera"
  };
  return FiberVirtualJoysticksCamera;
}();

var FiberWebVRFreeCameraProps =
/** @class */
function (_super) {
  __extends(FiberWebVRFreeCameraProps, _super);

  function FiberWebVRFreeCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberWebVRFreeCameraProps;
}(FiberFreeCameraProps);

var FiberWebVRFreeCameraPropsHandler =
/** @class */
function () {
  function FiberWebVRFreeCameraPropsHandler() {}

  FiberWebVRFreeCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.WebVRController[] property (not coded) BABYLON.WebVRFreeCamera.controllers.
    // BABYLON.WebVRFreeCamera.devicePosition of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.devicePosition && (!oldProps.devicePosition || !oldProps.devicePosition.equals(newProps.devicePosition))) {
      updates.push({
        propertyName: "devicePosition",
        value: newProps.devicePosition,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Quaternion property (not coded) BABYLON.WebVRFreeCamera.deviceRotationQuaternion.
    // BABYLON.WebVRFreeCamera.deviceScaleFactor of type 'number':


    if (oldProps.deviceScaleFactor !== newProps.deviceScaleFactor) {
      updates.push({
        propertyName: "deviceScaleFactor",
        value: newProps.deviceScaleFactor,
        type: "number"
      });
    } // BABYLON.WebVRFreeCamera.onControllerMeshLoadedObservable of type 'BABYLON.Observable<BABYLON.WebVRController>/fn':


    if (oldProps.onControllerMeshLoadedObservable === undefined && oldProps.onControllerMeshLoadedObservable !== newProps.onControllerMeshLoadedObservable) {
      updates.push({
        propertyName: "onControllerMeshLoadedObservable",
        value: newProps.onControllerMeshLoadedObservable,
        type: "BABYLON.Observable<BABYLON.WebVRController>"
      });
    } // BABYLON.WebVRFreeCamera.onControllersAttachedObservable of type 'BABYLON.Observable<BABYLON.WebVRController[]>/fn':


    if (oldProps.onControllersAttachedObservable === undefined && oldProps.onControllersAttachedObservable !== newProps.onControllersAttachedObservable) {
      updates.push({
        propertyName: "onControllersAttachedObservable",
        value: newProps.onControllersAttachedObservable,
        type: "BABYLON.Observable<BABYLON.WebVRController[]>"
      });
    } // BABYLON.WebVRFreeCamera.onPoseUpdatedFromDeviceObservable of type 'BABYLON.Observable<any>/fn':


    if (oldProps.onPoseUpdatedFromDeviceObservable === undefined && oldProps.onPoseUpdatedFromDeviceObservable !== newProps.onPoseUpdatedFromDeviceObservable) {
      updates.push({
        propertyName: "onPoseUpdatedFromDeviceObservable",
        value: newProps.onPoseUpdatedFromDeviceObservable,
        type: "BABYLON.Observable<any>"
      });
    } // TODO: type: BABYLON.DevicePose property (not coded) BABYLON.WebVRFreeCamera.rawPose.
    // BABYLON.WebVRFreeCamera.rigParenting of type 'boolean':


    if (oldProps.rigParenting !== newProps.rigParenting) {
      updates.push({
        propertyName: "rigParenting",
        value: newProps.rigParenting,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.WebVRFreeCamera.updateCacheCalled.
    // TODO: type: any property (not coded) BABYLON.WebVRFreeCamera.webVROptions.


    return updates.length == 0 ? null : updates;
  };

  return FiberWebVRFreeCameraPropsHandler;
}();
/**
 * This represents a WebVR camera.
 * The WebVR camera is Babylon's simple interface to interaction with Windows Mixed Reality, HTC Vive and Oculus Rift.
 *
 * This code has been generated
 */


var FiberWebVRFreeCamera =
/** @class */
function () {
  function FiberWebVRFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberWebVRFreeCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberWebVRFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberWebVRFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberWebVRFreeCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "WebVRFreeCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "webVROptions",
      type: "BABYLON.WebVROptions",
      optional: true
    }]
  };
  FiberWebVRFreeCamera.Metadata = {
    isCamera: true,
    className: "FiberWebVRFreeCamera"
  };
  return FiberWebVRFreeCamera;
}();

var FiberAnaglyphFreeCameraProps =
/** @class */
function (_super) {
  __extends(FiberAnaglyphFreeCameraProps, _super);

  function FiberAnaglyphFreeCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAnaglyphFreeCameraProps;
}(FiberFreeCameraProps);

var FiberAnaglyphFreeCameraPropsHandler =
/** @class */
function () {
  function FiberAnaglyphFreeCameraPropsHandler() {}

  FiberAnaglyphFreeCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberAnaglyphFreeCameraPropsHandler;
}();
/**
 * Camera used to simulate anaglyphic rendering (based on FreeCamera)
 *
 * This code has been generated
 */


var FiberAnaglyphFreeCamera =
/** @class */
function () {
  function FiberAnaglyphFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberAnaglyphFreeCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberAnaglyphFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAnaglyphFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAnaglyphFreeCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AnaglyphFreeCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberAnaglyphFreeCamera.Metadata = {
    isCamera: true,
    className: "FiberAnaglyphFreeCamera"
  };
  return FiberAnaglyphFreeCamera;
}();

var FiberStereoscopicFreeCameraProps =
/** @class */
function (_super) {
  __extends(FiberStereoscopicFreeCameraProps, _super);

  function FiberStereoscopicFreeCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStereoscopicFreeCameraProps;
}(FiberFreeCameraProps);

var FiberStereoscopicFreeCameraPropsHandler =
/** @class */
function () {
  function FiberStereoscopicFreeCameraPropsHandler() {}

  FiberStereoscopicFreeCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberStereoscopicFreeCameraPropsHandler;
}();
/**
 * Camera used to simulate stereoscopic rendering (based on FreeCamera)
 *
 * This code has been generated
 */


var FiberStereoscopicFreeCamera =
/** @class */
function () {
  function FiberStereoscopicFreeCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberStereoscopicFreeCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberStereoscopicFreeCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStereoscopicFreeCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStereoscopicFreeCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StereoscopicFreeCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "interaxialDistance",
      type: "number",
      optional: false
    }, {
      name: "isStereoscopicSideBySide",
      type: "boolean",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberStereoscopicFreeCamera.Metadata = {
    isCamera: true,
    className: "FiberStereoscopicFreeCamera"
  };
  return FiberStereoscopicFreeCamera;
}();

var FiberWebXRCameraProps =
/** @class */
function (_super) {
  __extends(FiberWebXRCameraProps, _super);

  function FiberWebXRCameraProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberWebXRCameraProps;
}(FiberFreeCameraProps);

var FiberWebXRCameraPropsHandler =
/** @class */
function () {
  function FiberWebXRCameraPropsHandler() {}

  FiberWebXRCameraPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberWebXRCameraPropsHandler;
}();
/**
 * WebXR Camera which holds the views for the xrSession
 *
 * This code has been generated
 */


var FiberWebXRCamera =
/** @class */
function () {
  function FiberWebXRCamera() {
    this.isTargetable = true;
    this.propsHandlers = [new FiberWebXRCameraPropsHandler(), new FiberFreeCameraPropsHandler(), new FiberTargetCameraPropsHandler(), new FiberCameraPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberWebXRCamera.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberWebXRCamera.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberWebXRCamera.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "WebXRCamera",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberWebXRCamera.Metadata = {
    isCamera: true,
    className: "FiberWebXRCamera"
  };
  return FiberWebXRCamera;
}();
/**
 * Creates a box mesh
 * * The parameter `size` sets the size (float) of each box side (default 1)
 * * You can set some different box dimensions by using the parameters `width`, `height` and `depth` (all by default have the same value of `size`)
 * * You can set different colors and different images to each box side by using the parameters `faceColors` (an array of 6 Color3 elements) and `faceUV` (an array of 6 Vector4 elements)
 * * Please read this tutorial : https://doc.babylonjs.com/how_to/createbox_per_face_textures_and_colors
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberBox =
/** @class */
function () {
  function FiberBox() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberBox.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBox.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBox.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateBox",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "size",
        type: "number",
        optional: true
      }, {
        name: "width",
        type: "number",
        optional: true
      }, {
        name: "height",
        type: "number",
        optional: true
      }, {
        name: "depth",
        type: "number",
        optional: true
      }, {
        name: "faceUV",
        type: "BABYLON.Vector4[]",
        optional: true
      }, {
        name: "faceColors",
        type: "BABYLON.Color4[]",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberBox.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberBox"
  };
  return FiberBox;
}();
/**
 * Creates a sphere mesh
 * * The parameter `diameter` sets the diameter size (float) of the sphere (default 1)
 * * You can set some different sphere dimensions, for instance to build an ellipsoid, by using the parameters `diameterX`, `diameterY` and `diameterZ` (all by default have the same value of `diameter`)
 * * The parameter `segments` sets the sphere number of horizontal stripes (positive integer, default 32)
 * * You can create an unclosed sphere with the parameter `arc` (positive float, default 1), valued between 0 and 1, what is the ratio of the circumference (latitude) : 2 x PI x ratio
 * * You can create an unclosed sphere on its height with the parameter `slice` (positive float, default1), valued between 0 and 1, what is the height ratio (longitude)
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberSphere =
/** @class */
function () {
  function FiberSphere() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberSphere.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSphere.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSphere.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateSphere",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "segments",
        type: "number",
        optional: true
      }, {
        name: "diameter",
        type: "number",
        optional: true
      }, {
        name: "diameterX",
        type: "number",
        optional: true
      }, {
        name: "diameterY",
        type: "number",
        optional: true
      }, {
        name: "diameterZ",
        type: "number",
        optional: true
      }, {
        name: "arc",
        type: "number",
        optional: true
      }, {
        name: "slice",
        type: "number",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "any",
      optional: false
    }]
  };
  FiberSphere.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberSphere"
  };
  return FiberSphere;
}();
/**
 * Creates a plane polygonal mesh.  By default, this is a disc
 * * The parameter `radius` sets the radius size (float) of the polygon (default 0.5)
 * * The parameter `tessellation` sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
 * * You can create an unclosed polygon with the parameter `arc` (positive float, default 1), valued between 0 and 1, what is the ratio of the circumference : 2 x PI x ratio
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberDisc =
/** @class */
function () {
  function FiberDisc() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDisc.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDisc.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDisc.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateDisc",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "radius",
        type: "number",
        optional: true
      }, {
        name: "tessellation",
        type: "number",
        optional: true
      }, {
        name: "arc",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberDisc.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberDisc"
  };
  return FiberDisc;
}();
/**
 * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
 * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
 * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value of `radius`)
 * * The parameter `subdivisions` sets the number of subdivisions (postive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
 * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberIcoSphere =
/** @class */
function () {
  function FiberIcoSphere() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberIcoSphere.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberIcoSphere.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberIcoSphere.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateIcoSphere",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "radius",
        type: "number",
        optional: true
      }, {
        name: "radiusX",
        type: "number",
        optional: true
      }, {
        name: "radiusY",
        type: "number",
        optional: true
      }, {
        name: "radiusZ",
        type: "number",
        optional: true
      }, {
        name: "flat",
        type: "boolean",
        optional: true
      }, {
        name: "subdivisions",
        type: "number",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberIcoSphere.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberIcoSphere"
  };
  return FiberIcoSphere;
}();
/**
 * Creates a ribbon mesh. The ribbon is a parametric shape.  It has no predefined shape. Its final shape will depend on the input parameters
 * * The parameter `pathArray` is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry
 * * The parameter `closeArray` (boolean, default false) creates a seam between the first and the last paths of the path array
 * * The parameter `closePath` (boolean, default false) creates a seam between the first and the last points of each path of the path array
 * * The parameter `offset` (positive integer, default : rounded half size of the pathArray length), is taken in account only if the `pathArray` is containing a single path
 * * It's the offset to join the points from the same path. Ex : offset = 10 means the point 1 is joined to the point 11
 * * The optional parameter `instance` is an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#ribbon
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The parameter `uvs` is an optional flat array of `Vector2` to update/set each ribbon vertex with its own custom UV values instead of the computed ones
 * * The parameters `colors` is an optional flat array of `Color4` to set/update each ribbon vertex with its own custom color values
 * * Note that if you use the parameters `uvs` or `colors`, the passed arrays must be populated with the right number of elements, it is to say the number of ribbon vertices. Remember that if you set `closePath` to `true`, there's one extra vertex per path in the geometry
 * * Moreover, you can use the parameter `color` with `instance` (to update the ribbon), only if you previously used it at creation time
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberRibbon =
/** @class */
function () {
  function FiberRibbon() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberRibbon.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRibbon.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRibbon.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateRibbon",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "pathArray",
        type: "BABYLON.Vector3[][]",
        optional: false
      }, {
        name: "closeArray",
        type: "boolean",
        optional: true
      }, {
        name: "closePath",
        type: "boolean",
        optional: true
      }, {
        name: "offset",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.Mesh",
        optional: true
      }, {
        name: "invertUV",
        type: "boolean",
        optional: true
      }, {
        name: "uvs",
        type: "BABYLON.Vector2[]",
        optional: true
      }, {
        name: "colors",
        type: "BABYLON.Color4[]",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberRibbon.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberRibbon"
  };
  return FiberRibbon;
}();
/**
 * Creates a cylinder or a cone mesh
 * * The parameter `height` sets the height size (float) of the cylinder/cone (float, default 2).
 * * The parameter `diameter` sets the diameter of the top and bottom cap at once (float, default 1).
 * * The parameters `diameterTop` and `diameterBottom` overwrite the parameter `diameter` and set respectively the top cap and bottom cap diameter (floats, default 1). The parameter "diameterBottom" can't be zero.
 * * The parameter `tessellation` sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance.
 * * The parameter `subdivisions` sets the number of rings along the cylinder height (positive integer, default 1).
 * * The parameter `hasRings` (boolean, default false) makes the subdivisions independent from each other, so they become different faces.
 * * The parameter `enclose`  (boolean, default false) adds two extra faces per subdivision to a sliced cylinder to close it around its height axis.
 * * The parameter `arc` (float, default 1) is the ratio (max 1) to apply to the circumference to slice the cylinder.
 * * You can set different colors and different images to each box side by using the parameters `faceColors` (an array of n Color3 elements) and `faceUV` (an array of n Vector4 elements).
 * * The value of n is the number of cylinder faces. If the cylinder has only 1 subdivisions, n equals : top face + cylinder surface + bottom face = 3
 * * Now, if the cylinder has 5 independent subdivisions (hasRings = true), n equals : top face + 5 stripe surfaces + bottom face = 2 + 5 = 7
 * * Finally, if the cylinder has 5 independent subdivisions and is enclose, n equals : top face + 5 x (stripe surface + 2 closing faces) + bottom face = 2 + 5 * 3 = 17
 * * Each array (color or UVs) is always ordered the same way : the first element is the bottom cap, the last element is the top cap. The other elements are each a ring surface.
 * * If `enclose` is false, a ring surface is one element.
 * * If `enclose` is true, a ring surface is 3 successive elements in the array : the tubular surface, then the two closing faces.
 * * Example how to set colors and textures on a sliced cylinder : https://www.html5gamedevs.com/topic/17945-creating-a-closed-slice-of-a-cylinder/#comment-106379
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberCylinder =
/** @class */
function () {
  function FiberCylinder() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberCylinder.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCylinder.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCylinder.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateCylinder",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "height",
        type: "number",
        optional: true
      }, {
        name: "diameterTop",
        type: "number",
        optional: true
      }, {
        name: "diameterBottom",
        type: "number",
        optional: true
      }, {
        name: "diameter",
        type: "number",
        optional: true
      }, {
        name: "tessellation",
        type: "number",
        optional: true
      }, {
        name: "subdivisions",
        type: "number",
        optional: true
      }, {
        name: "arc",
        type: "number",
        optional: true
      }, {
        name: "faceColors",
        type: "BABYLON.Color4[]",
        optional: true
      }, {
        name: "faceUV",
        type: "BABYLON.Vector4[]",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "hasRings",
        type: "boolean",
        optional: true
      }, {
        name: "enclose",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "any",
      optional: false
    }]
  };
  FiberCylinder.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberCylinder"
  };
  return FiberCylinder;
}();
/**
 * Creates a torus mesh
 * * The parameter `diameter` sets the diameter size (float) of the torus (default 1)
 * * The parameter `thickness` sets the diameter size of the tube of the torus (float, default 0.5)
 * * The parameter `tessellation` sets the number of torus sides (postive integer, default 16)
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberTorus =
/** @class */
function () {
  function FiberTorus() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTorus.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTorus.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTorus.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateTorus",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "diameter",
        type: "number",
        optional: true
      }, {
        name: "thickness",
        type: "number",
        optional: true
      }, {
        name: "tessellation",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "any",
      optional: false
    }]
  };
  FiberTorus.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberTorus"
  };
  return FiberTorus;
}();
/**
 * Creates a torus knot mesh
 * * The parameter `radius` sets the global radius size (float) of the torus knot (default 2)
 * * The parameter `radialSegments` sets the number of sides on each tube segments (positive integer, default 32)
 * * The parameter `tubularSegments` sets the number of tubes to decompose the knot into (positive integer, default 32)
 * * The parameters `p` and `q` are the number of windings on each axis (positive integers, default 2 and 3)
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberTorusKnot =
/** @class */
function () {
  function FiberTorusKnot() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTorusKnot.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTorusKnot.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTorusKnot.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateTorusKnot",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "radius",
        type: "number",
        optional: true
      }, {
        name: "tube",
        type: "number",
        optional: true
      }, {
        name: "radialSegments",
        type: "number",
        optional: true
      }, {
        name: "tubularSegments",
        type: "number",
        optional: true
      }, {
        name: "p",
        type: "number",
        optional: true
      }, {
        name: "q",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "any",
      optional: false
    }]
  };
  FiberTorusKnot.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberTorusKnot"
  };
  return FiberTorusKnot;
}();
/**
 * Creates a line system mesh. A line system is a pool of many lines gathered in a single mesh
 * * A line system mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of lines as an input parameter
 * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineSystem to this static function
 * * The parameter `lines` is an array of lines, each line being an array of successive Vector3
 * * The optional parameter `instance` is an instance of an existing LineSystem object to be updated with the passed `lines` parameter
 * * The optional parameter `colors` is an array of line colors, each line colors being an array of successive Color4, one per line point
 * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need the alpha blending (faster)
 * * Updating a simple Line mesh, you just need to update every line in the `lines` array : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#lines-and-dashedlines
 * * When updating an instance, remember that only line point positions can change, not the number of points, neither the number of lines
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberLineSystem =
/** @class */
function () {
  function FiberLineSystem() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLineSystem.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLineSystem.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLineSystem.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateLineSystem",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "lines",
        type: "BABYLON.Vector3[][]",
        optional: false
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.LinesMesh",
        optional: true
      }, {
        name: "colors",
        type: "BABYLON.Color4[][]",
        optional: true
      }, {
        name: "useVertexAlpha",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberLineSystem.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberLineSystem"
  };
  return FiberLineSystem;
}();
/**
 * Creates a line mesh
 * A line mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of points as an input parameter
 * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineMesh to this static function
 * * The parameter `points` is an array successive Vector3
 * * The optional parameter `instance` is an instance of an existing LineMesh object to be updated with the passed `points` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#lines-and-dashedlines
 * * The optional parameter `colors` is an array of successive Color4, one per line point
 * * The optional parameter `useVertexAlpha` is to be set to `false` (default `true`) when you don't need alpha blending (faster)
 * * When updating an instance, remember that only point positions can change, not the number of points
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberLines =
/** @class */
function () {
  function FiberLines() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLines.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLines.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLines.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateLines",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "points",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.LinesMesh",
        optional: true
      }, {
        name: "colors",
        type: "BABYLON.Color4[]",
        optional: true
      }, {
        name: "useVertexAlpha",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberLines.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberLines"
  };
  return FiberLines;
}();
/**
 * Creates a dashed line mesh
 * * A dashed line mesh is considered as a parametric shape since it has no predefined original shape. Its shape is determined by the passed array of points as an input parameter
 * * Like every other parametric shape, it is dynamically updatable by passing an existing instance of LineMesh to this static function
 * * The parameter `points` is an array successive Vector3
 * * The parameter `dashNb` is the intended total number of dashes (positive integer, default 200)
 * * The parameter `dashSize` is the size of the dashes relatively the dash number (positive float, default 3)
 * * The parameter `gapSize` is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
 * * The optional parameter `instance` is an instance of an existing LineMesh object to be updated with the passed `points` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#lines-and-dashedlines
 * * When updating an instance, remember that only point positions can change, not the number of points
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberDashedLines =
/** @class */
function () {
  function FiberDashedLines() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDashedLines.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDashedLines.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDashedLines.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateDashedLines",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "points",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "dashSize",
        type: "number",
        optional: true
      }, {
        name: "gapSize",
        type: "number",
        optional: true
      }, {
        name: "dashNb",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.LinesMesh",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberDashedLines.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberDashedLines"
  };
  return FiberDashedLines;
}();
/**
 * Creates an extruded shape mesh. The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
 * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis.
 * * The parameter `path` is a required array of successive Vector3. This is the axis curve the shape is extruded along.
 * * The parameter `rotation` (float, default 0 radians) is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve.
 * * The parameter `scale` (float, default 1) is the value to scale the shape.
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * The optional parameter `instance` is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#extruded-shape
 * * Remember you can only change the shape or path point positions, not their number when updating an extruded shape.
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture.
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberExtrudeShape =
/** @class */
function () {
  function FiberExtrudeShape() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberExtrudeShape.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberExtrudeShape.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberExtrudeShape.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "ExtrudeShape",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "shape",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "path",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "scale",
        type: "number",
        optional: true
      }, {
        name: "rotation",
        type: "number",
        optional: true
      }, {
        name: "cap",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.Mesh",
        optional: true
      }, {
        name: "invertUV",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberExtrudeShape.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberExtrudeShape"
  };
  return FiberExtrudeShape;
}();
/**
 * Creates an custom extruded shape mesh.
 * The custom extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
 * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis.
 * * The parameter `path` is a required array of successive Vector3. This is the axis curve the shape is extruded along.
 * * The parameter `rotationFunction` (JS function) is a custom Javascript function called on each path point. This function is passed the position i of the point in the path and the distance of this point from the begining of the path
 * * It must returns a float value that will be the rotation in radians applied to the shape on each path point.
 * * The parameter `scaleFunction` (JS function) is a custom Javascript function called on each path point. This function is passed the position i of the point in the path and the distance of this point from the begining of the path
 * * It must returns a float value that will be the scale value applied to the shape on each path point
 * * The parameter `ribbonClosePath` (boolean, default false) forces the extrusion underlying ribbon to close all the paths in its `pathArray`
 * * The parameter `ribbonCloseArray` (boolean, default false) forces the extrusion underlying ribbon to close its `pathArray`
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * The optional parameter `instance` is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#extruded-shape
 * * Remember you can only change the shape or path point positions, not their number when updating an extruded shape
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberExtrudeShapeCustom =
/** @class */
function () {
  function FiberExtrudeShapeCustom() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberExtrudeShapeCustom.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberExtrudeShapeCustom.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberExtrudeShapeCustom.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "ExtrudeShapeCustom",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "shape",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "path",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "scaleFunction",
        type: "any",
        optional: true
      }, {
        name: "rotationFunction",
        type: "any",
        optional: true
      }, {
        name: "ribbonCloseArray",
        type: "boolean",
        optional: true
      }, {
        name: "ribbonClosePath",
        type: "boolean",
        optional: true
      }, {
        name: "cap",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.Mesh",
        optional: true
      }, {
        name: "invertUV",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberExtrudeShapeCustom.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberExtrudeShapeCustom"
  };
  return FiberExtrudeShapeCustom;
}();
/**
 * Creates lathe mesh.
 * The lathe is a shape with a symetry axis : a 2D model shape is rotated around this axis to design the lathe
 * * The parameter `shape` is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
 * * The parameter `radius` (positive float, default 1) is the radius value of the lathe
 * * The parameter `tessellation` (positive integer, default 64) is the side number of the lathe
 * * The parameter `clip` (positive integer, default 0) is the number of sides to not create without effecting the general shape of the sides
 * * The parameter `arc` (positive float, default 1) is the ratio of the lathe. 0.5 builds for instance half a lathe, so an opened shape
 * * The parameter `closed` (boolean, default true) opens/closes the lathe circumference. This should be set to false when used with the parameter "arc"
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberLathe =
/** @class */
function () {
  function FiberLathe() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLathe.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLathe.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLathe.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateLathe",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "shape",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "radius",
        type: "number",
        optional: true
      }, {
        name: "tessellation",
        type: "number",
        optional: true
      }, {
        name: "clip",
        type: "number",
        optional: true
      }, {
        name: "arc",
        type: "number",
        optional: true
      }, {
        name: "closed",
        type: "boolean",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "cap",
        type: "number",
        optional: true
      }, {
        name: "invertUV",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberLathe.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberLathe"
  };
  return FiberLathe;
}();
/**
 * Creates a plane mesh
 * * The parameter `size` sets the size (float) of both sides of the plane at once (default 1)
 * * You can set some different plane dimensions by using the parameters `width` and `height` (both by default have the same value of `size`)
 * * The parameter `sourcePlane` is a Plane instance. It builds a mesh plane from a Math plane
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberPlane =
/** @class */
function () {
  function FiberPlane() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPlane.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPlane.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPlane.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreatePlane",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "size",
        type: "number",
        optional: true
      }, {
        name: "width",
        type: "number",
        optional: true
      }, {
        name: "height",
        type: "number",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sourcePlane",
        type: "BABYLON.Plane",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPlane.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberPlane"
  };
  return FiberPlane;
}();
/**
 * Creates a ground mesh
 * * The parameters `width` and `height` (floats, default 1) set the width and height sizes of the ground
 * * The parameter `subdivisions` (positive integer) sets the number of subdivisions per side
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberGround =
/** @class */
function () {
  function FiberGround() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberGround.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGround.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGround.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateGround",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "width",
        type: "number",
        optional: true
      }, {
        name: "height",
        type: "number",
        optional: true
      }, {
        name: "subdivisions",
        type: "number",
        optional: true
      }, {
        name: "subdivisionsX",
        type: "number",
        optional: true
      }, {
        name: "subdivisionsY",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "any",
      optional: false
    }]
  };
  FiberGround.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberGround"
  };
  return FiberGround;
}();
/**
 * Creates a tiled ground mesh
 * * The parameters `xmin` and `xmax` (floats, default -1 and 1) set the ground minimum and maximum X coordinates
 * * The parameters `zmin` and `zmax` (floats, default -1 and 1) set the ground minimum and maximum Z coordinates
 * * The parameter `subdivisions` is a javascript object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
 * * The parameter `precision` is a javascript object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberTiledGround =
/** @class */
function () {
  function FiberTiledGround() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTiledGround.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTiledGround.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTiledGround.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateTiledGround",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "xmin",
        type: "number",
        optional: false
      }, {
        name: "zmin",
        type: "number",
        optional: false
      }, {
        name: "xmax",
        type: "number",
        optional: false
      }, {
        name: "zmax",
        type: "number",
        optional: false
      }, {
        name: "subdivisions",
        type: "{ w: number; h: number; }",
        optional: true
      }, {
        name: "precision",
        type: "{ w: number; h: number; }",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberTiledGround.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberTiledGround"
  };
  return FiberTiledGround;
}();
/**
 * Creates a ground mesh from a height map
 * * The parameter `url` sets the URL of the height map image resource.
 * * The parameters `width` and `height` (positive floats, default 10) set the ground width and height sizes.
 * * The parameter `subdivisions` (positive integer, default 1) sets the number of subdivision per side.
 * * The parameter `minHeight` (float, default 0) is the minimum altitude on the ground.
 * * The parameter `maxHeight` (float, default 1) is the maximum altitude on the ground.
 * * The parameter `colorFilter` (optional Color3, default (0.3, 0.59, 0.11) ) is the filter to apply to the image pixel colors to compute the height.
 * * The parameter `onReady` is a javascript callback function that will be called  once the mesh is just built (the height map download can last some time).
 * * The parameter `alphaFilter` will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
 *
 * This code has been generated
 */


var FiberGroundFromHeightMap =
/** @class */
function () {
  function FiberGroundFromHeightMap() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberGroundFromHeightMap.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGroundFromHeightMap.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGroundFromHeightMap.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateGroundFromHeightMap",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "url",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "width",
        type: "number",
        optional: true
      }, {
        name: "height",
        type: "number",
        optional: true
      }, {
        name: "subdivisions",
        type: "number",
        optional: true
      }, {
        name: "minHeight",
        type: "number",
        optional: true
      }, {
        name: "maxHeight",
        type: "number",
        optional: true
      }, {
        name: "colorFilter",
        type: "BABYLON.Color3",
        optional: true
      }, {
        name: "alphaFilter",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "onReady",
        type: "(mesh: BABYLON.GroundMesh) => void",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberGroundFromHeightMap.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberGroundFromHeightMap"
  };
  return FiberGroundFromHeightMap;
}();
/**
 * Creates a polygon mesh
 * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh
 * * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
 * * You can set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4)
 * * Remember you can only change the shape positions, not their number when updating a polygon
 *
 * This code has been generated
 */


var FiberPolygon =
/** @class */
function () {
  function FiberPolygon() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPolygon.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPolygon.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPolygon.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreatePolygon",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "shape",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "holes",
        type: "BABYLON.Vector3[][]",
        optional: true
      }, {
        name: "depth",
        type: "number",
        optional: true
      }, {
        name: "faceUV",
        type: "BABYLON.Vector4[]",
        optional: true
      }, {
        name: "faceColors",
        type: "BABYLON.Color4[]",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPolygon.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberPolygon"
  };
  return FiberPolygon;
}();
/**
 * Creates an extruded polygon mesh, with depth in the Y direction.
 * * You can set different colors and different images to the top, bottom and extruded side by using the parameters `faceColors` (an array of 3 Color3 elements) and `faceUV` (an array of 3 Vector4 elements)
 *
 * This code has been generated
 */


var FiberExtrudePolygon =
/** @class */
function () {
  function FiberExtrudePolygon() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberExtrudePolygon.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberExtrudePolygon.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberExtrudePolygon.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "ExtrudePolygon",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "shape",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "holes",
        type: "BABYLON.Vector3[][]",
        optional: true
      }, {
        name: "depth",
        type: "number",
        optional: true
      }, {
        name: "faceUV",
        type: "BABYLON.Vector4[]",
        optional: true
      }, {
        name: "faceColors",
        type: "BABYLON.Color4[]",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberExtrudePolygon.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberExtrudePolygon"
  };
  return FiberExtrudePolygon;
}();
/**
 * Creates a tube mesh.
 * The tube is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters
 * * The parameter `path` is a required array of successive Vector3. It is the curve used as the axis of the tube
 * * The parameter `radius` (positive float, default 1) sets the tube radius size
 * * The parameter `tessellation` (positive float, default 64) is the number of sides on the tubular surface
 * * The parameter `radiusFunction` (javascript function, default null) is a vanilla javascript function. If it is not null, it overwrittes the parameter `radius`
 * * This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path. It must return a radius value (positive float)
 * * The parameter `arc` (positive float, maximum 1, default 1) is the ratio to apply to the tube circumference : 2 x PI x arc
 * * The parameter `cap` sets the way the extruded shape is capped. Possible values : BABYLON.Mesh.NO_CAP (default), BABYLON.Mesh.CAP_START, BABYLON.Mesh.CAP_END, BABYLON.Mesh.CAP_ALL
 * * The optional parameter `instance` is an instance of an existing Tube object to be updated with the passed `pathArray` parameter : https://doc.babylonjs.com/how_to/how_to_dynamically_morph_a_mesh#tube
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The optional parameter `invertUV` (boolean, default false) swaps in the geometry the U and V coordinates to apply a texture
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberTube =
/** @class */
function () {
  function FiberTube() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberTube.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTube.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTube.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateTube",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "path",
        type: "BABYLON.Vector3[]",
        optional: false
      }, {
        name: "radius",
        type: "number",
        optional: true
      }, {
        name: "tessellation",
        type: "number",
        optional: true
      }, {
        name: "radiusFunction",
        type: "(i: number, distance: number) => number",
        optional: true
      }, {
        name: "cap",
        type: "number",
        optional: true
      }, {
        name: "arc",
        type: "number",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "instance",
        type: "BABYLON.Mesh",
        optional: true
      }, {
        name: "invertUV",
        type: "boolean",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberTube.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberTube"
  };
  return FiberTube;
}();
/**
 * Creates a polyhedron mesh
 * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embbeded types. Please refer to the type sheet in the tutorial to choose the wanted type
 * * The parameter `size` (positive float, default 1) sets the polygon size
 * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
 * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overwrittes the parameter `type`
 * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
 * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
 * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/how_to/createbox_per_face_textures_and_colors
 * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
 * * You can also set the mesh side orientation with the values : BABYLON.Mesh.FRONTSIDE (default), BABYLON.Mesh.BACKSIDE or BABYLON.Mesh.DOUBLESIDE
 * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/babylon101/discover_basic_elements#side-orientation
 * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
 *
 * This code has been generated
 */


var FiberPolyhedron =
/** @class */
function () {
  function FiberPolyhedron() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPolyhedron.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPolyhedron.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPolyhedron.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreatePolyhedron",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "type",
        type: "number",
        optional: true
      }, {
        name: "size",
        type: "number",
        optional: true
      }, {
        name: "sizeX",
        type: "number",
        optional: true
      }, {
        name: "sizeY",
        type: "number",
        optional: true
      }, {
        name: "sizeZ",
        type: "number",
        optional: true
      }, {
        name: "custom",
        type: "any",
        optional: true
      }, {
        name: "faceUV",
        type: "BABYLON.Vector4[]",
        optional: true
      }, {
        name: "faceColors",
        type: "BABYLON.Color4[]",
        optional: true
      }, {
        name: "flat",
        type: "boolean",
        optional: true
      }, {
        name: "updatable",
        type: "boolean",
        optional: true
      }, {
        name: "sideOrientation",
        type: "number",
        optional: true
      }, {
        name: "frontUVs",
        type: "BABYLON.Vector4",
        optional: true
      }, {
        name: "backUVs",
        type: "BABYLON.Vector4",
        optional: true
      }],
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPolyhedron.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberPolyhedron"
  };
  return FiberPolyhedron;
}();
/**
 * Creates a decal mesh.
 * A decal is a mesh usually applied as a model onto the surface of another mesh. So don't forget the parameter `sourceMesh` depicting the decal
 * * The parameter `position` (Vector3, default `(0, 0, 0)`) sets the position of the decal in World coordinates
 * * The parameter `normal` (Vector3, default `Vector3.Up`) sets the normal of the mesh where the decal is applied onto in World coordinates
 * * The parameter `size` (Vector3, default `(1, 1, 1)`) sets the decal scaling
 * * The parameter `angle` (float in radian, default 0) sets the angle to rotate the decal
 *
 * This code has been generated
 */


var FiberDecal =
/** @class */
function () {
  function FiberDecal() {
    this.propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDecal.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDecal.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDecal.CreateInfo = {
    creationType: "FactoryMethod",
    libraryLocation: "MeshBuilder",
    namespace: "BABYLON",
    factoryMethod: "CreateDecal",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "sourceMesh",
      type: "BABYLON.AbstractMesh",
      optional: false
    }, {
      name: "options",
      type: [{
        name: "position",
        type: "BABYLON.Vector3",
        optional: true
      }, {
        name: "normal",
        type: "BABYLON.Vector3",
        optional: true
      }, {
        name: "size",
        type: "BABYLON.Vector3",
        optional: true
      }, {
        name: "angle",
        type: "number",
        optional: true
      }],
      optional: false
    }]
  };
  FiberDecal.Metadata = {
    acceptsMaterials: true,
    isMesh: true,
    className: "FiberDecal"
  };
  return FiberDecal;
}();

var FiberMaterialProps =
/** @class */
function () {
  function FiberMaterialProps() {}

  return FiberMaterialProps;
}();

var FiberMaterialPropsHandler =
/** @class */
function () {
  function FiberMaterialPropsHandler() {}

  FiberMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.Material.alpha of type 'number':

    if (oldProps.alpha !== newProps.alpha) {
      updates.push({
        propertyName: "alpha",
        value: newProps.alpha,
        type: "number"
      });
    } // BABYLON.Material.alphaMode of type 'number':


    if (oldProps.alphaMode !== newProps.alphaMode) {
      updates.push({
        propertyName: "alphaMode",
        value: newProps.alphaMode,
        type: "number"
      });
    } // TODO: type: BABYLON.Animation[] property (not coded) BABYLON.Material.animations.
    // BABYLON.Material.backFaceCulling of type 'boolean':


    if (oldProps.backFaceCulling !== newProps.backFaceCulling) {
      updates.push({
        propertyName: "backFaceCulling",
        value: newProps.backFaceCulling,
        type: "boolean"
      });
    } // BABYLON.Material.checkReadyOnEveryCall of type 'boolean':


    if (oldProps.checkReadyOnEveryCall !== newProps.checkReadyOnEveryCall) {
      updates.push({
        propertyName: "checkReadyOnEveryCall",
        value: newProps.checkReadyOnEveryCall,
        type: "boolean"
      });
    } // BABYLON.Material.checkReadyOnlyOnce of type 'boolean':


    if (oldProps.checkReadyOnlyOnce !== newProps.checkReadyOnlyOnce) {
      updates.push({
        propertyName: "checkReadyOnlyOnce",
        value: newProps.checkReadyOnlyOnce,
        type: "boolean"
      });
    } // BABYLON.Material.disableDepthWrite of type 'boolean':


    if (oldProps.disableDepthWrite !== newProps.disableDepthWrite) {
      updates.push({
        propertyName: "disableDepthWrite",
        value: newProps.disableDepthWrite,
        type: "boolean"
      });
    } // BABYLON.Material.doNotSerialize of type 'boolean':


    if (oldProps.doNotSerialize !== newProps.doNotSerialize) {
      updates.push({
        propertyName: "doNotSerialize",
        value: newProps.doNotSerialize,
        type: "boolean"
      });
    } // BABYLON.Material.fillMode of type 'number':


    if (oldProps.fillMode !== newProps.fillMode) {
      updates.push({
        propertyName: "fillMode",
        value: newProps.fillMode,
        type: "number"
      });
    } // BABYLON.Material.fogEnabled of type 'boolean':


    if (oldProps.fogEnabled !== newProps.fogEnabled) {
      updates.push({
        propertyName: "fogEnabled",
        value: newProps.fogEnabled,
        type: "boolean"
      });
    } // BABYLON.Material.forceDepthWrite of type 'boolean':


    if (oldProps.forceDepthWrite !== newProps.forceDepthWrite) {
      updates.push({
        propertyName: "forceDepthWrite",
        value: newProps.forceDepthWrite,
        type: "boolean"
      });
    } // TODO: type: () => BABYLON.SmartArray<BABYLON.RenderTargetTexture> property (not coded) BABYLON.Material.getRenderTargetTextures.
    // BABYLON.Material.id of type 'string':


    if (oldProps.id !== newProps.id) {
      updates.push({
        propertyName: "id",
        value: newProps.id,
        type: "string"
      });
    } // TODO: type: { [id: string]: BABYLON.AbstractMesh; } property (not coded) BABYLON.Material.meshMap.
    // TODO: type: any property (not coded) BABYLON.Material.metadata.
    // BABYLON.Material.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // BABYLON.Material.needDepthPrePass of type 'boolean':


    if (oldProps.needDepthPrePass !== newProps.needDepthPrePass) {
      updates.push({
        propertyName: "needDepthPrePass",
        value: newProps.needDepthPrePass,
        type: "boolean"
      });
    } // BABYLON.Material.onBind of type '(Mesh: BABYLON.AbstractMesh) => void/fn':


    if (oldProps.onBind === undefined && oldProps.onBind !== newProps.onBind) {
      updates.push({
        propertyName: "onBind",
        value: newProps.onBind,
        type: "(Mesh: BABYLON.AbstractMesh) => void"
      });
    } // BABYLON.Material.onCompiled of type '(effect: BABYLON.Effect) => void/fn':


    if (oldProps.onCompiled === undefined && oldProps.onCompiled !== newProps.onCompiled) {
      updates.push({
        propertyName: "onCompiled",
        value: newProps.onCompiled,
        type: "(effect: BABYLON.Effect) => void"
      });
    } // BABYLON.Material.onDispose of type '() => void/fn':


    if (oldProps.onDispose === undefined && oldProps.onDispose !== newProps.onDispose) {
      updates.push({
        propertyName: "onDispose",
        value: newProps.onDispose,
        type: "() => void"
      });
    } // BABYLON.Material.onDisposeObservable of type 'BABYLON.Observable<BABYLON.Material>/fn':


    if (oldProps.onDisposeObservable === undefined && oldProps.onDisposeObservable !== newProps.onDisposeObservable) {
      updates.push({
        propertyName: "onDisposeObservable",
        value: newProps.onDisposeObservable,
        type: "BABYLON.Observable<BABYLON.Material>"
      });
    } // BABYLON.Material.onError of type '(effect: BABYLON.Effect, errors: string) => void/fn':


    if (oldProps.onError === undefined && oldProps.onError !== newProps.onError) {
      updates.push({
        propertyName: "onError",
        value: newProps.onError,
        type: "(effect: BABYLON.Effect, errors: string) => void"
      });
    } // BABYLON.Material.pointsCloud of type 'boolean':


    if (oldProps.pointsCloud !== newProps.pointsCloud) {
      updates.push({
        propertyName: "pointsCloud",
        value: newProps.pointsCloud,
        type: "boolean"
      });
    } // BABYLON.Material.pointSize of type 'number':


    if (oldProps.pointSize !== newProps.pointSize) {
      updates.push({
        propertyName: "pointSize",
        value: newProps.pointSize,
        type: "number"
      });
    } // TODO: type: any property (not coded) BABYLON.Material.releaseVertexArrayObject.
    // TODO: type: any property (not coded) BABYLON.Material.reservedDataStore.
    // BABYLON.Material.separateCullingPass of type 'boolean':


    if (oldProps.separateCullingPass !== newProps.separateCullingPass) {
      updates.push({
        propertyName: "separateCullingPass",
        value: newProps.separateCullingPass,
        type: "boolean"
      });
    } // BABYLON.Material.sideOrientation of type 'number':


    if (oldProps.sideOrientation !== newProps.sideOrientation) {
      updates.push({
        propertyName: "sideOrientation",
        value: newProps.sideOrientation,
        type: "number"
      });
    } // BABYLON.Material.state of type 'string':


    if (oldProps.state !== newProps.state) {
      updates.push({
        propertyName: "state",
        value: newProps.state,
        type: "string"
      });
    } // BABYLON.Material.uniqueId of type 'number':


    if (oldProps.uniqueId !== newProps.uniqueId) {
      updates.push({
        propertyName: "uniqueId",
        value: newProps.uniqueId,
        type: "number"
      });
    } // BABYLON.Material.wireframe of type 'boolean':


    if (oldProps.wireframe !== newProps.wireframe) {
      updates.push({
        propertyName: "wireframe",
        value: newProps.wireframe,
        type: "boolean"
      });
    } // BABYLON.Material.zOffset of type 'number':


    if (oldProps.zOffset !== newProps.zOffset) {
      updates.push({
        propertyName: "zOffset",
        value: newProps.zOffset,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberMaterialPropsHandler;
}();
/**
 * Base class for the main features of a material in Babylon.js
 *
 * This code has been generated
 */


var FiberMaterial =
/** @class */
function () {
  function FiberMaterial() {
    this.propsHandlers = [new FiberMaterialPropsHandler()];
  }

  FiberMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Material",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "doNotAdd",
      type: "boolean",
      optional: true
    }]
  };
  FiberMaterial.Metadata = {
    isMaterial: true,
    className: "FiberMaterial"
  };
  return FiberMaterial;
}();

var FiberMultiMaterialProps =
/** @class */
function (_super) {
  __extends(FiberMultiMaterialProps, _super);

  function FiberMultiMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberMultiMaterialProps;
}(FiberMaterialProps);

var FiberMultiMaterialPropsHandler =
/** @class */
function () {
  function FiberMultiMaterialPropsHandler() {}

  FiberMultiMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.Material[] property (not coded) BABYLON.MultiMaterial.subMaterials.

    return updates.length == 0 ? null : updates;
  };

  return FiberMultiMaterialPropsHandler;
}();
/**
 * A multi-material is used to apply different materials to different parts of the same object without the need of
 * separate meshes. This can be use to improve performances.
 *
 * This code has been generated
 */


var FiberMultiMaterial =
/** @class */
function () {
  function FiberMultiMaterial() {
    this.propsHandlers = [new FiberMultiMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberMultiMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "MultiMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberMultiMaterial.Metadata = {
    isMaterial: true,
    className: "FiberMultiMaterial"
  };
  return FiberMultiMaterial;
}();

var FiberPushMaterialProps =
/** @class */
function (_super) {
  __extends(FiberPushMaterialProps, _super);

  function FiberPushMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPushMaterialProps;
}(FiberMaterialProps);

var FiberPushMaterialPropsHandler =
/** @class */
function () {
  function FiberPushMaterialPropsHandler() {}

  FiberPushMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PushMaterial.allowShaderHotSwapping of type 'boolean':

    if (oldProps.allowShaderHotSwapping !== newProps.allowShaderHotSwapping) {
      updates.push({
        propertyName: "allowShaderHotSwapping",
        value: newProps.allowShaderHotSwapping,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberPushMaterialPropsHandler;
}();
/**
 * Base class of materials working in push mode in babylon JS
 *
 * This code has been generated
 */


var FiberPushMaterial =
/** @class */
function () {
  function FiberPushMaterial() {
    this.propsHandlers = [new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPushMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPushMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPushMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PushMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPushMaterial.Metadata = {
    isMaterial: true,
    className: "FiberPushMaterial"
  };
  return FiberPushMaterial;
}();

var FiberStandardMaterialProps =
/** @class */
function (_super) {
  __extends(FiberStandardMaterialProps, _super);

  function FiberStandardMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStandardMaterialProps;
}(FiberPushMaterialProps);

var FiberStandardMaterialPropsHandler =
/** @class */
function () {
  function FiberStandardMaterialPropsHandler() {}

  FiberStandardMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.StandardMaterial.alphaCutOff of type 'number':

    if (oldProps.alphaCutOff !== newProps.alphaCutOff) {
      updates.push({
        propertyName: "alphaCutOff",
        value: newProps.alphaCutOff,
        type: "number"
      });
    } // BABYLON.StandardMaterial.ambientColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.ambientColor && (!oldProps.ambientColor || !oldProps.ambientColor.equals(newProps.ambientColor))) {
      updates.push({
        propertyName: "ambientColor",
        value: newProps.ambientColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.ambientTexture.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.bumpTexture.
    // TODO: type: BABYLON.ColorCurves property (not coded) BABYLON.StandardMaterial.cameraColorCurves.
    // BABYLON.StandardMaterial.cameraColorCurvesEnabled of type 'boolean':


    if (oldProps.cameraColorCurvesEnabled !== newProps.cameraColorCurvesEnabled) {
      updates.push({
        propertyName: "cameraColorCurvesEnabled",
        value: newProps.cameraColorCurvesEnabled,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.cameraColorGradingEnabled of type 'boolean':


    if (oldProps.cameraColorGradingEnabled !== newProps.cameraColorGradingEnabled) {
      updates.push({
        propertyName: "cameraColorGradingEnabled",
        value: newProps.cameraColorGradingEnabled,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.cameraColorGradingTexture.
    // BABYLON.StandardMaterial.cameraContrast of type 'number':


    if (oldProps.cameraContrast !== newProps.cameraContrast) {
      updates.push({
        propertyName: "cameraContrast",
        value: newProps.cameraContrast,
        type: "number"
      });
    } // BABYLON.StandardMaterial.cameraExposure of type 'number':


    if (oldProps.cameraExposure !== newProps.cameraExposure) {
      updates.push({
        propertyName: "cameraExposure",
        value: newProps.cameraExposure,
        type: "number"
      });
    } // BABYLON.StandardMaterial.cameraToneMappingEnabled of type 'boolean':


    if (oldProps.cameraToneMappingEnabled !== newProps.cameraToneMappingEnabled) {
      updates.push({
        propertyName: "cameraToneMappingEnabled",
        value: newProps.cameraToneMappingEnabled,
        type: "boolean"
      });
    } // TODO: type: (shaderName: string, uniforms: string[], uniformBuffers: string[], samplers: string[], defines: BABYLON.StandardMaterialDefines) => string property (not coded) BABYLON.StandardMaterial.customShaderNameResolve.
    // BABYLON.StandardMaterial.diffuseColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.diffuseColor && (!oldProps.diffuseColor || !oldProps.diffuseColor.equals(newProps.diffuseColor))) {
      updates.push({
        propertyName: "diffuseColor",
        value: newProps.diffuseColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.FresnelParameters property (not coded) BABYLON.StandardMaterial.diffuseFresnelParameters.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.diffuseTexture.
    // BABYLON.StandardMaterial.disableLighting of type 'boolean':


    if (oldProps.disableLighting !== newProps.disableLighting) {
      updates.push({
        propertyName: "disableLighting",
        value: newProps.disableLighting,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.emissiveColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.emissiveColor && (!oldProps.emissiveColor || !oldProps.emissiveColor.equals(newProps.emissiveColor))) {
      updates.push({
        propertyName: "emissiveColor",
        value: newProps.emissiveColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.FresnelParameters property (not coded) BABYLON.StandardMaterial.emissiveFresnelParameters.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.emissiveTexture.
    // TODO: type: BABYLON.ImageProcessingConfiguration property (not coded) BABYLON.StandardMaterial.imageProcessingConfiguration.
    // BABYLON.StandardMaterial.indexOfRefraction of type 'number':


    if (oldProps.indexOfRefraction !== newProps.indexOfRefraction) {
      updates.push({
        propertyName: "indexOfRefraction",
        value: newProps.indexOfRefraction,
        type: "number"
      });
    } // BABYLON.StandardMaterial.invertNormalMapX of type 'boolean':


    if (oldProps.invertNormalMapX !== newProps.invertNormalMapX) {
      updates.push({
        propertyName: "invertNormalMapX",
        value: newProps.invertNormalMapX,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.invertNormalMapY of type 'boolean':


    if (oldProps.invertNormalMapY !== newProps.invertNormalMapY) {
      updates.push({
        propertyName: "invertNormalMapY",
        value: newProps.invertNormalMapY,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.invertRefractionY of type 'boolean':


    if (oldProps.invertRefractionY !== newProps.invertRefractionY) {
      updates.push({
        propertyName: "invertRefractionY",
        value: newProps.invertRefractionY,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.lightmapTexture.
    // BABYLON.StandardMaterial.linkEmissiveWithDiffuse of type 'boolean':


    if (oldProps.linkEmissiveWithDiffuse !== newProps.linkEmissiveWithDiffuse) {
      updates.push({
        propertyName: "linkEmissiveWithDiffuse",
        value: newProps.linkEmissiveWithDiffuse,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.maxSimultaneousLights of type 'number':


    if (oldProps.maxSimultaneousLights !== newProps.maxSimultaneousLights) {
      updates.push({
        propertyName: "maxSimultaneousLights",
        value: newProps.maxSimultaneousLights,
        type: "number"
      });
    } // TODO: type: BABYLON.FresnelParameters property (not coded) BABYLON.StandardMaterial.opacityFresnelParameters.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.opacityTexture.
    // BABYLON.StandardMaterial.parallaxScaleBias of type 'number':


    if (oldProps.parallaxScaleBias !== newProps.parallaxScaleBias) {
      updates.push({
        propertyName: "parallaxScaleBias",
        value: newProps.parallaxScaleBias,
        type: "number"
      });
    } // TODO: type: BABYLON.FresnelParameters property (not coded) BABYLON.StandardMaterial.reflectionFresnelParameters.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.reflectionTexture.
    // TODO: type: BABYLON.FresnelParameters property (not coded) BABYLON.StandardMaterial.refractionFresnelParameters.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.refractionTexture.
    // BABYLON.StandardMaterial.roughness of type 'number':


    if (oldProps.roughness !== newProps.roughness) {
      updates.push({
        propertyName: "roughness",
        value: newProps.roughness,
        type: "number"
      });
    } // BABYLON.StandardMaterial.specularColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.specularColor && (!oldProps.specularColor || !oldProps.specularColor.equals(newProps.specularColor))) {
      updates.push({
        propertyName: "specularColor",
        value: newProps.specularColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.StandardMaterial.specularPower of type 'number':


    if (oldProps.specularPower !== newProps.specularPower) {
      updates.push({
        propertyName: "specularPower",
        value: newProps.specularPower,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.StandardMaterial.specularTexture.
    // BABYLON.StandardMaterial.twoSidedLighting of type 'boolean':


    if (oldProps.twoSidedLighting !== newProps.twoSidedLighting) {
      updates.push({
        propertyName: "twoSidedLighting",
        value: newProps.twoSidedLighting,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useAlphaFromDiffuseTexture of type 'boolean':


    if (oldProps.useAlphaFromDiffuseTexture !== newProps.useAlphaFromDiffuseTexture) {
      updates.push({
        propertyName: "useAlphaFromDiffuseTexture",
        value: newProps.useAlphaFromDiffuseTexture,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useEmissiveAsIllumination of type 'boolean':


    if (oldProps.useEmissiveAsIllumination !== newProps.useEmissiveAsIllumination) {
      updates.push({
        propertyName: "useEmissiveAsIllumination",
        value: newProps.useEmissiveAsIllumination,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useGlossinessFromSpecularMapAlpha of type 'boolean':


    if (oldProps.useGlossinessFromSpecularMapAlpha !== newProps.useGlossinessFromSpecularMapAlpha) {
      updates.push({
        propertyName: "useGlossinessFromSpecularMapAlpha",
        value: newProps.useGlossinessFromSpecularMapAlpha,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useLightmapAsShadowmap of type 'boolean':


    if (oldProps.useLightmapAsShadowmap !== newProps.useLightmapAsShadowmap) {
      updates.push({
        propertyName: "useLightmapAsShadowmap",
        value: newProps.useLightmapAsShadowmap,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useLogarithmicDepth of type 'boolean':


    if (oldProps.useLogarithmicDepth !== newProps.useLogarithmicDepth) {
      updates.push({
        propertyName: "useLogarithmicDepth",
        value: newProps.useLogarithmicDepth,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useObjectSpaceNormalMap of type 'boolean':


    if (oldProps.useObjectSpaceNormalMap !== newProps.useObjectSpaceNormalMap) {
      updates.push({
        propertyName: "useObjectSpaceNormalMap",
        value: newProps.useObjectSpaceNormalMap,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useParallax of type 'boolean':


    if (oldProps.useParallax !== newProps.useParallax) {
      updates.push({
        propertyName: "useParallax",
        value: newProps.useParallax,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useParallaxOcclusion of type 'boolean':


    if (oldProps.useParallaxOcclusion !== newProps.useParallaxOcclusion) {
      updates.push({
        propertyName: "useParallaxOcclusion",
        value: newProps.useParallaxOcclusion,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useReflectionFresnelFromSpecular of type 'boolean':


    if (oldProps.useReflectionFresnelFromSpecular !== newProps.useReflectionFresnelFromSpecular) {
      updates.push({
        propertyName: "useReflectionFresnelFromSpecular",
        value: newProps.useReflectionFresnelFromSpecular,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useReflectionOverAlpha of type 'boolean':


    if (oldProps.useReflectionOverAlpha !== newProps.useReflectionOverAlpha) {
      updates.push({
        propertyName: "useReflectionOverAlpha",
        value: newProps.useReflectionOverAlpha,
        type: "boolean"
      });
    } // BABYLON.StandardMaterial.useSpecularOverAlpha of type 'boolean':


    if (oldProps.useSpecularOverAlpha !== newProps.useSpecularOverAlpha) {
      updates.push({
        propertyName: "useSpecularOverAlpha",
        value: newProps.useSpecularOverAlpha,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberStandardMaterialPropsHandler;
}();
/**
 * This is the default material used in Babylon. It is the best trade off between quality
 * and performances.
 *
 * This code has been generated
 */


var FiberStandardMaterial =
/** @class */
function () {
  function FiberStandardMaterial() {
    this.propsHandlers = [new FiberStandardMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberStandardMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStandardMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStandardMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StandardMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberStandardMaterial.Metadata = {
    isMaterial: true,
    className: "FiberStandardMaterial"
  };
  return FiberStandardMaterial;
}();

var FiberBackgroundMaterialProps =
/** @class */
function (_super) {
  __extends(FiberBackgroundMaterialProps, _super);

  function FiberBackgroundMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberBackgroundMaterialProps;
}(FiberPushMaterialProps);

var FiberBackgroundMaterialPropsHandler =
/** @class */
function () {
  function FiberBackgroundMaterialPropsHandler() {}

  FiberBackgroundMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.ColorCurves property (not coded) BABYLON.BackgroundMaterial.cameraColorCurves.
    // BABYLON.BackgroundMaterial.cameraColorCurvesEnabled of type 'boolean':

    if (oldProps.cameraColorCurvesEnabled !== newProps.cameraColorCurvesEnabled) {
      updates.push({
        propertyName: "cameraColorCurvesEnabled",
        value: newProps.cameraColorCurvesEnabled,
        type: "boolean"
      });
    } // BABYLON.BackgroundMaterial.cameraColorGradingEnabled of type 'boolean':


    if (oldProps.cameraColorGradingEnabled !== newProps.cameraColorGradingEnabled) {
      updates.push({
        propertyName: "cameraColorGradingEnabled",
        value: newProps.cameraColorGradingEnabled,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.BackgroundMaterial.cameraColorGradingTexture.
    // BABYLON.BackgroundMaterial.cameraContrast of type 'number':


    if (oldProps.cameraContrast !== newProps.cameraContrast) {
      updates.push({
        propertyName: "cameraContrast",
        value: newProps.cameraContrast,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.cameraExposure of type 'number':


    if (oldProps.cameraExposure !== newProps.cameraExposure) {
      updates.push({
        propertyName: "cameraExposure",
        value: newProps.cameraExposure,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.cameraToneMappingEnabled of type 'boolean':


    if (oldProps.cameraToneMappingEnabled !== newProps.cameraToneMappingEnabled) {
      updates.push({
        propertyName: "cameraToneMappingEnabled",
        value: newProps.cameraToneMappingEnabled,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.BackgroundMaterial.diffuseTexture.
    // BABYLON.BackgroundMaterial.enableNoise of type 'boolean':


    if (oldProps.enableNoise !== newProps.enableNoise) {
      updates.push({
        propertyName: "enableNoise",
        value: newProps.enableNoise,
        type: "boolean"
      });
    } // BABYLON.BackgroundMaterial.fovMultiplier of type 'number':


    if (oldProps.fovMultiplier !== newProps.fovMultiplier) {
      updates.push({
        propertyName: "fovMultiplier",
        value: newProps.fovMultiplier,
        type: "number"
      });
    } // TODO: type: BABYLON.ImageProcessingConfiguration property (not coded) BABYLON.BackgroundMaterial.imageProcessingConfiguration.
    // BABYLON.BackgroundMaterial.maxSimultaneousLights of type 'number':


    if (oldProps.maxSimultaneousLights !== newProps.maxSimultaneousLights) {
      updates.push({
        propertyName: "maxSimultaneousLights",
        value: newProps.maxSimultaneousLights,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.opacityFresnel of type 'boolean':


    if (oldProps.opacityFresnel !== newProps.opacityFresnel) {
      updates.push({
        propertyName: "opacityFresnel",
        value: newProps.opacityFresnel,
        type: "boolean"
      });
    } // BABYLON.BackgroundMaterial.primaryColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.primaryColor && (!oldProps.primaryColor || !oldProps.primaryColor.equals(newProps.primaryColor))) {
      updates.push({
        propertyName: "primaryColor",
        value: newProps.primaryColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.BackgroundMaterial.primaryColorHighlightLevel of type 'number':


    if (oldProps.primaryColorHighlightLevel !== newProps.primaryColorHighlightLevel) {
      updates.push({
        propertyName: "primaryColorHighlightLevel",
        value: newProps.primaryColorHighlightLevel,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.primaryColorShadowLevel of type 'number':


    if (oldProps.primaryColorShadowLevel !== newProps.primaryColorShadowLevel) {
      updates.push({
        propertyName: "primaryColorShadowLevel",
        value: newProps.primaryColorShadowLevel,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.reflectionAmount of type 'number':


    if (oldProps.reflectionAmount !== newProps.reflectionAmount) {
      updates.push({
        propertyName: "reflectionAmount",
        value: newProps.reflectionAmount,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.reflectionBlur of type 'number':


    if (oldProps.reflectionBlur !== newProps.reflectionBlur) {
      updates.push({
        propertyName: "reflectionBlur",
        value: newProps.reflectionBlur,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.reflectionFalloffDistance of type 'number':


    if (oldProps.reflectionFalloffDistance !== newProps.reflectionFalloffDistance) {
      updates.push({
        propertyName: "reflectionFalloffDistance",
        value: newProps.reflectionFalloffDistance,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.reflectionFresnel of type 'boolean':


    if (oldProps.reflectionFresnel !== newProps.reflectionFresnel) {
      updates.push({
        propertyName: "reflectionFresnel",
        value: newProps.reflectionFresnel,
        type: "boolean"
      });
    } // BABYLON.BackgroundMaterial.reflectionReflectance0 of type 'number':


    if (oldProps.reflectionReflectance0 !== newProps.reflectionReflectance0) {
      updates.push({
        propertyName: "reflectionReflectance0",
        value: newProps.reflectionReflectance0,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.reflectionReflectance90 of type 'number':


    if (oldProps.reflectionReflectance90 !== newProps.reflectionReflectance90) {
      updates.push({
        propertyName: "reflectionReflectance90",
        value: newProps.reflectionReflectance90,
        type: "number"
      });
    } // BABYLON.BackgroundMaterial.reflectionStandardFresnelWeight of type 'number':


    if (oldProps.reflectionStandardFresnelWeight !== newProps.reflectionStandardFresnelWeight) {
      updates.push({
        propertyName: "reflectionStandardFresnelWeight",
        value: newProps.reflectionStandardFresnelWeight,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.BackgroundMaterial.reflectionTexture.
    // BABYLON.BackgroundMaterial.sceneCenter of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.sceneCenter && (!oldProps.sceneCenter || !oldProps.sceneCenter.equals(newProps.sceneCenter))) {
      updates.push({
        propertyName: "sceneCenter",
        value: newProps.sceneCenter,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.BackgroundMaterial.shadowLevel of type 'number':


    if (oldProps.shadowLevel !== newProps.shadowLevel) {
      updates.push({
        propertyName: "shadowLevel",
        value: newProps.shadowLevel,
        type: "number"
      });
    } // TODO: type: BABYLON.IShadowLight[] property (not coded) BABYLON.BackgroundMaterial.shadowLights.
    // BABYLON.BackgroundMaterial.switchToBGR of type 'boolean':


    if (oldProps.switchToBGR !== newProps.switchToBGR) {
      updates.push({
        propertyName: "switchToBGR",
        value: newProps.switchToBGR,
        type: "boolean"
      });
    } // BABYLON.BackgroundMaterial.useEquirectangularFOV of type 'boolean':


    if (oldProps.useEquirectangularFOV !== newProps.useEquirectangularFOV) {
      updates.push({
        propertyName: "useEquirectangularFOV",
        value: newProps.useEquirectangularFOV,
        type: "boolean"
      });
    } // BABYLON.BackgroundMaterial.useRGBColor of type 'boolean':


    if (oldProps.useRGBColor !== newProps.useRGBColor) {
      updates.push({
        propertyName: "useRGBColor",
        value: newProps.useRGBColor,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberBackgroundMaterialPropsHandler;
}();
/**
 * Background material used to create an efficient environement around your scene.
 *
 * This code has been generated
 */


var FiberBackgroundMaterial =
/** @class */
function () {
  function FiberBackgroundMaterial() {
    this.propsHandlers = [new FiberBackgroundMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberBackgroundMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBackgroundMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBackgroundMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "BackgroundMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberBackgroundMaterial.Metadata = {
    isMaterial: true,
    className: "FiberBackgroundMaterial"
  };
  return FiberBackgroundMaterial;
}();

var FiberPBRBaseMaterialProps =
/** @class */
function (_super) {
  __extends(FiberPBRBaseMaterialProps, _super);

  function FiberPBRBaseMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPBRBaseMaterialProps;
}(FiberPushMaterialProps);

var FiberPBRBaseMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRBaseMaterialPropsHandler() {}

  FiberPBRBaseMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PBRBaseMaterial.transparencyMode of type 'number':

    if (oldProps.transparencyMode !== newProps.transparencyMode) {
      updates.push({
        propertyName: "transparencyMode",
        value: newProps.transparencyMode,
        type: "number"
      });
    } // BABYLON.PBRBaseMaterial.useLogarithmicDepth of type 'boolean':


    if (oldProps.useLogarithmicDepth !== newProps.useLogarithmicDepth) {
      updates.push({
        propertyName: "useLogarithmicDepth",
        value: newProps.useLogarithmicDepth,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberPBRBaseMaterialPropsHandler;
}();
/**
 * The Physically based material base class of BJS.
 *
 * This offers the main features of a standard PBR material.
 * For more information, please refer to the documentation :
 * http://doc.babylonjs.com/extensions/Physically_Based_Rendering
 *
 * This code has been generated
 */


var FiberPBRBaseMaterial =
/** @class */
function () {
  function FiberPBRBaseMaterial() {
    this.propsHandlers = [new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRBaseMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRBaseMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRBaseMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PBRBaseMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPBRBaseMaterial.Metadata = {
    isMaterial: true,
    className: "FiberPBRBaseMaterial"
  };
  return FiberPBRBaseMaterial;
}();

var FiberPBRBaseSimpleMaterialProps =
/** @class */
function (_super) {
  __extends(FiberPBRBaseSimpleMaterialProps, _super);

  function FiberPBRBaseSimpleMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPBRBaseSimpleMaterialProps;
}(FiberPBRBaseMaterialProps);

var FiberPBRBaseSimpleMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRBaseSimpleMaterialPropsHandler() {}

  FiberPBRBaseSimpleMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PBRBaseSimpleMaterial.alphaCutOff of type 'number':

    if (oldProps.alphaCutOff !== newProps.alphaCutOff) {
      updates.push({
        propertyName: "alphaCutOff",
        value: newProps.alphaCutOff,
        type: "number"
      });
    } // BABYLON.PBRBaseSimpleMaterial.disableLighting of type 'boolean':


    if (oldProps.disableLighting !== newProps.disableLighting) {
      updates.push({
        propertyName: "disableLighting",
        value: newProps.disableLighting,
        type: "boolean"
      });
    } // BABYLON.PBRBaseSimpleMaterial.doubleSided of type 'boolean':


    if (oldProps.doubleSided !== newProps.doubleSided) {
      updates.push({
        propertyName: "doubleSided",
        value: newProps.doubleSided,
        type: "boolean"
      });
    } // BABYLON.PBRBaseSimpleMaterial.emissiveColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.emissiveColor && (!oldProps.emissiveColor || !oldProps.emissiveColor.equals(newProps.emissiveColor))) {
      updates.push({
        propertyName: "emissiveColor",
        value: newProps.emissiveColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRBaseSimpleMaterial.emissiveTexture.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRBaseSimpleMaterial.environmentTexture.
    // BABYLON.PBRBaseSimpleMaterial.invertNormalMapX of type 'boolean':


    if (oldProps.invertNormalMapX !== newProps.invertNormalMapX) {
      updates.push({
        propertyName: "invertNormalMapX",
        value: newProps.invertNormalMapX,
        type: "boolean"
      });
    } // BABYLON.PBRBaseSimpleMaterial.invertNormalMapY of type 'boolean':


    if (oldProps.invertNormalMapY !== newProps.invertNormalMapY) {
      updates.push({
        propertyName: "invertNormalMapY",
        value: newProps.invertNormalMapY,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRBaseSimpleMaterial.lightmapTexture.
    // BABYLON.PBRBaseSimpleMaterial.maxSimultaneousLights of type 'number':


    if (oldProps.maxSimultaneousLights !== newProps.maxSimultaneousLights) {
      updates.push({
        propertyName: "maxSimultaneousLights",
        value: newProps.maxSimultaneousLights,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRBaseSimpleMaterial.normalTexture.
    // BABYLON.PBRBaseSimpleMaterial.occlusionStrength of type 'number':


    if (oldProps.occlusionStrength !== newProps.occlusionStrength) {
      updates.push({
        propertyName: "occlusionStrength",
        value: newProps.occlusionStrength,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRBaseSimpleMaterial.occlusionTexture.
    // BABYLON.PBRBaseSimpleMaterial.useLightmapAsShadowmap of type 'boolean':


    if (oldProps.useLightmapAsShadowmap !== newProps.useLightmapAsShadowmap) {
      updates.push({
        propertyName: "useLightmapAsShadowmap",
        value: newProps.useLightmapAsShadowmap,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberPBRBaseSimpleMaterialPropsHandler;
}();
/**
 * The Physically based simple base material of BJS.
 *
 * This enables better naming and convention enforcements on top of the pbrMaterial.
 * It is used as the base class for both the specGloss and metalRough conventions.
 *
 * This code has been generated
 */


var FiberPBRBaseSimpleMaterial =
/** @class */
function () {
  function FiberPBRBaseSimpleMaterial() {
    this.propsHandlers = [new FiberPBRBaseSimpleMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRBaseSimpleMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRBaseSimpleMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRBaseSimpleMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PBRBaseSimpleMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPBRBaseSimpleMaterial.Metadata = {
    isMaterial: true,
    className: "FiberPBRBaseSimpleMaterial"
  };
  return FiberPBRBaseSimpleMaterial;
}();

var FiberPBRMetallicRoughnessMaterialProps =
/** @class */
function (_super) {
  __extends(FiberPBRMetallicRoughnessMaterialProps, _super);

  function FiberPBRMetallicRoughnessMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPBRMetallicRoughnessMaterialProps;
}(FiberPBRBaseSimpleMaterialProps);

var FiberPBRMetallicRoughnessMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRMetallicRoughnessMaterialPropsHandler() {}

  FiberPBRMetallicRoughnessMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PBRMetallicRoughnessMaterial.baseColor of BABYLONBABYLON.Color3 uses object equals to find diffs:

    if (newProps.baseColor && (!oldProps.baseColor || !oldProps.baseColor.equals(newProps.baseColor))) {
      updates.push({
        propertyName: "baseColor",
        value: newProps.baseColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMetallicRoughnessMaterial.baseTexture.
    // BABYLON.PBRMetallicRoughnessMaterial.metallic of type 'number':


    if (oldProps.metallic !== newProps.metallic) {
      updates.push({
        propertyName: "metallic",
        value: newProps.metallic,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMetallicRoughnessMaterial.metallicRoughnessTexture.
    // BABYLON.PBRMetallicRoughnessMaterial.roughness of type 'number':


    if (oldProps.roughness !== newProps.roughness) {
      updates.push({
        propertyName: "roughness",
        value: newProps.roughness,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberPBRMetallicRoughnessMaterialPropsHandler;
}();
/**
 * The PBR material of BJS following the metal roughness convention.
 *
 * This fits to the PBR convention in the GLTF definition:
 * https://github.com/KhronosGroup/glTF/tree/2.0/specification/2.0
 *
 * This code has been generated
 */


var FiberPBRMetallicRoughnessMaterial =
/** @class */
function () {
  function FiberPBRMetallicRoughnessMaterial() {
    this.propsHandlers = [new FiberPBRMetallicRoughnessMaterialPropsHandler(), new FiberPBRBaseSimpleMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRMetallicRoughnessMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRMetallicRoughnessMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRMetallicRoughnessMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PBRMetallicRoughnessMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPBRMetallicRoughnessMaterial.Metadata = {
    isMaterial: true,
    className: "FiberPBRMetallicRoughnessMaterial"
  };
  return FiberPBRMetallicRoughnessMaterial;
}();

var FiberPBRSpecularGlossinessMaterialProps =
/** @class */
function (_super) {
  __extends(FiberPBRSpecularGlossinessMaterialProps, _super);

  function FiberPBRSpecularGlossinessMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPBRSpecularGlossinessMaterialProps;
}(FiberPBRBaseSimpleMaterialProps);

var FiberPBRSpecularGlossinessMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRSpecularGlossinessMaterialPropsHandler() {}

  FiberPBRSpecularGlossinessMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PBRSpecularGlossinessMaterial.diffuseColor of BABYLONBABYLON.Color3 uses object equals to find diffs:

    if (newProps.diffuseColor && (!oldProps.diffuseColor || !oldProps.diffuseColor.equals(newProps.diffuseColor))) {
      updates.push({
        propertyName: "diffuseColor",
        value: newProps.diffuseColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRSpecularGlossinessMaterial.diffuseTexture.
    // BABYLON.PBRSpecularGlossinessMaterial.glossiness of type 'number':


    if (oldProps.glossiness !== newProps.glossiness) {
      updates.push({
        propertyName: "glossiness",
        value: newProps.glossiness,
        type: "number"
      });
    } // BABYLON.PBRSpecularGlossinessMaterial.specularColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.specularColor && (!oldProps.specularColor || !oldProps.specularColor.equals(newProps.specularColor))) {
      updates.push({
        propertyName: "specularColor",
        value: newProps.specularColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRSpecularGlossinessMaterial.specularGlossinessTexture.


    return updates.length == 0 ? null : updates;
  };

  return FiberPBRSpecularGlossinessMaterialPropsHandler;
}();
/**
 * The PBR material of BJS following the specular glossiness convention.
 *
 * This fits to the PBR convention in the GLTF definition:
 * https://github.com/KhronosGroup/glTF/tree/2.0/extensions/Khronos/KHR_materials_pbrSpecularGlossiness
 *
 * This code has been generated
 */


var FiberPBRSpecularGlossinessMaterial =
/** @class */
function () {
  function FiberPBRSpecularGlossinessMaterial() {
    this.propsHandlers = [new FiberPBRSpecularGlossinessMaterialPropsHandler(), new FiberPBRBaseSimpleMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRSpecularGlossinessMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRSpecularGlossinessMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRSpecularGlossinessMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PBRSpecularGlossinessMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPBRSpecularGlossinessMaterial.Metadata = {
    isMaterial: true,
    className: "FiberPBRSpecularGlossinessMaterial"
  };
  return FiberPBRSpecularGlossinessMaterial;
}();

var FiberPBRMaterialProps =
/** @class */
function (_super) {
  __extends(FiberPBRMaterialProps, _super);

  function FiberPBRMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPBRMaterialProps;
}(FiberPBRBaseMaterialProps);

var FiberPBRMaterialPropsHandler =
/** @class */
function () {
  function FiberPBRMaterialPropsHandler() {}

  FiberPBRMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PBRMaterial.albedoColor of BABYLONBABYLON.Color3 uses object equals to find diffs:

    if (newProps.albedoColor && (!oldProps.albedoColor || !oldProps.albedoColor.equals(newProps.albedoColor))) {
      updates.push({
        propertyName: "albedoColor",
        value: newProps.albedoColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.albedoTexture.
    // BABYLON.PBRMaterial.alphaCutOff of type 'number':


    if (oldProps.alphaCutOff !== newProps.alphaCutOff) {
      updates.push({
        propertyName: "alphaCutOff",
        value: newProps.alphaCutOff,
        type: "number"
      });
    } // BABYLON.PBRMaterial.ambientColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.ambientColor && (!oldProps.ambientColor || !oldProps.ambientColor.equals(newProps.ambientColor))) {
      updates.push({
        propertyName: "ambientColor",
        value: newProps.ambientColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.ambientTexture.
    // BABYLON.PBRMaterial.ambientTextureImpactOnAnalyticalLights of type 'number':


    if (oldProps.ambientTextureImpactOnAnalyticalLights !== newProps.ambientTextureImpactOnAnalyticalLights) {
      updates.push({
        propertyName: "ambientTextureImpactOnAnalyticalLights",
        value: newProps.ambientTextureImpactOnAnalyticalLights,
        type: "number"
      });
    } // BABYLON.PBRMaterial.ambientTextureStrength of type 'number':


    if (oldProps.ambientTextureStrength !== newProps.ambientTextureStrength) {
      updates.push({
        propertyName: "ambientTextureStrength",
        value: newProps.ambientTextureStrength,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.bumpTexture.
    // TODO: type: BABYLON.ColorCurves property (not coded) BABYLON.PBRMaterial.cameraColorCurves.
    // BABYLON.PBRMaterial.cameraColorCurvesEnabled of type 'boolean':


    if (oldProps.cameraColorCurvesEnabled !== newProps.cameraColorCurvesEnabled) {
      updates.push({
        propertyName: "cameraColorCurvesEnabled",
        value: newProps.cameraColorCurvesEnabled,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.cameraColorGradingEnabled of type 'boolean':


    if (oldProps.cameraColorGradingEnabled !== newProps.cameraColorGradingEnabled) {
      updates.push({
        propertyName: "cameraColorGradingEnabled",
        value: newProps.cameraColorGradingEnabled,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.cameraColorGradingTexture.
    // BABYLON.PBRMaterial.cameraContrast of type 'number':


    if (oldProps.cameraContrast !== newProps.cameraContrast) {
      updates.push({
        propertyName: "cameraContrast",
        value: newProps.cameraContrast,
        type: "number"
      });
    } // BABYLON.PBRMaterial.cameraExposure of type 'number':


    if (oldProps.cameraExposure !== newProps.cameraExposure) {
      updates.push({
        propertyName: "cameraExposure",
        value: newProps.cameraExposure,
        type: "number"
      });
    } // BABYLON.PBRMaterial.cameraToneMappingEnabled of type 'boolean':


    if (oldProps.cameraToneMappingEnabled !== newProps.cameraToneMappingEnabled) {
      updates.push({
        propertyName: "cameraToneMappingEnabled",
        value: newProps.cameraToneMappingEnabled,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.directIntensity of type 'number':


    if (oldProps.directIntensity !== newProps.directIntensity) {
      updates.push({
        propertyName: "directIntensity",
        value: newProps.directIntensity,
        type: "number"
      });
    } // BABYLON.PBRMaterial.disableBumpMap of type 'boolean':


    if (oldProps.disableBumpMap !== newProps.disableBumpMap) {
      updates.push({
        propertyName: "disableBumpMap",
        value: newProps.disableBumpMap,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.disableLighting of type 'boolean':


    if (oldProps.disableLighting !== newProps.disableLighting) {
      updates.push({
        propertyName: "disableLighting",
        value: newProps.disableLighting,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.emissiveColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.emissiveColor && (!oldProps.emissiveColor || !oldProps.emissiveColor.equals(newProps.emissiveColor))) {
      updates.push({
        propertyName: "emissiveColor",
        value: newProps.emissiveColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.PBRMaterial.emissiveIntensity of type 'number':


    if (oldProps.emissiveIntensity !== newProps.emissiveIntensity) {
      updates.push({
        propertyName: "emissiveIntensity",
        value: newProps.emissiveIntensity,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.emissiveTexture.
    // BABYLON.PBRMaterial.enableSpecularAntiAliasing of type 'boolean':


    if (oldProps.enableSpecularAntiAliasing !== newProps.enableSpecularAntiAliasing) {
      updates.push({
        propertyName: "enableSpecularAntiAliasing",
        value: newProps.enableSpecularAntiAliasing,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.environmentBRDFTexture.
    // BABYLON.PBRMaterial.environmentIntensity of type 'number':


    if (oldProps.environmentIntensity !== newProps.environmentIntensity) {
      updates.push({
        propertyName: "environmentIntensity",
        value: newProps.environmentIntensity,
        type: "number"
      });
    } // BABYLON.PBRMaterial.forceAlphaTest of type 'boolean':


    if (oldProps.forceAlphaTest !== newProps.forceAlphaTest) {
      updates.push({
        propertyName: "forceAlphaTest",
        value: newProps.forceAlphaTest,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.forceIrradianceInFragment of type 'boolean':


    if (oldProps.forceIrradianceInFragment !== newProps.forceIrradianceInFragment) {
      updates.push({
        propertyName: "forceIrradianceInFragment",
        value: newProps.forceIrradianceInFragment,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.forceNormalForward of type 'boolean':


    if (oldProps.forceNormalForward !== newProps.forceNormalForward) {
      updates.push({
        propertyName: "forceNormalForward",
        value: newProps.forceNormalForward,
        type: "boolean"
      });
    } // TODO: type: BABYLON.ImageProcessingConfiguration property (not coded) BABYLON.PBRMaterial.imageProcessingConfiguration.
    // BABYLON.PBRMaterial.indexOfRefraction of type 'number':


    if (oldProps.indexOfRefraction !== newProps.indexOfRefraction) {
      updates.push({
        propertyName: "indexOfRefraction",
        value: newProps.indexOfRefraction,
        type: "number"
      });
    } // BABYLON.PBRMaterial.invertNormalMapX of type 'boolean':


    if (oldProps.invertNormalMapX !== newProps.invertNormalMapX) {
      updates.push({
        propertyName: "invertNormalMapX",
        value: newProps.invertNormalMapX,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.invertNormalMapY of type 'boolean':


    if (oldProps.invertNormalMapY !== newProps.invertNormalMapY) {
      updates.push({
        propertyName: "invertNormalMapY",
        value: newProps.invertNormalMapY,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.invertRefractionY of type 'boolean':


    if (oldProps.invertRefractionY !== newProps.invertRefractionY) {
      updates.push({
        propertyName: "invertRefractionY",
        value: newProps.invertRefractionY,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.lightmapTexture.
    // BABYLON.PBRMaterial.linkRefractionWithTransparency of type 'boolean':


    if (oldProps.linkRefractionWithTransparency !== newProps.linkRefractionWithTransparency) {
      updates.push({
        propertyName: "linkRefractionWithTransparency",
        value: newProps.linkRefractionWithTransparency,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.maxSimultaneousLights of type 'number':


    if (oldProps.maxSimultaneousLights !== newProps.maxSimultaneousLights) {
      updates.push({
        propertyName: "maxSimultaneousLights",
        value: newProps.maxSimultaneousLights,
        type: "number"
      });
    } // BABYLON.PBRMaterial.metallic of type 'number':


    if (oldProps.metallic !== newProps.metallic) {
      updates.push({
        propertyName: "metallic",
        value: newProps.metallic,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.metallicTexture.
    // BABYLON.PBRMaterial.microSurface of type 'number':


    if (oldProps.microSurface !== newProps.microSurface) {
      updates.push({
        propertyName: "microSurface",
        value: newProps.microSurface,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.microSurfaceTexture.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.opacityTexture.
    // BABYLON.PBRMaterial.parallaxScaleBias of type 'number':


    if (oldProps.parallaxScaleBias !== newProps.parallaxScaleBias) {
      updates.push({
        propertyName: "parallaxScaleBias",
        value: newProps.parallaxScaleBias,
        type: "number"
      });
    } // BABYLON.PBRMaterial.reflectionColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.reflectionColor && (!oldProps.reflectionColor || !oldProps.reflectionColor.equals(newProps.reflectionColor))) {
      updates.push({
        propertyName: "reflectionColor",
        value: newProps.reflectionColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.reflectionTexture.
    // BABYLON.PBRMaterial.reflectivityColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.reflectivityColor && (!oldProps.reflectivityColor || !oldProps.reflectivityColor.equals(newProps.reflectivityColor))) {
      updates.push({
        propertyName: "reflectivityColor",
        value: newProps.reflectivityColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.reflectivityTexture.
    // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.PBRMaterial.refractionTexture.
    // BABYLON.PBRMaterial.roughness of type 'number':


    if (oldProps.roughness !== newProps.roughness) {
      updates.push({
        propertyName: "roughness",
        value: newProps.roughness,
        type: "number"
      });
    } // BABYLON.PBRMaterial.specularIntensity of type 'number':


    if (oldProps.specularIntensity !== newProps.specularIntensity) {
      updates.push({
        propertyName: "specularIntensity",
        value: newProps.specularIntensity,
        type: "number"
      });
    } // BABYLON.PBRMaterial.twoSidedLighting of type 'boolean':


    if (oldProps.twoSidedLighting !== newProps.twoSidedLighting) {
      updates.push({
        propertyName: "twoSidedLighting",
        value: newProps.twoSidedLighting,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.unlit of type 'boolean':


    if (oldProps.unlit !== newProps.unlit) {
      updates.push({
        propertyName: "unlit",
        value: newProps.unlit,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useAlphaFresnel of type 'boolean':


    if (oldProps.useAlphaFresnel !== newProps.useAlphaFresnel) {
      updates.push({
        propertyName: "useAlphaFresnel",
        value: newProps.useAlphaFresnel,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useAlphaFromAlbedoTexture of type 'boolean':


    if (oldProps.useAlphaFromAlbedoTexture !== newProps.useAlphaFromAlbedoTexture) {
      updates.push({
        propertyName: "useAlphaFromAlbedoTexture",
        value: newProps.useAlphaFromAlbedoTexture,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useAmbientInGrayScale of type 'boolean':


    if (oldProps.useAmbientInGrayScale !== newProps.useAmbientInGrayScale) {
      updates.push({
        propertyName: "useAmbientInGrayScale",
        value: newProps.useAmbientInGrayScale,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useAmbientOcclusionFromMetallicTextureRed of type 'boolean':


    if (oldProps.useAmbientOcclusionFromMetallicTextureRed !== newProps.useAmbientOcclusionFromMetallicTextureRed) {
      updates.push({
        propertyName: "useAmbientOcclusionFromMetallicTextureRed",
        value: newProps.useAmbientOcclusionFromMetallicTextureRed,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useAutoMicroSurfaceFromReflectivityMap of type 'boolean':


    if (oldProps.useAutoMicroSurfaceFromReflectivityMap !== newProps.useAutoMicroSurfaceFromReflectivityMap) {
      updates.push({
        propertyName: "useAutoMicroSurfaceFromReflectivityMap",
        value: newProps.useAutoMicroSurfaceFromReflectivityMap,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useGLTFLightFalloff of type 'boolean':


    if (oldProps.useGLTFLightFalloff !== newProps.useGLTFLightFalloff) {
      updates.push({
        propertyName: "useGLTFLightFalloff",
        value: newProps.useGLTFLightFalloff,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useHorizonOcclusion of type 'boolean':


    if (oldProps.useHorizonOcclusion !== newProps.useHorizonOcclusion) {
      updates.push({
        propertyName: "useHorizonOcclusion",
        value: newProps.useHorizonOcclusion,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useLightmapAsShadowmap of type 'boolean':


    if (oldProps.useLightmapAsShadowmap !== newProps.useLightmapAsShadowmap) {
      updates.push({
        propertyName: "useLightmapAsShadowmap",
        value: newProps.useLightmapAsShadowmap,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useLinearAlphaFresnel of type 'boolean':


    if (oldProps.useLinearAlphaFresnel !== newProps.useLinearAlphaFresnel) {
      updates.push({
        propertyName: "useLinearAlphaFresnel",
        value: newProps.useLinearAlphaFresnel,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useMetallnessFromMetallicTextureBlue of type 'boolean':


    if (oldProps.useMetallnessFromMetallicTextureBlue !== newProps.useMetallnessFromMetallicTextureBlue) {
      updates.push({
        propertyName: "useMetallnessFromMetallicTextureBlue",
        value: newProps.useMetallnessFromMetallicTextureBlue,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useMicroSurfaceFromReflectivityMapAlpha of type 'boolean':


    if (oldProps.useMicroSurfaceFromReflectivityMapAlpha !== newProps.useMicroSurfaceFromReflectivityMapAlpha) {
      updates.push({
        propertyName: "useMicroSurfaceFromReflectivityMapAlpha",
        value: newProps.useMicroSurfaceFromReflectivityMapAlpha,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useObjectSpaceNormalMap of type 'boolean':


    if (oldProps.useObjectSpaceNormalMap !== newProps.useObjectSpaceNormalMap) {
      updates.push({
        propertyName: "useObjectSpaceNormalMap",
        value: newProps.useObjectSpaceNormalMap,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useParallax of type 'boolean':


    if (oldProps.useParallax !== newProps.useParallax) {
      updates.push({
        propertyName: "useParallax",
        value: newProps.useParallax,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useParallaxOcclusion of type 'boolean':


    if (oldProps.useParallaxOcclusion !== newProps.useParallaxOcclusion) {
      updates.push({
        propertyName: "useParallaxOcclusion",
        value: newProps.useParallaxOcclusion,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.usePhysicalLightFalloff of type 'boolean':


    if (oldProps.usePhysicalLightFalloff !== newProps.usePhysicalLightFalloff) {
      updates.push({
        propertyName: "usePhysicalLightFalloff",
        value: newProps.usePhysicalLightFalloff,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useRadianceOcclusion of type 'boolean':


    if (oldProps.useRadianceOcclusion !== newProps.useRadianceOcclusion) {
      updates.push({
        propertyName: "useRadianceOcclusion",
        value: newProps.useRadianceOcclusion,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useRadianceOverAlpha of type 'boolean':


    if (oldProps.useRadianceOverAlpha !== newProps.useRadianceOverAlpha) {
      updates.push({
        propertyName: "useRadianceOverAlpha",
        value: newProps.useRadianceOverAlpha,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useRoughnessFromMetallicTextureAlpha of type 'boolean':


    if (oldProps.useRoughnessFromMetallicTextureAlpha !== newProps.useRoughnessFromMetallicTextureAlpha) {
      updates.push({
        propertyName: "useRoughnessFromMetallicTextureAlpha",
        value: newProps.useRoughnessFromMetallicTextureAlpha,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useRoughnessFromMetallicTextureGreen of type 'boolean':


    if (oldProps.useRoughnessFromMetallicTextureGreen !== newProps.useRoughnessFromMetallicTextureGreen) {
      updates.push({
        propertyName: "useRoughnessFromMetallicTextureGreen",
        value: newProps.useRoughnessFromMetallicTextureGreen,
        type: "boolean"
      });
    } // BABYLON.PBRMaterial.useSpecularOverAlpha of type 'boolean':


    if (oldProps.useSpecularOverAlpha !== newProps.useSpecularOverAlpha) {
      updates.push({
        propertyName: "useSpecularOverAlpha",
        value: newProps.useSpecularOverAlpha,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberPBRMaterialPropsHandler;
}();
/**
 * The Physically based material of BJS.
 *
 * This offers the main features of a standard PBR material.
 * For more information, please refer to the documentation :
 * http://doc.babylonjs.com/extensions/Physically_Based_Rendering
 *
 * This code has been generated
 */


var FiberPBRMaterial =
/** @class */
function () {
  function FiberPBRMaterial() {
    this.propsHandlers = [new FiberPBRMaterialPropsHandler(), new FiberPBRBaseMaterialPropsHandler(), new FiberPushMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberPBRMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPBRMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPBRMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PBRMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPBRMaterial.Metadata = {
    isMaterial: true,
    className: "FiberPBRMaterial"
  };
  return FiberPBRMaterial;
}();

var FiberShaderMaterialProps =
/** @class */
function (_super) {
  __extends(FiberShaderMaterialProps, _super);

  function FiberShaderMaterialProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberShaderMaterialProps;
}(FiberMaterialProps);

var FiberShaderMaterialPropsHandler =
/** @class */
function () {
  function FiberShaderMaterialPropsHandler() {}

  FiberShaderMaterialPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.ShaderMaterial.setArray2 of type '(name?: string, value?: number[])':

    if (oldProps.setArray2 !== newProps.setArray2) {
      updates.push({
        propertyName: "setArray2",
        value: newProps.setArray2,
        type: "(name?: string, value?: number[])"
      });
    } // BABYLON.ShaderMaterial.setArray3 of type '(name?: string, value?: number[])':


    if (oldProps.setArray3 !== newProps.setArray3) {
      updates.push({
        propertyName: "setArray3",
        value: newProps.setArray3,
        type: "(name?: string, value?: number[])"
      });
    } // BABYLON.ShaderMaterial.setColor3 of type '(name?: string, value?: BABYLON.Color3)':


    if (oldProps.setColor3 !== newProps.setColor3) {
      updates.push({
        propertyName: "setColor3",
        value: newProps.setColor3,
        type: "(name?: string, value?: BABYLON.Color3)"
      });
    } // BABYLON.ShaderMaterial.setColor3Array of type '(name?: string, value?: BABYLON.Color3[])':


    if (oldProps.setColor3Array !== newProps.setColor3Array) {
      updates.push({
        propertyName: "setColor3Array",
        value: newProps.setColor3Array,
        type: "(name?: string, value?: BABYLON.Color3[])"
      });
    } // BABYLON.ShaderMaterial.setColor4 of type '(name?: string, value?: BABYLON.Color4)':


    if (oldProps.setColor4 !== newProps.setColor4) {
      updates.push({
        propertyName: "setColor4",
        value: newProps.setColor4,
        type: "(name?: string, value?: BABYLON.Color4)"
      });
    } // BABYLON.ShaderMaterial.setFloat of type '(name?: string, value?: number)':


    if (oldProps.setFloat !== newProps.setFloat) {
      updates.push({
        propertyName: "setFloat",
        value: newProps.setFloat,
        type: "(name?: string, value?: number)"
      });
    } // BABYLON.ShaderMaterial.setFloats of type '(name?: string, value?: number[])':


    if (oldProps.setFloats !== newProps.setFloats) {
      updates.push({
        propertyName: "setFloats",
        value: newProps.setFloats,
        type: "(name?: string, value?: number[])"
      });
    } // BABYLON.ShaderMaterial.setInt of type '(name?: string, value?: number)':


    if (oldProps.setInt !== newProps.setInt) {
      updates.push({
        propertyName: "setInt",
        value: newProps.setInt,
        type: "(name?: string, value?: number)"
      });
    } // BABYLON.ShaderMaterial.setMatrix of type '(name?: string, value?: BABYLON.Matrix)':


    if (oldProps.setMatrix !== newProps.setMatrix) {
      updates.push({
        propertyName: "setMatrix",
        value: newProps.setMatrix,
        type: "(name?: string, value?: BABYLON.Matrix)"
      });
    } // BABYLON.ShaderMaterial.setMatrix2x2 of type '(name?: string, value?: Float32Array)':


    if (oldProps.setMatrix2x2 !== newProps.setMatrix2x2) {
      updates.push({
        propertyName: "setMatrix2x2",
        value: newProps.setMatrix2x2,
        type: "(name?: string, value?: Float32Array)"
      });
    } // BABYLON.ShaderMaterial.setMatrix3x3 of type '(name?: string, value?: Float32Array)':


    if (oldProps.setMatrix3x3 !== newProps.setMatrix3x3) {
      updates.push({
        propertyName: "setMatrix3x3",
        value: newProps.setMatrix3x3,
        type: "(name?: string, value?: Float32Array)"
      });
    } // BABYLON.ShaderMaterial.setTexture of type '(name?: string, texture?: BABYLON.Texture)':


    if (oldProps.setTexture !== newProps.setTexture) {
      updates.push({
        propertyName: "setTexture",
        value: newProps.setTexture,
        type: "(name?: string, texture?: BABYLON.Texture)"
      });
    } // BABYLON.ShaderMaterial.setTextureArray of type '(name?: string, textures?: BABYLON.Texture[])':


    if (oldProps.setTextureArray !== newProps.setTextureArray) {
      updates.push({
        propertyName: "setTextureArray",
        value: newProps.setTextureArray,
        type: "(name?: string, textures?: BABYLON.Texture[])"
      });
    } // BABYLON.ShaderMaterial.setVector2 of type '(name?: string, value?: BABYLON.Vector2)':


    if (oldProps.setVector2 !== newProps.setVector2) {
      updates.push({
        propertyName: "setVector2",
        value: newProps.setVector2,
        type: "(name?: string, value?: BABYLON.Vector2)"
      });
    } // BABYLON.ShaderMaterial.setVector3 of type '(name?: string, value?: BABYLON.Vector3)':


    if (oldProps.setVector3 !== newProps.setVector3) {
      updates.push({
        propertyName: "setVector3",
        value: newProps.setVector3,
        type: "(name?: string, value?: BABYLON.Vector3)"
      });
    } // BABYLON.ShaderMaterial.setVector4 of type '(name?: string, value?: BABYLON.Vector4)':


    if (oldProps.setVector4 !== newProps.setVector4) {
      updates.push({
        propertyName: "setVector4",
        value: newProps.setVector4,
        type: "(name?: string, value?: BABYLON.Vector4)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberShaderMaterialPropsHandler;
}();
/**
 * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
 *
 * This returned material effects how the mesh will look based on the code in the shaders.
 *
 * This code has been generated
 */


var FiberShaderMaterial =
/** @class */
function () {
  function FiberShaderMaterial() {
    this.propsHandlers = [new FiberShaderMaterialPropsHandler(), new FiberMaterialPropsHandler()];
  }

  FiberShaderMaterial.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberShaderMaterial.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberShaderMaterial.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ShaderMaterial",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "shaderPath",
      type: "any",
      optional: false
    }, {
      name: "options",
      type: "Partial<BABYLON.IShaderMaterialOptions>",
      optional: true
    }]
  };
  FiberShaderMaterial.Metadata = {
    isMaterial: true,
    className: "FiberShaderMaterial"
  };
  return FiberShaderMaterial;
}();

var FiberLightProps =
/** @class */
function (_super) {
  __extends(FiberLightProps, _super);

  function FiberLightProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberLightProps;
}(FiberNodeProps);

var FiberLightPropsHandler =
/** @class */
function () {
  function FiberLightPropsHandler() {}

  FiberLightPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.Light.diffuse of BABYLONBABYLON.Color3 uses object equals to find diffs:

    if (newProps.diffuse && (!oldProps.diffuse || !oldProps.diffuse.equals(newProps.diffuse))) {
      updates.push({
        propertyName: "diffuse",
        value: newProps.diffuse,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.AbstractMesh[] property (not coded) BABYLON.Light.excludedMeshes.
    // BABYLON.Light.excludeWithLayerMask of type 'number':


    if (oldProps.excludeWithLayerMask !== newProps.excludeWithLayerMask) {
      updates.push({
        propertyName: "excludeWithLayerMask",
        value: newProps.excludeWithLayerMask,
        type: "number"
      });
    } // BABYLON.Light.falloffType of type 'number':


    if (oldProps.falloffType !== newProps.falloffType) {
      updates.push({
        propertyName: "falloffType",
        value: newProps.falloffType,
        type: "number"
      });
    } // TODO: type: BABYLON.AbstractMesh[] property (not coded) BABYLON.Light.includedOnlyMeshes.
    // BABYLON.Light.includeOnlyWithLayerMask of type 'number':


    if (oldProps.includeOnlyWithLayerMask !== newProps.includeOnlyWithLayerMask) {
      updates.push({
        propertyName: "includeOnlyWithLayerMask",
        value: newProps.includeOnlyWithLayerMask,
        type: "number"
      });
    } // BABYLON.Light.intensity of type 'number':


    if (oldProps.intensity !== newProps.intensity) {
      updates.push({
        propertyName: "intensity",
        value: newProps.intensity,
        type: "number"
      });
    } // BABYLON.Light.intensityMode of type 'number':


    if (oldProps.intensityMode !== newProps.intensityMode) {
      updates.push({
        propertyName: "intensityMode",
        value: newProps.intensityMode,
        type: "number"
      });
    } // BABYLON.Light.lightmapMode of type 'number':


    if (oldProps.lightmapMode !== newProps.lightmapMode) {
      updates.push({
        propertyName: "lightmapMode",
        value: newProps.lightmapMode,
        type: "number"
      });
    } // BABYLON.Light.radius of type 'number':


    if (oldProps.radius !== newProps.radius) {
      updates.push({
        propertyName: "radius",
        value: newProps.radius,
        type: "number"
      });
    } // BABYLON.Light.range of type 'number':


    if (oldProps.range !== newProps.range) {
      updates.push({
        propertyName: "range",
        value: newProps.range,
        type: "number"
      });
    } // BABYLON.Light.renderPriority of type 'number':


    if (oldProps.renderPriority !== newProps.renderPriority) {
      updates.push({
        propertyName: "renderPriority",
        value: newProps.renderPriority,
        type: "number"
      });
    } // BABYLON.Light.shadowEnabled of type 'boolean':


    if (oldProps.shadowEnabled !== newProps.shadowEnabled) {
      updates.push({
        propertyName: "shadowEnabled",
        value: newProps.shadowEnabled,
        type: "boolean"
      });
    } // BABYLON.Light.specular of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.specular && (!oldProps.specular || !oldProps.specular.equals(newProps.specular))) {
      updates.push({
        propertyName: "specular",
        value: newProps.specular,
        type: "BABYLON.Color3"
      });
    } // BABYLON.Light.setEnabled of type '(value?: boolean)':


    if (oldProps.setEnabled !== newProps.setEnabled) {
      updates.push({
        propertyName: "setEnabled",
        value: newProps.setEnabled,
        type: "(value?: boolean)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberLightPropsHandler;
}();
/**
 * Base class of all the lights in Babylon. It groups all the generic information about lights.
 * Lights are used, as you would expect, to affect how meshes are seen, in terms of both illumination and colour.
 * All meshes allow light to pass through them unless shadow generation is activated. The default number of lights allowed is four but this can be increased.
 *
 * This code has been generated
 */


var FiberLight =
/** @class */
function () {
  function FiberLight() {
    this.propsHandlers = [new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLight.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Light",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberLight.Metadata = {
    className: "FiberLight"
  };
  return FiberLight;
}();

var FiberHemisphericLightProps =
/** @class */
function (_super) {
  __extends(FiberHemisphericLightProps, _super);

  function FiberHemisphericLightProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberHemisphericLightProps;
}(FiberLightProps);

var FiberHemisphericLightPropsHandler =
/** @class */
function () {
  function FiberHemisphericLightPropsHandler() {}

  FiberHemisphericLightPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.HemisphericLight.direction of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.direction && (!oldProps.direction || !oldProps.direction.equals(newProps.direction))) {
      updates.push({
        propertyName: "direction",
        value: newProps.direction,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.HemisphericLight.groundColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.groundColor && (!oldProps.groundColor || !oldProps.groundColor.equals(newProps.groundColor))) {
      updates.push({
        propertyName: "groundColor",
        value: newProps.groundColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.HemisphericLight.setDirectionToTarget of type '(target?: BABYLON.Vector3)':


    if (oldProps.setDirectionToTarget !== newProps.setDirectionToTarget) {
      updates.push({
        propertyName: "setDirectionToTarget",
        value: newProps.setDirectionToTarget,
        type: "(target?: BABYLON.Vector3)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberHemisphericLightPropsHandler;
}();
/**
 * The HemisphericLight simulates the ambient environment light,
 * so the passed direction is the light reflection direction, not the incoming direction.
 *
 * This code has been generated
 */


var FiberHemisphericLight =
/** @class */
function () {
  function FiberHemisphericLight() {
    this.propsHandlers = [new FiberHemisphericLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberHemisphericLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHemisphericLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHemisphericLight.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "HemisphericLight",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "direction",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberHemisphericLight.Metadata = {
    className: "FiberHemisphericLight"
  };
  return FiberHemisphericLight;
}();

var FiberShadowLightProps =
/** @class */
function (_super) {
  __extends(FiberShadowLightProps, _super);

  function FiberShadowLightProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberShadowLightProps;
}(FiberLightProps);

var FiberShadowLightPropsHandler =
/** @class */
function () {
  function FiberShadowLightPropsHandler() {}

  FiberShadowLightPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: (viewMatrix: BABYLON.Matrix, renderList: BABYLON.AbstractMesh[], result: BABYLON.Matrix) => void property (not coded) BABYLON.ShadowLight.customProjectionMatrixBuilder.
    // BABYLON.ShadowLight.direction of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.direction && (!oldProps.direction || !oldProps.direction.equals(newProps.direction))) {
      updates.push({
        propertyName: "direction",
        value: newProps.direction,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ShadowLight.position of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.position && (!oldProps.position || !oldProps.position.equals(newProps.position))) {
      updates.push({
        propertyName: "position",
        value: newProps.position,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ShadowLight.shadowMaxZ of type 'number':


    if (oldProps.shadowMaxZ !== newProps.shadowMaxZ) {
      updates.push({
        propertyName: "shadowMaxZ",
        value: newProps.shadowMaxZ,
        type: "number"
      });
    } // BABYLON.ShadowLight.shadowMinZ of type 'number':


    if (oldProps.shadowMinZ !== newProps.shadowMinZ) {
      updates.push({
        propertyName: "shadowMinZ",
        value: newProps.shadowMinZ,
        type: "number"
      });
    } // BABYLON.ShadowLight.transformedDirection of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.transformedDirection && (!oldProps.transformedDirection || !oldProps.transformedDirection.equals(newProps.transformedDirection))) {
      updates.push({
        propertyName: "transformedDirection",
        value: newProps.transformedDirection,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ShadowLight.transformedPosition of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.transformedPosition && (!oldProps.transformedPosition || !oldProps.transformedPosition.equals(newProps.transformedPosition))) {
      updates.push({
        propertyName: "transformedPosition",
        value: newProps.transformedPosition,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.ShadowLight.setDirectionToTarget of type '(target?: BABYLON.Vector3)':


    if (oldProps.setDirectionToTarget !== newProps.setDirectionToTarget) {
      updates.push({
        propertyName: "setDirectionToTarget",
        value: newProps.setDirectionToTarget,
        type: "(target?: BABYLON.Vector3)"
      });
    } // BABYLON.ShadowLight.setShadowProjectionMatrix of type '(matrix?: BABYLON.Matrix, viewMatrix?: BABYLON.Matrix, renderList?: BABYLON.AbstractMesh[])':


    if (oldProps.setShadowProjectionMatrix !== newProps.setShadowProjectionMatrix) {
      updates.push({
        propertyName: "setShadowProjectionMatrix",
        value: newProps.setShadowProjectionMatrix,
        type: "(matrix?: BABYLON.Matrix, viewMatrix?: BABYLON.Matrix, renderList?: BABYLON.AbstractMesh[])"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberShadowLightPropsHandler;
}();
/**
 * Base implementation IShadowLight
 * It groups all the common behaviour in order to reduce dupplication and better follow the DRY pattern.
 *
 * This code has been generated
 */


var FiberShadowLight =
/** @class */
function () {
  function FiberShadowLight() {
    this.propsHandlers = [new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberShadowLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberShadowLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberShadowLight.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ShadowLight",
    namespace: "BABYLON",
    parameters: []
  };
  FiberShadowLight.Metadata = {
    className: "FiberShadowLight",
    isShadowLight: true
  };
  return FiberShadowLight;
}();

var FiberDirectionalLightProps =
/** @class */
function (_super) {
  __extends(FiberDirectionalLightProps, _super);

  function FiberDirectionalLightProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberDirectionalLightProps;
}(FiberShadowLightProps);

var FiberDirectionalLightPropsHandler =
/** @class */
function () {
  function FiberDirectionalLightPropsHandler() {}

  FiberDirectionalLightPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.DirectionalLight.autoUpdateExtends of type 'boolean':

    if (oldProps.autoUpdateExtends !== newProps.autoUpdateExtends) {
      updates.push({
        propertyName: "autoUpdateExtends",
        value: newProps.autoUpdateExtends,
        type: "boolean"
      });
    } // BABYLON.DirectionalLight.shadowFrustumSize of type 'number':


    if (oldProps.shadowFrustumSize !== newProps.shadowFrustumSize) {
      updates.push({
        propertyName: "shadowFrustumSize",
        value: newProps.shadowFrustumSize,
        type: "number"
      });
    } // BABYLON.DirectionalLight.shadowOrthoScale of type 'number':


    if (oldProps.shadowOrthoScale !== newProps.shadowOrthoScale) {
      updates.push({
        propertyName: "shadowOrthoScale",
        value: newProps.shadowOrthoScale,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberDirectionalLightPropsHandler;
}();
/**
 * A directional light is defined by a direction (what a surprise!).
 * The light is emitted from everywhere in the specified direction, and has an infinite range.
 * An example of a directional light is when a distance planet is lit by the apparently parallel lines of light from its sun. Light in a downward direction will light the top of an object.
 * Documentation: https://doc.babylonjs.com/babylon101/lights
 *
 * This code has been generated
 */


var FiberDirectionalLight =
/** @class */
function () {
  function FiberDirectionalLight() {
    this.propsHandlers = [new FiberDirectionalLightPropsHandler(), new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberDirectionalLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDirectionalLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDirectionalLight.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "DirectionalLight",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "direction",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberDirectionalLight.Metadata = {
    className: "FiberDirectionalLight",
    isShadowLight: true
  };
  return FiberDirectionalLight;
}();

var FiberPointLightProps =
/** @class */
function (_super) {
  __extends(FiberPointLightProps, _super);

  function FiberPointLightProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPointLightProps;
}(FiberShadowLightProps);

var FiberPointLightPropsHandler =
/** @class */
function () {
  function FiberPointLightPropsHandler() {}

  FiberPointLightPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.PointLight.direction of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.direction && (!oldProps.direction || !oldProps.direction.equals(newProps.direction))) {
      updates.push({
        propertyName: "direction",
        value: newProps.direction,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.PointLight.shadowAngle of type 'number':


    if (oldProps.shadowAngle !== newProps.shadowAngle) {
      updates.push({
        propertyName: "shadowAngle",
        value: newProps.shadowAngle,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberPointLightPropsHandler;
}();
/**
 * A point light is a light defined by an unique point in world space.
 * The light is emitted in every direction from this point.
 * A good example of a point light is a standard light bulb.
 * Documentation: https://doc.babylonjs.com/babylon101/lights
 *
 * This code has been generated
 */


var FiberPointLight =
/** @class */
function () {
  function FiberPointLight() {
    this.propsHandlers = [new FiberPointLightPropsHandler(), new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberPointLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPointLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPointLight.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PointLight",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberPointLight.Metadata = {
    className: "FiberPointLight",
    isShadowLight: true
  };
  return FiberPointLight;
}();

var FiberSpotLightProps =
/** @class */
function (_super) {
  __extends(FiberSpotLightProps, _super);

  function FiberSpotLightProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberSpotLightProps;
}(FiberShadowLightProps);

var FiberSpotLightPropsHandler =
/** @class */
function () {
  function FiberSpotLightPropsHandler() {}

  FiberSpotLightPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.SpotLight.angle of type 'number':

    if (oldProps.angle !== newProps.angle) {
      updates.push({
        propertyName: "angle",
        value: newProps.angle,
        type: "number"
      });
    } // BABYLON.SpotLight.exponent of type 'number':


    if (oldProps.exponent !== newProps.exponent) {
      updates.push({
        propertyName: "exponent",
        value: newProps.exponent,
        type: "number"
      });
    } // BABYLON.SpotLight.innerAngle of type 'number':


    if (oldProps.innerAngle !== newProps.innerAngle) {
      updates.push({
        propertyName: "innerAngle",
        value: newProps.innerAngle,
        type: "number"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.SpotLight.projectionTexture.
    // BABYLON.SpotLight.projectionTextureLightFar of type 'number':


    if (oldProps.projectionTextureLightFar !== newProps.projectionTextureLightFar) {
      updates.push({
        propertyName: "projectionTextureLightFar",
        value: newProps.projectionTextureLightFar,
        type: "number"
      });
    } // BABYLON.SpotLight.projectionTextureLightNear of type 'number':


    if (oldProps.projectionTextureLightNear !== newProps.projectionTextureLightNear) {
      updates.push({
        propertyName: "projectionTextureLightNear",
        value: newProps.projectionTextureLightNear,
        type: "number"
      });
    } // BABYLON.SpotLight.projectionTextureUpDirection of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.projectionTextureUpDirection && (!oldProps.projectionTextureUpDirection || !oldProps.projectionTextureUpDirection.equals(newProps.projectionTextureUpDirection))) {
      updates.push({
        propertyName: "projectionTextureUpDirection",
        value: newProps.projectionTextureUpDirection,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.SpotLight.shadowAngleScale of type 'number':


    if (oldProps.shadowAngleScale !== newProps.shadowAngleScale) {
      updates.push({
        propertyName: "shadowAngleScale",
        value: newProps.shadowAngleScale,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberSpotLightPropsHandler;
}();
/**
 * A spot light is defined by a position, a direction, an angle, and an exponent.
 * These values define a cone of light starting from the position, emitting toward the direction.
 * The angle, in radians, defines the size (field of illumination) of the spotlight's conical beam,
 * and the exponent defines the speed of the decay of the light with distance (reach).
 * Documentation: https://doc.babylonjs.com/babylon101/lights
 *
 * This code has been generated
 */


var FiberSpotLight =
/** @class */
function () {
  function FiberSpotLight() {
    this.propsHandlers = [new FiberSpotLightPropsHandler(), new FiberShadowLightPropsHandler(), new FiberLightPropsHandler(), new FiberNodePropsHandler()];
  }

  FiberSpotLight.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSpotLight.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSpotLight.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "SpotLight",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "position",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "direction",
      type: "BABYLON.Vector3",
      optional: false
    }, {
      name: "angle",
      type: "number",
      optional: false
    }, {
      name: "exponent",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberSpotLight.Metadata = {
    className: "FiberSpotLight",
    isShadowLight: true
  };
  return FiberSpotLight;
}();

var FiberControlProps =
/** @class */
function () {
  function FiberControlProps() {}

  return FiberControlProps;
}();

var FiberControlPropsHandler =
/** @class */
function () {
  function FiberControlPropsHandler() {}

  FiberControlPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Control.alpha of type 'number':

    if (oldProps.alpha !== newProps.alpha) {
      updates.push({
        propertyName: "alpha",
        value: newProps.alpha,
        type: "number"
      });
    } // GUI.Control.clipChildren of type 'boolean':


    if (oldProps.clipChildren !== newProps.clipChildren) {
      updates.push({
        propertyName: "clipChildren",
        value: newProps.clipChildren,
        type: "boolean"
      });
    } // GUI.Control.color of type 'string':


    if (oldProps.color !== newProps.color) {
      updates.push({
        propertyName: "color",
        value: newProps.color,
        type: "string"
      });
    } // GUI.Control.disabledColor of type 'string':


    if (oldProps.disabledColor !== newProps.disabledColor) {
      updates.push({
        propertyName: "disabledColor",
        value: newProps.disabledColor,
        type: "string"
      });
    } // GUI.Control.fontFamily of type 'string':


    if (oldProps.fontFamily !== newProps.fontFamily) {
      updates.push({
        propertyName: "fontFamily",
        value: newProps.fontFamily,
        type: "string"
      });
    } // TODO: type: { ascent: number; height: number; descent: number; } property (not coded) GUI.Control.fontOffset.
    // GUI.Control.fontSize of type 'string | number':


    if (oldProps.fontSize !== newProps.fontSize) {
      updates.push({
        propertyName: "fontSize",
        value: newProps.fontSize,
        type: "string | number"
      });
    } // GUI.Control.fontStyle of type 'string':


    if (oldProps.fontStyle !== newProps.fontStyle) {
      updates.push({
        propertyName: "fontStyle",
        value: newProps.fontStyle,
        type: "string"
      });
    } // GUI.Control.fontWeight of type 'string':


    if (oldProps.fontWeight !== newProps.fontWeight) {
      updates.push({
        propertyName: "fontWeight",
        value: newProps.fontWeight,
        type: "string"
      });
    } // GUI.Control.height of type 'string | number':


    if (oldProps.height !== newProps.height) {
      updates.push({
        propertyName: "height",
        value: newProps.height,
        type: "string | number"
      });
    } // GUI.Control.horizontalAlignment of type 'number':


    if (oldProps.horizontalAlignment !== newProps.horizontalAlignment) {
      updates.push({
        propertyName: "horizontalAlignment",
        value: newProps.horizontalAlignment,
        type: "number"
      });
    } // GUI.Control.hoverCursor of type 'string':


    if (oldProps.hoverCursor !== newProps.hoverCursor) {
      updates.push({
        propertyName: "hoverCursor",
        value: newProps.hoverCursor,
        type: "string"
      });
    } // GUI.Control.isEnabled of type 'boolean':


    if (oldProps.isEnabled !== newProps.isEnabled) {
      updates.push({
        propertyName: "isEnabled",
        value: newProps.isEnabled,
        type: "boolean"
      });
    } // GUI.Control.isFocusInvisible of type 'boolean':


    if (oldProps.isFocusInvisible !== newProps.isFocusInvisible) {
      updates.push({
        propertyName: "isFocusInvisible",
        value: newProps.isFocusInvisible,
        type: "boolean"
      });
    } // GUI.Control.isHighlighted of type 'boolean':


    if (oldProps.isHighlighted !== newProps.isHighlighted) {
      updates.push({
        propertyName: "isHighlighted",
        value: newProps.isHighlighted,
        type: "boolean"
      });
    } // GUI.Control.isHitTestVisible of type 'boolean':


    if (oldProps.isHitTestVisible !== newProps.isHitTestVisible) {
      updates.push({
        propertyName: "isHitTestVisible",
        value: newProps.isHitTestVisible,
        type: "boolean"
      });
    } // GUI.Control.isPointerBlocker of type 'boolean':


    if (oldProps.isPointerBlocker !== newProps.isPointerBlocker) {
      updates.push({
        propertyName: "isPointerBlocker",
        value: newProps.isPointerBlocker,
        type: "boolean"
      });
    } // GUI.Control.isVisible of type 'boolean':


    if (oldProps.isVisible !== newProps.isVisible) {
      updates.push({
        propertyName: "isVisible",
        value: newProps.isVisible,
        type: "boolean"
      });
    } // GUI.Control.left of type 'string | number':


    if (oldProps.left !== newProps.left) {
      updates.push({
        propertyName: "left",
        value: newProps.left,
        type: "string | number"
      });
    } // GUI.Control.linkOffsetX of type 'string | number':


    if (oldProps.linkOffsetX !== newProps.linkOffsetX) {
      updates.push({
        propertyName: "linkOffsetX",
        value: newProps.linkOffsetX,
        type: "string | number"
      });
    } // GUI.Control.linkOffsetY of type 'string | number':


    if (oldProps.linkOffsetY !== newProps.linkOffsetY) {
      updates.push({
        propertyName: "linkOffsetY",
        value: newProps.linkOffsetY,
        type: "string | number"
      });
    } // TODO: type: any property (not coded) GUI.Control.metadata.
    // GUI.Control.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Control.notRenderable of type 'boolean':


    if (oldProps.notRenderable !== newProps.notRenderable) {
      updates.push({
        propertyName: "notRenderable",
        value: newProps.notRenderable,
        type: "boolean"
      });
    } // GUI.Control.onAfterDrawObservable of type 'BABYLON.Observable<BABYLON.GUI.Control>/fn':


    if (oldProps.onAfterDrawObservable === undefined && oldProps.onAfterDrawObservable !== newProps.onAfterDrawObservable) {
      updates.push({
        propertyName: "onAfterDrawObservable",
        value: newProps.onAfterDrawObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control>"
      });
    } // GUI.Control.onBeforeDrawObservable of type 'BABYLON.Observable<BABYLON.GUI.Control>/fn':


    if (oldProps.onBeforeDrawObservable === undefined && oldProps.onBeforeDrawObservable !== newProps.onBeforeDrawObservable) {
      updates.push({
        propertyName: "onBeforeDrawObservable",
        value: newProps.onBeforeDrawObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control>"
      });
    } // GUI.Control.onDirtyObservable of type 'BABYLON.Observable<BABYLON.GUI.Control>/fn':


    if (oldProps.onDirtyObservable === undefined && oldProps.onDirtyObservable !== newProps.onDirtyObservable) {
      updates.push({
        propertyName: "onDirtyObservable",
        value: newProps.onDirtyObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control>"
      });
    } // GUI.Control.onPointerClickObservable of type 'BABYLON.Observable<BABYLON.GUI.Vector2WithInfo>/fn':


    if (oldProps.onPointerClickObservable === undefined && oldProps.onPointerClickObservable !== newProps.onPointerClickObservable) {
      updates.push({
        propertyName: "onPointerClickObservable",
        value: newProps.onPointerClickObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Vector2WithInfo>"
      });
    } // GUI.Control.onPointerDownObservable of type 'BABYLON.Observable<BABYLON.GUI.Vector2WithInfo>/fn':


    if (oldProps.onPointerDownObservable === undefined && oldProps.onPointerDownObservable !== newProps.onPointerDownObservable) {
      updates.push({
        propertyName: "onPointerDownObservable",
        value: newProps.onPointerDownObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Vector2WithInfo>"
      });
    } // GUI.Control.onPointerEnterObservable of type 'BABYLON.Observable<BABYLON.GUI.Control>/fn':


    if (oldProps.onPointerEnterObservable === undefined && oldProps.onPointerEnterObservable !== newProps.onPointerEnterObservable) {
      updates.push({
        propertyName: "onPointerEnterObservable",
        value: newProps.onPointerEnterObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control>"
      });
    } // GUI.Control.onPointerMoveObservable of type 'BABYLON.Observable<BABYLON.Vector2>/fn':


    if (oldProps.onPointerMoveObservable === undefined && oldProps.onPointerMoveObservable !== newProps.onPointerMoveObservable) {
      updates.push({
        propertyName: "onPointerMoveObservable",
        value: newProps.onPointerMoveObservable,
        type: "BABYLON.Observable<BABYLON.Vector2>"
      });
    } // GUI.Control.onPointerOutObservable of type 'BABYLON.Observable<BABYLON.GUI.Control>/fn':


    if (oldProps.onPointerOutObservable === undefined && oldProps.onPointerOutObservable !== newProps.onPointerOutObservable) {
      updates.push({
        propertyName: "onPointerOutObservable",
        value: newProps.onPointerOutObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control>"
      });
    } // GUI.Control.onPointerUpObservable of type 'BABYLON.Observable<BABYLON.GUI.Vector2WithInfo>/fn':


    if (oldProps.onPointerUpObservable === undefined && oldProps.onPointerUpObservable !== newProps.onPointerUpObservable) {
      updates.push({
        propertyName: "onPointerUpObservable",
        value: newProps.onPointerUpObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Vector2WithInfo>"
      });
    } // GUI.Control.paddingBottom of type 'string | number':


    if (oldProps.paddingBottom !== newProps.paddingBottom) {
      updates.push({
        propertyName: "paddingBottom",
        value: newProps.paddingBottom,
        type: "string | number"
      });
    } // GUI.Control.paddingLeft of type 'string | number':


    if (oldProps.paddingLeft !== newProps.paddingLeft) {
      updates.push({
        propertyName: "paddingLeft",
        value: newProps.paddingLeft,
        type: "string | number"
      });
    } // GUI.Control.paddingRight of type 'string | number':


    if (oldProps.paddingRight !== newProps.paddingRight) {
      updates.push({
        propertyName: "paddingRight",
        value: newProps.paddingRight,
        type: "string | number"
      });
    } // GUI.Control.paddingTop of type 'string | number':


    if (oldProps.paddingTop !== newProps.paddingTop) {
      updates.push({
        propertyName: "paddingTop",
        value: newProps.paddingTop,
        type: "string | number"
      });
    } // TODO: type: BABYLON.GUI.Container property (not coded) GUI.Control.parent.
    // GUI.Control.rotation of type 'number':


    if (oldProps.rotation !== newProps.rotation) {
      updates.push({
        propertyName: "rotation",
        value: newProps.rotation,
        type: "number"
      });
    } // GUI.Control.scaleX of type 'number':


    if (oldProps.scaleX !== newProps.scaleX) {
      updates.push({
        propertyName: "scaleX",
        value: newProps.scaleX,
        type: "number"
      });
    } // GUI.Control.scaleY of type 'number':


    if (oldProps.scaleY !== newProps.scaleY) {
      updates.push({
        propertyName: "scaleY",
        value: newProps.scaleY,
        type: "number"
      });
    } // GUI.Control.shadowBlur of type 'number':


    if (oldProps.shadowBlur !== newProps.shadowBlur) {
      updates.push({
        propertyName: "shadowBlur",
        value: newProps.shadowBlur,
        type: "number"
      });
    } // GUI.Control.shadowColor of type 'string':


    if (oldProps.shadowColor !== newProps.shadowColor) {
      updates.push({
        propertyName: "shadowColor",
        value: newProps.shadowColor,
        type: "string"
      });
    } // GUI.Control.shadowOffsetX of type 'number':


    if (oldProps.shadowOffsetX !== newProps.shadowOffsetX) {
      updates.push({
        propertyName: "shadowOffsetX",
        value: newProps.shadowOffsetX,
        type: "number"
      });
    } // GUI.Control.shadowOffsetY of type 'number':


    if (oldProps.shadowOffsetY !== newProps.shadowOffsetY) {
      updates.push({
        propertyName: "shadowOffsetY",
        value: newProps.shadowOffsetY,
        type: "number"
      });
    } // TODO: type: BABYLON.GUI.Style property (not coded) GUI.Control.style.
    // GUI.Control.top of type 'string | number':


    if (oldProps.top !== newProps.top) {
      updates.push({
        propertyName: "top",
        value: newProps.top,
        type: "string | number"
      });
    } // GUI.Control.transformCenterX of type 'number':


    if (oldProps.transformCenterX !== newProps.transformCenterX) {
      updates.push({
        propertyName: "transformCenterX",
        value: newProps.transformCenterX,
        type: "number"
      });
    } // GUI.Control.transformCenterY of type 'number':


    if (oldProps.transformCenterY !== newProps.transformCenterY) {
      updates.push({
        propertyName: "transformCenterY",
        value: newProps.transformCenterY,
        type: "number"
      });
    } // GUI.Control.uniqueId of type 'number':


    if (oldProps.uniqueId !== newProps.uniqueId) {
      updates.push({
        propertyName: "uniqueId",
        value: newProps.uniqueId,
        type: "number"
      });
    } // GUI.Control.verticalAlignment of type 'number':


    if (oldProps.verticalAlignment !== newProps.verticalAlignment) {
      updates.push({
        propertyName: "verticalAlignment",
        value: newProps.verticalAlignment,
        type: "number"
      });
    } // GUI.Control.width of type 'string | number':


    if (oldProps.width !== newProps.width) {
      updates.push({
        propertyName: "width",
        value: newProps.width,
        type: "string | number"
      });
    } // GUI.Control.zIndex of type 'number':


    if (oldProps.zIndex !== newProps.zIndex) {
      updates.push({
        propertyName: "zIndex",
        value: newProps.zIndex,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberControlPropsHandler;
}();
/**
 * Root class used for all 2D controls
 *
 * This code has been generated
 */


var FiberControl =
/** @class */
function () {
  function FiberControl() {
    this.propsHandlers = [new FiberControlPropsHandler()];
  }

  FiberControl.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberControl.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberControl.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Control",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberControl.Metadata = {
    isGUI2DControl: true,
    className: "FiberControl"
  };
  return FiberControl;
}();

var FiberCheckboxProps =
/** @class */
function (_super) {
  __extends(FiberCheckboxProps, _super);

  function FiberCheckboxProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberCheckboxProps;
}(FiberControlProps);

var FiberCheckboxPropsHandler =
/** @class */
function () {
  function FiberCheckboxPropsHandler() {}

  FiberCheckboxPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Checkbox.background of type 'string':

    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.Checkbox.checkSizeRatio of type 'number':


    if (oldProps.checkSizeRatio !== newProps.checkSizeRatio) {
      updates.push({
        propertyName: "checkSizeRatio",
        value: newProps.checkSizeRatio,
        type: "number"
      });
    } // GUI.Checkbox.isChecked of type 'boolean':


    if (oldProps.isChecked !== newProps.isChecked) {
      updates.push({
        propertyName: "isChecked",
        value: newProps.isChecked,
        type: "boolean"
      });
    } // GUI.Checkbox.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Checkbox.onIsCheckedChangedObservable of type 'BABYLON.Observable<boolean>/fn':


    if (oldProps.onIsCheckedChangedObservable === undefined && oldProps.onIsCheckedChangedObservable !== newProps.onIsCheckedChangedObservable) {
      updates.push({
        propertyName: "onIsCheckedChangedObservable",
        value: newProps.onIsCheckedChangedObservable,
        type: "BABYLON.Observable<boolean>"
      });
    } // GUI.Checkbox.thickness of type 'number':


    if (oldProps.thickness !== newProps.thickness) {
      updates.push({
        propertyName: "thickness",
        value: newProps.thickness,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberCheckboxPropsHandler;
}();
/**
 * Class used to represent a 2D checkbox
 *
 * This code has been generated
 */


var FiberCheckbox =
/** @class */
function () {
  function FiberCheckbox() {
    this.propsHandlers = [new FiberCheckboxPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberCheckbox.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCheckbox.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCheckbox.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Checkbox",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberCheckbox.Metadata = {
    isGUI2DControl: true,
    className: "FiberCheckbox"
  };
  return FiberCheckbox;
}();

var FiberColorPickerProps =
/** @class */
function (_super) {
  __extends(FiberColorPickerProps, _super);

  function FiberColorPickerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberColorPickerProps;
}(FiberControlProps);

var FiberColorPickerPropsHandler =
/** @class */
function () {
  function FiberColorPickerPropsHandler() {}

  FiberColorPickerPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.ColorPicker.height of type 'string | number':

    if (oldProps.height !== newProps.height) {
      updates.push({
        propertyName: "height",
        value: newProps.height,
        type: "string | number"
      });
    } // GUI.ColorPicker.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.ColorPicker.onValueChangedObservable of type 'BABYLON.Observable<BABYLON.Color3>/fn':


    if (oldProps.onValueChangedObservable === undefined && oldProps.onValueChangedObservable !== newProps.onValueChangedObservable) {
      updates.push({
        propertyName: "onValueChangedObservable",
        value: newProps.onValueChangedObservable,
        type: "BABYLON.Observable<BABYLON.Color3>"
      });
    } // GUI.ColorPicker.size of type 'string | number':


    if (oldProps.size !== newProps.size) {
      updates.push({
        propertyName: "size",
        value: newProps.size,
        type: "string | number"
      });
    } // TODO: type: BABYLON.Color3 property (not coded) GUI.ColorPicker.value.
    // GUI.ColorPicker.width of type 'string | number':


    if (oldProps.width !== newProps.width) {
      updates.push({
        propertyName: "width",
        value: newProps.width,
        type: "string | number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberColorPickerPropsHandler;
}();
/**
 * Class used to create color pickers
 *
 * This code has been generated
 */


var FiberColorPicker =
/** @class */
function () {
  function FiberColorPicker() {
    this.propsHandlers = [new FiberColorPickerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberColorPicker.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberColorPicker.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberColorPicker.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ColorPicker",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberColorPicker.Metadata = {
    isGUI2DControl: true,
    className: "FiberColorPicker"
  };
  return FiberColorPicker;
}();

var FiberContainerProps =
/** @class */
function (_super) {
  __extends(FiberContainerProps, _super);

  function FiberContainerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberContainerProps;
}(FiberControlProps);

var FiberContainerPropsHandler =
/** @class */
function () {
  function FiberContainerPropsHandler() {}

  FiberContainerPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Container.adaptHeightToChildren of type 'boolean':

    if (oldProps.adaptHeightToChildren !== newProps.adaptHeightToChildren) {
      updates.push({
        propertyName: "adaptHeightToChildren",
        value: newProps.adaptHeightToChildren,
        type: "boolean"
      });
    } // GUI.Container.adaptWidthToChildren of type 'boolean':


    if (oldProps.adaptWidthToChildren !== newProps.adaptWidthToChildren) {
      updates.push({
        propertyName: "adaptWidthToChildren",
        value: newProps.adaptWidthToChildren,
        type: "boolean"
      });
    } // GUI.Container.background of type 'string':


    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.Container.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberContainerPropsHandler;
}();
/**
 * Root class for 2D containers
 *
 * This code has been generated
 */


var FiberContainer =
/** @class */
function () {
  function FiberContainer() {
    this.propsHandlers = [new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberContainer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberContainer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberContainer.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Container",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberContainer.Metadata = {
    isGUI2DControl: true,
    className: "FiberContainer"
  };
  return FiberContainer;
}();

var FiberEllipseProps =
/** @class */
function (_super) {
  __extends(FiberEllipseProps, _super);

  function FiberEllipseProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberEllipseProps;
}(FiberContainerProps);

var FiberEllipsePropsHandler =
/** @class */
function () {
  function FiberEllipsePropsHandler() {}

  FiberEllipsePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Ellipse.name of type 'string':

    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Ellipse.thickness of type 'number':


    if (oldProps.thickness !== newProps.thickness) {
      updates.push({
        propertyName: "thickness",
        value: newProps.thickness,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberEllipsePropsHandler;
}();
/**
 * Class used to create 2D ellipse containers
 *
 * This code has been generated
 */


var FiberEllipse =
/** @class */
function () {
  function FiberEllipse() {
    this.propsHandlers = [new FiberEllipsePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberEllipse.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberEllipse.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberEllipse.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Ellipse",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberEllipse.Metadata = {
    isGUI2DControl: true,
    className: "FiberEllipse"
  };
  return FiberEllipse;
}();

var FiberGridProps =
/** @class */
function (_super) {
  __extends(FiberGridProps, _super);

  function FiberGridProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberGridProps;
}(FiberContainerProps);

var FiberGridPropsHandler =
/** @class */
function () {
  function FiberGridPropsHandler() {}

  FiberGridPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Grid.name of type 'string':

    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Grid.setColumnDefinition of type '(index?: number, width?: number, isPixel?: boolean)':


    if (oldProps.setColumnDefinition !== newProps.setColumnDefinition) {
      updates.push({
        propertyName: "setColumnDefinition",
        value: newProps.setColumnDefinition,
        type: "(index?: number, width?: number, isPixel?: boolean)"
      });
    } // GUI.Grid.setRowDefinition of type '(index?: number, height?: number, isPixel?: boolean)':


    if (oldProps.setRowDefinition !== newProps.setRowDefinition) {
      updates.push({
        propertyName: "setRowDefinition",
        value: newProps.setRowDefinition,
        type: "(index?: number, height?: number, isPixel?: boolean)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberGridPropsHandler;
}();
/**
 * Class used to create a 2D grid container
 *
 * This code has been generated
 */


var FiberGrid =
/** @class */
function () {
  function FiberGrid() {
    this.propsHandlers = [new FiberGridPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberGrid.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGrid.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGrid.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Grid",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberGrid.Metadata = {
    isGUI2DControl: true,
    className: "FiberGrid"
  };
  return FiberGrid;
}();

var FiberStackPanelProps =
/** @class */
function (_super) {
  __extends(FiberStackPanelProps, _super);

  function FiberStackPanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStackPanelProps;
}(FiberContainerProps);

var FiberStackPanelPropsHandler =
/** @class */
function () {
  function FiberStackPanelPropsHandler() {}

  FiberStackPanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.StackPanel.height of type 'string | number':

    if (oldProps.height !== newProps.height) {
      updates.push({
        propertyName: "height",
        value: newProps.height,
        type: "string | number"
      });
    } // GUI.StackPanel.isVertical of type 'boolean':


    if (oldProps.isVertical !== newProps.isVertical) {
      updates.push({
        propertyName: "isVertical",
        value: newProps.isVertical,
        type: "boolean"
      });
    } // GUI.StackPanel.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.StackPanel.width of type 'string | number':


    if (oldProps.width !== newProps.width) {
      updates.push({
        propertyName: "width",
        value: newProps.width,
        type: "string | number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberStackPanelPropsHandler;
}();
/**
 * Class used to create a 2D stack panel container
 *
 * This code has been generated
 */


var FiberStackPanel =
/** @class */
function () {
  function FiberStackPanel() {
    this.propsHandlers = [new FiberStackPanelPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberStackPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStackPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStackPanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StackPanel",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberStackPanel.Metadata = {
    isGUI2DControl: true,
    className: "FiberStackPanel"
  };
  return FiberStackPanel;
}();

var FiberVirtualKeyboardProps =
/** @class */
function (_super) {
  __extends(FiberVirtualKeyboardProps, _super);

  function FiberVirtualKeyboardProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVirtualKeyboardProps;
}(FiberStackPanelProps);

var FiberVirtualKeyboardPropsHandler =
/** @class */
function () {
  function FiberVirtualKeyboardPropsHandler() {}

  FiberVirtualKeyboardPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.VirtualKeyboard.defaultButtonBackground of type 'string':

    if (oldProps.defaultButtonBackground !== newProps.defaultButtonBackground) {
      updates.push({
        propertyName: "defaultButtonBackground",
        value: newProps.defaultButtonBackground,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonColor of type 'string':


    if (oldProps.defaultButtonColor !== newProps.defaultButtonColor) {
      updates.push({
        propertyName: "defaultButtonColor",
        value: newProps.defaultButtonColor,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonHeight of type 'string':


    if (oldProps.defaultButtonHeight !== newProps.defaultButtonHeight) {
      updates.push({
        propertyName: "defaultButtonHeight",
        value: newProps.defaultButtonHeight,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonPaddingBottom of type 'string':


    if (oldProps.defaultButtonPaddingBottom !== newProps.defaultButtonPaddingBottom) {
      updates.push({
        propertyName: "defaultButtonPaddingBottom",
        value: newProps.defaultButtonPaddingBottom,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonPaddingLeft of type 'string':


    if (oldProps.defaultButtonPaddingLeft !== newProps.defaultButtonPaddingLeft) {
      updates.push({
        propertyName: "defaultButtonPaddingLeft",
        value: newProps.defaultButtonPaddingLeft,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonPaddingRight of type 'string':


    if (oldProps.defaultButtonPaddingRight !== newProps.defaultButtonPaddingRight) {
      updates.push({
        propertyName: "defaultButtonPaddingRight",
        value: newProps.defaultButtonPaddingRight,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonPaddingTop of type 'string':


    if (oldProps.defaultButtonPaddingTop !== newProps.defaultButtonPaddingTop) {
      updates.push({
        propertyName: "defaultButtonPaddingTop",
        value: newProps.defaultButtonPaddingTop,
        type: "string"
      });
    } // GUI.VirtualKeyboard.defaultButtonWidth of type 'string':


    if (oldProps.defaultButtonWidth !== newProps.defaultButtonWidth) {
      updates.push({
        propertyName: "defaultButtonWidth",
        value: newProps.defaultButtonWidth,
        type: "string"
      });
    } // GUI.VirtualKeyboard.onKeyPressObservable of type 'BABYLON.Observable<string>/fn':


    if (oldProps.onKeyPressObservable === undefined && oldProps.onKeyPressObservable !== newProps.onKeyPressObservable) {
      updates.push({
        propertyName: "onKeyPressObservable",
        value: newProps.onKeyPressObservable,
        type: "BABYLON.Observable<string>"
      });
    } // GUI.VirtualKeyboard.selectedShiftThickness of type 'number':


    if (oldProps.selectedShiftThickness !== newProps.selectedShiftThickness) {
      updates.push({
        propertyName: "selectedShiftThickness",
        value: newProps.selectedShiftThickness,
        type: "number"
      });
    } // GUI.VirtualKeyboard.shiftButtonColor of type 'string':


    if (oldProps.shiftButtonColor !== newProps.shiftButtonColor) {
      updates.push({
        propertyName: "shiftButtonColor",
        value: newProps.shiftButtonColor,
        type: "string"
      });
    } // GUI.VirtualKeyboard.shiftState of type 'number':


    if (oldProps.shiftState !== newProps.shiftState) {
      updates.push({
        propertyName: "shiftState",
        value: newProps.shiftState,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberVirtualKeyboardPropsHandler;
}();
/**
 * Class used to create virtual keyboard
 *
 * This code has been generated
 */


var FiberVirtualKeyboard =
/** @class */
function () {
  function FiberVirtualKeyboard() {
    this.propsHandlers = [new FiberVirtualKeyboardPropsHandler(), new FiberStackPanelPropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberVirtualKeyboard.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVirtualKeyboard.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVirtualKeyboard.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VirtualKeyboard",
    namespace: "GUI",
    parameters: []
  };
  FiberVirtualKeyboard.Metadata = {
    isGUI2DControl: true,
    className: "FiberVirtualKeyboard"
  };
  return FiberVirtualKeyboard;
}();

var FiberRectangleProps =
/** @class */
function (_super) {
  __extends(FiberRectangleProps, _super);

  function FiberRectangleProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRectangleProps;
}(FiberContainerProps);

var FiberRectanglePropsHandler =
/** @class */
function () {
  function FiberRectanglePropsHandler() {}

  FiberRectanglePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Rectangle.cornerRadius of type 'number':

    if (oldProps.cornerRadius !== newProps.cornerRadius) {
      updates.push({
        propertyName: "cornerRadius",
        value: newProps.cornerRadius,
        type: "number"
      });
    } // GUI.Rectangle.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Rectangle.thickness of type 'number':


    if (oldProps.thickness !== newProps.thickness) {
      updates.push({
        propertyName: "thickness",
        value: newProps.thickness,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberRectanglePropsHandler;
}();
/**
 * Class used to create rectangle container
 *
 * This code has been generated
 */


var FiberRectangle =
/** @class */
function () {
  function FiberRectangle() {
    this.propsHandlers = [new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberRectangle.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRectangle.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRectangle.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Rectangle",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberRectangle.Metadata = {
    isGUI2DControl: true,
    className: "FiberRectangle"
  };
  return FiberRectangle;
}();

var FiberButtonProps =
/** @class */
function (_super) {
  __extends(FiberButtonProps, _super);

  function FiberButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberButtonProps;
}(FiberRectangleProps);

var FiberButtonPropsHandler =
/** @class */
function () {
  function FiberButtonPropsHandler() {}

  FiberButtonPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Button.name of type 'string':

    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // TODO: type: () => void property (not coded) GUI.Button.pointerDownAnimation.
    // TODO: type: () => void property (not coded) GUI.Button.pointerEnterAnimation.
    // TODO: type: () => void property (not coded) GUI.Button.pointerOutAnimation.
    // TODO: type: () => void property (not coded) GUI.Button.pointerUpAnimation.


    return updates.length == 0 ? null : updates;
  };

  return FiberButtonPropsHandler;
}();
/**
 * Class used to create 2D buttons
 *
 * This code has been generated
 */


var FiberButton =
/** @class */
function () {
  function FiberButton() {
    this.propsHandlers = [new FiberButtonPropsHandler(), new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberButton.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberButton.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberButton.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Button",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberButton.Metadata = {
    isGUI2DControl: true,
    className: "FiberButton"
  };
  return FiberButton;
}();

var FiberSelectionPanelProps =
/** @class */
function (_super) {
  __extends(FiberSelectionPanelProps, _super);

  function FiberSelectionPanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberSelectionPanelProps;
}(FiberRectangleProps);

var FiberSelectionPanelPropsHandler =
/** @class */
function () {
  function FiberSelectionPanelPropsHandler() {}

  FiberSelectionPanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.SelectionPanel.barColor of type 'string':

    if (oldProps.barColor !== newProps.barColor) {
      updates.push({
        propertyName: "barColor",
        value: newProps.barColor,
        type: "string"
      });
    } // GUI.SelectionPanel.barHeight of type 'string':


    if (oldProps.barHeight !== newProps.barHeight) {
      updates.push({
        propertyName: "barHeight",
        value: newProps.barHeight,
        type: "string"
      });
    } // GUI.SelectionPanel.buttonBackground of type 'string':


    if (oldProps.buttonBackground !== newProps.buttonBackground) {
      updates.push({
        propertyName: "buttonBackground",
        value: newProps.buttonBackground,
        type: "string"
      });
    } // GUI.SelectionPanel.buttonColor of type 'string':


    if (oldProps.buttonColor !== newProps.buttonColor) {
      updates.push({
        propertyName: "buttonColor",
        value: newProps.buttonColor,
        type: "string"
      });
    } // TODO: type: BABYLON.GUI.SelectorGroup[] property (not coded) GUI.SelectionPanel.groups.
    // GUI.SelectionPanel.headerColor of type 'string':


    if (oldProps.headerColor !== newProps.headerColor) {
      updates.push({
        propertyName: "headerColor",
        value: newProps.headerColor,
        type: "string"
      });
    } // GUI.SelectionPanel.labelColor of type 'string':


    if (oldProps.labelColor !== newProps.labelColor) {
      updates.push({
        propertyName: "labelColor",
        value: newProps.labelColor,
        type: "string"
      });
    } // GUI.SelectionPanel.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.SelectionPanel.spacerHeight of type 'string':


    if (oldProps.spacerHeight !== newProps.spacerHeight) {
      updates.push({
        propertyName: "spacerHeight",
        value: newProps.spacerHeight,
        type: "string"
      });
    } // GUI.SelectionPanel.setHeaderName of type '(label?: string, groupNb?: number)':


    if (oldProps.setHeaderName !== newProps.setHeaderName) {
      updates.push({
        propertyName: "setHeaderName",
        value: newProps.setHeaderName,
        type: "(label?: string, groupNb?: number)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberSelectionPanelPropsHandler;
}();
/**
 * Class used to hold the controls for the checkboxes, radio buttons and sliders
 *
 * This code has been generated
 */


var FiberSelectionPanel =
/** @class */
function () {
  function FiberSelectionPanel() {
    this.propsHandlers = [new FiberSelectionPanelPropsHandler(), new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberSelectionPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSelectionPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSelectionPanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "SelectionPanel",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "groups",
      type: "BABYLON.GUI.SelectorGroup[]",
      optional: true
    }]
  };
  FiberSelectionPanel.Metadata = {
    isGUI2DControl: true,
    className: "FiberSelectionPanel"
  };
  return FiberSelectionPanel;
}();

var FiberScrollViewerProps =
/** @class */
function (_super) {
  __extends(FiberScrollViewerProps, _super);

  function FiberScrollViewerProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberScrollViewerProps;
}(FiberRectangleProps);

var FiberScrollViewerPropsHandler =
/** @class */
function () {
  function FiberScrollViewerPropsHandler() {}

  FiberScrollViewerPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.ScrollViewer.barBackground of type 'string':

    if (oldProps.barBackground !== newProps.barBackground) {
      updates.push({
        propertyName: "barBackground",
        value: newProps.barBackground,
        type: "string"
      });
    } // GUI.ScrollViewer.barBorderColor of type 'string':


    if (oldProps.barBorderColor !== newProps.barBorderColor) {
      updates.push({
        propertyName: "barBorderColor",
        value: newProps.barBorderColor,
        type: "string"
      });
    } // GUI.ScrollViewer.barColor of type 'string':


    if (oldProps.barColor !== newProps.barColor) {
      updates.push({
        propertyName: "barColor",
        value: newProps.barColor,
        type: "string"
      });
    } // GUI.ScrollViewer.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.ScrollViewer.paddingBottom of type 'string | number':


    if (oldProps.paddingBottom !== newProps.paddingBottom) {
      updates.push({
        propertyName: "paddingBottom",
        value: newProps.paddingBottom,
        type: "string | number"
      });
    } // GUI.ScrollViewer.paddingLeft of type 'string | number':


    if (oldProps.paddingLeft !== newProps.paddingLeft) {
      updates.push({
        propertyName: "paddingLeft",
        value: newProps.paddingLeft,
        type: "string | number"
      });
    } // GUI.ScrollViewer.paddingRight of type 'string | number':


    if (oldProps.paddingRight !== newProps.paddingRight) {
      updates.push({
        propertyName: "paddingRight",
        value: newProps.paddingRight,
        type: "string | number"
      });
    } // GUI.ScrollViewer.paddingTop of type 'string | number':


    if (oldProps.paddingTop !== newProps.paddingTop) {
      updates.push({
        propertyName: "paddingTop",
        value: newProps.paddingTop,
        type: "string | number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberScrollViewerPropsHandler;
}();
/**
 * Class used to hold a viewer window and sliders in a grid
 *
 * This code has been generated
 */


var FiberScrollViewer =
/** @class */
function () {
  function FiberScrollViewer() {
    this.propsHandlers = [new FiberScrollViewerPropsHandler(), new FiberRectanglePropsHandler(), new FiberContainerPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberScrollViewer.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberScrollViewer.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberScrollViewer.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ScrollViewer",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberScrollViewer.Metadata = {
    isGUI2DControl: true,
    className: "FiberScrollViewer"
  };
  return FiberScrollViewer;
}();

var FiberImageProps =
/** @class */
function (_super) {
  __extends(FiberImageProps, _super);

  function FiberImageProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberImageProps;
}(FiberControlProps);

var FiberImagePropsHandler =
/** @class */
function () {
  function FiberImagePropsHandler() {}

  FiberImagePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Image.autoScale of type 'boolean':

    if (oldProps.autoScale !== newProps.autoScale) {
      updates.push({
        propertyName: "autoScale",
        value: newProps.autoScale,
        type: "boolean"
      });
    } // GUI.Image.cellHeight of type 'number':


    if (oldProps.cellHeight !== newProps.cellHeight) {
      updates.push({
        propertyName: "cellHeight",
        value: newProps.cellHeight,
        type: "number"
      });
    } // GUI.Image.cellId of type 'number':


    if (oldProps.cellId !== newProps.cellId) {
      updates.push({
        propertyName: "cellId",
        value: newProps.cellId,
        type: "number"
      });
    } // GUI.Image.cellWidth of type 'number':


    if (oldProps.cellWidth !== newProps.cellWidth) {
      updates.push({
        propertyName: "cellWidth",
        value: newProps.cellWidth,
        type: "number"
      });
    } // TODO: type: HTMLImageElement property (not coded) GUI.Image.domImage.
    // GUI.Image.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Image.onImageLoadedObservable of type 'BABYLON.Observable<BABYLON.GUI.Image>/fn':


    if (oldProps.onImageLoadedObservable === undefined && oldProps.onImageLoadedObservable !== newProps.onImageLoadedObservable) {
      updates.push({
        propertyName: "onImageLoadedObservable",
        value: newProps.onImageLoadedObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Image>"
      });
    } // GUI.Image.source of type 'string':


    if (oldProps.source !== newProps.source) {
      updates.push({
        propertyName: "source",
        value: newProps.source,
        type: "string"
      });
    } // GUI.Image.sourceHeight of type 'number':


    if (oldProps.sourceHeight !== newProps.sourceHeight) {
      updates.push({
        propertyName: "sourceHeight",
        value: newProps.sourceHeight,
        type: "number"
      });
    } // GUI.Image.sourceLeft of type 'number':


    if (oldProps.sourceLeft !== newProps.sourceLeft) {
      updates.push({
        propertyName: "sourceLeft",
        value: newProps.sourceLeft,
        type: "number"
      });
    } // GUI.Image.sourceTop of type 'number':


    if (oldProps.sourceTop !== newProps.sourceTop) {
      updates.push({
        propertyName: "sourceTop",
        value: newProps.sourceTop,
        type: "number"
      });
    } // GUI.Image.sourceWidth of type 'number':


    if (oldProps.sourceWidth !== newProps.sourceWidth) {
      updates.push({
        propertyName: "sourceWidth",
        value: newProps.sourceWidth,
        type: "number"
      });
    } // GUI.Image.stretch of type 'number':


    if (oldProps.stretch !== newProps.stretch) {
      updates.push({
        propertyName: "stretch",
        value: newProps.stretch,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberImagePropsHandler;
}();
/**
 * Class used to create 2D images
 *
 * This code has been generated
 */


var FiberImage =
/** @class */
function () {
  function FiberImage() {
    this.propsHandlers = [new FiberImagePropsHandler(), new FiberControlPropsHandler()];
  }

  FiberImage.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberImage.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberImage.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Image",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }, {
      name: "url",
      type: "string",
      optional: true
    }]
  };
  FiberImage.Metadata = {
    isGUI2DControl: true,
    className: "FiberImage"
  };
  return FiberImage;
}();

var FiberInputTextProps =
/** @class */
function (_super) {
  __extends(FiberInputTextProps, _super);

  function FiberInputTextProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberInputTextProps;
}(FiberControlProps);

var FiberInputTextPropsHandler =
/** @class */
function () {
  function FiberInputTextPropsHandler() {}

  FiberInputTextPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.InputText.addKey of type 'boolean':

    if (oldProps.addKey !== newProps.addKey) {
      updates.push({
        propertyName: "addKey",
        value: newProps.addKey,
        type: "boolean"
      });
    } // GUI.InputText.autoStretchWidth of type 'boolean':


    if (oldProps.autoStretchWidth !== newProps.autoStretchWidth) {
      updates.push({
        propertyName: "autoStretchWidth",
        value: newProps.autoStretchWidth,
        type: "boolean"
      });
    } // GUI.InputText.background of type 'string':


    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.InputText.currentKey of type 'string':


    if (oldProps.currentKey !== newProps.currentKey) {
      updates.push({
        propertyName: "currentKey",
        value: newProps.currentKey,
        type: "string"
      });
    } // GUI.InputText.deadKey of type 'boolean':


    if (oldProps.deadKey !== newProps.deadKey) {
      updates.push({
        propertyName: "deadKey",
        value: newProps.deadKey,
        type: "boolean"
      });
    } // GUI.InputText.focusedBackground of type 'string':


    if (oldProps.focusedBackground !== newProps.focusedBackground) {
      updates.push({
        propertyName: "focusedBackground",
        value: newProps.focusedBackground,
        type: "string"
      });
    } // GUI.InputText.highligherOpacity of type 'number':


    if (oldProps.highligherOpacity !== newProps.highligherOpacity) {
      updates.push({
        propertyName: "highligherOpacity",
        value: newProps.highligherOpacity,
        type: "number"
      });
    } // GUI.InputText.highlightedText of type 'string':


    if (oldProps.highlightedText !== newProps.highlightedText) {
      updates.push({
        propertyName: "highlightedText",
        value: newProps.highlightedText,
        type: "string"
      });
    } // GUI.InputText.margin of type 'string':


    if (oldProps.margin !== newProps.margin) {
      updates.push({
        propertyName: "margin",
        value: newProps.margin,
        type: "string"
      });
    } // GUI.InputText.maxWidth of type 'string | number':


    if (oldProps.maxWidth !== newProps.maxWidth) {
      updates.push({
        propertyName: "maxWidth",
        value: newProps.maxWidth,
        type: "string | number"
      });
    } // GUI.InputText.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.InputText.onBeforeKeyAddObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onBeforeKeyAddObservable === undefined && oldProps.onBeforeKeyAddObservable !== newProps.onBeforeKeyAddObservable) {
      updates.push({
        propertyName: "onBeforeKeyAddObservable",
        value: newProps.onBeforeKeyAddObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onBlurObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onBlurObservable === undefined && oldProps.onBlurObservable !== newProps.onBlurObservable) {
      updates.push({
        propertyName: "onBlurObservable",
        value: newProps.onBlurObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onFocusObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onFocusObservable === undefined && oldProps.onFocusObservable !== newProps.onFocusObservable) {
      updates.push({
        propertyName: "onFocusObservable",
        value: newProps.onFocusObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onFocusSelectAll of type 'boolean/fn':


    if (oldProps.onFocusSelectAll === undefined && oldProps.onFocusSelectAll !== newProps.onFocusSelectAll) {
      updates.push({
        propertyName: "onFocusSelectAll",
        value: newProps.onFocusSelectAll,
        type: "boolean"
      });
    } // GUI.InputText.onTextChangedObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onTextChangedObservable === undefined && oldProps.onTextChangedObservable !== newProps.onTextChangedObservable) {
      updates.push({
        propertyName: "onTextChangedObservable",
        value: newProps.onTextChangedObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onTextCopyObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onTextCopyObservable === undefined && oldProps.onTextCopyObservable !== newProps.onTextCopyObservable) {
      updates.push({
        propertyName: "onTextCopyObservable",
        value: newProps.onTextCopyObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onTextCutObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onTextCutObservable === undefined && oldProps.onTextCutObservable !== newProps.onTextCutObservable) {
      updates.push({
        propertyName: "onTextCutObservable",
        value: newProps.onTextCutObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onTextHighlightObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onTextHighlightObservable === undefined && oldProps.onTextHighlightObservable !== newProps.onTextHighlightObservable) {
      updates.push({
        propertyName: "onTextHighlightObservable",
        value: newProps.onTextHighlightObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.onTextPasteObservable of type 'BABYLON.Observable<BABYLON.GUI.InputText>/fn':


    if (oldProps.onTextPasteObservable === undefined && oldProps.onTextPasteObservable !== newProps.onTextPasteObservable) {
      updates.push({
        propertyName: "onTextPasteObservable",
        value: newProps.onTextPasteObservable,
        type: "BABYLON.Observable<BABYLON.GUI.InputText>"
      });
    } // GUI.InputText.placeholderColor of type 'string':


    if (oldProps.placeholderColor !== newProps.placeholderColor) {
      updates.push({
        propertyName: "placeholderColor",
        value: newProps.placeholderColor,
        type: "string"
      });
    } // GUI.InputText.placeholderText of type 'string':


    if (oldProps.placeholderText !== newProps.placeholderText) {
      updates.push({
        propertyName: "placeholderText",
        value: newProps.placeholderText,
        type: "string"
      });
    } // GUI.InputText.promptMessage of type 'string':


    if (oldProps.promptMessage !== newProps.promptMessage) {
      updates.push({
        propertyName: "promptMessage",
        value: newProps.promptMessage,
        type: "string"
      });
    } // GUI.InputText.text of type 'string':


    if (oldProps.text !== newProps.text) {
      updates.push({
        propertyName: "text",
        value: newProps.text,
        type: "string"
      });
    } // GUI.InputText.textHighlightColor of type 'string':


    if (oldProps.textHighlightColor !== newProps.textHighlightColor) {
      updates.push({
        propertyName: "textHighlightColor",
        value: newProps.textHighlightColor,
        type: "string"
      });
    } // GUI.InputText.thickness of type 'number':


    if (oldProps.thickness !== newProps.thickness) {
      updates.push({
        propertyName: "thickness",
        value: newProps.thickness,
        type: "number"
      });
    } // GUI.InputText.width of type 'string | number':


    if (oldProps.width !== newProps.width) {
      updates.push({
        propertyName: "width",
        value: newProps.width,
        type: "string | number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberInputTextPropsHandler;
}();
/**
 * Class used to create input text control
 *
 * This code has been generated
 */


var FiberInputText =
/** @class */
function () {
  function FiberInputText() {
    this.propsHandlers = [new FiberInputTextPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberInputText.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberInputText.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberInputText.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "InputText",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }, {
      name: "text",
      type: "string",
      optional: true
    }]
  };
  FiberInputText.Metadata = {
    isGUI2DControl: true,
    className: "FiberInputText"
  };
  return FiberInputText;
}();

var FiberInputPasswordProps =
/** @class */
function (_super) {
  __extends(FiberInputPasswordProps, _super);

  function FiberInputPasswordProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberInputPasswordProps;
}(FiberInputTextProps);

var FiberInputPasswordPropsHandler =
/** @class */
function () {
  function FiberInputPasswordPropsHandler() {}

  FiberInputPasswordPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberInputPasswordPropsHandler;
}();
/**
 * Class used to create a password control
 *
 * This code has been generated
 */


var FiberInputPassword =
/** @class */
function () {
  function FiberInputPassword() {
    this.propsHandlers = [new FiberInputPasswordPropsHandler(), new FiberInputTextPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberInputPassword.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberInputPassword.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberInputPassword.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "InputPassword",
    namespace: "GUI",
    parameters: []
  };
  FiberInputPassword.Metadata = {
    isGUI2DControl: true,
    className: "FiberInputPassword"
  };
  return FiberInputPassword;
}();

var FiberLineProps =
/** @class */
function (_super) {
  __extends(FiberLineProps, _super);

  function FiberLineProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberLineProps;
}(FiberControlProps);

var FiberLinePropsHandler =
/** @class */
function () {
  function FiberLinePropsHandler() {}

  FiberLinePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Line.connectedControl of GUIBABYLON.GUI.Control uses object equals to find diffs:

    if (newProps.connectedControl && !oldProps.connectedControl) {
      updates.push({
        propertyName: "connectedControl",
        value: newProps.connectedControl,
        type: "BABYLON.GUI.Control"
      });
    } // TODO: type: number[] property (not coded) GUI.Line.dash.
    // GUI.Line.horizontalAlignment of type 'number':


    if (oldProps.horizontalAlignment !== newProps.horizontalAlignment) {
      updates.push({
        propertyName: "horizontalAlignment",
        value: newProps.horizontalAlignment,
        type: "number"
      });
    } // GUI.Line.lineWidth of type 'number':


    if (oldProps.lineWidth !== newProps.lineWidth) {
      updates.push({
        propertyName: "lineWidth",
        value: newProps.lineWidth,
        type: "number"
      });
    } // GUI.Line.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Line.verticalAlignment of type 'number':


    if (oldProps.verticalAlignment !== newProps.verticalAlignment) {
      updates.push({
        propertyName: "verticalAlignment",
        value: newProps.verticalAlignment,
        type: "number"
      });
    } // GUI.Line.x1 of type 'string | number':


    if (oldProps.x1 !== newProps.x1) {
      updates.push({
        propertyName: "x1",
        value: newProps.x1,
        type: "string | number"
      });
    } // GUI.Line.x2 of type 'string | number':


    if (oldProps.x2 !== newProps.x2) {
      updates.push({
        propertyName: "x2",
        value: newProps.x2,
        type: "string | number"
      });
    } // GUI.Line.y1 of type 'string | number':


    if (oldProps.y1 !== newProps.y1) {
      updates.push({
        propertyName: "y1",
        value: newProps.y1,
        type: "string | number"
      });
    } // GUI.Line.y2 of type 'string | number':


    if (oldProps.y2 !== newProps.y2) {
      updates.push({
        propertyName: "y2",
        value: newProps.y2,
        type: "string | number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberLinePropsHandler;
}();
/**
 * Class used to render 2D lines
 *
 * This code has been generated
 */


var FiberLine =
/** @class */
function () {
  function FiberLine() {
    this.propsHandlers = [new FiberLinePropsHandler(), new FiberControlPropsHandler()];
  }

  FiberLine.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberLine.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberLine.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Line",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberLine.Metadata = {
    isGUI2DControl: true,
    className: "FiberLine"
  };
  return FiberLine;
}();

var FiberMultiLineProps =
/** @class */
function (_super) {
  __extends(FiberMultiLineProps, _super);

  function FiberMultiLineProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberMultiLineProps;
}(FiberControlProps);

var FiberMultiLinePropsHandler =
/** @class */
function () {
  function FiberMultiLinePropsHandler() {}

  FiberMultiLinePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: number[] property (not coded) GUI.MultiLine.dash.
    // GUI.MultiLine.horizontalAlignment of type 'number':

    if (oldProps.horizontalAlignment !== newProps.horizontalAlignment) {
      updates.push({
        propertyName: "horizontalAlignment",
        value: newProps.horizontalAlignment,
        type: "number"
      });
    } // GUI.MultiLine.lineWidth of type 'number':


    if (oldProps.lineWidth !== newProps.lineWidth) {
      updates.push({
        propertyName: "lineWidth",
        value: newProps.lineWidth,
        type: "number"
      });
    } // GUI.MultiLine.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.MultiLine.onPointUpdate of type '() => void/fn':


    if (oldProps.onPointUpdate === undefined && oldProps.onPointUpdate !== newProps.onPointUpdate) {
      updates.push({
        propertyName: "onPointUpdate",
        value: newProps.onPointUpdate,
        type: "() => void"
      });
    } // GUI.MultiLine.verticalAlignment of type 'number':


    if (oldProps.verticalAlignment !== newProps.verticalAlignment) {
      updates.push({
        propertyName: "verticalAlignment",
        value: newProps.verticalAlignment,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberMultiLinePropsHandler;
}();
/**
 * Class used to create multi line control
 *
 * This code has been generated
 */


var FiberMultiLine =
/** @class */
function () {
  function FiberMultiLine() {
    this.propsHandlers = [new FiberMultiLinePropsHandler(), new FiberControlPropsHandler()];
  }

  FiberMultiLine.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiLine.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiLine.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "MultiLine",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberMultiLine.Metadata = {
    isGUI2DControl: true,
    className: "FiberMultiLine"
  };
  return FiberMultiLine;
}();

var FiberRadioButtonProps =
/** @class */
function (_super) {
  __extends(FiberRadioButtonProps, _super);

  function FiberRadioButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRadioButtonProps;
}(FiberControlProps);

var FiberRadioButtonPropsHandler =
/** @class */
function () {
  function FiberRadioButtonPropsHandler() {}

  FiberRadioButtonPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.RadioButton.background of type 'string':

    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.RadioButton.checkSizeRatio of type 'number':


    if (oldProps.checkSizeRatio !== newProps.checkSizeRatio) {
      updates.push({
        propertyName: "checkSizeRatio",
        value: newProps.checkSizeRatio,
        type: "number"
      });
    } // GUI.RadioButton.group of type 'string':


    if (oldProps.group !== newProps.group) {
      updates.push({
        propertyName: "group",
        value: newProps.group,
        type: "string"
      });
    } // GUI.RadioButton.isChecked of type 'boolean':


    if (oldProps.isChecked !== newProps.isChecked) {
      updates.push({
        propertyName: "isChecked",
        value: newProps.isChecked,
        type: "boolean"
      });
    } // GUI.RadioButton.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.RadioButton.onIsCheckedChangedObservable of type 'BABYLON.Observable<boolean>/fn':


    if (oldProps.onIsCheckedChangedObservable === undefined && oldProps.onIsCheckedChangedObservable !== newProps.onIsCheckedChangedObservable) {
      updates.push({
        propertyName: "onIsCheckedChangedObservable",
        value: newProps.onIsCheckedChangedObservable,
        type: "BABYLON.Observable<boolean>"
      });
    } // GUI.RadioButton.thickness of type 'number':


    if (oldProps.thickness !== newProps.thickness) {
      updates.push({
        propertyName: "thickness",
        value: newProps.thickness,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberRadioButtonPropsHandler;
}();
/**
 * Class used to create radio button controls
 *
 * This code has been generated
 */


var FiberRadioButton =
/** @class */
function () {
  function FiberRadioButton() {
    this.propsHandlers = [new FiberRadioButtonPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberRadioButton.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRadioButton.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRadioButton.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "RadioButton",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberRadioButton.Metadata = {
    isGUI2DControl: true,
    className: "FiberRadioButton"
  };
  return FiberRadioButton;
}();

var FiberTextBlockProps =
/** @class */
function (_super) {
  __extends(FiberTextBlockProps, _super);

  function FiberTextBlockProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberTextBlockProps;
}(FiberControlProps);

var FiberTextBlockPropsHandler =
/** @class */
function () {
  function FiberTextBlockPropsHandler() {}

  FiberTextBlockPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.TextBlock.lineSpacing of type 'string | number':

    if (oldProps.lineSpacing !== newProps.lineSpacing) {
      updates.push({
        propertyName: "lineSpacing",
        value: newProps.lineSpacing,
        type: "string | number"
      });
    } // GUI.TextBlock.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.TextBlock.onLinesReadyObservable of type 'BABYLON.Observable<BABYLON.GUI.TextBlock>/fn':


    if (oldProps.onLinesReadyObservable === undefined && oldProps.onLinesReadyObservable !== newProps.onLinesReadyObservable) {
      updates.push({
        propertyName: "onLinesReadyObservable",
        value: newProps.onLinesReadyObservable,
        type: "BABYLON.Observable<BABYLON.GUI.TextBlock>"
      });
    } // GUI.TextBlock.onTextChangedObservable of type 'BABYLON.Observable<BABYLON.GUI.TextBlock>/fn':


    if (oldProps.onTextChangedObservable === undefined && oldProps.onTextChangedObservable !== newProps.onTextChangedObservable) {
      updates.push({
        propertyName: "onTextChangedObservable",
        value: newProps.onTextChangedObservable,
        type: "BABYLON.Observable<BABYLON.GUI.TextBlock>"
      });
    } // GUI.TextBlock.outlineColor of type 'string':


    if (oldProps.outlineColor !== newProps.outlineColor) {
      updates.push({
        propertyName: "outlineColor",
        value: newProps.outlineColor,
        type: "string"
      });
    } // GUI.TextBlock.outlineWidth of type 'number':


    if (oldProps.outlineWidth !== newProps.outlineWidth) {
      updates.push({
        propertyName: "outlineWidth",
        value: newProps.outlineWidth,
        type: "number"
      });
    } // GUI.TextBlock.resizeToFit of type 'boolean':


    if (oldProps.resizeToFit !== newProps.resizeToFit) {
      updates.push({
        propertyName: "resizeToFit",
        value: newProps.resizeToFit,
        type: "boolean"
      });
    } // GUI.TextBlock.text of type 'string':


    if (oldProps.text !== newProps.text) {
      updates.push({
        propertyName: "text",
        value: newProps.text,
        type: "string"
      });
    } // GUI.TextBlock.textHorizontalAlignment of type 'number':


    if (oldProps.textHorizontalAlignment !== newProps.textHorizontalAlignment) {
      updates.push({
        propertyName: "textHorizontalAlignment",
        value: newProps.textHorizontalAlignment,
        type: "number"
      });
    } // GUI.TextBlock.textVerticalAlignment of type 'number':


    if (oldProps.textVerticalAlignment !== newProps.textVerticalAlignment) {
      updates.push({
        propertyName: "textVerticalAlignment",
        value: newProps.textVerticalAlignment,
        type: "number"
      });
    } // TODO: type: boolean | BABYLON.GUI.TextWrapping property (not coded) GUI.TextBlock.textWrapping.


    return updates.length == 0 ? null : updates;
  };

  return FiberTextBlockPropsHandler;
}();
/**
 * Class used to create text block control
 *
 * This code has been generated
 */


var FiberTextBlock =
/** @class */
function () {
  function FiberTextBlock() {
    this.propsHandlers = [new FiberTextBlockPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberTextBlock.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTextBlock.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTextBlock.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "TextBlock",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }, {
      name: "text",
      type: "string",
      optional: true
    }]
  };
  FiberTextBlock.Metadata = {
    isGUI2DControl: true,
    className: "FiberTextBlock"
  };
  return FiberTextBlock;
}();

var FiberDisplayGridProps =
/** @class */
function (_super) {
  __extends(FiberDisplayGridProps, _super);

  function FiberDisplayGridProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberDisplayGridProps;
}(FiberControlProps);

var FiberDisplayGridPropsHandler =
/** @class */
function () {
  function FiberDisplayGridPropsHandler() {}

  FiberDisplayGridPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.DisplayGrid.background of type 'string':

    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.DisplayGrid.cellHeight of type 'number':


    if (oldProps.cellHeight !== newProps.cellHeight) {
      updates.push({
        propertyName: "cellHeight",
        value: newProps.cellHeight,
        type: "number"
      });
    } // GUI.DisplayGrid.cellWidth of type 'number':


    if (oldProps.cellWidth !== newProps.cellWidth) {
      updates.push({
        propertyName: "cellWidth",
        value: newProps.cellWidth,
        type: "number"
      });
    } // GUI.DisplayGrid.displayMajorLines of type 'boolean':


    if (oldProps.displayMajorLines !== newProps.displayMajorLines) {
      updates.push({
        propertyName: "displayMajorLines",
        value: newProps.displayMajorLines,
        type: "boolean"
      });
    } // GUI.DisplayGrid.displayMinorLines of type 'boolean':


    if (oldProps.displayMinorLines !== newProps.displayMinorLines) {
      updates.push({
        propertyName: "displayMinorLines",
        value: newProps.displayMinorLines,
        type: "boolean"
      });
    } // GUI.DisplayGrid.majorLineColor of type 'string':


    if (oldProps.majorLineColor !== newProps.majorLineColor) {
      updates.push({
        propertyName: "majorLineColor",
        value: newProps.majorLineColor,
        type: "string"
      });
    } // GUI.DisplayGrid.majorLineFrequency of type 'number':


    if (oldProps.majorLineFrequency !== newProps.majorLineFrequency) {
      updates.push({
        propertyName: "majorLineFrequency",
        value: newProps.majorLineFrequency,
        type: "number"
      });
    } // GUI.DisplayGrid.majorLineTickness of type 'number':


    if (oldProps.majorLineTickness !== newProps.majorLineTickness) {
      updates.push({
        propertyName: "majorLineTickness",
        value: newProps.majorLineTickness,
        type: "number"
      });
    } // GUI.DisplayGrid.minorLineColor of type 'string':


    if (oldProps.minorLineColor !== newProps.minorLineColor) {
      updates.push({
        propertyName: "minorLineColor",
        value: newProps.minorLineColor,
        type: "string"
      });
    } // GUI.DisplayGrid.minorLineTickness of type 'number':


    if (oldProps.minorLineTickness !== newProps.minorLineTickness) {
      updates.push({
        propertyName: "minorLineTickness",
        value: newProps.minorLineTickness,
        type: "number"
      });
    } // GUI.DisplayGrid.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberDisplayGridPropsHandler;
}();
/**
 * Class used to render a grid
 *
 * This code has been generated
 */


var FiberDisplayGrid =
/** @class */
function () {
  function FiberDisplayGrid() {
    this.propsHandlers = [new FiberDisplayGridPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberDisplayGrid.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDisplayGrid.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDisplayGrid.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "DisplayGrid",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberDisplayGrid.Metadata = {
    isGUI2DControl: true,
    className: "FiberDisplayGrid"
  };
  return FiberDisplayGrid;
}();

var FiberBaseSliderProps =
/** @class */
function (_super) {
  __extends(FiberBaseSliderProps, _super);

  function FiberBaseSliderProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberBaseSliderProps;
}(FiberControlProps);

var FiberBaseSliderPropsHandler =
/** @class */
function () {
  function FiberBaseSliderPropsHandler() {}

  FiberBaseSliderPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.BaseSlider.barOffset of type 'string | number':

    if (oldProps.barOffset !== newProps.barOffset) {
      updates.push({
        propertyName: "barOffset",
        value: newProps.barOffset,
        type: "string | number"
      });
    } // GUI.BaseSlider.displayThumb of type 'boolean':


    if (oldProps.displayThumb !== newProps.displayThumb) {
      updates.push({
        propertyName: "displayThumb",
        value: newProps.displayThumb,
        type: "boolean"
      });
    } // GUI.BaseSlider.isThumbClamped of type 'boolean':


    if (oldProps.isThumbClamped !== newProps.isThumbClamped) {
      updates.push({
        propertyName: "isThumbClamped",
        value: newProps.isThumbClamped,
        type: "boolean"
      });
    } // GUI.BaseSlider.isVertical of type 'boolean':


    if (oldProps.isVertical !== newProps.isVertical) {
      updates.push({
        propertyName: "isVertical",
        value: newProps.isVertical,
        type: "boolean"
      });
    } // GUI.BaseSlider.maximum of type 'number':


    if (oldProps.maximum !== newProps.maximum) {
      updates.push({
        propertyName: "maximum",
        value: newProps.maximum,
        type: "number"
      });
    } // GUI.BaseSlider.minimum of type 'number':


    if (oldProps.minimum !== newProps.minimum) {
      updates.push({
        propertyName: "minimum",
        value: newProps.minimum,
        type: "number"
      });
    } // GUI.BaseSlider.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.BaseSlider.onValueChangedObservable of type 'BABYLON.Observable<number>/fn':


    if (oldProps.onValueChangedObservable === undefined && oldProps.onValueChangedObservable !== newProps.onValueChangedObservable) {
      updates.push({
        propertyName: "onValueChangedObservable",
        value: newProps.onValueChangedObservable,
        type: "BABYLON.Observable<number>"
      });
    } // GUI.BaseSlider.thumbWidth of type 'string | number':


    if (oldProps.thumbWidth !== newProps.thumbWidth) {
      updates.push({
        propertyName: "thumbWidth",
        value: newProps.thumbWidth,
        type: "string | number"
      });
    } // GUI.BaseSlider.value of type 'number':


    if (oldProps.value !== newProps.value) {
      updates.push({
        propertyName: "value",
        value: newProps.value,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberBaseSliderPropsHandler;
}();
/**
 * Class used to create slider controls
 *
 * This code has been generated
 */


var FiberBaseSlider =
/** @class */
function () {
  function FiberBaseSlider() {
    this.propsHandlers = [new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberBaseSlider.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBaseSlider.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBaseSlider.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "BaseSlider",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberBaseSlider.Metadata = {
    isGUI2DControl: true,
    className: "FiberBaseSlider"
  };
  return FiberBaseSlider;
}();

var FiberSliderProps =
/** @class */
function (_super) {
  __extends(FiberSliderProps, _super);

  function FiberSliderProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberSliderProps;
}(FiberBaseSliderProps);

var FiberSliderPropsHandler =
/** @class */
function () {
  function FiberSliderPropsHandler() {}

  FiberSliderPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Slider.background of type 'string':

    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.Slider.borderColor of type 'string':


    if (oldProps.borderColor !== newProps.borderColor) {
      updates.push({
        propertyName: "borderColor",
        value: newProps.borderColor,
        type: "string"
      });
    } // GUI.Slider.isThumbCircle of type 'boolean':


    if (oldProps.isThumbCircle !== newProps.isThumbCircle) {
      updates.push({
        propertyName: "isThumbCircle",
        value: newProps.isThumbCircle,
        type: "boolean"
      });
    } // GUI.Slider.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberSliderPropsHandler;
}();
/**
 * Class used to create slider controls
 *
 * This code has been generated
 */


var FiberSlider =
/** @class */
function () {
  function FiberSlider() {
    this.propsHandlers = [new FiberSliderPropsHandler(), new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberSlider.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSlider.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSlider.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Slider",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberSlider.Metadata = {
    isGUI2DControl: true,
    className: "FiberSlider"
  };
  return FiberSlider;
}();

var FiberImageBasedSliderProps =
/** @class */
function (_super) {
  __extends(FiberImageBasedSliderProps, _super);

  function FiberImageBasedSliderProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberImageBasedSliderProps;
}(FiberBaseSliderProps);

var FiberImageBasedSliderPropsHandler =
/** @class */
function () {
  function FiberImageBasedSliderPropsHandler() {}

  FiberImageBasedSliderPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.GUI.Image property (not coded) GUI.ImageBasedSlider.backgroundImage.
    // GUI.ImageBasedSlider.displayThumb of type 'boolean':

    if (oldProps.displayThumb !== newProps.displayThumb) {
      updates.push({
        propertyName: "displayThumb",
        value: newProps.displayThumb,
        type: "boolean"
      });
    } // GUI.ImageBasedSlider.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // TODO: type: BABYLON.GUI.Image property (not coded) GUI.ImageBasedSlider.thumbImage.
    // TODO: type: BABYLON.GUI.Image property (not coded) GUI.ImageBasedSlider.valueBarImage.


    return updates.length == 0 ? null : updates;
  };

  return FiberImageBasedSliderPropsHandler;
}();
/**
 * Class used to create slider controls based on images
 *
 * This code has been generated
 */


var FiberImageBasedSlider =
/** @class */
function () {
  function FiberImageBasedSlider() {
    this.propsHandlers = [new FiberImageBasedSliderPropsHandler(), new FiberBaseSliderPropsHandler(), new FiberControlPropsHandler()];
  }

  FiberImageBasedSlider.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberImageBasedSlider.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberImageBasedSlider.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ImageBasedSlider",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberImageBasedSlider.Metadata = {
    isGUI2DControl: true,
    className: "FiberImageBasedSlider"
  };
  return FiberImageBasedSlider;
}();

var FiberControl3DProps =
/** @class */
function () {
  function FiberControl3DProps() {}

  return FiberControl3DProps;
}();

var FiberControl3DPropsHandler =
/** @class */
function () {
  function FiberControl3DPropsHandler() {}

  FiberControl3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Control3D.isVisible of type 'boolean':

    if (oldProps.isVisible !== newProps.isVisible) {
      updates.push({
        propertyName: "isVisible",
        value: newProps.isVisible,
        type: "boolean"
      });
    } // GUI.Control3D.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // GUI.Control3D.onPointerClickObservable of type 'BABYLON.Observable<BABYLON.GUI.Vector3WithInfo>/fn':


    if (oldProps.onPointerClickObservable === undefined && oldProps.onPointerClickObservable !== newProps.onPointerClickObservable) {
      updates.push({
        propertyName: "onPointerClickObservable",
        value: newProps.onPointerClickObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Vector3WithInfo>"
      });
    } // GUI.Control3D.onPointerDownObservable of type 'BABYLON.Observable<BABYLON.GUI.Vector3WithInfo>/fn':


    if (oldProps.onPointerDownObservable === undefined && oldProps.onPointerDownObservable !== newProps.onPointerDownObservable) {
      updates.push({
        propertyName: "onPointerDownObservable",
        value: newProps.onPointerDownObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Vector3WithInfo>"
      });
    } // GUI.Control3D.onPointerEnterObservable of type 'BABYLON.Observable<BABYLON.GUI.Control3D>/fn':


    if (oldProps.onPointerEnterObservable === undefined && oldProps.onPointerEnterObservable !== newProps.onPointerEnterObservable) {
      updates.push({
        propertyName: "onPointerEnterObservable",
        value: newProps.onPointerEnterObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control3D>"
      });
    } // GUI.Control3D.onPointerMoveObservable of type 'BABYLON.Observable<BABYLON.Vector3>/fn':


    if (oldProps.onPointerMoveObservable === undefined && oldProps.onPointerMoveObservable !== newProps.onPointerMoveObservable) {
      updates.push({
        propertyName: "onPointerMoveObservable",
        value: newProps.onPointerMoveObservable,
        type: "BABYLON.Observable<BABYLON.Vector3>"
      });
    } // GUI.Control3D.onPointerOutObservable of type 'BABYLON.Observable<BABYLON.GUI.Control3D>/fn':


    if (oldProps.onPointerOutObservable === undefined && oldProps.onPointerOutObservable !== newProps.onPointerOutObservable) {
      updates.push({
        propertyName: "onPointerOutObservable",
        value: newProps.onPointerOutObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control3D>"
      });
    } // GUI.Control3D.onPointerUpObservable of type 'BABYLON.Observable<BABYLON.GUI.Vector3WithInfo>/fn':


    if (oldProps.onPointerUpObservable === undefined && oldProps.onPointerUpObservable !== newProps.onPointerUpObservable) {
      updates.push({
        propertyName: "onPointerUpObservable",
        value: newProps.onPointerUpObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Vector3WithInfo>"
      });
    } // TODO: type: BABYLON.GUI.Container3D property (not coded) GUI.Control3D.parent.
    // TODO: type: () => void property (not coded) GUI.Control3D.pointerDownAnimation.
    // TODO: type: () => void property (not coded) GUI.Control3D.pointerEnterAnimation.
    // TODO: type: () => void property (not coded) GUI.Control3D.pointerOutAnimation.
    // TODO: type: () => void property (not coded) GUI.Control3D.pointerUpAnimation.
    // TODO: type: BABYLON.Vector3 property (not coded) GUI.Control3D.position.
    // TODO: type: BABYLON.Vector3 property (not coded) GUI.Control3D.scaling.


    return updates.length == 0 ? null : updates;
  };

  return FiberControl3DPropsHandler;
}();
/**
 * Class used as base class for controls
 *
 * This code has been generated
 */


var FiberControl3D =
/** @class */
function () {
  function FiberControl3D() {
    this.propsHandlers = [new FiberControl3DPropsHandler()];
  }

  FiberControl3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberControl3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberControl3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Control3D",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberControl3D.Metadata = {
    isGUI3DControl: true,
    className: "FiberControl3D"
  };
  return FiberControl3D;
}();

var FiberAbstractButton3DProps =
/** @class */
function (_super) {
  __extends(FiberAbstractButton3DProps, _super);

  function FiberAbstractButton3DProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAbstractButton3DProps;
}(FiberControl3DProps);

var FiberAbstractButton3DPropsHandler =
/** @class */
function () {
  function FiberAbstractButton3DPropsHandler() {}

  FiberAbstractButton3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberAbstractButton3DPropsHandler;
}();
/**
 * Class used as a root to all buttons
 *
 * This code has been generated
 */


var FiberAbstractButton3D =
/** @class */
function () {
  function FiberAbstractButton3D() {
    this.propsHandlers = [new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberAbstractButton3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAbstractButton3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAbstractButton3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AbstractButton3D",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberAbstractButton3D.Metadata = {
    isGUI3DControl: true,
    className: "FiberAbstractButton3D"
  };
  return FiberAbstractButton3D;
}();

var FiberButton3DProps =
/** @class */
function (_super) {
  __extends(FiberButton3DProps, _super);

  function FiberButton3DProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberButton3DProps;
}(FiberAbstractButton3DProps);

var FiberButton3DPropsHandler =
/** @class */
function () {
  function FiberButton3DPropsHandler() {}

  FiberButton3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Button3D.content of GUIBABYLON.GUI.Control uses object equals to find diffs:

    if (newProps.content && !oldProps.content) {
      updates.push({
        propertyName: "content",
        value: newProps.content,
        type: "BABYLON.GUI.Control"
      });
    } // GUI.Button3D.contentResolution of type 'number':


    if (oldProps.contentResolution !== newProps.contentResolution) {
      updates.push({
        propertyName: "contentResolution",
        value: newProps.contentResolution,
        type: "number"
      });
    } // GUI.Button3D.contentScaleRatio of type 'number':


    if (oldProps.contentScaleRatio !== newProps.contentScaleRatio) {
      updates.push({
        propertyName: "contentScaleRatio",
        value: newProps.contentScaleRatio,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberButton3DPropsHandler;
}();
/**
 * Class used to create a button in 3D
 *
 * This code has been generated
 */


var FiberButton3D =
/** @class */
function () {
  function FiberButton3D() {
    this.propsHandlers = [new FiberButton3DPropsHandler(), new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberButton3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberButton3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberButton3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Button3D",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberButton3D.Metadata = {
    isGUI3DControl: true,
    className: "FiberButton3D"
  };
  return FiberButton3D;
}();

var FiberHolographicButtonProps =
/** @class */
function (_super) {
  __extends(FiberHolographicButtonProps, _super);

  function FiberHolographicButtonProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberHolographicButtonProps;
}(FiberButton3DProps);

var FiberHolographicButtonPropsHandler =
/** @class */
function () {
  function FiberHolographicButtonPropsHandler() {}

  FiberHolographicButtonPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.HolographicButton.imageUrl of type 'string':

    if (oldProps.imageUrl !== newProps.imageUrl) {
      updates.push({
        propertyName: "imageUrl",
        value: newProps.imageUrl,
        type: "string"
      });
    } // GUI.HolographicButton.text of type 'string':


    if (oldProps.text !== newProps.text) {
      updates.push({
        propertyName: "text",
        value: newProps.text,
        type: "string"
      });
    } // GUI.HolographicButton.tooltipText of type 'string':


    if (oldProps.tooltipText !== newProps.tooltipText) {
      updates.push({
        propertyName: "tooltipText",
        value: newProps.tooltipText,
        type: "string"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberHolographicButtonPropsHandler;
}();
/**
 * Class used to create a holographic button in 3D
 *
 * This code has been generated
 */


var FiberHolographicButton =
/** @class */
function () {
  function FiberHolographicButton() {
    this.propsHandlers = [new FiberHolographicButtonPropsHandler(), new FiberButton3DPropsHandler(), new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberHolographicButton.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHolographicButton.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHolographicButton.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "HolographicButton",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }, {
      name: "shareMaterials",
      type: "boolean",
      optional: true
    }]
  };
  FiberHolographicButton.Metadata = {
    isGUI3DControl: true,
    className: "FiberHolographicButton"
  };
  return FiberHolographicButton;
}();

var FiberMeshButton3DProps =
/** @class */
function (_super) {
  __extends(FiberMeshButton3DProps, _super);

  function FiberMeshButton3DProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberMeshButton3DProps;
}(FiberButton3DProps);

var FiberMeshButton3DPropsHandler =
/** @class */
function () {
  function FiberMeshButton3DPropsHandler() {}

  FiberMeshButton3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberMeshButton3DPropsHandler;
}();
/**
 * Class used to create an interactable object. It's a 3D button using a mesh coming from the current scene
 *
 * This code has been generated
 */


var FiberMeshButton3D =
/** @class */
function () {
  function FiberMeshButton3D() {
    this.propsHandlers = [new FiberMeshButton3DPropsHandler(), new FiberButton3DPropsHandler(), new FiberAbstractButton3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberMeshButton3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMeshButton3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMeshButton3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "MeshButton3D",
    namespace: "GUI",
    parameters: [{
      name: "mesh",
      type: "BABYLON.Mesh",
      optional: false
    }, {
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberMeshButton3D.Metadata = {
    isGUI3DControl: true,
    className: "FiberMeshButton3D"
  };
  return FiberMeshButton3D;
}();

var FiberContainer3DProps =
/** @class */
function (_super) {
  __extends(FiberContainer3DProps, _super);

  function FiberContainer3DProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberContainer3DProps;
}(FiberControl3DProps);

var FiberContainer3DPropsHandler =
/** @class */
function () {
  function FiberContainer3DPropsHandler() {}

  FiberContainer3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.Container3D.blockLayout of type 'boolean':

    if (oldProps.blockLayout !== newProps.blockLayout) {
      updates.push({
        propertyName: "blockLayout",
        value: newProps.blockLayout,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberContainer3DPropsHandler;
}();
/**
 * Class used to create containers for controls
 *
 * This code has been generated
 */


var FiberContainer3D =
/** @class */
function () {
  function FiberContainer3D() {
    this.propsHandlers = [new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberContainer3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberContainer3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberContainer3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Container3D",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: true
    }]
  };
  FiberContainer3D.Metadata = {
    isGUI3DControl: true,
    className: "FiberContainer3D"
  };
  return FiberContainer3D;
}();

var FiberStackPanel3DProps =
/** @class */
function (_super) {
  __extends(FiberStackPanel3DProps, _super);

  function FiberStackPanel3DProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberStackPanel3DProps;
}(FiberContainer3DProps);

var FiberStackPanel3DPropsHandler =
/** @class */
function () {
  function FiberStackPanel3DPropsHandler() {}

  FiberStackPanel3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.StackPanel3D.isVertical of type 'boolean':

    if (oldProps.isVertical !== newProps.isVertical) {
      updates.push({
        propertyName: "isVertical",
        value: newProps.isVertical,
        type: "boolean"
      });
    } // GUI.StackPanel3D.margin of type 'number':


    if (oldProps.margin !== newProps.margin) {
      updates.push({
        propertyName: "margin",
        value: newProps.margin,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberStackPanel3DPropsHandler;
}();
/**
 * Class used to create a stack panel in 3D on XY plane
 *
 * This code has been generated
 */


var FiberStackPanel3D =
/** @class */
function () {
  function FiberStackPanel3D() {
    this.propsHandlers = [new FiberStackPanel3DPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberStackPanel3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberStackPanel3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberStackPanel3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "StackPanel3D",
    namespace: "GUI",
    parameters: [{
      name: "isVertical",
      type: "boolean",
      optional: true
    }]
  };
  FiberStackPanel3D.Metadata = {
    isGUI3DControl: true,
    className: "FiberStackPanel3D"
  };
  return FiberStackPanel3D;
}();

var FiberVolumeBasedPanelProps =
/** @class */
function (_super) {
  __extends(FiberVolumeBasedPanelProps, _super);

  function FiberVolumeBasedPanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVolumeBasedPanelProps;
}(FiberContainer3DProps);

var FiberVolumeBasedPanelPropsHandler =
/** @class */
function () {
  function FiberVolumeBasedPanelPropsHandler() {}

  FiberVolumeBasedPanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.VolumeBasedPanel.columns of type 'number':

    if (oldProps.columns !== newProps.columns) {
      updates.push({
        propertyName: "columns",
        value: newProps.columns,
        type: "number"
      });
    } // GUI.VolumeBasedPanel.margin of type 'number':


    if (oldProps.margin !== newProps.margin) {
      updates.push({
        propertyName: "margin",
        value: newProps.margin,
        type: "number"
      });
    } // GUI.VolumeBasedPanel.orientation of type 'number':


    if (oldProps.orientation !== newProps.orientation) {
      updates.push({
        propertyName: "orientation",
        value: newProps.orientation,
        type: "number"
      });
    } // GUI.VolumeBasedPanel.rows of type 'number':


    if (oldProps.rows !== newProps.rows) {
      updates.push({
        propertyName: "rows",
        value: newProps.rows,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberVolumeBasedPanelPropsHandler;
}();
/**
 * Abstract class used to create a container panel deployed on the surface of a volume
 *
 * This code has been generated
 */


var FiberVolumeBasedPanel =
/** @class */
function () {
  function FiberVolumeBasedPanel() {
    this.propsHandlers = [new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberVolumeBasedPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVolumeBasedPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVolumeBasedPanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VolumeBasedPanel",
    namespace: "GUI",
    parameters: []
  };
  FiberVolumeBasedPanel.Metadata = {
    isGUI3DControl: true,
    className: "FiberVolumeBasedPanel"
  };
  return FiberVolumeBasedPanel;
}();

var FiberCylinderPanelProps =
/** @class */
function (_super) {
  __extends(FiberCylinderPanelProps, _super);

  function FiberCylinderPanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberCylinderPanelProps;
}(FiberVolumeBasedPanelProps);

var FiberCylinderPanelPropsHandler =
/** @class */
function () {
  function FiberCylinderPanelPropsHandler() {}

  FiberCylinderPanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.CylinderPanel.radius of type 'number':

    if (oldProps.radius !== newProps.radius) {
      updates.push({
        propertyName: "radius",
        value: newProps.radius,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberCylinderPanelPropsHandler;
}();
/**
 * Class used to create a container panel deployed on the surface of a cylinder
 *
 * This code has been generated
 */


var FiberCylinderPanel =
/** @class */
function () {
  function FiberCylinderPanel() {
    this.propsHandlers = [new FiberCylinderPanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberCylinderPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCylinderPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCylinderPanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "CylinderPanel",
    namespace: "GUI",
    parameters: []
  };
  FiberCylinderPanel.Metadata = {
    isGUI3DControl: true,
    className: "FiberCylinderPanel"
  };
  return FiberCylinderPanel;
}();

var FiberPlanePanelProps =
/** @class */
function (_super) {
  __extends(FiberPlanePanelProps, _super);

  function FiberPlanePanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberPlanePanelProps;
}(FiberVolumeBasedPanelProps);

var FiberPlanePanelPropsHandler =
/** @class */
function () {
  function FiberPlanePanelPropsHandler() {}

  FiberPlanePanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberPlanePanelPropsHandler;
}();
/**
 * Class used to create a container panel deployed on the surface of a plane
 *
 * This code has been generated
 */


var FiberPlanePanel =
/** @class */
function () {
  function FiberPlanePanel() {
    this.propsHandlers = [new FiberPlanePanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberPlanePanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberPlanePanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberPlanePanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "PlanePanel",
    namespace: "GUI",
    parameters: []
  };
  FiberPlanePanel.Metadata = {
    isGUI3DControl: true,
    className: "FiberPlanePanel"
  };
  return FiberPlanePanel;
}();

var FiberScatterPanelProps =
/** @class */
function (_super) {
  __extends(FiberScatterPanelProps, _super);

  function FiberScatterPanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberScatterPanelProps;
}(FiberVolumeBasedPanelProps);

var FiberScatterPanelPropsHandler =
/** @class */
function () {
  function FiberScatterPanelPropsHandler() {}

  FiberScatterPanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.ScatterPanel.iteration of type 'number':

    if (oldProps.iteration !== newProps.iteration) {
      updates.push({
        propertyName: "iteration",
        value: newProps.iteration,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberScatterPanelPropsHandler;
}();
/**
 * Class used to create a container panel where items get randomized planar mapping
 *
 * This code has been generated
 */


var FiberScatterPanel =
/** @class */
function () {
  function FiberScatterPanel() {
    this.propsHandlers = [new FiberScatterPanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberScatterPanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberScatterPanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberScatterPanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ScatterPanel",
    namespace: "GUI",
    parameters: []
  };
  FiberScatterPanel.Metadata = {
    isGUI3DControl: true,
    className: "FiberScatterPanel"
  };
  return FiberScatterPanel;
}();

var FiberSpherePanelProps =
/** @class */
function (_super) {
  __extends(FiberSpherePanelProps, _super);

  function FiberSpherePanelProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberSpherePanelProps;
}(FiberVolumeBasedPanelProps);

var FiberSpherePanelPropsHandler =
/** @class */
function () {
  function FiberSpherePanelPropsHandler() {}

  FiberSpherePanelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.SpherePanel.radius of type 'number':

    if (oldProps.radius !== newProps.radius) {
      updates.push({
        propertyName: "radius",
        value: newProps.radius,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberSpherePanelPropsHandler;
}();
/**
 * Class used to create a container panel deployed on the surface of a sphere
 *
 * This code has been generated
 */


var FiberSpherePanel =
/** @class */
function () {
  function FiberSpherePanel() {
    this.propsHandlers = [new FiberSpherePanelPropsHandler(), new FiberVolumeBasedPanelPropsHandler(), new FiberContainer3DPropsHandler(), new FiberControl3DPropsHandler()];
  }

  FiberSpherePanel.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberSpherePanel.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberSpherePanel.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "SpherePanel",
    namespace: "GUI",
    parameters: []
  };
  FiberSpherePanel.Metadata = {
    isGUI3DControl: true,
    className: "FiberSpherePanel"
  };
  return FiberSpherePanel;
}();

var FiberBaseTextureProps =
/** @class */
function () {
  function FiberBaseTextureProps() {}

  return FiberBaseTextureProps;
}();

var FiberBaseTexturePropsHandler =
/** @class */
function () {
  function FiberBaseTexturePropsHandler() {}

  FiberBaseTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.Animation[] property (not coded) BABYLON.BaseTexture.animations.
    // BABYLON.BaseTexture.anisotropicFilteringLevel of type 'number':

    if (oldProps.anisotropicFilteringLevel !== newProps.anisotropicFilteringLevel) {
      updates.push({
        propertyName: "anisotropicFilteringLevel",
        value: newProps.anisotropicFilteringLevel,
        type: "number"
      });
    } // BABYLON.BaseTexture.coordinatesIndex of type 'number':


    if (oldProps.coordinatesIndex !== newProps.coordinatesIndex) {
      updates.push({
        propertyName: "coordinatesIndex",
        value: newProps.coordinatesIndex,
        type: "number"
      });
    } // BABYLON.BaseTexture.coordinatesMode of type 'number':


    if (oldProps.coordinatesMode !== newProps.coordinatesMode) {
      updates.push({
        propertyName: "coordinatesMode",
        value: newProps.coordinatesMode,
        type: "number"
      });
    } // BABYLON.BaseTexture.delayLoadState of type 'number':


    if (oldProps.delayLoadState !== newProps.delayLoadState) {
      updates.push({
        propertyName: "delayLoadState",
        value: newProps.delayLoadState,
        type: "number"
      });
    } // BABYLON.BaseTexture.gammaSpace of type 'boolean':


    if (oldProps.gammaSpace !== newProps.gammaSpace) {
      updates.push({
        propertyName: "gammaSpace",
        value: newProps.gammaSpace,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.getAlphaFromRGB of type 'boolean':


    if (oldProps.getAlphaFromRGB !== newProps.getAlphaFromRGB) {
      updates.push({
        propertyName: "getAlphaFromRGB",
        value: newProps.getAlphaFromRGB,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.hasAlpha of type 'boolean':


    if (oldProps.hasAlpha !== newProps.hasAlpha) {
      updates.push({
        propertyName: "hasAlpha",
        value: newProps.hasAlpha,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.invertZ of type 'boolean':


    if (oldProps.invertZ !== newProps.invertZ) {
      updates.push({
        propertyName: "invertZ",
        value: newProps.invertZ,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.is3D of type 'boolean':


    if (oldProps.is3D !== newProps.is3D) {
      updates.push({
        propertyName: "is3D",
        value: newProps.is3D,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.isCube of type 'boolean':


    if (oldProps.isCube !== newProps.isCube) {
      updates.push({
        propertyName: "isCube",
        value: newProps.isCube,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.isRenderTarget of type 'boolean':


    if (oldProps.isRenderTarget !== newProps.isRenderTarget) {
      updates.push({
        propertyName: "isRenderTarget",
        value: newProps.isRenderTarget,
        type: "boolean"
      });
    } // BABYLON.BaseTexture.level of type 'number':


    if (oldProps.level !== newProps.level) {
      updates.push({
        propertyName: "level",
        value: newProps.level,
        type: "number"
      });
    } // BABYLON.BaseTexture.lodGenerationOffset of type 'number':


    if (oldProps.lodGenerationOffset !== newProps.lodGenerationOffset) {
      updates.push({
        propertyName: "lodGenerationOffset",
        value: newProps.lodGenerationOffset,
        type: "number"
      });
    } // BABYLON.BaseTexture.lodGenerationScale of type 'number':


    if (oldProps.lodGenerationScale !== newProps.lodGenerationScale) {
      updates.push({
        propertyName: "lodGenerationScale",
        value: newProps.lodGenerationScale,
        type: "number"
      });
    } // BABYLON.BaseTexture.lodLevelInAlpha of type 'boolean':


    if (oldProps.lodLevelInAlpha !== newProps.lodLevelInAlpha) {
      updates.push({
        propertyName: "lodLevelInAlpha",
        value: newProps.lodLevelInAlpha,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.BaseTexture.metadata.
    // BABYLON.BaseTexture.name of type 'string':


    if (oldProps.name !== newProps.name) {
      updates.push({
        propertyName: "name",
        value: newProps.name,
        type: "string"
      });
    } // BABYLON.BaseTexture.onDispose of type '() => void/fn':


    if (oldProps.onDispose === undefined && oldProps.onDispose !== newProps.onDispose) {
      updates.push({
        propertyName: "onDispose",
        value: newProps.onDispose,
        type: "() => void"
      });
    } // BABYLON.BaseTexture.onDisposeObservable of type 'BABYLON.Observable<BABYLON.BaseTexture>/fn':


    if (oldProps.onDisposeObservable === undefined && oldProps.onDisposeObservable !== newProps.onDisposeObservable) {
      updates.push({
        propertyName: "onDisposeObservable",
        value: newProps.onDisposeObservable,
        type: "BABYLON.Observable<BABYLON.BaseTexture>"
      });
    } // TODO: type: any property (not coded) BABYLON.BaseTexture.reservedDataStore.
    // TODO: type: BABYLON.SphericalPolynomial property (not coded) BABYLON.BaseTexture.sphericalPolynomial.
    // BABYLON.BaseTexture.uniqueId of type 'number':


    if (oldProps.uniqueId !== newProps.uniqueId) {
      updates.push({
        propertyName: "uniqueId",
        value: newProps.uniqueId,
        type: "number"
      });
    } // BABYLON.BaseTexture.wrapR of type 'number':


    if (oldProps.wrapR !== newProps.wrapR) {
      updates.push({
        propertyName: "wrapR",
        value: newProps.wrapR,
        type: "number"
      });
    } // BABYLON.BaseTexture.wrapU of type 'number':


    if (oldProps.wrapU !== newProps.wrapU) {
      updates.push({
        propertyName: "wrapU",
        value: newProps.wrapU,
        type: "number"
      });
    } // BABYLON.BaseTexture.wrapV of type 'number':


    if (oldProps.wrapV !== newProps.wrapV) {
      updates.push({
        propertyName: "wrapV",
        value: newProps.wrapV,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberBaseTexturePropsHandler;
}();
/**
 * Base class of all the textures in babylon.
 * It groups all the common properties the materials, post process, lights... might need
 * in order to make a correct use of the texture.
 *
 * This code has been generated
 */


var FiberBaseTexture =
/** @class */
function () {
  function FiberBaseTexture() {
    this.propsHandlers = [new FiberBaseTexturePropsHandler()];
  }

  FiberBaseTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberBaseTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberBaseTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "BaseTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberBaseTexture.Metadata = {
    isTexture: true,
    className: "FiberBaseTexture"
  };
  return FiberBaseTexture;
}();

var FiberColorGradingTextureProps =
/** @class */
function (_super) {
  __extends(FiberColorGradingTextureProps, _super);

  function FiberColorGradingTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberColorGradingTextureProps;
}(FiberBaseTextureProps);

var FiberColorGradingTexturePropsHandler =
/** @class */
function () {
  function FiberColorGradingTexturePropsHandler() {}

  FiberColorGradingTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: any property (not coded) BABYLON.ColorGradingTexture.load3dlTexture.
    // TODO: type: any property (not coded) BABYLON.ColorGradingTexture.loadTexture.
    // BABYLON.ColorGradingTexture.url of type 'string':

    if (oldProps.url !== newProps.url) {
      updates.push({
        propertyName: "url",
        value: newProps.url,
        type: "string"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberColorGradingTexturePropsHandler;
}();
/**
 * This represents a color grading texture. This acts as a lookup table LUT, useful during post process
 * It can help converting any input color in a desired output one. This can then be used to create effects
 * from sepia, black and white to sixties or futuristic rendering...
 *
 * The only supported format is currently 3dl.
 * More information on LUT: https://en.wikipedia.org/wiki/3D_lookup_table
 *
 * This code has been generated
 */


var FiberColorGradingTexture =
/** @class */
function () {
  function FiberColorGradingTexture() {
    this.propsHandlers = [new FiberColorGradingTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberColorGradingTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberColorGradingTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberColorGradingTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ColorGradingTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "url",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberColorGradingTexture.Metadata = {
    isTexture: true,
    className: "FiberColorGradingTexture"
  };
  return FiberColorGradingTexture;
}();

var FiberCubeTextureProps =
/** @class */
function (_super) {
  __extends(FiberCubeTextureProps, _super);

  function FiberCubeTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberCubeTextureProps;
}(FiberBaseTextureProps);

var FiberCubeTexturePropsHandler =
/** @class */
function () {
  function FiberCubeTexturePropsHandler() {}

  FiberCubeTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.CubeTexture.boundingBoxPosition of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.boundingBoxPosition && (!oldProps.boundingBoxPosition || !oldProps.boundingBoxPosition.equals(newProps.boundingBoxPosition))) {
      updates.push({
        propertyName: "boundingBoxPosition",
        value: newProps.boundingBoxPosition,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.CubeTexture.boundingBoxSize of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.boundingBoxSize && (!oldProps.boundingBoxSize || !oldProps.boundingBoxSize.equals(newProps.boundingBoxSize))) {
      updates.push({
        propertyName: "boundingBoxSize",
        value: newProps.boundingBoxSize,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.CubeTexture.rotationY of type 'number':


    if (oldProps.rotationY !== newProps.rotationY) {
      updates.push({
        propertyName: "rotationY",
        value: newProps.rotationY,
        type: "number"
      });
    } // BABYLON.CubeTexture.url of type 'string':


    if (oldProps.url !== newProps.url) {
      updates.push({
        propertyName: "url",
        value: newProps.url,
        type: "string"
      });
    } // BABYLON.CubeTexture.setReflectionTextureMatrix of type '(value?: BABYLON.Matrix)':


    if (oldProps.setReflectionTextureMatrix !== newProps.setReflectionTextureMatrix) {
      updates.push({
        propertyName: "setReflectionTextureMatrix",
        value: newProps.setReflectionTextureMatrix,
        type: "(value?: BABYLON.Matrix)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberCubeTexturePropsHandler;
}();
/**
 * Class for creating a cube texture
 *
 * This code has been generated
 */


var FiberCubeTexture =
/** @class */
function () {
  function FiberCubeTexture() {
    this.propsHandlers = [new FiberCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCubeTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "CubeTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "rootUrl",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "extensions",
      type: "string[]",
      optional: true
    }, {
      name: "noMipmap",
      type: "boolean",
      optional: true
    }, {
      name: "files",
      type: "string[]",
      optional: true
    }, {
      name: "onLoad",
      type: "() => void",
      optional: true
    }, {
      name: "onError",
      type: "(message?: string, exception?: any) => void",
      optional: true
    }, {
      name: "format",
      type: "number",
      optional: true
    }, {
      name: "prefiltered",
      type: "boolean",
      optional: true
    }, {
      name: "forcedExtension",
      type: "any",
      optional: true
    }, {
      name: "createPolynomials",
      type: "boolean",
      optional: true
    }, {
      name: "lodScale",
      type: "number",
      optional: true
    }, {
      name: "lodOffset",
      type: "number",
      optional: true
    }]
  };
  FiberCubeTexture.Metadata = {
    isTexture: true,
    className: "FiberCubeTexture"
  };
  return FiberCubeTexture;
}();

var FiberRawCubeTextureProps =
/** @class */
function (_super) {
  __extends(FiberRawCubeTextureProps, _super);

  function FiberRawCubeTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRawCubeTextureProps;
}(FiberCubeTextureProps);

var FiberRawCubeTexturePropsHandler =
/** @class */
function () {
  function FiberRawCubeTexturePropsHandler() {}

  FiberRawCubeTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberRawCubeTexturePropsHandler;
}();
/**
 * Raw cube texture where the raw buffers are passed in
 *
 * This code has been generated
 */


var FiberRawCubeTexture =
/** @class */
function () {
  function FiberRawCubeTexture() {
    this.propsHandlers = [new FiberRawCubeTexturePropsHandler(), new FiberCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawCubeTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "RawCubeTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "data",
      type: "ArrayBufferView[]",
      optional: false
    }, {
      name: "size",
      type: "number",
      optional: false
    }, {
      name: "format",
      type: "number",
      optional: true
    }, {
      name: "type",
      type: "number",
      optional: true
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "invertY",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "compression",
      type: "string",
      optional: true
    }]
  };
  FiberRawCubeTexture.Metadata = {
    isTexture: true,
    className: "FiberRawCubeTexture"
  };
  return FiberRawCubeTexture;
}();

var FiberHDRCubeTextureProps =
/** @class */
function (_super) {
  __extends(FiberHDRCubeTextureProps, _super);

  function FiberHDRCubeTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberHDRCubeTextureProps;
}(FiberBaseTextureProps);

var FiberHDRCubeTexturePropsHandler =
/** @class */
function () {
  function FiberHDRCubeTexturePropsHandler() {}

  FiberHDRCubeTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.HDRCubeTexture.boundingBoxPosition of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.boundingBoxPosition && (!oldProps.boundingBoxPosition || !oldProps.boundingBoxPosition.equals(newProps.boundingBoxPosition))) {
      updates.push({
        propertyName: "boundingBoxPosition",
        value: newProps.boundingBoxPosition,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.HDRCubeTexture.boundingBoxSize of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.boundingBoxSize && (!oldProps.boundingBoxSize || !oldProps.boundingBoxSize.equals(newProps.boundingBoxSize))) {
      updates.push({
        propertyName: "boundingBoxSize",
        value: newProps.boundingBoxSize,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.HDRCubeTexture.coordinatesMode of type 'number':


    if (oldProps.coordinatesMode !== newProps.coordinatesMode) {
      updates.push({
        propertyName: "coordinatesMode",
        value: newProps.coordinatesMode,
        type: "number"
      });
    } // BABYLON.HDRCubeTexture.isBlocking of type 'boolean':


    if (oldProps.isBlocking !== newProps.isBlocking) {
      updates.push({
        propertyName: "isBlocking",
        value: newProps.isBlocking,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.HDRCubeTexture.loadTexture.
    // BABYLON.HDRCubeTexture.rotationY of type 'number':


    if (oldProps.rotationY !== newProps.rotationY) {
      updates.push({
        propertyName: "rotationY",
        value: newProps.rotationY,
        type: "number"
      });
    } // BABYLON.HDRCubeTexture.url of type 'string':


    if (oldProps.url !== newProps.url) {
      updates.push({
        propertyName: "url",
        value: newProps.url,
        type: "string"
      });
    } // BABYLON.HDRCubeTexture.setReflectionTextureMatrix of type '(value?: BABYLON.Matrix)':


    if (oldProps.setReflectionTextureMatrix !== newProps.setReflectionTextureMatrix) {
      updates.push({
        propertyName: "setReflectionTextureMatrix",
        value: newProps.setReflectionTextureMatrix,
        type: "(value?: BABYLON.Matrix)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberHDRCubeTexturePropsHandler;
}();
/**
 * This represents a texture coming from an HDR input.
 *
 * The only supported format is currently panorama picture stored in RGBE format.
 * Example of such files can be found on HDRLib: http://hdrlib.com/
 *
 * This code has been generated
 */


var FiberHDRCubeTexture =
/** @class */
function () {
  function FiberHDRCubeTexture() {
    this.propsHandlers = [new FiberHDRCubeTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberHDRCubeTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberHDRCubeTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberHDRCubeTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "HDRCubeTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "url",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "size",
      type: "number",
      optional: false
    }, {
      name: "noMipmap",
      type: "boolean",
      optional: true
    }, {
      name: "generateHarmonics",
      type: "boolean",
      optional: true
    }, {
      name: "gammaSpace",
      type: "boolean",
      optional: true
    }, {
      name: "reserved",
      type: "boolean",
      optional: true
    }, {
      name: "onLoad",
      type: "() => void",
      optional: true
    }, {
      name: "onError",
      type: "(message?: string, exception?: any) => void",
      optional: true
    }]
  };
  FiberHDRCubeTexture.Metadata = {
    isTexture: true,
    className: "FiberHDRCubeTexture"
  };
  return FiberHDRCubeTexture;
}();

var FiberTextureProps =
/** @class */
function (_super) {
  __extends(FiberTextureProps, _super);

  function FiberTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberTextureProps;
}(FiberBaseTextureProps);

var FiberTexturePropsHandler =
/** @class */
function () {
  function FiberTexturePropsHandler() {}

  FiberTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.Texture.isBlocking of type 'boolean':

    if (oldProps.isBlocking !== newProps.isBlocking) {
      updates.push({
        propertyName: "isBlocking",
        value: newProps.isBlocking,
        type: "boolean"
      });
    } // BABYLON.Texture.onLoadObservable of type 'BABYLON.Observable<BABYLON.Texture>/fn':


    if (oldProps.onLoadObservable === undefined && oldProps.onLoadObservable !== newProps.onLoadObservable) {
      updates.push({
        propertyName: "onLoadObservable",
        value: newProps.onLoadObservable,
        type: "BABYLON.Observable<BABYLON.Texture>"
      });
    } // BABYLON.Texture.uAng of type 'number':


    if (oldProps.uAng !== newProps.uAng) {
      updates.push({
        propertyName: "uAng",
        value: newProps.uAng,
        type: "number"
      });
    } // BABYLON.Texture.uOffset of type 'number':


    if (oldProps.uOffset !== newProps.uOffset) {
      updates.push({
        propertyName: "uOffset",
        value: newProps.uOffset,
        type: "number"
      });
    } // BABYLON.Texture.url of type 'string':


    if (oldProps.url !== newProps.url) {
      updates.push({
        propertyName: "url",
        value: newProps.url,
        type: "string"
      });
    } // BABYLON.Texture.uRotationCenter of type 'number':


    if (oldProps.uRotationCenter !== newProps.uRotationCenter) {
      updates.push({
        propertyName: "uRotationCenter",
        value: newProps.uRotationCenter,
        type: "number"
      });
    } // BABYLON.Texture.uScale of type 'number':


    if (oldProps.uScale !== newProps.uScale) {
      updates.push({
        propertyName: "uScale",
        value: newProps.uScale,
        type: "number"
      });
    } // BABYLON.Texture.vAng of type 'number':


    if (oldProps.vAng !== newProps.vAng) {
      updates.push({
        propertyName: "vAng",
        value: newProps.vAng,
        type: "number"
      });
    } // BABYLON.Texture.vOffset of type 'number':


    if (oldProps.vOffset !== newProps.vOffset) {
      updates.push({
        propertyName: "vOffset",
        value: newProps.vOffset,
        type: "number"
      });
    } // BABYLON.Texture.vRotationCenter of type 'number':


    if (oldProps.vRotationCenter !== newProps.vRotationCenter) {
      updates.push({
        propertyName: "vRotationCenter",
        value: newProps.vRotationCenter,
        type: "number"
      });
    } // BABYLON.Texture.vScale of type 'number':


    if (oldProps.vScale !== newProps.vScale) {
      updates.push({
        propertyName: "vScale",
        value: newProps.vScale,
        type: "number"
      });
    } // BABYLON.Texture.wAng of type 'number':


    if (oldProps.wAng !== newProps.wAng) {
      updates.push({
        propertyName: "wAng",
        value: newProps.wAng,
        type: "number"
      });
    } // BABYLON.Texture.wRotationCenter of type 'number':


    if (oldProps.wRotationCenter !== newProps.wRotationCenter) {
      updates.push({
        propertyName: "wRotationCenter",
        value: newProps.wRotationCenter,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberTexturePropsHandler;
}();
/**
 * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
 *
 * This code has been generated
 */


var FiberTexture =
/** @class */
function () {
  function FiberTexture() {
    this.propsHandlers = [new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "Texture",
    namespace: "BABYLON",
    parameters: [{
      name: "url",
      type: "string",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "noMipmap",
      type: "boolean",
      optional: true
    }, {
      name: "invertY",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "onLoad",
      type: "() => void",
      optional: true
    }, {
      name: "onError",
      type: "(message?: string, exception?: any) => void",
      optional: true
    }, {
      name: "buffer",
      type: "string | HTMLImageElement | ArrayBuffer | Blob",
      optional: true
    }, {
      name: "deleteBuffer",
      type: "boolean",
      optional: true
    }, {
      name: "format",
      type: "number",
      optional: true
    }]
  };
  FiberTexture.Metadata = {
    isTexture: true,
    className: "FiberTexture"
  };
  return FiberTexture;
}();

var FiberDynamicTextureProps =
/** @class */
function (_super) {
  __extends(FiberDynamicTextureProps, _super);

  function FiberDynamicTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberDynamicTextureProps;
}(FiberTextureProps);

var FiberDynamicTexturePropsHandler =
/** @class */
function () {
  function FiberDynamicTexturePropsHandler() {}

  FiberDynamicTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = [];
    return updates.length == 0 ? null : updates;
  };

  return FiberDynamicTexturePropsHandler;
}();
/**
 * A class extending Texture allowing drawing on a texture
 *
 * This code has been generated
 */


var FiberDynamicTexture =
/** @class */
function () {
  function FiberDynamicTexture() {
    this.propsHandlers = [new FiberDynamicTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberDynamicTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberDynamicTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberDynamicTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "DynamicTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "options",
      type: "any",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: false
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "format",
      type: "number",
      optional: true
    }]
  };
  FiberDynamicTexture.Metadata = {
    isTexture: true,
    className: "FiberDynamicTexture"
  };
  return FiberDynamicTexture;
}();

var FiberRawTextureProps =
/** @class */
function (_super) {
  __extends(FiberRawTextureProps, _super);

  function FiberRawTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRawTextureProps;
}(FiberTextureProps);

var FiberRawTexturePropsHandler =
/** @class */
function () {
  function FiberRawTexturePropsHandler() {}

  FiberRawTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.RawTexture.format of type 'number':

    if (oldProps.format !== newProps.format) {
      updates.push({
        propertyName: "format",
        value: newProps.format,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberRawTexturePropsHandler;
}();
/**
 * Raw texture can help creating a texture directly from an array of data.
 * This can be super useful if you either get the data from an uncompressed source or
 * if you wish to create your texture pixel by pixel.
 *
 * This code has been generated
 */


var FiberRawTexture =
/** @class */
function () {
  function FiberRawTexture() {
    this.propsHandlers = [new FiberRawTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "RawTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "data",
      type: "ArrayBufferView",
      optional: false
    }, {
      name: "width",
      type: "number",
      optional: false
    }, {
      name: "height",
      type: "number",
      optional: false
    }, {
      name: "format",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "invertY",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "type",
      type: "number",
      optional: true
    }]
  };
  FiberRawTexture.Metadata = {
    isTexture: true,
    className: "FiberRawTexture"
  };
  return FiberRawTexture;
}();

var FiberRawTexture3DProps =
/** @class */
function (_super) {
  __extends(FiberRawTexture3DProps, _super);

  function FiberRawTexture3DProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRawTexture3DProps;
}(FiberTextureProps);

var FiberRawTexture3DPropsHandler =
/** @class */
function () {
  function FiberRawTexture3DPropsHandler() {}

  FiberRawTexture3DPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.RawTexture3D.format of type 'number':

    if (oldProps.format !== newProps.format) {
      updates.push({
        propertyName: "format",
        value: newProps.format,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberRawTexture3DPropsHandler;
}();
/**
 * Class used to store 3D textures containing user data
 *
 * This code has been generated
 */


var FiberRawTexture3D =
/** @class */
function () {
  function FiberRawTexture3D() {
    this.propsHandlers = [new FiberRawTexture3DPropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRawTexture3D.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRawTexture3D.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRawTexture3D.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "RawTexture3D",
    namespace: "BABYLON",
    parameters: [{
      name: "data",
      type: "ArrayBufferView",
      optional: false
    }, {
      name: "width",
      type: "number",
      optional: false
    }, {
      name: "height",
      type: "number",
      optional: false
    }, {
      name: "depth",
      type: "number",
      optional: false
    }, {
      name: "format",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "invertY",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "textureType",
      type: "number",
      optional: true
    }]
  };
  FiberRawTexture3D.Metadata = {
    isTexture: true,
    className: "FiberRawTexture3D"
  };
  return FiberRawTexture3D;
}();

var FiberRenderTargetTextureProps =
/** @class */
function (_super) {
  __extends(FiberRenderTargetTextureProps, _super);

  function FiberRenderTargetTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRenderTargetTextureProps;
}(FiberTextureProps);

var FiberRenderTargetTexturePropsHandler =
/** @class */
function () {
  function FiberRenderTargetTexturePropsHandler() {}

  FiberRenderTargetTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.Camera property (not coded) BABYLON.RenderTargetTexture.activeCamera.
    // BABYLON.RenderTargetTexture.boundingBoxPosition of BABYLONBABYLON.Vector3 uses object equals to find diffs:

    if (newProps.boundingBoxPosition && (!oldProps.boundingBoxPosition || !oldProps.boundingBoxPosition.equals(newProps.boundingBoxPosition))) {
      updates.push({
        propertyName: "boundingBoxPosition",
        value: newProps.boundingBoxPosition,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.RenderTargetTexture.boundingBoxSize of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.boundingBoxSize && (!oldProps.boundingBoxSize || !oldProps.boundingBoxSize.equals(newProps.boundingBoxSize))) {
      updates.push({
        propertyName: "boundingBoxSize",
        value: newProps.boundingBoxSize,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: BABYLON.Color4 property (not coded) BABYLON.RenderTargetTexture.clearColor.
    // BABYLON.RenderTargetTexture.coordinatesMode of type 'number':


    if (oldProps.coordinatesMode !== newProps.coordinatesMode) {
      updates.push({
        propertyName: "coordinatesMode",
        value: newProps.coordinatesMode,
        type: "number"
      });
    } // TODO: type: (opaqueSubMeshes: BABYLON.SmartArray<BABYLON.SubMesh>, alphaTestSubMeshes: BABYLON.SmartArray<BABYLON.SubMesh>, transparentSubMeshes: BABYLON.SmartArray<BABYLON.SubMesh>, depthOnlySubMeshes: BABYLON.SmartArray<BABYLON.SubMesh>, beforeTransparents?: () => void) => void property (not coded) BABYLON.RenderTargetTexture.customRenderFunction.
    // TODO: type: BABYLON.InternalTexture property (not coded) BABYLON.RenderTargetTexture.depthStencilTexture.
    // BABYLON.RenderTargetTexture.ignoreCameraViewport of type 'boolean':


    if (oldProps.ignoreCameraViewport !== newProps.ignoreCameraViewport) {
      updates.push({
        propertyName: "ignoreCameraViewport",
        value: newProps.ignoreCameraViewport,
        type: "boolean"
      });
    } // BABYLON.RenderTargetTexture.isCube of type 'boolean':


    if (oldProps.isCube !== newProps.isCube) {
      updates.push({
        propertyName: "isCube",
        value: newProps.isCube,
        type: "boolean"
      });
    } // BABYLON.RenderTargetTexture.onAfterRender of type '(faceIndex: number) => void/fn':


    if (oldProps.onAfterRender === undefined && oldProps.onAfterRender !== newProps.onAfterRender) {
      updates.push({
        propertyName: "onAfterRender",
        value: newProps.onAfterRender,
        type: "(faceIndex: number) => void"
      });
    } // BABYLON.RenderTargetTexture.onAfterRenderObservable of type 'BABYLON.Observable<number>/fn':


    if (oldProps.onAfterRenderObservable === undefined && oldProps.onAfterRenderObservable !== newProps.onAfterRenderObservable) {
      updates.push({
        propertyName: "onAfterRenderObservable",
        value: newProps.onAfterRenderObservable,
        type: "BABYLON.Observable<number>"
      });
    } // BABYLON.RenderTargetTexture.onAfterUnbind of type '() => void/fn':


    if (oldProps.onAfterUnbind === undefined && oldProps.onAfterUnbind !== newProps.onAfterUnbind) {
      updates.push({
        propertyName: "onAfterUnbind",
        value: newProps.onAfterUnbind,
        type: "() => void"
      });
    } // BABYLON.RenderTargetTexture.onAfterUnbindObservable of type 'BABYLON.Observable<BABYLON.RenderTargetTexture>/fn':


    if (oldProps.onAfterUnbindObservable === undefined && oldProps.onAfterUnbindObservable !== newProps.onAfterUnbindObservable) {
      updates.push({
        propertyName: "onAfterUnbindObservable",
        value: newProps.onAfterUnbindObservable,
        type: "BABYLON.Observable<BABYLON.RenderTargetTexture>"
      });
    } // BABYLON.RenderTargetTexture.onBeforeBindObservable of type 'BABYLON.Observable<BABYLON.RenderTargetTexture>/fn':


    if (oldProps.onBeforeBindObservable === undefined && oldProps.onBeforeBindObservable !== newProps.onBeforeBindObservable) {
      updates.push({
        propertyName: "onBeforeBindObservable",
        value: newProps.onBeforeBindObservable,
        type: "BABYLON.Observable<BABYLON.RenderTargetTexture>"
      });
    } // BABYLON.RenderTargetTexture.onBeforeRender of type '(faceIndex: number) => void/fn':


    if (oldProps.onBeforeRender === undefined && oldProps.onBeforeRender !== newProps.onBeforeRender) {
      updates.push({
        propertyName: "onBeforeRender",
        value: newProps.onBeforeRender,
        type: "(faceIndex: number) => void"
      });
    } // BABYLON.RenderTargetTexture.onBeforeRenderObservable of type 'BABYLON.Observable<number>/fn':


    if (oldProps.onBeforeRenderObservable === undefined && oldProps.onBeforeRenderObservable !== newProps.onBeforeRenderObservable) {
      updates.push({
        propertyName: "onBeforeRenderObservable",
        value: newProps.onBeforeRenderObservable,
        type: "BABYLON.Observable<number>"
      });
    } // BABYLON.RenderTargetTexture.onClear of type '(Engine: BABYLON.Engine) => void/fn':


    if (oldProps.onClear === undefined && oldProps.onClear !== newProps.onClear) {
      updates.push({
        propertyName: "onClear",
        value: newProps.onClear,
        type: "(Engine: BABYLON.Engine) => void"
      });
    } // BABYLON.RenderTargetTexture.onClearObservable of type 'BABYLON.Observable<BABYLON.Engine>/fn':


    if (oldProps.onClearObservable === undefined && oldProps.onClearObservable !== newProps.onClearObservable) {
      updates.push({
        propertyName: "onClearObservable",
        value: newProps.onClearObservable,
        type: "BABYLON.Observable<BABYLON.Engine>"
      });
    } // BABYLON.RenderTargetTexture.refreshRate of type 'number':


    if (oldProps.refreshRate !== newProps.refreshRate) {
      updates.push({
        propertyName: "refreshRate",
        value: newProps.refreshRate,
        type: "number"
      });
    } // TODO: type: BABYLON.AbstractMesh[] property (not coded) BABYLON.RenderTargetTexture.renderList.
    // TODO: type: (AbstractMesh: BABYLON.AbstractMesh) => boolean property (not coded) BABYLON.RenderTargetTexture.renderListPredicate.
    // BABYLON.RenderTargetTexture.renderParticles of type 'boolean':


    if (oldProps.renderParticles !== newProps.renderParticles) {
      updates.push({
        propertyName: "renderParticles",
        value: newProps.renderParticles,
        type: "boolean"
      });
    } // BABYLON.RenderTargetTexture.renderSprites of type 'boolean':


    if (oldProps.renderSprites !== newProps.renderSprites) {
      updates.push({
        propertyName: "renderSprites",
        value: newProps.renderSprites,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.RenderTargetTexture.renderToTarget.
    // BABYLON.RenderTargetTexture.samples of type 'number':


    if (oldProps.samples !== newProps.samples) {
      updates.push({
        propertyName: "samples",
        value: newProps.samples,
        type: "number"
      });
    } // BABYLON.RenderTargetTexture.useCameraPostProcesses of type 'boolean':


    if (oldProps.useCameraPostProcesses !== newProps.useCameraPostProcesses) {
      updates.push({
        propertyName: "useCameraPostProcesses",
        value: newProps.useCameraPostProcesses,
        type: "boolean"
      });
    } // BABYLON.RenderTargetTexture.setRenderingAutoClearDepthStencil of type '(renderingGroupId?: number, autoClearDepthStencil?: boolean)':


    if (oldProps.setRenderingAutoClearDepthStencil !== newProps.setRenderingAutoClearDepthStencil) {
      updates.push({
        propertyName: "setRenderingAutoClearDepthStencil",
        value: newProps.setRenderingAutoClearDepthStencil,
        type: "(renderingGroupId?: number, autoClearDepthStencil?: boolean)"
      });
    } // BABYLON.RenderTargetTexture.setRenderingOrder of type '(renderingGroupId?: number, opaqueSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, alphaTestSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, transparentSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number)':


    if (oldProps.setRenderingOrder !== newProps.setRenderingOrder) {
      updates.push({
        propertyName: "setRenderingOrder",
        value: newProps.setRenderingOrder,
        type: "(renderingGroupId?: number, opaqueSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, alphaTestSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, transparentSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberRenderTargetTexturePropsHandler;
}();
/**
 * This Helps creating a texture that will be created from a camera in your scene.
 * It is basically a dynamic texture that could be used to create special effects for instance.
 * Actually, It is the base of lot of effects in the framework like post process, shadows, effect layers and rendering pipelines...
 *
 * This code has been generated
 */


var FiberRenderTargetTexture =
/** @class */
function () {
  function FiberRenderTargetTexture() {
    this.propsHandlers = [new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRenderTargetTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRenderTargetTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRenderTargetTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "RenderTargetTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "number | { width: number; height: number; } | { ratio: number; }",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "doNotChangeAspectRatio",
      type: "boolean",
      optional: true
    }, {
      name: "type",
      type: "number",
      optional: true
    }, {
      name: "isCube",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "generateDepthBuffer",
      type: "boolean",
      optional: true
    }, {
      name: "generateStencilBuffer",
      type: "boolean",
      optional: true
    }, {
      name: "isMulti",
      type: "boolean",
      optional: true
    }, {
      name: "format",
      type: "number",
      optional: true
    }, {
      name: "delayAllocation",
      type: "boolean",
      optional: true
    }]
  };
  FiberRenderTargetTexture.Metadata = {
    isTexture: true,
    className: "FiberRenderTargetTexture"
  };
  return FiberRenderTargetTexture;
}();

var FiberMirrorTextureProps =
/** @class */
function (_super) {
  __extends(FiberMirrorTextureProps, _super);

  function FiberMirrorTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberMirrorTextureProps;
}(FiberRenderTargetTextureProps);

var FiberMirrorTexturePropsHandler =
/** @class */
function () {
  function FiberMirrorTexturePropsHandler() {}

  FiberMirrorTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.MirrorTexture.adaptiveBlurKernel of type 'number':

    if (oldProps.adaptiveBlurKernel !== newProps.adaptiveBlurKernel) {
      updates.push({
        propertyName: "adaptiveBlurKernel",
        value: newProps.adaptiveBlurKernel,
        type: "number"
      });
    } // BABYLON.MirrorTexture.blurKernel of type 'number':


    if (oldProps.blurKernel !== newProps.blurKernel) {
      updates.push({
        propertyName: "blurKernel",
        value: newProps.blurKernel,
        type: "number"
      });
    } // BABYLON.MirrorTexture.blurKernelX of type 'number':


    if (oldProps.blurKernelX !== newProps.blurKernelX) {
      updates.push({
        propertyName: "blurKernelX",
        value: newProps.blurKernelX,
        type: "number"
      });
    } // BABYLON.MirrorTexture.blurKernelY of type 'number':


    if (oldProps.blurKernelY !== newProps.blurKernelY) {
      updates.push({
        propertyName: "blurKernelY",
        value: newProps.blurKernelY,
        type: "number"
      });
    } // BABYLON.MirrorTexture.blurRatio of type 'number':


    if (oldProps.blurRatio !== newProps.blurRatio) {
      updates.push({
        propertyName: "blurRatio",
        value: newProps.blurRatio,
        type: "number"
      });
    } // TODO: type: BABYLON.Plane property (not coded) BABYLON.MirrorTexture.mirrorPlane.
    // TODO: type: any property (not coded) BABYLON.MirrorTexture.scene.


    return updates.length == 0 ? null : updates;
  };

  return FiberMirrorTexturePropsHandler;
}();
/**
 * Mirror texture can be used to simulate the view from a mirror in a scene.
 * It will dynamically be rendered every frame to adapt to the camera point of view.
 * You can then easily use it as a reflectionTexture on a flat surface.
 * In case the surface is not a plane, please consider relying on reflection probes.
 *
 * This code has been generated
 */


var FiberMirrorTexture =
/** @class */
function () {
  function FiberMirrorTexture() {
    this.propsHandlers = [new FiberMirrorTexturePropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberMirrorTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMirrorTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMirrorTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "MirrorTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "number | { width: number; height: number; } | { ratio: number; }",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "type",
      type: "number",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "generateDepthBuffer",
      type: "boolean",
      optional: true
    }]
  };
  FiberMirrorTexture.Metadata = {
    isTexture: true,
    className: "FiberMirrorTexture"
  };
  return FiberMirrorTexture;
}();

var FiberMultiRenderTargetProps =
/** @class */
function (_super) {
  __extends(FiberMultiRenderTargetProps, _super);

  function FiberMultiRenderTargetProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberMultiRenderTargetProps;
}(FiberRenderTargetTextureProps);

var FiberMultiRenderTargetPropsHandler =
/** @class */
function () {
  function FiberMultiRenderTargetPropsHandler() {}

  FiberMultiRenderTargetPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.MultiRenderTarget.samples of type 'number':

    if (oldProps.samples !== newProps.samples) {
      updates.push({
        propertyName: "samples",
        value: newProps.samples,
        type: "number"
      });
    } // BABYLON.MultiRenderTarget.wrapU of type 'number':


    if (oldProps.wrapU !== newProps.wrapU) {
      updates.push({
        propertyName: "wrapU",
        value: newProps.wrapU,
        type: "number"
      });
    } // BABYLON.MultiRenderTarget.wrapV of type 'number':


    if (oldProps.wrapV !== newProps.wrapV) {
      updates.push({
        propertyName: "wrapV",
        value: newProps.wrapV,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberMultiRenderTargetPropsHandler;
}();
/**
 * A multi render target, like a render target provides the ability to render to a texture.
 * Unlike the render target, it can render to several draw buffers in one draw.
 * This is specially interesting in deferred rendering or for any effects requiring more than
 * just one color from a single pass.
 *
 * This code has been generated
 */


var FiberMultiRenderTarget =
/** @class */
function () {
  function FiberMultiRenderTarget() {
    this.propsHandlers = [new FiberMultiRenderTargetPropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberMultiRenderTarget.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberMultiRenderTarget.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberMultiRenderTarget.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "MultiRenderTarget",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "any",
      optional: false
    }, {
      name: "count",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "options",
      type: "BABYLON.IMultiRenderTargetOptions",
      optional: true
    }]
  };
  FiberMultiRenderTarget.Metadata = {
    isTexture: true,
    className: "FiberMultiRenderTarget"
  };
  return FiberMultiRenderTarget;
}();

var FiberRefractionTextureProps =
/** @class */
function (_super) {
  __extends(FiberRefractionTextureProps, _super);

  function FiberRefractionTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberRefractionTextureProps;
}(FiberRenderTargetTextureProps);

var FiberRefractionTexturePropsHandler =
/** @class */
function () {
  function FiberRefractionTexturePropsHandler() {}

  FiberRefractionTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.RefractionTexture.depth of type 'number':

    if (oldProps.depth !== newProps.depth) {
      updates.push({
        propertyName: "depth",
        value: newProps.depth,
        type: "number"
      });
    } // TODO: type: BABYLON.Plane property (not coded) BABYLON.RefractionTexture.refractionPlane.


    return updates.length == 0 ? null : updates;
  };

  return FiberRefractionTexturePropsHandler;
}();
/**
 * Creates a refraction texture used by refraction channel of the standard material.
 * It is like a mirror but to see through a material.
 *
 * This code has been generated
 */


var FiberRefractionTexture =
/** @class */
function () {
  function FiberRefractionTexture() {
    this.propsHandlers = [new FiberRefractionTexturePropsHandler(), new FiberRenderTargetTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberRefractionTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberRefractionTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberRefractionTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "RefractionTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }]
  };
  FiberRefractionTexture.Metadata = {
    isTexture: true,
    className: "FiberRefractionTexture"
  };
  return FiberRefractionTexture;
}();

var FiberVideoTextureProps =
/** @class */
function (_super) {
  __extends(FiberVideoTextureProps, _super);

  function FiberVideoTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberVideoTextureProps;
}(FiberTextureProps);

var FiberVideoTexturePropsHandler =
/** @class */
function () {
  function FiberVideoTexturePropsHandler() {}

  FiberVideoTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: any property (not coded) BABYLON.VideoTexture.reset.

    return updates.length == 0 ? null : updates;
  };

  return FiberVideoTexturePropsHandler;
}();
/**
 * If you want to display a video in your scene, this is the special texture for that.
 * This special texture works similar to other textures, with the exception of a few parameters.
 *
 * This code has been generated
 */


var FiberVideoTexture =
/** @class */
function () {
  function FiberVideoTexture() {
    this.propsHandlers = [new FiberVideoTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberVideoTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVideoTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVideoTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VideoTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "src",
      type: "string | string[] | HTMLVideoElement",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "invertY",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }, {
      name: "settings",
      type: "BABYLON.VideoTextureSettings",
      optional: true
    }]
  };
  FiberVideoTexture.Metadata = {
    isTexture: true,
    className: "FiberVideoTexture"
  };
  return FiberVideoTexture;
}();

var FiberProceduralTextureProps =
/** @class */
function (_super) {
  __extends(FiberProceduralTextureProps, _super);

  function FiberProceduralTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberProceduralTextureProps;
}(FiberTextureProps);

var FiberProceduralTexturePropsHandler =
/** @class */
function () {
  function FiberProceduralTexturePropsHandler() {}

  FiberProceduralTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.ProceduralTexture.autoClear of type 'boolean':

    if (oldProps.autoClear !== newProps.autoClear) {
      updates.push({
        propertyName: "autoClear",
        value: newProps.autoClear,
        type: "boolean"
      });
    } // BABYLON.ProceduralTexture.isCube of type 'boolean':


    if (oldProps.isCube !== newProps.isCube) {
      updates.push({
        propertyName: "isCube",
        value: newProps.isCube,
        type: "boolean"
      });
    } // BABYLON.ProceduralTexture.isEnabled of type 'boolean':


    if (oldProps.isEnabled !== newProps.isEnabled) {
      updates.push({
        propertyName: "isEnabled",
        value: newProps.isEnabled,
        type: "boolean"
      });
    } // BABYLON.ProceduralTexture.onGenerated of type '() => void/fn':


    if (oldProps.onGenerated === undefined && oldProps.onGenerated !== newProps.onGenerated) {
      updates.push({
        propertyName: "onGenerated",
        value: newProps.onGenerated,
        type: "() => void"
      });
    } // BABYLON.ProceduralTexture.onGeneratedObservable of type 'BABYLON.Observable<BABYLON.ProceduralTexture>/fn':


    if (oldProps.onGeneratedObservable === undefined && oldProps.onGeneratedObservable !== newProps.onGeneratedObservable) {
      updates.push({
        propertyName: "onGeneratedObservable",
        value: newProps.onGeneratedObservable,
        type: "BABYLON.Observable<BABYLON.ProceduralTexture>"
      });
    } // BABYLON.ProceduralTexture.refreshRate of type 'number':


    if (oldProps.refreshRate !== newProps.refreshRate) {
      updates.push({
        propertyName: "refreshRate",
        value: newProps.refreshRate,
        type: "number"
      });
    } // BABYLON.ProceduralTexture.setColor3 of type '(name?: string, value?: BABYLON.Color3)':


    if (oldProps.setColor3 !== newProps.setColor3) {
      updates.push({
        propertyName: "setColor3",
        value: newProps.setColor3,
        type: "(name?: string, value?: BABYLON.Color3)"
      });
    } // BABYLON.ProceduralTexture.setColor4 of type '(name?: string, value?: BABYLON.Color4)':


    if (oldProps.setColor4 !== newProps.setColor4) {
      updates.push({
        propertyName: "setColor4",
        value: newProps.setColor4,
        type: "(name?: string, value?: BABYLON.Color4)"
      });
    } // BABYLON.ProceduralTexture.setFloat of type '(name?: string, value?: number)':


    if (oldProps.setFloat !== newProps.setFloat) {
      updates.push({
        propertyName: "setFloat",
        value: newProps.setFloat,
        type: "(name?: string, value?: number)"
      });
    } // BABYLON.ProceduralTexture.setFloats of type '(name?: string, value?: number[])':


    if (oldProps.setFloats !== newProps.setFloats) {
      updates.push({
        propertyName: "setFloats",
        value: newProps.setFloats,
        type: "(name?: string, value?: number[])"
      });
    } // BABYLON.ProceduralTexture.setFragment of type '(fragment?: any)':


    if (oldProps.setFragment !== newProps.setFragment) {
      updates.push({
        propertyName: "setFragment",
        value: newProps.setFragment,
        type: "(fragment?: any)"
      });
    } // BABYLON.ProceduralTexture.setInt of type '(name?: string, value?: number)':


    if (oldProps.setInt !== newProps.setInt) {
      updates.push({
        propertyName: "setInt",
        value: newProps.setInt,
        type: "(name?: string, value?: number)"
      });
    } // BABYLON.ProceduralTexture.setMatrix of type '(name?: string, value?: BABYLON.Matrix)':


    if (oldProps.setMatrix !== newProps.setMatrix) {
      updates.push({
        propertyName: "setMatrix",
        value: newProps.setMatrix,
        type: "(name?: string, value?: BABYLON.Matrix)"
      });
    } // BABYLON.ProceduralTexture.setTexture of type '(name?: string, texture?: BABYLON.Texture)':


    if (oldProps.setTexture !== newProps.setTexture) {
      updates.push({
        propertyName: "setTexture",
        value: newProps.setTexture,
        type: "(name?: string, texture?: BABYLON.Texture)"
      });
    } // BABYLON.ProceduralTexture.setVector2 of type '(name?: string, value?: BABYLON.Vector2)':


    if (oldProps.setVector2 !== newProps.setVector2) {
      updates.push({
        propertyName: "setVector2",
        value: newProps.setVector2,
        type: "(name?: string, value?: BABYLON.Vector2)"
      });
    } // BABYLON.ProceduralTexture.setVector3 of type '(name?: string, value?: BABYLON.Vector3)':


    if (oldProps.setVector3 !== newProps.setVector3) {
      updates.push({
        propertyName: "setVector3",
        value: newProps.setVector3,
        type: "(name?: string, value?: BABYLON.Vector3)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberProceduralTexturePropsHandler;
}();
/**
 * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes called 'refMaps' or 'sampler' images.
 * This is the base class of any Procedural texture and contains most of the shareable code.
 *
 * This code has been generated
 */


var FiberProceduralTexture =
/** @class */
function () {
  function FiberProceduralTexture() {
    this.propsHandlers = [new FiberProceduralTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberProceduralTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberProceduralTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberProceduralTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ProceduralTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "any",
      optional: false
    }, {
      name: "fragment",
      type: "any",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "fallbackTexture",
      type: "BABYLON.Texture",
      optional: true
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "isCube",
      type: "boolean",
      optional: true
    }]
  };
  FiberProceduralTexture.Metadata = {
    isTexture: true,
    className: "FiberProceduralTexture"
  };
  return FiberProceduralTexture;
}();

var FiberCustomProceduralTextureProps =
/** @class */
function (_super) {
  __extends(FiberCustomProceduralTextureProps, _super);

  function FiberCustomProceduralTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberCustomProceduralTextureProps;
}(FiberProceduralTextureProps);

var FiberCustomProceduralTexturePropsHandler =
/** @class */
function () {
  function FiberCustomProceduralTexturePropsHandler() {}

  FiberCustomProceduralTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.CustomProceduralTexture.animate of type 'boolean':

    if (oldProps.animate !== newProps.animate) {
      updates.push({
        propertyName: "animate",
        value: newProps.animate,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberCustomProceduralTexturePropsHandler;
}();
/**
 * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes called 'refMaps' or 'sampler' images.
 * Custom Procedural textures are the easiest way to create your own procedural in your application.
 *
 * This code has been generated
 */


var FiberCustomProceduralTexture =
/** @class */
function () {
  function FiberCustomProceduralTexture() {
    this.propsHandlers = [new FiberCustomProceduralTexturePropsHandler(), new FiberProceduralTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberCustomProceduralTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberCustomProceduralTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberCustomProceduralTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "CustomProceduralTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "texturePath",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "fallbackTexture",
      type: "BABYLON.Texture",
      optional: true
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }]
  };
  FiberCustomProceduralTexture.Metadata = {
    isTexture: true,
    className: "FiberCustomProceduralTexture"
  };
  return FiberCustomProceduralTexture;
}();

var FiberNoiseProceduralTextureProps =
/** @class */
function (_super) {
  __extends(FiberNoiseProceduralTextureProps, _super);

  function FiberNoiseProceduralTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberNoiseProceduralTextureProps;
}(FiberProceduralTextureProps);

var FiberNoiseProceduralTexturePropsHandler =
/** @class */
function () {
  function FiberNoiseProceduralTexturePropsHandler() {}

  FiberNoiseProceduralTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.NoiseProceduralTexture.animationSpeedFactor of type 'number':

    if (oldProps.animationSpeedFactor !== newProps.animationSpeedFactor) {
      updates.push({
        propertyName: "animationSpeedFactor",
        value: newProps.animationSpeedFactor,
        type: "number"
      });
    } // BABYLON.NoiseProceduralTexture.brightness of type 'number':


    if (oldProps.brightness !== newProps.brightness) {
      updates.push({
        propertyName: "brightness",
        value: newProps.brightness,
        type: "number"
      });
    } // BABYLON.NoiseProceduralTexture.octaves of type 'number':


    if (oldProps.octaves !== newProps.octaves) {
      updates.push({
        propertyName: "octaves",
        value: newProps.octaves,
        type: "number"
      });
    } // BABYLON.NoiseProceduralTexture.persistence of type 'number':


    if (oldProps.persistence !== newProps.persistence) {
      updates.push({
        propertyName: "persistence",
        value: newProps.persistence,
        type: "number"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberNoiseProceduralTexturePropsHandler;
}();
/**
 * Class used to generate noise procedural textures
 *
 * This code has been generated
 */


var FiberNoiseProceduralTexture =
/** @class */
function () {
  function FiberNoiseProceduralTexture() {
    this.propsHandlers = [new FiberNoiseProceduralTexturePropsHandler(), new FiberProceduralTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberNoiseProceduralTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberNoiseProceduralTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberNoiseProceduralTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "NoiseProceduralTexture",
    namespace: "BABYLON",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "size",
      type: "number",
      optional: true
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }, {
      name: "fallbackTexture",
      type: "BABYLON.Texture",
      optional: true
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }]
  };
  FiberNoiseProceduralTexture.Metadata = {
    isTexture: true,
    className: "FiberNoiseProceduralTexture"
  };
  return FiberNoiseProceduralTexture;
}();

var FiberAdvancedDynamicTextureProps =
/** @class */
function (_super) {
  __extends(FiberAdvancedDynamicTextureProps, _super);

  function FiberAdvancedDynamicTextureProps() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return FiberAdvancedDynamicTextureProps;
}(FiberDynamicTextureProps);

var FiberAdvancedDynamicTexturePropsHandler =
/** @class */
function () {
  function FiberAdvancedDynamicTexturePropsHandler() {}

  FiberAdvancedDynamicTexturePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.AdvancedDynamicTexture.background of type 'string':

    if (oldProps.background !== newProps.background) {
      updates.push({
        propertyName: "background",
        value: newProps.background,
        type: "string"
      });
    } // GUI.AdvancedDynamicTexture.clipboardData of type 'string':


    if (oldProps.clipboardData !== newProps.clipboardData) {
      updates.push({
        propertyName: "clipboardData",
        value: newProps.clipboardData,
        type: "string"
      });
    } // TODO: type: BABYLON.GUI.IFocusableControl property (not coded) GUI.AdvancedDynamicTexture.focusedControl.
    // GUI.AdvancedDynamicTexture.idealHeight of type 'number':


    if (oldProps.idealHeight !== newProps.idealHeight) {
      updates.push({
        propertyName: "idealHeight",
        value: newProps.idealHeight,
        type: "number"
      });
    } // GUI.AdvancedDynamicTexture.idealWidth of type 'number':


    if (oldProps.idealWidth !== newProps.idealWidth) {
      updates.push({
        propertyName: "idealWidth",
        value: newProps.idealWidth,
        type: "number"
      });
    } // GUI.AdvancedDynamicTexture.isForeground of type 'boolean':


    if (oldProps.isForeground !== newProps.isForeground) {
      updates.push({
        propertyName: "isForeground",
        value: newProps.isForeground,
        type: "boolean"
      });
    } // GUI.AdvancedDynamicTexture.onClipboardObservable of type 'BABYLON.Observable<BABYLON.ClipboardInfo>/fn':


    if (oldProps.onClipboardObservable === undefined && oldProps.onClipboardObservable !== newProps.onClipboardObservable) {
      updates.push({
        propertyName: "onClipboardObservable",
        value: newProps.onClipboardObservable,
        type: "BABYLON.Observable<BABYLON.ClipboardInfo>"
      });
    } // GUI.AdvancedDynamicTexture.onControlPickedObservable of type 'BABYLON.Observable<BABYLON.GUI.Control>/fn':


    if (oldProps.onControlPickedObservable === undefined && oldProps.onControlPickedObservable !== newProps.onControlPickedObservable) {
      updates.push({
        propertyName: "onControlPickedObservable",
        value: newProps.onControlPickedObservable,
        type: "BABYLON.Observable<BABYLON.GUI.Control>"
      });
    } // GUI.AdvancedDynamicTexture.premulAlpha of type 'boolean':


    if (oldProps.premulAlpha !== newProps.premulAlpha) {
      updates.push({
        propertyName: "premulAlpha",
        value: newProps.premulAlpha,
        type: "boolean"
      });
    } // GUI.AdvancedDynamicTexture.renderAtIdealSize of type 'boolean':


    if (oldProps.renderAtIdealSize !== newProps.renderAtIdealSize) {
      updates.push({
        propertyName: "renderAtIdealSize",
        value: newProps.renderAtIdealSize,
        type: "boolean"
      });
    } // GUI.AdvancedDynamicTexture.renderScale of type 'number':


    if (oldProps.renderScale !== newProps.renderScale) {
      updates.push({
        propertyName: "renderScale",
        value: newProps.renderScale,
        type: "number"
      });
    } // GUI.AdvancedDynamicTexture.useSmallestIdeal of type 'boolean':


    if (oldProps.useSmallestIdeal !== newProps.useSmallestIdeal) {
      updates.push({
        propertyName: "useSmallestIdeal",
        value: newProps.useSmallestIdeal,
        type: "boolean"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberAdvancedDynamicTexturePropsHandler;
}();
/**
 * Class used to create texture to support 2D GUI elements
 *
 * This code has been generated
 */


var FiberAdvancedDynamicTexture =
/** @class */
function () {
  function FiberAdvancedDynamicTexture() {
    this.propsHandlers = [new FiberAdvancedDynamicTexturePropsHandler(), new FiberDynamicTexturePropsHandler(), new FiberTexturePropsHandler(), new FiberBaseTexturePropsHandler()];
  }

  FiberAdvancedDynamicTexture.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberAdvancedDynamicTexture.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberAdvancedDynamicTexture.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "AdvancedDynamicTexture",
    namespace: "GUI",
    parameters: [{
      name: "name",
      type: "string",
      optional: false
    }, {
      name: "width",
      type: "number",
      optional: false
    }, {
      name: "height",
      type: "number",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "generateMipMaps",
      type: "boolean",
      optional: true
    }, {
      name: "samplingMode",
      type: "number",
      optional: true
    }]
  };
  FiberAdvancedDynamicTexture.Metadata = {
    isGUI2DControl: true,
    className: "FiberAdvancedDynamicTexture"
  };
  return FiberAdvancedDynamicTexture;
}();

var FiberGUI3DManagerProps =
/** @class */
function () {
  function FiberGUI3DManagerProps() {}

  return FiberGUI3DManagerProps;
}();

var FiberGUI3DManagerPropsHandler =
/** @class */
function () {
  function FiberGUI3DManagerPropsHandler() {}

  FiberGUI3DManagerPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // GUI.GUI3DManager.onPickedPointChangedObservable of type 'BABYLON.Observable<BABYLON.Vector3>/fn':

    if (oldProps.onPickedPointChangedObservable === undefined && oldProps.onPickedPointChangedObservable !== newProps.onPickedPointChangedObservable) {
      updates.push({
        propertyName: "onPickedPointChangedObservable",
        value: newProps.onPickedPointChangedObservable,
        type: "BABYLON.Observable<BABYLON.Vector3>"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberGUI3DManagerPropsHandler;
}();
/**
 * Class used to manage 3D user interface
 *
 * This code has been generated
 */


var FiberGUI3DManager =
/** @class */
function () {
  function FiberGUI3DManager() {
    this.propsHandlers = [new FiberGUI3DManagerPropsHandler()];
  }

  FiberGUI3DManager.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberGUI3DManager.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberGUI3DManager.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "GUI3DManager",
    namespace: "GUI",
    parameters: [{
      name: "scene",
      type: "BABYLON.Scene",
      optional: true
    }]
  };
  FiberGUI3DManager.Metadata = {
    isGUI3DControl: true,
    className: "FiberGUI3DManager"
  };
  return FiberGUI3DManager;
}();

var FiberShadowGeneratorProps =
/** @class */
function () {
  function FiberShadowGeneratorProps() {}

  return FiberShadowGeneratorProps;
}();

var FiberShadowGeneratorPropsHandler =
/** @class */
function () {
  function FiberShadowGeneratorPropsHandler() {}

  FiberShadowGeneratorPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.ShadowGenerator.bias of type 'number':

    if (oldProps.bias !== newProps.bias) {
      updates.push({
        propertyName: "bias",
        value: newProps.bias,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.blurBoxOffset of type 'number':


    if (oldProps.blurBoxOffset !== newProps.blurBoxOffset) {
      updates.push({
        propertyName: "blurBoxOffset",
        value: newProps.blurBoxOffset,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.blurKernel of type 'number':


    if (oldProps.blurKernel !== newProps.blurKernel) {
      updates.push({
        propertyName: "blurKernel",
        value: newProps.blurKernel,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.blurScale of type 'number':


    if (oldProps.blurScale !== newProps.blurScale) {
      updates.push({
        propertyName: "blurScale",
        value: newProps.blurScale,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.contactHardeningLightSizeUVRatio of type 'number':


    if (oldProps.contactHardeningLightSizeUVRatio !== newProps.contactHardeningLightSizeUVRatio) {
      updates.push({
        propertyName: "contactHardeningLightSizeUVRatio",
        value: newProps.contactHardeningLightSizeUVRatio,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.depthScale of type 'number':


    if (oldProps.depthScale !== newProps.depthScale) {
      updates.push({
        propertyName: "depthScale",
        value: newProps.depthScale,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.filter of type 'number':


    if (oldProps.filter !== newProps.filter) {
      updates.push({
        propertyName: "filter",
        value: newProps.filter,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.filteringQuality of type 'number':


    if (oldProps.filteringQuality !== newProps.filteringQuality) {
      updates.push({
        propertyName: "filteringQuality",
        value: newProps.filteringQuality,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.forceBackFacesOnly of type 'boolean':


    if (oldProps.forceBackFacesOnly !== newProps.forceBackFacesOnly) {
      updates.push({
        propertyName: "forceBackFacesOnly",
        value: newProps.forceBackFacesOnly,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.frustumEdgeFalloff of type 'number':


    if (oldProps.frustumEdgeFalloff !== newProps.frustumEdgeFalloff) {
      updates.push({
        propertyName: "frustumEdgeFalloff",
        value: newProps.frustumEdgeFalloff,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.normalBias of type 'number':


    if (oldProps.normalBias !== newProps.normalBias) {
      updates.push({
        propertyName: "normalBias",
        value: newProps.normalBias,
        type: "number"
      });
    } // BABYLON.ShadowGenerator.useBlurCloseExponentialShadowMap of type 'boolean':


    if (oldProps.useBlurCloseExponentialShadowMap !== newProps.useBlurCloseExponentialShadowMap) {
      updates.push({
        propertyName: "useBlurCloseExponentialShadowMap",
        value: newProps.useBlurCloseExponentialShadowMap,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.useBlurExponentialShadowMap of type 'boolean':


    if (oldProps.useBlurExponentialShadowMap !== newProps.useBlurExponentialShadowMap) {
      updates.push({
        propertyName: "useBlurExponentialShadowMap",
        value: newProps.useBlurExponentialShadowMap,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.useCloseExponentialShadowMap of type 'boolean':


    if (oldProps.useCloseExponentialShadowMap !== newProps.useCloseExponentialShadowMap) {
      updates.push({
        propertyName: "useCloseExponentialShadowMap",
        value: newProps.useCloseExponentialShadowMap,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.useContactHardeningShadow of type 'boolean':


    if (oldProps.useContactHardeningShadow !== newProps.useContactHardeningShadow) {
      updates.push({
        propertyName: "useContactHardeningShadow",
        value: newProps.useContactHardeningShadow,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.useExponentialShadowMap of type 'boolean':


    if (oldProps.useExponentialShadowMap !== newProps.useExponentialShadowMap) {
      updates.push({
        propertyName: "useExponentialShadowMap",
        value: newProps.useExponentialShadowMap,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.useKernelBlur of type 'boolean':


    if (oldProps.useKernelBlur !== newProps.useKernelBlur) {
      updates.push({
        propertyName: "useKernelBlur",
        value: newProps.useKernelBlur,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.usePercentageCloserFiltering of type 'boolean':


    if (oldProps.usePercentageCloserFiltering !== newProps.usePercentageCloserFiltering) {
      updates.push({
        propertyName: "usePercentageCloserFiltering",
        value: newProps.usePercentageCloserFiltering,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.usePoissonSampling of type 'boolean':


    if (oldProps.usePoissonSampling !== newProps.usePoissonSampling) {
      updates.push({
        propertyName: "usePoissonSampling",
        value: newProps.usePoissonSampling,
        type: "boolean"
      });
    } // BABYLON.ShadowGenerator.setDarkness of type '(darkness?: number)':


    if (oldProps.setDarkness !== newProps.setDarkness) {
      updates.push({
        propertyName: "setDarkness",
        value: newProps.setDarkness,
        type: "(darkness?: number)"
      });
    } // BABYLON.ShadowGenerator.setTransparencyShadow of type '(transparent?: boolean)':


    if (oldProps.setTransparencyShadow !== newProps.setTransparencyShadow) {
      updates.push({
        propertyName: "setTransparencyShadow",
        value: newProps.setTransparencyShadow,
        type: "(transparent?: boolean)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberShadowGeneratorPropsHandler;
}();
/**
 * Default implementation IShadowGenerator.
 * This is the main object responsible of generating shadows in the framework.
 * Documentation: https://doc.babylonjs.com/babylon101/shadows
 *
 * This code has been generated
 */


var FiberShadowGenerator =
/** @class */
function () {
  function FiberShadowGenerator() {
    this.propsHandlers = [new FiberShadowGeneratorPropsHandler()];
  }

  FiberShadowGenerator.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberShadowGenerator.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberShadowGenerator.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "ShadowGenerator",
    namespace: "BABYLON",
    parameters: [{
      name: "mapSize",
      type: "number",
      optional: false
    }, {
      name: "light",
      type: "BABYLON.IShadowLight",
      optional: false
    }, {
      name: "usefulFloatFirst",
      type: "boolean",
      optional: true
    }]
  };
  FiberShadowGenerator.Metadata = {
    delayCreation: true,
    className: "FiberShadowGenerator"
  };
  return FiberShadowGenerator;
}();

var FiberEnvironmentHelperProps =
/** @class */
function () {
  function FiberEnvironmentHelperProps() {}

  return FiberEnvironmentHelperProps;
}();

var FiberEnvironmentHelperPropsHandler =
/** @class */
function () {
  function FiberEnvironmentHelperPropsHandler() {}

  FiberEnvironmentHelperPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // BABYLON.EnvironmentHelper.onErrorObservable of type 'BABYLON.Observable<{ message?: string; exception?: any; }>/fn':

    if (oldProps.onErrorObservable === undefined && oldProps.onErrorObservable !== newProps.onErrorObservable) {
      updates.push({
        propertyName: "onErrorObservable",
        value: newProps.onErrorObservable,
        type: "BABYLON.Observable<{ message?: string; exception?: any; }>"
      });
    } // BABYLON.EnvironmentHelper.setMainColor of type '(color?: BABYLON.Color3)':


    if (oldProps.setMainColor !== newProps.setMainColor) {
      updates.push({
        propertyName: "setMainColor",
        value: newProps.setMainColor,
        type: "(color?: BABYLON.Color3)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberEnvironmentHelperPropsHandler;
}();
/**
 * The Environment helper class can be used to add a fully featuread none expensive background to your scene.
 * It includes by default a skybox and a ground relying on the BackgroundMaterial.
 * It also helps with the default setup of your imageProcessing configuration.
 *
 * This code has been generated
 */


var FiberEnvironmentHelper =
/** @class */
function () {
  function FiberEnvironmentHelper() {
    this.propsHandlers = [new FiberEnvironmentHelperPropsHandler()];
  }

  FiberEnvironmentHelper.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberEnvironmentHelper.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberEnvironmentHelper.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "EnvironmentHelper",
    namespace: "BABYLON",
    parameters: [{
      name: "options",
      type: "Partial<BABYLON.IEnvironmentHelperOptions>",
      optional: false
    }, {
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }]
  };
  FiberEnvironmentHelper.Metadata = {
    isEnvironment: true,
    className: "FiberEnvironmentHelper"
  };
  return FiberEnvironmentHelper;
}();

var FiberVRExperienceHelperProps =
/** @class */
function () {
  function FiberVRExperienceHelperProps() {}

  return FiberVRExperienceHelperProps;
}();

var FiberVRExperienceHelperPropsHandler =
/** @class */
function () {
  function FiberVRExperienceHelperPropsHandler() {}

  FiberVRExperienceHelperPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: any property (not coded) BABYLON.VRExperienceHelper.beforeRender.
    // BABYLON.VRExperienceHelper.displayGaze of type 'boolean':

    if (oldProps.displayGaze !== newProps.displayGaze) {
      updates.push({
        propertyName: "displayGaze",
        value: newProps.displayGaze,
        type: "boolean"
      });
    } // BABYLON.VRExperienceHelper.displayLaserPointer of type 'boolean':


    if (oldProps.displayLaserPointer !== newProps.displayLaserPointer) {
      updates.push({
        propertyName: "displayLaserPointer",
        value: newProps.displayLaserPointer,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.VRExperienceHelper.displayVRButton.
    // TODO: type: BABYLON.Mesh property (not coded) BABYLON.VRExperienceHelper.gazeTrackerMesh.
    // TODO: type: (mesh: BABYLON.AbstractMesh) => boolean property (not coded) BABYLON.VRExperienceHelper.meshSelectionPredicate.
    // TODO: type: any property (not coded) BABYLON.VRExperienceHelper.moveButtonToBottomRight.
    // BABYLON.VRExperienceHelper.onAfterCameraTeleport of type 'BABYLON.Observable<BABYLON.Vector3>/fn':


    if (oldProps.onAfterCameraTeleport === undefined && oldProps.onAfterCameraTeleport !== newProps.onAfterCameraTeleport) {
      updates.push({
        propertyName: "onAfterCameraTeleport",
        value: newProps.onAfterCameraTeleport,
        type: "BABYLON.Observable<BABYLON.Vector3>"
      });
    } // BABYLON.VRExperienceHelper.onBeforeCameraTeleport of type 'BABYLON.Observable<BABYLON.Vector3>/fn':


    if (oldProps.onBeforeCameraTeleport === undefined && oldProps.onBeforeCameraTeleport !== newProps.onBeforeCameraTeleport) {
      updates.push({
        propertyName: "onBeforeCameraTeleport",
        value: newProps.onBeforeCameraTeleport,
        type: "BABYLON.Observable<BABYLON.Vector3>"
      });
    } // BABYLON.VRExperienceHelper.onControllerMeshLoadedObservable of type 'BABYLON.Observable<BABYLON.WebVRController>/fn':


    if (oldProps.onControllerMeshLoadedObservable === undefined && oldProps.onControllerMeshLoadedObservable !== newProps.onControllerMeshLoadedObservable) {
      updates.push({
        propertyName: "onControllerMeshLoadedObservable",
        value: newProps.onControllerMeshLoadedObservable,
        type: "BABYLON.Observable<BABYLON.WebVRController>"
      });
    } // BABYLON.VRExperienceHelper.onEnteringVRObservable of type 'BABYLON.Observable<BABYLON.VRExperienceHelper>/fn':


    if (oldProps.onEnteringVRObservable === undefined && oldProps.onEnteringVRObservable !== newProps.onEnteringVRObservable) {
      updates.push({
        propertyName: "onEnteringVRObservable",
        value: newProps.onEnteringVRObservable,
        type: "BABYLON.Observable<BABYLON.VRExperienceHelper>"
      });
    } // BABYLON.VRExperienceHelper.onExitingVRObservable of type 'BABYLON.Observable<BABYLON.VRExperienceHelper>/fn':


    if (oldProps.onExitingVRObservable === undefined && oldProps.onExitingVRObservable !== newProps.onExitingVRObservable) {
      updates.push({
        propertyName: "onExitingVRObservable",
        value: newProps.onExitingVRObservable,
        type: "BABYLON.Observable<BABYLON.VRExperienceHelper>"
      });
    } // BABYLON.VRExperienceHelper.onNewMeshPicked of type 'BABYLON.Observable<BABYLON.PickingInfo>/fn':


    if (oldProps.onNewMeshPicked === undefined && oldProps.onNewMeshPicked !== newProps.onNewMeshPicked) {
      updates.push({
        propertyName: "onNewMeshPicked",
        value: newProps.onNewMeshPicked,
        type: "BABYLON.Observable<BABYLON.PickingInfo>"
      });
    } // BABYLON.VRExperienceHelper.onNewMeshSelected of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onNewMeshSelected === undefined && oldProps.onNewMeshSelected !== newProps.onNewMeshSelected) {
      updates.push({
        propertyName: "onNewMeshSelected",
        value: newProps.onNewMeshSelected,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.VRExperienceHelper.onSelectedMeshUnselected of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onSelectedMeshUnselected === undefined && oldProps.onSelectedMeshUnselected !== newProps.onSelectedMeshUnselected) {
      updates.push({
        propertyName: "onSelectedMeshUnselected",
        value: newProps.onSelectedMeshUnselected,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.VRExperienceHelper.onVRDisplayChanged of type 'any/fn':


    if (oldProps.onVRDisplayChanged === undefined && oldProps.onVRDisplayChanged !== newProps.onVRDisplayChanged) {
      updates.push({
        propertyName: "onVRDisplayChanged",
        value: newProps.onVRDisplayChanged,
        type: "any"
      });
    } // BABYLON.VRExperienceHelper.onVrDisplayPresentChange of type 'any/fn':


    if (oldProps.onVrDisplayPresentChange === undefined && oldProps.onVrDisplayPresentChange !== newProps.onVrDisplayPresentChange) {
      updates.push({
        propertyName: "onVrDisplayPresentChange",
        value: newProps.onVrDisplayPresentChange,
        type: "any"
      });
    } // BABYLON.VRExperienceHelper.position of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.position && (!oldProps.position || !oldProps.position.equals(newProps.position))) {
      updates.push({
        propertyName: "position",
        value: newProps.position,
        type: "BABYLON.Vector3"
      });
    } // TODO: type: (mesh: BABYLON.AbstractMesh) => boolean property (not coded) BABYLON.VRExperienceHelper.raySelectionPredicate.
    // BABYLON.VRExperienceHelper.teleportationEnabled of type 'boolean':


    if (oldProps.teleportationEnabled !== newProps.teleportationEnabled) {
      updates.push({
        propertyName: "teleportationEnabled",
        value: newProps.teleportationEnabled,
        type: "boolean"
      });
    } // TODO: type: BABYLON.Mesh property (not coded) BABYLON.VRExperienceHelper.teleportationTarget.
    // TODO: type: any property (not coded) BABYLON.VRExperienceHelper.updateButtonVisibility.
    // BABYLON.VRExperienceHelper.updateGazeTrackerScale of type 'boolean':


    if (oldProps.updateGazeTrackerScale !== newProps.updateGazeTrackerScale) {
      updates.push({
        propertyName: "updateGazeTrackerScale",
        value: newProps.updateGazeTrackerScale,
        type: "boolean"
      });
    } // TODO: type: BABYLON.VRExperienceHelperOptions property (not coded) BABYLON.VRExperienceHelper.webVROptions.


    return updates.length == 0 ? null : updates;
  };

  return FiberVRExperienceHelperPropsHandler;
}();
/**
 * Helps to quickly add VR support to an existing scene.
 * See http://doc.babylonjs.com/how_to/webvr_helper
 *
 * This code has been generated
 */


var FiberVRExperienceHelper =
/** @class */
function () {
  function FiberVRExperienceHelper() {
    this.propsHandlers = [new FiberVRExperienceHelperPropsHandler()];
  }

  FiberVRExperienceHelper.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  FiberVRExperienceHelper.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  FiberVRExperienceHelper.CreateInfo = {
    creationType: "Constructor",
    libraryLocation: "VRExperienceHelper",
    namespace: "BABYLON",
    parameters: [{
      name: "scene",
      type: "BABYLON.Scene",
      optional: false
    }, {
      name: "webVROptions",
      type: "BABYLON.VRExperienceHelperOptions",
      optional: true
    }]
  };
  FiberVRExperienceHelper.Metadata = {
    className: "FiberVRExperienceHelper"
  };
  return FiberVRExperienceHelper;
}();

var FiberSceneProps =
/** @class */
function () {
  function FiberSceneProps() {}

  return FiberSceneProps;
}();

var FiberScenePropsHandler =
/** @class */
function () {
  function FiberScenePropsHandler() {}

  FiberScenePropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    // generated code
    var updates = []; // TODO: type: BABYLON.ActionManager property (not coded) BABYLON.Scene.actionManager.
    // TODO: type: BABYLON.Camera property (not coded) BABYLON.Scene.activeCamera.
    // TODO: type: BABYLON.Camera[] property (not coded) BABYLON.Scene.activeCameras.
    // TODO: type: () => void property (not coded) BABYLON.Scene.afterCameraRender.
    // TODO: type: () => void property (not coded) BABYLON.Scene.afterRender.
    // BABYLON.Scene.ambientColor of BABYLONBABYLON.Color3 uses object equals to find diffs:

    if (newProps.ambientColor && (!oldProps.ambientColor || !oldProps.ambientColor.equals(newProps.ambientColor))) {
      updates.push({
        propertyName: "ambientColor",
        value: newProps.ambientColor,
        type: "BABYLON.Color3"
      });
    } // TODO: type: BABYLON.AnimationPropertiesOverride property (not coded) BABYLON.Scene.animationPropertiesOverride.
    // BABYLON.Scene.animationsEnabled of type 'boolean':


    if (oldProps.animationsEnabled !== newProps.animationsEnabled) {
      updates.push({
        propertyName: "animationsEnabled",
        value: newProps.animationsEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.animationTimeScale of type 'number':


    if (oldProps.animationTimeScale !== newProps.animationTimeScale) {
      updates.push({
        propertyName: "animationTimeScale",
        value: newProps.animationTimeScale,
        type: "number"
      });
    } // BABYLON.Scene.autoClear of type 'boolean':


    if (oldProps.autoClear !== newProps.autoClear) {
      updates.push({
        propertyName: "autoClear",
        value: newProps.autoClear,
        type: "boolean"
      });
    } // BABYLON.Scene.autoClearDepthAndStencil of type 'boolean':


    if (oldProps.autoClearDepthAndStencil !== newProps.autoClearDepthAndStencil) {
      updates.push({
        propertyName: "autoClearDepthAndStencil",
        value: newProps.autoClearDepthAndStencil,
        type: "boolean"
      });
    } // TODO: type: () => void property (not coded) BABYLON.Scene.beforeCameraRender.
    // TODO: type: () => void property (not coded) BABYLON.Scene.beforeRender.
    // BABYLON.Scene.blockfreeActiveMeshesAndRenderingGroups of type 'boolean':


    if (oldProps.blockfreeActiveMeshesAndRenderingGroups !== newProps.blockfreeActiveMeshesAndRenderingGroups) {
      updates.push({
        propertyName: "blockfreeActiveMeshesAndRenderingGroups",
        value: newProps.blockfreeActiveMeshesAndRenderingGroups,
        type: "boolean"
      });
    } // BABYLON.Scene.blockMaterialDirtyMechanism of type 'boolean':


    if (oldProps.blockMaterialDirtyMechanism !== newProps.blockMaterialDirtyMechanism) {
      updates.push({
        propertyName: "blockMaterialDirtyMechanism",
        value: newProps.blockMaterialDirtyMechanism,
        type: "boolean"
      });
    } // TODO: type: BABYLON.Camera property (not coded) BABYLON.Scene.cameraToUseForPointers.
    // TODO: type: BABYLON.Color4 property (not coded) BABYLON.Scene.clearColor.
    // TODO: type: BABYLON.Plane property (not coded) BABYLON.Scene.clipPlane.
    // TODO: type: BABYLON.Plane property (not coded) BABYLON.Scene.clipPlane2.
    // TODO: type: BABYLON.Plane property (not coded) BABYLON.Scene.clipPlane3.
    // TODO: type: BABYLON.Plane property (not coded) BABYLON.Scene.clipPlane4.
    // TODO: type: BABYLON.ICollisionCoordinator property (not coded) BABYLON.Scene.collisionCoordinator.
    // BABYLON.Scene.collisionsEnabled of type 'boolean':


    if (oldProps.collisionsEnabled !== newProps.collisionsEnabled) {
      updates.push({
        propertyName: "collisionsEnabled",
        value: newProps.collisionsEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.constantlyUpdateMeshUnderPointer of type 'boolean':


    if (oldProps.constantlyUpdateMeshUnderPointer !== newProps.constantlyUpdateMeshUnderPointer) {
      updates.push({
        propertyName: "constantlyUpdateMeshUnderPointer",
        value: newProps.constantlyUpdateMeshUnderPointer,
        type: "boolean"
      });
    } // TODO: type: BABYLON.RenderTargetTexture[] property (not coded) BABYLON.Scene.customRenderTargets.
    // BABYLON.Scene.defaultCursor of type 'string':


    if (oldProps.defaultCursor !== newProps.defaultCursor) {
      updates.push({
        propertyName: "defaultCursor",
        value: newProps.defaultCursor,
        type: "string"
      });
    } // TODO: type: BABYLON.Material property (not coded) BABYLON.Scene.defaultMaterial.
    // TODO: type: RegExp[] property (not coded) BABYLON.Scene.disableOfflineSupportExceptionRules.
    // BABYLON.Scene.dispatchAllSubMeshesOfActiveMeshes of type 'boolean':


    if (oldProps.dispatchAllSubMeshesOfActiveMeshes !== newProps.dispatchAllSubMeshesOfActiveMeshes) {
      updates.push({
        propertyName: "dispatchAllSubMeshesOfActiveMeshes",
        value: newProps.dispatchAllSubMeshesOfActiveMeshes,
        type: "boolean"
      });
    } // BABYLON.Scene.dumpNextRenderTargets of type 'boolean':


    if (oldProps.dumpNextRenderTargets !== newProps.dumpNextRenderTargets) {
      updates.push({
        propertyName: "dumpNextRenderTargets",
        value: newProps.dumpNextRenderTargets,
        type: "boolean"
      });
    } // TODO: type: BABYLON.BaseTexture property (not coded) BABYLON.Scene.environmentTexture.
    // BABYLON.Scene.fogColor of BABYLONBABYLON.Color3 uses object equals to find diffs:


    if (newProps.fogColor && (!oldProps.fogColor || !oldProps.fogColor.equals(newProps.fogColor))) {
      updates.push({
        propertyName: "fogColor",
        value: newProps.fogColor,
        type: "BABYLON.Color3"
      });
    } // BABYLON.Scene.fogDensity of type 'number':


    if (oldProps.fogDensity !== newProps.fogDensity) {
      updates.push({
        propertyName: "fogDensity",
        value: newProps.fogDensity,
        type: "number"
      });
    } // BABYLON.Scene.fogEnabled of type 'boolean':


    if (oldProps.fogEnabled !== newProps.fogEnabled) {
      updates.push({
        propertyName: "fogEnabled",
        value: newProps.fogEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.fogEnd of type 'number':


    if (oldProps.fogEnd !== newProps.fogEnd) {
      updates.push({
        propertyName: "fogEnd",
        value: newProps.fogEnd,
        type: "number"
      });
    } // BABYLON.Scene.fogMode of type 'number':


    if (oldProps.fogMode !== newProps.fogMode) {
      updates.push({
        propertyName: "fogMode",
        value: newProps.fogMode,
        type: "number"
      });
    } // BABYLON.Scene.fogStart of type 'number':


    if (oldProps.fogStart !== newProps.fogStart) {
      updates.push({
        propertyName: "fogStart",
        value: newProps.fogStart,
        type: "number"
      });
    } // BABYLON.Scene.forcePointsCloud of type 'boolean':


    if (oldProps.forcePointsCloud !== newProps.forcePointsCloud) {
      updates.push({
        propertyName: "forcePointsCloud",
        value: newProps.forcePointsCloud,
        type: "boolean"
      });
    } // BABYLON.Scene.forceWireframe of type 'boolean':


    if (oldProps.forceWireframe !== newProps.forceWireframe) {
      updates.push({
        propertyName: "forceWireframe",
        value: newProps.forceWireframe,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.Scene.geometriesById.
    // TODO: type: () => BABYLON.ISmartArrayLike<BABYLON.AbstractMesh> property (not coded) BABYLON.Scene.getActiveMeshCandidates.
    // TODO: type: (mesh: BABYLON.AbstractMesh) => BABYLON.ISmartArrayLike<BABYLON.SubMesh> property (not coded) BABYLON.Scene.getActiveSubMeshCandidates.
    // TODO: type: (mesh: BABYLON.AbstractMesh, collider: BABYLON.Collider) => BABYLON.ISmartArrayLike<BABYLON.SubMesh> property (not coded) BABYLON.Scene.getCollidingSubMeshCandidates.
    // TODO: type: () => number property (not coded) BABYLON.Scene.getDeterministicFrameTime.
    // TODO: type: (mesh: BABYLON.AbstractMesh, localRay: BABYLON.Ray) => BABYLON.ISmartArrayLike<BABYLON.SubMesh> property (not coded) BABYLON.Scene.getIntersectingSubMeshCandidates.
    // BABYLON.Scene.gravity of BABYLONBABYLON.Vector3 uses object equals to find diffs:


    if (newProps.gravity && (!oldProps.gravity || !oldProps.gravity.equals(newProps.gravity))) {
      updates.push({
        propertyName: "gravity",
        value: newProps.gravity,
        type: "BABYLON.Vector3"
      });
    } // BABYLON.Scene.hoverCursor of type 'string':


    if (oldProps.hoverCursor !== newProps.hoverCursor) {
      updates.push({
        propertyName: "hoverCursor",
        value: newProps.hoverCursor,
        type: "string"
      });
    } // TODO: type: String[] property (not coded) BABYLON.Scene.importedMeshesFiles.
    // BABYLON.Scene.lensFlaresEnabled of type 'boolean':


    if (oldProps.lensFlaresEnabled !== newProps.lensFlaresEnabled) {
      updates.push({
        propertyName: "lensFlaresEnabled",
        value: newProps.lensFlaresEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.lightsEnabled of type 'boolean':


    if (oldProps.lightsEnabled !== newProps.lightsEnabled) {
      updates.push({
        propertyName: "lightsEnabled",
        value: newProps.lightsEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.loadingPluginName of type 'string':


    if (oldProps.loadingPluginName !== newProps.loadingPluginName) {
      updates.push({
        propertyName: "loadingPluginName",
        value: newProps.loadingPluginName,
        type: "string"
      });
    } // TODO: type: any property (not coded) BABYLON.Scene.metadata.
    // TODO: type: BABYLON.IOfflineProvider property (not coded) BABYLON.Scene.offlineProvider.
    // BABYLON.Scene.onActiveCameraChanged of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onActiveCameraChanged === undefined && oldProps.onActiveCameraChanged !== newProps.onActiveCameraChanged) {
      updates.push({
        propertyName: "onActiveCameraChanged",
        value: newProps.onActiveCameraChanged,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterActiveMeshesEvaluationObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterActiveMeshesEvaluationObservable === undefined && oldProps.onAfterActiveMeshesEvaluationObservable !== newProps.onAfterActiveMeshesEvaluationObservable) {
      updates.push({
        propertyName: "onAfterActiveMeshesEvaluationObservable",
        value: newProps.onAfterActiveMeshesEvaluationObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterAnimationsObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterAnimationsObservable === undefined && oldProps.onAfterAnimationsObservable !== newProps.onAfterAnimationsObservable) {
      updates.push({
        propertyName: "onAfterAnimationsObservable",
        value: newProps.onAfterAnimationsObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterCameraRenderObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onAfterCameraRenderObservable === undefined && oldProps.onAfterCameraRenderObservable !== newProps.onAfterCameraRenderObservable) {
      updates.push({
        propertyName: "onAfterCameraRenderObservable",
        value: newProps.onAfterCameraRenderObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Scene.onAfterDrawPhaseObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterDrawPhaseObservable === undefined && oldProps.onAfterDrawPhaseObservable !== newProps.onAfterDrawPhaseObservable) {
      updates.push({
        propertyName: "onAfterDrawPhaseObservable",
        value: newProps.onAfterDrawPhaseObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterParticlesRenderingObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterParticlesRenderingObservable === undefined && oldProps.onAfterParticlesRenderingObservable !== newProps.onAfterParticlesRenderingObservable) {
      updates.push({
        propertyName: "onAfterParticlesRenderingObservable",
        value: newProps.onAfterParticlesRenderingObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterRenderingGroupObservable of type 'BABYLON.Observable<BABYLON.RenderingGroupInfo>/fn':


    if (oldProps.onAfterRenderingGroupObservable === undefined && oldProps.onAfterRenderingGroupObservable !== newProps.onAfterRenderingGroupObservable) {
      updates.push({
        propertyName: "onAfterRenderingGroupObservable",
        value: newProps.onAfterRenderingGroupObservable,
        type: "BABYLON.Observable<BABYLON.RenderingGroupInfo>"
      });
    } // BABYLON.Scene.onAfterRenderObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterRenderObservable === undefined && oldProps.onAfterRenderObservable !== newProps.onAfterRenderObservable) {
      updates.push({
        propertyName: "onAfterRenderObservable",
        value: newProps.onAfterRenderObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterRenderTargetsRenderObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterRenderTargetsRenderObservable === undefined && oldProps.onAfterRenderTargetsRenderObservable !== newProps.onAfterRenderTargetsRenderObservable) {
      updates.push({
        propertyName: "onAfterRenderTargetsRenderObservable",
        value: newProps.onAfterRenderTargetsRenderObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onAfterStepObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onAfterStepObservable === undefined && oldProps.onAfterStepObservable !== newProps.onAfterStepObservable) {
      updates.push({
        propertyName: "onAfterStepObservable",
        value: newProps.onAfterStepObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeActiveMeshesEvaluationObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeActiveMeshesEvaluationObservable === undefined && oldProps.onBeforeActiveMeshesEvaluationObservable !== newProps.onBeforeActiveMeshesEvaluationObservable) {
      updates.push({
        propertyName: "onBeforeActiveMeshesEvaluationObservable",
        value: newProps.onBeforeActiveMeshesEvaluationObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeAnimationsObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeAnimationsObservable === undefined && oldProps.onBeforeAnimationsObservable !== newProps.onBeforeAnimationsObservable) {
      updates.push({
        propertyName: "onBeforeAnimationsObservable",
        value: newProps.onBeforeAnimationsObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeCameraRenderObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onBeforeCameraRenderObservable === undefined && oldProps.onBeforeCameraRenderObservable !== newProps.onBeforeCameraRenderObservable) {
      updates.push({
        propertyName: "onBeforeCameraRenderObservable",
        value: newProps.onBeforeCameraRenderObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Scene.onBeforeDrawPhaseObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeDrawPhaseObservable === undefined && oldProps.onBeforeDrawPhaseObservable !== newProps.onBeforeDrawPhaseObservable) {
      updates.push({
        propertyName: "onBeforeDrawPhaseObservable",
        value: newProps.onBeforeDrawPhaseObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeParticlesRenderingObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeParticlesRenderingObservable === undefined && oldProps.onBeforeParticlesRenderingObservable !== newProps.onBeforeParticlesRenderingObservable) {
      updates.push({
        propertyName: "onBeforeParticlesRenderingObservable",
        value: newProps.onBeforeParticlesRenderingObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeRenderingGroupObservable of type 'BABYLON.Observable<BABYLON.RenderingGroupInfo>/fn':


    if (oldProps.onBeforeRenderingGroupObservable === undefined && oldProps.onBeforeRenderingGroupObservable !== newProps.onBeforeRenderingGroupObservable) {
      updates.push({
        propertyName: "onBeforeRenderingGroupObservable",
        value: newProps.onBeforeRenderingGroupObservable,
        type: "BABYLON.Observable<BABYLON.RenderingGroupInfo>"
      });
    } // BABYLON.Scene.onBeforeRenderObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeRenderObservable === undefined && oldProps.onBeforeRenderObservable !== newProps.onBeforeRenderObservable) {
      updates.push({
        propertyName: "onBeforeRenderObservable",
        value: newProps.onBeforeRenderObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeRenderTargetsRenderObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeRenderTargetsRenderObservable === undefined && oldProps.onBeforeRenderTargetsRenderObservable !== newProps.onBeforeRenderTargetsRenderObservable) {
      updates.push({
        propertyName: "onBeforeRenderTargetsRenderObservable",
        value: newProps.onBeforeRenderTargetsRenderObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onBeforeStepObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onBeforeStepObservable === undefined && oldProps.onBeforeStepObservable !== newProps.onBeforeStepObservable) {
      updates.push({
        propertyName: "onBeforeStepObservable",
        value: newProps.onBeforeStepObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onCameraRemovedObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onCameraRemovedObservable === undefined && oldProps.onCameraRemovedObservable !== newProps.onCameraRemovedObservable) {
      updates.push({
        propertyName: "onCameraRemovedObservable",
        value: newProps.onCameraRemovedObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Scene.onDataLoadedObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onDataLoadedObservable === undefined && oldProps.onDataLoadedObservable !== newProps.onDataLoadedObservable) {
      updates.push({
        propertyName: "onDataLoadedObservable",
        value: newProps.onDataLoadedObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onDispose of type '() => void/fn':


    if (oldProps.onDispose === undefined && oldProps.onDispose !== newProps.onDispose) {
      updates.push({
        propertyName: "onDispose",
        value: newProps.onDispose,
        type: "() => void"
      });
    } // BABYLON.Scene.onDisposeObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onDisposeObservable === undefined && oldProps.onDisposeObservable !== newProps.onDisposeObservable) {
      updates.push({
        propertyName: "onDisposeObservable",
        value: newProps.onDisposeObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onGeometryRemovedObservable of type 'BABYLON.Observable<BABYLON.Geometry>/fn':


    if (oldProps.onGeometryRemovedObservable === undefined && oldProps.onGeometryRemovedObservable !== newProps.onGeometryRemovedObservable) {
      updates.push({
        propertyName: "onGeometryRemovedObservable",
        value: newProps.onGeometryRemovedObservable,
        type: "BABYLON.Observable<BABYLON.Geometry>"
      });
    } // BABYLON.Scene.onKeyboardObservable of type 'BABYLON.Observable<BABYLON.KeyboardInfo>/fn':


    if (oldProps.onKeyboardObservable === undefined && oldProps.onKeyboardObservable !== newProps.onKeyboardObservable) {
      updates.push({
        propertyName: "onKeyboardObservable",
        value: newProps.onKeyboardObservable,
        type: "BABYLON.Observable<BABYLON.KeyboardInfo>"
      });
    } // BABYLON.Scene.onLightRemovedObservable of type 'BABYLON.Observable<BABYLON.Light>/fn':


    if (oldProps.onLightRemovedObservable === undefined && oldProps.onLightRemovedObservable !== newProps.onLightRemovedObservable) {
      updates.push({
        propertyName: "onLightRemovedObservable",
        value: newProps.onLightRemovedObservable,
        type: "BABYLON.Observable<BABYLON.Light>"
      });
    } // BABYLON.Scene.onMaterialRemovedObservable of type 'BABYLON.Observable<BABYLON.Material>/fn':


    if (oldProps.onMaterialRemovedObservable === undefined && oldProps.onMaterialRemovedObservable !== newProps.onMaterialRemovedObservable) {
      updates.push({
        propertyName: "onMaterialRemovedObservable",
        value: newProps.onMaterialRemovedObservable,
        type: "BABYLON.Observable<BABYLON.Material>"
      });
    } // BABYLON.Scene.onMeshImportedObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onMeshImportedObservable === undefined && oldProps.onMeshImportedObservable !== newProps.onMeshImportedObservable) {
      updates.push({
        propertyName: "onMeshImportedObservable",
        value: newProps.onMeshImportedObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.Scene.onMeshRemovedObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onMeshRemovedObservable === undefined && oldProps.onMeshRemovedObservable !== newProps.onMeshRemovedObservable) {
      updates.push({
        propertyName: "onMeshRemovedObservable",
        value: newProps.onMeshRemovedObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.Scene.onNewCameraAddedObservable of type 'BABYLON.Observable<BABYLON.Camera>/fn':


    if (oldProps.onNewCameraAddedObservable === undefined && oldProps.onNewCameraAddedObservable !== newProps.onNewCameraAddedObservable) {
      updates.push({
        propertyName: "onNewCameraAddedObservable",
        value: newProps.onNewCameraAddedObservable,
        type: "BABYLON.Observable<BABYLON.Camera>"
      });
    } // BABYLON.Scene.onNewGeometryAddedObservable of type 'BABYLON.Observable<BABYLON.Geometry>/fn':


    if (oldProps.onNewGeometryAddedObservable === undefined && oldProps.onNewGeometryAddedObservable !== newProps.onNewGeometryAddedObservable) {
      updates.push({
        propertyName: "onNewGeometryAddedObservable",
        value: newProps.onNewGeometryAddedObservable,
        type: "BABYLON.Observable<BABYLON.Geometry>"
      });
    } // BABYLON.Scene.onNewLightAddedObservable of type 'BABYLON.Observable<BABYLON.Light>/fn':


    if (oldProps.onNewLightAddedObservable === undefined && oldProps.onNewLightAddedObservable !== newProps.onNewLightAddedObservable) {
      updates.push({
        propertyName: "onNewLightAddedObservable",
        value: newProps.onNewLightAddedObservable,
        type: "BABYLON.Observable<BABYLON.Light>"
      });
    } // BABYLON.Scene.onNewMaterialAddedObservable of type 'BABYLON.Observable<BABYLON.Material>/fn':


    if (oldProps.onNewMaterialAddedObservable === undefined && oldProps.onNewMaterialAddedObservable !== newProps.onNewMaterialAddedObservable) {
      updates.push({
        propertyName: "onNewMaterialAddedObservable",
        value: newProps.onNewMaterialAddedObservable,
        type: "BABYLON.Observable<BABYLON.Material>"
      });
    } // BABYLON.Scene.onNewMeshAddedObservable of type 'BABYLON.Observable<BABYLON.AbstractMesh>/fn':


    if (oldProps.onNewMeshAddedObservable === undefined && oldProps.onNewMeshAddedObservable !== newProps.onNewMeshAddedObservable) {
      updates.push({
        propertyName: "onNewMeshAddedObservable",
        value: newProps.onNewMeshAddedObservable,
        type: "BABYLON.Observable<BABYLON.AbstractMesh>"
      });
    } // BABYLON.Scene.onNewTextureAddedObservable of type 'BABYLON.Observable<BABYLON.BaseTexture>/fn':


    if (oldProps.onNewTextureAddedObservable === undefined && oldProps.onNewTextureAddedObservable !== newProps.onNewTextureAddedObservable) {
      updates.push({
        propertyName: "onNewTextureAddedObservable",
        value: newProps.onNewTextureAddedObservable,
        type: "BABYLON.Observable<BABYLON.BaseTexture>"
      });
    } // BABYLON.Scene.onNewTransformNodeAddedObservable of type 'BABYLON.Observable<BABYLON.TransformNode>/fn':


    if (oldProps.onNewTransformNodeAddedObservable === undefined && oldProps.onNewTransformNodeAddedObservable !== newProps.onNewTransformNodeAddedObservable) {
      updates.push({
        propertyName: "onNewTransformNodeAddedObservable",
        value: newProps.onNewTransformNodeAddedObservable,
        type: "BABYLON.Observable<BABYLON.TransformNode>"
      });
    } // BABYLON.Scene.onPointerDown of type '(evt: PointerEvent, pickInfo: BABYLON.PickingInfo, type: BABYLON.PointerEventTypes) => void/fn':


    if (oldProps.onPointerDown === undefined && oldProps.onPointerDown !== newProps.onPointerDown) {
      updates.push({
        propertyName: "onPointerDown",
        value: newProps.onPointerDown,
        type: "(evt: PointerEvent, pickInfo: BABYLON.PickingInfo, type: BABYLON.PointerEventTypes) => void"
      });
    } // BABYLON.Scene.onPointerMove of type '(evt: PointerEvent, pickInfo: BABYLON.PickingInfo, type: BABYLON.PointerEventTypes) => void/fn':


    if (oldProps.onPointerMove === undefined && oldProps.onPointerMove !== newProps.onPointerMove) {
      updates.push({
        propertyName: "onPointerMove",
        value: newProps.onPointerMove,
        type: "(evt: PointerEvent, pickInfo: BABYLON.PickingInfo, type: BABYLON.PointerEventTypes) => void"
      });
    } // BABYLON.Scene.onPointerObservable of type 'BABYLON.Observable<BABYLON.PointerInfo>/fn':


    if (oldProps.onPointerObservable === undefined && oldProps.onPointerObservable !== newProps.onPointerObservable) {
      updates.push({
        propertyName: "onPointerObservable",
        value: newProps.onPointerObservable,
        type: "BABYLON.Observable<BABYLON.PointerInfo>"
      });
    } // BABYLON.Scene.onPointerPick of type '(evt: PointerEvent, pickInfo: BABYLON.PickingInfo) => void/fn':


    if (oldProps.onPointerPick === undefined && oldProps.onPointerPick !== newProps.onPointerPick) {
      updates.push({
        propertyName: "onPointerPick",
        value: newProps.onPointerPick,
        type: "(evt: PointerEvent, pickInfo: BABYLON.PickingInfo) => void"
      });
    } // BABYLON.Scene.onPointerUp of type '(evt: PointerEvent, pickInfo: BABYLON.PickingInfo, type: BABYLON.PointerEventTypes) => void/fn':


    if (oldProps.onPointerUp === undefined && oldProps.onPointerUp !== newProps.onPointerUp) {
      updates.push({
        propertyName: "onPointerUp",
        value: newProps.onPointerUp,
        type: "(evt: PointerEvent, pickInfo: BABYLON.PickingInfo, type: BABYLON.PointerEventTypes) => void"
      });
    } // BABYLON.Scene.onPreKeyboardObservable of type 'BABYLON.Observable<BABYLON.KeyboardInfoPre>/fn':


    if (oldProps.onPreKeyboardObservable === undefined && oldProps.onPreKeyboardObservable !== newProps.onPreKeyboardObservable) {
      updates.push({
        propertyName: "onPreKeyboardObservable",
        value: newProps.onPreKeyboardObservable,
        type: "BABYLON.Observable<BABYLON.KeyboardInfoPre>"
      });
    } // BABYLON.Scene.onPrePointerObservable of type 'BABYLON.Observable<BABYLON.PointerInfoPre>/fn':


    if (oldProps.onPrePointerObservable === undefined && oldProps.onPrePointerObservable !== newProps.onPrePointerObservable) {
      updates.push({
        propertyName: "onPrePointerObservable",
        value: newProps.onPrePointerObservable,
        type: "BABYLON.Observable<BABYLON.PointerInfoPre>"
      });
    } // BABYLON.Scene.onReadyObservable of type 'BABYLON.Observable<BABYLON.Scene>/fn':


    if (oldProps.onReadyObservable === undefined && oldProps.onReadyObservable !== newProps.onReadyObservable) {
      updates.push({
        propertyName: "onReadyObservable",
        value: newProps.onReadyObservable,
        type: "BABYLON.Observable<BABYLON.Scene>"
      });
    } // BABYLON.Scene.onTextureRemovedObservable of type 'BABYLON.Observable<BABYLON.BaseTexture>/fn':


    if (oldProps.onTextureRemovedObservable === undefined && oldProps.onTextureRemovedObservable !== newProps.onTextureRemovedObservable) {
      updates.push({
        propertyName: "onTextureRemovedObservable",
        value: newProps.onTextureRemovedObservable,
        type: "BABYLON.Observable<BABYLON.BaseTexture>"
      });
    } // BABYLON.Scene.onTransformNodeRemovedObservable of type 'BABYLON.Observable<BABYLON.TransformNode>/fn':


    if (oldProps.onTransformNodeRemovedObservable === undefined && oldProps.onTransformNodeRemovedObservable !== newProps.onTransformNodeRemovedObservable) {
      updates.push({
        propertyName: "onTransformNodeRemovedObservable",
        value: newProps.onTransformNodeRemovedObservable,
        type: "BABYLON.Observable<BABYLON.TransformNode>"
      });
    } // BABYLON.Scene.particlesEnabled of type 'boolean':


    if (oldProps.particlesEnabled !== newProps.particlesEnabled) {
      updates.push({
        propertyName: "particlesEnabled",
        value: newProps.particlesEnabled,
        type: "boolean"
      });
    } // TODO: type: (Mesh: BABYLON.AbstractMesh) => boolean property (not coded) BABYLON.Scene.pointerDownPredicate.
    // TODO: type: (Mesh: BABYLON.AbstractMesh) => boolean property (not coded) BABYLON.Scene.pointerMovePredicate.
    // TODO: type: (Mesh: BABYLON.AbstractMesh) => boolean property (not coded) BABYLON.Scene.pointerUpPredicate.
    // TODO: type: BABYLON.PostProcess[] property (not coded) BABYLON.Scene.postProcesses.
    // BABYLON.Scene.postProcessesEnabled of type 'boolean':


    if (oldProps.postProcessesEnabled !== newProps.postProcessesEnabled) {
      updates.push({
        propertyName: "postProcessesEnabled",
        value: newProps.postProcessesEnabled,
        type: "boolean"
      });
    } // TODO: type: BABYLON.PostProcessManager property (not coded) BABYLON.Scene.postProcessManager.
    // BABYLON.Scene.preventDefaultOnPointerDown of type 'boolean':


    if (oldProps.preventDefaultOnPointerDown !== newProps.preventDefaultOnPointerDown) {
      updates.push({
        propertyName: "preventDefaultOnPointerDown",
        value: newProps.preventDefaultOnPointerDown,
        type: "boolean"
      });
    } // BABYLON.Scene.preventDefaultOnPointerUp of type 'boolean':


    if (oldProps.preventDefaultOnPointerUp !== newProps.preventDefaultOnPointerUp) {
      updates.push({
        propertyName: "preventDefaultOnPointerUp",
        value: newProps.preventDefaultOnPointerUp,
        type: "boolean"
      });
    } // BABYLON.Scene.probesEnabled of type 'boolean':


    if (oldProps.probesEnabled !== newProps.probesEnabled) {
      updates.push({
        propertyName: "probesEnabled",
        value: newProps.probesEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.proceduralTexturesEnabled of type 'boolean':


    if (oldProps.proceduralTexturesEnabled !== newProps.proceduralTexturesEnabled) {
      updates.push({
        propertyName: "proceduralTexturesEnabled",
        value: newProps.proceduralTexturesEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.renderTargetsEnabled of type 'boolean':


    if (oldProps.renderTargetsEnabled !== newProps.renderTargetsEnabled) {
      updates.push({
        propertyName: "renderTargetsEnabled",
        value: newProps.renderTargetsEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.requireLightSorting of type 'boolean':


    if (oldProps.requireLightSorting !== newProps.requireLightSorting) {
      updates.push({
        propertyName: "requireLightSorting",
        value: newProps.requireLightSorting,
        type: "boolean"
      });
    } // TODO: type: any property (not coded) BABYLON.Scene.reservedDataStore.
    // BABYLON.Scene.shadowsEnabled of type 'boolean':


    if (oldProps.shadowsEnabled !== newProps.shadowsEnabled) {
      updates.push({
        propertyName: "shadowsEnabled",
        value: newProps.shadowsEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.skeletonsEnabled of type 'boolean':


    if (oldProps.skeletonsEnabled !== newProps.skeletonsEnabled) {
      updates.push({
        propertyName: "skeletonsEnabled",
        value: newProps.skeletonsEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.spritesEnabled of type 'boolean':


    if (oldProps.spritesEnabled !== newProps.spritesEnabled) {
      updates.push({
        propertyName: "spritesEnabled",
        value: newProps.spritesEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.texturesEnabled of type 'boolean':


    if (oldProps.texturesEnabled !== newProps.texturesEnabled) {
      updates.push({
        propertyName: "texturesEnabled",
        value: newProps.texturesEnabled,
        type: "boolean"
      });
    } // BABYLON.Scene.useConstantAnimationDeltaTime of type 'boolean':


    if (oldProps.useConstantAnimationDeltaTime !== newProps.useConstantAnimationDeltaTime) {
      updates.push({
        propertyName: "useConstantAnimationDeltaTime",
        value: newProps.useConstantAnimationDeltaTime,
        type: "boolean"
      });
    } // BABYLON.Scene.useDelayedTextureLoading of type 'boolean':


    if (oldProps.useDelayedTextureLoading !== newProps.useDelayedTextureLoading) {
      updates.push({
        propertyName: "useDelayedTextureLoading",
        value: newProps.useDelayedTextureLoading,
        type: "boolean"
      });
    } // BABYLON.Scene.useRightHandedSystem of type 'boolean':


    if (oldProps.useRightHandedSystem !== newProps.useRightHandedSystem) {
      updates.push({
        propertyName: "useRightHandedSystem",
        value: newProps.useRightHandedSystem,
        type: "boolean"
      });
    } // BABYLON.Scene.workerCollisions of type 'boolean':


    if (oldProps.workerCollisions !== newProps.workerCollisions) {
      updates.push({
        propertyName: "workerCollisions",
        value: newProps.workerCollisions,
        type: "boolean"
      });
    } // BABYLON.Scene.setActiveCameraByID of type '(id?: string)':


    if (oldProps.setActiveCameraByID !== newProps.setActiveCameraByID) {
      updates.push({
        propertyName: "setActiveCameraByID",
        value: newProps.setActiveCameraByID,
        type: "(id?: string)"
      });
    } // BABYLON.Scene.setActiveCameraByName of type '(name?: string)':


    if (oldProps.setActiveCameraByName !== newProps.setActiveCameraByName) {
      updates.push({
        propertyName: "setActiveCameraByName",
        value: newProps.setActiveCameraByName,
        type: "(name?: string)"
      });
    } // BABYLON.Scene.setPointerOverMesh of type '(mesh?: BABYLON.AbstractMesh)':


    if (oldProps.setPointerOverMesh !== newProps.setPointerOverMesh) {
      updates.push({
        propertyName: "setPointerOverMesh",
        value: newProps.setPointerOverMesh,
        type: "(mesh?: BABYLON.AbstractMesh)"
      });
    } // BABYLON.Scene.setRenderingAutoClearDepthStencil of type '(renderingGroupId?: number, autoClearDepthStencil?: boolean, depth?: boolean, stencil?: boolean)':


    if (oldProps.setRenderingAutoClearDepthStencil !== newProps.setRenderingAutoClearDepthStencil) {
      updates.push({
        propertyName: "setRenderingAutoClearDepthStencil",
        value: newProps.setRenderingAutoClearDepthStencil,
        type: "(renderingGroupId?: number, autoClearDepthStencil?: boolean, depth?: boolean, stencil?: boolean)"
      });
    } // BABYLON.Scene.setRenderingOrder of type '(renderingGroupId?: number, opaqueSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, alphaTestSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, transparentSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number)':


    if (oldProps.setRenderingOrder !== newProps.setRenderingOrder) {
      updates.push({
        propertyName: "setRenderingOrder",
        value: newProps.setRenderingOrder,
        type: "(renderingGroupId?: number, opaqueSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, alphaTestSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number, transparentSortCompareFn?: (a: BABYLON.SubMesh, b: BABYLON.SubMesh) => number)"
      });
    } // BABYLON.Scene.setStepId of type '(newStepId?: number)':


    if (oldProps.setStepId !== newProps.setStepId) {
      updates.push({
        propertyName: "setStepId",
        value: newProps.setStepId,
        type: "(newStepId?: number)"
      });
    } // BABYLON.Scene.setTransformMatrix of type '(view?: BABYLON.Matrix, projection?: BABYLON.Matrix)':


    if (oldProps.setTransformMatrix !== newProps.setTransformMatrix) {
      updates.push({
        propertyName: "setTransformMatrix",
        value: newProps.setTransformMatrix,
        type: "(view?: BABYLON.Matrix, projection?: BABYLON.Matrix)"
      });
    }

    return updates.length == 0 ? null : updates;
  };

  return FiberScenePropsHandler;
}();

var AbstractButton3D = "AbstractButton3D",
    AbstractMesh$1 = "AbstractMesh",
    AdvancedDynamicTexture = "AdvancedDynamicTexture",
    AnaglyphArcRotateCamera = "AnaglyphArcRotateCamera",
    AnaglyphFreeCamera = "AnaglyphFreeCamera",
    AnaglyphGamepadCamera = "AnaglyphGamepadCamera",
    AnaglyphUniversalCamera = "AnaglyphUniversalCamera",
    ArcFollowCamera = "ArcFollowCamera",
    ArcRotateCamera = "ArcRotateCamera",
    BackgroundMaterial = "BackgroundMaterial",
    BaseSlider = "BaseSlider",
    BaseTexture = "BaseTexture",
    Box = "Box",
    Button = "Button",
    Button3D = "Button3D",
    Camera = "Camera",
    Checkbox = "Checkbox",
    ColorGradingTexture = "ColorGradingTexture",
    ColorPicker = "ColorPicker",
    Container = "Container",
    Container3D = "Container3D",
    Control = "Control",
    Control3D = "Control3D",
    CubeTexture = "CubeTexture",
    CustomProceduralTexture = "CustomProceduralTexture",
    Cylinder = "Cylinder",
    CylinderPanel = "CylinderPanel",
    DashedLines = "DashedLines",
    Decal = "Decal",
    DeviceOrientationCamera = "DeviceOrientationCamera",
    DirectionalLight = "DirectionalLight",
    Disc = "Disc",
    DisplayGrid = "DisplayGrid",
    DynamicTexture = "DynamicTexture",
    Ellipse = "Ellipse",
    EnvironmentHelper = "EnvironmentHelper",
    ExtrudePolygon = "ExtrudePolygon",
    ExtrudeShape = "ExtrudeShape",
    ExtrudeShapeCustom = "ExtrudeShapeCustom",
    FlyCamera = "FlyCamera",
    FollowCamera = "FollowCamera",
    FreeCamera = "FreeCamera",
    GUI3DManager = "GUI3DManager",
    GamepadCamera = "GamepadCamera",
    Grid = "Grid",
    Ground = "Ground",
    GroundFromHeightMap = "GroundFromHeightMap",
    HDRCubeTexture = "HDRCubeTexture",
    HemisphericLight = "HemisphericLight",
    HolographicButton = "HolographicButton",
    IcoSphere = "IcoSphere",
    Image = "Image",
    ImageBasedSlider = "ImageBasedSlider",
    InputPassword = "InputPassword",
    InputText = "InputText",
    Lathe = "Lathe",
    Light = "Light",
    Line = "Line",
    LineSystem = "LineSystem",
    Lines = "Lines",
    Material = "Material",
    Mesh = "Mesh",
    MeshButton3D = "MeshButton3D",
    MirrorTexture = "MirrorTexture",
    MultiLine = "MultiLine",
    MultiMaterial = "MultiMaterial",
    MultiRenderTarget = "MultiRenderTarget",
    Node = "Node",
    NoiseProceduralTexture = "NoiseProceduralTexture",
    PBRBaseMaterial = "PBRBaseMaterial",
    PBRBaseSimpleMaterial = "PBRBaseSimpleMaterial",
    PBRMaterial = "PBRMaterial",
    PBRMetallicRoughnessMaterial = "PBRMetallicRoughnessMaterial",
    PBRSpecularGlossinessMaterial = "PBRSpecularGlossinessMaterial",
    Plane = "Plane",
    PlanePanel = "PlanePanel",
    PointLight = "PointLight",
    Polygon = "Polygon",
    Polyhedron = "Polyhedron",
    ProceduralTexture = "ProceduralTexture",
    PushMaterial = "PushMaterial",
    RadioButton = "RadioButton",
    RawCubeTexture = "RawCubeTexture",
    RawTexture = "RawTexture",
    RawTexture3D = "RawTexture3D",
    Rectangle = "Rectangle",
    RefractionTexture = "RefractionTexture",
    RenderTargetTexture = "RenderTargetTexture",
    Ribbon = "Ribbon",
    ScatterPanel = "ScatterPanel",
    ScrollViewer = "ScrollViewer",
    SelectionPanel = "SelectionPanel",
    ShaderMaterial = "ShaderMaterial",
    ShadowGenerator$1 = "ShadowGenerator",
    ShadowLight = "ShadowLight",
    Slider = "Slider",
    Sphere = "Sphere",
    SpherePanel = "SpherePanel",
    SpotLight = "SpotLight",
    StackPanel = "StackPanel",
    StackPanel3D = "StackPanel3D",
    StandardMaterial$1 = "StandardMaterial",
    StereoscopicArcRotateCamera = "StereoscopicArcRotateCamera",
    StereoscopicFreeCamera = "StereoscopicFreeCamera",
    StereoscopicGamepadCamera = "StereoscopicGamepadCamera",
    StereoscopicUniversalCamera = "StereoscopicUniversalCamera",
    TargetCamera = "TargetCamera",
    TextBlock = "TextBlock",
    Texture$1 = "Texture",
    TiledGround = "TiledGround",
    Torus = "Torus",
    TorusKnot = "TorusKnot",
    TouchCamera = "TouchCamera",
    TransformNode = "TransformNode",
    Tube = "Tube",
    UniversalCamera = "UniversalCamera",
    VRDeviceOrientationArcRotateCamera = "VRDeviceOrientationArcRotateCamera",
    VRDeviceOrientationFreeCamera = "VRDeviceOrientationFreeCamera",
    VRDeviceOrientationGamepadCamera = "VRDeviceOrientationGamepadCamera",
    VRExperienceHelper = "VRExperienceHelper",
    VideoTexture = "VideoTexture",
    VirtualJoysticksCamera = "VirtualJoysticksCamera",
    VirtualKeyboard = "VirtualKeyboard",
    VolumeBasedPanel = "VolumeBasedPanel",
    WebVRFreeCamera = "WebVRFreeCamera",
    WebXRCamera = "WebXRCamera";
var GENERATED =
/*#__PURE__*/
Object.freeze({
  FiberNodeProps: FiberNodeProps,
  FiberNodePropsHandler: FiberNodePropsHandler,
  FiberNode: FiberNode,
  FiberTransformNodeProps: FiberTransformNodeProps,
  FiberTransformNodePropsHandler: FiberTransformNodePropsHandler,
  FiberTransformNode: FiberTransformNode,
  FiberAbstractMeshProps: FiberAbstractMeshProps,
  FiberAbstractMeshPropsHandler: FiberAbstractMeshPropsHandler,
  FiberAbstractMesh: FiberAbstractMesh,
  FiberMeshProps: FiberMeshProps,
  FiberMeshPropsHandler: FiberMeshPropsHandler,
  FiberMesh: FiberMesh,
  FiberCameraProps: FiberCameraProps,
  FiberCameraPropsHandler: FiberCameraPropsHandler,
  FiberCamera: FiberCamera,
  FiberTargetCameraProps: FiberTargetCameraProps,
  FiberTargetCameraPropsHandler: FiberTargetCameraPropsHandler,
  FiberTargetCamera: FiberTargetCamera,
  FiberArcRotateCameraProps: FiberArcRotateCameraProps,
  FiberArcRotateCameraPropsHandler: FiberArcRotateCameraPropsHandler,
  FiberArcRotateCamera: FiberArcRotateCamera,
  FiberVRDeviceOrientationArcRotateCameraProps: FiberVRDeviceOrientationArcRotateCameraProps,
  FiberVRDeviceOrientationArcRotateCameraPropsHandler: FiberVRDeviceOrientationArcRotateCameraPropsHandler,
  FiberVRDeviceOrientationArcRotateCamera: FiberVRDeviceOrientationArcRotateCamera,
  FiberAnaglyphArcRotateCameraProps: FiberAnaglyphArcRotateCameraProps,
  FiberAnaglyphArcRotateCameraPropsHandler: FiberAnaglyphArcRotateCameraPropsHandler,
  FiberAnaglyphArcRotateCamera: FiberAnaglyphArcRotateCamera,
  FiberStereoscopicArcRotateCameraProps: FiberStereoscopicArcRotateCameraProps,
  FiberStereoscopicArcRotateCameraPropsHandler: FiberStereoscopicArcRotateCameraPropsHandler,
  FiberStereoscopicArcRotateCamera: FiberStereoscopicArcRotateCamera,
  FiberFlyCameraProps: FiberFlyCameraProps,
  FiberFlyCameraPropsHandler: FiberFlyCameraPropsHandler,
  FiberFlyCamera: FiberFlyCamera,
  FiberFollowCameraProps: FiberFollowCameraProps,
  FiberFollowCameraPropsHandler: FiberFollowCameraPropsHandler,
  FiberFollowCamera: FiberFollowCamera,
  FiberArcFollowCameraProps: FiberArcFollowCameraProps,
  FiberArcFollowCameraPropsHandler: FiberArcFollowCameraPropsHandler,
  FiberArcFollowCamera: FiberArcFollowCamera,
  FiberFreeCameraProps: FiberFreeCameraProps,
  FiberFreeCameraPropsHandler: FiberFreeCameraPropsHandler,
  FiberFreeCamera: FiberFreeCamera,
  FiberDeviceOrientationCameraProps: FiberDeviceOrientationCameraProps,
  FiberDeviceOrientationCameraPropsHandler: FiberDeviceOrientationCameraPropsHandler,
  FiberDeviceOrientationCamera: FiberDeviceOrientationCamera,
  FiberVRDeviceOrientationFreeCameraProps: FiberVRDeviceOrientationFreeCameraProps,
  FiberVRDeviceOrientationFreeCameraPropsHandler: FiberVRDeviceOrientationFreeCameraPropsHandler,
  FiberVRDeviceOrientationFreeCamera: FiberVRDeviceOrientationFreeCamera,
  FiberVRDeviceOrientationGamepadCameraProps: FiberVRDeviceOrientationGamepadCameraProps,
  FiberVRDeviceOrientationGamepadCameraPropsHandler: FiberVRDeviceOrientationGamepadCameraPropsHandler,
  FiberVRDeviceOrientationGamepadCamera: FiberVRDeviceOrientationGamepadCamera,
  FiberTouchCameraProps: FiberTouchCameraProps,
  FiberTouchCameraPropsHandler: FiberTouchCameraPropsHandler,
  FiberTouchCamera: FiberTouchCamera,
  FiberUniversalCameraProps: FiberUniversalCameraProps,
  FiberUniversalCameraPropsHandler: FiberUniversalCameraPropsHandler,
  FiberUniversalCamera: FiberUniversalCamera,
  FiberGamepadCameraProps: FiberGamepadCameraProps,
  FiberGamepadCameraPropsHandler: FiberGamepadCameraPropsHandler,
  FiberGamepadCamera: FiberGamepadCamera,
  FiberAnaglyphGamepadCameraProps: FiberAnaglyphGamepadCameraProps,
  FiberAnaglyphGamepadCameraPropsHandler: FiberAnaglyphGamepadCameraPropsHandler,
  FiberAnaglyphGamepadCamera: FiberAnaglyphGamepadCamera,
  FiberStereoscopicGamepadCameraProps: FiberStereoscopicGamepadCameraProps,
  FiberStereoscopicGamepadCameraPropsHandler: FiberStereoscopicGamepadCameraPropsHandler,
  FiberStereoscopicGamepadCamera: FiberStereoscopicGamepadCamera,
  FiberAnaglyphUniversalCameraProps: FiberAnaglyphUniversalCameraProps,
  FiberAnaglyphUniversalCameraPropsHandler: FiberAnaglyphUniversalCameraPropsHandler,
  FiberAnaglyphUniversalCamera: FiberAnaglyphUniversalCamera,
  FiberStereoscopicUniversalCameraProps: FiberStereoscopicUniversalCameraProps,
  FiberStereoscopicUniversalCameraPropsHandler: FiberStereoscopicUniversalCameraPropsHandler,
  FiberStereoscopicUniversalCamera: FiberStereoscopicUniversalCamera,
  FiberVirtualJoysticksCameraProps: FiberVirtualJoysticksCameraProps,
  FiberVirtualJoysticksCameraPropsHandler: FiberVirtualJoysticksCameraPropsHandler,
  FiberVirtualJoysticksCamera: FiberVirtualJoysticksCamera,
  FiberWebVRFreeCameraProps: FiberWebVRFreeCameraProps,
  FiberWebVRFreeCameraPropsHandler: FiberWebVRFreeCameraPropsHandler,
  FiberWebVRFreeCamera: FiberWebVRFreeCamera,
  FiberAnaglyphFreeCameraProps: FiberAnaglyphFreeCameraProps,
  FiberAnaglyphFreeCameraPropsHandler: FiberAnaglyphFreeCameraPropsHandler,
  FiberAnaglyphFreeCamera: FiberAnaglyphFreeCamera,
  FiberStereoscopicFreeCameraProps: FiberStereoscopicFreeCameraProps,
  FiberStereoscopicFreeCameraPropsHandler: FiberStereoscopicFreeCameraPropsHandler,
  FiberStereoscopicFreeCamera: FiberStereoscopicFreeCamera,
  FiberWebXRCameraProps: FiberWebXRCameraProps,
  FiberWebXRCameraPropsHandler: FiberWebXRCameraPropsHandler,
  FiberWebXRCamera: FiberWebXRCamera,
  FiberBox: FiberBox,
  FiberSphere: FiberSphere,
  FiberDisc: FiberDisc,
  FiberIcoSphere: FiberIcoSphere,
  FiberRibbon: FiberRibbon,
  FiberCylinder: FiberCylinder,
  FiberTorus: FiberTorus,
  FiberTorusKnot: FiberTorusKnot,
  FiberLineSystem: FiberLineSystem,
  FiberLines: FiberLines,
  FiberDashedLines: FiberDashedLines,
  FiberExtrudeShape: FiberExtrudeShape,
  FiberExtrudeShapeCustom: FiberExtrudeShapeCustom,
  FiberLathe: FiberLathe,
  FiberPlane: FiberPlane,
  FiberGround: FiberGround,
  FiberTiledGround: FiberTiledGround,
  FiberGroundFromHeightMap: FiberGroundFromHeightMap,
  FiberPolygon: FiberPolygon,
  FiberExtrudePolygon: FiberExtrudePolygon,
  FiberTube: FiberTube,
  FiberPolyhedron: FiberPolyhedron,
  FiberDecal: FiberDecal,
  FiberMaterialProps: FiberMaterialProps,
  FiberMaterialPropsHandler: FiberMaterialPropsHandler,
  FiberMaterial: FiberMaterial,
  FiberMultiMaterialProps: FiberMultiMaterialProps,
  FiberMultiMaterialPropsHandler: FiberMultiMaterialPropsHandler,
  FiberMultiMaterial: FiberMultiMaterial,
  FiberPushMaterialProps: FiberPushMaterialProps,
  FiberPushMaterialPropsHandler: FiberPushMaterialPropsHandler,
  FiberPushMaterial: FiberPushMaterial,
  FiberStandardMaterialProps: FiberStandardMaterialProps,
  FiberStandardMaterialPropsHandler: FiberStandardMaterialPropsHandler,
  FiberStandardMaterial: FiberStandardMaterial,
  FiberBackgroundMaterialProps: FiberBackgroundMaterialProps,
  FiberBackgroundMaterialPropsHandler: FiberBackgroundMaterialPropsHandler,
  FiberBackgroundMaterial: FiberBackgroundMaterial,
  FiberPBRBaseMaterialProps: FiberPBRBaseMaterialProps,
  FiberPBRBaseMaterialPropsHandler: FiberPBRBaseMaterialPropsHandler,
  FiberPBRBaseMaterial: FiberPBRBaseMaterial,
  FiberPBRBaseSimpleMaterialProps: FiberPBRBaseSimpleMaterialProps,
  FiberPBRBaseSimpleMaterialPropsHandler: FiberPBRBaseSimpleMaterialPropsHandler,
  FiberPBRBaseSimpleMaterial: FiberPBRBaseSimpleMaterial,
  FiberPBRMetallicRoughnessMaterialProps: FiberPBRMetallicRoughnessMaterialProps,
  FiberPBRMetallicRoughnessMaterialPropsHandler: FiberPBRMetallicRoughnessMaterialPropsHandler,
  FiberPBRMetallicRoughnessMaterial: FiberPBRMetallicRoughnessMaterial,
  FiberPBRSpecularGlossinessMaterialProps: FiberPBRSpecularGlossinessMaterialProps,
  FiberPBRSpecularGlossinessMaterialPropsHandler: FiberPBRSpecularGlossinessMaterialPropsHandler,
  FiberPBRSpecularGlossinessMaterial: FiberPBRSpecularGlossinessMaterial,
  FiberPBRMaterialProps: FiberPBRMaterialProps,
  FiberPBRMaterialPropsHandler: FiberPBRMaterialPropsHandler,
  FiberPBRMaterial: FiberPBRMaterial,
  FiberShaderMaterialProps: FiberShaderMaterialProps,
  FiberShaderMaterialPropsHandler: FiberShaderMaterialPropsHandler,
  FiberShaderMaterial: FiberShaderMaterial,
  FiberLightProps: FiberLightProps,
  FiberLightPropsHandler: FiberLightPropsHandler,
  FiberLight: FiberLight,
  FiberHemisphericLightProps: FiberHemisphericLightProps,
  FiberHemisphericLightPropsHandler: FiberHemisphericLightPropsHandler,
  FiberHemisphericLight: FiberHemisphericLight,
  FiberShadowLightProps: FiberShadowLightProps,
  FiberShadowLightPropsHandler: FiberShadowLightPropsHandler,
  FiberShadowLight: FiberShadowLight,
  FiberDirectionalLightProps: FiberDirectionalLightProps,
  FiberDirectionalLightPropsHandler: FiberDirectionalLightPropsHandler,
  FiberDirectionalLight: FiberDirectionalLight,
  FiberPointLightProps: FiberPointLightProps,
  FiberPointLightPropsHandler: FiberPointLightPropsHandler,
  FiberPointLight: FiberPointLight,
  FiberSpotLightProps: FiberSpotLightProps,
  FiberSpotLightPropsHandler: FiberSpotLightPropsHandler,
  FiberSpotLight: FiberSpotLight,
  FiberControlProps: FiberControlProps,
  FiberControlPropsHandler: FiberControlPropsHandler,
  FiberControl: FiberControl,
  FiberCheckboxProps: FiberCheckboxProps,
  FiberCheckboxPropsHandler: FiberCheckboxPropsHandler,
  FiberCheckbox: FiberCheckbox,
  FiberColorPickerProps: FiberColorPickerProps,
  FiberColorPickerPropsHandler: FiberColorPickerPropsHandler,
  FiberColorPicker: FiberColorPicker,
  FiberContainerProps: FiberContainerProps,
  FiberContainerPropsHandler: FiberContainerPropsHandler,
  FiberContainer: FiberContainer,
  FiberEllipseProps: FiberEllipseProps,
  FiberEllipsePropsHandler: FiberEllipsePropsHandler,
  FiberEllipse: FiberEllipse,
  FiberGridProps: FiberGridProps,
  FiberGridPropsHandler: FiberGridPropsHandler,
  FiberGrid: FiberGrid,
  FiberStackPanelProps: FiberStackPanelProps,
  FiberStackPanelPropsHandler: FiberStackPanelPropsHandler,
  FiberStackPanel: FiberStackPanel,
  FiberVirtualKeyboardProps: FiberVirtualKeyboardProps,
  FiberVirtualKeyboardPropsHandler: FiberVirtualKeyboardPropsHandler,
  FiberVirtualKeyboard: FiberVirtualKeyboard,
  FiberRectangleProps: FiberRectangleProps,
  FiberRectanglePropsHandler: FiberRectanglePropsHandler,
  FiberRectangle: FiberRectangle,
  FiberButtonProps: FiberButtonProps,
  FiberButtonPropsHandler: FiberButtonPropsHandler,
  FiberButton: FiberButton,
  FiberSelectionPanelProps: FiberSelectionPanelProps,
  FiberSelectionPanelPropsHandler: FiberSelectionPanelPropsHandler,
  FiberSelectionPanel: FiberSelectionPanel,
  FiberScrollViewerProps: FiberScrollViewerProps,
  FiberScrollViewerPropsHandler: FiberScrollViewerPropsHandler,
  FiberScrollViewer: FiberScrollViewer,
  FiberImageProps: FiberImageProps,
  FiberImagePropsHandler: FiberImagePropsHandler,
  FiberImage: FiberImage,
  FiberInputTextProps: FiberInputTextProps,
  FiberInputTextPropsHandler: FiberInputTextPropsHandler,
  FiberInputText: FiberInputText,
  FiberInputPasswordProps: FiberInputPasswordProps,
  FiberInputPasswordPropsHandler: FiberInputPasswordPropsHandler,
  FiberInputPassword: FiberInputPassword,
  FiberLineProps: FiberLineProps,
  FiberLinePropsHandler: FiberLinePropsHandler,
  FiberLine: FiberLine,
  FiberMultiLineProps: FiberMultiLineProps,
  FiberMultiLinePropsHandler: FiberMultiLinePropsHandler,
  FiberMultiLine: FiberMultiLine,
  FiberRadioButtonProps: FiberRadioButtonProps,
  FiberRadioButtonPropsHandler: FiberRadioButtonPropsHandler,
  FiberRadioButton: FiberRadioButton,
  FiberTextBlockProps: FiberTextBlockProps,
  FiberTextBlockPropsHandler: FiberTextBlockPropsHandler,
  FiberTextBlock: FiberTextBlock,
  FiberDisplayGridProps: FiberDisplayGridProps,
  FiberDisplayGridPropsHandler: FiberDisplayGridPropsHandler,
  FiberDisplayGrid: FiberDisplayGrid,
  FiberBaseSliderProps: FiberBaseSliderProps,
  FiberBaseSliderPropsHandler: FiberBaseSliderPropsHandler,
  FiberBaseSlider: FiberBaseSlider,
  FiberSliderProps: FiberSliderProps,
  FiberSliderPropsHandler: FiberSliderPropsHandler,
  FiberSlider: FiberSlider,
  FiberImageBasedSliderProps: FiberImageBasedSliderProps,
  FiberImageBasedSliderPropsHandler: FiberImageBasedSliderPropsHandler,
  FiberImageBasedSlider: FiberImageBasedSlider,
  FiberControl3DProps: FiberControl3DProps,
  FiberControl3DPropsHandler: FiberControl3DPropsHandler,
  FiberControl3D: FiberControl3D,
  FiberAbstractButton3DProps: FiberAbstractButton3DProps,
  FiberAbstractButton3DPropsHandler: FiberAbstractButton3DPropsHandler,
  FiberAbstractButton3D: FiberAbstractButton3D,
  FiberButton3DProps: FiberButton3DProps,
  FiberButton3DPropsHandler: FiberButton3DPropsHandler,
  FiberButton3D: FiberButton3D,
  FiberHolographicButtonProps: FiberHolographicButtonProps,
  FiberHolographicButtonPropsHandler: FiberHolographicButtonPropsHandler,
  FiberHolographicButton: FiberHolographicButton,
  FiberMeshButton3DProps: FiberMeshButton3DProps,
  FiberMeshButton3DPropsHandler: FiberMeshButton3DPropsHandler,
  FiberMeshButton3D: FiberMeshButton3D,
  FiberContainer3DProps: FiberContainer3DProps,
  FiberContainer3DPropsHandler: FiberContainer3DPropsHandler,
  FiberContainer3D: FiberContainer3D,
  FiberStackPanel3DProps: FiberStackPanel3DProps,
  FiberStackPanel3DPropsHandler: FiberStackPanel3DPropsHandler,
  FiberStackPanel3D: FiberStackPanel3D,
  FiberVolumeBasedPanelProps: FiberVolumeBasedPanelProps,
  FiberVolumeBasedPanelPropsHandler: FiberVolumeBasedPanelPropsHandler,
  FiberVolumeBasedPanel: FiberVolumeBasedPanel,
  FiberCylinderPanelProps: FiberCylinderPanelProps,
  FiberCylinderPanelPropsHandler: FiberCylinderPanelPropsHandler,
  FiberCylinderPanel: FiberCylinderPanel,
  FiberPlanePanelProps: FiberPlanePanelProps,
  FiberPlanePanelPropsHandler: FiberPlanePanelPropsHandler,
  FiberPlanePanel: FiberPlanePanel,
  FiberScatterPanelProps: FiberScatterPanelProps,
  FiberScatterPanelPropsHandler: FiberScatterPanelPropsHandler,
  FiberScatterPanel: FiberScatterPanel,
  FiberSpherePanelProps: FiberSpherePanelProps,
  FiberSpherePanelPropsHandler: FiberSpherePanelPropsHandler,
  FiberSpherePanel: FiberSpherePanel,
  FiberBaseTextureProps: FiberBaseTextureProps,
  FiberBaseTexturePropsHandler: FiberBaseTexturePropsHandler,
  FiberBaseTexture: FiberBaseTexture,
  FiberColorGradingTextureProps: FiberColorGradingTextureProps,
  FiberColorGradingTexturePropsHandler: FiberColorGradingTexturePropsHandler,
  FiberColorGradingTexture: FiberColorGradingTexture,
  FiberCubeTextureProps: FiberCubeTextureProps,
  FiberCubeTexturePropsHandler: FiberCubeTexturePropsHandler,
  FiberCubeTexture: FiberCubeTexture,
  FiberRawCubeTextureProps: FiberRawCubeTextureProps,
  FiberRawCubeTexturePropsHandler: FiberRawCubeTexturePropsHandler,
  FiberRawCubeTexture: FiberRawCubeTexture,
  FiberHDRCubeTextureProps: FiberHDRCubeTextureProps,
  FiberHDRCubeTexturePropsHandler: FiberHDRCubeTexturePropsHandler,
  FiberHDRCubeTexture: FiberHDRCubeTexture,
  FiberTextureProps: FiberTextureProps,
  FiberTexturePropsHandler: FiberTexturePropsHandler,
  FiberTexture: FiberTexture,
  FiberDynamicTextureProps: FiberDynamicTextureProps,
  FiberDynamicTexturePropsHandler: FiberDynamicTexturePropsHandler,
  FiberDynamicTexture: FiberDynamicTexture,
  FiberRawTextureProps: FiberRawTextureProps,
  FiberRawTexturePropsHandler: FiberRawTexturePropsHandler,
  FiberRawTexture: FiberRawTexture,
  FiberRawTexture3DProps: FiberRawTexture3DProps,
  FiberRawTexture3DPropsHandler: FiberRawTexture3DPropsHandler,
  FiberRawTexture3D: FiberRawTexture3D,
  FiberRenderTargetTextureProps: FiberRenderTargetTextureProps,
  FiberRenderTargetTexturePropsHandler: FiberRenderTargetTexturePropsHandler,
  FiberRenderTargetTexture: FiberRenderTargetTexture,
  FiberMirrorTextureProps: FiberMirrorTextureProps,
  FiberMirrorTexturePropsHandler: FiberMirrorTexturePropsHandler,
  FiberMirrorTexture: FiberMirrorTexture,
  FiberMultiRenderTargetProps: FiberMultiRenderTargetProps,
  FiberMultiRenderTargetPropsHandler: FiberMultiRenderTargetPropsHandler,
  FiberMultiRenderTarget: FiberMultiRenderTarget,
  FiberRefractionTextureProps: FiberRefractionTextureProps,
  FiberRefractionTexturePropsHandler: FiberRefractionTexturePropsHandler,
  FiberRefractionTexture: FiberRefractionTexture,
  FiberVideoTextureProps: FiberVideoTextureProps,
  FiberVideoTexturePropsHandler: FiberVideoTexturePropsHandler,
  FiberVideoTexture: FiberVideoTexture,
  FiberProceduralTextureProps: FiberProceduralTextureProps,
  FiberProceduralTexturePropsHandler: FiberProceduralTexturePropsHandler,
  FiberProceduralTexture: FiberProceduralTexture,
  FiberCustomProceduralTextureProps: FiberCustomProceduralTextureProps,
  FiberCustomProceduralTexturePropsHandler: FiberCustomProceduralTexturePropsHandler,
  FiberCustomProceduralTexture: FiberCustomProceduralTexture,
  FiberNoiseProceduralTextureProps: FiberNoiseProceduralTextureProps,
  FiberNoiseProceduralTexturePropsHandler: FiberNoiseProceduralTexturePropsHandler,
  FiberNoiseProceduralTexture: FiberNoiseProceduralTexture,
  FiberAdvancedDynamicTextureProps: FiberAdvancedDynamicTextureProps,
  FiberAdvancedDynamicTexturePropsHandler: FiberAdvancedDynamicTexturePropsHandler,
  FiberAdvancedDynamicTexture: FiberAdvancedDynamicTexture,
  FiberGUI3DManagerProps: FiberGUI3DManagerProps,
  FiberGUI3DManagerPropsHandler: FiberGUI3DManagerPropsHandler,
  FiberGUI3DManager: FiberGUI3DManager,
  FiberShadowGeneratorProps: FiberShadowGeneratorProps,
  FiberShadowGeneratorPropsHandler: FiberShadowGeneratorPropsHandler,
  FiberShadowGenerator: FiberShadowGenerator,
  FiberEnvironmentHelperProps: FiberEnvironmentHelperProps,
  FiberEnvironmentHelperPropsHandler: FiberEnvironmentHelperPropsHandler,
  FiberEnvironmentHelper: FiberEnvironmentHelper,
  FiberVRExperienceHelperProps: FiberVRExperienceHelperProps,
  FiberVRExperienceHelperPropsHandler: FiberVRExperienceHelperPropsHandler,
  FiberVRExperienceHelper: FiberVRExperienceHelper,
  FiberSceneProps: FiberSceneProps,
  FiberScenePropsHandler: FiberScenePropsHandler,
  AbstractButton3D: AbstractButton3D,
  AbstractMesh: AbstractMesh$1,
  AdvancedDynamicTexture: AdvancedDynamicTexture,
  AnaglyphArcRotateCamera: AnaglyphArcRotateCamera,
  AnaglyphFreeCamera: AnaglyphFreeCamera,
  AnaglyphGamepadCamera: AnaglyphGamepadCamera,
  AnaglyphUniversalCamera: AnaglyphUniversalCamera,
  ArcFollowCamera: ArcFollowCamera,
  ArcRotateCamera: ArcRotateCamera,
  BackgroundMaterial: BackgroundMaterial,
  BaseSlider: BaseSlider,
  BaseTexture: BaseTexture,
  Box: Box,
  Button: Button,
  Button3D: Button3D,
  Camera: Camera,
  Checkbox: Checkbox,
  ColorGradingTexture: ColorGradingTexture,
  ColorPicker: ColorPicker,
  Container: Container,
  Container3D: Container3D,
  Control: Control,
  Control3D: Control3D,
  CubeTexture: CubeTexture,
  CustomProceduralTexture: CustomProceduralTexture,
  Cylinder: Cylinder,
  CylinderPanel: CylinderPanel,
  DashedLines: DashedLines,
  Decal: Decal,
  DeviceOrientationCamera: DeviceOrientationCamera,
  DirectionalLight: DirectionalLight,
  Disc: Disc,
  DisplayGrid: DisplayGrid,
  DynamicTexture: DynamicTexture,
  Ellipse: Ellipse,
  EnvironmentHelper: EnvironmentHelper,
  ExtrudePolygon: ExtrudePolygon,
  ExtrudeShape: ExtrudeShape,
  ExtrudeShapeCustom: ExtrudeShapeCustom,
  FlyCamera: FlyCamera,
  FollowCamera: FollowCamera,
  FreeCamera: FreeCamera,
  GUI3DManager: GUI3DManager,
  GamepadCamera: GamepadCamera,
  Grid: Grid,
  Ground: Ground,
  GroundFromHeightMap: GroundFromHeightMap,
  HDRCubeTexture: HDRCubeTexture,
  HemisphericLight: HemisphericLight,
  HolographicButton: HolographicButton,
  IcoSphere: IcoSphere,
  Image: Image,
  ImageBasedSlider: ImageBasedSlider,
  InputPassword: InputPassword,
  InputText: InputText,
  Lathe: Lathe,
  Light: Light,
  Line: Line,
  LineSystem: LineSystem,
  Lines: Lines,
  Material: Material,
  Mesh: Mesh,
  MeshButton3D: MeshButton3D,
  MirrorTexture: MirrorTexture,
  MultiLine: MultiLine,
  MultiMaterial: MultiMaterial,
  MultiRenderTarget: MultiRenderTarget,
  Node: Node,
  NoiseProceduralTexture: NoiseProceduralTexture,
  PBRBaseMaterial: PBRBaseMaterial,
  PBRBaseSimpleMaterial: PBRBaseSimpleMaterial,
  PBRMaterial: PBRMaterial,
  PBRMetallicRoughnessMaterial: PBRMetallicRoughnessMaterial,
  PBRSpecularGlossinessMaterial: PBRSpecularGlossinessMaterial,
  Plane: Plane,
  PlanePanel: PlanePanel,
  PointLight: PointLight,
  Polygon: Polygon,
  Polyhedron: Polyhedron,
  ProceduralTexture: ProceduralTexture,
  PushMaterial: PushMaterial,
  RadioButton: RadioButton,
  RawCubeTexture: RawCubeTexture,
  RawTexture: RawTexture,
  RawTexture3D: RawTexture3D,
  Rectangle: Rectangle,
  RefractionTexture: RefractionTexture,
  RenderTargetTexture: RenderTargetTexture,
  Ribbon: Ribbon,
  ScatterPanel: ScatterPanel,
  ScrollViewer: ScrollViewer,
  SelectionPanel: SelectionPanel,
  ShaderMaterial: ShaderMaterial,
  ShadowGenerator: ShadowGenerator$1,
  ShadowLight: ShadowLight,
  Slider: Slider,
  Sphere: Sphere,
  SpherePanel: SpherePanel,
  SpotLight: SpotLight,
  StackPanel: StackPanel,
  StackPanel3D: StackPanel3D,
  StandardMaterial: StandardMaterial$1,
  StereoscopicArcRotateCamera: StereoscopicArcRotateCamera,
  StereoscopicFreeCamera: StereoscopicFreeCamera,
  StereoscopicGamepadCamera: StereoscopicGamepadCamera,
  StereoscopicUniversalCamera: StereoscopicUniversalCamera,
  TargetCamera: TargetCamera,
  TextBlock: TextBlock,
  Texture: Texture$1,
  TiledGround: TiledGround,
  Torus: Torus,
  TorusKnot: TorusKnot,
  TouchCamera: TouchCamera,
  TransformNode: TransformNode,
  Tube: Tube,
  UniversalCamera: UniversalCamera,
  VRDeviceOrientationArcRotateCamera: VRDeviceOrientationArcRotateCamera,
  VRDeviceOrientationFreeCamera: VRDeviceOrientationFreeCamera,
  VRDeviceOrientationGamepadCamera: VRDeviceOrientationGamepadCamera,
  VRExperienceHelper: VRExperienceHelper,
  VideoTexture: VideoTexture,
  VirtualJoysticksCamera: VirtualJoysticksCamera,
  VirtualKeyboard: VirtualKeyboard,
  VolumeBasedPanel: VolumeBasedPanel,
  WebVRFreeCamera: WebVRFreeCamera,
  WebXRCamera: WebXRCamera
});

var AdvancedDynamicTextureLifecycleListener =
/** @class */
function () {
  function AdvancedDynamicTextureLifecycleListener(scene, props) {
    this.scene = scene;
    this.props = props;
  }

  AdvancedDynamicTextureLifecycleListener.prototype.onParented = function (parent, child) {};

  AdvancedDynamicTextureLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  AdvancedDynamicTextureLifecycleListener.prototype.onMount = function (instance) {
    this.addControls(instance);

    if (instance.customProps.createForParentMesh === true) {
      // console.log('for parent mesh', instance.parent ? instance.parent.babylonJsObject : 'error: no parent object')
      var mesh = instance.parent.hostInstance; // should crawl parent hierarchy for a mesh
      // console.error('we will be attaching the mesh:', mesh.name, mesh);

      var material = new StandardMaterial("AdvancedDynamicTextureMaterial", mesh.getScene());
      material.backFaceCulling = false;
      material.diffuseColor = Color3.Black();
      material.specularColor = Color3.Black();

      if (this.props.onlyAlphaTesting) {
        material.diffuseTexture = instance.hostInstance;
        material.emissiveTexture = instance.hostInstance;
        instance.hostInstance.hasAlpha = true;
      } else {
        material.emissiveTexture = instance.hostInstance;
        material.opacityTexture = instance.hostInstance;
      }

      mesh.material = material;
      var supportPointerMove = this.props.supportPointerMove === true ? true : false;
      instance.hostInstance.attachToMesh(mesh, supportPointerMove);
    }
  };

  AdvancedDynamicTextureLifecycleListener.prototype.addControls = function (instance) {
    var _this = this; // When there is a panel, it must be added before the children. Otherwise there is no UtilityLayer to attach to.
    // This project before 'react-reconciler' was added from parent up the tree.  'react-reconciler' wants to do the opposite.


    instance.children.forEach(function (child) {
      if (child.metadata.isGUI2DControl === true) {
        instance.hostInstance.addControl(child.hostInstance);
        child.state = {
          added: true
        };
      }
    });

    if (instance.customProps.connectControlNames !== undefined && Array.isArray(instance.customProps.connectControlNames)) {
      var controlNames = instance.customProps.connectControlNames;
      var root = instance;

      while (root.parent !== null) {
        root = root.parent;
      }

      this.connect(instance, root, controlNames);
    }

    instance.children.forEach(function (child) {
      _this.addControls(child);
    });
  };

  AdvancedDynamicTextureLifecycleListener.prototype.connect = function (keyboard, searchInstance, controlNames) {
    var _this = this;

    if (searchInstance.metadata.isGUI2DControl && searchInstance.hostInstance && controlNames.indexOf(searchInstance.hostInstance.name) !== -1) {
      // console.log(keyboard.hostInstance, '.connect(->', searchInstance.hostInstance)
      keyboard.hostInstance.connect(searchInstance.hostInstance);
    }

    searchInstance.children.forEach(function (child) {
      return _this.connect(keyboard, child, controlNames);
    });
  };

  return AdvancedDynamicTextureLifecycleListener;
}();

var CameraLifecycleListener =
/** @class */
function () {
  function CameraLifecycleListener(scene, props, canvas) {
    this.props = props;
    this.canvas = canvas;
    this.scene = scene;
  }

  CameraLifecycleListener.prototype.onParented = function (parent, child) {};

  CameraLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  CameraLifecycleListener.prototype.onMount = function (instance) {
    // prevent default unless explicitly specified.
    var camera = instance.hostInstance;
    var noPreventDefault = this.props.noPreventDefault === false ? false : true; // console.log("attachControl. camera:", camera, this.canvas, noPreventDefault)
    // should be a custom property for autoAttaching?  Will be an issue for multiple cameras.

    camera.attachControl(this.canvas, noPreventDefault);

    if (instance.metadata.isTargetable && this.props.lockedTargetMeshName) {
      if (this.scene === null) {
        console.error("no scene for targeting");
      } else {
        var targetCamera = camera;
        targetCamera.lockedTarget = this.scene.getMeshByName(this.props.lockedTargetMeshName);
      }
    }
  };

  return CameraLifecycleListener;
}();

var EnvironmentHelperLifecycleListener =
/** @class */
function () {
  function EnvironmentHelperLifecycleListener(scene, props) {
    this.scene = scene;
    this.props = props;
  }

  EnvironmentHelperLifecycleListener.prototype.onParented = function (parent, child) {};

  EnvironmentHelperLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  EnvironmentHelperLifecycleListener.prototype.onMount = function (instance) {
    if (this.props.mainColor) {
      if (typeof instance.hostInstance.setMainColor === "function") {
        instance.hostInstance.setMainColor(this.props.mainColor);
      }
    }

    if (this.props.teleportEnvironmentGround) {
      console.error("need to enable teleportation to ground (also from VRExperienceHelper, so call order has no impact.");
    }
  };

  return EnvironmentHelperLifecycleListener;
}();

var GUI2DControlLifecycleListener =
/** @class */
function () {
  function GUI2DControlLifecycleListener() {}

  GUI2DControlLifecycleListener.prototype.onParented = function (parent, child) {};

  GUI2DControlLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  GUI2DControlLifecycleListener.prototype.onMount = function (instance) {
    if (instance.customProps.defaultKeyboard === true) {
      // TODO: Generate from factory method.  VirtualKeyboard.CreateDefaultLayout()
      instance.hostInstance.addKeysRow(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "\u2190"]);
      instance.hostInstance.addKeysRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"]);
      instance.hostInstance.addKeysRow(["a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "\u21B5"]);
      instance.hostInstance.addKeysRow(["\u21E7", "z", "x", "c", "v", "b", "n", "m", ",", ".", "/"]);
      instance.hostInstance.addKeysRow([" "], [{
        width: "200px"
      }]);
    }

    if (instance.state && instance.state.added === true) {
      return;
    }

    var addedParent = null;
    var tmp = instance.parent;

    while (tmp) {
      if (tmp.metadata.isGUI2DControl) {
        if (tmp.state && tmp.state.added === true) {
          addedParent = tmp;
          break;
        }
      }

      tmp = tmp.parent;
    }

    if (addedParent) {
      this.addControls(addedParent);
    }
  };

  GUI2DControlLifecycleListener.prototype.addControls = function (instance) {
    var _this = this;

    instance.children.forEach(function (child) {
      if (child.metadata.isGUI2DControl === true) {
        // console.warn("calling ", instance.hostInstance.name, ".addControl(", child.hostInstance.name, ")")
        instance.hostInstance.addControl(child.hostInstance);
        child.state = {
          added: true
        };
      }
    });

    if (instance.customProps.connectControlNames !== undefined && Array.isArray(instance.customProps.connectControlNames)) {
      var controlNames = instance.customProps.connectControlNames;
      var root = instance;

      while (root.parent !== null) {
        root = root.parent;
      }
    }

    instance.children.forEach(function (child) {
      _this.addControls(child);
    });
  };

  return GUI2DControlLifecycleListener;
}();

var GUI3DControlLifecycleListener =
/** @class */
function () {
  function GUI3DControlLifecycleListener(scene) {
    this.scene = scene;
  }

  GUI3DControlLifecycleListener.prototype.onParented = function (parent, child) {};

  GUI3DControlLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  GUI3DControlLifecycleListener.prototype.onMount = function (instance) {
    if (instance.state && instance.state.added === true) {
      return;
    }

    var addedParent = null;
    var tmp = instance.parent;

    while (tmp) {
      if (tmp.metadata.isGUI3DControl === true) {
        if (tmp.state && tmp.state.added === true) {
          addedParent = tmp;
          break;
        }
      }

      tmp = tmp.parent;
    }

    if (addedParent) {
      this.addControls(addedParent, addedParent);
    }
  };

  GUI3DControlLifecycleListener.prototype.addControls = function (instance, last3DGuiControl) {
    var _this = this;

    var last3d = instance.metadata.isGUI3DControl === true ? instance : last3DGuiControl;
    instance.children.forEach(function (child) {
      if (last3d.customProps.childrenAsContent === true) {
        last3d.hostInstance.content = child.hostInstance; // child.hostInstance will be GUI.Control (ie: 2D)

        child.state = {
          added: true,
          content: true
        };
      } else if (child.metadata.isGUI3DControl === true) {
        last3d.hostInstance.addControl(child.hostInstance); // NOTE: this must be called after .addControl(child.hostInstance).

        if (child.customProps.linkToTransformNodeByName) {
          var toLinkTo = _this.scene.getMeshByName(child.customProps.linkToTransformNodeByName);

          if (toLinkTo !== null) {
            child.hostInstance.linkToTransformNode(toLinkTo); // toLinkTo.computeWorldMatrix()
          } else {
            console.error("linkToTransformNode cannot find Mesh:", instance.customProps.linkToTransformNodeByName, " and does not have a scene listener for added meshes." + " Declare Mesh earlier or add an issue on github (TransformNode does not work).");
          }
        }

        child.state = {
          added: true
        };
      }
    });

    if (instance.children.length > 0) {
      instance.children.forEach(function (child) {
        if (!child.state || child.state.content !== true) {
          if (child.state && child.state.added === true && child.customProps.onControlAdded) {
            child.customProps.onControlAdded(child);
          }

          _this.addControls(child, last3d);
        }
      });
    }
  };

  return GUI3DControlLifecycleListener;
}();

var GUI3DManagerLifecycleListener =
/** @class */
function () {
  function GUI3DManagerLifecycleListener(scene) {
    this.scene = scene;
  }

  GUI3DManagerLifecycleListener.prototype.onParented = function (parent) {};

  GUI3DManagerLifecycleListener.prototype.onChildAdded = function (child) {};

  GUI3DManagerLifecycleListener.prototype.onMount = function (instance) {
    this.addControls(instance, instance);
  };
  /**
   * We may have BoundComponents inbetween gui3d controls.
   */


  GUI3DManagerLifecycleListener.prototype.addControls = function (instance, last3DGuiControl) {
    var _this = this; // When there is a panel, it must be added before the children. Otherwise there is no UtilityLayer to attach to.
    // This project before 'react-reconciler' was added from parent up the tree.  'react-reconciler' wants to do the opposite.


    instance.children.forEach(function (child) {
      if (child.metadata.isGUI3DControl === true) {
        if (last3DGuiControl.customProps.childrenAsContent === true) {
          last3DGuiControl.hostInstance.content = child.hostInstance;
          child.state = {
            added: true,
            content: true
          };
        } else {
          last3DGuiControl.hostInstance.addControl(child.hostInstance);
          child.state = {
            added: true
          }; // NOTE: this must be called after .addControl(child.hostInstance).

          if (child.customProps.linkToTransformNodeByName) {
            var toLinkTo = _this.scene.getMeshByName(child.customProps.linkToTransformNodeByName);

            if (toLinkTo !== null) {
              child.hostInstance.linkToTransformNode(toLinkTo);
            } else {
              console.error("linkToTransformNode cannot find ", instance.customProps.linkToTransformNodeByName, " and does not have a scene listener for added meshes.  Declare earlier or add an issue on github.");
            }
          }
        }
      }

      if (child.state && child.state.added === true && child.customProps.onControlAdded) {
        child.customProps.onControlAdded(child);
      }

      if (!child.state || child.state.content !== true) {
        var last3d = child.metadata.isGUI3DControl === true ? child : last3DGuiControl;

        _this.addControls(child, last3d);
      }
    }); // Here we can now do a transform with an anchor point.

    console.error("transform gui3dmanager anchor missing");
  };

  return GUI3DManagerLifecycleListener;
}();

var MaterialsLifecycleListener =
/** @class */
function () {
  function MaterialsLifecycleListener() {}

  MaterialsLifecycleListener.prototype.onCreated = function (instance, scene) {
    if (instance.customProps.attachToMeshesByName) {
      if (!Array.isArray(instance.customProps.attachToMeshesByName)) {
        console.error("AttachToMeshesByName must be an array (of strings).", instance.customProps.attachToMeshesByName);
        return;
      }

      var meshNamesToAttachTo_1 = instance.customProps.attachToMeshesByName.slice(0); // TODO: also need a listener for models or if we want to add a predicate:

      scene.onNewMeshAddedObservable.add(function (mesh) {
        if (meshNamesToAttachTo_1.indexOf(mesh.name) >= 0) {
          setTimeout(function () {
            mesh.material = instance.hostInstance;
          }, 0);
        }
      });
      scene.meshes.forEach(function (mesh) {
        if (meshNamesToAttachTo_1.indexOf(mesh.name) >= 0) {
          mesh.material = instance.hostInstance;
        }
      });
    }
  };

  MaterialsLifecycleListener.prototype.onParented = function (parent) {};

  MaterialsLifecycleListener.prototype.onChildAdded = function (child) {};

  MaterialsLifecycleListener.prototype.onMount = function (instance) {
    if (!instance.customProps.attachToMeshesByName) {
      var material = instance.hostInstance;
      var tmp = instance.parent;

      while (tmp != null) {
        if (tmp.metadata && tmp.metadata.acceptsMaterials === true) {
          tmp.hostInstance.material = material;
          break;
        }

        tmp = tmp.parent;
      }
    }
  };

  return MaterialsLifecycleListener;
}();

var MeshLifecycleListener =
/** @class */
function () {
  function MeshLifecycleListener() {}

  MeshLifecycleListener.prototype.onParented = function (parent, child) {
    if (parent.metadata.isMesh && child.metadata.isMesh) {
      // TODO: consider add option for setParent(), which parents and maintains mesh pos/rot in world space
      //child.hostInstance.setParent(parent.hostInstance)
      child.hostInstance.parent = parent.hostInstance;
    }
  };

  MeshLifecycleListener.prototype.onChildAdded = function (parent, child) {};

  MeshLifecycleListener.prototype.onMount = function (instance) {};

  return MeshLifecycleListener;
}();
/**
 * This is a host component.  Much like a span or div for ReactDOM.render();
 */


var HostWithEventsFiber =
/** @class */
function () {
  function HostWithEventsFiber(scene, engine, props) {
    this._scene = scene;
    this._engine = engine;

    if (props.onParented && typeof props.onParented === "function") {
      this._onParented = props.onParented;
    }

    if (props.onChildAdded && typeof props.onChildAdded === "function") {
      this._onChildAdded = props.onChildAdded;
    }

    if (props.onMount && typeof props.onMount === "function") {
      this._onMount = props.onMount;
    }
  }

  HostWithEventsFiber.prototype.onParented = function (parent) {
    if (parent !== undefined && this._onParented !== undefined) {
      this._hostContextData = this._onParented(this._scene, this._engine, parent);
    }
  };

  HostWithEventsFiber.prototype.onChildAdded = function (child) {
    if (this._onChildAdded) {
      this._hostContextData = this._onChildAdded(this._scene, this._engine, child, this._hostContextData);
    }
  };

  HostWithEventsFiber.prototype.onMount = function (instance) {
    if (this._onMount) {
      this._hostContextData = this._onMount(this._scene, this._engine, instance, this._hostContextData);
    }
  };

  HostWithEventsFiber.prototype.dispose = function () {
    if (this._onUnmount) {
      this._onUnmount(this._scene, this._engine, this._hostContextData);
    }
  };

  return HostWithEventsFiber;
}(); // These are only used by the reconciler.  We export them as strings (as we do for all generated code as well)


var HostWithEvents = "HostWithEvents";
var Model = "Model";
var CUSTOM_HOSTS =
/*#__PURE__*/
Object.freeze({
  HostWithEvents: HostWithEvents,
  Model: Model,
  HostWithEventsFiber: HostWithEventsFiber
});
var LoaderStatus;

(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["Loading"] = 0] = "Loading";
  LoaderStatus[LoaderStatus["Loaded"] = 1] = "Loaded";
  LoaderStatus[LoaderStatus["Error"] = 2] = "Error";
})(LoaderStatus || (LoaderStatus = {}));

var LoadedModel =
/** @class */
function () {
  function LoadedModel() {}

  Object.defineProperty(LoadedModel.prototype, "boundingInfo", {
    get: function get() {
      if (!this.rootMesh) {
        return null;
      } // meshes are already parented to root mesh, so we do not need to look further.


      var min = null;
      var max = null;
      this.rootMesh.getChildMeshes().forEach(function (childMesh) {
        var _a = childMesh.getBoundingInfo().boundingBox,
            minimumWorld = _a.minimumWorld,
            maximumWorld = _a.maximumWorld;

        if (min === null) {
          min = minimumWorld;
        } else {
          min = Vector3.Minimize(min, minimumWorld);
        }

        if (max === null) {
          max = maximumWorld;
        } else {
          max = Vector3.Maximize(max, maximumWorld);
        }
      });

      if (min !== null && max != null) {
        return new BoundingInfo(min, max);
      }

      return null;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Clean up all resources.
   */

  LoadedModel.prototype.dispose = function () {
    if (this.meshes) {
      this.meshes.forEach(function (mesh) {
        mesh.dispose(false
        /* not recursive */
        , true
        /* materials + textures */
        );
      });
      this.meshes = [];
    }

    if (this.particleSystems) {
      this.particleSystems.forEach(function (ps) {
        // ps.stop();
        ps.dispose();
      });
      this.particleSystems = [];
    }

    if (this.skeletons) {
      this.skeletons.forEach(function (skeleton) {
        return skeleton.dispose();
      });
      this.skeletons = [];
    }

    if (this.animationGroups) {
      this.animationGroups.forEach(function (animationGroup) {
        return animationGroup.dispose();
      });
      this.animationGroups = [];
    }
  };

  return LoadedModel;
}();
/**
 * TODO: Integrate this into the generated code, which duplicates for every class.
 */


var BasePropsHandler =
/** @class */
function () {
  function BasePropsHandler(propsHandlers) {
    this.propsHandlers = propsHandlers;
  }

  BasePropsHandler.prototype.getPropsHandlers = function () {
    return this.propsHandlers;
  };

  BasePropsHandler.prototype.addPropsHandler = function (propHandler) {
    this.propsHandlers.push(propHandler);
  };

  return BasePropsHandler;
}();

var __extends$1 = undefined && undefined.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var FiberModel =
/** @class */
function (_super) {
  __extends$1(FiberModel, _super);

  function FiberModel() {
    return _super.call(this, [new ModelPropsHandler()]) || this;
  }

  return FiberModel;
}(BasePropsHandler);

var ModelPropsHandler =
/** @class */
function () {
  function ModelPropsHandler() {}

  ModelPropsHandler.prototype.getPropertyUpdates = function (hostInstance, oldProps, newProps, scene) {
    var propsHandlers = [new FiberMeshPropsHandler(), new FiberAbstractMeshPropsHandler(), new FiberTransformNodePropsHandler(), new FiberNodePropsHandler()];
    var meshUpdates = [];
    propsHandlers.forEach(function (propHandler) {
      // NOTE: this is actually WRONG, because here we want to compare the props with the object.
      var handlerUpdates = propHandler.getPropertyUpdates(hostInstance.rootMesh, oldProps, newProps, scene);

      if (handlerUpdates !== null) {
        meshUpdates.push.apply(meshUpdates, handlerUpdates);
      }
    });

    if (meshUpdates.length === 0) {
      return null;
    } // add target


    meshUpdates.forEach(function (propertyUpdate) {
      return propertyUpdate.target = "rootMesh";
    });
    return meshUpdates;
  };

  return ModelPropsHandler;
}();

var CreationType =
/** @class */
function () {
  function CreationType() {}

  CreationType.FactoryMethod = "FactoryMethod";
  CreationType.Constructor = "Constructor";
  return CreationType;
}();

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var applyUpdateToInstance = function applyUpdateToInstance(hostInstance, update, type) {
  var target = update.target !== undefined ? hostInstance[update.target] : hostInstance;

  switch (update.type) {
    case "string":
    case "number":
    case "boolean":
    case "string | number":
      // TODO: string | number is a deficiency in the code generator.  ie: can test for only primitives | and generate update type in code generator
      // console.log(` > ${type}: updating ${update.type} on ${update.propertyName} to ${update.value}`)
      target[update.propertyName] = update.value;
      break;

    case "BABYLON.Vector3":
      // TODO: merge with Color3
      if (target[update.propertyName]) {
        target[update.propertyName].copyFrom(update.value);
      } else if (update.value) {
        target[update.propertyName] = update.value.clone();
      } else {
        target[update.propertyName] = update.value; // ie: undefined/null?
      }

      break;

    case "BABYLON.Color3":
      // merge this switch with BABYLON.Vector3, Color4, etc.  The copyFrom BABYLON types.
      if (target[update.propertyName]) {
        target[update.propertyName].copyFrom(update.value);
      } else if (update.value) {
        target[update.propertyName] = update.value.clone();
      } else {
        target[update.propertyName] = update.value;
      }

      break;

    case "BABYLON.Mesh":
      // console.log(` > ${type}: updating Mesh on:${update.propertyName} to ${update.value}`)
      if (target[update.propertyName] && update.value) {
        if (target[update.propertyName].uniqueId != update.value.uniqueId) {
          target[update.propertyName] = update.value;
        }
      } else {
        target[update.propertyName] = update.value;
      }

      break;

    case "BABYLON.GUI.Control":
      target[update.propertyName] = update.value;
      break;

    default:
      if (update.type.startsWith("BABYLON.Observable")) {
        // TODO: we want to remove the old prop when changed, so it should be passed along as well.
        //if (update.prevValue) {
        //  babylonObject[update.propertyName].remove(update.prevValue)
        //}
        target[update.propertyName].add(update.value);
      } else if (update.type.startsWith("(")) {
        if (typeof target[update.propertyName] === "function") {
          if (Array.isArray(update.value)) {
            target[update.propertyName].apply(target, update.value);
          } else {
            target[update.propertyName].apply(target, Object.values(update.value));
          }
        } else {
          console.error("Cannot call [not a function] " + update.propertyName + "(...) on:", update.type, target);
        }
      } else {
        console.error("Unhandled property update of type " + update.type);
      }

      break;
  }
};

function createCreatedInstance(className, hostInstance, propsHandlers, metadata, customProps, lifecycleListener) {
  var createdMetadata = metadata; // TODO: move how this is generated as a boolean to a metadata on objects themselves (and the next 3 lines!).

  if (propsHandlers.isTargetable === true) {
    createdMetadata.isTargetable = true;
  }

  return {
    hostInstance: hostInstance,
    metadata: createdMetadata,
    parent: null,
    children: [],
    propsHandlers: propsHandlers,
    lifecycleListener: lifecycleListener,
    customProps: customProps
  };
}

var ReactBabylonJSHostConfig = {
  // This has the reconciler include in call chain ie: appendChild, removeChild
  get supportsMutation() {
    return true;
  },

  now: function now() {
    return Date.now(); // TODO: use performance.now
  },

  // multiple renderers concurrently render using the same context objects. E.g. React DOM and React ART on the
  // same page. DOM is the primary renderer; ART is the secondary renderer.
  get isPrimaryRenderer() {
    return false;
  },

  get supportsPersistence() {
    return false;
  },

  // TODO: see if this will allow ie: improved HMR support.  Need to implement a lot of currently optional methods.
  get supportsHydration() {
    return false;
  },

  // this enables refs
  getPublicInstance: function getPublicInstance(instance) {
    return instance;
  },
  getRootHostContext: function getRootHostContext(rootContainerInstance) {
    // this is the context you pass to your chilren, as parameter 'parentHostContext' from "root".
    // So, opportunity to share context here via HostConfig further up tree.
    return {
      canvas: rootContainerInstance.canvas,
      engine: rootContainerInstance.engine,
      scene: rootContainerInstance.scene,
      rootInstance: {
        hostInstance: undefined,
        metadata: {
          className: "rootContainer",
          namespace: "ignore"
        },
        parent: null,
        children: [],
        customProps: {}
      }
    };
  },
  // this is the context you pass down to children.  without this root will not be available to attach to in appendChildToContainer.
  getChildHostContext: function getChildHostContext(parentHostContext, type, rootContainerInstance) {
    return parentHostContext;
  },
  prepareUpdate: function prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, hostContext) {
    if (!instance || instance.metadata && instance.metadata.customType === true) {
      return null;
    }

    var updatePayload = []; // Only custom types will not have a fiber object to handle props changes

    instance.propsHandlers.getPropsHandlers().forEach(function (propHandler) {
      var handlerUpdates = propHandler.getPropertyUpdates(instance, oldProps, newProps, rootContainerInstance.scene);

      if (handlerUpdates !== null) {
        updatePayload.push.apply(updatePayload, handlerUpdates);
      }
    });
    return updatePayload.length == 0 ? null : updatePayload;
  },

  /**
   * This is called when something is dynamically added to root (not on initial appendChildToContainer)
   */
  insertInContainerBefore: function insertInContainerBefore(container, child, beforeChild) {
    // same implementation as appendChildToContainer
    if (child) {
      // doubly link child to root.  we don't care about order - ie: 'beforeChild'
      container.rootInstance.children.push(child);
      child.parent = container.rootInstance;
    } else {
      console.error("insertInContainerBefore. No child:", child);
    }
  },
  createInstance: function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
    var _a, _b, _c; // TODO: Make a registry like React Native host config or just build a map in /customHosts/index.ts.


    var customTypes = [HostWithEvents]; // TODO: Check source for difference between hostContext and rootContainerInstance.

    var canvas = rootContainerInstance.canvas,
        engine = rootContainerInstance.engine,
        scene = rootContainerInstance.scene;

    if (customTypes.indexOf(type) !== -1) {
      var metadata_1 = __assign({
        className: type,
        customType: true
      }, props.metadata);

      var createdInstance = {
        hostInstance: null,
        metadata: metadata_1,
        parent: null,
        children: [],
        propsHandlers: undefined,
        customProps: {},
        lifecycleListener: new CUSTOM_HOSTS[type + "Fiber"](scene, engine, props)
      }; // onCreated and other lifecycle hooks are not called for built-in host

      return createdInstance;
    } // so far this is the only non-babylonJS host component, but otherwise a more generic solution will be needed:


    if (type === "Model") {
      var createdInstance = {
        hostInstance: new LoadedModel()
        /* this is reassigned in Lifecycle Listener */
        ,
        metadata: {
          className: "Model"
        },
        parent: null,
        children: [],
        propsHandlers: new FiberModel(),
        lifecycleListener: new ModelLifecycleListener(scene
        /* should always be available */
        , props),
        customProps: {}
      }; // onCreated and other lifecycle hooks are not called for built-in host

      return createdInstance;
    }

    var classDefinition = GENERATED["Fiber" + type];

    if (classDefinition === undefined) {
      throw new Error("Cannot generate type '" + type + "' inside 'react-babylonjs' (ie: no DOM rendering on HTMLCanvas)");
    }

    var createInfoArgs = classDefinition.CreateInfo;
    var metadata = classDefinition.Metadata; // console.log(`creating: ${createInfoArgs.namespace}.${type}`)

    var generatedParameters = createInfoArgs.parameters; // console.log("generated params:", generatedParameters)

    var args = generatedParameters.map(function (generatedParameter) {
      if (Array.isArray(generatedParameter.type)) {
        // TODO: if all props are missing, warn if main prop (ie: options) is required.
        var newParameter_1 = {};
        generatedParameter.type.forEach(function (subParameter) {
          var subPropValue = props[subParameter.name];

          if (subPropValue === undefined && subParameter.optional === false && generatedParameter.optional === false) {
            console.warn("Missing a required secondary property:", subParameter.name);
          } else {
            newParameter_1[subParameter.name] = subPropValue;
          }
        });
        return newParameter_1;
      } else {
        var value = props[generatedParameter.name];

        if (value === undefined && generatedParameter.optional === false) {
          // NOTE: we removed the hosted Scene component, which needs (generatedParameter.type == "BABYLON.Engine")
          if (generatedParameter.type === "BABYLON.Scene" || generatedParameter.type === "any" && generatedParameter.name === "scene") {
            // MeshBuild.createSphere(name: string, options: {...}, scene: any)
            value = scene;
          } else {
            console.warn("On " + type + " you are missing a non-optional parameter '" + generatedParameter.name + "' of type '" + generatedParameter.type + "'");
          }
        }

        return value;
      }
    });
    var babylonObject = undefined;

    if (createInfoArgs.creationType === CreationType.FactoryMethod) {
      // console.log("creating from factory", type, ...args)
      //yconsole.dir(args)
      babylonObject = (_a = BABYLON$1.MeshBuilder)[createInfoArgs.factoryMethod].apply(_a, args);
    } else {
      if (metadata.delayCreation !== true) {
        switch (createInfoArgs.namespace) {
          case "BABYLON":
            // console.log("creating:", type, ...args)
            babylonObject = new ((_b = BABYLON$1[type]).bind.apply(_b, [void 0].concat(args)))();
            break;

          case "GUI":
            // console.log("creating GUI", type, ...args)
            babylonObject = new ((_c = GUI[type]).bind.apply(_c, [void 0].concat(args)))();
            break;

          default:
            console.error("metadata defines (or does not) an namespace that is known", metadata);
            break;
        }
      }
    } // Developer accessible lifecycle phase.  ie: access propery/method exposed in props.


    if (typeof props.onCreated === "function") {
      props.onCreated(babylonObject);
    }

    var fiberObject = new GENERATED["Fiber" + type]();
    var lifecycleListener = undefined;
    var customProps = {
      childrenAsContent: props.childrenAsContent === true,
      createForParentMesh: props.createForParentMesh === true,
      onControlAdded: typeof props.onControlAdded === "function" ? props.onControlAdded : undefined,
      connectControlNames: props.connectControlNames,
      defaultKeyboard: props.defaultKeyboard === true,
      linkToTransformNodeByName: props.linkToTransformNodeByName,
      shadowCasters: props.shadowCasters,
      attachToMeshesByName: props.attachToMeshesByName // for materials - otherwise will attach to first parent that accepts materials

    }; // Consider these being dynamically attached to a list, much like PropsHandlers<T>

    if (metadata.isMaterial === true) {
      lifecycleListener = new MaterialsLifecycleListener();
    } else if (metadata.isGUI3DControl === true) {
      lifecycleListener = new GUI3DControlLifecycleListener(scene);
    } else if (metadata.isGUI2DControl === true) {
      lifecycleListener = new GUI2DControlLifecycleListener();
    } else if (metadata.isTexture === true) {
      lifecycleListener = new TexturesLifecycleListener();
    } else if (metadata.isCamera === true) {
      lifecycleListener = new CameraLifecycleListener(scene, props, canvas);
    } else if (metadata.isMesh === true) {
      lifecycleListener = new MeshLifecycleListener();
    } // here we dynamically assign listeners for specific types.


    if (CUSTOM_COMPONENTS[type + "LifecycleListener"] !== undefined) {
      lifecycleListener = new CUSTOM_COMPONENTS[type + "LifecycleListener"](scene, props);
    }

    var createdReference = createCreatedInstance(type, babylonObject, fiberObject, metadata, customProps, lifecycleListener);

    if (lifecycleListener && lifecycleListener.onCreated) {
      lifecycleListener.onCreated(createdReference, scene);
    } // Here we dynamically attach known props handlers.  Will be adding more in code generation for GUI - also for lifecycle mgmt.


    if (createdReference.metadata && createdReference.metadata.isTargetable === true) {
      fiberObject.addPropsHandler(new TargetPropsHandler());
    }

    if (metadata.delayCreation !== true) {
      var initPayload_1 = [];
      fiberObject.getPropsHandlers().forEach(function (propHandler) {
        // NOTE: this is actually WRONG, because here we want to compare the props with the object.
        var handlerUpdates = propHandler.getPropertyUpdates(createdReference, {}, // Here we will reapply things like 'name', so perhaps should get default props from 'babylonObject'.
        props, scene // custom handlers may require scene access.
        );

        if (handlerUpdates !== null) {
          initPayload_1.push.apply(initPayload_1, handlerUpdates);
        }
      });

      if (initPayload_1.length > 0) {
        initPayload_1.forEach(function (update) {
          applyUpdateToInstance(babylonObject, update, type);
        });
      }
    }

    return createdReference;
  },
  shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree(type, props) {
    return false;
  },
  createTextInstance: function createTextInstance() {
    return undefined;
  },
  scheduleDeferredCallback: function scheduleDeferredCallback(callback, opts) {
    return window.requestIdleCallback(callback, opts); // ReactDOMHostConfig has: unstable_scheduleCallback as scheduleDeferredCallback
  },
  cancelDeferredCallback: function cancelDeferredCallback(handle) {
    return window.cancelIdleCallback(handle);
  },
  setTimeout: function setTimeout(handler, timeout) {
    return window.setTimeout(handler);
  },
  clearTimeout: function clearTimeout(handle) {
    window.clearTimeout(handle);
  },
  // https://github.com/facebook/react/blob/master/packages/react-dom/src/client/ReactDOMHostConfig.js#L288
  noTimeout: -1,
  // Called based on return value of: finalizeInitialChildren.  in-memory render tree created, but not yet attached.
  prepareForCommit: function prepareForCommit(containerInfo) {},
  // Called after the in-memory tree has been committed (ie: after attaching again to root element)
  resetAfterCommit: function resetAfterCommit(containerInfo) {},
  appendInitialChild: function appendInitialChild(parent, child) {
    // Here we are traversing downwards.  Beyond parent has not been initialized, but all children have been.
    if (parent) {
      // doubly linking child to parent
      parent.children.push(child); // TODO: need to remove from children as well when removing.

      child.parent = parent;
    }

    if (child && child.lifecycleListener && child.lifecycleListener.onParented) {
      child.lifecycleListener.onParented(parent, child);
    }

    if (parent && parent.lifecycleListener && parent.lifecycleListener.onChildAdded) {
      parent.lifecycleListener.onChildAdded(child, parent);
    }
  },
  appendChild: function appendChild(parent, child) {
    parent.children.push(child);
    child.parent = parent;
  },
  canHydrateInstance: function canHydrateInstance(instance, type, props) {
    console.log("canHydrateInstance", instance, type, props);
    return null;
  },
  // The parent of this node has not yet been instantiated.  The reconciler will continue by calling:
  // createInstance → appendInitialChild → finalizeInitialChildren on the parent.
  // When that has reached the top of the recursion tree (root), then prepareForCommit() will be called.
  // NOTE: All children of this component, however, HAVE been initialized.
  finalizeInitialChildren: function finalizeInitialChildren() {
    return true;
    /* callCommitMountForThisInstance */
  },
  commitMount: function commitMount(instance, type, newProps, internalInstanceHandle) {
    if (instance && instance.lifecycleListener && instance.lifecycleListener.onMount) {
      instance.lifecycleListener.onMount(instance);
    }
  },
  // NOTE: only called if supportsMutation = true;
  // ReactDOM uses this for attaching child nodes to root DOM.  For us we want to link the all parts of tree together for tree crawling.
  // same implementation as insertInContainerBefore
  appendChildToContainer: function appendChildToContainer(container, child) {
    if (child) {
      // doubly link child to root
      container.rootInstance.children.push(child);
      child.parent = container.rootInstance;
    }
  },
  commitUpdate: function commitUpdate(instance, updatePayload, type
  /* old + new props are extra params here */
  ) {
    if (updatePayload != null) {
      updatePayload.forEach(function (update) {
        applyUpdateToInstance(instance.hostInstance, update, type);
      });
    }
  },
  removeChildFromContainer: function removeChildFromContainer(container, child) {
    if (child && child.hostInstance && typeof child.hostInstance.dispose === "function") {
      child.hostInstance.dispose();
    }

    console.error("need to remove child from parent (container)");
  },
  removeChild: function removeChild(parentInstance, child) {
    if (child.metadata.isGUI3DControl === true) {
      console.error("3D remove control not implemented.");
    }

    if (parentInstance.metadata.isGUI2DControl === true && child.metadata.isGUI2DControl === true) {
      // NOTE: the if statement should be || and we may need to walk the tree to remove.
      parentInstance.hostInstance.removeControl(child.hostInstance);
    }

    if (typeof child.hostInstance.dispose === "function") {
      child.hostInstance.dispose(); // TODO: Consider adding metadata/descriptors as some dispose methods have optional args.
    }

    parentInstance.children = parentInstance.children.filter(function (ci) {
      return ci !== child;
    });
    child.parent = null;
  },
  // text-content nodes are not used.  treated as a leaf node.  children are not traversed.  calls methods like createTextInstance(...)
  shouldSetTextContent: function shouldSetTextContent(type, props) {
    return false;
  }
};

var ModelLifecycleListener =
/** @class */
function () {
  function ModelLifecycleListener(scene, props) {
    this.props = props;
    this.scene = scene;
  }

  ModelLifecycleListener.prototype.onParented = function (parent, child) {};

  ModelLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  ModelLifecycleListener.prototype.onMount = function (instance) {
    var _this = this;

    var loadedModel = new LoadedModel();
    loadedModel.status = LoaderStatus.Loading;
    instance.hostInstance = loadedModel;
    var loader = SceneLoader.ImportMesh(undefined, this.props.rootUrl, this.props.sceneFilename, this.scene, function (meshes, particleSystems, skeletons, animationGroups) {
      loadedModel.rootMesh = new AbstractMesh(_this.props.sceneFilename + "-model");
      loadedModel.rootMesh.alwaysSelectAsActiveMesh = true;
      loadedModel.meshes = [];
      meshes.forEach(function (mesh) {
        loadedModel.meshes.push(mesh); // leave meshes already parented to maintain model hierarchy:

        if (!mesh.parent) {
          mesh.parent = loadedModel.rootMesh;
        }

        if (_this.props.receiveShadows === true) {
          mesh.receiveShadows = true;
        }
      });
      loadedModel.particleSystems = particleSystems;
      loadedModel.skeletons = skeletons;
      loadedModel.animationGroups = animationGroups;

      if (_this.props.onModelLoaded) {
        _this.props.onModelLoaded(loadedModel);
      }

      loadedModel.status = LoaderStatus.Loaded; // we want to trigger after mesh is loaded (ie: position/rotation)

      var updates = new ModelPropsHandler().getPropertyUpdates(loadedModel, {
        rootUrl: "",
        sceneFilename: ""
      }, _this.props, _this.scene);

      if (updates != null) {
        updates.forEach(function (update) {
          return applyUpdateToInstance(instance.hostInstance, update, "model");
        });
      }

      if (_this.props.scaleToDimension && loadedModel && loadedModel.scaleToDimension !== _this.props.scaleToDimension) {
        var boundingInfo = loadedModel.boundingInfo; // will be null when no meshes are loaded

        if (boundingInfo) {
          var longestDimension = Math.max(Math.abs(boundingInfo.minimum.x - boundingInfo.maximum.x), Math.abs(boundingInfo.minimum.y - boundingInfo.maximum.y), Math.abs(boundingInfo.minimum.z - boundingInfo.maximum.z));
          var dimension = _this.props.scaleToDimension / longestDimension;
          loadedModel.rootMesh.scaling.scaleInPlace(dimension);
          loadedModel.scaleToDimension = _this.props.scaleToDimension;
        }
      }
    }, function (event) {
      if (_this.props.onLoadProgress) {
        _this.props.onLoadProgress(event);
      }
    }, function (scene, message, exception) {
      loadedModel.status = LoaderStatus.Error;
      loadedModel.errorMessage = "error: " + message + " -> " + (exception ? exception.message : "no exception");

      if (_this.props.onModelError) {
        _this.props.onModelError(loadedModel);
      }
    }, this.props.pluginExtension);

    if (loader) {
      loadedModel.loaderName = loader.name;
    } else {
      loadedModel.loaderName = "no loader found";
    }
  };

  return ModelLifecycleListener;
}();

var AdvancedDynamicTextureLifecycleListener$1 =
/** @class */
function () {
  function AdvancedDynamicTextureLifecycleListener(scene, props) {
    this.scene = scene;
    this.props = props;
  }

  AdvancedDynamicTextureLifecycleListener.prototype.onParented = function (parent, child) {};

  AdvancedDynamicTextureLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  AdvancedDynamicTextureLifecycleListener.prototype.onMount = function (instance) {
    var tmp = instance.parent;

    while (tmp != null) {
      if (tmp.metadata.isShadowLight) {
        // console.log("Creating ShadowGenerator.  size:", this.props.mapSize, "light", tmp.hostInstance)
        instance.hostInstance = new ShadowGenerator(this.props.mapSize, tmp.hostInstance, this.props.useFullFloatFirst);
        break;
      }

      tmp = tmp.parent;
    }

    if (instance.hostInstance === undefined) {
      console.error("ShadowGenerator has no light source.");
    }

    if (instance.customProps.shadowCasters) {
      if (!Array.isArray(instance.customProps.shadowCasters)) {
        console.error("Shadow casters must be an array (of strings).", instance.customProps.shadowCasters);
        return;
      }

      var shadowCasters_1 = instance.customProps.shadowCasters.slice(0); // TODO: also need a listener for models or if we want to add a predicate:

      this.scene.onNewMeshAddedObservable.add(function (mesh) {
        if (shadowCasters_1.indexOf(mesh.name) >= 0) {
          // console.log("adding on observable shadow caster:", mesh.name)
          instance.hostInstance.addShadowCaster(mesh);
          shadowCasters_1 = shadowCasters_1.filter(function (name) {
            return name !== mesh.name;
          });
        }
      });
      this.scene.meshes.forEach(function (mesh) {
        if (shadowCasters_1.indexOf(mesh.name) >= 0) {
          // console.log("adding shadow caster:", mesh.name)
          instance.hostInstance.addShadowCaster(mesh);
          shadowCasters_1 = shadowCasters_1.filter(function (name) {
            return name !== mesh.name;
          });
        }
      });
    }
  };

  return AdvancedDynamicTextureLifecycleListener;
}();

var Skybox = function Skybox(props) {
  return React.createElement("Box", {
    size: 100,
    infiniteDistance: true,
    renderingGroupId: 0
  }, [React.createElement("StandardMaterial", {
    backFaceCulling: false,
    disableLighting: true
  }, [React.createElement("CubeTexture", {
    key: "cube-texture-" + props.rootUrl,
    rootUrl: props.rootUrl,
    coordinatesMode: Texture.SKYBOX_MODE
  })])]);
}; // This does not work when declared component with "lockedTargetMeshName" is before the mesh with that name.
// Need to wait for full commit mount of entire tree, so use in conjunction with LifecycleListner is best option.


var TargetPropsHandler =
/** @class */
function () {
  function TargetPropsHandler() {}

  TargetPropsHandler.prototype.getPropertyUpdates = function (createdInstance, oldProps, newProps, scene) {
    var propertyUpdates = [];

    if (!oldProps.lockedTargetMeshName || oldProps.lockedTargetMeshName !== newProps.lockedTargetMeshName) {
      if (typeof newProps.lockedTargetMeshName == "string") {
        propertyUpdates.push({
          type: "BABYLON.Mesh",
          value: scene.getMeshByName(newProps.lockedTargetMeshName),
          propertyName: "lockedTarget"
        });
      }
    }

    return propertyUpdates;
  };

  return TargetPropsHandler;
}();

var TexturesLifecycleListener =
/** @class */
function () {
  function TexturesLifecycleListener() {}

  TexturesLifecycleListener.prototype.onParented = function (parent) {};

  TexturesLifecycleListener.prototype.onChildAdded = function (child) {};

  TexturesLifecycleListener.prototype.onMount = function (instance) {
    var texture = instance.hostInstance;
    var tmp = instance.parent;

    while (tmp != null) {
      if (tmp.metadata && tmp.metadata.isMaterial === true) {
        console.error("Skybox specific code.  Assigning reflection texture.  Need custom properties to define which texture/coordinatesMode to apply", texture, BABYLON.Texture.SKYBOX_MODE);
        tmp.hostInstance.reflectionTexture = texture; // need a way to assign different textures;

        tmp.hostInstance.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        break;
      }

      tmp = tmp.parent;
    }
  };

  return TexturesLifecycleListener;
}();

var VRExperienceHelperLifecycleListener =
/** @class */
function () {
  function VRExperienceHelperLifecycleListener(props) {
    this.props = props;
  }

  VRExperienceHelperLifecycleListener.prototype.onParented = function (parent, child) {};

  VRExperienceHelperLifecycleListener.prototype.onChildAdded = function (child, parent) {};

  VRExperienceHelperLifecycleListener.prototype.onMount = function (instance) {
    if (this.props.enableInteractions) {
      if (typeof instance.hostInstance.enableInteractions === "function") {
        instance.hostInstance.enableInteractions();
      }
    }
  };

  return VRExperienceHelperLifecycleListener;
}();

var __extends$2 = undefined && undefined.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign$1 = undefined && undefined.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}; // TODO: build a fallback mechanism when typeof React.createContext !== 'function'
// this will allow (16.0 <= react versions < 16.3) to work.


var BabylonJSContext = createContext({
  engine: null,
  canvas: null
});
var BabylonJSContextConsumer = BabylonJSContext.Consumer;

function withBabylonJS(Component) {
  return function BoundComponent(props) {
    return React.createElement(BabylonJSContext.Consumer, null, function (ctx) {
      return React.createElement(Component, __assign$1({}, props, {
        babylonJSContext: ctx
      }));
    });
  };
}

var Engine =
/** @class */
function (_super) {
  __extends$2(Engine, _super);

  function Engine(props) {
    var _this = _super.call(this, props) || this;

    _this._engine = null;
    _this._canvas = null;

    _this.onCanvasRef = function (c) {
      // We are not using the react.createPortal(...), as it adds a ReactDOM dependency, but also 
      // it was not flowing the context through to HOCs properly.
      if (_this.props.portalCanvas) {
        _this._canvas = document.getElementById('portal-canvas');
        console.error('set canvas', _this._canvas);
      } else {
        if (c !== null) {
          // null when called from unmountComponent()
          //c.addEventListener('mouseover', this.focus)
          //c.addEventListener('mouseout', this.blur)
          _this._canvas = c;
        }
      } // console.error('onCanvas:', c); // trying to diagnose why HMR keep rebuilding entire Scene!  Look at ProxyComponent v4.

    };

    _this.onResizeWindow = function () {
      if (_this._engine) {
        _this._engine.resize();
      }
    };

    _this.state = {
      canRender: false
    };
    return _this;
  }

  Engine.prototype.componentDidMount = function () {
    var _this = this;

    this._engine = new BABYLON$1.Engine(this._canvas, this.props.antialias === true ? true : false, // default false
    this.props.engineOptions, this.props.adaptToDeviceRatio === true ? true : false // default false
    );

    this._engine.runRenderLoop(function () {
      _this._engine.scenes.forEach(function (scene) {
        scene.render();
      });
    });

    this._engine.onContextLostObservable.add(function (eventData) {
      console.log('context loss observable from Engine: ', eventData);
    });

    window.addEventListener('resize', this.onResizeWindow);
    this.setState({
      canRender: true
    });
  };

  Engine.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.onResizeWindow);
  };

  Engine.prototype.render = function () {
    if (this.state.canRender === false && this.props.noSSR !== undefined && this.props.noSSR !== false) {
      if (typeof this.props.noSSR === 'boolean') {
        return null;
      }

      return this.props.noSSR;
    }

    var _a = this.props,
        touchActionNone = _a.touchActionNone,
        width = _a.width,
        height = _a.height,
        canvasStyle = _a.canvasStyle,
        canvasId = _a.canvasId,
        rest = __rest(_a, ["touchActionNone", "width", "height", "canvasStyle", "canvasId"]);

    var opts = {};

    if (touchActionNone !== false) {
      opts['touch-action'] = 'none';
    }

    if (width !== undefined && height !== undefined) {
      opts.width = width;
      opts.height = height;
    }

    if (canvasId) {
      opts.id = canvasId;
    }

    if (canvasStyle) {
      opts.style = canvasStyle;
    } // TODO: this.props.portalCanvas does not need to render a canvas.


    return React.createElement(BabylonJSContext.Provider, {
      value: {
        engine: this._engine,
        canvas: this._canvas
      }
    }, React.createElement("canvas", __assign$1({}, opts, {
      ref: this.onCanvasRef
    }), this._engine !== null && this.props.children));
  };

  return Engine;
}(React.Component);

var Engine$1 = withBabylonJS(Engine);

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */


var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
var scheduler_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var d = null,
      f = !1,
      h = 3,
      k = -1,
      l = -1,
      m = !1,
      n = !1;

  function p() {
    if (!m) {
      var a = d.expirationTime;
      n ? q() : n = !0;

      _r(t, a);
    }
  }

  function u() {
    var a = d,
        b = d.next;
    if (d === b) d = null;else {
      var c = d.previous;
      d = c.next = b;
      b.previous = c;
    }
    a.next = a.previous = null;
    c = a.callback;
    b = a.expirationTime;
    a = a.priorityLevel;
    var e = h,
        Q = l;
    h = a;
    l = b;

    try {
      var g = c();
    } finally {
      h = e, l = Q;
    }

    if ("function" === typeof g) if (g = {
      callback: g,
      priorityLevel: a,
      expirationTime: b,
      next: null,
      previous: null
    }, null === d) d = g.next = g.previous = g;else {
      c = null;
      a = d;

      do {
        if (a.expirationTime >= b) {
          c = a;
          break;
        }

        a = a.next;
      } while (a !== d);

      null === c ? c = d : c === d && (d = g, p());
      b = c.previous;
      b.next = c.previous = g;
      g.next = c;
      g.previous = b;
    }
  }

  function v() {
    if (-1 === k && null !== d && 1 === d.priorityLevel) {
      m = !0;

      try {
        do {
          u();
        } while (null !== d && 1 === d.priorityLevel);
      } finally {
        m = !1, null !== d ? p() : n = !1;
      }
    }
  }

  function t(a) {
    m = !0;
    var b = f;
    f = a;

    try {
      if (a) for (; null !== d;) {
        var c = exports.unstable_now();

        if (d.expirationTime <= c) {
          do {
            u();
          } while (null !== d && d.expirationTime <= c);
        } else break;
      } else if (null !== d) {
        do {
          u();
        } while (null !== d && !w());
      }
    } finally {
      m = !1, f = b, null !== d ? p() : n = !1, v();
    }
  }

  var x = Date,
      y = "function" === typeof setTimeout ? setTimeout : void 0,
      z = "function" === typeof clearTimeout ? clearTimeout : void 0,
      A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
      B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
      C,
      D;

  function E(a) {
    C = A(function (b) {
      z(D);
      a(b);
    });
    D = y(function () {
      B(C);
      a(exports.unstable_now());
    }, 100);
  }

  if ("object" === typeof performance && "function" === typeof performance.now) {
    var F = performance;

    exports.unstable_now = function () {
      return F.now();
    };
  } else exports.unstable_now = function () {
    return x.now();
  };

  var _r, q, w;

  if ("undefined" !== typeof window && window._schedMock) {
    var G = window._schedMock;
    _r = G[0];
    q = G[1];
    w = G[2];
  } else if ("undefined" === typeof window || "function" !== typeof window.addEventListener) {
    var H = null,
        I = -1,
        J = function J(a, b) {
      if (null !== H) {
        var c = H;
        H = null;

        try {
          I = b, c(a);
        } finally {
          I = -1;
        }
      }
    };

    _r = function r(a, b) {
      -1 !== I ? setTimeout(_r, 0, a, b) : (H = a, setTimeout(J, b, !0, b), setTimeout(J, 1073741823, !1, 1073741823));
    };

    q = function q() {
      H = null;
    };

    w = function w() {
      return !1;
    };

    exports.unstable_now = function () {
      return -1 === I ? 0 : I;
    };
  } else {
    "undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    var K = null,
        L = !1,
        M = -1,
        N = !1,
        O = !1,
        P = 0,
        R = 33,
        S = 33;

    w = function w() {
      return P <= exports.unstable_now();
    };

    var T = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
    window.addEventListener("message", function (a) {
      if (a.source === window && a.data === T) {
        L = !1;
        a = K;
        var b = M;
        K = null;
        M = -1;
        var c = exports.unstable_now(),
            e = !1;
        if (0 >= P - c) if (-1 !== b && b <= c) e = !0;else {
          N || (N = !0, E(U));
          K = a;
          M = b;
          return;
        }

        if (null !== a) {
          O = !0;

          try {
            a(e);
          } finally {
            O = !1;
          }
        }
      }
    }, !1);

    var U = function U(a) {
      if (null !== K) {
        E(U);
        var b = a - P + S;
        b < S && R < S ? (8 > b && (b = 8), S = b < R ? R : b) : R = b;
        P = a + S;
        L || (L = !0, window.postMessage(T, "*"));
      } else N = !1;
    };

    _r = function _r(a, b) {
      K = a;
      M = b;
      O || 0 > b ? window.postMessage(T, "*") : N || (N = !0, E(U));
    };

    q = function q() {
      K = null;
      L = !1;
      M = -1;
    };
  }

  exports.unstable_ImmediatePriority = 1;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_NormalPriority = 3;
  exports.unstable_IdlePriority = 5;
  exports.unstable_LowPriority = 4;

  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        a = 3;
    }

    var c = h,
        e = k;
    h = a;
    k = exports.unstable_now();

    try {
      return b();
    } finally {
      h = c, k = e, v();
    }
  };

  exports.unstable_scheduleCallback = function (a, b) {
    var c = -1 !== k ? k : exports.unstable_now();
    if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = c + b.timeout;else switch (h) {
      case 1:
        b = c + -1;
        break;

      case 2:
        b = c + 250;
        break;

      case 5:
        b = c + 1073741823;
        break;

      case 4:
        b = c + 1E4;
        break;

      default:
        b = c + 5E3;
    }
    a = {
      callback: a,
      priorityLevel: h,
      expirationTime: b,
      next: null,
      previous: null
    };
    if (null === d) d = a.next = a.previous = a, p();else {
      c = null;
      var e = d;

      do {
        if (e.expirationTime > b) {
          c = e;
          break;
        }

        e = e.next;
      } while (e !== d);

      null === c ? c = d : c === d && (d = a, p());
      b = c.previous;
      b.next = c.previous = a;
      a.next = c;
      a.previous = b;
    }
    return a;
  };

  exports.unstable_cancelCallback = function (a) {
    var b = a.next;

    if (null !== b) {
      if (b === a) d = null;else {
        a === d && (d = b);
        var c = a.previous;
        c.next = b;
        b.previous = c;
      }
      a.next = a.previous = null;
    }
  };

  exports.unstable_wrapCallback = function (a) {
    var b = h;
    return function () {
      var c = h,
          e = k;
      h = b;
      k = exports.unstable_now();

      try {
        return a.apply(this, arguments);
      } finally {
        h = c, k = e, v();
      }
    };
  };

  exports.unstable_getCurrentPriorityLevel = function () {
    return h;
  };

  exports.unstable_shouldYield = function () {
    return !f && (null !== d && d.expirationTime < l || w());
  };
});
unwrapExports(scheduler_production_min);
var scheduler_production_min_1 = scheduler_production_min.unstable_now;
var scheduler_production_min_2 = scheduler_production_min.unstable_ImmediatePriority;
var scheduler_production_min_3 = scheduler_production_min.unstable_UserBlockingPriority;
var scheduler_production_min_4 = scheduler_production_min.unstable_NormalPriority;
var scheduler_production_min_5 = scheduler_production_min.unstable_IdlePriority;
var scheduler_production_min_6 = scheduler_production_min.unstable_LowPriority;
var scheduler_production_min_7 = scheduler_production_min.unstable_runWithPriority;
var scheduler_production_min_8 = scheduler_production_min.unstable_scheduleCallback;
var scheduler_production_min_9 = scheduler_production_min.unstable_cancelCallback;
var scheduler_production_min_10 = scheduler_production_min.unstable_wrapCallback;
var scheduler_production_min_11 = scheduler_production_min.unstable_getCurrentPriorityLevel;
var scheduler_production_min_12 = scheduler_production_min.unstable_shouldYield;
var scheduler_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /* eslint-disable no-var */
      // TODO: Use symbols?

      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5; // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111

      var maxSigned31BitInt = 1073741823; // Times out immediately

      var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

      var USER_BLOCKING_PRIORITY = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5000;
      var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

      var IDLE_PRIORITY = maxSigned31BitInt; // Callbacks are stored as a circular, doubly linked list.

      var firstCallbackNode = null;
      var currentDidTimeout = false;
      var currentPriorityLevel = NormalPriority;
      var currentEventStartTime = -1;
      var currentExpirationTime = -1; // This is set when a callback is being executed, to prevent re-entrancy.

      var isExecutingCallback = false;
      var isHostCallbackScheduled = false;
      var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

      function ensureHostCallbackIsScheduled() {
        if (isExecutingCallback) {
          // Don't schedule work yet; wait until the next time we yield.
          return;
        } // Schedule the host callback using the earliest expiration in the list.


        var expirationTime = firstCallbackNode.expirationTime;

        if (!isHostCallbackScheduled) {
          isHostCallbackScheduled = true;
        } else {
          // Cancel the existing host callback.
          cancelHostCallback();
        }

        _requestHostCallback(flushWork, expirationTime);
      }

      function flushFirstCallback() {
        var flushedNode = firstCallbackNode; // Remove the node from the list before calling the callback. That way the
        // list is in a consistent state even if the callback throws.

        var next = firstCallbackNode.next;

        if (firstCallbackNode === next) {
          // This is the last callback in the list.
          firstCallbackNode = null;
          next = null;
        } else {
          var lastCallbackNode = firstCallbackNode.previous;
          firstCallbackNode = lastCallbackNode.next = next;
          next.previous = lastCallbackNode;
        }

        flushedNode.next = flushedNode.previous = null; // Now it's safe to call the callback.

        var callback = flushedNode.callback;
        var expirationTime = flushedNode.expirationTime;
        var priorityLevel = flushedNode.priorityLevel;
        var previousPriorityLevel = currentPriorityLevel;
        var previousExpirationTime = currentExpirationTime;
        currentPriorityLevel = priorityLevel;
        currentExpirationTime = expirationTime;
        var continuationCallback;

        try {
          continuationCallback = callback();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
          currentExpirationTime = previousExpirationTime;
        } // A callback may return a continuation. The continuation should be scheduled
        // with the same priority and expiration as the just-finished callback.


        if (typeof continuationCallback === 'function') {
          var continuationNode = {
            callback: continuationCallback,
            priorityLevel: priorityLevel,
            expirationTime: expirationTime,
            next: null,
            previous: null
          }; // Insert the new callback into the list, sorted by its expiration. This is
          // almost the same as the code in `scheduleCallback`, except the callback
          // is inserted into the list *before* callbacks of equal expiration instead
          // of after.

          if (firstCallbackNode === null) {
            // This is the first callback in the list.
            firstCallbackNode = continuationNode.next = continuationNode.previous = continuationNode;
          } else {
            var nextAfterContinuation = null;
            var node = firstCallbackNode;

            do {
              if (node.expirationTime >= expirationTime) {
                // This callback expires at or after the continuation. We will insert
                // the continuation *before* this callback.
                nextAfterContinuation = node;
                break;
              }

              node = node.next;
            } while (node !== firstCallbackNode);

            if (nextAfterContinuation === null) {
              // No equal or lower priority callback was found, which means the new
              // callback is the lowest priority callback in the list.
              nextAfterContinuation = firstCallbackNode;
            } else if (nextAfterContinuation === firstCallbackNode) {
              // The new callback is the highest priority callback in the list.
              firstCallbackNode = continuationNode;
              ensureHostCallbackIsScheduled();
            }

            var previous = nextAfterContinuation.previous;
            previous.next = nextAfterContinuation.previous = continuationNode;
            continuationNode.next = nextAfterContinuation;
            continuationNode.previous = previous;
          }
        }
      }

      function flushImmediateWork() {
        if ( // Confirm we've exited the outer most event handler
        currentEventStartTime === -1 && firstCallbackNode !== null && firstCallbackNode.priorityLevel === ImmediatePriority) {
          isExecutingCallback = true;

          try {
            do {
              flushFirstCallback();
            } while ( // Keep flushing until there are no more immediate callbacks
            firstCallbackNode !== null && firstCallbackNode.priorityLevel === ImmediatePriority);
          } finally {
            isExecutingCallback = false;

            if (firstCallbackNode !== null) {
              // There's still work remaining. Request another callback.
              ensureHostCallbackIsScheduled();
            } else {
              isHostCallbackScheduled = false;
            }
          }
        }
      }

      function flushWork(didTimeout) {
        isExecutingCallback = true;
        var previousDidTimeout = currentDidTimeout;
        currentDidTimeout = didTimeout;

        try {
          if (didTimeout) {
            // Flush all the expired callbacks without yielding.
            while (firstCallbackNode !== null) {
              // Read the current time. Flush all the callbacks that expire at or
              // earlier than that time. Then read the current time again and repeat.
              // This optimizes for as few performance.now calls as possible.
              var currentTime = exports.unstable_now();

              if (firstCallbackNode.expirationTime <= currentTime) {
                do {
                  flushFirstCallback();
                } while (firstCallbackNode !== null && firstCallbackNode.expirationTime <= currentTime);

                continue;
              }

              break;
            }
          } else {
            // Keep flushing callbacks until we run out of time in the frame.
            if (firstCallbackNode !== null) {
              do {
                flushFirstCallback();
              } while (firstCallbackNode !== null && !shouldYieldToHost());
            }
          }
        } finally {
          isExecutingCallback = false;
          currentDidTimeout = previousDidTimeout;

          if (firstCallbackNode !== null) {
            // There's still work remaining. Request another callback.
            ensureHostCallbackIsScheduled();
          } else {
            isHostCallbackScheduled = false;
          } // Before exiting, flush all the immediate work that was scheduled.


          flushImmediateWork();
        }
      }

      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;

          default:
            priorityLevel = NormalPriority;
        }

        var previousPriorityLevel = currentPriorityLevel;
        var previousEventStartTime = currentEventStartTime;
        currentPriorityLevel = priorityLevel;
        currentEventStartTime = exports.unstable_now();

        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
          currentEventStartTime = previousEventStartTime; // Before exiting, flush all the immediate work that was scheduled.

          flushImmediateWork();
        }
      }

      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function () {
          // This is a fork of runWithPriority, inlined for performance.
          var previousPriorityLevel = currentPriorityLevel;
          var previousEventStartTime = currentEventStartTime;
          currentPriorityLevel = parentPriorityLevel;
          currentEventStartTime = exports.unstable_now();

          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
            currentEventStartTime = previousEventStartTime;
            flushImmediateWork();
          }
        };
      }

      function unstable_scheduleCallback(callback, deprecated_options) {
        var startTime = currentEventStartTime !== -1 ? currentEventStartTime : exports.unstable_now();
        var expirationTime;

        if (typeof deprecated_options === 'object' && deprecated_options !== null && typeof deprecated_options.timeout === 'number') {
          // FIXME: Remove this branch once we lift expiration times out of React.
          expirationTime = startTime + deprecated_options.timeout;
        } else {
          switch (currentPriorityLevel) {
            case ImmediatePriority:
              expirationTime = startTime + IMMEDIATE_PRIORITY_TIMEOUT;
              break;

            case UserBlockingPriority:
              expirationTime = startTime + USER_BLOCKING_PRIORITY;
              break;

            case IdlePriority:
              expirationTime = startTime + IDLE_PRIORITY;
              break;

            case LowPriority:
              expirationTime = startTime + LOW_PRIORITY_TIMEOUT;
              break;

            case NormalPriority:
            default:
              expirationTime = startTime + NORMAL_PRIORITY_TIMEOUT;
          }
        }

        var newNode = {
          callback: callback,
          priorityLevel: currentPriorityLevel,
          expirationTime: expirationTime,
          next: null,
          previous: null
        }; // Insert the new callback into the list, ordered first by expiration, then
        // by insertion. So the new callback is inserted any other callback with
        // equal expiration.

        if (firstCallbackNode === null) {
          // This is the first callback in the list.
          firstCallbackNode = newNode.next = newNode.previous = newNode;
          ensureHostCallbackIsScheduled();
        } else {
          var next = null;
          var node = firstCallbackNode;

          do {
            if (node.expirationTime > expirationTime) {
              // The new callback expires before this one.
              next = node;
              break;
            }

            node = node.next;
          } while (node !== firstCallbackNode);

          if (next === null) {
            // No callback with a later expiration was found, which means the new
            // callback has the latest expiration in the list.
            next = firstCallbackNode;
          } else if (next === firstCallbackNode) {
            // The new callback has the earliest expiration in the entire list.
            firstCallbackNode = newNode;
            ensureHostCallbackIsScheduled();
          }

          var previous = next.previous;
          previous.next = next.previous = newNode;
          newNode.next = next;
          newNode.previous = previous;
        }

        return newNode;
      }

      function unstable_cancelCallback(callbackNode) {
        var next = callbackNode.next;

        if (next === null) {
          // Already cancelled.
          return;
        }

        if (next === callbackNode) {
          // This is the only scheduled callback. Clear the list.
          firstCallbackNode = null;
        } else {
          // Remove the callback from its position in the list.
          if (callbackNode === firstCallbackNode) {
            firstCallbackNode = next;
          }

          var previous = callbackNode.previous;
          previous.next = next;
          next.previous = previous;
        }

        callbackNode.next = callbackNode.previous = null;
      }

      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }

      function unstable_shouldYield() {
        return !currentDidTimeout && (firstCallbackNode !== null && firstCallbackNode.expirationTime < currentExpirationTime || shouldYieldToHost());
      } // The remaining code is essentially a polyfill for requestIdleCallback. It
      // works by scheduling a requestAnimationFrame, storing the time for the start
      // of the frame, then scheduling a postMessage which gets scheduled after paint.
      // Within the postMessage handler do as much work as possible until time + frame
      // rate. By separating the idle call into a separate event tick we ensure that
      // layout, paint and other browser work is counted against the available time.
      // The frame rate is dynamically adjusted.
      // We capture a local reference to any global, in case it gets polyfilled after
      // this module is initially evaluated. We want to be using a
      // consistent implementation.


      var localDate = Date; // This initialization code may run even on server environments if a component
      // just imports ReactDOM (e.g. for findDOMNode). Some environments might not
      // have setTimeout or clearTimeout. However, we always expect them to be defined
      // on the client. https://github.com/facebook/react/pull/13088

      var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
      var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined; // We don't expect either of these to necessarily be defined, but we will error
      // later if they are missing on the client.

      var localRequestAnimationFrame = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : undefined;
      var localCancelAnimationFrame = typeof cancelAnimationFrame === 'function' ? cancelAnimationFrame : undefined; // requestAnimationFrame does not run when the tab is in the background. If
      // we're backgrounded we prefer for that work to happen so that the page
      // continues to load in the background. So we also schedule a 'setTimeout' as
      // a fallback.
      // TODO: Need a better heuristic for backgrounded work.

      var ANIMATION_FRAME_TIMEOUT = 100;
      var rAFID;
      var rAFTimeoutID;

      var requestAnimationFrameWithTimeout = function requestAnimationFrameWithTimeout(callback) {
        // schedule rAF and also a setTimeout
        rAFID = localRequestAnimationFrame(function (timestamp) {
          // cancel the setTimeout
          localClearTimeout(rAFTimeoutID);
          callback(timestamp);
        });
        rAFTimeoutID = localSetTimeout(function () {
          // cancel the requestAnimationFrame
          localCancelAnimationFrame(rAFID);
          callback(exports.unstable_now());
        }, ANIMATION_FRAME_TIMEOUT);
      };

      if (hasNativePerformanceNow) {
        var Performance = performance;

        exports.unstable_now = function () {
          return Performance.now();
        };
      } else {
        exports.unstable_now = function () {
          return localDate.now();
        };
      }

      var _requestHostCallback;

      var cancelHostCallback;
      var shouldYieldToHost;

      if (typeof window !== 'undefined' && window._schedMock) {
        // Dynamic injection, only for testing purposes.
        var impl = window._schedMock;
        _requestHostCallback = impl[0];
        cancelHostCallback = impl[1];
        shouldYieldToHost = impl[2];
      } else if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
      // implementation using setTimeout.
      typeof window === 'undefined' || // "addEventListener" might not be available on the window object
      // if this is a mocked "window" object. So we need to validate that too.
      typeof window.addEventListener !== 'function') {
        var _callback = null;

        var _currentTime = -1;

        var _flushCallback = function _flushCallback(didTimeout, ms) {
          if (_callback !== null) {
            var cb = _callback;
            _callback = null;

            try {
              _currentTime = ms;
              cb(didTimeout);
            } finally {
              _currentTime = -1;
            }
          }
        };

        _requestHostCallback = function requestHostCallback(cb, ms) {
          if (_currentTime !== -1) {
            // Protect against re-entrancy.
            setTimeout(_requestHostCallback, 0, cb, ms);
          } else {
            _callback = cb;
            setTimeout(_flushCallback, ms, true, ms);
            setTimeout(_flushCallback, maxSigned31BitInt, false, maxSigned31BitInt);
          }
        };

        cancelHostCallback = function cancelHostCallback() {
          _callback = null;
        };

        shouldYieldToHost = function shouldYieldToHost() {
          return false;
        };

        exports.unstable_now = function () {
          return _currentTime === -1 ? 0 : _currentTime;
        };
      } else {
        if (typeof console !== 'undefined') {
          // TODO: Remove fb.me link
          if (typeof localRequestAnimationFrame !== 'function') {
            console.error("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }

          if (typeof localCancelAnimationFrame !== 'function') {
            console.error("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }
        }

        var scheduledHostCallback = null;
        var isMessageEventScheduled = false;
        var timeoutTime = -1;
        var isAnimationFrameScheduled = false;
        var isFlushingHostCallback = false;
        var frameDeadline = 0; // We start out assuming that we run at 30fps but then the heuristic tracking
        // will adjust this value to a faster fps if we get more frequent animation
        // frames.

        var previousFrameTime = 33;
        var activeFrameTime = 33;

        shouldYieldToHost = function shouldYieldToHost() {
          return frameDeadline <= exports.unstable_now();
        }; // We use the postMessage trick to defer idle work until after the repaint.


        var messageKey = '__reactIdleCallback$' + Math.random().toString(36).slice(2);

        var idleTick = function idleTick(event) {
          if (event.source !== window || event.data !== messageKey) {
            return;
          }

          isMessageEventScheduled = false;
          var prevScheduledCallback = scheduledHostCallback;
          var prevTimeoutTime = timeoutTime;
          scheduledHostCallback = null;
          timeoutTime = -1;
          var currentTime = exports.unstable_now();
          var didTimeout = false;

          if (frameDeadline - currentTime <= 0) {
            // There's no time left in this idle period. Check if the callback has
            // a timeout and whether it's been exceeded.
            if (prevTimeoutTime !== -1 && prevTimeoutTime <= currentTime) {
              // Exceeded the timeout. Invoke the callback even though there's no
              // time left.
              didTimeout = true;
            } else {
              // No timeout.
              if (!isAnimationFrameScheduled) {
                // Schedule another animation callback so we retry later.
                isAnimationFrameScheduled = true;
                requestAnimationFrameWithTimeout(animationTick);
              } // Exit without invoking the callback.


              scheduledHostCallback = prevScheduledCallback;
              timeoutTime = prevTimeoutTime;
              return;
            }
          }

          if (prevScheduledCallback !== null) {
            isFlushingHostCallback = true;

            try {
              prevScheduledCallback(didTimeout);
            } finally {
              isFlushingHostCallback = false;
            }
          }
        }; // Assumes that we have addEventListener in this environment. Might need
        // something better for old IE.


        window.addEventListener('message', idleTick, false);

        var animationTick = function animationTick(rafTime) {
          if (scheduledHostCallback !== null) {
            // Eagerly schedule the next animation callback at the beginning of the
            // frame. If the scheduler queue is not empty at the end of the frame, it
            // will continue flushing inside that callback. If the queue *is* empty,
            // then it will exit immediately. Posting the callback at the start of the
            // frame ensures it's fired within the earliest possible frame. If we
            // waited until the end of the frame to post the callback, we risk the
            // browser skipping a frame and not firing the callback until the frame
            // after that.
            requestAnimationFrameWithTimeout(animationTick);
          } else {
            // No pending work. Exit.
            isAnimationFrameScheduled = false;
            return;
          }

          var nextFrameTime = rafTime - frameDeadline + activeFrameTime;

          if (nextFrameTime < activeFrameTime && previousFrameTime < activeFrameTime) {
            if (nextFrameTime < 8) {
              // Defensive coding. We don't support higher frame rates than 120hz.
              // If the calculated frame time gets lower than 8, it is probably a bug.
              nextFrameTime = 8;
            } // If one frame goes long, then the next one can be short to catch up.
            // If two frames are short in a row, then that's an indication that we
            // actually have a higher frame rate than what we're currently optimizing.
            // We adjust our heuristic dynamically accordingly. For example, if we're
            // running on 120hz display or 90hz VR display.
            // Take the max of the two in case one of them was an anomaly due to
            // missed frame deadlines.


            activeFrameTime = nextFrameTime < previousFrameTime ? previousFrameTime : nextFrameTime;
          } else {
            previousFrameTime = nextFrameTime;
          }

          frameDeadline = rafTime + activeFrameTime;

          if (!isMessageEventScheduled) {
            isMessageEventScheduled = true;
            window.postMessage(messageKey, '*');
          }
        };

        _requestHostCallback = function _requestHostCallback(callback, absoluteTimeout) {
          scheduledHostCallback = callback;
          timeoutTime = absoluteTimeout;

          if (isFlushingHostCallback || absoluteTimeout < 0) {
            // Don't wait for the next frame. Continue working ASAP, in a new event.
            window.postMessage(messageKey, '*');
          } else if (!isAnimationFrameScheduled) {
            // If rAF didn't already schedule one, we need to schedule a frame.
            // TODO: If this rAF doesn't materialize because the browser throttles, we
            // might want to still have setTimeout trigger rIC as a backup to ensure
            // that we keep performing work.
            isAnimationFrameScheduled = true;
            requestAnimationFrameWithTimeout(animationTick);
          }
        };

        cancelHostCallback = function cancelHostCallback() {
          scheduledHostCallback = null;
          isMessageEventScheduled = false;
          timeoutTime = -1;
        };
      }

      exports.unstable_ImmediatePriority = ImmediatePriority;
      exports.unstable_UserBlockingPriority = UserBlockingPriority;
      exports.unstable_NormalPriority = NormalPriority;
      exports.unstable_IdlePriority = IdlePriority;
      exports.unstable_LowPriority = LowPriority;
      exports.unstable_runWithPriority = unstable_runWithPriority;
      exports.unstable_scheduleCallback = unstable_scheduleCallback;
      exports.unstable_cancelCallback = unstable_cancelCallback;
      exports.unstable_wrapCallback = unstable_wrapCallback;
      exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      exports.unstable_shouldYield = unstable_shouldYield;
    })();
  }
});
unwrapExports(scheduler_development);
var scheduler_development_1 = scheduler_development.unstable_now;
var scheduler_development_2 = scheduler_development.unstable_ImmediatePriority;
var scheduler_development_3 = scheduler_development.unstable_UserBlockingPriority;
var scheduler_development_4 = scheduler_development.unstable_NormalPriority;
var scheduler_development_5 = scheduler_development.unstable_IdlePriority;
var scheduler_development_6 = scheduler_development.unstable_LowPriority;
var scheduler_development_7 = scheduler_development.unstable_runWithPriority;
var scheduler_development_8 = scheduler_development.unstable_scheduleCallback;
var scheduler_development_9 = scheduler_development.unstable_cancelCallback;
var scheduler_development_10 = scheduler_development.unstable_wrapCallback;
var scheduler_development_11 = scheduler_development.unstable_getCurrentPriorityLevel;
var scheduler_development_12 = scheduler_development.unstable_shouldYield;
var scheduler = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = scheduler_production_min;
  } else {
    module.exports = scheduler_development;
  }
});
var reactReconciler_production_min = createCommonjsModule(function (module) {
  /** @license React v16.6.1
   * react-reconciler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  module.exports = function $$$reconciler($$$hostConfig) {
    var aa = objectAssign,
        ba = React;

    function da(a, b, c, d, e, g, f, l) {
      if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var h = [c, d, e, g, f, l],
              k = 0;
          a = Error(b.replace(/%s/g, function () {
            return h[k++];
          }));
          a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
      }
    }

    function m(a) {
      for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {
        c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
      }

      da(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
    }

    var ea = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
        n = "function" === typeof Symbol && Symbol.for,
        fa = n ? Symbol.for("react.element") : 60103,
        ha = n ? Symbol.for("react.portal") : 60106,
        ia = n ? Symbol.for("react.fragment") : 60107,
        ja = n ? Symbol.for("react.strict_mode") : 60108,
        ka = n ? Symbol.for("react.profiler") : 60114,
        la = n ? Symbol.for("react.provider") : 60109,
        ma = n ? Symbol.for("react.context") : 60110,
        na = n ? Symbol.for("react.concurrent_mode") : 60111,
        oa = n ? Symbol.for("react.forward_ref") : 60112,
        pa = n ? Symbol.for("react.suspense") : 60113,
        qa = n ? Symbol.for("react.memo") : 60115,
        ra = n ? Symbol.for("react.lazy") : 60116,
        sa = "function" === typeof Symbol && Symbol.iterator;

    function ua(a) {
      if (null === a || "object" !== typeof a) return null;
      a = sa && a[sa] || a["@@iterator"];
      return "function" === typeof a ? a : null;
    }

    function va(a) {
      if (null == a) return null;
      if ("function" === typeof a) return a.displayName || a.name || null;
      if ("string" === typeof a) return a;

      switch (a) {
        case na:
          return "ConcurrentMode";

        case ia:
          return "Fragment";

        case ha:
          return "Portal";

        case ka:
          return "Profiler";

        case ja:
          return "StrictMode";

        case pa:
          return "Suspense";
      }

      if ("object" === typeof a) switch (a.$$typeof) {
        case ma:
          return "Context.Consumer";

        case la:
          return "Context.Provider";

        case oa:
          var b = a.render;
          b = b.displayName || b.name || "";
          return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

        case qa:
          return va(a.type);

        case ra:
          if (a = 1 === a._status ? a._result : null) return va(a);
      }
      return null;
    }

    function wa(a) {
      var b = a;
      if (a.alternate) for (; b.return;) {
        b = b.return;
      } else {
        if (0 !== (b.effectTag & 2)) return 1;

        for (; b.return;) {
          if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
        }
      }
      return 3 === b.tag ? 2 : 3;
    }

    function xa(a) {
      2 !== wa(a) ? m("188") : void 0;
    }

    function ya(a) {
      var b = a.alternate;
      if (!b) return b = wa(a), 3 === b ? m("188") : void 0, 1 === b ? null : a;

      for (var c = a, d = b;;) {
        var e = c.return,
            g = e ? e.alternate : null;
        if (!e || !g) break;

        if (e.child === g.child) {
          for (var f = e.child; f;) {
            if (f === c) return xa(e), a;
            if (f === d) return xa(e), b;
            f = f.sibling;
          }

          m("188");
        }

        if (c.return !== d.return) c = e, d = g;else {
          f = !1;

          for (var l = e.child; l;) {
            if (l === c) {
              f = !0;
              c = e;
              d = g;
              break;
            }

            if (l === d) {
              f = !0;
              d = e;
              c = g;
              break;
            }

            l = l.sibling;
          }

          if (!f) {
            for (l = g.child; l;) {
              if (l === c) {
                f = !0;
                c = g;
                d = e;
                break;
              }

              if (l === d) {
                f = !0;
                d = g;
                c = e;
                break;
              }

              l = l.sibling;
            }

            f ? void 0 : m("189");
          }
        }
        c.alternate !== d ? m("190") : void 0;
      }

      3 !== c.tag ? m("188") : void 0;
      return c.stateNode.current === c ? a : b;
    }

    function za(a) {
      a = ya(a);
      if (!a) return null;

      for (var b = a;;) {
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;else {
          if (b === a) break;

          for (; !b.sibling;) {
            if (!b.return || b.return === a) return null;
            b = b.return;
          }

          b.sibling.return = b.return;
          b = b.sibling;
        }
      }

      return null;
    }

    function Aa(a) {
      a = ya(a);
      if (!a) return null;

      for (var b = a;;) {
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;else {
          if (b === a) break;

          for (; !b.sibling;) {
            if (!b.return || b.return === a) return null;
            b = b.return;
          }

          b.sibling.return = b.return;
          b = b.sibling;
        }
      }

      return null;
    }

    var Ba = $$$hostConfig.getPublicInstance,
        Ca = $$$hostConfig.getRootHostContext,
        Da = $$$hostConfig.getChildHostContext,
        Ea = $$$hostConfig.prepareForCommit,
        Fa = $$$hostConfig.resetAfterCommit,
        Ga = $$$hostConfig.createInstance,
        Ha = $$$hostConfig.appendInitialChild,
        Ia = $$$hostConfig.finalizeInitialChildren,
        Ja = $$$hostConfig.prepareUpdate,
        Ka = $$$hostConfig.shouldSetTextContent,
        La = $$$hostConfig.shouldDeprioritizeSubtree,
        Ma = $$$hostConfig.createTextInstance,
        Na = $$$hostConfig.scheduleDeferredCallback,
        Oa = $$$hostConfig.cancelDeferredCallback,
        Pa = $$$hostConfig.shouldYield,
        Qa = $$$hostConfig.setTimeout,
        Ra = $$$hostConfig.clearTimeout,
        Sa = $$$hostConfig.noTimeout,
        Ta = $$$hostConfig.now,
        Ua = $$$hostConfig.isPrimaryRenderer,
        Va = $$$hostConfig.supportsMutation,
        Wa = $$$hostConfig.supportsPersistence,
        Xa = $$$hostConfig.supportsHydration,
        Ya = $$$hostConfig.appendChild,
        Za = $$$hostConfig.appendChildToContainer,
        $a = $$$hostConfig.commitTextUpdate,
        ab = $$$hostConfig.commitMount,
        bb = $$$hostConfig.commitUpdate,
        cb = $$$hostConfig.insertBefore,
        db = $$$hostConfig.insertInContainerBefore,
        eb = $$$hostConfig.removeChild,
        fb = $$$hostConfig.removeChildFromContainer,
        gb = $$$hostConfig.resetTextContent,
        hb = $$$hostConfig.hideInstance,
        ib = $$$hostConfig.hideTextInstance,
        jb = $$$hostConfig.unhideInstance,
        kb = $$$hostConfig.unhideTextInstance,
        lb = $$$hostConfig.cloneInstance,
        mb = $$$hostConfig.createContainerChildSet,
        nb = $$$hostConfig.appendChildToContainerChildSet,
        ob = $$$hostConfig.finalizeContainerChildren,
        pb = $$$hostConfig.replaceContainerChildren,
        qb = $$$hostConfig.cloneHiddenInstance,
        rb = $$$hostConfig.cloneUnhiddenInstance,
        tb = $$$hostConfig.createHiddenTextInstance,
        ub = $$$hostConfig.canHydrateInstance,
        vb = $$$hostConfig.canHydrateTextInstance,
        wb = $$$hostConfig.getNextHydratableSibling,
        xb = $$$hostConfig.getFirstHydratableChild,
        yb = $$$hostConfig.hydrateInstance,
        zb = $$$hostConfig.hydrateTextInstance,
        Ab = /^(.*)[\\\/]/;

    function Bb(a) {
      var b = "";

      do {
        a: switch (a.tag) {
          case 2:
          case 16:
          case 0:
          case 1:
          case 5:
          case 8:
          case 13:
            var c = a._debugOwner,
                d = a._debugSource,
                e = va(a.type);
            var g = null;
            c && (g = va(c.type));
            c = e;
            e = "";
            d ? e = " (at " + d.fileName.replace(Ab, "") + ":" + d.lineNumber + ")" : g && (e = " (created by " + g + ")");
            g = "\n    in " + (c || "Unknown") + e;
            break a;

          default:
            g = "";
        }

        b += g;
        a = a.return;
      } while (a);

      return b;
    }

    var Cb = [],
        Db = -1;

    function x(a) {
      0 > Db || (a.current = Cb[Db], Cb[Db] = null, Db--);
    }

    function z(a, b) {
      Db++;
      Cb[Db] = a.current;
      a.current = b;
    }

    var Eb = {},
        A = {
      current: Eb
    },
        B = {
      current: !1
    },
        Fb = Eb;

    function Gb(a, b) {
      var c = a.type.contextTypes;
      if (!c) return Eb;
      var d = a.stateNode;
      if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
      var e = {},
          g;

      for (g in c) {
        e[g] = b[g];
      }

      d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
      return e;
    }

    function C(a) {
      a = a.childContextTypes;
      return null !== a && void 0 !== a;
    }

    function Hb(a) {
      x(B, a);
      x(A, a);
    }

    function Ib(a) {
      x(B, a);
      x(A, a);
    }

    function Jb(a, b, c) {
      A.current !== Eb ? m("168") : void 0;
      z(A, b, a);
      z(B, c, a);
    }

    function Kb(a, b, c) {
      var d = a.stateNode;
      a = b.childContextTypes;
      if ("function" !== typeof d.getChildContext) return c;
      d = d.getChildContext();

      for (var e in d) {
        e in a ? void 0 : m("108", va(b) || "Unknown", e);
      }

      return aa({}, c, d);
    }

    function Lb(a) {
      var b = a.stateNode;
      b = b && b.__reactInternalMemoizedMergedChildContext || Eb;
      Fb = A.current;
      z(A, b, a);
      z(B, B.current, a);
      return !0;
    }

    function Mb(a, b, c) {
      var d = a.stateNode;
      d ? void 0 : m("169");
      c ? (b = Kb(a, b, Fb), d.__reactInternalMemoizedMergedChildContext = b, x(B, a), x(A, a), z(A, b, a)) : x(B, a);
      z(B, c, a);
    }

    var Nb = null,
        Ob = null;

    function Pb(a) {
      return function (b) {
        try {
          return a(b);
        } catch (c) {}
      };
    }

    function Qb(a) {
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
      var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (b.isDisabled || !b.supportsFiber) return !0;

      try {
        var c = b.inject(a);
        Nb = Pb(function (a) {
          return b.onCommitFiberRoot(c, a);
        });
        Ob = Pb(function (a) {
          return b.onCommitFiberUnmount(c, a);
        });
      } catch (d) {}

      return !0;
    }

    function Rb(a, b, c, d) {
      this.tag = a;
      this.key = c;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.ref = null;
      this.pendingProps = b;
      this.firstContextDependency = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = d;
      this.effectTag = 0;
      this.lastEffect = this.firstEffect = this.nextEffect = null;
      this.childExpirationTime = this.expirationTime = 0;
      this.alternate = null;
    }

    function D(a, b, c, d) {
      return new Rb(a, b, c, d);
    }

    function Sb(a) {
      a = a.prototype;
      return !(!a || !a.isReactComponent);
    }

    function Tb(a) {
      if ("function" === typeof a) return Sb(a) ? 1 : 0;

      if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === oa) return 11;
        if (a === qa) return 14;
      }

      return 2;
    }

    function Ub(a, b) {
      var c = a.alternate;
      null === c ? (c = D(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
      c.childExpirationTime = a.childExpirationTime;
      c.expirationTime = a.expirationTime;
      c.child = a.child;
      c.memoizedProps = a.memoizedProps;
      c.memoizedState = a.memoizedState;
      c.updateQueue = a.updateQueue;
      c.firstContextDependency = a.firstContextDependency;
      c.sibling = a.sibling;
      c.index = a.index;
      c.ref = a.ref;
      return c;
    }

    function Vb(a, b, c, d, e, g) {
      var f = 2;
      d = a;
      if ("function" === typeof a) Sb(a) && (f = 1);else if ("string" === typeof a) f = 5;else a: switch (a) {
        case ia:
          return Wb(c.children, e, g, b);

        case na:
          return Xb(c, e | 3, g, b);

        case ja:
          return Xb(c, e | 2, g, b);

        case ka:
          return a = D(12, c, b, e | 4), a.elementType = ka, a.type = ka, a.expirationTime = g, a;

        case pa:
          return a = D(13, c, b, e), a.elementType = pa, a.type = pa, a.expirationTime = g, a;

        default:
          if ("object" === typeof a && null !== a) switch (a.$$typeof) {
            case la:
              f = 10;
              break a;

            case ma:
              f = 9;
              break a;

            case oa:
              f = 11;
              break a;

            case qa:
              f = 14;
              break a;

            case ra:
              f = 16;
              d = null;
              break a;
          }
          m("130", null == a ? a : typeof a, "");
      }
      b = D(f, c, b, e);
      b.elementType = a;
      b.type = d;
      b.expirationTime = g;
      return b;
    }

    function Wb(a, b, c, d) {
      a = D(7, a, d, b);
      a.expirationTime = c;
      return a;
    }

    function Xb(a, b, c, d) {
      a = D(8, a, d, b);
      b = 0 === (b & 1) ? ja : na;
      a.elementType = b;
      a.type = b;
      a.expirationTime = c;
      return a;
    }

    function Yb(a, b, c) {
      a = D(6, a, null, b);
      a.expirationTime = c;
      return a;
    }

    function Zb(a, b, c) {
      b = D(4, null !== a.children ? a.children : [], a.key, b);
      b.expirationTime = c;
      b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
      };
      return b;
    }

    function $b(a, b) {
      a.didError = !1;
      var c = a.earliestPendingTime;
      0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);
      ac(b, a);
    }

    function bc(a, b) {
      a.didError = !1;
      var c = a.latestPingedTime;
      0 !== c && c >= b && (a.latestPingedTime = 0);
      c = a.earliestPendingTime;
      var d = a.latestPendingTime;
      c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);
      c = a.earliestSuspendedTime;
      d = a.latestSuspendedTime;
      0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);
      ac(b, a);
    }

    function cc(a, b) {
      var c = a.earliestPendingTime;
      a = a.earliestSuspendedTime;
      c > b && (b = c);
      a > b && (b = a);
      return b;
    }

    function ac(a, b) {
      var c = b.earliestSuspendedTime,
          d = b.latestSuspendedTime,
          e = b.earliestPendingTime,
          g = b.latestPingedTime;
      e = 0 !== e ? e : g;
      0 === e && (0 === a || d < a) && (e = d);
      a = e;
      0 !== a && c > a && (a = c);
      b.nextExpirationTimeToWorkOn = e;
      b.expirationTime = a;
    }

    var ec = !1;

    function fc(a) {
      return {
        baseState: a,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }

    function gc(a) {
      return {
        baseState: a.baseState,
        firstUpdate: a.firstUpdate,
        lastUpdate: a.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }

    function hc(a) {
      return {
        expirationTime: a,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
      };
    }

    function ic(a, b) {
      null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
    }

    function E(a, b) {
      var c = a.alternate;

      if (null === c) {
        var d = a.updateQueue;
        var e = null;
        null === d && (d = a.updateQueue = fc(a.memoizedState));
      } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = fc(a.memoizedState), e = c.updateQueue = fc(c.memoizedState)) : d = a.updateQueue = gc(e) : null === e && (e = c.updateQueue = gc(d));

      null === e || d === e ? ic(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (ic(d, b), ic(e, b)) : (ic(d, b), e.lastUpdate = b);
    }

    function jc(a, b) {
      var c = a.updateQueue;
      c = null === c ? a.updateQueue = fc(a.memoizedState) : kc(a, c);
      null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
    }

    function kc(a, b) {
      var c = a.alternate;
      null !== c && b === c.updateQueue && (b = a.updateQueue = gc(b));
      return b;
    }

    function lc(a, b, c, d, e, g) {
      switch (c.tag) {
        case 1:
          return a = c.payload, "function" === typeof a ? a.call(g, d, e) : a;

        case 3:
          a.effectTag = a.effectTag & -2049 | 64;

        case 0:
          a = c.payload;
          e = "function" === typeof a ? a.call(g, d, e) : a;
          if (null === e || void 0 === e) break;
          return aa({}, d, e);

        case 2:
          ec = !0;
      }

      return d;
    }

    function mc(a, b, c, d, e) {
      ec = !1;
      b = kc(a, b);

      for (var g = b.baseState, f = null, l = 0, h = b.firstUpdate, k = g; null !== h;) {
        var p = h.expirationTime;
        p < e ? (null === f && (f = h, g = k), l < p && (l = p)) : (k = lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = h : (b.lastEffect.nextEffect = h, b.lastEffect = h)));
        h = h.next;
      }

      p = null;

      for (h = b.firstCapturedUpdate; null !== h;) {
        var y = h.expirationTime;
        y < e ? (null === p && (p = h, null === f && (g = k)), l < y && (l = y)) : (k = lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = h : (b.lastCapturedEffect.nextEffect = h, b.lastCapturedEffect = h)));
        h = h.next;
      }

      null === f && (b.lastUpdate = null);
      null === p ? b.lastCapturedUpdate = null : a.effectTag |= 32;
      null === f && null === p && (g = k);
      b.baseState = g;
      b.firstUpdate = f;
      b.firstCapturedUpdate = p;
      a.expirationTime = l;
      a.memoizedState = k;
    }

    function nc(a, b, c) {
      null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
      oc(b.firstEffect, c);
      b.firstEffect = b.lastEffect = null;
      oc(b.firstCapturedEffect, c);
      b.firstCapturedEffect = b.lastCapturedEffect = null;
    }

    function oc(a, b) {
      for (; null !== a;) {
        var c = a.callback;

        if (null !== c) {
          a.callback = null;
          var d = b;
          "function" !== typeof c ? m("191", c) : void 0;
          c.call(d);
        }

        a = a.nextEffect;
      }
    }

    function pc(a, b) {
      return {
        value: a,
        source: b,
        stack: Bb(b)
      };
    }

    var qc = {
      current: null
    },
        rc = null,
        sc = null,
        tc = null;

    function uc(a, b) {
      var c = a.type._context;
      Ua ? (z(qc, c._currentValue, a), c._currentValue = b) : (z(qc, c._currentValue2, a), c._currentValue2 = b);
    }

    function vc(a) {
      var b = qc.current;
      x(qc, a);
      a = a.type._context;
      Ua ? a._currentValue = b : a._currentValue2 = b;
    }

    function wc(a) {
      rc = a;
      tc = sc = null;
      a.firstContextDependency = null;
    }

    function xc(a, b) {
      if (tc !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) tc = a, b = 1073741823;
        b = {
          context: a,
          observedBits: b,
          next: null
        };
        null === sc ? (null === rc ? m("293") : void 0, rc.firstContextDependency = sc = b) : sc = sc.next = b;
      }

      return Ua ? a._currentValue : a._currentValue2;
    }

    var yc = {},
        zc = {
      current: yc
    },
        Ac = {
      current: yc
    },
        Bc = {
      current: yc
    };

    function Cc(a) {
      a === yc ? m("174") : void 0;
      return a;
    }

    function Dc(a, b) {
      z(Bc, b, a);
      z(Ac, a, a);
      z(zc, yc, a);
      b = Ca(b);
      x(zc, a);
      z(zc, b, a);
    }

    function Ec(a) {
      x(zc, a);
      x(Ac, a);
      x(Bc, a);
    }

    function Fc() {
      return Cc(zc.current);
    }

    function Gc(a) {
      var b = Cc(Bc.current),
          c = Cc(zc.current);
      b = Da(c, a.type, b);
      c !== b && (z(Ac, a, a), z(zc, b, a));
    }

    function Hc(a) {
      Ac.current === a && (x(zc, a), x(Ac, a));
    }

    var Ic = Object.prototype.hasOwnProperty;

    function Jc(a, b) {
      return a === b ? 0 !== a || 0 !== b || 1 / a === 1 / b : a !== a && b !== b;
    }

    function Kc(a, b) {
      if (Jc(a, b)) return !0;
      if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
      var c = Object.keys(a),
          d = Object.keys(b);
      if (c.length !== d.length) return !1;

      for (d = 0; d < c.length; d++) {
        if (!Ic.call(b, c[d]) || !Jc(a[c[d]], b[c[d]])) return !1;
      }

      return !0;
    }

    function F(a, b) {
      if (a && a.defaultProps) {
        b = aa({}, b);
        a = a.defaultProps;

        for (var c in a) {
          void 0 === b[c] && (b[c] = a[c]);
        }
      }

      return b;
    }

    function Lc(a) {
      var b = a._result;

      switch (a._status) {
        case 1:
          return b;

        case 2:
          throw b;

        case 0:
          throw b;

        default:
          throw a._status = 0, b = a._ctor, b = b(), b.then(function (b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
          }, function (b) {
            0 === a._status && (a._status = 2, a._result = b);
          }), a._result = b, b;
      }
    }

    var Mc = ea.ReactCurrentOwner,
        Nc = new ba.Component().refs;

    function Oc(a, b, c, d) {
      b = a.memoizedState;
      c = c(d, b);
      c = null === c || void 0 === c ? b : aa({}, b, c);
      a.memoizedState = c;
      d = a.updateQueue;
      null !== d && 0 === a.expirationTime && (d.baseState = c);
    }

    var Sc = {
      isMounted: function isMounted(a) {
        return (a = a._reactInternalFiber) ? 2 === wa(a) : !1;
      },
      enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternalFiber;
        var d = G();
        d = Pc(d, a);
        var e = hc(d);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        E(a, e);
        Rc(a, d);
      },
      enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternalFiber;
        var d = G();
        d = Pc(d, a);
        var e = hc(d);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        E(a, e);
        Rc(a, d);
      },
      enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternalFiber;
        var c = G();
        c = Pc(c, a);
        var d = hc(c);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        E(a, d);
        Rc(a, c);
      }
    };

    function Tc(a, b, c, d, e, g, f) {
      a = a.stateNode;
      return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, g, f) : b.prototype && b.prototype.isPureReactComponent ? !Kc(c, d) || !Kc(e, g) : !0;
    }

    function Uc(a, b, c) {
      var d = !1,
          e = Eb;
      var g = b.contextType;
      "object" === typeof g && null !== g ? g = Mc.currentDispatcher.readContext(g) : (e = C(b) ? Fb : A.current, d = b.contextTypes, g = (d = null !== d && void 0 !== d) ? Gb(a, e) : Eb);
      b = new b(c, g);
      a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
      b.updater = Sc;
      a.stateNode = b;
      b._reactInternalFiber = a;
      d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = g);
      return b;
    }

    function Vc(a, b, c, d) {
      a = b.state;
      "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
      "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
      b.state !== a && Sc.enqueueReplaceState(b, b.state, null);
    }

    function Wc(a, b, c, d) {
      var e = a.stateNode;
      e.props = c;
      e.state = a.memoizedState;
      e.refs = Nc;
      var g = b.contextType;
      "object" === typeof g && null !== g ? e.context = Mc.currentDispatcher.readContext(g) : (g = C(b) ? Fb : A.current, e.context = Gb(a, g));
      g = a.updateQueue;
      null !== g && (mc(a, g, c, e, d), e.state = a.memoizedState);
      g = b.getDerivedStateFromProps;
      "function" === typeof g && (Oc(a, b, g, c), e.state = a.memoizedState);
      "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Sc.enqueueReplaceState(e, e.state, null), g = a.updateQueue, null !== g && (mc(a, g, c, e, d), e.state = a.memoizedState));
      "function" === typeof e.componentDidMount && (a.effectTag |= 4);
    }

    var Xc = Array.isArray;

    function Yc(a, b, c) {
      a = c.ref;

      if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
          c = c._owner;
          var d = void 0;
          c && (1 !== c.tag ? m("289") : void 0, d = c.stateNode);
          d ? void 0 : m("147", a);
          var e = "" + a;
          if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;

          b = function b(_b2) {
            var a = d.refs;
            a === Nc && (a = d.refs = {});
            null === _b2 ? delete a[e] : a[e] = _b2;
          };

          b._stringRef = e;
          return b;
        }

        "string" !== typeof a ? m("284") : void 0;
        c._owner ? void 0 : m("290", a);
      }

      return a;
    }

    function Zc(a, b) {
      "textarea" !== a.type && m("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
    }

    function $c(a) {
      function b(b, c) {
        if (a) {
          var d = b.lastEffect;
          null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
          c.nextEffect = null;
          c.effectTag = 8;
        }
      }

      function c(c, d) {
        if (!a) return null;

        for (; null !== d;) {
          b(c, d), d = d.sibling;
        }

        return null;
      }

      function d(b, a) {
        for (b = new Map(); null !== a;) {
          null !== a.key ? b.set(a.key, a) : b.set(a.index, a), a = a.sibling;
        }

        return b;
      }

      function e(b, a, c) {
        b = Ub(b, a, c);
        b.index = 0;
        b.sibling = null;
        return b;
      }

      function g(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
      }

      function f(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
      }

      function l(b, a, c, d) {
        if (null === a || 6 !== a.tag) return a = Yb(c, b.mode, d), a.return = b, a;
        a = e(a, c, d);
        a.return = b;
        return a;
      }

      function h(b, a, c, d) {
        if (null !== a && a.elementType === c.type) return d = e(a, c.props, d), d.ref = Yc(b, a, c), d.return = b, d;
        d = Vb(c.type, c.key, c.props, null, b.mode, d);
        d.ref = Yc(b, a, c);
        d.return = b;
        return d;
      }

      function k(b, a, c, d) {
        if (null === a || 4 !== a.tag || a.stateNode.containerInfo !== c.containerInfo || a.stateNode.implementation !== c.implementation) return a = Zb(c, b.mode, d), a.return = b, a;
        a = e(a, c.children || [], d);
        a.return = b;
        return a;
      }

      function p(b, a, c, d, f) {
        if (null === a || 7 !== a.tag) return a = Wb(c, b.mode, d, f), a.return = b, a;
        a = e(a, c, d);
        a.return = b;
        return a;
      }

      function y(b, a, c) {
        if ("string" === typeof a || "number" === typeof a) return a = Yb("" + a, b.mode, c), a.return = b, a;

        if ("object" === typeof a && null !== a) {
          switch (a.$$typeof) {
            case fa:
              return c = Vb(a.type, a.key, a.props, null, b.mode, c), c.ref = Yc(b, null, a), c.return = b, c;

            case ha:
              return a = Zb(a, b.mode, c), a.return = b, a;
          }

          if (Xc(a) || ua(a)) return a = Wb(a, b.mode, c, null), a.return = b, a;
          Zc(b, a);
        }

        return null;
      }

      function v(b, a, c, d) {
        var e = null !== a ? a.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : l(b, a, "" + c, d);

        if ("object" === typeof c && null !== c) {
          switch (c.$$typeof) {
            case fa:
              return c.key === e ? c.type === ia ? p(b, a, c.props.children, d, e) : h(b, a, c, d) : null;

            case ha:
              return c.key === e ? k(b, a, c, d) : null;
          }

          if (Xc(c) || ua(c)) return null !== e ? null : p(b, a, c, d, null);
          Zc(b, c);
        }

        return null;
      }

      function u(b, a, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return b = b.get(c) || null, l(a, b, "" + d, e);

        if ("object" === typeof d && null !== d) {
          switch (d.$$typeof) {
            case fa:
              return b = b.get(null === d.key ? c : d.key) || null, d.type === ia ? p(a, b, d.props.children, e, d.key) : h(a, b, d, e);

            case ha:
              return b = b.get(null === d.key ? c : d.key) || null, k(a, b, d, e);
          }

          if (Xc(d) || ua(d)) return b = b.get(c) || null, p(a, b, d, e, null);
          Zc(a, d);
        }

        return null;
      }

      function J(e, f, h, l) {
        for (var k = null, w = null, q = f, t = f = 0, p = null; null !== q && t < h.length; t++) {
          q.index > t ? (p = q, q = null) : p = q.sibling;
          var r = v(e, q, h[t], l);

          if (null === r) {
            null === q && (q = p);
            break;
          }

          a && q && null === r.alternate && b(e, q);
          f = g(r, f, t);
          null === w ? k = r : w.sibling = r;
          w = r;
          q = p;
        }

        if (t === h.length) return c(e, q), k;

        if (null === q) {
          for (; t < h.length; t++) {
            if (q = y(e, h[t], l)) f = g(q, f, t), null === w ? k = q : w.sibling = q, w = q;
          }

          return k;
        }

        for (q = d(e, q); t < h.length; t++) {
          if (p = u(q, e, t, h[t], l)) a && null !== p.alternate && q.delete(null === p.key ? t : p.key), f = g(p, f, t), null === w ? k = p : w.sibling = p, w = p;
        }

        a && q.forEach(function (a) {
          return b(e, a);
        });
        return k;
      }

      function ta(e, f, h, l) {
        var k = ua(h);
        "function" !== typeof k ? m("150") : void 0;
        h = k.call(h);
        null == h ? m("151") : void 0;

        for (var q = k = null, t = f, w = f = 0, p = null, r = h.next(); null !== t && !r.done; w++, r = h.next()) {
          t.index > w ? (p = t, t = null) : p = t.sibling;
          var U = v(e, t, r.value, l);

          if (null === U) {
            t || (t = p);
            break;
          }

          a && t && null === U.alternate && b(e, t);
          f = g(U, f, w);
          null === q ? k = U : q.sibling = U;
          q = U;
          t = p;
        }

        if (r.done) return c(e, t), k;

        if (null === t) {
          for (; !r.done; w++, r = h.next()) {
            r = y(e, r.value, l), null !== r && (f = g(r, f, w), null === q ? k = r : q.sibling = r, q = r);
          }

          return k;
        }

        for (t = d(e, t); !r.done; w++, r = h.next()) {
          r = u(t, e, w, r.value, l), null !== r && (a && null !== r.alternate && t.delete(null === r.key ? w : r.key), f = g(r, f, w), null === q ? k = r : q.sibling = r, q = r);
        }

        a && t.forEach(function (a) {
          return b(e, a);
        });
        return k;
      }

      return function (a, d, g, h) {
        var k = "object" === typeof g && null !== g && g.type === ia && null === g.key;
        k && (g = g.props.children);
        var l = "object" === typeof g && null !== g;
        if (l) switch (g.$$typeof) {
          case fa:
            a: {
              l = g.key;

              for (k = d; null !== k;) {
                if (k.key === l) {
                  if (7 === k.tag ? g.type === ia : k.elementType === g.type) {
                    c(a, k.sibling);
                    d = e(k, g.type === ia ? g.props.children : g.props, h);
                    d.ref = Yc(a, k, g);
                    d.return = a;
                    a = d;
                    break a;
                  } else {
                    c(a, k);
                    break;
                  }
                } else b(a, k);
                k = k.sibling;
              }

              g.type === ia ? (d = Wb(g.props.children, a.mode, h, g.key), d.return = a, a = d) : (h = Vb(g.type, g.key, g.props, null, a.mode, h), h.ref = Yc(a, d, g), h.return = a, a = h);
            }

            return f(a);

          case ha:
            a: {
              for (k = g.key; null !== d;) {
                if (d.key === k) {
                  if (4 === d.tag && d.stateNode.containerInfo === g.containerInfo && d.stateNode.implementation === g.implementation) {
                    c(a, d.sibling);
                    d = e(d, g.children || [], h);
                    d.return = a;
                    a = d;
                    break a;
                  } else {
                    c(a, d);
                    break;
                  }
                } else b(a, d);
                d = d.sibling;
              }

              d = Zb(g, a.mode, h);
              d.return = a;
              a = d;
            }

            return f(a);
        }
        if ("string" === typeof g || "number" === typeof g) return g = "" + g, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, g, h), d.return = a, a = d) : (c(a, d), d = Yb(g, a.mode, h), d.return = a, a = d), f(a);
        if (Xc(g)) return J(a, d, g, h);
        if (ua(g)) return ta(a, d, g, h);
        l && Zc(a, g);
        if ("undefined" === typeof g && !k) switch (a.tag) {
          case 1:
          case 0:
            h = a.type, m("152", h.displayName || h.name || "Component");
        }
        return c(a, d);
      };
    }

    var ad = $c(!0),
        bd = $c(!1),
        H = null,
        cd = null,
        dd = !1;

    function ed(a, b) {
      var c = D(5, null, null, 0);
      c.elementType = "DELETED";
      c.type = "DELETED";
      c.stateNode = b;
      c.return = a;
      c.effectTag = 8;
      null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
    }

    function fd(a, b) {
      switch (a.tag) {
        case 5:
          return b = ub(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;

        case 6:
          return b = vb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;

        default:
          return !1;
      }
    }

    function id(a) {
      if (dd) {
        var b = cd;

        if (b) {
          var c = b;

          if (!fd(a, b)) {
            b = wb(c);

            if (!b || !fd(a, b)) {
              a.effectTag |= 2;
              dd = !1;
              H = a;
              return;
            }

            ed(H, c);
          }

          H = a;
          cd = xb(b);
        } else a.effectTag |= 2, dd = !1, H = a;
      }
    }

    function jd(a) {
      for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag;) {
        a = a.return;
      }

      H = a;
    }

    function kd(a) {
      if (!Xa || a !== H) return !1;
      if (!dd) return jd(a), dd = !0, !1;
      var b = a.type;
      if (5 !== a.tag || "head" !== b && "body" !== b && !Ka(b, a.memoizedProps)) for (b = cd; b;) {
        ed(a, b), b = wb(b);
      }
      jd(a);
      cd = H ? wb(a.stateNode) : null;
      return !0;
    }

    function ld() {
      Xa && (cd = H = null, dd = !1);
    }

    var md = ea.ReactCurrentOwner;

    function I(a, b, c, d) {
      b.child = null === a ? bd(b, null, c, d) : ad(b, a.child, c, d);
    }

    function nd(a, b, c, d, e) {
      c = c.render;
      var g = b.ref;
      wc(b, e);
      d = c(d, g);
      b.effectTag |= 1;
      I(a, b, d, e);
      return b.child;
    }

    function od(a, b, c, d, e, g) {
      if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !Sb(f) && void 0 === f.defaultProps && null === c.compare) return b.tag = 15, b.type = f, pd(a, b, f, d, e, g);
        a = Vb(c.type, null, d, null, b.mode, g);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
      }

      f = a.child;
      if (e < g && (e = f.memoizedProps, c = c.compare, c = null !== c ? c : Kc, c(e, d) && a.ref === b.ref)) return qd(a, b, g);
      b.effectTag |= 1;
      a = Ub(f, d, g);
      a.ref = b.ref;
      a.return = b;
      return b.child = a;
    }

    function pd(a, b, c, d, e, g) {
      return null !== a && e < g && Kc(a.memoizedProps, d) && a.ref === b.ref ? qd(a, b, g) : rd(a, b, c, d, g);
    }

    function sd(a, b) {
      var c = b.ref;
      if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
    }

    function rd(a, b, c, d, e) {
      var g = C(c) ? Fb : A.current;
      g = Gb(b, g);
      wc(b, e);
      c = c(d, g);
      b.effectTag |= 1;
      I(a, b, c, e);
      return b.child;
    }

    function td(a, b, c, d, e) {
      if (C(c)) {
        var g = !0;
        Lb(b);
      } else g = !1;

      wc(b, e);
      if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Uc(b, c, d, e), Wc(b, c, d, e), d = !0;else if (null === a) {
        var f = b.stateNode,
            l = b.memoizedProps;
        f.props = l;
        var h = f.context,
            k = c.contextType;
        "object" === typeof k && null !== k ? k = Mc.currentDispatcher.readContext(k) : (k = C(c) ? Fb : A.current, k = Gb(b, k));
        var p = c.getDerivedStateFromProps,
            y = "function" === typeof p || "function" === typeof f.getSnapshotBeforeUpdate;
        y || "function" !== typeof f.UNSAFE_componentWillReceiveProps && "function" !== typeof f.componentWillReceiveProps || (l !== d || h !== k) && Vc(b, f, d, k);
        ec = !1;
        var v = b.memoizedState;
        h = f.state = v;
        var u = b.updateQueue;
        null !== u && (mc(b, u, d, f, e), h = b.memoizedState);
        l !== d || v !== h || B.current || ec ? ("function" === typeof p && (Oc(b, c, p, d), h = b.memoizedState), (l = ec || Tc(b, c, l, d, v, h, k)) ? (y || "function" !== typeof f.UNSAFE_componentWillMount && "function" !== typeof f.componentWillMount || ("function" === typeof f.componentWillMount && f.componentWillMount(), "function" === typeof f.UNSAFE_componentWillMount && f.UNSAFE_componentWillMount()), "function" === typeof f.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof f.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = h), f.props = d, f.state = h, f.context = k, d = l) : ("function" === typeof f.componentDidMount && (b.effectTag |= 4), d = !1);
      } else f = b.stateNode, l = b.memoizedProps, f.props = b.type === b.elementType ? l : F(b.type, l), h = f.context, k = c.contextType, "object" === typeof k && null !== k ? k = Mc.currentDispatcher.readContext(k) : (k = C(c) ? Fb : A.current, k = Gb(b, k)), p = c.getDerivedStateFromProps, (y = "function" === typeof p || "function" === typeof f.getSnapshotBeforeUpdate) || "function" !== typeof f.UNSAFE_componentWillReceiveProps && "function" !== typeof f.componentWillReceiveProps || (l !== d || h !== k) && Vc(b, f, d, k), ec = !1, h = b.memoizedState, v = f.state = h, u = b.updateQueue, null !== u && (mc(b, u, d, f, e), v = b.memoizedState), l !== d || h !== v || B.current || ec ? ("function" === typeof p && (Oc(b, c, p, d), v = b.memoizedState), (p = ec || Tc(b, c, l, d, h, v, k)) ? (y || "function" !== typeof f.UNSAFE_componentWillUpdate && "function" !== typeof f.componentWillUpdate || ("function" === typeof f.componentWillUpdate && f.componentWillUpdate(d, v, k), "function" === typeof f.UNSAFE_componentWillUpdate && f.UNSAFE_componentWillUpdate(d, v, k)), "function" === typeof f.componentDidUpdate && (b.effectTag |= 4), "function" === typeof f.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof f.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof f.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = v), f.props = d, f.state = v, f.context = k, d = p) : ("function" !== typeof f.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof f.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), d = !1);
      return ud(a, b, c, d, g, e);
    }

    function ud(a, b, c, d, e, g) {
      sd(a, b);
      var f = 0 !== (b.effectTag & 64);
      if (!d && !f) return e && Mb(b, c, !1), qd(a, b, g);
      d = b.stateNode;
      md.current = b;
      var l = f && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
      b.effectTag |= 1;
      null !== a && f ? (b.child = ad(b, a.child, null, g), b.child = ad(b, null, l, g)) : I(a, b, l, g);
      b.memoizedState = d.state;
      e && Mb(b, c, !0);
      return b.child;
    }

    function vd(a) {
      var b = a.stateNode;
      b.pendingContext ? Jb(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Jb(a, b.context, !1);
      Dc(a, b.containerInfo);
    }

    function wd(a, b, c) {
      var d = b.mode,
          e = b.pendingProps,
          g = b.memoizedState;

      if (0 === (b.effectTag & 64)) {
        g = null;
        var f = !1;
      } else g = {
        timedOutAt: null !== g ? g.timedOutAt : 0
      }, f = !0, b.effectTag &= -65;

      null === a ? f ? (f = e.fallback, e = Wb(null, d, 0, null), 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = Wb(f, d, c, null), e.sibling = d, c = e, c.return = d.return = b) : c = d = bd(b, null, e.children, c) : null !== a.memoizedState ? (d = a.child, a = d.sibling, f ? (c = e.fallback, e = Ub(d, d.pendingProps, 0), 0 === (b.mode & 1) && (f = null !== b.memoizedState ? b.child.child : b.child, f !== d.child && (e.child = f)), d = e.sibling = Ub(a, c, a.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = ad(b, d.child, e.children, c)) : (a = a.child, f ? (f = e.fallback, e = Wb(null, d, 0, null), e.child = a, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = Wb(f, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = ad(b, a, e.children, c));
      b.memoizedState = g;
      b.child = c;
      return d;
    }

    function qd(a, b, c) {
      null !== a && (b.firstContextDependency = a.firstContextDependency);
      if (b.childExpirationTime < c) return null;
      null !== a && b.child !== a.child ? m("153") : void 0;

      if (null !== b.child) {
        a = b.child;
        c = Ub(a, a.pendingProps, a.expirationTime);
        b.child = c;

        for (c.return = b; null !== a.sibling;) {
          a = a.sibling, c = c.sibling = Ub(a, a.pendingProps, a.expirationTime), c.return = b;
        }

        c.sibling = null;
      }

      return b.child;
    }

    function xd(a, b, c) {
      var d = b.expirationTime;

      if (null !== a && a.memoizedProps === b.pendingProps && !B.current && d < c) {
        switch (b.tag) {
          case 3:
            vd(b);
            ld();
            break;

          case 5:
            Gc(b);
            break;

          case 1:
            C(b.type) && Lb(b);
            break;

          case 4:
            Dc(b, b.stateNode.containerInfo);
            break;

          case 10:
            uc(b, b.memoizedProps.value);
            break;

          case 13:
            if (null !== b.memoizedState) {
              d = b.child.childExpirationTime;
              if (0 !== d && d >= c) return wd(a, b, c);
              b = qd(a, b, c);
              return null !== b ? b.sibling : null;
            }

        }

        return qd(a, b, c);
      }

      b.expirationTime = 0;

      switch (b.tag) {
        case 2:
          d = b.elementType;
          null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
          a = b.pendingProps;
          var e = Gb(b, A.current);
          wc(b, c);
          e = d(a, e);
          b.effectTag |= 1;

          if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
            b.tag = 1;

            if (C(d)) {
              var g = !0;
              Lb(b);
            } else g = !1;

            b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
            var f = d.getDerivedStateFromProps;
            "function" === typeof f && Oc(b, d, f, a);
            e.updater = Sc;
            b.stateNode = e;
            e._reactInternalFiber = b;
            Wc(b, d, a, c);
            b = ud(null, b, d, !0, g, c);
          } else b.tag = 0, I(null, b, e, c), b = b.child;

          return b;

        case 16:
          e = b.elementType;
          null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
          g = b.pendingProps;
          a = Lc(e);
          b.type = a;
          e = b.tag = Tb(a);
          g = F(a, g);
          f = void 0;

          switch (e) {
            case 0:
              f = rd(null, b, a, g, c);
              break;

            case 1:
              f = td(null, b, a, g, c);
              break;

            case 11:
              f = nd(null, b, a, g, c);
              break;

            case 14:
              f = od(null, b, a, F(a.type, g), d, c);
              break;

            default:
              m("283", a);
          }

          return f;

        case 0:
          return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), rd(a, b, d, e, c);

        case 1:
          return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), td(a, b, d, e, c);

        case 3:
          vd(b);
          d = b.updateQueue;
          null === d ? m("282") : void 0;
          e = b.memoizedState;
          e = null !== e ? e.element : null;
          mc(b, d, b.pendingProps, null, c);
          d = b.memoizedState.element;
          if (d === e) ld(), b = qd(a, b, c);else {
            e = b.stateNode;
            if (e = (null === a || null === a.child) && e.hydrate) Xa ? (cd = xb(b.stateNode.containerInfo), H = b, e = dd = !0) : e = !1;
            e ? (b.effectTag |= 2, b.child = bd(b, null, d, c)) : (I(a, b, d, c), ld());
            b = b.child;
          }
          return b;

        case 5:
          return Gc(b), null === a && id(b), d = b.type, e = b.pendingProps, g = null !== a ? a.memoizedProps : null, f = e.children, Ka(d, e) ? f = null : null !== g && Ka(d, g) && (b.effectTag |= 16), sd(a, b), 1 !== c && b.mode & 1 && La(d, e) ? (b.expirationTime = 1, b = null) : (I(a, b, f, c), b = b.child), b;

        case 6:
          return null === a && id(b), null;

        case 13:
          return wd(a, b, c);

        case 4:
          return Dc(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = ad(b, null, d, c) : I(a, b, d, c), b.child;

        case 11:
          return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), nd(a, b, d, e, c);

        case 7:
          return I(a, b, b.pendingProps, c), b.child;

        case 8:
          return I(a, b, b.pendingProps.children, c), b.child;

        case 12:
          return I(a, b, b.pendingProps.children, c), b.child;

        case 10:
          a: {
            d = b.type._context;
            e = b.pendingProps;
            f = b.memoizedProps;
            g = e.value;
            uc(b, g);

            if (null !== f) {
              var l = f.value;
              g = l === g && (0 !== l || 1 / l === 1 / g) || l !== l && g !== g ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(l, g) : 1073741823) | 0;

              if (0 === g) {
                if (f.children === e.children && !B.current) {
                  b = qd(a, b, c);
                  break a;
                }
              } else for (f = b.child, null !== f && (f.return = b); null !== f;) {
                l = f.firstContextDependency;

                if (null !== l) {
                  do {
                    if (l.context === d && 0 !== (l.observedBits & g)) {
                      if (1 === f.tag) {
                        var h = hc(c);
                        h.tag = 2;
                        E(f, h);
                      }

                      f.expirationTime < c && (f.expirationTime = c);
                      h = f.alternate;
                      null !== h && h.expirationTime < c && (h.expirationTime = c);

                      for (var k = f.return; null !== k;) {
                        h = k.alternate;
                        if (k.childExpirationTime < c) k.childExpirationTime = c, null !== h && h.childExpirationTime < c && (h.childExpirationTime = c);else if (null !== h && h.childExpirationTime < c) h.childExpirationTime = c;else break;
                        k = k.return;
                      }
                    }

                    h = f.child;
                    l = l.next;
                  } while (null !== l);
                } else h = 10 === f.tag ? f.type === b.type ? null : f.child : f.child;

                if (null !== h) h.return = f;else for (h = f; null !== h;) {
                  if (h === b) {
                    h = null;
                    break;
                  }

                  f = h.sibling;

                  if (null !== f) {
                    f.return = h.return;
                    h = f;
                    break;
                  }

                  h = h.return;
                }
                f = h;
              }
            }

            I(a, b, e.children, c);
            b = b.child;
          }

          return b;

        case 9:
          return e = b.type, g = b.pendingProps, d = g.children, wc(b, c), e = xc(e, g.unstable_observedBits), d = d(e), b.effectTag |= 1, I(a, b, d, c), b.child;

        case 14:
          return e = b.type, g = F(e.type, b.pendingProps), od(a, b, e, g, d, c);

        case 15:
          return pd(a, b, b.type, b.pendingProps, d, c);

        case 17:
          return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, C(d) ? (a = !0, Lb(b)) : a = !1, wc(b, c), Uc(b, d, e, c), Wc(b, d, e, c), ud(null, b, d, !0, a, c);

        default:
          m("156");
      }
    }

    function K(a) {
      a.effectTag |= 4;
    }

    var _yd = void 0,
        zd = void 0,
        Ad = void 0,
        Bd = void 0;

    if (Va) _yd = function yd(a, b) {
      for (var c = b.child; null !== c;) {
        if (5 === c.tag || 6 === c.tag) Ha(a, c.stateNode);else if (4 !== c.tag && null !== c.child) {
          c.child.return = c;
          c = c.child;
          continue;
        }
        if (c === b) break;

        for (; null === c.sibling;) {
          if (null === c.return || c.return === b) return;
          c = c.return;
        }

        c.sibling.return = c.return;
        c = c.sibling;
      }
    }, zd = function zd() {}, Ad = function Ad(a, b, c, d, e) {
      a = a.memoizedProps;

      if (a !== d) {
        var g = b.stateNode,
            f = Fc();
        c = Ja(g, c, a, d, e, f);
        (b.updateQueue = c) && K(b);
      }
    }, Bd = function Bd(a, b, c, d) {
      c !== d && K(b);
    };else if (Wa) {
      _yd = function yd(a, b, c, d) {
        for (var e = b.child; null !== e;) {
          a: if (5 === e.tag) {
            var g = e.stateNode;

            if (c) {
              var f = e.memoizedProps,
                  l = e.type;
              g = d ? qb(g, l, f, e) : rb(g, l, f, e);
              e.stateNode = g;
            }

            Ha(a, g);
          } else if (6 === e.tag) g = e.stateNode, c && (g = e.memoizedProps, f = Cc(Bc.current), l = Fc(), g = d ? tb(g, f, l, b) : Ma(g, f, l, b), e.stateNode = g), Ha(a, g);else if (4 !== e.tag) {
            if (13 === e.tag && (f = e.alternate, null !== f && (g = null !== e.memoizedState, null !== f.memoizedState !== g))) {
              f = g ? e.child : e;
              null !== f && _yd(a, f, !0, g);
              break a;
            }

            if (null !== e.child) {
              e.child.return = e;
              e = e.child;
              continue;
            }
          }

          if (e === b) break;

          for (; null === e.sibling;) {
            if (null === e.return || e.return === b) return;
            e = e.return;
          }

          e.sibling.return = e.return;
          e = e.sibling;
        }
      };

      var Cd = function Cd(a, b, c, d) {
        for (var e = b.child; null !== e;) {
          a: if (5 === e.tag) {
            var g = e.stateNode;

            if (c) {
              var f = e.memoizedProps,
                  l = e.type;
              g = d ? qb(g, l, f, e) : rb(g, l, f, e);
              e.stateNode = g;
            }

            nb(a, g);
          } else if (6 === e.tag) g = e.stateNode, c && (g = e.memoizedProps, f = Cc(Bc.current), l = Fc(), g = d ? tb(g, f, l, b) : Ma(g, f, l, b), e.stateNode = g), nb(a, g);else if (4 !== e.tag) {
            if (13 === e.tag && (f = e.alternate, null !== f && (g = null !== e.memoizedState, null !== f.memoizedState !== g))) {
              f = g ? e.child : e;
              null !== f && Cd(a, f, !0, g);
              break a;
            }

            if (null !== e.child) {
              e.child.return = e;
              e = e.child;
              continue;
            }
          }

          if (e === b) break;

          for (; null === e.sibling;) {
            if (null === e.return || e.return === b) return;
            e = e.return;
          }

          e.sibling.return = e.return;
          e = e.sibling;
        }
      };

      zd = function zd(a) {
        var b = a.stateNode;

        if (null !== a.firstEffect) {
          var c = b.containerInfo,
              d = mb(c);
          Cd(d, a, !1, !1);
          b.pendingChildren = d;
          K(a);
          ob(c, d);
        }
      };

      Ad = function Ad(a, b, c, d, e) {
        var g = a.stateNode,
            f = a.memoizedProps;
        if ((a = null === b.firstEffect) && f === d) b.stateNode = g;else {
          var l = b.stateNode,
              h = Fc(),
              k = null;
          f !== d && (k = Ja(l, c, f, d, e, h));
          a && null === k ? b.stateNode = g : (g = lb(g, k, c, f, d, b, a, l), Ia(g, c, d, e, h) && K(b), b.stateNode = g, a ? K(b) : _yd(g, b, !1, !1));
        }
      };

      Bd = function Bd(a, b, c, d) {
        c !== d && (a = Cc(Bc.current), c = Fc(), b.stateNode = Ma(d, a, c, b), K(b));
      };
    } else zd = function zd() {}, Ad = function Ad() {}, Bd = function Bd() {};

    function Dd(a, b) {
      var c = b.source,
          d = b.stack;
      null === d && null !== c && (d = Bb(c));
      null !== c && va(c.type);
      b = b.value;
      null !== a && 1 === a.tag && va(a.type);

      try {
        console.error(b);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }

    function Ed(a) {
      var b = a.ref;
      if (null !== b) if ("function" === typeof b) try {
        b(null);
      } catch (c) {
        Fd(a, c);
      } else b.current = null;
    }

    function Gd(a) {
      "function" === typeof Ob && Ob(a);

      switch (a.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          var b = a.updateQueue;

          if (null !== b && (b = b.lastEffect, null !== b)) {
            var c = b = b.next;

            do {
              var d = c.destroy;

              if (null !== d) {
                var e = a;

                try {
                  d();
                } catch (g) {
                  Fd(e, g);
                }
              }

              c = c.next;
            } while (c !== b);
          }

          break;

        case 1:
          Ed(a);
          b = a.stateNode;
          if ("function" === typeof b.componentWillUnmount) try {
            b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
          } catch (g) {
            Fd(a, g);
          }
          break;

        case 5:
          Ed(a);
          break;

        case 4:
          Va ? Hd(a) : Wa && Wa && (a = a.stateNode.containerInfo, b = mb(a), pb(a, b));
      }
    }

    function Id(a) {
      for (var b = a;;) {
        if (Gd(b), null === b.child || Va && 4 === b.tag) {
          if (b === a) break;

          for (; null === b.sibling;) {
            if (null === b.return || b.return === a) return;
            b = b.return;
          }

          b.sibling.return = b.return;
          b = b.sibling;
        } else b.child.return = b, b = b.child;
      }
    }

    function Jd(a) {
      return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }

    function Kd(a) {
      if (Va) {
        a: {
          for (var b = a.return; null !== b;) {
            if (Jd(b)) {
              var c = b;
              break a;
            }

            b = b.return;
          }

          m("160");
          c = void 0;
        }

        var d = b = void 0;

        switch (c.tag) {
          case 5:
            b = c.stateNode;
            d = !1;
            break;

          case 3:
            b = c.stateNode.containerInfo;
            d = !0;
            break;

          case 4:
            b = c.stateNode.containerInfo;
            d = !0;
            break;

          default:
            m("161");
        }

        c.effectTag & 16 && (gb(b), c.effectTag &= -17);

        a: b: for (c = a;;) {
          for (; null === c.sibling;) {
            if (null === c.return || Jd(c.return)) {
              c = null;
              break a;
            }

            c = c.return;
          }

          c.sibling.return = c.return;

          for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
          }

          if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
          }
        }

        for (var e = a;;) {
          if (5 === e.tag || 6 === e.tag) c ? d ? db(b, e.stateNode, c) : cb(b, e.stateNode, c) : d ? Za(b, e.stateNode) : Ya(b, e.stateNode);else if (4 !== e.tag && null !== e.child) {
            e.child.return = e;
            e = e.child;
            continue;
          }
          if (e === a) break;

          for (; null === e.sibling;) {
            if (null === e.return || e.return === a) return;
            e = e.return;
          }

          e.sibling.return = e.return;
          e = e.sibling;
        }
      }
    }

    function Hd(a) {
      for (var b = a, c = !1, d = void 0, e = void 0;;) {
        if (!c) {
          c = b.return;

          a: for (;;) {
            null === c ? m("160") : void 0;

            switch (c.tag) {
              case 5:
                d = c.stateNode;
                e = !1;
                break a;

              case 3:
                d = c.stateNode.containerInfo;
                e = !0;
                break a;

              case 4:
                d = c.stateNode.containerInfo;
                e = !0;
                break a;
            }

            c = c.return;
          }

          c = !0;
        }

        if (5 === b.tag || 6 === b.tag) Id(b), e ? fb(d, b.stateNode) : eb(d, b.stateNode);else if (4 === b.tag ? (d = b.stateNode.containerInfo, e = !0) : Gd(b), null !== b.child) {
          b.child.return = b;
          b = b.child;
          continue;
        }
        if (b === a) break;

        for (; null === b.sibling;) {
          if (null === b.return || b.return === a) return;
          b = b.return;
          4 === b.tag && (c = !1);
        }

        b.sibling.return = b.return;
        b = b.sibling;
      }
    }

    function Ld(a, b) {
      if (Va) switch (b.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          break;

        case 1:
          break;

        case 5:
          var c = b.stateNode;

          if (null != c) {
            var d = b.memoizedProps;
            a = null !== a ? a.memoizedProps : d;
            var e = b.type,
                g = b.updateQueue;
            b.updateQueue = null;
            null !== g && bb(c, g, e, a, d, b);
          }

          break;

        case 6:
          null === b.stateNode ? m("162") : void 0;
          c = b.memoizedProps;
          $a(b.stateNode, null !== a ? a.memoizedProps : c, c);
          break;

        case 3:
          break;

        case 12:
          break;

        case 13:
          d = b.memoizedState;
          a = b;
          null === d ? c = !1 : (c = !0, a = b.child, 0 === d.timedOutAt && (d.timedOutAt = G()));
          if (null !== a) a: if (b = a, Va) for (d = b;;) {
            if (5 === d.tag) a = d.stateNode, c ? hb(a) : jb(d.stateNode, d.memoizedProps);else if (6 === d.tag) a = d.stateNode, c ? ib(a) : kb(a, d.memoizedProps);else if (13 === d.tag && null !== d.memoizedState) {
              a = d.child.sibling;
              a.return = d;
              d = a;
              continue;
            } else if (null !== d.child) {
              d.child.return = d;
              d = d.child;
              continue;
            }
            if (d === b) break a;

            for (; null === d.sibling;) {
              if (null === d.return || d.return === b) break a;
              d = d.return;
            }

            d.sibling.return = d.return;
            d = d.sibling;
          }
          break;

        case 17:
          break;

        default:
          m("163");
      } else {
        switch (b.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            return;
        }

        if (Wa) switch (b.tag) {
          case 1:
            break;

          case 5:
            break;

          case 6:
            break;

          case 3:
          case 4:
            b = b.stateNode;
            pb(b.containerInfo, b.pendingChildren);
            break;

          default:
            m("163");
        }
      }
    }

    function Md(a, b, c) {
      c = hc(c);
      c.tag = 3;
      c.payload = {
        element: null
      };
      var d = b.value;

      c.callback = function () {
        Nd(d);
        Dd(a, b);
      };

      return c;
    }

    function Od(a, b, c) {
      c = hc(c);
      c.tag = 3;
      var d = a.type.getDerivedStateFromError;

      if ("function" === typeof d) {
        var e = b.value;

        c.payload = function () {
          return d(e);
        };
      }

      var g = a.stateNode;
      null !== g && "function" === typeof g.componentDidCatch && (c.callback = function () {
        "function" !== typeof d && (null === Pd ? Pd = new Set([this]) : Pd.add(this));
        var c = b.value,
            e = b.stack;
        Dd(a, b);
        this.componentDidCatch(c, {
          componentStack: null !== e ? e : ""
        });
      });
      return c;
    }

    function Qd(a) {
      switch (a.tag) {
        case 1:
          C(a.type) && Hb(a);
          var b = a.effectTag;
          return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;

        case 3:
          return Ec(a), Ib(a), b = a.effectTag, 0 !== (b & 64) ? m("285") : void 0, a.effectTag = b & -2049 | 64, a;

        case 5:
          return Hc(a), null;

        case 13:
          return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;

        case 4:
          return Ec(a), null;

        case 10:
          return vc(a), null;

        default:
          return null;
      }
    }

    var Rd = {
      readContext: xc
    },
        Sd = ea.ReactCurrentOwner,
        Td = 1073741822,
        Ud = 0,
        Vd = !1,
        L = null,
        M = null,
        N = 0,
        Wd = -1,
        Xd = !1,
        O = null,
        Yd = !1,
        Pd = null;

    function ae() {
      if (null !== L) for (var a = L.return; null !== a;) {
        var b = a;

        switch (b.tag) {
          case 1:
            var c = b.type.childContextTypes;
            null !== c && void 0 !== c && Hb(b);
            break;

          case 3:
            Ec(b);
            Ib(b);
            break;

          case 5:
            Hc(b);
            break;

          case 4:
            Ec(b);
            break;

          case 10:
            vc(b);
        }

        a = a.return;
      }
      M = null;
      N = 0;
      Wd = -1;
      Xd = !1;
      L = null;
    }

    function be(a) {
      for (;;) {
        var b = a.alternate,
            c = a.return,
            d = a.sibling;

        if (0 === (a.effectTag & 1024)) {
          L = a;

          a: {
            var e = b;
            b = a;
            var g = N,
                f = b.pendingProps;

            switch (b.tag) {
              case 2:
                break;

              case 16:
                break;

              case 15:
              case 0:
                break;

              case 1:
                C(b.type) && Hb(b);
                break;

              case 3:
                Ec(b);
                Ib(b);
                f = b.stateNode;
                f.pendingContext && (f.context = f.pendingContext, f.pendingContext = null);
                if (null === e || null === e.child) kd(b), b.effectTag &= -3;
                zd(b);
                break;

              case 5:
                Hc(b);
                g = Cc(Bc.current);
                var l = b.type;
                if (null !== e && null != b.stateNode) Ad(e, b, l, f, g), e.ref !== b.ref && (b.effectTag |= 128);else if (f) {
                  e = Fc();
                  if (kd(b)) f = b, Xa || m("175"), e = yb(f.stateNode, f.type, f.memoizedProps, g, e, f), f.updateQueue = e, e = null !== e ? !0 : !1, e && K(b);else {
                    var h = Ga(l, f, g, e, b);

                    _yd(h, b, !1, !1);

                    Ia(h, l, f, g, e) && K(b);
                    b.stateNode = h;
                  }
                  null !== b.ref && (b.effectTag |= 128);
                } else null === b.stateNode ? m("166") : void 0;
                break;

              case 6:
                e && null != b.stateNode ? Bd(e, b, e.memoizedProps, f) : ("string" !== typeof f && (null === b.stateNode ? m("166") : void 0), e = Cc(Bc.current), g = Fc(), kd(b) ? (e = b, Xa || m("176"), (e = zb(e.stateNode, e.memoizedProps, e)) && K(b)) : b.stateNode = Ma(f, e, g, b));
                break;

              case 11:
                break;

              case 13:
                f = b.memoizedState;

                if (0 !== (b.effectTag & 64)) {
                  b.expirationTime = g;
                  L = b;
                  break a;
                }

                f = null !== f;
                g = null !== e && null !== e.memoizedState;
                null !== e && !f && g && (e = e.child.sibling, null !== e && (l = b.firstEffect, null !== l ? (b.firstEffect = e, e.nextEffect = l) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));
                if (f !== g || 0 === (b.effectTag & 1) && f) b.effectTag |= 4;
                break;

              case 7:
                break;

              case 8:
                break;

              case 12:
                break;

              case 4:
                Ec(b);
                zd(b);
                break;

              case 10:
                vc(b);
                break;

              case 9:
                break;

              case 14:
                break;

              case 17:
                C(b.type) && Hb(b);
                break;

              default:
                m("156");
            }

            L = null;
          }

          b = a;

          if (1 === N || 1 !== b.childExpirationTime) {
            e = 0;

            for (f = b.child; null !== f;) {
              g = f.expirationTime, l = f.childExpirationTime, g > e && (e = g), l > e && (e = l), f = f.sibling;
            }

            b.childExpirationTime = e;
          }

          if (null !== L) return L;
          null !== c && 0 === (c.effectTag & 1024) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
        } else {
          a = Qd(a, N);
          if (null !== a) return a.effectTag &= 1023, a;
          null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);
        }

        if (null !== d) return d;
        if (null !== c) a = c;else break;
      }

      return null;
    }

    function ce(a) {
      var b = xd(a.alternate, a, N);
      a.memoizedProps = a.pendingProps;
      null === b && (b = be(a));
      Sd.current = null;
      return b;
    }

    function de(a, b) {
      Vd ? m("243") : void 0;
      Vd = !0;
      Sd.currentDispatcher = Rd;
      var c = a.nextExpirationTimeToWorkOn;
      if (c !== N || a !== M || null === L) ae(), M = a, N = c, L = Ub(M.current, null, N), a.pendingCommitExpirationTime = 0;
      var d = !1;

      do {
        try {
          if (b) for (; null !== L && !ee();) {
            L = ce(L);
          } else for (; null !== L;) {
            L = ce(L);
          }
        } catch (J) {
          if (tc = sc = rc = null, null === L) d = !0, Nd(J);else {
            null === L ? m("271") : void 0;
            var e = L,
                g = e.return;
            if (null === g) d = !0, Nd(J);else {
              a: {
                var f = a,
                    l = g,
                    h = e,
                    k = J;
                g = N;
                h.effectTag |= 1024;
                h.firstEffect = h.lastEffect = null;

                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                  var p = k;
                  k = l;
                  var y = -1,
                      v = -1;

                  do {
                    if (13 === k.tag) {
                      var u = k.alternate;

                      if (null !== u && (u = u.memoizedState, null !== u)) {
                        v = 10 * (1073741822 - u.timedOutAt);
                        break;
                      }

                      u = k.pendingProps.maxDuration;
                      if ("number" === typeof u) if (0 >= u) y = 0;else if (-1 === y || u < y) y = u;
                    }

                    k = k.return;
                  } while (null !== k);

                  k = l;

                  do {
                    if (u = 13 === k.tag) u = void 0 === k.memoizedProps.fallback ? !1 : null === k.memoizedState;

                    if (u) {
                      l = fe.bind(null, f, k, h, 0 === (k.mode & 1) ? 1073741823 : g);
                      p.then(l, l);

                      if (0 === (k.mode & 1)) {
                        k.effectTag |= 64;
                        h.effectTag &= -1957;
                        1 === h.tag && null === h.alternate && (h.tag = 17);
                        h.expirationTime = g;
                        break a;
                      }

                      -1 === y ? f = 1073741823 : (-1 === v && (v = 10 * (1073741822 - cc(f, g)) - 5E3), f = v + y);
                      0 <= f && Wd < f && (Wd = f);
                      k.effectTag |= 2048;
                      k.expirationTime = g;
                      break a;
                    }

                    k = k.return;
                  } while (null !== k);

                  k = Error((va(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Bb(h));
                }

                Xd = !0;
                k = pc(k, h);
                f = l;

                do {
                  switch (f.tag) {
                    case 3:
                      h = k;
                      f.effectTag |= 2048;
                      f.expirationTime = g;
                      g = Md(f, h, g);
                      jc(f, g);
                      break a;

                    case 1:
                      if (h = k, l = f.type, p = f.stateNode, 0 === (f.effectTag & 64) && ("function" === typeof l.getDerivedStateFromError || null !== p && "function" === typeof p.componentDidCatch && (null === Pd || !Pd.has(p)))) {
                        f.effectTag |= 2048;
                        f.expirationTime = g;
                        g = Od(f, h, g);
                        jc(f, g);
                        break a;
                      }

                  }

                  f = f.return;
                } while (null !== f);
              }

              L = be(e);
              continue;
            }
          }
        }

        break;
      } while (1);

      Vd = !1;
      tc = sc = rc = Sd.currentDispatcher = null;
      if (d) M = null, a.finishedWork = null;else if (null !== L) a.finishedWork = null;else {
        d = a.current.alternate;
        null === d ? m("281") : void 0;
        M = null;

        if (Xd) {
          e = a.latestPendingTime;
          g = a.latestSuspendedTime;
          f = a.latestPingedTime;

          if (0 !== e && e < c || 0 !== g && g < c || 0 !== f && f < c) {
            bc(a, c);
            ge(a, d, c, a.expirationTime, -1);
            return;
          }

          if (!a.didError && b) {
            a.didError = !0;
            c = a.nextExpirationTimeToWorkOn = c;
            b = a.expirationTime = 1073741823;
            ge(a, d, c, b, -1);
            return;
          }
        }

        b && -1 !== Wd ? (bc(a, c), b = 10 * (1073741822 - cc(a, c)), b < Wd && (Wd = b), b = 10 * (1073741822 - G()), b = Wd - b, ge(a, d, c, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = c, a.finishedWork = d);
      }
    }

    function Fd(a, b) {
      for (var c = a.return; null !== c;) {
        switch (c.tag) {
          case 1:
            var d = c.stateNode;

            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Pd || !Pd.has(d))) {
              a = pc(b, a);
              a = Od(c, a, 1073741823);
              E(c, a);
              Rc(c, 1073741823);
              return;
            }

            break;

          case 3:
            a = pc(b, a);
            a = Md(c, a, 1073741823);
            E(c, a);
            Rc(c, 1073741823);
            return;
        }

        c = c.return;
      }

      3 === a.tag && (c = pc(b, a), c = Md(a, c, 1073741823), E(a, c), Rc(a, 1073741823));
    }

    function Pc(a, b) {
      0 !== Ud ? a = Ud : Vd ? a = Yd ? 1073741823 : N : b.mode & 1 ? (a = P ? 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1) : 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1), null !== M && a === N && --a) : a = 1073741823;
      P && (0 === Q || a < Q) && (Q = a);
      return a;
    }

    function fe(a, b, c, d) {
      var e = a.earliestSuspendedTime;
      var g = a.latestSuspendedTime;

      if (0 !== e && d <= e && d >= g) {
        g = e = d;
        a.didError = !1;
        var f = a.latestPingedTime;
        if (0 === f || f > g) a.latestPingedTime = g;
        ac(g, a);
      } else e = G(), e = Pc(e, b), $b(a, e);

      0 !== (b.mode & 1) && a === M && N === d && (M = null);
      he(b, e);
      0 === (b.mode & 1) && (he(c, e), 1 === c.tag && null !== c.stateNode && (b = hc(e), b.tag = 2, E(c, b)));
      c = a.expirationTime;
      0 !== c && ie(a, c);
    }

    function he(a, b) {
      a.expirationTime < b && (a.expirationTime = b);
      var c = a.alternate;
      null !== c && c.expirationTime < b && (c.expirationTime = b);
      var d = a.return,
          e = null;
      if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);

        if (null === d.return && 3 === d.tag) {
          e = d.stateNode;
          break;
        }

        d = d.return;
      }
      return e;
    }

    function Rc(a, b) {
      a = he(a, b);
      null !== a && (!Vd && 0 !== N && b > N && ae(), $b(a, b), Vd && !Yd && M === a || ie(a, a.expirationTime), je > ke && (je = 0, m("185")));
    }

    function le(a, b, c, d, e) {
      var g = Ud;
      Ud = 1073741823;

      try {
        return a(b, c, d, e);
      } finally {
        Ud = g;
      }
    }

    var R = null,
        S = null,
        me = 0,
        ne = void 0,
        T = !1,
        V = null,
        W = 0,
        Q = 0,
        oe = !1,
        pe = null,
        X = !1,
        qe = !1,
        P = !1,
        re = null,
        se = Ta(),
        Y = 1073741822 - (se / 10 | 0),
        te = Y,
        ke = 50,
        je = 0,
        ue = null;

    function ve() {
      Y = 1073741822 - ((Ta() - se) / 10 | 0);
    }

    function we(a, b) {
      if (0 !== me) {
        if (b < me) return;
        null !== ne && Oa(ne);
      }

      me = b;
      a = Ta() - se;
      ne = Na(xe, {
        timeout: 10 * (1073741822 - b) - a
      });
    }

    function ge(a, b, c, d, e) {
      a.expirationTime = d;
      0 !== e || ee() ? 0 < e && (a.timeoutHandle = Qa(ze.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);
    }

    function ze(a, b, c) {
      a.pendingCommitExpirationTime = c;
      a.finishedWork = b;
      ve();
      te = Y;
      Ae(a, c);
    }

    function G() {
      if (T) return te;
      Be();
      if (0 === W || 1 === W) ve(), te = Y;
      return te;
    }

    function ie(a, b) {
      null === a.nextScheduledRoot ? (a.expirationTime = b, null === S ? (R = S = a, a.nextScheduledRoot = a) : (S = S.nextScheduledRoot = a, S.nextScheduledRoot = R)) : b > a.expirationTime && (a.expirationTime = b);
      T || (X ? qe && (V = a, W = 1073741823, Ce(a, 1073741823, !1)) : 1073741823 === b ? Z(1073741823, !1) : we(a, b));
    }

    function Be() {
      var a = 0,
          b = null;
      if (null !== S) for (var c = S, d = R; null !== d;) {
        var e = d.expirationTime;

        if (0 === e) {
          null === c || null === S ? m("244") : void 0;

          if (d === d.nextScheduledRoot) {
            R = S = d.nextScheduledRoot = null;
            break;
          } else if (d === R) R = e = d.nextScheduledRoot, S.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === S) {
            S = c;
            S.nextScheduledRoot = R;
            d.nextScheduledRoot = null;
            break;
          } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;

          d = c.nextScheduledRoot;
        } else {
          e > a && (a = e, b = d);
          if (d === S) break;
          if (1073741823 === a) break;
          c = d;
          d = d.nextScheduledRoot;
        }
      }
      V = b;
      W = a;
    }

    var De = !1;

    function ee() {
      return De ? !0 : Pa() ? De = !0 : !1;
    }

    function xe() {
      try {
        if (!ee() && null !== R) {
          ve();
          var a = R;

          do {
            var b = a.expirationTime;
            0 !== b && Y <= b && (a.nextExpirationTimeToWorkOn = Y);
            a = a.nextScheduledRoot;
          } while (a !== R);
        }

        Z(0, !0);
      } finally {
        De = !1;
      }
    }

    function Z(a, b) {
      Be();
      if (b) for (ve(), te = Y; null !== V && 0 !== W && a <= W && !(De && Y > W);) {
        Ce(V, W, Y > W), Be(), ve(), te = Y;
      } else for (; null !== V && 0 !== W && a <= W;) {
        Ce(V, W, !1), Be();
      }
      b && (me = 0, ne = null);
      0 !== W && we(V, W);
      je = 0;
      ue = null;
      if (null !== re) for (a = re, re = null, b = 0; b < a.length; b++) {
        var c = a[b];

        try {
          c._onComplete();
        } catch (d) {
          oe || (oe = !0, pe = d);
        }
      }
      if (oe) throw a = pe, pe = null, oe = !1, a;
    }

    function Ae(a, b) {
      T ? m("253") : void 0;
      V = a;
      W = b;
      Ce(a, b, !1);
      Z(1073741823, !1);
    }

    function Ce(a, b, c) {
      T ? m("245") : void 0;
      T = !0;

      if (c) {
        var d = a.finishedWork;
        null !== d ? Ee(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, d !== Sa && (a.timeoutHandle = Sa, Ra(d)), de(a, c), d = a.finishedWork, null !== d && (ee() ? a.finishedWork = d : Ee(a, d, b)));
      } else d = a.finishedWork, null !== d ? Ee(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, d !== Sa && (a.timeoutHandle = Sa, Ra(d)), de(a, c), d = a.finishedWork, null !== d && Ee(a, d, b));

      T = !1;
    }

    function Ee(a, b, c) {
      var d = a.firstBatch;

      if (null !== d && d._expirationTime >= c && (null === re ? re = [d] : re.push(d), d._defer)) {
        a.finishedWork = b;
        a.expirationTime = 0;
        return;
      }

      a.finishedWork = null;
      a === ue ? je++ : (ue = a, je = 0);
      Yd = Vd = !0;
      a.current === b ? m("177") : void 0;
      c = a.pendingCommitExpirationTime;
      0 === c ? m("261") : void 0;
      a.pendingCommitExpirationTime = 0;
      d = b.expirationTime;
      var e = b.childExpirationTime;
      d = e > d ? e : d;
      a.didError = !1;
      0 === d ? (a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0) : (e = a.latestPendingTime, 0 !== e && (e > d ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > d && (a.earliestPendingTime = a.latestPendingTime)), e = a.earliestSuspendedTime, 0 === e ? $b(a, d) : d < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, $b(a, d)) : d > e && $b(a, d));
      ac(0, a);
      Sd.current = null;
      1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;
      Ea(a.containerInfo);

      for (O = d; null !== O;) {
        e = !1;
        var g = void 0;

        try {
          for (; null !== O;) {
            if (O.effectTag & 256) a: {
              var f = O.alternate,
                  l = O;

              switch (l.tag) {
                case 0:
                case 11:
                case 15:
                  break a;

                case 1:
                  if (l.effectTag & 256 && null !== f) {
                    var h = f.memoizedProps,
                        k = f.memoizedState,
                        p = l.stateNode,
                        y = p.getSnapshotBeforeUpdate(l.elementType === l.type ? h : F(l.type, h), k);
                    p.__reactInternalSnapshotBeforeUpdate = y;
                  }

                  break a;

                case 3:
                case 5:
                case 6:
                case 4:
                case 17:
                  break a;

                default:
                  m("163");
              }
            }
            O = O.nextEffect;
          }
        } catch (r) {
          e = !0, g = r;
        }

        e && (null === O ? m("178") : void 0, Fd(O, g), null !== O && (O = O.nextEffect));
      }

      for (O = d; null !== O;) {
        f = !1;
        h = void 0;

        try {
          for (; null !== O;) {
            var v = O.effectTag;
            v & 16 && Va && gb(O.stateNode);

            if (v & 128) {
              var u = O.alternate;

              if (null !== u) {
                var J = u.ref;
                null !== J && ("function" === typeof J ? J(null) : J.current = null);
              }
            }

            switch (v & 14) {
              case 2:
                Kd(O);
                O.effectTag &= -3;
                break;

              case 6:
                Kd(O);
                O.effectTag &= -3;
                Ld(O.alternate, O);
                break;

              case 4:
                Ld(O.alternate, O);
                break;

              case 8:
                k = O, Va ? Hd(k) : Id(k), k.return = null, k.child = null, k.alternate && (k.alternate.child = null, k.alternate.return = null);
            }

            O = O.nextEffect;
          }
        } catch (r) {
          f = !0, h = r;
        }

        f && (null === O ? m("178") : void 0, Fd(O, h), null !== O && (O = O.nextEffect));
      }

      Fa(a.containerInfo);
      a.current = b;

      for (O = d; null !== O;) {
        v = !1;
        u = void 0;

        try {
          for (J = c; null !== O;) {
            var ta = O.effectTag;

            if (ta & 36) {
              var q = O.alternate;
              f = O;
              h = J;

              switch (f.tag) {
                case 0:
                case 11:
                case 15:
                  break;

                case 1:
                  var w = f.stateNode;
                  if (f.effectTag & 4) if (null === q) w.componentDidMount();else {
                    var t = f.elementType === f.type ? q.memoizedProps : F(f.type, q.memoizedProps);
                    w.componentDidUpdate(t, q.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
                  }
                  var U = f.updateQueue;
                  null !== U && nc(f, U, w, h);
                  break;

                case 3:
                  var gd = f.updateQueue;

                  if (null !== gd) {
                    k = null;
                    if (null !== f.child) switch (f.child.tag) {
                      case 5:
                        k = Ba(f.child.stateNode);
                        break;

                      case 1:
                        k = f.child.stateNode;
                    }
                    nc(f, gd, k, h);
                  }

                  break;

                case 5:
                  var ye = f.stateNode;
                  null === q && f.effectTag & 4 && ab(ye, f.type, f.memoizedProps, f);
                  break;

                case 6:
                  break;

                case 4:
                  break;

                case 12:
                  break;

                case 13:
                  break;

                case 17:
                  break;

                default:
                  m("163");
              }
            }

            if (ta & 128) {
              var sb = O.ref;

              if (null !== sb) {
                var hd = O.stateNode;

                switch (O.tag) {
                  case 5:
                    var dc = Ba(hd);
                    break;

                  default:
                    dc = hd;
                }

                "function" === typeof sb ? sb(dc) : sb.current = dc;
              }
            }

            O = O.nextEffect;
          }
        } catch (r) {
          v = !0, u = r;
        }

        v && (null === O ? m("178") : void 0, Fd(O, u), null !== O && (O = O.nextEffect));
      }

      Vd = Yd = !1;
      "function" === typeof Nb && Nb(b.stateNode);
      ta = b.expirationTime;
      b = b.childExpirationTime;
      b = b > ta ? b : ta;
      0 === b && (Pd = null);
      a.expirationTime = b;
      a.finishedWork = null;
    }

    function Nd(a) {
      null === V ? m("246") : void 0;
      V.expirationTime = 0;
      oe || (oe = !0, pe = a);
    }

    function Fe(a, b, c, d, e) {
      var g = b.current;

      a: if (c) {
        c = c._reactInternalFiber;

        b: {
          2 === wa(c) && 1 === c.tag ? void 0 : m("170");
          var f = c;

          do {
            switch (f.tag) {
              case 3:
                f = f.stateNode.context;
                break b;

              case 1:
                if (C(f.type)) {
                  f = f.stateNode.__reactInternalMemoizedMergedChildContext;
                  break b;
                }

            }

            f = f.return;
          } while (null !== f);

          m("171");
          f = void 0;
        }

        if (1 === c.tag) {
          var l = c.type;

          if (C(l)) {
            c = Kb(c, l, f);
            break a;
          }
        }

        c = f;
      } else c = Eb;

      null === b.context ? b.context = c : b.pendingContext = c;
      b = e;
      e = hc(d);
      e.payload = {
        element: a
      };
      b = void 0 === b ? null : b;
      null !== b && (e.callback = b);
      E(g, e);
      Rc(g, d);
      return d;
    }

    function Ge(a) {
      var b = a._reactInternalFiber;
      void 0 === b && ("function" === typeof a.render ? m("188") : m("268", Object.keys(a)));
      a = za(b);
      return null === a ? null : a.stateNode;
    }

    var He = {
      updateContainerAtExpirationTime: Fe,
      createContainer: function createContainer(a, b, c) {
        b = D(3, null, null, b ? 3 : 0);
        a = {
          current: b,
          containerInfo: a,
          pendingChildren: null,
          earliestPendingTime: 0,
          latestPendingTime: 0,
          earliestSuspendedTime: 0,
          latestSuspendedTime: 0,
          latestPingedTime: 0,
          didError: !1,
          pendingCommitExpirationTime: 0,
          finishedWork: null,
          timeoutHandle: Sa,
          context: null,
          pendingContext: null,
          hydrate: c,
          nextExpirationTimeToWorkOn: 0,
          expirationTime: 0,
          firstBatch: null,
          nextScheduledRoot: null
        };
        return b.stateNode = a;
      },
      updateContainer: function updateContainer(a, b, c, d) {
        var e = b.current,
            g = G();
        e = Pc(g, e);
        return Fe(a, b, c, e, d);
      },
      flushRoot: Ae,
      requestWork: ie,
      computeUniqueAsyncExpiration: function computeUniqueAsyncExpiration() {
        var a = 1073741822 - 25 * (((1073741822 - G() + 500) / 25 | 0) + 1);
        a >= Td && (a = Td - 1);
        return Td = a;
      },
      batchedUpdates: function batchedUpdates(a, b) {
        var c = X;
        X = !0;

        try {
          return a(b);
        } finally {
          (X = c) || T || Z(1073741823, !1);
        }
      },
      unbatchedUpdates: function unbatchedUpdates(a, b) {
        if (X && !qe) {
          qe = !0;

          try {
            return a(b);
          } finally {
            qe = !1;
          }
        }

        return a(b);
      },
      deferredUpdates: function deferredUpdates(a) {
        var b = G(),
            c = Ud,
            d = P;
        Ud = 1073741822 - 25 * (((1073741822 - b + 500) / 25 | 0) + 1);
        P = !1;

        try {
          return a();
        } finally {
          Ud = c, P = d;
        }
      },
      syncUpdates: le,
      interactiveUpdates: function interactiveUpdates(a, b, c) {
        if (P) return a(b, c);
        X || T || 0 === Q || (Z(Q, !1), Q = 0);
        var d = P,
            e = X;
        X = P = !0;

        try {
          return a(b, c);
        } finally {
          P = d, (X = e) || T || Z(1073741823, !1);
        }
      },
      flushInteractiveUpdates: function flushInteractiveUpdates() {
        T || 0 === Q || (Z(Q, !1), Q = 0);
      },
      flushControlled: function flushControlled(a) {
        var b = X;
        X = !0;

        try {
          le(a);
        } finally {
          (X = b) || T || Z(1073741823, !1);
        }
      },
      flushSync: function flushSync(a, b) {
        T ? m("187") : void 0;
        var c = X;
        X = !0;

        try {
          return le(a, b);
        } finally {
          X = c, Z(1073741823, !1);
        }
      },
      getPublicRootInstance: function getPublicRootInstance(a) {
        a = a.current;
        if (!a.child) return null;

        switch (a.child.tag) {
          case 5:
            return Ba(a.child.stateNode);

          default:
            return a.child.stateNode;
        }
      },
      findHostInstance: Ge,
      findHostInstanceWithWarning: function findHostInstanceWithWarning(a) {
        return Ge(a);
      },
      findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
        a = Aa(a);
        return null === a ? null : a.stateNode;
      },
      injectIntoDevTools: function injectIntoDevTools(a) {
        var b = a.findFiberByHostInstance;
        return Qb(aa({}, a, {
          findHostInstanceByFiber: function findHostInstanceByFiber(a) {
            a = za(a);
            return null === a ? null : a.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(a) {
            return b ? b(a) : null;
          }
        }));
      }
    };
    module.exports = He.default || He;
    var $$$renderer = module.exports;
    module.exports = $$$reconciler;
    return $$$renderer;
  };
});
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;
var schedulerTracing_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = 0;
  exports.__interactionsRef = null;
  exports.__subscriberRef = null;

  exports.unstable_clear = function (a) {
    return a();
  };

  exports.unstable_getCurrent = function () {
    return null;
  };

  exports.unstable_getThreadID = function () {
    return ++b;
  };

  exports.unstable_trace = function (a, d, c) {
    return c();
  };

  exports.unstable_wrap = function (a) {
    return a;
  };

  exports.unstable_subscribe = function () {};

  exports.unstable_unsubscribe = function () {};
});
unwrapExports(schedulerTracing_production_min);
var schedulerTracing_production_min_1 = schedulerTracing_production_min.__interactionsRef;
var schedulerTracing_production_min_2 = schedulerTracing_production_min.__subscriberRef;
var schedulerTracing_production_min_3 = schedulerTracing_production_min.unstable_clear;
var schedulerTracing_production_min_4 = schedulerTracing_production_min.unstable_getCurrent;
var schedulerTracing_production_min_5 = schedulerTracing_production_min.unstable_getThreadID;
var schedulerTracing_production_min_6 = schedulerTracing_production_min.unstable_trace;
var schedulerTracing_production_min_7 = schedulerTracing_production_min.unstable_wrap;
var schedulerTracing_production_min_8 = schedulerTracing_production_min.unstable_subscribe;
var schedulerTracing_production_min_9 = schedulerTracing_production_min.unstable_unsubscribe;
var schedulerTracing_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // Only used in www builds.
      // Only used in www builds.
      // React Fire: prevent the value and checked attributes from syncing
      // with their related DOM properties
      // These APIs will no longer be "unstable" in the upcoming 16.7 release,
      // Control this behavior with a flag to support 16.6 minor releases in the meanwhile.

      var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

      var interactionIDCounter = 0;
      var threadIDCounter = 0; // Set of currently traced interactions.
      // Interactions "stack"–
      // Meaning that newly traced interactions are appended to the previously active set.
      // When an interaction goes out of scope, the previous set (if any) is restored.

      exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

      exports.__subscriberRef = null;
      {
        exports.__interactionsRef = {
          current: new Set()
        };
        exports.__subscriberRef = {
          current: null
        };
      }

      function unstable_clear(callback) {
        var prevInteractions = exports.__interactionsRef.current;
        exports.__interactionsRef.current = new Set();

        try {
          return callback();
        } finally {
          exports.__interactionsRef.current = prevInteractions;
        }
      }

      function unstable_getCurrent() {
        {
          return exports.__interactionsRef.current;
        }
      }

      function unstable_getThreadID() {
        return ++threadIDCounter;
      }

      function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
          __count: 1,
          id: interactionIDCounter++,
          name: name,
          timestamp: timestamp
        };
        var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.

        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        exports.__interactionsRef.current = interactions;
        var subscriber = exports.__subscriberRef.current;
        var returnValue = void 0;

        try {
          if (subscriber !== null) {
            subscriber.onInteractionTraced(interaction);
          }
        } finally {
          try {
            if (subscriber !== null) {
              subscriber.onWorkStarted(interactions, threadID);
            }
          } finally {
            try {
              returnValue = callback();
            } finally {
              exports.__interactionsRef.current = prevInteractions;

              try {
                if (subscriber !== null) {
                  subscriber.onWorkStopped(interactions, threadID);
                }
              } finally {
                interaction.__count--; // If no async work was scheduled for this interaction,
                // Notify subscribers that it's completed.

                if (subscriber !== null && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              }
            }
          }
        }

        return returnValue;
      }

      function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = exports.__interactionsRef.current;
        var subscriber = exports.__subscriberRef.current;

        if (subscriber !== null) {
          subscriber.onWorkScheduled(wrappedInteractions, threadID);
        } // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.


        wrappedInteractions.forEach(function (interaction) {
          interaction.__count++;
        });
        var hasRun = false;

        function wrapped() {
          var prevInteractions = exports.__interactionsRef.current;
          exports.__interactionsRef.current = wrappedInteractions;
          subscriber = exports.__subscriberRef.current;

          try {
            var returnValue = void 0;

            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(wrappedInteractions, threadID);
              }
            } finally {
              try {
                returnValue = callback.apply(undefined, arguments);
              } finally {
                exports.__interactionsRef.current = prevInteractions;

                if (subscriber !== null) {
                  subscriber.onWorkStopped(wrappedInteractions, threadID);
                }
              }
            }

            return returnValue;
          } finally {
            if (!hasRun) {
              // We only expect a wrapped function to be executed once,
              // But in the event that it's executed more than once–
              // Only decrement the outstanding interaction counts once.
              hasRun = true; // Update pending async counts for all wrapped interactions.
              // If this was the last scheduled async work for any of them,
              // Mark them as completed.

              wrappedInteractions.forEach(function (interaction) {
                interaction.__count--;

                if (subscriber !== null && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          }
        }

        wrapped.cancel = function cancel() {
          subscriber = exports.__subscriberRef.current;

          try {
            if (subscriber !== null) {
              subscriber.onWorkCanceled(wrappedInteractions, threadID);
            }
          } finally {
            // Update pending async counts for all wrapped interactions.
            // If this was the last scheduled async work for any of them,
            // Mark them as completed.
            wrappedInteractions.forEach(function (interaction) {
              interaction.__count--;

              if (subscriber && interaction.__count === 0) {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
              }
            });
          }
        };

        return wrapped;
      }

      var subscribers = null;
      {
        subscribers = new Set();
      }

      function unstable_subscribe(subscriber) {
        {
          subscribers.add(subscriber);

          if (subscribers.size === 1) {
            exports.__subscriberRef.current = {
              onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
              onInteractionTraced: onInteractionTraced,
              onWorkCanceled: onWorkCanceled,
              onWorkScheduled: onWorkScheduled,
              onWorkStarted: onWorkStarted,
              onWorkStopped: onWorkStopped
            };
          }
        }
      }

      function unstable_unsubscribe(subscriber) {
        {
          subscribers.delete(subscriber);

          if (subscribers.size === 0) {
            exports.__subscriberRef.current = null;
          }
        }
      }

      function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onInteractionTraced(interaction);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });

        if (didCatchError) {
          throw caughtError;
        }
      }

      function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });

        if (didCatchError) {
          throw caughtError;
        }
      }

      function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkScheduled(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });

        if (didCatchError) {
          throw caughtError;
        }
      }

      function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkStarted(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });

        if (didCatchError) {
          throw caughtError;
        }
      }

      function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkStopped(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });

        if (didCatchError) {
          throw caughtError;
        }
      }

      function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkCanceled(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });

        if (didCatchError) {
          throw caughtError;
        }
      }

      exports.unstable_clear = unstable_clear;
      exports.unstable_getCurrent = unstable_getCurrent;
      exports.unstable_getThreadID = unstable_getThreadID;
      exports.unstable_trace = unstable_trace;
      exports.unstable_wrap = unstable_wrap;
      exports.unstable_subscribe = unstable_subscribe;
      exports.unstable_unsubscribe = unstable_unsubscribe;
    })();
  }
});
unwrapExports(schedulerTracing_development);
var schedulerTracing_development_1 = schedulerTracing_development.__interactionsRef;
var schedulerTracing_development_2 = schedulerTracing_development.__subscriberRef;
var schedulerTracing_development_3 = schedulerTracing_development.unstable_clear;
var schedulerTracing_development_4 = schedulerTracing_development.unstable_getCurrent;
var schedulerTracing_development_5 = schedulerTracing_development.unstable_getThreadID;
var schedulerTracing_development_6 = schedulerTracing_development.unstable_trace;
var schedulerTracing_development_7 = schedulerTracing_development.unstable_wrap;
var schedulerTracing_development_8 = schedulerTracing_development.unstable_subscribe;
var schedulerTracing_development_9 = schedulerTracing_development.unstable_unsubscribe;
var tracing = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = schedulerTracing_production_min;
  } else {
    module.exports = schedulerTracing_development;
  }
});
var reactReconciler_development = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== "production") {
    module.exports = function $$$reconciler($$$hostConfig) {
      var _assign = objectAssign;
      var React$$1 = React;
      var checkPropTypes = checkPropTypes_1;
      var tracing$$1 = tracing;
      var scheduler$$1 = scheduler;
      /**
       * Use invariant() to assert state which your program assumes to be true.
       *
       * Provide sprintf-style format (only %s is supported) and arguments
       * to provide information about what broke and what you were
       * expecting.
       *
       * The invariant message will be stripped in production, but the invariant
       * will remain to ensure logic does not differ in production.
       */

      var validateFormat = function validateFormat() {};

      {
        validateFormat = function validateFormat(format) {
          if (format === undefined) {
            throw new Error('invariant requires an error message argument');
          }
        };
      }

      function invariant(condition, format, a, b, c, d, e, f) {
        validateFormat(format);

        if (!condition) {
          var error = void 0;

          if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
          } else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
              return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
          }

          error.framesToPop = 1; // we don't care about invariant's own frame

          throw error;
        }
      } // Relying on the `invariant()` implementation lets us
      // preserve the format and params in the www builds.

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var warningWithoutStack = function warningWithoutStack() {};

      {
        warningWithoutStack = function warningWithoutStack(condition, format) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          if (format === undefined) {
            throw new Error('`warningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (args.length > 8) {
            // Check before the condition to catch violations early.
            throw new Error('warningWithoutStack() currently supports at most 8 arguments.');
          }

          if (condition) {
            return;
          }

          if (typeof console !== 'undefined') {
            var argsWithFormat = args.map(function (item) {
              return '' + item;
            });
            argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
            // breaks IE9: https://github.com/facebook/react/issues/13610

            Function.prototype.apply.call(console.error, console, argsWithFormat);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });
            throw new Error(message);
          } catch (x) {}
        };
      }
      var warningWithoutStack$1 = warningWithoutStack;
      /**
       * `ReactInstanceMap` maintains a mapping from a public facing stateful
       * instance (key) and the internal representation (value). This allows public
       * methods to accept the user facing instance as an argument and map them back
       * to internal methods.
       *
       * Note that this module is currently shared and assumed to be stateless.
       * If this becomes an actual Map, that will break.
       */

      /**
       * This API should be called `delete` but we'd have to make sure to always
       * transform these to strings for IE support. When this transform is fully
       * supported we can rename it.
       */

      function get(key) {
        return key._reactInternalFiber;
      }

      function set(key, value) {
        key._reactInternalFiber = value;
      }

      var ReactSharedInternals = React$$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var Pending = 0;
      var Resolved = 1;
      var Rejected = 2;

      function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + '(' + functionName + ')' : wrapperName);
      }

      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            warningWithoutStack$1(false, 'Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case REACT_CONCURRENT_MODE_TYPE:
            return 'ConcurrentMode';

          case REACT_FRAGMENT_TYPE:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              return 'Context.Consumer';

            case REACT_PROVIDER_TYPE:
              return 'Context.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              return getComponentName(type.type);

            case REACT_LAZY_TYPE:
              {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);

                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
              }
          }
        }

        return null;
      }

      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2; // Before we know whether it is function or class

      var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

      var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

      var HostComponent = 5;
      var HostText = 6;
      var Fragment = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17; // Don't change these two values. They're used by React Dev Tools.

      var NoEffect =
      /*              */
      0;
      var PerformedWork =
      /*         */
      1; // You can change the rest (and add more).

      var Placement =
      /*             */
      2;
      var Update =
      /*                */
      4;
      var PlacementAndUpdate =
      /*    */
      6;
      var Deletion =
      /*              */
      8;
      var ContentReset =
      /*          */
      16;
      var Callback =
      /*              */
      32;
      var DidCapture =
      /*            */
      64;
      var Ref =
      /*                   */
      128;
      var Snapshot =
      /*              */
      256; // Passive & Update & Callback & Ref & Snapshot

      var LifecycleEffectMask =
      /*   */
      932; // Union of all host effects

      var HostEffectMask =
      /*        */
      1023;
      var Incomplete =
      /*            */
      1024;
      var ShouldCapture =
      /*         */
      2048;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var MOUNTING = 1;
      var MOUNTED = 2;
      var UNMOUNTED = 3;

      function isFiberMountedImpl(fiber) {
        var node = fiber;

        if (!fiber.alternate) {
          // If there is no alternate, this might be a new tree that isn't inserted
          // yet. If it is, then it will have a pending insertion effect on it.
          if ((node.effectTag & Placement) !== NoEffect) {
            return MOUNTING;
          }

          while (node.return) {
            node = node.return;

            if ((node.effectTag & Placement) !== NoEffect) {
              return MOUNTING;
            }
          }
        } else {
          while (node.return) {
            node = node.return;
          }
        }

        if (node.tag === HostRoot) {
          // TODO: Check if this was a nested HostRoot when used with
          // renderContainerIntoSubtree.
          return MOUNTED;
        } // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.


        return UNMOUNTED;
      }

      function isFiberMounted(fiber) {
        return isFiberMountedImpl(fiber) === MOUNTED;
      }

      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;

          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            !instance._warnedAboutRefsInRender ? warningWithoutStack$1(false, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component') : void 0;
            instance._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get(component);

        if (!fiber) {
          return false;
        }

        return isFiberMountedImpl(fiber) === MOUNTED;
      }

      function assertIsMounted(fiber) {
        !(isFiberMountedImpl(fiber) === MOUNTED) ? invariant(false, 'Unable to find node on an unmounted component.') : void 0;
      }

      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;

        if (!alternate) {
          // If there is no alternate, then we only need to check if it is mounted.
          var state = isFiberMountedImpl(fiber);
          !(state !== UNMOUNTED) ? invariant(false, 'Unable to find node on an unmounted component.') : void 0;

          if (state === MOUNTING) {
            return null;
          }

          return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.


        var a = fiber;
        var b = alternate;

        while (true) {
          var parentA = a.return;
          var parentB = parentA ? parentA.alternate : null;

          if (!parentA || !parentB) {
            // We're at the root.
            break;
          } // If both copies of the parent fiber point to the same child, we can
          // assume that the child is current. This happens when we bailout on low
          // priority: the bailed out fiber's child reuses the current child.


          if (parentA.child === parentB.child) {
            var child = parentA.child;

            while (child) {
              if (child === a) {
                // We've determined that A is the current branch.
                assertIsMounted(parentA);
                return fiber;
              }

              if (child === b) {
                // We've determined that B is the current branch.
                assertIsMounted(parentA);
                return alternate;
              }

              child = child.sibling;
            } // We should never have an alternate for any mounting node. So the only
            // way this could possibly happen is if this was unmounted, if at all.


            invariant(false, 'Unable to find node on an unmounted component.');
          }

          if (a.return !== b.return) {
            // The return pointer of A and the return pointer of B point to different
            // fibers. We assume that return pointers never criss-cross, so A must
            // belong to the child set of A.return, and B must belong to the child
            // set of B.return.
            a = parentA;
            b = parentB;
          } else {
            // The return pointers point to the same fiber. We'll have to use the
            // default, slow path: scan the child sets of each parent alternate to see
            // which child belongs to which set.
            //
            // Search parent A's child set
            var didFindChild = false;
            var _child = parentA.child;

            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }

              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }

              _child = _child.sibling;
            }

            if (!didFindChild) {
              // Search parent B's child set
              _child = parentB.child;

              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }

                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }

                _child = _child.sibling;
              }

              !didFindChild ? invariant(false, 'Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.') : void 0;
            }
          }

          !(a.alternate === b) ? invariant(false, 'Return fibers should always be each others\' alternates. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.


        !(a.tag === HostRoot) ? invariant(false, 'Unable to find node on an unmounted component.') : void 0;

        if (a.stateNode.current === a) {
          // We've determined that A is the current branch.
          return fiber;
        } // Otherwise B has to be current branch.


        return alternate;
      }

      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);

        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.


        var node = currentParent;

        while (true) {
          if (node.tag === HostComponent || node.tag === HostText) {
            return node;
          } else if (node.child) {
            node.child.return = node;
            node = node.child;
            continue;
          }

          if (node === currentParent) {
            return null;
          }

          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }

            node = node.return;
          }

          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable


        return null;
      }

      function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);

        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.


        var node = currentParent;

        while (true) {
          if (node.tag === HostComponent || node.tag === HostText) {
            return node;
          } else if (node.child && node.tag !== HostPortal) {
            node.child.return = node;
            node = node.child;
            continue;
          }

          if (node === currentParent) {
            return null;
          }

          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }

            node = node.return;
          }

          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable


        return null;
      } // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef


      var getPublicInstance = $$$hostConfig.getPublicInstance; // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // eslint-disable-line no-undef
      // This is a host config that's used for the `react-reconciler` package on npm.
      // It is only used by third-party renderers.
      //
      // Its API lets you pass the host config as an argument.
      // However, inside the `react-reconciler` we treat host config as a module.
      // This file is a shim between two worlds.
      //
      // It works because the `react-reconciler` bundle is wrapped in something like:
      //
      // module.exports = function ($$$config) {
      //   /* reconciler code */
      // }
      //
      // So `$$$config` looks like a global variable, but it's
      // really an argument to a top-level wrapping function.

      var getRootHostContext = $$$hostConfig.getRootHostContext;
      var getChildHostContext = $$$hostConfig.getChildHostContext;
      var prepareForCommit = $$$hostConfig.prepareForCommit;
      var resetAfterCommit = $$$hostConfig.resetAfterCommit;
      var createInstance = $$$hostConfig.createInstance;
      var appendInitialChild = $$$hostConfig.appendInitialChild;
      var finalizeInitialChildren = $$$hostConfig.finalizeInitialChildren;
      var prepareUpdate = $$$hostConfig.prepareUpdate;
      var shouldSetTextContent = $$$hostConfig.shouldSetTextContent;
      var shouldDeprioritizeSubtree = $$$hostConfig.shouldDeprioritizeSubtree;
      var createTextInstance = $$$hostConfig.createTextInstance;
      var scheduleDeferredCallback = $$$hostConfig.scheduleDeferredCallback;
      var cancelDeferredCallback = $$$hostConfig.cancelDeferredCallback;
      var shouldYield = $$$hostConfig.shouldYield;
      var scheduleTimeout = $$$hostConfig.setTimeout;
      var cancelTimeout = $$$hostConfig.clearTimeout;
      var noTimeout = $$$hostConfig.noTimeout;
      var now = $$$hostConfig.now;
      var isPrimaryRenderer = $$$hostConfig.isPrimaryRenderer;
      var supportsMutation = $$$hostConfig.supportsMutation;
      var supportsPersistence = $$$hostConfig.supportsPersistence;
      var supportsHydration = $$$hostConfig.supportsHydration; // -------------------
      //      Mutation
      //     (optional)
      // -------------------

      var appendChild = $$$hostConfig.appendChild;
      var appendChildToContainer = $$$hostConfig.appendChildToContainer;
      var commitTextUpdate = $$$hostConfig.commitTextUpdate;
      var commitMount = $$$hostConfig.commitMount;
      var commitUpdate = $$$hostConfig.commitUpdate;
      var insertBefore = $$$hostConfig.insertBefore;
      var insertInContainerBefore = $$$hostConfig.insertInContainerBefore;
      var removeChild = $$$hostConfig.removeChild;
      var removeChildFromContainer = $$$hostConfig.removeChildFromContainer;
      var resetTextContent = $$$hostConfig.resetTextContent;
      var hideInstance = $$$hostConfig.hideInstance;
      var hideTextInstance = $$$hostConfig.hideTextInstance;
      var unhideInstance = $$$hostConfig.unhideInstance;
      var unhideTextInstance = $$$hostConfig.unhideTextInstance; // -------------------
      //     Persistence
      //     (optional)
      // -------------------

      var cloneInstance = $$$hostConfig.cloneInstance;
      var createContainerChildSet = $$$hostConfig.createContainerChildSet;
      var appendChildToContainerChildSet = $$$hostConfig.appendChildToContainerChildSet;
      var finalizeContainerChildren = $$$hostConfig.finalizeContainerChildren;
      var replaceContainerChildren = $$$hostConfig.replaceContainerChildren;
      var cloneHiddenInstance = $$$hostConfig.cloneHiddenInstance;
      var cloneUnhiddenInstance = $$$hostConfig.cloneUnhiddenInstance;
      var createHiddenTextInstance = $$$hostConfig.createHiddenTextInstance; // -------------------
      //     Hydration
      //     (optional)
      // -------------------

      var canHydrateInstance = $$$hostConfig.canHydrateInstance;
      var canHydrateTextInstance = $$$hostConfig.canHydrateTextInstance;
      var getNextHydratableSibling = $$$hostConfig.getNextHydratableSibling;
      var getFirstHydratableChild = $$$hostConfig.getFirstHydratableChild;
      var hydrateInstance = $$$hostConfig.hydrateInstance;
      var hydrateTextInstance = $$$hostConfig.hydrateTextInstance;
      var didNotMatchHydratedContainerTextInstance = $$$hostConfig.didNotMatchHydratedContainerTextInstance;
      var didNotMatchHydratedTextInstance = $$$hostConfig.didNotMatchHydratedTextInstance;
      var didNotHydrateContainerInstance = $$$hostConfig.didNotHydrateContainerInstance;
      var didNotHydrateInstance = $$$hostConfig.didNotHydrateInstance;
      var didNotFindHydratableContainerInstance = $$$hostConfig.didNotFindHydratableContainerInstance;
      var didNotFindHydratableContainerTextInstance = $$$hostConfig.didNotFindHydratableContainerTextInstance;
      var didNotFindHydratableInstance = $$$hostConfig.didNotFindHydratableInstance;
      var didNotFindHydratableTextInstance = $$$hostConfig.didNotFindHydratableTextInstance;
      var BEFORE_SLASH_RE = /^(.*)[\\\/]/;

      var describeComponentFrame = function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';

        if (source) {
          var path = source.fileName;
          var fileName = path.replace(BEFORE_SLASH_RE, '');
          {
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
              var match = path.match(BEFORE_SLASH_RE);

              if (match) {
                var pathBeforeSlash = match[1];

                if (pathBeforeSlash) {
                  var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                  fileName = folderName + '/' + fileName;
                }
              }
            }
          }
          sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) {
          sourceInfo = ' (created by ' + ownerName + ')';
        }

        return '\n    in ' + (name || 'Unknown') + sourceInfo;
      };

      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function describeFiber(fiber) {
        switch (fiber.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case FunctionComponent:
          case ClassComponent:
          case HostComponent:
          case Mode:
          case SuspenseComponent:
            var owner = fiber._debugOwner;
            var source = fiber._debugSource;
            var name = getComponentName(fiber.type);
            var ownerName = null;

            if (owner) {
              ownerName = getComponentName(owner.type);
            }

            return describeComponentFrame(name, source, ownerName);

          default:
            return '';
        }
      }

      function getStackByFiberInDevAndProd(workInProgress) {
        var info = '';
        var node = workInProgress;

        do {
          info += describeFiber(node);
          node = node.return;
        } while (node);

        return info;
      }

      var current = null;
      var phase = null;

      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }

          var owner = current._debugOwner;

          if (owner !== null && typeof owner !== 'undefined') {
            return getComponentName(owner.type);
          }
        }
        return null;
      }

      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return '';
          } // Safe because if current fiber exists, we are reconciling,
          // and it is guaranteed to be the work-in-progress version.


          return getStackByFiberInDevAndProd(current);
        }
        return '';
      }

      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame.getCurrentStack = null;
          current = null;
          phase = null;
        }
      }

      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
          current = fiber;
          phase = null;
        }
      }

      function setCurrentPhase(lifeCyclePhase) {
        {
          phase = lifeCyclePhase;
        }
      } // Only used in www builds.
      // Only used in www builds.
      // React Fire: prevent the value and checked attributes from syncing
      // with their related DOM properties
      // These APIs will no longer be "unstable" in the upcoming 16.7 release,
      // Control this behavior with a flag to support 16.6 minor releases in the meanwhile.
      // Prefix measurements so that it's possible to filter them.
      // Longer prefixes are hard to read in DevTools.


      var reactEmoji = "\u269B";
      var warningEmoji = "\u26D4";
      var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
      // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?

      var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
      // Reusing `currentFiber` would be confusing for this because user code fiber
      // can change during commit phase too, but we don't need to unwind it (since
      // lifecycles in the commit phase don't resemble a tree).

      var currentPhase = null;
      var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
      // so we will keep track of it, and include it in the report.
      // Track commits caused by cascading updates.

      var isCommitting = false;
      var hasScheduledUpdateInCurrentCommit = false;
      var hasScheduledUpdateInCurrentPhase = false;
      var commitCountInCurrentWorkLoop = 0;
      var effectCountInCurrentCommit = 0;
      var isWaitingForCallback = false; // During commits, we only show a measurement once per method name
      // to avoid stretch the commit phase with measurement overhead.

      var labelsInCurrentCommit = new Set();

      var formatMarkName = function formatMarkName(markName) {
        return reactEmoji + ' ' + markName;
      };

      var formatLabel = function formatLabel(label, warning) {
        var prefix = warning ? warningEmoji + ' ' : reactEmoji + ' ';
        var suffix = warning ? ' Warning: ' + warning : '';
        return '' + prefix + label + suffix;
      };

      var beginMark = function beginMark(markName) {
        performance.mark(formatMarkName(markName));
      };

      var clearMark = function clearMark(markName) {
        performance.clearMarks(formatMarkName(markName));
      };

      var endMark = function endMark(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);

        try {
          performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.


        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
      };

      var getFiberMarkName = function getFiberMarkName(label, debugID) {
        return label + ' (#' + debugID + ')';
      };

      var getFiberLabel = function getFiberLabel(componentName, isMounted, phase) {
        if (phase === null) {
          // These are composite component total time measurements.
          return componentName + ' [' + (isMounted ? 'update' : 'mount') + ']';
        } else {
          // Composite component methods.
          return componentName + '.' + phase;
        }
      };

      var beginFiberMark = function beginFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);

        if (isCommitting && labelsInCurrentCommit.has(label)) {
          // During the commit phase, we don't show duplicate labels because
          // there is a fixed overhead for every measurement, and we don't
          // want to stretch the commit phase beyond necessary.
          return false;
        }

        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
      };

      var clearFiberMark = function clearFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
      };

      var endFiberMark = function endFiberMark(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
      };

      var shouldIgnoreFiber = function shouldIgnoreFiber(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch (fiber.tag) {
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case Fragment:
          case ContextProvider:
          case ContextConsumer:
          case Mode:
            return true;

          default:
            return false;
        }
      };

      var clearPendingPhaseMeasurement = function clearPendingPhaseMeasurement() {
        if (currentPhase !== null && currentPhaseFiber !== null) {
          clearFiberMark(currentPhaseFiber, currentPhase);
        }

        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
      };

      var pauseTimers = function pauseTimers() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;

        while (fiber) {
          if (fiber._debugIsCurrentlyTiming) {
            endFiberMark(fiber, null, null);
          }

          fiber = fiber.return;
        }
      };

      var resumeTimersRecursively = function resumeTimersRecursively(fiber) {
        if (fiber.return !== null) {
          resumeTimersRecursively(fiber.return);
        }

        if (fiber._debugIsCurrentlyTiming) {
          beginFiberMark(fiber, null);
        }
      };

      var resumeTimers = function resumeTimers() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) {
          resumeTimersRecursively(currentFiber);
        }
      };

      function recordEffect() {
        {
          effectCountInCurrentCommit++;
        }
      }

      function recordScheduleUpdate() {
        {
          if (isCommitting) {
            hasScheduledUpdateInCurrentCommit = true;
          }

          if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') {
            hasScheduledUpdateInCurrentPhase = true;
          }
        }
      }

      function startRequestCallbackTimer() {
        {
          if (supportsUserTiming && !isWaitingForCallback) {
            isWaitingForCallback = true;
            beginMark('(Waiting for async callback...)');
          }
        }
      }

      function stopRequestCallbackTimer(didExpire, expirationTime) {
        {
          if (supportsUserTiming) {
            isWaitingForCallback = false;
            var warning = didExpire ? 'React was blocked by main thread' : null;
            endMark('(Waiting for async callback... will force flush in ' + expirationTime + ' ms)', '(Waiting for async callback...)', warning);
          }
        }
      }

      function startWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, this is the fiber to unwind from.


          currentFiber = fiber;

          if (!beginFiberMark(fiber, null)) {
            return;
          }

          fiber._debugIsCurrentlyTiming = true;
        }
      }

      function cancelWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // Remember we shouldn't complete measurement for this fiber.
          // Otherwise flamechart will be deep even for small updates.


          fiber._debugIsCurrentlyTiming = false;
          clearFiberMark(fiber, null);
        }
      }

      function stopWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.


          currentFiber = fiber.return;

          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }

          fiber._debugIsCurrentlyTiming = false;
          endFiberMark(fiber, null, null);
        }
      }

      function stopFailedWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.


          currentFiber = fiber.return;

          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }

          fiber._debugIsCurrentlyTiming = false;
          var warning = fiber.tag === SuspenseComponent ? 'Rendering was suspended' : 'An error was thrown inside this error boundary';
          endFiberMark(fiber, null, warning);
        }
      }

      function startPhaseTimer(fiber, phase) {
        {
          if (!supportsUserTiming) {
            return;
          }

          clearPendingPhaseMeasurement();

          if (!beginFiberMark(fiber, phase)) {
            return;
          }

          currentPhaseFiber = fiber;
          currentPhase = phase;
        }
      }

      function stopPhaseTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          if (currentPhase !== null && currentPhaseFiber !== null) {
            var warning = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
            endFiberMark(currentPhaseFiber, currentPhase, warning);
          }

          currentPhase = null;
          currentPhaseFiber = null;
        }
      }

      function startWorkLoopTimer(nextUnitOfWork) {
        {
          currentFiber = nextUnitOfWork;

          if (!supportsUserTiming) {
            return;
          }

          commitCountInCurrentWorkLoop = 0; // This is top level call.
          // Any other measurements are performed within.

          beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.

          resumeTimers();
        }
      }

      function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        {
          if (!supportsUserTiming) {
            return;
          }

          var warning = null;

          if (interruptedBy !== null) {
            if (interruptedBy.tag === HostRoot) {
              warning = 'A top-level update interrupted the previous render';
            } else {
              var componentName = getComponentName(interruptedBy.type) || 'Unknown';
              warning = 'An update to ' + componentName + ' interrupted the previous render';
            }
          } else if (commitCountInCurrentWorkLoop > 1) {
            warning = 'There were cascading updates';
          }

          commitCountInCurrentWorkLoop = 0;
          var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.

          pauseTimers();
          endMark(label, '(React Tree Reconciliation)', warning);
        }
      }

      function startCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          isCommitting = true;
          hasScheduledUpdateInCurrentCommit = false;
          labelsInCurrentCommit.clear();
          beginMark('(Committing Changes)');
        }
      }

      function stopCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          var warning = null;

          if (hasScheduledUpdateInCurrentCommit) {
            warning = 'Lifecycle hook scheduled a cascading update';
          } else if (commitCountInCurrentWorkLoop > 0) {
            warning = 'Caused by a cascading update in earlier commit';
          }

          hasScheduledUpdateInCurrentCommit = false;
          commitCountInCurrentWorkLoop++;
          isCommitting = false;
          labelsInCurrentCommit.clear();
          endMark('(Committing Changes)', '(Committing Changes)', warning);
        }
      }

      function startCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          effectCountInCurrentCommit = 0;
          beginMark('(Committing Snapshot Effects)');
        }
      }

      function stopCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark('(Committing Snapshot Effects: ' + count + ' Total)', '(Committing Snapshot Effects)', null);
        }
      }

      function startCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          effectCountInCurrentCommit = 0;
          beginMark('(Committing Host Effects)');
        }
      }

      function stopCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark('(Committing Host Effects: ' + count + ' Total)', '(Committing Host Effects)', null);
        }
      }

      function startCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          effectCountInCurrentCommit = 0;
          beginMark('(Calling Lifecycle Methods)');
        }
      }

      function stopCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }

          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark('(Calling Lifecycle Methods: ' + count + ' Total)', '(Calling Lifecycle Methods)', null);
        }
      }

      var valueStack = [];
      var fiberStack = void 0;
      {
        fiberStack = [];
      }
      var index = -1;

      function createCursor(defaultValue) {
        return {
          current: defaultValue
        };
      }

      function pop(cursor, fiber) {
        if (index < 0) {
          {
            warningWithoutStack$1(false, 'Unexpected pop.');
          }
          return;
        }

        {
          if (fiber !== fiberStack[index]) {
            warningWithoutStack$1(false, 'Unexpected Fiber popped.');
          }
        }
        cursor.current = valueStack[index];
        valueStack[index] = null;
        {
          fiberStack[index] = null;
        }
        index--;
      }

      function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        {
          fiberStack[index] = fiber;
        }
        cursor.current = value;
      }

      function checkThatStackIsEmpty() {
        {
          if (index !== -1) {
            warningWithoutStack$1(false, 'Expected an empty stack. Something was not reset properly.');
          }
        }
      }

      function resetStackAfterFatalErrorInDev() {
        {
          index = -1;
          valueStack.length = 0;
          fiberStack.length = 0;
        }
      }

      var warnedAboutMissingGetChildContext = void 0;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      } // A cursor to the current merged context object on the stack.

      var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

      var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
      // We use this to get access to the parent context after we have already
      // pushed the next context provider, and now need to merge their contexts.

      var previousContext = emptyContextObject;

      function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) {
          // If the fiber is a context provider itself, when we read its context
          // we may have already pushed its own child context on the stack. A context
          // provider should not "see" its own child context. Therefore we read the
          // previous (parent) context instead for a context provider.
          return previousContext;
        }

        return contextStackCursor.current;
      }

      function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
      }

      function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;

        if (!contextTypes) {
          return emptyContextObject;
        } // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.


        var instance = workInProgress.stateNode;

        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
          return instance.__reactInternalMemoizedMaskedChildContext;
        }

        var context = {};

        for (var key in contextTypes) {
          context[key] = unmaskedContext[key];
        }

        {
          var name = getComponentName(type) || 'Unknown';
          checkPropTypes(contextTypes, context, 'context', name, getCurrentFiberStackInDev);
        } // Cache unmasked context so we can avoid recreating masked context unless necessary.
        // Context is created before the class component is instantiated so check for instance.

        if (instance) {
          cacheContext(workInProgress, unmaskedContext, context);
        }

        return context;
      }

      function hasContextChanged() {
        return didPerformWorkStackCursor.current;
      }

      function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
      }

      function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
      }

      function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
      }

      function pushTopLevelContextObject(fiber, context, didChange) {
        !(contextStackCursor.current === emptyContextObject) ? invariant(false, 'Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
      }

      function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.

        if (typeof instance.getChildContext !== 'function') {
          {
            var componentName = getComponentName(type) || 'Unknown';

            if (!warnedAboutMissingGetChildContext[componentName]) {
              warnedAboutMissingGetChildContext[componentName] = true;
              warningWithoutStack$1(false, '%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
            }
          }
          return parentContext;
        }

        var childContext = void 0;
        {
          setCurrentPhase('getChildContext');
        }
        startPhaseTimer(fiber, 'getChildContext');
        childContext = instance.getChildContext();
        stopPhaseTimer();
        {
          setCurrentPhase(null);
        }

        for (var contextKey in childContext) {
          !(contextKey in childContextTypes) ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', getComponentName(type) || 'Unknown', contextKey) : void 0;
        }

        {
          var name = getComponentName(type) || 'Unknown';
          checkPropTypes(childContextTypes, childContext, 'child context', name, // In practice, there is one case in which we won't get a stack. It's when
          // somebody calls unstable_renderSubtreeIntoContainer() and we process
          // context from the parent component instance. The stack will be missing
          // because it's outside of the reconciliation, and so the pointer has not
          // been set. This is rare and doesn't matter. We'll also remove that API.
          getCurrentFiberStackInDev);
        }
        return _assign({}, parentContext, childContext);
      }

      function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.

        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
      }

      function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        !instance ? invariant(false, 'Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.') : void 0;

        if (didChange) {
          // Merge parent and own context.
          // Skip this if we're not updating due to sCU.
          // This avoids unnecessarily recomputing memoized values.
          var mergedContext = processChildContext(workInProgress, type, previousContext);
          instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
          // It is important to unwind the context in the reverse order.

          pop(didPerformWorkStackCursor, workInProgress);
          pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

          push(contextStackCursor, mergedContext, workInProgress);
          push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
          pop(didPerformWorkStackCursor, workInProgress);
          push(didPerformWorkStackCursor, didChange, workInProgress);
        }
      }

      function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        !(isFiberMounted(fiber) && fiber.tag === ClassComponent) ? invariant(false, 'Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        var node = fiber;

        do {
          switch (node.tag) {
            case HostRoot:
              return node.stateNode.context;

            case ClassComponent:
              {
                var Component = node.type;

                if (isContextProvider(Component)) {
                  return node.stateNode.__reactInternalMemoizedMergedChildContext;
                }

                break;
              }
          }

          node = node.return;
        } while (node !== null);

        invariant(false, 'Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.');
      }

      var onCommitFiberRoot = null;
      var onCommitFiberUnmount = null;
      var hasLoggedError = false;

      function catchErrors(fn) {
        return function (arg) {
          try {
            return fn(arg);
          } catch (err) {
            if (!hasLoggedError) {
              hasLoggedError = true;
              warningWithoutStack$1(false, 'React DevTools encountered an error: %s', err);
            }
          }
        };
      }

      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';

      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
          // No DevTools
          return false;
        }

        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

        if (hook.isDisabled) {
          // This isn't a real property on the hook, but it can be set to opt out
          // of DevTools integration and associated warnings and logs.
          // https://github.com/facebook/react/issues/3877
          return true;
        }

        if (!hook.supportsFiber) {
          {
            warningWithoutStack$1(false, 'The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://fb.me/react-devtools');
          } // DevTools exists, even though it doesn't support Fiber.

          return true;
        }

        try {
          var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

          onCommitFiberRoot = catchErrors(function (root) {
            return hook.onCommitFiberRoot(rendererID, root);
          });
          onCommitFiberUnmount = catchErrors(function (fiber) {
            return hook.onCommitFiberUnmount(rendererID, fiber);
          });
        } catch (err) {
          // Catch all errors because it is unsafe to throw during initialization.
          {
            warningWithoutStack$1(false, 'React DevTools encountered an error: %s.', err);
          }
        } // DevTools exists


        return true;
      }

      function onCommitRoot(root) {
        if (typeof onCommitFiberRoot === 'function') {
          onCommitFiberRoot(root);
        }
      }

      function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === 'function') {
          onCommitFiberUnmount(fiber);
        }
      } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111


      var maxSigned31BitInt = 1073741823;
      var NoWork = 0;
      var Never = 1;
      var Sync = maxSigned31BitInt;
      var UNIT_SIZE = 10;
      var MAGIC_NUMBER_OFFSET = maxSigned31BitInt - 1; // 1 unit of expiration time represents 10ms.

      function msToExpirationTime(ms) {
        // Always add an offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
      }

      function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
      }

      function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
      }

      function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
      }

      var LOW_PRIORITY_EXPIRATION = 5000;
      var LOW_PRIORITY_BATCH_SIZE = 250;

      function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
      } // We intentionally set a higher expiration time for interactive updates in
      // dev than in production.
      //
      // If the main thread is being blocked so long that you hit the expiration,
      // it's a problem that could be solved with better scheduling.
      //
      // People will be more likely to notice this and fix it with the long
      // expiration time in development.
      //
      // In production we opt for better UX at the risk of masking scheduling
      // problems, by expiring fast.


      var HIGH_PRIORITY_EXPIRATION = 500;
      var HIGH_PRIORITY_BATCH_SIZE = 100;

      function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
      }

      var NoContext = 0;
      var ConcurrentMode = 1;
      var StrictMode = 2;
      var ProfileMode = 4;
      var hasBadMapPolyfill = void 0;
      {
        hasBadMapPolyfill = false;

        try {
          var nonExtensibleObject = Object.preventExtensions({});
          var testMap = new Map([[nonExtensibleObject, null]]);
          var testSet = new Set([nonExtensibleObject]); // This is necessary for Rollup to not consider these unused.
          // https://github.com/rollup/rollup/issues/1771
          // TODO: we can remove these if Rollup fixes the bug.

          testMap.set(0, 0);
          testSet.add(0);
        } catch (e) {
          // TODO: Consider warning about bad polyfills
          hasBadMapPolyfill = true;
        }
      } // A Fiber is work on a Component that needs to be done or was done. There can
      // be more than one per component.

      var debugCounter = void 0;
      {
        debugCounter = 1;
      }

      function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber

        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.firstContextDependency = null;
        this.mode = mode; // Effects

        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        {
          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        }
        {
          this._debugID = debugCounter++;
          this._debugSource = null;
          this._debugOwner = null;
          this._debugIsCurrentlyTiming = false;

          if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
            Object.preventExtensions(this);
          }
        }
      } // This is a constructor function, rather than a POJO constructor, still
      // please ensure we do the following:
      // 1) Nobody should add any instance methods on this. Instance methods can be
      //    more difficult to predict when they get optimized and they are almost
      //    never inlined properly in static compilers.
      // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
      //    always know when it is a fiber.
      // 3) We might want to experiment with using numeric keys since they are easier
      //    to optimize in a non-JIT environment.
      // 4) We can easily go from a constructor to a createFiber object literal if that
      //    is faster.
      // 5) It should be easy to port this to a C struct and keep a C implementation
      //    compatible.


      var createFiber = function createFiber(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
      };

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
      }

      function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') {
          return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        } else if (Component !== undefined && Component !== null) {
          var $$typeof = Component.$$typeof;

          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }

          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }

        return IndeterminateComponent;
      } // This is used to create an alternate fiber to do work on.


      function createWorkInProgress(current, pendingProps, expirationTime) {
        var workInProgress = current.alternate;

        if (workInProgress === null) {
          // We use a double buffering pooling technique because we know that we'll
          // only ever need at most two versions of a tree. We pool the "other" unused
          // node that we're free to reuse. This is lazily created to avoid allocating
          // extra objects for things that are never updated. It also allow us to
          // reclaim the extra memory if needed.
          workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
          workInProgress.elementType = current.elementType;
          workInProgress.type = current.type;
          workInProgress.stateNode = current.stateNode;
          {
            // DEV-only fields
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
          }
          workInProgress.alternate = current;
          current.alternate = workInProgress;
        } else {
          workInProgress.pendingProps = pendingProps; // We already have an alternate.
          // Reset the effect tag.

          workInProgress.effectTag = NoEffect; // The effect list is no longer valid.

          workInProgress.nextEffect = null;
          workInProgress.firstEffect = null;
          workInProgress.lastEffect = null;
          {
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
          }
        }

        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.firstContextDependency = current.firstContextDependency; // These will be overridden during the parent's reconciliation

        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        {
          workInProgress.selfBaseDuration = current.selfBaseDuration;
          workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
      }

      function createHostRootFiber(isConcurrent) {
        var mode = isConcurrent ? ConcurrentMode | StrictMode : NoContext;

        if (isDevToolsPresent) {
          // Always collect profile timings when DevTools are present.
          // This enables DevTools to start capturing timing at any point–
          // Without some nodes in the tree having empty base times.
          mode |= ProfileMode;
        }

        return createFiber(HostRoot, null, null, mode);
      }

      function createFiberFromTypeAndProps(type, // React$ElementType
      key, pendingProps, owner, mode, expirationTime) {
        var fiber = void 0;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

        var resolvedType = type;

        if (typeof type === 'function') {
          if (shouldConstruct(type)) {
            fiberTag = ClassComponent;
          }
        } else if (typeof type === 'string') {
          fiberTag = HostComponent;
        } else {
          getTag: switch (type) {
            case REACT_FRAGMENT_TYPE:
              return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);

            case REACT_CONCURRENT_MODE_TYPE:
              return createFiberFromMode(pendingProps, mode | ConcurrentMode | StrictMode, expirationTime, key);

            case REACT_STRICT_MODE_TYPE:
              return createFiberFromMode(pendingProps, mode | StrictMode, expirationTime, key);

            case REACT_PROFILER_TYPE:
              return createFiberFromProfiler(pendingProps, mode, expirationTime, key);

            case REACT_SUSPENSE_TYPE:
              return createFiberFromSuspense(pendingProps, mode, expirationTime, key);

            default:
              {
                if (typeof type === 'object' && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;

                    case REACT_CONTEXT_TYPE:
                      // This is a consumer
                      fiberTag = ContextConsumer;
                      break getTag;

                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      break getTag;

                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;

                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                  }
                }

                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }

                  var ownerName = owner ? getComponentName(owner.type) : null;

                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info);
              }
          }
        }

        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
      }

      function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }

      function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }

      function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        {
          if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') {
            warningWithoutStack$1(false, 'Profiler must specify an "id" string and "onRender" function as props');
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }

      function createFiberFromMode(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(Mode, pendingProps, key, mode); // TODO: The Mode fiber shouldn't have a type. It has a tag.

        var type = (mode & ConcurrentMode) === NoContext ? REACT_STRICT_MODE_TYPE : REACT_CONCURRENT_MODE_TYPE;
        fiber.elementType = type;
        fiber.type = type;
        fiber.expirationTime = expirationTime;
        return fiber;
      }

      function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.

        var type = REACT_SUSPENSE_TYPE;
        fiber.elementType = type;
        fiber.type = type;
        fiber.expirationTime = expirationTime;
        return fiber;
      }

      function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }

      function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoContext); // TODO: These should not need a type.

        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
      }

      function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: portal.implementation
        };
        return fiber;
      } // Used for stashing WIP properties to replay failed work in DEV.


      function assignFiberPropertiesInDEV(target, source) {
        if (target === null) {
          // This Fiber's initial properties will always be overwritten.
          // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
          target = createFiber(IndeterminateComponent, null, null, NoContext);
        } // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.


        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.firstContextDependency = source.firstContextDependency;
        target.mode = source.mode;
        target.effectTag = source.effectTag;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.expirationTime = source.expirationTime;
        target.childExpirationTime = source.childExpirationTime;
        target.alternate = source.alternate;
        {
          target.actualDuration = source.actualDuration;
          target.actualStartTime = source.actualStartTime;
          target.selfBaseDuration = source.selfBaseDuration;
          target.treeBaseDuration = source.treeBaseDuration;
        }
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
        return target;
      } // TODO: This should be lifted into the renderer.
      // The following attributes are only used by interaction tracing builds.
      // They enable interactions to be associated with their async work,
      // And expose interaction metadata to the React DevTools Profiler plugin.
      // Note that these attributes are only defined when the enableSchedulerTracing flag is enabled.
      // Exported FiberRoot type includes all properties,
      // To avoid requiring potentially error-prone :any casts throughout the project.
      // Profiling properties are only safe to access in profiling builds (when enableSchedulerTracing is true).
      // The types are defined separately within this file to ensure they stay in sync.
      // (We don't have to use an inline :any cast when enableSchedulerTracing is disabled.)


      function createFiberRoot(containerInfo, isConcurrent, hydrate) {
        // Cyclic construction. This cheats the type system right now because
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(isConcurrent);
        var root = void 0;
        {
          root = {
            current: uninitializedFiber,
            containerInfo: containerInfo,
            pendingChildren: null,
            earliestPendingTime: NoWork,
            latestPendingTime: NoWork,
            earliestSuspendedTime: NoWork,
            latestSuspendedTime: NoWork,
            latestPingedTime: NoWork,
            didError: false,
            pendingCommitExpirationTime: NoWork,
            finishedWork: null,
            timeoutHandle: noTimeout,
            context: null,
            pendingContext: null,
            hydrate: hydrate,
            nextExpirationTimeToWorkOn: NoWork,
            expirationTime: NoWork,
            firstBatch: null,
            nextScheduledRoot: null,
            interactionThreadID: tracing$$1.unstable_getThreadID(),
            memoizedInteractions: new Set(),
            pendingInteractionMap: new Map()
          };
        }
        uninitializedFiber.stateNode = root; // The reason for the way the Flow types are structured in this file,
        // Is to avoid needing :any casts everywhere interaction tracing fields are used.
        // Unfortunately that requires an :any cast for non-interaction tracing capable builds.
        // $FlowFixMe Remove this :any cast and replace it with something better.

        return root;
      }

      var invokeGuardedCallbackImpl = function invokeGuardedCallbackImpl(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);

        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      };

      {
        // In DEV mode, we swap out invokeGuardedCallback for a special version
        // that plays more nicely with the browser's DevTools. The idea is to preserve
        // "Pause on exceptions" behavior. Because React wraps all user-provided
        // functions in invokeGuardedCallback, and the production version of
        // invokeGuardedCallback uses a try-catch, all user exceptions are treated
        // like caught exceptions, and the DevTools won't pause unless the developer
        // takes the extra step of enabling pause on caught exceptions. This is
        // untintuitive, though, because even though React has caught the error, from
        // the developer's perspective, the error is uncaught.
        //
        // To preserve the expected "Pause on exceptions" behavior, we don't use a
        // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
        // DOM node, and call the user-provided callback from inside an event handler
        // for that fake event. If the callback throws, the error is "captured" using
        // a global event handler. But because the error happens in a different
        // event loop context, it does not interrupt the normal program flow.
        // Effectively, this gives us try-catch behavior without actually using
        // try-catch. Neat!
        // Check that the browser supports the APIs we need to implement our special
        // DEV version of invokeGuardedCallback
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');

          var invokeGuardedCallbackDev = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            !(typeof document !== 'undefined') ? invariant(false, 'The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.') : void 0;
            var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.

            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.

            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688

            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event'); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.

            var funcArgs = Array.prototype.slice.call(arguments, 3);

            function callCallback() {
              // We immediately remove the callback from event listeners so that
              // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
              // nested call would trigger the fake event handlers of any call higher
              // in the stack.
              fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
              // window.event assignment in both IE <= 10 as they throw an error
              // "Member not found" in strict mode, and in Firefox which does not
              // support window.event.

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }

              func.apply(context, funcArgs);
              didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.


            var error = void 0; // Use this to track whether the error event is ever called.

            var didSetError = false;
            var isCrossOriginError = false;

            function handleWindowError(event) {
              error = event.error;
              didSetError = true;

              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }

              if (event.defaultPrevented) {
                // Some other error handler has prevented default.
                // Browsers silence the error report if this happens.
                // We'll remember this to later decide whether to log it or not.
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {// Ignore.
                  }
                }
              }
            } // Create a fake event type.


            var evtType = 'react-' + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.

            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);

            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }

            if (didError) {
              if (!didSetError) {
                // The callback errored, but the error event never fired.
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://fb.me/react-crossorigin-error for more information.');
              }

              this.onError(error);
            } // Remove our event listeners


            window.removeEventListener('error', handleWindowError);
          };

          invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl; // Used by Fiber to simulate a try-catch.

      var hasError = false;
      var caughtError = null;
      var reporter = {
        onError: function onError(error) {
          hasError = true;
          caughtError = error;
        }
      };
      /**
       * Call a function while guarding against errors that happens within it.
       * Returns an error if it throws, otherwise null.
       *
       * In production, this is implemented using a try-catch. The reason we don't
       * use a try-catch directly is so that we can swap out a different
       * implementation in DEV mode.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }
      /**
       * Same as invokeGuardedCallback, but instead of returning an error, it stores
       * it in a global so it can be rethrown by `rethrowCaughtError` later.
       * TODO: See if caughtError and rethrowError can be unified.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      /**
       * During execution of guarded functions we will capture the first error which
       * we will rethrow to be handled by the top level error handler.
       */


      function hasCaughtError() {
        return hasError;
      }

      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          invariant(false, 'clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.');
        }
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarning = function lowPriorityWarning() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarning = function lowPriorityWarning(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      var lowPriorityWarning$1 = lowPriorityWarning;
      var ReactStrictModeWarnings = {
        discardPendingWarnings: function discardPendingWarnings() {},
        flushPendingDeprecationWarnings: function flushPendingDeprecationWarnings() {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordDeprecationWarnings: function recordDeprecationWarnings(fiber, instance) {},
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {}
      };
      {
        var LIFECYCLE_SUGGESTIONS = {
          UNSAFE_componentWillMount: 'componentDidMount',
          UNSAFE_componentWillReceiveProps: 'static getDerivedStateFromProps',
          UNSAFE_componentWillUpdate: 'componentDidUpdate'
        };
        var pendingComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUnsafeLifecycleWarnings = new Map();
        var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

        var didWarnAboutDeprecatedLifecycles = new Set();
        var didWarnAboutUnsafeLifecycles = new Set();
        var didWarnAboutLegacyContext = new Set();

        var setToSortedString = function setToSortedString(set) {
          var array = [];
          set.forEach(function (value) {
            array.push(value);
          });
          return array.sort().join(', ');
        };

        ReactStrictModeWarnings.discardPendingWarnings = function () {
          pendingComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUnsafeLifecycleWarnings = new Map();
          pendingLegacyContextWarning = new Map();
        };

        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
          pendingUnsafeLifecycleWarnings.forEach(function (lifecycleWarningsMap, strictRoot) {
            var lifecyclesWarningMesages = [];
            Object.keys(lifecycleWarningsMap).forEach(function (lifecycle) {
              var lifecycleWarnings = lifecycleWarningsMap[lifecycle];

              if (lifecycleWarnings.length > 0) {
                var componentNames = new Set();
                lifecycleWarnings.forEach(function (fiber) {
                  componentNames.add(getComponentName(fiber.type) || 'Component');
                  didWarnAboutUnsafeLifecycles.add(fiber.type);
                });
                var formatted = lifecycle.replace('UNSAFE_', '');
                var suggestion = LIFECYCLE_SUGGESTIONS[lifecycle];
                var sortedComponentNames = setToSortedString(componentNames);
                lifecyclesWarningMesages.push(formatted + ': Please update the following components to use ' + (suggestion + ' instead: ' + sortedComponentNames));
              }
            });

            if (lifecyclesWarningMesages.length > 0) {
              var strictRootComponentStack = getStackByFiberInDevAndProd(strictRoot);
              warningWithoutStack$1(false, 'Unsafe lifecycle methods were found within a strict-mode tree:%s' + '\n\n%s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-strict-mode-warnings', strictRootComponentStack, lifecyclesWarningMesages.join('\n\n'));
            }
          });
          pendingUnsafeLifecycleWarnings = new Map();
        };

        var findStrictRoot = function findStrictRoot(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;

          while (node !== null) {
            if (node.mode & StrictMode) {
              maybeStrictRoot = node;
            }

            node = node.return;
          }

          return maybeStrictRoot;
        };

        ReactStrictModeWarnings.flushPendingDeprecationWarnings = function () {
          if (pendingComponentWillMountWarnings.length > 0) {
            var uniqueNames = new Set();
            pendingComponentWillMountWarnings.forEach(function (fiber) {
              uniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutDeprecatedLifecycles.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            lowPriorityWarning$1(false, 'componentWillMount is deprecated and will be removed in the next major version. ' + 'Use componentDidMount instead. As a temporary workaround, ' + 'you can rename to UNSAFE_componentWillMount.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-async-component-lifecycle-hooks', sortedNames);
            pendingComponentWillMountWarnings = [];
          }

          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            var _uniqueNames = new Set();

            pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
              _uniqueNames.add(getComponentName(fiber.type) || 'Component');

              didWarnAboutDeprecatedLifecycles.add(fiber.type);
            });

            var _sortedNames = setToSortedString(_uniqueNames);

            lowPriorityWarning$1(false, 'componentWillReceiveProps is deprecated and will be removed in the next major version. ' + 'Use static getDerivedStateFromProps instead.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-async-component-lifecycle-hooks', _sortedNames);
            pendingComponentWillReceivePropsWarnings = [];
          }

          if (pendingComponentWillUpdateWarnings.length > 0) {
            var _uniqueNames2 = new Set();

            pendingComponentWillUpdateWarnings.forEach(function (fiber) {
              _uniqueNames2.add(getComponentName(fiber.type) || 'Component');

              didWarnAboutDeprecatedLifecycles.add(fiber.type);
            });

            var _sortedNames2 = setToSortedString(_uniqueNames2);

            lowPriorityWarning$1(false, 'componentWillUpdate is deprecated and will be removed in the next major version. ' + 'Use componentDidUpdate instead. As a temporary workaround, ' + 'you can rename to UNSAFE_componentWillUpdate.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-async-component-lifecycle-hooks', _sortedNames2);
            pendingComponentWillUpdateWarnings = [];
          }
        };

        ReactStrictModeWarnings.recordDeprecationWarnings = function (fiber, instance) {
          // Dedup strategy: Warn once per component.
          if (didWarnAboutDeprecatedLifecycles.has(fiber.type)) {
            return;
          } // Don't warn about react-lifecycles-compat polyfilled components.


          if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }

          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }

          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }
        };

        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);

          if (strictRoot === null) {
            warningWithoutStack$1(false, 'Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          } // Dedup strategy: Warn once per component.
          // This is difficult to track any other way since component names
          // are often vague and are likely to collide between 3rd party libraries.
          // An expand property is probably okay to use here since it's DEV-only,
          // and will only be set in the event of serious warnings.


          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }

          var warningsForRoot = void 0;

          if (!pendingUnsafeLifecycleWarnings.has(strictRoot)) {
            warningsForRoot = {
              UNSAFE_componentWillMount: [],
              UNSAFE_componentWillReceiveProps: [],
              UNSAFE_componentWillUpdate: []
            };
            pendingUnsafeLifecycleWarnings.set(strictRoot, warningsForRoot);
          } else {
            warningsForRoot = pendingUnsafeLifecycleWarnings.get(strictRoot);
          }

          var unsafeLifecycles = [];

          if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true || typeof instance.UNSAFE_componentWillMount === 'function') {
            unsafeLifecycles.push('UNSAFE_componentWillMount');
          }

          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true || typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            unsafeLifecycles.push('UNSAFE_componentWillReceiveProps');
          }

          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true || typeof instance.UNSAFE_componentWillUpdate === 'function') {
            unsafeLifecycles.push('UNSAFE_componentWillUpdate');
          }

          if (unsafeLifecycles.length > 0) {
            unsafeLifecycles.forEach(function (lifecycle) {
              warningsForRoot[lifecycle].push(fiber);
            });
          }
        };

        ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);

          if (strictRoot === null) {
            warningWithoutStack$1(false, 'Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          } // Dedup strategy: Warn once per component.


          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }

          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }

            warningsForRoot.push(fiber);
          }
        };

        ReactStrictModeWarnings.flushLegacyContextWarning = function () {
          pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
            var uniqueNames = new Set();
            fiberArray.forEach(function (fiber) {
              uniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var strictRootComponentStack = getStackByFiberInDevAndProd(strictRoot);
            warningWithoutStack$1(false, 'Legacy context API has been detected within a strict-mode tree: %s' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here:' + '\nhttps://fb.me/react-strict-mode-warnings', strictRootComponentStack, sortedNames);
          });
        };
      } // TODO: Offscreen updates should never suspend. However, a promise that
      // suspended inside an offscreen subtree should be able to ping at the priority
      // of the outer render.

      function markPendingPriorityLevel(root, expirationTime) {
        // If there's a gap between completing a failed root and retrying it,
        // additional updates may be scheduled. Clear `didError`, in case the update
        // is sufficient to fix the error.
        root.didError = false; // Update the latest and earliest pending times

        var earliestPendingTime = root.earliestPendingTime;

        if (earliestPendingTime === NoWork) {
          // No other pending updates.
          root.earliestPendingTime = root.latestPendingTime = expirationTime;
        } else {
          if (earliestPendingTime < expirationTime) {
            // This is the earliest pending update.
            root.earliestPendingTime = expirationTime;
          } else {
            var latestPendingTime = root.latestPendingTime;

            if (latestPendingTime > expirationTime) {
              // This is the latest pending update
              root.latestPendingTime = expirationTime;
            }
          }
        }

        findNextExpirationTimeToWorkOn(expirationTime, root);
      }

      function markCommittedPriorityLevels(root, earliestRemainingTime) {
        root.didError = false;

        if (earliestRemainingTime === NoWork) {
          // Fast path. There's no remaining work. Clear everything.
          root.earliestPendingTime = NoWork;
          root.latestPendingTime = NoWork;
          root.earliestSuspendedTime = NoWork;
          root.latestSuspendedTime = NoWork;
          root.latestPingedTime = NoWork;
          findNextExpirationTimeToWorkOn(NoWork, root);
          return;
        } // Let's see if the previous latest known pending level was just flushed.


        var latestPendingTime = root.latestPendingTime;

        if (latestPendingTime !== NoWork) {
          if (latestPendingTime > earliestRemainingTime) {
            // We've flushed all the known pending levels.
            root.earliestPendingTime = root.latestPendingTime = NoWork;
          } else {
            var earliestPendingTime = root.earliestPendingTime;

            if (earliestPendingTime > earliestRemainingTime) {
              // We've flushed the earliest known pending level. Set this to the
              // latest pending time.
              root.earliestPendingTime = root.latestPendingTime;
            }
          }
        } // Now let's handle the earliest remaining level in the whole tree. We need to
        // decide whether to treat it as a pending level or as suspended. Check
        // it falls within the range of known suspended levels.


        var earliestSuspendedTime = root.earliestSuspendedTime;

        if (earliestSuspendedTime === NoWork) {
          // There's no suspended work. Treat the earliest remaining level as a
          // pending level.
          markPendingPriorityLevel(root, earliestRemainingTime);
          findNextExpirationTimeToWorkOn(NoWork, root);
          return;
        }

        var latestSuspendedTime = root.latestSuspendedTime;

        if (earliestRemainingTime < latestSuspendedTime) {
          // The earliest remaining level is later than all the suspended work. That
          // means we've flushed all the suspended work.
          root.earliestSuspendedTime = NoWork;
          root.latestSuspendedTime = NoWork;
          root.latestPingedTime = NoWork; // There's no suspended work. Treat the earliest remaining level as a
          // pending level.

          markPendingPriorityLevel(root, earliestRemainingTime);
          findNextExpirationTimeToWorkOn(NoWork, root);
          return;
        }

        if (earliestRemainingTime > earliestSuspendedTime) {
          // The earliest remaining time is earlier than all the suspended work.
          // Treat it as a pending update.
          markPendingPriorityLevel(root, earliestRemainingTime);
          findNextExpirationTimeToWorkOn(NoWork, root);
          return;
        } // The earliest remaining time falls within the range of known suspended
        // levels. We should treat this as suspended work.


        findNextExpirationTimeToWorkOn(NoWork, root);
      }

      function hasLowerPriorityWork(root, erroredExpirationTime) {
        var latestPendingTime = root.latestPendingTime;
        var latestSuspendedTime = root.latestSuspendedTime;
        var latestPingedTime = root.latestPingedTime;
        return latestPendingTime !== NoWork && latestPendingTime < erroredExpirationTime || latestSuspendedTime !== NoWork && latestSuspendedTime < erroredExpirationTime || latestPingedTime !== NoWork && latestPingedTime < erroredExpirationTime;
      }

      function isPriorityLevelSuspended(root, expirationTime) {
        var earliestSuspendedTime = root.earliestSuspendedTime;
        var latestSuspendedTime = root.latestSuspendedTime;
        return earliestSuspendedTime !== NoWork && expirationTime <= earliestSuspendedTime && expirationTime >= latestSuspendedTime;
      }

      function markSuspendedPriorityLevel(root, suspendedTime) {
        root.didError = false;
        clearPing(root, suspendedTime); // First, check the known pending levels and update them if needed.

        var earliestPendingTime = root.earliestPendingTime;
        var latestPendingTime = root.latestPendingTime;

        if (earliestPendingTime === suspendedTime) {
          if (latestPendingTime === suspendedTime) {
            // Both known pending levels were suspended. Clear them.
            root.earliestPendingTime = root.latestPendingTime = NoWork;
          } else {
            // The earliest pending level was suspended. Clear by setting it to the
            // latest pending level.
            root.earliestPendingTime = latestPendingTime;
          }
        } else if (latestPendingTime === suspendedTime) {
          // The latest pending level was suspended. Clear by setting it to the
          // latest pending level.
          root.latestPendingTime = earliestPendingTime;
        } // Finally, update the known suspended levels.


        var earliestSuspendedTime = root.earliestSuspendedTime;
        var latestSuspendedTime = root.latestSuspendedTime;

        if (earliestSuspendedTime === NoWork) {
          // No other suspended levels.
          root.earliestSuspendedTime = root.latestSuspendedTime = suspendedTime;
        } else {
          if (earliestSuspendedTime < suspendedTime) {
            // This is the earliest suspended level.
            root.earliestSuspendedTime = suspendedTime;
          } else if (latestSuspendedTime > suspendedTime) {
            // This is the latest suspended level
            root.latestSuspendedTime = suspendedTime;
          }
        }

        findNextExpirationTimeToWorkOn(suspendedTime, root);
      }

      function markPingedPriorityLevel(root, pingedTime) {
        root.didError = false; // TODO: When we add back resuming, we need to ensure the progressed work
        // is thrown out and not reused during the restarted render. One way to
        // invalidate the progressed work is to restart at expirationTime + 1.

        var latestPingedTime = root.latestPingedTime;

        if (latestPingedTime === NoWork || latestPingedTime > pingedTime) {
          root.latestPingedTime = pingedTime;
        }

        findNextExpirationTimeToWorkOn(pingedTime, root);
      }

      function clearPing(root, completedTime) {
        // TODO: Track whether the root was pinged during the render phase. If so,
        // we need to make sure we don't lose track of it.
        var latestPingedTime = root.latestPingedTime;

        if (latestPingedTime !== NoWork && latestPingedTime >= completedTime) {
          root.latestPingedTime = NoWork;
        }
      }

      function findEarliestOutstandingPriorityLevel(root, renderExpirationTime) {
        var earliestExpirationTime = renderExpirationTime;
        var earliestPendingTime = root.earliestPendingTime;
        var earliestSuspendedTime = root.earliestSuspendedTime;

        if (earliestPendingTime > earliestExpirationTime) {
          earliestExpirationTime = earliestPendingTime;
        }

        if (earliestSuspendedTime > earliestExpirationTime) {
          earliestExpirationTime = earliestSuspendedTime;
        }

        return earliestExpirationTime;
      }

      function didExpireAtExpirationTime(root, currentTime) {
        var expirationTime = root.expirationTime;

        if (expirationTime !== NoWork && currentTime <= expirationTime) {
          // The root has expired. Flush all work up to the current time.
          root.nextExpirationTimeToWorkOn = currentTime;
        }
      }

      function findNextExpirationTimeToWorkOn(completedExpirationTime, root) {
        var earliestSuspendedTime = root.earliestSuspendedTime;
        var latestSuspendedTime = root.latestSuspendedTime;
        var earliestPendingTime = root.earliestPendingTime;
        var latestPingedTime = root.latestPingedTime; // Work on the earliest pending time. Failing that, work on the latest
        // pinged time.

        var nextExpirationTimeToWorkOn = earliestPendingTime !== NoWork ? earliestPendingTime : latestPingedTime; // If there is no pending or pinged work, check if there's suspended work
        // that's lower priority than what we just completed.

        if (nextExpirationTimeToWorkOn === NoWork && (completedExpirationTime === NoWork || latestSuspendedTime < completedExpirationTime)) {
          // The lowest priority suspended work is the work most likely to be
          // committed next. Let's start rendering it again, so that if it times out,
          // it's ready to commit.
          nextExpirationTimeToWorkOn = latestSuspendedTime;
        }

        var expirationTime = nextExpirationTimeToWorkOn;

        if (expirationTime !== NoWork && earliestSuspendedTime > expirationTime) {
          // Expire using the earliest known expiration time.
          expirationTime = earliestSuspendedTime;
        }

        root.nextExpirationTimeToWorkOn = nextExpirationTimeToWorkOn;
        root.expirationTime = expirationTime;
      } // UpdateQueue is a linked list of prioritized updates.
      //
      // Like fibers, update queues come in pairs: a current queue, which represents
      // the visible state of the screen, and a work-in-progress queue, which is
      // can be mutated and processed asynchronously before it is committed — a form
      // of double buffering. If a work-in-progress render is discarded before
      // finishing, we create a new work-in-progress by cloning the current queue.
      //
      // Both queues share a persistent, singly-linked list structure. To schedule an
      // update, we append it to the end of both queues. Each queue maintains a
      // pointer to first update in the persistent list that hasn't been processed.
      // The work-in-progress pointer always has a position equal to or greater than
      // the current queue, since we always work on that one. The current queue's
      // pointer is only updated during the commit phase, when we swap in the
      // work-in-progress.
      //
      // For example:
      //
      //   Current pointer:           A - B - C - D - E - F
      //   Work-in-progress pointer:              D - E - F
      //                                          ^
      //                                          The work-in-progress queue has
      //                                          processed more updates than current.
      //
      // The reason we append to both queues is because otherwise we might drop
      // updates without ever processing them. For example, if we only add updates to
      // the work-in-progress queue, some updates could be lost whenever a work-in
      // -progress render restarts by cloning from current. Similarly, if we only add
      // updates to the current queue, the updates will be lost whenever an already
      // in-progress queue commits and swaps with the current queue. However, by
      // adding to both queues, we guarantee that the update will be part of the next
      // work-in-progress. (And because the work-in-progress queue becomes the
      // current queue once it commits, there's no danger of applying the same
      // update twice.)
      //
      // Prioritization
      // --------------
      //
      // Updates are not sorted by priority, but by insertion; new updates are always
      // appended to the end of the list.
      //
      // The priority is still important, though. When processing the update queue
      // during the render phase, only the updates with sufficient priority are
      // included in the result. If we skip an update because it has insufficient
      // priority, it remains in the queue to be processed later, during a lower
      // priority render. Crucially, all updates subsequent to a skipped update also
      // remain in the queue *regardless of their priority*. That means high priority
      // updates are sometimes processed twice, at two separate priorities. We also
      // keep track of a base state, that represents the state before the first
      // update in the queue is applied.
      //
      // For example:
      //
      //   Given a base state of '', and the following queue of updates
      //
      //     A1 - B2 - C1 - D2
      //
      //   where the number indicates the priority, and the update is applied to the
      //   previous state by appending a letter, React will process these updates as
      //   two separate renders, one per distinct priority level:
      //
      //   First render, at priority 1:
      //     Base state: ''
      //     Updates: [A1, C1]
      //     Result state: 'AC'
      //
      //   Second render, at priority 2:
      //     Base state: 'A'            <-  The base state does not include C1,
      //                                    because B2 was skipped.
      //     Updates: [B2, C1, D2]      <-  C1 was rebased on top of B2
      //     Result state: 'ABCD'
      //
      // Because we process updates in insertion order, and rebase high priority
      // updates when preceding updates are skipped, the final result is deterministic
      // regardless of priority. Intermediate state may vary according to system
      // resources, but the final state is always the same.


      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
      // It should only be read right after calling `processUpdateQueue`, via
      // `checkHasForceUpdateAfterProcessing`.

      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate = void 0;
      var currentlyProcessingQueue = void 0;
      var resetCurrentlyProcessingQueue = void 0;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;

        resetCurrentlyProcessingQueue = function resetCurrentlyProcessingQueue() {
          currentlyProcessingQueue = null;
        };
      }

      function createUpdateQueue(baseState) {
        var queue = {
          baseState: baseState,
          firstUpdate: null,
          lastUpdate: null,
          firstCapturedUpdate: null,
          lastCapturedUpdate: null,
          firstEffect: null,
          lastEffect: null,
          firstCapturedEffect: null,
          lastCapturedEffect: null
        };
        return queue;
      }

      function cloneUpdateQueue(currentQueue) {
        var queue = {
          baseState: currentQueue.baseState,
          firstUpdate: currentQueue.firstUpdate,
          lastUpdate: currentQueue.lastUpdate,
          // TODO: With resuming, if we bail out and resuse the child tree, we should
          // keep these effects.
          firstCapturedUpdate: null,
          lastCapturedUpdate: null,
          firstEffect: null,
          lastEffect: null,
          firstCapturedEffect: null,
          lastCapturedEffect: null
        };
        return queue;
      }

      function createUpdate(expirationTime) {
        return {
          expirationTime: expirationTime,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null,
          nextEffect: null
        };
      }

      function appendUpdateToQueue(queue, update) {
        // Append the update to the end of the list.
        if (queue.lastUpdate === null) {
          // Queue is empty
          queue.firstUpdate = queue.lastUpdate = update;
        } else {
          queue.lastUpdate.next = update;
          queue.lastUpdate = update;
        }
      }

      function enqueueUpdate(fiber, update) {
        // Update queues are created lazily.
        var alternate = fiber.alternate;
        var queue1 = void 0;
        var queue2 = void 0;

        if (alternate === null) {
          // There's only one fiber.
          queue1 = fiber.updateQueue;
          queue2 = null;

          if (queue1 === null) {
            queue1 = fiber.updateQueue = createUpdateQueue(fiber.memoizedState);
          }
        } else {
          // There are two owners.
          queue1 = fiber.updateQueue;
          queue2 = alternate.updateQueue;

          if (queue1 === null) {
            if (queue2 === null) {
              // Neither fiber has an update queue. Create new ones.
              queue1 = fiber.updateQueue = createUpdateQueue(fiber.memoizedState);
              queue2 = alternate.updateQueue = createUpdateQueue(alternate.memoizedState);
            } else {
              // Only one fiber has an update queue. Clone to create a new one.
              queue1 = fiber.updateQueue = cloneUpdateQueue(queue2);
            }
          } else {
            if (queue2 === null) {
              // Only one fiber has an update queue. Clone to create a new one.
              queue2 = alternate.updateQueue = cloneUpdateQueue(queue1);
            }
          }
        }

        if (queue2 === null || queue1 === queue2) {
          // There's only a single queue.
          appendUpdateToQueue(queue1, update);
        } else {
          // There are two queues. We need to append the update to both queues,
          // while accounting for the persistent structure of the list — we don't
          // want the same update to be added multiple times.
          if (queue1.lastUpdate === null || queue2.lastUpdate === null) {
            // One of the queues is not empty. We must add the update to both queues.
            appendUpdateToQueue(queue1, update);
            appendUpdateToQueue(queue2, update);
          } else {
            // Both queues are non-empty. The last update is the same in both lists,
            // because of structural sharing. So, only append to one of the lists.
            appendUpdateToQueue(queue1, update); // But we still need to update the `lastUpdate` pointer of queue2.

            queue2.lastUpdate = update;
          }
        }

        {
          if (fiber.tag === ClassComponent && (currentlyProcessingQueue === queue1 || queue2 !== null && currentlyProcessingQueue === queue2) && !didWarnUpdateInsideUpdate) {
            warningWithoutStack$1(false, 'An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
            didWarnUpdateInsideUpdate = true;
          }
        }
      }

      function enqueueCapturedUpdate(workInProgress, update) {
        // Captured updates go into a separate list, and only on the work-in-
        // progress queue.
        var workInProgressQueue = workInProgress.updateQueue;

        if (workInProgressQueue === null) {
          workInProgressQueue = workInProgress.updateQueue = createUpdateQueue(workInProgress.memoizedState);
        } else {
          // TODO: I put this here rather than createWorkInProgress so that we don't
          // clone the queue unnecessarily. There's probably a better way to
          // structure this.
          workInProgressQueue = ensureWorkInProgressQueueIsAClone(workInProgress, workInProgressQueue);
        } // Append the update to the end of the list.


        if (workInProgressQueue.lastCapturedUpdate === null) {
          // This is the first render phase update
          workInProgressQueue.firstCapturedUpdate = workInProgressQueue.lastCapturedUpdate = update;
        } else {
          workInProgressQueue.lastCapturedUpdate.next = update;
          workInProgressQueue.lastCapturedUpdate = update;
        }
      }

      function ensureWorkInProgressQueueIsAClone(workInProgress, queue) {
        var current = workInProgress.alternate;

        if (current !== null) {
          // If the work-in-progress queue is equal to the current queue,
          // we need to clone it first.
          if (queue === current.updateQueue) {
            queue = workInProgress.updateQueue = cloneUpdateQueue(queue);
          }
        }

        return queue;
      }

      function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch (update.tag) {
          case ReplaceState:
            {
              var _payload = update.payload;

              if (typeof _payload === 'function') {
                // Updater function
                {
                  if (workInProgress.mode & StrictMode) {
                    _payload.call(instance, prevState, nextProps);
                  }
                }
                return _payload.call(instance, prevState, nextProps);
              } // State object


              return _payload;
            }

          case CaptureUpdate:
            {
              workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            }
          // Intentional fallthrough

          case UpdateState:
            {
              var _payload2 = update.payload;
              var partialState = void 0;

              if (typeof _payload2 === 'function') {
                // Updater function
                {
                  if (workInProgress.mode & StrictMode) {
                    _payload2.call(instance, prevState, nextProps);
                  }
                }
                partialState = _payload2.call(instance, prevState, nextProps);
              } else {
                // Partial state object
                partialState = _payload2;
              }

              if (partialState === null || partialState === undefined) {
                // Null and undefined are treated as no-ops.
                return prevState;
              } // Merge the partial state and the previous state.


              return _assign({}, prevState, partialState);
            }

          case ForceUpdate:
            {
              hasForceUpdate = true;
              return prevState;
            }
        }

        return prevState;
      }

      function processUpdateQueue(workInProgress, queue, props, instance, renderExpirationTime) {
        hasForceUpdate = false;
        queue = ensureWorkInProgressQueueIsAClone(workInProgress, queue);
        {
          currentlyProcessingQueue = queue;
        } // These values may change as we process the queue.

        var newBaseState = queue.baseState;
        var newFirstUpdate = null;
        var newExpirationTime = NoWork; // Iterate through the list of updates to compute the result.

        var update = queue.firstUpdate;
        var resultState = newBaseState;

        while (update !== null) {
          var updateExpirationTime = update.expirationTime;

          if (updateExpirationTime < renderExpirationTime) {
            // This update does not have sufficient priority. Skip it.
            if (newFirstUpdate === null) {
              // This is the first skipped update. It will be the first update in
              // the new list.
              newFirstUpdate = update; // Since this is the first update that was skipped, the current result
              // is the new base state.

              newBaseState = resultState;
            } // Since this update will remain in the list, update the remaining
            // expiration time.


            if (newExpirationTime < updateExpirationTime) {
              newExpirationTime = updateExpirationTime;
            }
          } else {
            // This update does have sufficient priority. Process it and compute
            // a new result.
            resultState = getStateFromUpdate(workInProgress, queue, update, resultState, props, instance);
            var _callback = update.callback;

            if (_callback !== null) {
              workInProgress.effectTag |= Callback; // Set this to null, in case it was mutated during an aborted render.

              update.nextEffect = null;

              if (queue.lastEffect === null) {
                queue.firstEffect = queue.lastEffect = update;
              } else {
                queue.lastEffect.nextEffect = update;
                queue.lastEffect = update;
              }
            }
          } // Continue to the next update.


          update = update.next;
        } // Separately, iterate though the list of captured updates.


        var newFirstCapturedUpdate = null;
        update = queue.firstCapturedUpdate;

        while (update !== null) {
          var _updateExpirationTime = update.expirationTime;

          if (_updateExpirationTime < renderExpirationTime) {
            // This update does not have sufficient priority. Skip it.
            if (newFirstCapturedUpdate === null) {
              // This is the first skipped captured update. It will be the first
              // update in the new list.
              newFirstCapturedUpdate = update; // If this is the first update that was skipped, the current result is
              // the new base state.

              if (newFirstUpdate === null) {
                newBaseState = resultState;
              }
            } // Since this update will remain in the list, update the remaining
            // expiration time.


            if (newExpirationTime < _updateExpirationTime) {
              newExpirationTime = _updateExpirationTime;
            }
          } else {
            // This update does have sufficient priority. Process it and compute
            // a new result.
            resultState = getStateFromUpdate(workInProgress, queue, update, resultState, props, instance);
            var _callback2 = update.callback;

            if (_callback2 !== null) {
              workInProgress.effectTag |= Callback; // Set this to null, in case it was mutated during an aborted render.

              update.nextEffect = null;

              if (queue.lastCapturedEffect === null) {
                queue.firstCapturedEffect = queue.lastCapturedEffect = update;
              } else {
                queue.lastCapturedEffect.nextEffect = update;
                queue.lastCapturedEffect = update;
              }
            }
          }

          update = update.next;
        }

        if (newFirstUpdate === null) {
          queue.lastUpdate = null;
        }

        if (newFirstCapturedUpdate === null) {
          queue.lastCapturedUpdate = null;
        } else {
          workInProgress.effectTag |= Callback;
        }

        if (newFirstUpdate === null && newFirstCapturedUpdate === null) {
          // We processed every update, without skipping. That means the new base
          // state is the same as the result state.
          newBaseState = resultState;
        }

        queue.baseState = newBaseState;
        queue.firstUpdate = newFirstUpdate;
        queue.firstCapturedUpdate = newFirstCapturedUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
        // This should be fine because the only two other things that contribute to
        // expiration time are props and context. We're already in the middle of the
        // begin phase by the time we start processing the queue, so we've already
        // dealt with the props. Context in components that specify
        // shouldComponentUpdate is tricky; but we'll have to account for
        // that regardless.

        workInProgress.expirationTime = newExpirationTime;
        workInProgress.memoizedState = resultState;
        {
          currentlyProcessingQueue = null;
        }
      }

      function callCallback(callback, context) {
        !(typeof callback === 'function') ? invariant(false, 'Invalid argument passed as callback. Expected a function. Instead received: %s', callback) : void 0;
        callback.call(context);
      }

      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }

      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }

      function commitUpdateQueue(finishedWork, finishedQueue, instance, renderExpirationTime) {
        // If the finished render included captured updates, and there are still
        // lower priority updates left over, we need to keep the captured updates
        // in the queue so that they are rebased and not dropped once we process the
        // queue again at the lower priority.
        if (finishedQueue.firstCapturedUpdate !== null) {
          // Join the captured update list to the end of the normal list.
          if (finishedQueue.lastUpdate !== null) {
            finishedQueue.lastUpdate.next = finishedQueue.firstCapturedUpdate;
            finishedQueue.lastUpdate = finishedQueue.lastCapturedUpdate;
          } // Clear the list of captured updates.


          finishedQueue.firstCapturedUpdate = finishedQueue.lastCapturedUpdate = null;
        } // Commit the effects


        commitUpdateEffects(finishedQueue.firstEffect, instance);
        finishedQueue.firstEffect = finishedQueue.lastEffect = null;
        commitUpdateEffects(finishedQueue.firstCapturedEffect, instance);
        finishedQueue.firstCapturedEffect = finishedQueue.lastCapturedEffect = null;
      }

      function commitUpdateEffects(effect, instance) {
        while (effect !== null) {
          var _callback3 = effect.callback;

          if (_callback3 !== null) {
            effect.callback = null;
            callCallback(_callback3, instance);
          }

          effect = effect.nextEffect;
        }
      }

      function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
          value: value,
          source: source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }
      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var warning = warningWithoutStack$1;
      {
        warning = function warning(condition, format) {
          if (condition) {
            return;
          }

          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum(); // eslint-disable-next-line react-internal/warning-and-invariant-args

          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          warningWithoutStack$1.apply(undefined, [false, format + '%s'].concat(args, [stack]));
        };
      }
      var warning$1 = warning;
      var valueCursor = createCursor(null);
      var rendererSigil = void 0;
      {
        // Use this to detect multiple renderers using the same context
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastContextWithAllBitsObserved = null;

      function resetContextDependences() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
      }

      function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;

        if (isPrimaryRenderer) {
          push(valueCursor, context._currentValue, providerFiber);
          context._currentValue = nextValue;
          {
            !(context._currentRenderer === undefined || context._currentRenderer === null || context._currentRenderer === rendererSigil) ? warningWithoutStack$1(false, 'Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.') : void 0;
            context._currentRenderer = rendererSigil;
          }
        } else {
          push(valueCursor, context._currentValue2, providerFiber);
          context._currentValue2 = nextValue;
          {
            !(context._currentRenderer2 === undefined || context._currentRenderer2 === null || context._currentRenderer2 === rendererSigil) ? warningWithoutStack$1(false, 'Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.') : void 0;
            context._currentRenderer2 = rendererSigil;
          }
        }
      }

      function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;

        if (isPrimaryRenderer) {
          context._currentValue = currentValue;
        } else {
          context._currentValue2 = currentValue;
        }
      }

      function calculateChangedBits(context, newValue, oldValue) {
        // Use Object.is to compare the new context value to the old value. Inlined
        // Object.is polyfill.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
        if (oldValue === newValue && (oldValue !== 0 || 1 / oldValue === 1 / newValue) || oldValue !== oldValue && newValue !== newValue // eslint-disable-line no-self-compare
        ) {
            // No change
            return 0;
          } else {
          var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : maxSigned31BitInt;
          {
            !((changedBits & maxSigned31BitInt) === changedBits) ? warning$1(false, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits) : void 0;
          }
          return changedBits | 0;
        }
      }

      function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;

        if (fiber !== null) {
          // Set the return pointer of the child to the work-in-progress fiber.
          fiber.return = workInProgress;
        }

        while (fiber !== null) {
          var nextFiber = void 0; // Visit this fiber.

          var dependency = fiber.firstContextDependency;

          if (dependency !== null) {
            do {
              // Check if the context matches.
              if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                // Match! Schedule an update on this fiber.
                if (fiber.tag === ClassComponent) {
                  // Schedule a force update on the work-in-progress.
                  var update = createUpdate(renderExpirationTime);
                  update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                  // update to the current fiber, too, which means it will persist even if
                  // this render is thrown away. Since it's a race condition, not sure it's
                  // worth fixing.

                  enqueueUpdate(fiber, update);
                }

                if (fiber.expirationTime < renderExpirationTime) {
                  fiber.expirationTime = renderExpirationTime;
                }

                var alternate = fiber.alternate;

                if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
                  alternate.expirationTime = renderExpirationTime;
                } // Update the child expiration time of all the ancestors, including
                // the alternates.


                var node = fiber.return;

                while (node !== null) {
                  alternate = node.alternate;

                  if (node.childExpirationTime < renderExpirationTime) {
                    node.childExpirationTime = renderExpirationTime;

                    if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
                      alternate.childExpirationTime = renderExpirationTime;
                    }
                  } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
                    alternate.childExpirationTime = renderExpirationTime;
                  } else {
                    // Neither alternate was updated, which means the rest of the
                    // ancestor path already has sufficient priority.
                    break;
                  }

                  node = node.return;
                }
              }

              nextFiber = fiber.child;
              dependency = dependency.next;
            } while (dependency !== null);
          } else if (fiber.tag === ContextProvider) {
            // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
          } else {
            // Traverse down.
            nextFiber = fiber.child;
          }

          if (nextFiber !== null) {
            // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
          } else {
            // No child. Traverse to next sibling.
            nextFiber = fiber;

            while (nextFiber !== null) {
              if (nextFiber === workInProgress) {
                // We're back to the root of this subtree. Exit.
                nextFiber = null;
                break;
              }

              var sibling = nextFiber.sibling;

              if (sibling !== null) {
                // Set the return pointer of the sibling to the work-in-progress fiber.
                sibling.return = nextFiber.return;
                nextFiber = sibling;
                break;
              } // No more siblings. Traverse up.


              nextFiber = nextFiber.return;
            }
          }

          fiber = nextFiber;
        }
      }

      function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null; // Reset the work-in-progress list

        workInProgress.firstContextDependency = null;
      }

      function readContext(context, observedBits) {
        if (lastContextWithAllBitsObserved === context) ;else if (observedBits === false || observedBits === 0) ;else {
          var resolvedObservedBits = void 0; // Avoid deopting on observable arguments or heterogeneous types.

          if (typeof observedBits !== 'number' || observedBits === maxSigned31BitInt) {
            // Observe all updates.
            lastContextWithAllBitsObserved = context;
            resolvedObservedBits = maxSigned31BitInt;
          } else {
            resolvedObservedBits = observedBits;
          }

          var contextItem = {
            context: context,
            observedBits: resolvedObservedBits,
            next: null
          };

          if (lastContextDependency === null) {
            !(currentlyRenderingFiber !== null) ? invariant(false, 'Context can only be read while React is rendering, e.g. inside the render method or getDerivedStateFromProps.') : void 0; // This is the first dependency in the list

            currentlyRenderingFiber.firstContextDependency = lastContextDependency = contextItem;
          } else {
            // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return isPrimaryRenderer ? context._currentValue : context._currentValue2;
      }

      var NoEffect$1 =
      /*             */
      0;
      var UnmountSnapshot =
      /*      */
      2;
      var UnmountMutation =
      /*      */
      4;
      var MountMutation =
      /*        */
      8;
      var UnmountLayout =
      /*        */
      16;
      var MountLayout =
      /*          */
      32; // The work-in-progress fiber. I've named it differently to distinguish it from
      // the work-in-progress hook.

      var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
      // current hook list is the list that belongs to the current fiber. The
      // work-in-progress hook list is a new list that will be added to the
      // work-in-progress fiber.

      var firstCurrentHook = null;
      var currentHook = null;
      var firstWorkInProgressHook = null;
      var remainingExpirationTime = NoWork;
      var componentUpdateQueue = null; // Whether an update was scheduled during the currently executing render pass.

      var didScheduleRenderPhaseUpdate = false;

      function prepareToUseHooks(current, workInProgress, nextRenderExpirationTime) {
        {
          return;
        }
        currentlyRenderingFiber$1 = workInProgress;
        firstCurrentHook = current !== null ? current.memoizedState : null; // The following should have already been reset
        // currentHook = null;
        // workInProgressHook = null;
        // remainingExpirationTime = NoWork;
        // componentUpdateQueue = null;
        // isReRender = false;
        // didScheduleRenderPhaseUpdate = false;
        // renderPhaseUpdates = null;
        // numberOfReRenders = 0;
      }

      function finishHooks(Component, props, children, refOrContext) {
        {
          return children;
        } // This must be called after every function component to prevent hooks from
        // being used in classes.

        while (didScheduleRenderPhaseUpdate) {
          // Updates were scheduled during the render phase. They are stored in
          // the `renderPhaseUpdates` map. Call the component again, reusing the
          // work-in-progress hooks and applying the additional updates on top. Keep
          // restarting until no more updates are scheduled.
          didScheduleRenderPhaseUpdate = false; // Start over from the beginning of the list

          currentHook = null;
          componentUpdateQueue = null;
          children = Component(props, refOrContext);
        }

        var renderedWork = currentlyRenderingFiber$1;
        renderedWork.memoizedState = firstWorkInProgressHook;
        renderedWork.expirationTime = remainingExpirationTime;
        renderedWork.updateQueue = componentUpdateQueue;
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        currentlyRenderingFiber$1 = null;
        firstCurrentHook = null;
        currentHook = null;
        firstWorkInProgressHook = null;
        remainingExpirationTime = NoWork;
        componentUpdateQueue = null; // Always set during createWorkInProgress
        // isReRender = false;
        // These were reset above
        // didScheduleRenderPhaseUpdate = false;
        // renderPhaseUpdates = null;
        // numberOfReRenders = 0;

        !!didRenderTooFewHooks ? invariant(false, 'Rendered fewer hooks than expected. This may be caused by an accidental early return statement.') : void 0;
        return children;
      }

      function resetHooks() {
        {
          return;
        }
        currentlyRenderingFiber$1 = null;
        firstCurrentHook = null;
        currentHook = null;
        firstWorkInProgressHook = null;
        remainingExpirationTime = NoWork;
        componentUpdateQueue = null; // Always set during createWorkInProgress
        // isReRender = false;

        didScheduleRenderPhaseUpdate = false;
      }

      var NO_CONTEXT = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT);
      var contextFiberStackCursor = createCursor(NO_CONTEXT);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT);

      function requiredContext(c) {
        !(c !== NO_CONTEXT) ? invariant(false, 'Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        return c;
      }

      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }

      function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.

        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
      }

      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }

      function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
      }

      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type, rootInstance); // Don't push this Fiber's context unless it's unique.

        if (context === nextContext) {
          return;
        } // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.


        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
      }

      function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }

        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }

      var commitTime = 0;
      var profilerStartTime = -1;

      function getCommitTime() {
        return commitTime;
      }

      function recordCommitTime() {
        commitTime = now();
      }

      function startProfilerTimer(fiber) {
        profilerStartTime = now();

        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now();
        }
      }

      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }

      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now() - profilerStartTime;
          fiber.actualDuration += elapsedTime;

          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }

          profilerStartTime = -1;
        }
      }
      /*eslint-disable no-self-compare */


      var hasOwnProperty = Object.prototype.hasOwnProperty;
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          // Added the nonzero y check to make Flow happy, but it is redundant
          return x !== 0 || y !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /**
       * Performs equality by iterating through keys on an object and returning false
       * when any key has values which are not strictly equal between the arguments.
       * Returns true when the values of all keys are strictly equal.
       */


      function shallowEqual(objA, objB) {
        if (is(objA, objB)) {
          return true;
        }

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }

        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);

        if (keysA.length !== keysB.length) {
          return false;
        } // Test for A's keys different from B.


        for (var i = 0; i < keysA.length; i++) {
          if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }

        return true;
      }

      function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
          // Resolve default props. Taken from ReactElement
          var props = _assign({}, baseProps);

          var defaultProps = Component.defaultProps;

          for (var propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }

          return props;
        }

        return baseProps;
      }

      function readLazyComponentType(lazyComponent) {
        var status = lazyComponent._status;
        var result = lazyComponent._result;

        switch (status) {
          case Resolved:
            {
              var Component = result;
              return Component;
            }

          case Rejected:
            {
              var error = result;
              throw error;
            }

          case Pending:
            {
              var thenable = result;
              throw thenable;
            }

          default:
            {
              lazyComponent._status = Pending;
              var ctor = lazyComponent._ctor;

              var _thenable = ctor();

              _thenable.then(function (moduleObject) {
                if (lazyComponent._status === Pending) {
                  var defaultExport = moduleObject.default;
                  {
                    if (defaultExport === undefined) {
                      warning$1(false, 'lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + "const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    }
                  }
                  lazyComponent._status = Resolved;
                  lazyComponent._result = defaultExport;
                }
              }, function (error) {
                if (lazyComponent._status === Pending) {
                  lazyComponent._status = Rejected;
                  lazyComponent._result = error;
                }
              });

              lazyComponent._result = _thenable;
              throw _thenable;
            }
        }
      }

      var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;

      function readContext$1(contextType) {
        var dispatcher = ReactCurrentOwner$3.currentDispatcher;
        return dispatcher.readContext(contextType);
      }

      var fakeInternalInstance = {};
      var isArray$1 = Array.isArray; // React.Component uses a shared frozen object by default.
      // We'll use it to determine whether we need to initialize legacy refs.

      var emptyRefsObject = new React$$1.Component().refs;
      var didWarnAboutStateAssignmentForComponent = void 0;
      var didWarnAboutUninitializedState = void 0;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = void 0;
      var didWarnAboutLegacyLifecyclesAndDerivedState = void 0;
      var didWarnAboutUndefinedDerivedState = void 0;
      var warnOnUndefinedDerivedState = void 0;
      var warnOnInvalidCallback = void 0;
      var didWarnAboutDirectlyAssigningPropsToState = void 0;
      var didWarnAboutContextTypeAndContextTypes = void 0;
      var didWarnAboutInvalidateContextType = void 0;
      {
        didWarnAboutStateAssignmentForComponent = new Set();
        didWarnAboutUninitializedState = new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
        didWarnAboutDirectlyAssigningPropsToState = new Set();
        didWarnAboutUndefinedDerivedState = new Set();
        didWarnAboutContextTypeAndContextTypes = new Set();
        didWarnAboutInvalidateContextType = new Set();
        var didWarnOnInvalidCallback = new Set();

        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === 'function') {
            return;
          }

          var key = callerName + '_' + callback;

          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            warningWithoutStack$1(false, '%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        };

        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';

            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              warningWithoutStack$1(false, '%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
            }
          }
        }; // This is so gross but it's at least non-critical and can be removed if
        // it causes problems. This is meant to give a nicer error message for
        // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
        // ...)) which otherwise throws a "_processChildContext is not a function"
        // exception.


        Object.defineProperty(fakeInternalInstance, '_processChildContext', {
          enumerable: false,
          value: function value() {
            invariant(false, '_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn\'t supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).');
          }
        });
        Object.freeze(fakeInternalInstance);
      }

      function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        {
          if (workInProgress.mode & StrictMode) {
            // Invoke the function an extra time to help detect side-effects.
            getDerivedStateFromProps(nextProps, prevState);
          }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          warnOnUndefinedDerivedState(ctor, partialState);
        } // Merge the partial state and the previous state.

        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.

        var updateQueue = workInProgress.updateQueue;

        if (updateQueue !== null && workInProgress.expirationTime === NoWork) {
          updateQueue.baseState = memoizedState;
        }
      }

      var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTime();
          var expirationTime = computeExpirationForFiber(currentTime, fiber);
          var update = createUpdate(expirationTime);
          update.payload = payload;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'setState');
            }
            update.callback = callback;
          }

          flushPassiveEffects();
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTime();
          var expirationTime = computeExpirationForFiber(currentTime, fiber);
          var update = createUpdate(expirationTime);
          update.tag = ReplaceState;
          update.payload = payload;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'replaceState');
            }
            update.callback = callback;
          }

          flushPassiveEffects();
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTime();
          var expirationTime = computeExpirationForFiber(currentTime, fiber);
          var update = createUpdate(expirationTime);
          update.tag = ForceUpdate;

          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'forceUpdate');
            }
            update.callback = callback;
          }

          flushPassiveEffects();
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        }
      };

      function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;

        if (typeof instance.shouldComponentUpdate === 'function') {
          startPhaseTimer(workInProgress, 'shouldComponentUpdate');
          var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
          stopPhaseTimer();
          {
            !(shouldUpdate !== undefined) ? warningWithoutStack$1(false, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component') : void 0;
          }
          return shouldUpdate;
        }

        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }

        return true;
      }

      function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        {
          var name = getComponentName(ctor) || 'Component';
          var renderPresent = instance.render;

          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') {
              warningWithoutStack$1(false, '%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
            } else {
              warningWithoutStack$1(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
            }
          }

          var noGetInitialStateOnES6 = !instance.getInitialState || instance.getInitialState.isReactClassApproved || instance.state;
          !noGetInitialStateOnES6 ? warningWithoutStack$1(false, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name) : void 0;
          var noGetDefaultPropsOnES6 = !instance.getDefaultProps || instance.getDefaultProps.isReactClassApproved;
          !noGetDefaultPropsOnES6 ? warningWithoutStack$1(false, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name) : void 0;
          var noInstancePropTypes = !instance.propTypes;
          !noInstancePropTypes ? warningWithoutStack$1(false, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name) : void 0;
          var noInstanceContextType = !instance.contextType;
          !noInstanceContextType ? warningWithoutStack$1(false, 'contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name) : void 0;
          var noInstanceContextTypes = !instance.contextTypes;
          !noInstanceContextTypes ? warningWithoutStack$1(false, 'contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name) : void 0;

          if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            warningWithoutStack$1(false, '%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
          }

          var noComponentShouldUpdate = typeof instance.componentShouldUpdate !== 'function';
          !noComponentShouldUpdate ? warningWithoutStack$1(false, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name) : void 0;

          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
            warningWithoutStack$1(false, '%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
          }

          var noComponentDidUnmount = typeof instance.componentDidUnmount !== 'function';
          !noComponentDidUnmount ? warningWithoutStack$1(false, '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name) : void 0;
          var noComponentDidReceiveProps = typeof instance.componentDidReceiveProps !== 'function';
          !noComponentDidReceiveProps ? warningWithoutStack$1(false, '%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name) : void 0;
          var noComponentWillRecieveProps = typeof instance.componentWillRecieveProps !== 'function';
          !noComponentWillRecieveProps ? warningWithoutStack$1(false, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name) : void 0;
          var noUnsafeComponentWillRecieveProps = typeof instance.UNSAFE_componentWillRecieveProps !== 'function';
          !noUnsafeComponentWillRecieveProps ? warningWithoutStack$1(false, '%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name) : void 0;
          var hasMutatedProps = instance.props !== newProps;
          !(instance.props === undefined || !hasMutatedProps) ? warningWithoutStack$1(false, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name) : void 0;
          var noInstanceDefaultProps = !instance.defaultProps;
          !noInstanceDefaultProps ? warningWithoutStack$1(false, 'Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name) : void 0;

          if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            warningWithoutStack$1(false, '%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
          }

          var noInstanceGetDerivedStateFromProps = typeof instance.getDerivedStateFromProps !== 'function';
          !noInstanceGetDerivedStateFromProps ? warningWithoutStack$1(false, '%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name) : void 0;
          var noInstanceGetDerivedStateFromCatch = typeof instance.getDerivedStateFromError !== 'function';
          !noInstanceGetDerivedStateFromCatch ? warningWithoutStack$1(false, '%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name) : void 0;
          var noStaticGetSnapshotBeforeUpdate = typeof ctor.getSnapshotBeforeUpdate !== 'function';
          !noStaticGetSnapshotBeforeUpdate ? warningWithoutStack$1(false, '%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name) : void 0;
          var _state = instance.state;

          if (_state && (typeof _state !== 'object' || isArray$1(_state))) {
            warningWithoutStack$1(false, '%s.state: must be set to an object or null', name);
          }

          if (typeof instance.getChildContext === 'function') {
            !(typeof ctor.childContextTypes === 'object') ? warningWithoutStack$1(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name) : void 0;
          }
        }
      }

      function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

        set(instance, workInProgress);
        {
          instance._reactInternalInstance = fakeInternalInstance;
        }
      }

      function constructClassInstance(workInProgress, ctor, props, renderExpirationTime) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = null;
        var contextType = ctor.contextType;

        if (typeof contextType === 'object' && contextType !== null) {
          {
            if (contextType.$$typeof !== REACT_CONTEXT_TYPE && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              warningWithoutStack$1(false, '%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext(). ' + 'Did you accidentally pass the Context.Provider instead?', getComponentName(ctor) || 'Component');
            }
          }
          context = readContext$1(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
          context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.


        {
          if (workInProgress.mode & StrictMode) {
            new ctor(props, context); // eslint-disable-line no-new
          }
        }
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        {
          if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';

            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              warningWithoutStack$1(false, '`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
          } // If new component APIs are defined, "unsafe" lifecycles won't be called.
          // Warn about these lifecycles if they are present.
          // Don't warn about react-lifecycles-compat polyfilled methods though.


          if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;

            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = 'componentWillMount';
            } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
              foundWillMountName = 'UNSAFE_componentWillMount';
            }

            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = 'componentWillReceiveProps';
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            }

            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = 'componentWillUpdate';
            } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            }

            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentName(ctor) || 'Component';

              var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                warningWithoutStack$1(false, 'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks', _componentName, newApiName, foundWillMountName !== null ? '\n  ' + foundWillMountName : '', foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '', foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '');
              }
            }
          }
        } // Cache unmasked context so we can avoid recreating masked context unless necessary.
        // ReactFiberContext usually updates this cache but can't for newly-created instances.

        if (isLegacyContextConsumer) {
          cacheContext(workInProgress, unmaskedContext, context);
        }

        return instance;
      }

      function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, 'componentWillMount');
        var oldState = instance.state;

        if (typeof instance.componentWillMount === 'function') {
          instance.componentWillMount();
        }

        if (typeof instance.UNSAFE_componentWillMount === 'function') {
          instance.UNSAFE_componentWillMount();
        }

        stopPhaseTimer();

        if (oldState !== instance.state) {
          {
            warningWithoutStack$1(false, '%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }

      function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, 'componentWillReceiveProps');

        if (typeof instance.componentWillReceiveProps === 'function') {
          instance.componentWillReceiveProps(newProps, nextContext);
        }

        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
          instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }

        stopPhaseTimer();

        if (instance.state !== oldState) {
          {
            var componentName = getComponentName(workInProgress.type) || 'Component';

            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              warningWithoutStack$1(false, '%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      } // Invokes the mount life-cycles on a previously never rendered instance.


      function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        {
          checkClassInstance(workInProgress, ctor, newProps);
        }
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        var contextType = ctor.contextType;

        if (typeof contextType === 'object' && contextType !== null) {
          instance.context = readContext$1(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }

        {
          if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';

            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              warningWithoutStack$1(false, '%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
            }
          }

          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
          }
        }
        var updateQueue = workInProgress.updateQueue;

        if (updateQueue !== null) {
          processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
          instance.state = workInProgress.memoizedState;
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.


        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
          callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
          // process them now.

          updateQueue = workInProgress.updateQueue;

          if (updateQueue !== null) {
            processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
            instance.state = workInProgress.memoizedState;
          }
        }

        if (typeof instance.componentDidMount === 'function') {
          workInProgress.effectTag |= Update;
        }
      }

      function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = void 0;

        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = readContext$1(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }

        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        var updateQueue = workInProgress.updateQueue;

        if (updateQueue !== null) {
          processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
          newState = workInProgress.memoizedState;
        }

        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }

          return false;
        }

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }

        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillMount');

            if (typeof instance.componentWillMount === 'function') {
              instance.componentWillMount();
            }

            if (typeof instance.UNSAFE_componentWillMount === 'function') {
              instance.UNSAFE_componentWillMount();
            }

            stopPhaseTimer();
          }

          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized state to indicate that this work can be reused.


          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.


        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      } // Invokes the update life-cycles and returns false if it shouldn't rerender.


      function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = void 0;

        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = readContext$1(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }

        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }

        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        var updateQueue = workInProgress.updateQueue;

        if (updateQueue !== null) {
          processUpdateQueue(workInProgress, updateQueue, newProps, instance, renderExpirationTime);
          newState = workInProgress.memoizedState;
        }

        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          }

          return false;
        }

        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }

        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillUpdate');

            if (typeof instance.componentWillUpdate === 'function') {
              instance.componentWillUpdate(newProps, newState, nextContext);
            }

            if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }

            stopPhaseTimer();
          }

          if (typeof instance.componentDidUpdate === 'function') {
            workInProgress.effectTag |= Update;
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            workInProgress.effectTag |= Snapshot;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }

          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized props/state to indicate that this work can be reused.


          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.


        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }

      var didWarnAboutMaps = void 0;
      var didWarnAboutGenerators = void 0;
      var didWarnAboutStringRefInStrictMode = void 0;
      var ownerHasKeyUseWarning = void 0;
      var ownerHasFunctionTypeWarning = void 0;

      var warnForMissingKey = function warnForMissingKey(child) {};

      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefInStrictMode = {};
        /**
         * Warn if there's no key explicitly set on dynamic arrays of children or
         * object keys are not valid. This allows us to keep track of children between
         * updates.
         */

        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};

        warnForMissingKey = function warnForMissingKey(child) {
          if (child === null || typeof child !== 'object') {
            return;
          }

          if (!child._store || child._store.validated || child.key != null) {
            return;
          }

          !(typeof child._store === 'object') ? invariant(false, 'React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          child._store.validated = true;
          var currentComponentErrorInfo = 'Each child in an array or iterator should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.' + getCurrentFiberStackInDev();

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          warning$1(false, 'Each child in an array or iterator should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.');
        };
      }
      var isArray = Array.isArray;

      function coerceRef(returnFiber, current$$1, element) {
        var mixedRef = element.ref;

        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
          {
            if (returnFiber.mode & StrictMode) {
              var componentName = getComponentName(returnFiber.type) || 'Component';

              if (!didWarnAboutStringRefInStrictMode[componentName]) {
                warningWithoutStack$1(false, 'A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using createRef() instead.' + '\n%s' + '\n\nLearn more about using refs safely here:' + '\nhttps://fb.me/react-strict-mode-string-ref', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                didWarnAboutStringRefInStrictMode[componentName] = true;
              }
            }
          }

          if (element._owner) {
            var owner = element._owner;
            var inst = void 0;

            if (owner) {
              var ownerFiber = owner;
              !(ownerFiber.tag === ClassComponent) ? invariant(false, 'Function components cannot have refs.') : void 0;
              inst = ownerFiber.stateNode;
            }

            !inst ? invariant(false, 'Missing owner for string ref %s. This error is likely caused by a bug in React. Please file an issue.', mixedRef) : void 0;
            var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

            if (current$$1 !== null && current$$1.ref !== null && typeof current$$1.ref === 'function' && current$$1.ref._stringRef === stringRef) {
              return current$$1.ref;
            }

            var ref = function ref(value) {
              var refs = inst.refs;

              if (refs === emptyRefsObject) {
                // This is a lazy pooled frozen object, so we need to initialize.
                refs = inst.refs = {};
              }

              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };

            ref._stringRef = stringRef;
            return ref;
          } else {
            !(typeof mixedRef === 'string') ? invariant(false, 'Expected ref to be a function, a string, an object returned by React.createRef(), or null.') : void 0;
            !element._owner ? invariant(false, 'Element ref was specified as a string (%s) but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component\'s render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.', mixedRef) : void 0;
          }
        }

        return mixedRef;
      }

      function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') {
          var addendum = '';
          {
            addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + getCurrentFiberStackInDev();
          }
          invariant(false, 'Objects are not valid as a React child (found: %s).%s', Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild, addendum);
        }
      }

      function warnOnFunctionType() {
        var currentComponentErrorInfo = 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.' + getCurrentFiberStackInDev();

        if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) {
          return;
        }

        ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
        warning$1(false, 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
      } // This wrapper function exists because I expect to clone the code in each path
      // to be able to optimize each path individually by branching early. This needs
      // a compiler or we can do it manually. Helpers that don't need this branching
      // live outside of this function.


      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return;
          } // Deletions are added in reversed order so we add it to the front.
          // At this point, the return fiber's effect list is empty except for
          // deletions, so we can just append the deletion to the list. The remaining
          // effects aren't added until the complete phase. Once we implement
          // resuming, this may not be true.


          var last = returnFiber.lastEffect;

          if (last !== null) {
            last.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }

          childToDelete.nextEffect = null;
          childToDelete.effectTag = Deletion;
        }

        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return null;
          } // TODO: For the shouldClone case, this could be micro-optimized a bit by
          // assuming that after the first child we've already added everything.


          var childToDelete = currentFirstChild;

          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }

          return null;
        }

        function mapRemainingChildren(returnFiber, currentFirstChild) {
          // Add the remaining children to a temporary map so that we can find them by
          // keys quickly. Implicit (null) keys get added to this set with their index
          var existingChildren = new Map();
          var existingChild = currentFirstChild;

          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }

            existingChild = existingChild.sibling;
          }

          return existingChildren;
        }

        function useFiber(fiber, pendingProps, expirationTime) {
          // We currently set sibling to null and index to 0 here because it is easy
          // to forget to do before returning it. E.g. for the single child case.
          var clone = createWorkInProgress(fiber, pendingProps, expirationTime);
          clone.index = 0;
          clone.sibling = null;
          return clone;
        }

        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;

          if (!shouldTrackSideEffects) {
            // Noop.
            return lastPlacedIndex;
          }

          var current$$1 = newFiber.alternate;

          if (current$$1 !== null) {
            var oldIndex = current$$1.index;

            if (oldIndex < lastPlacedIndex) {
              // This is a move.
              newFiber.effectTag = Placement;
              return lastPlacedIndex;
            } else {
              // This item can stay in place.
              return oldIndex;
            }
          } else {
            // This is an insertion.
            newFiber.effectTag = Placement;
            return lastPlacedIndex;
          }
        }

        function placeSingleChild(newFiber) {
          // This is simpler for the single child case. We only need to do a
          // placement for inserting new children.
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.effectTag = Placement;
          }

          return newFiber;
        }

        function updateTextNode(returnFiber, current$$1, textContent, expirationTime) {
          if (current$$1 === null || current$$1.tag !== HostText) {
            // Insert
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current$$1, textContent, expirationTime);
            existing.return = returnFiber;
            return existing;
          }
        }

        function updateElement(returnFiber, current$$1, element, expirationTime) {
          if (current$$1 !== null && current$$1.elementType === element.type) {
            // Move based on index
            var existing = useFiber(current$$1, element.props, expirationTime);
            existing.ref = coerceRef(returnFiber, current$$1, element);
            existing.return = returnFiber;
            {
              existing._debugSource = element._source;
              existing._debugOwner = element._owner;
            }
            return existing;
          } else {
            // Insert
            var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
            created.ref = coerceRef(returnFiber, current$$1, element);
            created.return = returnFiber;
            return created;
          }
        }

        function updatePortal(returnFiber, current$$1, portal, expirationTime) {
          if (current$$1 === null || current$$1.tag !== HostPortal || current$$1.stateNode.containerInfo !== portal.containerInfo || current$$1.stateNode.implementation !== portal.implementation) {
            // Insert
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current$$1, portal.children || [], expirationTime);
            existing.return = returnFiber;
            return existing;
          }
        }

        function updateFragment(returnFiber, current$$1, fragment, expirationTime, key) {
          if (current$$1 === null || current$$1.tag !== Fragment) {
            // Insert
            var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current$$1, fragment, expirationTime);
            existing.return = returnFiber;
            return existing;
          }
        }

        function createChild(returnFiber, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);

                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }

              case REACT_PORTAL_TYPE:
                {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);

                  _created2.return = returnFiber;
                  return _created2;
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);

              _created3.return = returnFiber;
              return _created3;
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }

        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
          // Update the fiber if the keys match, otherwise return null.
          var key = oldFiber !== null ? oldFiber.key : null;

          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            if (key !== null) {
              return null;
            }

            return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  if (newChild.key === key) {
                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                    }

                    return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }

              case REACT_PORTAL_TYPE:
                {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }

              return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }

        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys, so we neither have to check the old nor
            // new node for the key. If both are text nodes, they match.
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
          }

          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                  if (newChild.type === REACT_FRAGMENT_TYPE) {
                    return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                  }

                  return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                }

              case REACT_PORTAL_TYPE:
                {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                  return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
            }

            if (isArray(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;

              return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
            }

            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        /**
         * Warns if there is a duplicate or missing key
         */


        function warnOnInvalidKey(child, knownKeys) {
          {
            if (typeof child !== 'object' || child === null) {
              return knownKeys;
            }

            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child);
                var key = child.key;

                if (typeof key !== 'string') {
                  break;
                }

                if (knownKeys === null) {
                  knownKeys = new Set();
                  knownKeys.add(key);
                  break;
                }

                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }

                warning$1(false, 'Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                break;

              default:
                break;
            }
          }
          return knownKeys;
        }

        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
          // This algorithm can't optimize by searching from boths ends since we
          // don't have backpointers on fibers. I'm trying to see how far we can get
          // with that model. If it ends up not being worth the tradeoffs, we can
          // add it later.
          // Even with a two ended optimization, we'd want to optimize for the case
          // where there are few changes and brute force the comparison instead of
          // going for the Map. It'd like to explore hitting that path first in
          // forward-only mode and only go for the Map once we notice that we need
          // lots of look ahead. This doesn't handle reversal as well as two ended
          // search but that's unusual. Besides, for the two ended optimization to
          // work on Iterables, we'd need to copy the whole set.
          // In this first iteration, we'll just live with hitting the bad case
          // (adding everything to a Map) in for every insert/move.
          // If you change this code, also update reconcileChildrenIterator() which
          // uses the same algorithm.
          {
            // First, validate keys.
            var knownKeys = null;

            for (var i = 0; i < newChildren.length; i++) {
              var child = newChildren[i];
              knownKeys = warnOnInvalidKey(child, knownKeys);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;

          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }

            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);

            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }

              break;
            }

            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }

            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }

            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }

          if (newIdx === newChildren.length) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }

          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);

              if (!_newFiber) {
                continue;
              }

              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }

              previousNewFiber = _newFiber;
            }

            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.


          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);

            if (_newFiber2) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }

              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }

              previousNewFiber = _newFiber2;
            }
          }

          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }

          return resultingFirstChild;
        }

        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
          // This is the same implementation as reconcileChildrenArray(),
          // but using the iterator instead.
          var iteratorFn = getIteratorFn(newChildrenIterable);
          !(typeof iteratorFn === 'function') ? invariant(false, 'An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.') : void 0;
          {
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
              !didWarnAboutGenerators ? warning$1(false, 'Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.') : void 0;
              didWarnAboutGenerators = true;
            } // Warn about using Maps as children


            if (newChildrenIterable.entries === iteratorFn) {
              !didWarnAboutMaps ? warning$1(false, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.') : void 0;
              didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.


            var _newChildren = iteratorFn.call(newChildrenIterable);

            if (_newChildren) {
              var knownKeys = null;

              var _step = _newChildren.next();

              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);
          !(newChildren != null) ? invariant(false, 'An iterable object provided no iterator.') : void 0;
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();

          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }

            var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);

            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (!oldFiber) {
                oldFiber = nextOldFiber;
              }

              break;
            }

            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }

            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }

            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }

          if (step.done) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }

          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, expirationTime);

              if (_newFiber3 === null) {
                continue;
              }

              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }

              previousNewFiber = _newFiber3;
            }

            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.


          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);

            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }

              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }

              previousNewFiber = _newFiber4;
            }
          }

          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }

          return resultingFirstChild;
        }

        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
          // There's no need to check for keys on text nodes since we don't have a
          // way to define them.
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            // We already have an existing node so let's just update it and delete
            // the rest.
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber(currentFirstChild, textContent, expirationTime);
            existing.return = returnFiber;
            return existing;
          } // The existing first child is not a text node so we need to create one
          // and delete the existing ones.


          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        }

        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
          var key = element.key;
          var child = currentFirstChild;

          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              if (child.tag === Fragment ? element.type === REACT_FRAGMENT_TYPE : child.elementType === element.type) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, element.type === REACT_FRAGMENT_TYPE ? element.props.children : element.props, expirationTime);
                existing.ref = coerceRef(returnFiber, child, element);
                existing.return = returnFiber;
                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }

            child = child.sibling;
          }

          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
            created.return = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);

            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4.return = returnFiber;
            return _created4;
          }
        }

        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
          var key = portal.key;
          var child = currentFirstChild;

          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, portal.children || [], expirationTime);
                existing.return = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }

            child = child.sibling;
          }

          var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.


        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
          // This function is not recursive.
          // If the top level item is an array, we treat it as a set of children,
          // not as a fragment. Nested arrays on the other hand will be treated as
          // fragment nodes. Recursion happens at the normal flow.
          // Handle top level unkeyed fragments as if they were arrays.
          // This leads to an ambiguity between <>{[...]}</> and <>...</>.
          // We treat the ambiguous cases above the same.
          var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          } // Handle object types


          var isObject = typeof newChild === 'object' && newChild !== null;

          if (isObject) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));

              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
          }

          if (typeof newChild === 'string' || typeof newChild === 'number') {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
          }

          if (isArray(newChild)) {
            return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
          }

          if (getIteratorFn(newChild)) {
            return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
          }

          if (isObject) {
            throwOnInvalidObjectType(returnFiber, newChild);
          }

          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }

          if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
            // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch (returnFiber.tag) {
              case ClassComponent:
                {
                  {
                    var instance = returnFiber.stateNode;

                    if (instance.render._isMockFunction) {
                      // We allow auto-mocks to proceed as if they're returning null.
                      break;
                    }
                  }
                }
              // Intentionally fall through to the next case, which handles both
              // functions and classes
              // eslint-disable-next-lined no-fallthrough

              case FunctionComponent:
                {
                  var Component = returnFiber.type;
                  invariant(false, '%s(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.', Component.displayName || Component.name || 'Component');
                }
            }
          } // Remaining cases are all treated as empty.


          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }

        return reconcileChildFibers;
      }

      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);

      function cloneChildFibers(current$$1, workInProgress) {
        !(current$$1 === null || workInProgress.child === current$$1.child) ? invariant(false, 'Resuming work not yet implemented.') : void 0;

        if (workInProgress.child === null) {
          return;
        }

        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps, currentChild.expirationTime);
        workInProgress.child = newChild;
        newChild.return = workInProgress;

        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps, currentChild.expirationTime);
          newChild.return = workInProgress;
        }

        newChild.sibling = null;
      } // The deepest Fiber on the stack involved in a hydration context.
      // This may have been an insertion or a hydration.


      var hydrationParentFiber = null;
      var nextHydratableInstance = null;
      var isHydrating = false;

      function enterHydrationState(fiber) {
        if (!supportsHydration) {
          return false;
        }

        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
      }

      function deleteHydratableInstance(returnFiber, instance) {
        {
          switch (returnFiber.tag) {
            case HostRoot:
              didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
              break;

            case HostComponent:
              didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
              break;
          }
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.

        if (returnFiber.lastEffect !== null) {
          returnFiber.lastEffect.nextEffect = childToDelete;
          returnFiber.lastEffect = childToDelete;
        } else {
          returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
        }
      }

      function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.effectTag |= Placement;
        {
          switch (returnFiber.tag) {
            case HostRoot:
              {
                var parentContainer = returnFiber.stateNode.containerInfo;

                switch (fiber.tag) {
                  case HostComponent:
                    var type = fiber.type;
                    var props = fiber.pendingProps;
                    didNotFindHydratableContainerInstance(parentContainer, type, props);
                    break;

                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableContainerTextInstance(parentContainer, text);
                    break;
                }

                break;
              }

            case HostComponent:
              {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;

                switch (fiber.tag) {
                  case HostComponent:
                    var _type = fiber.type;
                    var _props = fiber.pendingProps;
                    didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props);
                    break;

                  case HostText:
                    var _text = fiber.pendingProps;
                    didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                    break;
                }

                break;
              }

            default:
              return;
          }
        }
      }

      function tryHydrate(fiber, nextInstance) {
        switch (fiber.tag) {
          case HostComponent:
            {
              var type = fiber.type;
              var props = fiber.pendingProps;
              var instance = canHydrateInstance(nextInstance, type, props);

              if (instance !== null) {
                fiber.stateNode = instance;
                return true;
              }

              return false;
            }

          case HostText:
            {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);

              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                return true;
              }

              return false;
            }

          default:
            return false;
        }
      }

      function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) {
          return;
        }

        var nextInstance = nextHydratableInstance;

        if (!nextInstance) {
          // Nothing to hydrate. Make it an insertion.
          insertNonHydratedInstance(hydrationParentFiber, fiber);
          isHydrating = false;
          hydrationParentFiber = fiber;
          return;
        }

        var firstAttemptedInstance = nextInstance;

        if (!tryHydrate(fiber, nextInstance)) {
          // If we can't hydrate this instance let's try the next one.
          // We use this as a heuristic. It's based on intuition and not data so it
          // might be flawed or unnecessary.
          nextInstance = getNextHydratableSibling(firstAttemptedInstance);

          if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          } // We matched the next one, we'll now assume that the first one was
          // superfluous and we'll delete it. Since we can't eagerly delete it
          // we'll have to schedule a deletion. To do that, this node needs a dummy
          // fiber associated with it.


          deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }

        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
      }

      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        if (!supportsHydration) {
          invariant(false, 'Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.');
        }

        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.

        if (updatePayload !== null) {
          return true;
        }

        return false;
      }

      function prepareToHydrateHostTextInstance(fiber) {
        if (!supportsHydration) {
          invariant(false, 'Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.');
        }

        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        {
          if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;

            if (returnFiber !== null) {
              switch (returnFiber.tag) {
                case HostRoot:
                  {
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                  }

                case HostComponent:
                  {
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
                  }
              }
            }
          }
        }
        return shouldUpdate;
      }

      function popToNextHostParent(fiber) {
        var parent = fiber.return;

        while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot) {
          parent = parent.return;
        }

        hydrationParentFiber = parent;
      }

      function popHydrationState(fiber) {
        if (!supportsHydration) {
          return false;
        }

        if (fiber !== hydrationParentFiber) {
          // We're deeper than the current hydration context, inside an inserted
          // tree.
          return false;
        }

        if (!isHydrating) {
          // If we're not currently hydrating but we're in a hydration context, then
          // we were an insertion and now need to pop up reenter hydration of our
          // siblings.
          popToNextHostParent(fiber);
          isHydrating = true;
          return false;
        }

        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.

        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
          var nextInstance = nextHydratableInstance;

          while (nextInstance) {
            deleteHydratableInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
          }
        }

        popToNextHostParent(fiber);
        nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
      }

      function resetHydrationState() {
        if (!supportsHydration) {
          return;
        }

        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
      }

      var ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner;
      var didWarnAboutBadClass = void 0;
      var didWarnAboutContextTypeOnFunctionComponent = void 0;
      var didWarnAboutGetDerivedStateOnFunctionComponent = void 0;
      var didWarnAboutFunctionRefs = void 0;
      {
        didWarnAboutBadClass = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
      }

      function reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime) {
        if (current$$1 === null) {
          // If this is a fresh new component that hasn't been rendered yet, we
          // won't update its child set by applying minimal side-effects. Instead,
          // we will add them all to the child before it gets rendered. That means
          // we can optimize this reconciliation pass by not tracking side-effects.
          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          // If the current child is the same as the work in progress, it means that
          // we haven't yet started any work on these children. Therefore, we use
          // the clone algorithm to create a copy of all the current children.
          // If we had any progressed work already, that is invalid at this point so
          // let's throw it out.
          workInProgress.child = reconcileChildFibers(workInProgress, current$$1.child, nextChildren, renderExpirationTime);
        }
      }

      function forceUnmountCurrentAndReconcile(current$$1, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current$$1.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their their
        // identity matches.

        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
      }

      function updateForwardRef(current$$1, workInProgress, Component, nextProps, renderExpirationTime) {
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

        var nextChildren = void 0;
        prepareToReadContext(workInProgress, renderExpirationTime);
        prepareToUseHooks(current$$1, workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$2.current = workInProgress;
          setCurrentPhase('render');
          nextChildren = render(nextProps, ref);
          setCurrentPhase(null);
        }
        nextChildren = finishHooks(render, nextProps, nextChildren, ref); // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function updateMemoComponent(current$$1, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current$$1 === null) {
          var type = Component.type;

          if (isSimpleFunctionComponent(type) && Component.compare === null) {
            // If this is a plain function component without default props,
            // and with only the default shallow comparison, we upgrade it
            // to a SimpleMemoComponent to allow fast path updates.
            workInProgress.tag = SimpleMemoComponent;
            workInProgress.type = type;
            return updateSimpleMemoComponent(current$$1, workInProgress, type, nextProps, updateExpirationTime, renderExpirationTime);
          }

          var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
          child.ref = workInProgress.ref;
          child.return = workInProgress;
          workInProgress.child = child;
          return child;
        }

        var currentChild = current$$1.child; // This is always exactly one child

        if (updateExpirationTime < renderExpirationTime) {
          // This will be the props with resolved defaultProps,
          // unlike current.memoizedProps which will be the unresolved ones.
          var prevProps = currentChild.memoizedProps; // Default to shallow comparison

          var compare = Component.compare;
          compare = compare !== null ? compare : shallowEqual;

          if (compare(prevProps, nextProps) && current$$1.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
          }
        } // React DevTools reads this flag.


        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps, renderExpirationTime);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
      }

      function updateSimpleMemoComponent(current$$1, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current$$1 !== null && updateExpirationTime < renderExpirationTime) {
          var prevProps = current$$1.memoizedProps;

          if (shallowEqual(prevProps, nextProps) && current$$1.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
          }
        }

        return updateFunctionComponent(current$$1, workInProgress, Component, nextProps, renderExpirationTime);
      }

      function updateFragment(current$$1, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function updateMode(current$$1, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function updateProfiler(current$$1, workInProgress, renderExpirationTime) {
        {
          workInProgress.effectTag |= Update;
        }
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function markRef(current$$1, workInProgress) {
        var ref = workInProgress.ref;

        if (current$$1 === null && ref !== null || current$$1 !== null && current$$1.ref !== ref) {
          // Schedule a Ref effect
          workInProgress.effectTag |= Ref;
        }
      }

      function updateFunctionComponent(current$$1, workInProgress, Component, nextProps, renderExpirationTime) {
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        var context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren = void 0;
        prepareToReadContext(workInProgress, renderExpirationTime);
        prepareToUseHooks(current$$1, workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$2.current = workInProgress;
          setCurrentPhase('render');
          nextChildren = Component(nextProps, context);
          setCurrentPhase(null);
        }
        nextChildren = finishHooks(Component, nextProps, nextChildren, context); // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function updateClassComponent(current$$1, workInProgress, Component, nextProps, renderExpirationTime) {
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext = void 0;

        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }

        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate = void 0;

        if (instance === null) {
          if (current$$1 !== null) {
            // An class component without an instance only mounts if it suspended
            // inside a non- concurrent tree, in an inconsistent state. We want to
            // tree it like a new mount, even though an empty version of it already
            // committed. Disconnect the alternate pointers.
            current$$1.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.effectTag |= Placement;
          } // In the initial pass we might need to construct the instance.


          constructClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
          mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
          shouldUpdate = true;
        } else if (current$$1 === null) {
          // In a resume, we'll already have an instance we can reuse.
          shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        } else {
          shouldUpdate = updateClassInstance(current$$1, workInProgress, Component, nextProps, renderExpirationTime);
        }

        return finishClassComponent(current$$1, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
      }

      function finishClassComponent(current$$1, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current$$1, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;

        if (!shouldUpdate && !didCaptureError) {
          // Context providers should defer to sCU for rendering
          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, false);
          }

          return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        }

        var instance = workInProgress.stateNode; // Rerender

        ReactCurrentOwner$2.current = workInProgress;
        var nextChildren = void 0;

        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
          // If we captured an error, but getDerivedStateFrom catch is not defined,
          // unmount all the children. componentDidCatch will schedule an update to
          // re-render a fallback. This is temporary until we migrate everyone to
          // the new API.
          // TODO: Warn in a future release.
          nextChildren = null;
          {
            stopProfilerTimerIfRunning(workInProgress);
          }
        } else {
          {
            setCurrentPhase('render');
            nextChildren = instance.render();

            if (workInProgress.mode & StrictMode) {
              instance.render();
            }

            setCurrentPhase(null);
          }
        } // React DevTools reads this flag.


        workInProgress.effectTag |= PerformedWork;

        if (current$$1 !== null && didCaptureError) {
          // If we're recovering from an error, reconcile without reusing any of
          // the existing children. Conceptually, the normal children and the children
          // that are shown on error are two different sets, so we shouldn't reuse
          // normal children even if their identities match.
          forceUnmountCurrentAndReconcile(current$$1, workInProgress, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        } // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.


        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

        if (hasContext) {
          invalidateContextProvider(workInProgress, Component, true);
        }

        return workInProgress.child;
      }

      function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;

        if (root.pendingContext) {
          pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        } else if (root.context) {
          // Should always be set
          pushTopLevelContextObject(workInProgress, root.context, false);
        }

        pushHostContainer(workInProgress, root.containerInfo);
      }

      function updateHostRoot(current$$1, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        !(updateQueue !== null) ? invariant(false, 'If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        processUpdateQueue(workInProgress, updateQueue, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".

        var nextChildren = nextState.element;

        if (nextChildren === prevChildren) {
          // If the state is the same as before, that's a bailout because we had
          // no work that expires at this time.
          resetHydrationState();
          return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
        }

        var root = workInProgress.stateNode;

        if ((current$$1 === null || current$$1.child === null) && root.hydrate && enterHydrationState(workInProgress)) {
          // If we don't have any current children this might be the first pass.
          // We always try to hydrate. If this isn't a hydration pass there won't
          // be any children to hydrate which is effectively the same thing as
          // not hydrating.
          // This is a bit of a hack. We track the host root as a placement to
          // know that we're currently in a mounting state. That way isMounted
          // works as expected. We must reset this before committing.
          // TODO: Delete this when we delete isMounted and findDOMNode.
          workInProgress.effectTag |= Placement; // Ensure that children mount into this root without tracking
          // side-effects. This ensures that we don't store Placement effects on
          // nodes that will be hydrated.

          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          // Otherwise reset hydration state in case we aborted and resumed another
          // root.
          reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
          resetHydrationState();
        }

        return workInProgress.child;
      }

      function updateHostComponent(current$$1, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);

        if (current$$1 === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }

        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current$$1 !== null ? current$$1.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);

        if (isDirectTextChild) {
          // We special case a direct text child of a host node. This is a common
          // case. We won't handle it as a reified child. We will instead handle
          // this in the host environment that also have access to this prop. That
          // avoids allocating another HostText fiber and traversing it.
          nextChildren = null;
        } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
          // If we're switching from a direct text child to a normal child, or to
          // empty, we need to schedule the text content to be reset.
          workInProgress.effectTag |= ContentReset;
        }

        markRef(current$$1, workInProgress); // Check the host config to see if the children are offscreen/hidden.

        if (renderExpirationTime !== Never && workInProgress.mode & ConcurrentMode && shouldDeprioritizeSubtree(type, nextProps)) {
          // Schedule this fiber to re-render at offscreen priority. Then bailout.
          workInProgress.expirationTime = Never;
          return null;
        }

        reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function updateHostText(current$$1, workInProgress) {
        if (current$$1 === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        } // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.


        return null;
      }

      function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
          // An lazy component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }

        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.

        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.

        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child = void 0;

        switch (resolvedTag) {
          case FunctionComponent:
            {
              child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              break;
            }

          case ClassComponent:
            {
              child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              break;
            }

          case ForwardRef:
            {
              child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              break;
            }

          case MemoComponent:
            {
              child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), // The inner type can have defaults too
              updateExpirationTime, renderExpirationTime);
              break;
            }

          default:
            {
              // This message intentionally doesn't mention ForwardRef or MemoComponent
              // because the fact that it's a separate type of work is an
              // implementation detail.
              invariant(false, 'Element type is invalid. Received a promise that resolves to: %s. Promise elements must resolve to a class or function.', Component);
            }
        }

        return child;
      }

      function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
          // An incomplete component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.


        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext = void 0;

        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }

        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
      }

      function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
          // An indeterminate component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }

        var props = workInProgress.pendingProps;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        var context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderExpirationTime);
        prepareToUseHooks(null, workInProgress, renderExpirationTime);
        var value = void 0;
        {
          if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';

            if (!didWarnAboutBadClass[componentName]) {
              warningWithoutStack$1(false, "The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }

          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
          }

          ReactCurrentOwner$2.current = workInProgress;
          value = Component(props, context);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;

        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
          // Proceed under the assumption that this is a class instance
          workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

          resetHooks(); // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.

          var hasContext = false;

          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }

          workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
          var getDerivedStateFromProps = Component.getDerivedStateFromProps;

          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
          }

          adoptClassInstance(workInProgress, value);
          mountClassInstance(workInProgress, Component, props, renderExpirationTime);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
          // Proceed under the assumption that this is a function component
          workInProgress.tag = FunctionComponent;
          value = finishHooks(Component, props, value, context);
          {
            if (Component) {
              !!Component.childContextTypes ? warningWithoutStack$1(false, '%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component') : void 0;
            }

            if (workInProgress.ref !== null) {
              var info = '';
              var ownerName = getCurrentFiberOwnerNameInDevOrNull();

              if (ownerName) {
                info += '\n\nCheck the render method of `' + ownerName + '`.';
              }

              var warningKey = ownerName || workInProgress._debugID || '';
              var debugSource = workInProgress._debugSource;

              if (debugSource) {
                warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
              }

              if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                warning$1(false, 'Function components cannot be given refs. ' + 'Attempts to access this ref will fail.%s', info);
              }
            }

            if (typeof Component.getDerivedStateFromProps === 'function') {
              var _componentName = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName]) {
                warningWithoutStack$1(false, '%s: Function components do not support getDerivedStateFromProps.', _componentName);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName] = true;
              }
            }

            if (typeof Component.contextType === 'object' && Component.contextType !== null) {
              var _componentName2 = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutContextTypeOnFunctionComponent[_componentName2]) {
                warningWithoutStack$1(false, '%s: Function components do not support contextType.', _componentName2);
                didWarnAboutContextTypeOnFunctionComponent[_componentName2] = true;
              }
            }
          }
          reconcileChildren(null, workInProgress, value, renderExpirationTime);
          return workInProgress.child;
        }
      }

      function updateSuspenseComponent(current$$1, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // We should attempt to render the primary children unless this boundary
        // already suspended during this render (`alreadyCaptured` is true).

        var nextState = workInProgress.memoizedState;
        var nextDidTimeout = void 0;

        if ((workInProgress.effectTag & DidCapture) === NoEffect) {
          // This is the first attempt.
          nextState = null;
          nextDidTimeout = false;
        } else {
          // Something in this boundary's subtree already suspended. Switch to
          // rendering the fallback children.
          nextState = {
            timedOutAt: nextState !== null ? nextState.timedOutAt : NoWork
          };
          nextDidTimeout = true;
          workInProgress.effectTag &= ~DidCapture;
        } // This next part is a bit confusing. If the children timeout, we switch to
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.
        // `child` points to the child fiber. In the normal case, this is the first
        // fiber of the primary children set. In the timed-out case, it's a
        // a fragment fiber containing the primary children.


        var child = void 0; // `next` points to the next fiber React should render. In the normal case,
        // it's the same as `child`: the first fiber of the primary children set.
        // In the timed-out case, it's a fragment fiber containing the *fallback*
        // children -- we skip over the primary children entirely.

        var next = void 0;

        if (current$$1 === null) {
          // This is the initial mount. This branch is pretty simple because there's
          // no previous state that needs to be preserved.
          if (nextDidTimeout) {
            // Mount separate fragments for primary and fallback children.
            var nextFallbackChildren = nextProps.fallback;
            var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);

            if ((workInProgress.mode & ConcurrentMode) === NoContext) {
              // Outside of concurrent mode, we commit the effects from the
              var progressedState = workInProgress.memoizedState;
              var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
              primaryChildFragment.child = progressedPrimaryChild;
            }

            var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
            primaryChildFragment.sibling = fallbackChildFragment;
            child = primaryChildFragment; // Skip the primary children, and continue working on the
            // fallback children.

            next = fallbackChildFragment;
            child.return = next.return = workInProgress;
          } else {
            // Mount the primary children without an intermediate fragment fiber.
            var nextPrimaryChildren = nextProps.children;
            child = next = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
          }
        } else {
          // This is an update. This branch is more complicated because we need to
          // ensure the state of the primary children is preserved.
          var prevState = current$$1.memoizedState;
          var prevDidTimeout = prevState !== null;

          if (prevDidTimeout) {
            // The current tree already timed out. That means each child set is
            var currentPrimaryChildFragment = current$$1.child;
            var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;

            if (nextDidTimeout) {
              // Still timed out. Reuse the current primary children by cloning
              // its fragment. We're going to skip over these entirely.
              var _nextFallbackChildren = nextProps.fallback;

              var _primaryChildFragment = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps, NoWork);

              if ((workInProgress.mode & ConcurrentMode) === NoContext) {
                // Outside of concurrent mode, we commit the effects from the
                var _progressedState = workInProgress.memoizedState;

                var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;

                if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                  _primaryChildFragment.child = _progressedPrimaryChild;
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.


              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var treeBaseDuration = 0;
                var hiddenChild = _primaryChildFragment.child;

                while (hiddenChild !== null) {
                  treeBaseDuration += hiddenChild.treeBaseDuration;
                  hiddenChild = hiddenChild.sibling;
                }

                _primaryChildFragment.treeBaseDuration = treeBaseDuration;
              } // Clone the fallback child fragment, too. These we'll continue
              // working on.


              var _fallbackChildFragment = _primaryChildFragment.sibling = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren, currentFallbackChildFragment.expirationTime);

              child = _primaryChildFragment;
              _primaryChildFragment.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              next = _fallbackChildFragment;
              child.return = next.return = workInProgress;
            } else {
              // No longer suspended. Switch back to showing the primary children,
              // and remove the intermediate fragment fiber.
              var _nextPrimaryChildren = nextProps.children;
              var currentPrimaryChild = currentPrimaryChildFragment.child;
              var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
              // children. Wait until the complete phase, after we've confirmed the
              // fallback is no longer needed.
              // TODO: Would it be better to store the fallback fragment on
              // the stateNode?
              // Continue rendering the children, like we normally do.

              child = next = primaryChild;
            }
          } else {
            // The current tree has not already timed out. That means the primary
            // children are not wrapped in a fragment fiber.
            var _currentPrimaryChild = current$$1.child;

            if (nextDidTimeout) {
              // Timed out. Wrap the children in a fragment fiber to keep them
              // separate from the fallback children.
              var _nextFallbackChildren2 = nextProps.fallback;

              var _primaryChildFragment2 = createFiberFromFragment( // It shouldn't matter what the pending props are because we aren't
              // going to render this fragment.
              null, mode, NoWork, null);

              _primaryChildFragment2.child = _currentPrimaryChild; // Even though we're creating a new fiber, there are no new children,
              // because we're reusing an already mounted tree. So we don't need to
              // schedule a placement.
              // primaryChildFragment.effectTag |= Placement;

              if ((workInProgress.mode & ConcurrentMode) === NoContext) {
                // Outside of concurrent mode, we commit the effects from the
                var _progressedState2 = workInProgress.memoizedState;

                var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;

                _primaryChildFragment2.child = _progressedPrimaryChild2;
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.


              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration = 0;
                var _hiddenChild = _primaryChildFragment2.child;

                while (_hiddenChild !== null) {
                  _treeBaseDuration += _hiddenChild.treeBaseDuration;
                  _hiddenChild = _hiddenChild.sibling;
                }

                _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
              } // Create a fragment from the fallback children, too.


              var _fallbackChildFragment2 = _primaryChildFragment2.sibling = createFiberFromFragment(_nextFallbackChildren2, mode, renderExpirationTime, null);

              _fallbackChildFragment2.effectTag |= Placement;
              child = _primaryChildFragment2;
              _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              next = _fallbackChildFragment2;
              child.return = next.return = workInProgress;
            } else {
              // Still haven't timed out.  Continue rendering the children, like we
              // normally do.
              var _nextPrimaryChildren2 = nextProps.children;
              next = child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
            }
          }
        }

        workInProgress.memoizedState = nextState;
        workInProgress.child = child;
        return next;
      }

      function updatePortalComponent(current$$1, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;

        if (current$$1 === null) {
          // Portals are special because we don't append the children during mount
          // but at commit. Therefore we need to track insertions which the normal
          // flow doesn't do during mount. This doesn't happen at the root because
          // the root always starts with a "current" with a null child.
          // TODO: Consider unifying this with how the root works.
          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current$$1, workInProgress, nextChildren, renderExpirationTime);
        }

        return workInProgress.child;
      }

      function updateContextProvider(current$$1, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        {
          var providerPropTypes = workInProgress.type.propTypes;

          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackInDev);
          }
        }
        pushProvider(workInProgress, newValue);

        if (oldProps !== null) {
          var oldValue = oldProps.value;
          var changedBits = calculateChangedBits(context, newValue, oldValue);

          if (changedBits === 0) {
            // No change. Bailout early if children are the same.
            if (oldProps.children === newProps.children && !hasContextChanged()) {
              return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
            }
          } else {
            // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
          }
        }

        var newChildren = newProps.children;
        reconcileChildren(current$$1, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }

      var hasWarnedAboutUsingContextAsConsumer = false;

      function updateContextConsumer(current$$1, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        // DEV mode, we create a separate object for Context.Consumer that acts
        // like a proxy to Context. This proxy object adds unnecessary code in PROD
        // so we use the old behaviour (Context.Consumer references Context) to
        // reduce size and overhead. The separate object references context via
        // a property called "_context", which also gives us the ability to check
        // in DEV mode if this property exists or not and warn if it does not.

        {
          if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                warning$1(false, 'Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
              }
            }
          } else {
            context = context._context;
          }
        }
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        {
          !(typeof render === 'function') ? warningWithoutStack$1(false, 'A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.') : void 0;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren = void 0;
        {
          ReactCurrentOwner$2.current = workInProgress;
          setCurrentPhase('render');
          newChildren = render(newValue);
          setCurrentPhase(null);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current$$1, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }

      function bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);

        if (current$$1 !== null) {
          // Reuse previous context list
          workInProgress.firstContextDependency = current$$1.firstContextDependency;
        }

        {
          // Don't update "base" render times for bailouts.
          stopProfilerTimerIfRunning(workInProgress);
        } // Check if the children have any pending work.

        var childExpirationTime = workInProgress.childExpirationTime;

        if (childExpirationTime < renderExpirationTime) {
          // The children don't have any work either. We can skip them.
          // TODO: Once we add back resuming, we should check if the children are
          // a work-in-progress set. If so, we need to transfer their effects.
          return null;
        } else {
          // This fiber doesn't have work, but its subtree does. Clone the child
          // fibers and continue.
          cloneChildFibers(current$$1, workInProgress);
          return workInProgress.child;
        }
      }

      function beginWork(current$$1, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;

        if (current$$1 !== null) {
          var oldProps = current$$1.memoizedProps;
          var newProps = workInProgress.pendingProps;

          if (oldProps === newProps && !hasContextChanged() && updateExpirationTime < renderExpirationTime) {
            // This fiber does not have any pending work. Bailout without entering
            // the begin phase. There's still some bookkeeping we that needs to be done
            // in this optimized path, mostly pushing stuff onto the stack.
            switch (workInProgress.tag) {
              case HostRoot:
                pushHostRootContext(workInProgress);
                resetHydrationState();
                break;

              case HostComponent:
                pushHostContext(workInProgress);
                break;

              case ClassComponent:
                {
                  var Component = workInProgress.type;

                  if (isContextProvider(Component)) {
                    pushContextProvider(workInProgress);
                  }

                  break;
                }

              case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;

              case ContextProvider:
                {
                  var newValue = workInProgress.memoizedProps.value;
                  pushProvider(workInProgress, newValue);
                  break;
                }

              case Profiler:
                {
                  workInProgress.effectTag |= Update;
                }
                break;

              case SuspenseComponent:
                {
                  var state = workInProgress.memoizedState;
                  var didTimeout = state !== null;

                  if (didTimeout) {
                    // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;

                    if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) {
                      // The primary children have pending work. Use the normal path
                      // to attempt to render the primary children again.
                      return updateSuspenseComponent(current$$1, workInProgress, renderExpirationTime);
                    } else {
                      // The primary children do not have pending work with sufficient
                      // priority. Bailout.
                      var child = bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);

                      if (child !== null) {
                        // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  }

                  break;
                }
            }

            return bailoutOnAlreadyFinishedWork(current$$1, workInProgress, renderExpirationTime);
          }
        } // Before entering the begin phase, clear the expiration time.


        workInProgress.expirationTime = NoWork;

        switch (workInProgress.tag) {
          case IndeterminateComponent:
            {
              var elementType = workInProgress.elementType;
              return mountIndeterminateComponent(current$$1, workInProgress, elementType, renderExpirationTime);
            }

          case LazyComponent:
            {
              var _elementType = workInProgress.elementType;
              return mountLazyComponent(current$$1, workInProgress, _elementType, updateExpirationTime, renderExpirationTime);
            }

          case FunctionComponent:
            {
              var _Component = workInProgress.type;
              var unresolvedProps = workInProgress.pendingProps;
              var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current$$1, workInProgress, _Component, resolvedProps, renderExpirationTime);
            }

          case ClassComponent:
            {
              var _Component2 = workInProgress.type;
              var _unresolvedProps = workInProgress.pendingProps;

              var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);

              return updateClassComponent(current$$1, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            }

          case HostRoot:
            return updateHostRoot(current$$1, workInProgress, renderExpirationTime);

          case HostComponent:
            return updateHostComponent(current$$1, workInProgress, renderExpirationTime);

          case HostText:
            return updateHostText(current$$1, workInProgress);

          case SuspenseComponent:
            return updateSuspenseComponent(current$$1, workInProgress, renderExpirationTime);

          case HostPortal:
            return updatePortalComponent(current$$1, workInProgress, renderExpirationTime);

          case ForwardRef:
            {
              var type = workInProgress.type;
              var _unresolvedProps2 = workInProgress.pendingProps;

              var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

              return updateForwardRef(current$$1, workInProgress, type, _resolvedProps2, renderExpirationTime);
            }

          case Fragment:
            return updateFragment(current$$1, workInProgress, renderExpirationTime);

          case Mode:
            return updateMode(current$$1, workInProgress, renderExpirationTime);

          case Profiler:
            return updateProfiler(current$$1, workInProgress, renderExpirationTime);

          case ContextProvider:
            return updateContextProvider(current$$1, workInProgress, renderExpirationTime);

          case ContextConsumer:
            return updateContextConsumer(current$$1, workInProgress, renderExpirationTime);

          case MemoComponent:
            {
              var _type = workInProgress.type;
              var _unresolvedProps3 = workInProgress.pendingProps;

              var _resolvedProps3 = resolveDefaultProps(_type.type, _unresolvedProps3);

              return updateMemoComponent(current$$1, workInProgress, _type, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            }

          case SimpleMemoComponent:
            {
              return updateSimpleMemoComponent(current$$1, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            }

          case IncompleteClassComponent:
            {
              var _Component3 = workInProgress.type;
              var _unresolvedProps4 = workInProgress.pendingProps;

              var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);

              return mountIncompleteClassComponent(current$$1, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            }

          default:
            invariant(false, 'Unknown unit of work tag. This error is likely caused by a bug in React. Please file an issue.');
        }
      }

      function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
      }

      function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
      }

      var _appendAllChildren = void 0;

      var updateHostContainer = void 0;
      var updateHostComponent$1 = void 0;
      var updateHostText$1 = void 0;

      if (supportsMutation) {
        // Mutation mode
        _appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;

          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) ;else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        };

        updateHostContainer = function updateHostContainer(workInProgress) {// Noop
        };

        updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
          // If we have an alternate, that means this is an update and we need to
          // schedule a side-effect to do the updates.
          var oldProps = current.memoizedProps;

          if (oldProps === newProps) {
            // In mutation mode, this is sufficient for a bailout because
            // we won't touch this node even if children changed.
            return;
          } // If we get updated because one of our children updated, we don't
          // have newProps so we'll have to reuse them.
          // TODO: Split the update API as separate for the props vs. children.
          // Even better would be if children weren't special cased at all tho.


          var instance = workInProgress.stateNode;
          var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
          // component is hitting the resume path. Figure out why. Possibly
          // related to `hidden`.

          var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

          workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
          // is a new ref we mark this as an update. All the work is done in commitWork.

          if (updatePayload) {
            markUpdate(workInProgress);
          }
        };

        updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
          // If the text differs, mark it as an update. All the work in done in commitWork.
          if (oldText !== newText) {
            markUpdate(workInProgress);
          }
        };
      } else if (supportsPersistence) {
        // Persistent host tree mode
        _appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;

          while (node !== null) {
            // eslint-disable-next-line no-labels
            branches: if (node.tag === HostComponent) {
              var instance = node.stateNode;

              if (needsVisibilityToggle) {
                var props = node.memoizedProps;
                var type = node.type;

                if (isHidden) {
                  // This child is inside a timed out tree. Hide it.
                  instance = cloneHiddenInstance(instance, type, props, node);
                } else {
                  // This child was previously inside a timed out tree. If it was not
                  // updated during this render, it may need to be unhidden. Clone
                  // again to be sure.
                  instance = cloneUnhiddenInstance(instance, type, props, node);
                }

                node.stateNode = instance;
              }

              appendInitialChild(parent, instance);
            } else if (node.tag === HostText) {
              var _instance = node.stateNode;

              if (needsVisibilityToggle) {
                var text = node.memoizedProps;
                var rootContainerInstance = getRootHostContainer();
                var currentHostContext = getHostContext();

                if (isHidden) {
                  _instance = createHiddenTextInstance(text, rootContainerInstance, currentHostContext, workInProgress);
                } else {
                  _instance = createTextInstance(text, rootContainerInstance, currentHostContext, workInProgress);
                }

                node.stateNode = _instance;
              }

              appendInitialChild(parent, _instance);
            } else if (node.tag === HostPortal) ;else if (node.tag === SuspenseComponent) {
              var current = node.alternate;

              if (current !== null) {
                var oldState = current.memoizedState;
                var newState = node.memoizedState;
                var oldIsHidden = oldState !== null;
                var newIsHidden = newState !== null;

                if (oldIsHidden !== newIsHidden) {
                  // The placeholder either just timed out or switched back to the normal
                  // children after having previously timed out. Toggle the visibility of
                  // the direct host children.
                  var primaryChildParent = newIsHidden ? node.child : node;

                  if (primaryChildParent !== null) {
                    _appendAllChildren(parent, primaryChildParent, true, newIsHidden);
                  } // eslint-disable-next-line no-labels


                  break branches;
                }
              }

              if (node.child !== null) {
                // Continue traversing like normal
                node.child.return = node;
                node = node.child;
                continue;
              }
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            } // $FlowFixMe This is correct but Flow is confused by the labeled break.


            node = node;

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }; // An unfortunate fork of appendAllChildren because we have two different parent types.


        var appendAllChildrenToContainer = function appendAllChildrenToContainer(containerChildSet, workInProgress, needsVisibilityToggle, isHidden) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;

          while (node !== null) {
            // eslint-disable-next-line no-labels
            branches: if (node.tag === HostComponent) {
              var instance = node.stateNode;

              if (needsVisibilityToggle) {
                var props = node.memoizedProps;
                var type = node.type;

                if (isHidden) {
                  // This child is inside a timed out tree. Hide it.
                  instance = cloneHiddenInstance(instance, type, props, node);
                } else {
                  // This child was previously inside a timed out tree. If it was not
                  // updated during this render, it may need to be unhidden. Clone
                  // again to be sure.
                  instance = cloneUnhiddenInstance(instance, type, props, node);
                }

                node.stateNode = instance;
              }

              appendChildToContainerChildSet(containerChildSet, instance);
            } else if (node.tag === HostText) {
              var _instance2 = node.stateNode;

              if (needsVisibilityToggle) {
                var text = node.memoizedProps;
                var rootContainerInstance = getRootHostContainer();
                var currentHostContext = getHostContext();

                if (isHidden) {
                  _instance2 = createHiddenTextInstance(text, rootContainerInstance, currentHostContext, workInProgress);
                } else {
                  _instance2 = createTextInstance(text, rootContainerInstance, currentHostContext, workInProgress);
                }

                node.stateNode = _instance2;
              }

              appendChildToContainerChildSet(containerChildSet, _instance2);
            } else if (node.tag === HostPortal) ;else if (node.tag === SuspenseComponent) {
              var current = node.alternate;

              if (current !== null) {
                var oldState = current.memoizedState;
                var newState = node.memoizedState;
                var oldIsHidden = oldState !== null;
                var newIsHidden = newState !== null;

                if (oldIsHidden !== newIsHidden) {
                  // The placeholder either just timed out or switched back to the normal
                  // children after having previously timed out. Toggle the visibility of
                  // the direct host children.
                  var primaryChildParent = newIsHidden ? node.child : node;

                  if (primaryChildParent !== null) {
                    appendAllChildrenToContainer(containerChildSet, primaryChildParent, true, newIsHidden);
                  } // eslint-disable-next-line no-labels


                  break branches;
                }
              }

              if (node.child !== null) {
                // Continue traversing like normal
                node.child.return = node;
                node = node.child;
                continue;
              }
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            } // $FlowFixMe This is correct but Flow is confused by the labeled break.


            node = node;

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        };

        updateHostContainer = function updateHostContainer(workInProgress) {
          var portalOrRoot = workInProgress.stateNode;
          var childrenUnchanged = workInProgress.firstEffect === null;
          if (childrenUnchanged) ;else {
            var container = portalOrRoot.containerInfo;
            var newChildSet = createContainerChildSet(container); // If children might have changed, we have to add them all to the set.

            appendAllChildrenToContainer(newChildSet, workInProgress, false, false);
            portalOrRoot.pendingChildren = newChildSet; // Schedule an update on the container to swap out the container.

            markUpdate(workInProgress);
            finalizeContainerChildren(container, newChildSet);
          }
        };

        updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
          var currentInstance = current.stateNode;
          var oldProps = current.memoizedProps; // If there are no effects associated with this node, then none of our children had any updates.
          // This guarantees that we can reuse all of them.

          var childrenUnchanged = workInProgress.firstEffect === null;

          if (childrenUnchanged && oldProps === newProps) {
            // No changes, just reuse the existing instance.
            // Note that this might release a previous clone.
            workInProgress.stateNode = currentInstance;
            return;
          }

          var recyclableInstance = workInProgress.stateNode;
          var currentHostContext = getHostContext();
          var updatePayload = null;

          if (oldProps !== newProps) {
            updatePayload = prepareUpdate(recyclableInstance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
          }

          if (childrenUnchanged && updatePayload === null) {
            // No changes, just reuse the existing instance.
            // Note that this might release a previous clone.
            workInProgress.stateNode = currentInstance;
            return;
          }

          var newInstance = cloneInstance(currentInstance, updatePayload, type, oldProps, newProps, workInProgress, childrenUnchanged, recyclableInstance);

          if (finalizeInitialChildren(newInstance, type, newProps, rootContainerInstance, currentHostContext)) {
            markUpdate(workInProgress);
          }

          workInProgress.stateNode = newInstance;

          if (childrenUnchanged) {
            // If there are no other effects in this tree, we need to flag this node as having one.
            // Even though we're not going to use it for anything.
            // Otherwise parents won't know that there are new children to propagate upwards.
            markUpdate(workInProgress);
          } else {
            // If children might have changed, we have to add them all to the set.
            _appendAllChildren(newInstance, workInProgress, false, false);
          }
        };

        updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
          if (oldText !== newText) {
            // If the text content differs, we'll create a new text instance for it.
            var rootContainerInstance = getRootHostContainer();
            var currentHostContext = getHostContext();
            workInProgress.stateNode = createTextInstance(newText, rootContainerInstance, currentHostContext, workInProgress); // We'll have to mark it as having an effect, even though we won't use the effect for anything.
            // This lets the parents know that at least one of their children has changed.

            markUpdate(workInProgress);
          }
        };
      } else {
        // No host operations
        updateHostContainer = function updateHostContainer(workInProgress) {// Noop
        };

        updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {// Noop
        };

        updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {// Noop
        };
      }

      function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;

        switch (workInProgress.tag) {
          case IndeterminateComponent:
            break;

          case LazyComponent:
            break;

          case SimpleMemoComponent:
          case FunctionComponent:
            break;

          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }

              break;
            }

          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var fiberRoot = workInProgress.stateNode;

              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }

              if (current === null || current.child === null) {
                // If we hydrated, pop so that we can delete any remaining children
                // that weren't hydrated.
                popHydrationState(workInProgress); // This resets the hacky state to fix isMounted before committing.
                // TODO: Delete this when we delete isMounted and findDOMNode.

                workInProgress.effectTag &= ~Placement;
              }

              updateHostContainer(workInProgress);
              break;
            }

          case HostComponent:
            {
              popHostContext(workInProgress);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress.type;

              if (current !== null && workInProgress.stateNode != null) {
                updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);

                if (current.ref !== workInProgress.ref) {
                  markRef$1(workInProgress);
                }
              } else {
                if (!newProps) {
                  !(workInProgress.stateNode !== null) ? invariant(false, 'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.') : void 0; // This can happen when we abort work.

                  break;
                }

                var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                // "stack" as the parent. Then append children as we go in beginWork
                // or completeWork depending on we want to add then top->down or
                // bottom->up. Top->down is faster in IE11.

                var wasHydrated = popHydrationState(workInProgress);

                if (wasHydrated) {
                  // TODO: Move this and createInstance step into the beginPhase
                  // to consolidate.
                  if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                    // If changes to the hydrated node needs to be applied at the
                    // commit-phase we mark this as such.
                    markUpdate(workInProgress);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);

                  _appendAllChildren(instance, workInProgress, false, false); // Certain renderers require commit-time effects for initial mount.
                  // (eg DOM renderer supports auto-focus for certain elements).
                  // Make sure such renderers get scheduled for later work.


                  if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance, currentHostContext)) {
                    markUpdate(workInProgress);
                  }

                  workInProgress.stateNode = instance;
                }

                if (workInProgress.ref !== null) {
                  // If there is a ref on a host node we need to schedule a callback
                  markRef$1(workInProgress);
                }
              }

              break;
            }

          case HostText:
            {
              var newText = newProps;

              if (current && workInProgress.stateNode != null) {
                var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                // to schedule a side-effect to do the updates.

                updateHostText$1(current, workInProgress, oldText, newText);
              } else {
                if (typeof newText !== 'string') {
                  !(workInProgress.stateNode !== null) ? invariant(false, 'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.') : void 0; // This can happen when we abort work.
                }

                var _rootContainerInstance = getRootHostContainer();

                var _currentHostContext = getHostContext();

                var _wasHydrated = popHydrationState(workInProgress);

                if (_wasHydrated) {
                  if (prepareToHydrateHostTextInstance(workInProgress)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
              }

              break;
            }

          case ForwardRef:
            break;

          case SuspenseComponent:
            {
              var nextState = workInProgress.memoizedState;

              if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                // Something suspended. Re-render with the fallback children.
                workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.

                return workInProgress;
              }

              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = current !== null && current.memoizedState !== null;

              if (current !== null && !nextDidTimeout && prevDidTimeout) {
                // We just switched from the fallback to the normal children. Delete
                // the fallback.
                // TODO: Would it be better to store the fallback fragment on
                var currentFallbackChild = current.child.sibling;

                if (currentFallbackChild !== null) {
                  // Deletions go at the beginning of the return fiber's effect list
                  var first = workInProgress.firstEffect;

                  if (first !== null) {
                    workInProgress.firstEffect = currentFallbackChild;
                    currentFallbackChild.nextEffect = first;
                  } else {
                    workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                    currentFallbackChild.nextEffect = null;
                  }

                  currentFallbackChild.effectTag = Deletion;
                }
              } // The children either timed out after previously being visible, or
              // were restored after previously being hidden. Schedule an effect
              // to update their visiblity.


              if ( //
              nextDidTimeout !== prevDidTimeout || // Outside concurrent mode, the primary children commit in an
              // inconsistent state, even if they are hidden. So if they are hidden,
              // we need to schedule an effect to re-hide them, just in case.
              (workInProgress.effectTag & ConcurrentMode) === NoContext && nextDidTimeout) {
                workInProgress.effectTag |= Update;
              }

              break;
            }

          case Fragment:
            break;

          case Mode:
            break;

          case Profiler:
            break;

          case HostPortal:
            popHostContainer(workInProgress);
            updateHostContainer(workInProgress);
            break;

          case ContextProvider:
            // Pop provider fiber
            popProvider(workInProgress);
            break;

          case ContextConsumer:
            break;

          case MemoComponent:
            break;

          case IncompleteClassComponent:
            {
              // Same as class component case. I put it down here so that the tags are
              // sequential to ensure this switch is compiled to a jump table.
              var _Component = workInProgress.type;

              if (isContextProvider(_Component)) {
                popContext(workInProgress);
              }

              break;
            }

          default:
            invariant(false, 'Unknown unit of work tag. This error is likely caused by a bug in React. Please file an issue.');
        }

        return null;
      }

      function shouldCaptureSuspense(current, workInProgress) {
        // In order to capture, the Suspense component must have a fallback prop.
        if (workInProgress.memoizedProps.fallback === undefined) {
          return false;
        } // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.


        var nextState = workInProgress.memoizedState;
        return nextState === null;
      }

      function logCapturedError(capturedError) {
        var error = capturedError.error;
        {
          var componentName = capturedError.componentName,
              componentStack = capturedError.componentStack,
              errorBoundaryName = capturedError.errorBoundaryName,
              errorBoundaryFound = capturedError.errorBoundaryFound,
              willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
          // `preventDefault()` in window `error` handler.
          // We record this information as an expando on the error.

          if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) {
              // The error is recoverable and was silenced.
              // Ignore it and don't print the stack addendum.
              // This is handy for testing error boundaries without noise.
              return;
            } // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.


            console.error(error); // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
          }

          var componentNameMessage = componentName ? 'The above error occurred in the <' + componentName + '> component:' : 'The above error occurred in one of your React components:';
          var errorBoundaryMessage = void 0; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.

          if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) {
              errorBoundaryMessage = 'React will try to recreate this component tree from scratch ' + ('using the error boundary you provided, ' + errorBoundaryName + '.');
            } else {
              errorBoundaryMessage = 'This error was initially handled by the error boundary ' + errorBoundaryName + '.\n' + 'Recreating the tree from scratch failed so React will unmount the tree.';
            }
          } else {
            errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://fb.me/react-error-boundaries to learn more about error boundaries.';
          }

          var combinedMessage = '' + componentNameMessage + componentStack + '\n\n' + ('' + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
          // We don't include the original error message and JS stack because the browser
          // has already printed it. Even if the application swallows the error, it is still
          // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

          console.error(combinedMessage);
        }
      }

      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
      }

      function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;

        if (stack === null && source !== null) {
          stack = getStackByFiberInDevAndProd(source);
        }

        var capturedError = {
          componentName: source !== null ? getComponentName(source.type) : null,
          componentStack: stack !== null ? stack : '',
          error: errorInfo.value,
          errorBoundary: null,
          errorBoundaryName: null,
          errorBoundaryFound: false,
          willRetry: false
        };

        if (boundary !== null && boundary.tag === ClassComponent) {
          capturedError.errorBoundary = boundary.stateNode;
          capturedError.errorBoundaryName = getComponentName(boundary.type);
          capturedError.errorBoundaryFound = true;
          capturedError.willRetry = true;
        }

        try {
          logCapturedError(capturedError);
        } catch (e) {
          // This method must not throw, or React internal state will get messed up.
          // If console.error is overridden, or logCapturedError() shows a dialog that throws,
          // we want to report this error outside of the normal stack as a last resort.
          // https://github.com/facebook/react/issues/13188
          setTimeout(function () {
            throw e;
          });
        }
      }

      var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current$$1, instance) {
        startPhaseTimer(current$$1, 'componentWillUnmount');
        instance.props = current$$1.memoizedProps;
        instance.state = current$$1.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
      }; // Capture errors so they don't interrupt unmounting.


      function safelyCallComponentWillUnmount(current$$1, instance) {
        {
          invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current$$1, instance);

          if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current$$1, unmountError);
          }
        }
      }

      function safelyDetachRef(current$$1) {
        var ref = current$$1.ref;

        if (ref !== null) {
          if (typeof ref === 'function') {
            {
              invokeGuardedCallback(null, ref, null, null);

              if (hasCaughtError()) {
                var refError = clearCaughtError();
                captureCommitPhaseError(current$$1, refError);
              }
            }
          } else {
            ref.current = null;
          }
        }
      }

      function safelyCallDestroy(current$$1, destroy) {
        {
          invokeGuardedCallback(null, destroy, null);

          if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current$$1, error);
          }
        }
      }

      function commitBeforeMutationLifeCycles(current$$1, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              commitHookEffectList(UnmountSnapshot, NoEffect$1, finishedWork);
              return;
            }

          case ClassComponent:
            {
              if (finishedWork.effectTag & Snapshot) {
                if (current$$1 !== null) {
                  var prevProps = current$$1.memoizedProps;
                  var prevState = current$$1.memoizedState;
                  startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                  var instance = finishedWork.stateNode; // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType) {
                      !(instance.props === finishedWork.memoizedProps) ? warning$1(false, 'Expected instance props to match memoized props before ' + 'getSnapshotBeforeUpdate. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                      !(instance.state === finishedWork.memoizedState) ? warning$1(false, 'Expected instance state to match memoized state before ' + 'getSnapshotBeforeUpdate. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

                    if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      warningWithoutStack$1(false, '%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                  stopPhaseTimer();
                }
              }

              return;
            }

          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case IncompleteClassComponent:
            // Nothing to do for these component types
            return;

          default:
            {
              invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
            }
        }
      }

      function commitHookEffectList(unmountTag, mountTag, finishedWork) {
        {
          return;
        }
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;

          do {
            if ((effect.tag & unmountTag) !== NoEffect$1) {
              // Unmount
              var destroy = effect.destroy;
              effect.destroy = null;

              if (destroy !== null) {
                destroy();
              }
            }

            if ((effect.tag & mountTag) !== NoEffect$1) {
              // Mount
              var create = effect.create;

              var _destroy = create();

              if (typeof _destroy !== 'function') {
                {
                  if (_destroy !== null && _destroy !== undefined) {
                    warningWithoutStack$1(false, 'useEffect function must return a cleanup function or ' + 'nothing.%s%s', typeof _destroy.then === 'function' ? ' Promises and useEffect(async () => ...) are not ' + 'supported, but you can call an async function inside an ' + 'effect.' : '', getStackByFiberInDevAndProd(finishedWork));
                  }
                }
                _destroy = null;
              }

              effect.destroy = _destroy;
            }

            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }

      function commitLifeCycles(finishedRoot, current$$1, finishedWork, committedExpirationTime) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
            {
              commitHookEffectList(UnmountLayout, MountLayout, finishedWork);
              break;
            }

          case ClassComponent:
            {
              var instance = finishedWork.stateNode;

              if (finishedWork.effectTag & Update) {
                if (current$$1 === null) {
                  startPhaseTimer(finishedWork, 'componentDidMount'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType) {
                      !(instance.props === finishedWork.memoizedProps) ? warning$1(false, 'Expected instance props to match memoized props before ' + 'componentDidMount. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                      !(instance.state === finishedWork.memoizedState) ? warning$1(false, 'Expected instance state to match memoized state before ' + 'componentDidMount. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                    }
                  }
                  instance.componentDidMount();
                  stopPhaseTimer();
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current$$1.memoizedProps : resolveDefaultProps(finishedWork.type, current$$1.memoizedProps);
                  var prevState = current$$1.memoizedState;
                  startPhaseTimer(finishedWork, 'componentDidUpdate'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType) {
                      !(instance.props === finishedWork.memoizedProps) ? warning$1(false, 'Expected instance props to match memoized props before ' + 'componentDidUpdate. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                      !(instance.state === finishedWork.memoizedState) ? warning$1(false, 'Expected instance state to match memoized state before ' + 'componentDidUpdate. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                    }
                  }
                  instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  stopPhaseTimer();
                }
              }

              var updateQueue = finishedWork.updateQueue;

              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType) {
                    !(instance.props === finishedWork.memoizedProps) ? warning$1(false, 'Expected instance props to match memoized props before ' + 'processing the update queue. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                    !(instance.state === finishedWork.memoizedState) ? warning$1(false, 'Expected instance state to match memoized state before ' + 'processing the update queue. This is likely due to a bug in React. ' + 'Please file an issue.') : void 0;
                  }
                } // We could update instance props and state here,
                // but instead we rely on them being set during last render.
                // TODO: revisit this when we implement resuming.

                commitUpdateQueue(finishedWork, updateQueue, instance, committedExpirationTime);
              }

              return;
            }

          case HostRoot:
            {
              var _updateQueue = finishedWork.updateQueue;

              if (_updateQueue !== null) {
                var _instance = null;

                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;

                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }

                commitUpdateQueue(finishedWork, _updateQueue, _instance, committedExpirationTime);
              }

              return;
            }

          case HostComponent:
            {
              var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
              // (eg DOM renderer may schedule auto-focus for inputs and form controls).
              // These effects should only be committed when components are first mounted,
              // aka when there is no current/alternate.

              if (current$$1 === null && finishedWork.effectTag & Update) {
                var type = finishedWork.type;
                var props = finishedWork.memoizedProps;
                commitMount(_instance2, type, props, finishedWork);
              }

              return;
            }

          case HostText:
            {
              // We have no life-cycles associated with text.
              return;
            }

          case HostPortal:
            {
              // We have no life-cycles associated with portals.
              return;
            }

          case Profiler:
            {
              {
                var onRender = finishedWork.memoizedProps.onRender;
                {
                  onRender(finishedWork.memoizedProps.id, current$$1 === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                }
              }
              return;
            }

          case SuspenseComponent:
            break;

          case IncompleteClassComponent:
            break;

          default:
            {
              invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
            }
        }
      }

      function hideOrUnhideAllChildren(finishedWork, isHidden) {
        if (supportsMutation) {
          // We only have the top Fiber that was inserted but we need recurse down its
          var node = finishedWork;

          while (true) {
            if (node.tag === HostComponent) {
              var instance = node.stateNode;

              if (isHidden) {
                hideInstance(instance);
              } else {
                unhideInstance(node.stateNode, node.memoizedProps);
              }
            } else if (node.tag === HostText) {
              var _instance3 = node.stateNode;

              if (isHidden) {
                hideTextInstance(_instance3);
              } else {
                unhideTextInstance(_instance3, node.memoizedProps);
              }
            } else if (node.tag === SuspenseComponent && node.memoizedState !== null) {
              // Found a nested Suspense component that timed out. Skip over the
              var fallbackChildFragment = node.child.sibling;
              fallbackChildFragment.return = node;
              node = fallbackChildFragment;
              continue;
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === finishedWork) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === finishedWork) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
      }

      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;

        if (ref !== null) {
          var instance = finishedWork.stateNode;
          var instanceToUse = void 0;

          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance);
              break;

            default:
              instanceToUse = instance;
          }

          if (typeof ref === 'function') {
            ref(instanceToUse);
          } else {
            {
              if (!ref.hasOwnProperty('current')) {
                warningWithoutStack$1(false, 'Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().%s', getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }

      function commitDetachRef(current$$1) {
        var currentRef = current$$1.ref;

        if (currentRef !== null) {
          if (typeof currentRef === 'function') {
            currentRef(null);
          } else {
            currentRef.current = null;
          }
        }
      } // User-originating errors (lifecycles and refs) should not interrupt
      // deletion, so don't let them throw. Host-originating errors should
      // interrupt deletion, so it's okay


      function commitUnmount(current$$1) {
        onCommitUnmount(current$$1);

        switch (current$$1.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
            {
              var updateQueue = current$$1.updateQueue;

              if (updateQueue !== null) {
                var lastEffect = updateQueue.lastEffect;

                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  var effect = firstEffect;

                  do {
                    var destroy = effect.destroy;

                    if (destroy !== null) {
                      safelyCallDestroy(current$$1, destroy);
                    }

                    effect = effect.next;
                  } while (effect !== firstEffect);
                }
              }

              break;
            }

          case ClassComponent:
            {
              safelyDetachRef(current$$1);
              var instance = current$$1.stateNode;

              if (typeof instance.componentWillUnmount === 'function') {
                safelyCallComponentWillUnmount(current$$1, instance);
              }

              return;
            }

          case HostComponent:
            {
              safelyDetachRef(current$$1);
              return;
            }

          case HostPortal:
            {
              // TODO: this is recursive.
              // We are also not using this parent because
              // the portal will get pushed immediately.
              if (supportsMutation) {
                unmountHostComponents(current$$1);
              } else if (supportsPersistence) {
                emptyPortalContainer(current$$1);
              }

              return;
            }
        }
      }

      function commitNestedUnmounts(root) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        var node = root;

        while (true) {
          commitUnmount(node); // Visit children because they may contain more composite or host nodes.
          // Skip portals because commitUnmount() currently visits them recursively.

          if (node.child !== null && ( // If we use mutation we drill down into portals using commitUnmount above.
          // If we don't use mutation we drill down into portals here instead.
          !supportsMutation || node.tag !== HostPortal)) {
            node.child.return = node;
            node = node.child;
            continue;
          }

          if (node === root) {
            return;
          }

          while (node.sibling === null) {
            if (node.return === null || node.return === root) {
              return;
            }

            node = node.return;
          }

          node.sibling.return = node.return;
          node = node.sibling;
        }
      }

      function detachFiber(current$$1) {
        // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        current$$1.return = null;
        current$$1.child = null;

        if (current$$1.alternate) {
          current$$1.alternate.child = null;
          current$$1.alternate.return = null;
        }
      }

      function emptyPortalContainer(current$$1) {
        if (!supportsPersistence) {
          return;
        }

        var portal = current$$1.stateNode;
        var containerInfo = portal.containerInfo;
        var emptyChildSet = createContainerChildSet(containerInfo);
        replaceContainerChildren(containerInfo, emptyChildSet);
      }

      function commitContainer(finishedWork) {
        if (!supportsPersistence) {
          return;
        }

        switch (finishedWork.tag) {
          case ClassComponent:
            {
              return;
            }

          case HostComponent:
            {
              return;
            }

          case HostText:
            {
              return;
            }

          case HostRoot:
          case HostPortal:
            {
              var portalOrRoot = finishedWork.stateNode;
              var containerInfo = portalOrRoot.containerInfo,
                  _pendingChildren = portalOrRoot.pendingChildren;
              replaceContainerChildren(containerInfo, _pendingChildren);
              return;
            }

          default:
            {
              invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
            }
        }
      }

      function getHostParentFiber(fiber) {
        var parent = fiber.return;

        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }

          parent = parent.return;
        }

        invariant(false, 'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.');
      }

      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }

      function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        var node = fiber;

        siblings: while (true) {
          // If we didn't find anything, let's try the next sibling.
          while (node.sibling === null) {
            if (node.return === null || isHostParent(node.return)) {
              // If we pop out of the root or hit the parent the fiber we are the
              // last sibling.
              return null;
            }

            node = node.return;
          }

          node.sibling.return = node.return;
          node = node.sibling;

          while (node.tag !== HostComponent && node.tag !== HostText) {
            // If it is not host node and, we might have a host node inside it.
            // Try to search down until we find one.
            if (node.effectTag & Placement) {
              // If we don't have a child, try the siblings instead.
              continue siblings;
            } // If we don't have a child, try the siblings instead.
            // We also skip portals because they are not part of this host tree.


            if (node.child === null || node.tag === HostPortal) {
              continue siblings;
            } else {
              node.child.return = node;
              node = node.child;
            }
          } // Check if this host node is stable or about to be placed.


          if (!(node.effectTag & Placement)) {
            // Found it!
            return node.stateNode;
          }
        }
      }

      function commitPlacement(finishedWork) {
        if (!supportsMutation) {
          return;
        } // Recursively insert all host nodes into the parent.


        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

        var parent = void 0;
        var isContainer = void 0;

        switch (parentFiber.tag) {
          case HostComponent:
            parent = parentFiber.stateNode;
            isContainer = false;
            break;

          case HostRoot:
            parent = parentFiber.stateNode.containerInfo;
            isContainer = true;
            break;

          case HostPortal:
            parent = parentFiber.stateNode.containerInfo;
            isContainer = true;
            break;

          default:
            invariant(false, 'Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.');
        }

        if (parentFiber.effectTag & ContentReset) {
          // Reset the text content of the parent before doing any insertions
          resetTextContent(parent); // Clear ContentReset from the effect tag

          parentFiber.effectTag &= ~ContentReset;
        }

        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need recurse down its
        // children to find all the terminal nodes.

        var node = finishedWork;

        while (true) {
          if (node.tag === HostComponent || node.tag === HostText) {
            if (before) {
              if (isContainer) {
                insertInContainerBefore(parent, node.stateNode, before);
              } else {
                insertBefore(parent, node.stateNode, before);
              }
            } else {
              if (isContainer) {
                appendChildToContainer(parent, node.stateNode);
              } else {
                appendChild(parent, node.stateNode);
              }
            }
          } else if (node.tag === HostPortal) ;else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }

          if (node === finishedWork) {
            return;
          }

          while (node.sibling === null) {
            if (node.return === null || node.return === finishedWork) {
              return;
            }

            node = node.return;
          }

          node.sibling.return = node.return;
          node = node.sibling;
        }
      }

      function unmountHostComponents(current$$1) {
        // We only have the top Fiber that was deleted but we need recurse down its
        var node = current$$1; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.

        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

        var currentParent = void 0;
        var currentParentIsContainer = void 0;

        while (true) {
          if (!currentParentIsValid) {
            var parent = node.return;

            findParent: while (true) {
              !(parent !== null) ? invariant(false, 'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.') : void 0;

              switch (parent.tag) {
                case HostComponent:
                  currentParent = parent.stateNode;
                  currentParentIsContainer = false;
                  break findParent;

                case HostRoot:
                  currentParent = parent.stateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;

                case HostPortal:
                  currentParent = parent.stateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
              }

              parent = parent.return;
            }

            currentParentIsValid = true;
          }

          if (node.tag === HostComponent || node.tag === HostText) {
            commitNestedUnmounts(node); // After all the children have unmounted, it is now safe to remove the
            // node from the tree.

            if (currentParentIsContainer) {
              removeChildFromContainer(currentParent, node.stateNode);
            } else {
              removeChild(currentParent, node.stateNode);
            } // Don't visit children because we already visited them.

          } else if (node.tag === HostPortal) {
            // When we go into a portal, it becomes the parent to remove from.
            // We will reassign it back when we pop the portal on the way up.
            currentParent = node.stateNode.containerInfo;
            currentParentIsContainer = true; // Visit children because portals might contain host components.

            if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
          } else {
            commitUnmount(node); // Visit children because we may find more host components below.

            if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
          }

          if (node === current$$1) {
            return;
          }

          while (node.sibling === null) {
            if (node.return === null || node.return === current$$1) {
              return;
            }

            node = node.return;

            if (node.tag === HostPortal) {
              // When we go out of the portal, we need to restore the parent.
              // Since we don't keep a stack of them, we will search for it.
              currentParentIsValid = false;
            }
          }

          node.sibling.return = node.return;
          node = node.sibling;
        }
      }

      function commitDeletion(current$$1) {
        if (supportsMutation) {
          // Recursively delete all host nodes from the parent.
          // Detach refs and call componentWillUnmount() on the whole subtree.
          unmountHostComponents(current$$1);
        } else {
          // Detach refs and call componentWillUnmount() on the whole subtree.
          commitNestedUnmounts(current$$1);
        }

        detachFiber(current$$1);
      }

      function commitWork(current$$1, finishedWork) {
        if (!supportsMutation) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
              {
                commitHookEffectList(UnmountMutation, MountMutation, finishedWork);
                return;
              }
          }

          commitContainer(finishedWork);
          return;
        }

        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
            {
              commitHookEffectList(UnmountMutation, MountMutation, finishedWork);
              return;
            }

          case ClassComponent:
            {
              return;
            }

          case HostComponent:
            {
              var instance = finishedWork.stateNode;

              if (instance != null) {
                // Commit the work prepared earlier.
                var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.

                var oldProps = current$$1 !== null ? current$$1.memoizedProps : newProps;
                var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;

                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type, oldProps, newProps, finishedWork);
                }
              }

              return;
            }

          case HostText:
            {
              !(finishedWork.stateNode !== null) ? invariant(false, 'This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.') : void 0;
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
              // as the newProps. The updatePayload will contain the real change in
              // this case.

              var oldText = current$$1 !== null ? current$$1.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }

          case HostRoot:
            {
              return;
            }

          case Profiler:
            {
              return;
            }

          case SuspenseComponent:
            {
              var newState = finishedWork.memoizedState;
              var newDidTimeout = void 0;
              var primaryChildParent = finishedWork;

              if (newState === null) {
                newDidTimeout = false;
              } else {
                newDidTimeout = true;
                primaryChildParent = finishedWork.child;

                if (newState.timedOutAt === NoWork) {
                  // If the children had not already timed out, record the time.
                  // This is used to compute the elapsed time during subsequent
                  // attempts to render the children.
                  newState.timedOutAt = requestCurrentTime();
                }
              }

              if (primaryChildParent !== null) {
                hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
              }

              return;
            }

          case IncompleteClassComponent:
            {
              return;
            }

          default:
            {
              invariant(false, 'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.');
            }
        }
      }

      function commitResetTextContent(current$$1) {
        if (!supportsMutation) {
          return;
        }

        resetTextContent(current$$1.stateNode);
      }

      function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime); // Unmount the root by rendering null.

        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: null
        };
        var error = errorInfo.value;

        update.callback = function () {
          onUncaughtError(error);
          logError(fiber, errorInfo);
        };

        return update;
      }

      function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

        if (typeof getDerivedStateFromError === 'function') {
          var error = errorInfo.value;

          update.payload = function () {
            return getDerivedStateFromError(error);
          };
        }

        var inst = fiber.stateNode;

        if (inst !== null && typeof inst.componentDidCatch === 'function') {
          update.callback = function callback() {
            if (typeof getDerivedStateFromError !== 'function') {
              // To preserve the preexisting retry behavior of error boundaries,
              // we keep track of which ones already failed during this batch.
              // This gets reset before we yield back to the browser.
              // TODO: Warn in strict mode if getDerivedStateFromError is
              // not defined.
              markLegacyErrorBoundaryAsFailed(this);
            }

            var error = errorInfo.value;
            var stack = errorInfo.stack;
            logError(fiber, errorInfo);
            this.componentDidCatch(error, {
              componentStack: stack !== null ? stack : ''
            });
            {
              if (typeof getDerivedStateFromError !== 'function') {
                // If componentDidCatch is the only error boundary method defined,
                // then it needs to call setState to recover from errors.
                // If no state update is scheduled then the boundary will swallow the error.
                !(fiber.expirationTime === Sync) ? warningWithoutStack$1(false, '%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown') : void 0;
              }
            }
          };
        }

        return update;
      }

      function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.

        sourceFiber.firstEffect = sourceFiber.lastEffect = null;

        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
          // This is a thenable.
          var thenable = value; // Find the earliest timeout threshold of all the placeholders in the
          // ancestor path. We could avoid this traversal by storing the thresholds on
          // the stack, but we choose not to because we only hit this path if we're
          // IO-bound (i.e. if something suspends). Whereas the stack is used even in
          // the non-IO- bound case.

          var _workInProgress = returnFiber;
          var earliestTimeoutMs = -1;
          var startTimeMs = -1;

          do {
            if (_workInProgress.tag === SuspenseComponent) {
              var current$$1 = _workInProgress.alternate;

              if (current$$1 !== null) {
                var currentState = current$$1.memoizedState;

                if (currentState !== null) {
                  // Reached a boundary that already timed out. Do not search
                  // any further.
                  var timedOutAt = currentState.timedOutAt;
                  startTimeMs = expirationTimeToMs(timedOutAt); // Do not search any further.

                  break;
                }
              }

              var timeoutPropMs = _workInProgress.pendingProps.maxDuration;

              if (typeof timeoutPropMs === 'number') {
                if (timeoutPropMs <= 0) {
                  earliestTimeoutMs = 0;
                } else if (earliestTimeoutMs === -1 || timeoutPropMs < earliestTimeoutMs) {
                  earliestTimeoutMs = timeoutPropMs;
                }
              }
            }

            _workInProgress = _workInProgress.return;
          } while (_workInProgress !== null); // Schedule the nearest Suspense to re-render the timed out view.


          _workInProgress = returnFiber;

          do {
            if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress.alternate, _workInProgress)) {
              // Found the nearest boundary.
              // If the boundary is not in concurrent mode, we should not suspend, and
              // likewise, when the promise resolves, we should ping synchronously.
              var pingTime = (_workInProgress.mode & ConcurrentMode) === NoEffect ? Sync : renderExpirationTime; // Attach a listener to the promise to "ping" the root and retry.

              var onResolveOrReject = retrySuspendedRoot.bind(null, root, _workInProgress, sourceFiber, pingTime);
              {
                onResolveOrReject = tracing$$1.unstable_wrap(onResolveOrReject);
              }
              thenable.then(onResolveOrReject, onResolveOrReject); // If the boundary is outside of concurrent mode, we should *not*
              // suspend the commit. Pretend as if the suspended component rendered
              // null and keep rendering. In the commit phase, we'll schedule a
              // subsequent synchronous update to re-render the Suspense.
              //
              // Note: It doesn't matter whether the component that suspended was
              // inside a concurrent mode tree. If the Suspense is outside of it, we
              // should *not* suspend the commit.

              if ((_workInProgress.mode & ConcurrentMode) === NoEffect) {
                _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.

                sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);

                if (sourceFiber.tag === ClassComponent) {
                  var _current = sourceFiber.alternate;

                  if (_current === null) {
                    // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                  }
                } // The source fiber did not complete. Mark it with the current
                // render priority to indicate that it still has pending work.


                sourceFiber.expirationTime = renderExpirationTime; // Exit without suspending.

                return;
              } // Confirmed that the boundary is in a concurrent mode tree. Continue
              // with the normal suspend path.


              var absoluteTimeoutMs = void 0;

              if (earliestTimeoutMs === -1) {
                // If no explicit threshold is given, default to an abitrarily large
                // value. The actual size doesn't matter because the threshold for the
                // whole tree will be clamped to the expiration time.
                absoluteTimeoutMs = maxSigned31BitInt;
              } else {
                if (startTimeMs === -1) {
                  // This suspend happened outside of any already timed-out
                  // placeholders. We don't know exactly when the update was
                  // scheduled, but we can infer an approximate start time from the
                  // expiration time. First, find the earliest uncommitted expiration
                  // time in the tree, including work that is suspended. Then subtract
                  // the offset used to compute an async update's expiration time.
                  // This will cause high priority (interactive) work to expire
                  // earlier than necessary, but we can account for this by adjusting
                  // for the Just Noticeable Difference.
                  var earliestExpirationTime = findEarliestOutstandingPriorityLevel(root, renderExpirationTime);
                  var earliestExpirationTimeMs = expirationTimeToMs(earliestExpirationTime);
                  startTimeMs = earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
                }

                absoluteTimeoutMs = startTimeMs + earliestTimeoutMs;
              } // Mark the earliest timeout in the suspended fiber's ancestor path.
              // After completing the root, we'll take the largest of all the
              // suspended fiber's timeouts and use it to compute a timeout for the
              // whole tree.


              renderDidSuspend(root, absoluteTimeoutMs, renderExpirationTime);
              _workInProgress.effectTag |= ShouldCapture;
              _workInProgress.expirationTime = renderExpirationTime;
              return;
            } // This boundary already captured during this render. Continue to the next
            // boundary.


            _workInProgress = _workInProgress.return;
          } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
          // TODO: Use invariant so the message is stripped in prod?


          value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.' + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.


        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;

        do {
          switch (workInProgress.tag) {
            case HostRoot:
              {
                var _errorInfo = value;
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime;
                var update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, update);
                return;
              }

            case ClassComponent:
              // Capture and retry
              var errorInfo = value;
              var ctor = workInProgress.type;
              var instance = workInProgress.stateNode;

              if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state

                var _update = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);

                enqueueCapturedUpdate(workInProgress, _update);
                return;
              }

              break;

            default:
              break;
          }

          workInProgress = workInProgress.return;
        } while (workInProgress !== null);
      }

      function unwindWork(workInProgress, renderExpirationTime) {
        switch (workInProgress.tag) {
          case ClassComponent:
            {
              var Component = workInProgress.type;

              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }

              var effectTag = workInProgress.effectTag;

              if (effectTag & ShouldCapture) {
                workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
              }

              return null;
            }

          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var _effectTag = workInProgress.effectTag;
              !((_effectTag & DidCapture) === NoEffect) ? invariant(false, 'The root failed to unmount after an error. This is likely a bug in React. Please file an issue.') : void 0;
              workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
              return workInProgress;
            }

          case HostComponent:
            {
              popHostContext(workInProgress);
              return null;
            }

          case SuspenseComponent:
            {
              var _effectTag2 = workInProgress.effectTag;

              if (_effectTag2 & ShouldCapture) {
                workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

                return workInProgress;
              }

              return null;
            }

          case HostPortal:
            popHostContainer(workInProgress);
            return null;

          case ContextProvider:
            popProvider(workInProgress);
            return null;

          default:
            return null;
        }
      }

      function unwindInterruptedWork(interruptedWork) {
        switch (interruptedWork.tag) {
          case ClassComponent:
            {
              var childContextTypes = interruptedWork.type.childContextTypes;

              if (childContextTypes !== null && childContextTypes !== undefined) {
                popContext(interruptedWork);
              }

              break;
            }

          case HostRoot:
            {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              break;
            }

          case HostComponent:
            {
              popHostContext(interruptedWork);
              break;
            }

          case HostPortal:
            popHostContainer(interruptedWork);
            break;

          case ContextProvider:
            popProvider(interruptedWork);
            break;

          default:
            break;
        }
      }

      var DispatcherWithoutHooks = {
        readContext: readContext
      };
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didWarnAboutStateTransition = void 0;
      var didWarnSetStateChildContext = void 0;
      var warnAboutUpdateOnUnmounted = void 0;
      var warnAboutInvalidUpdates = void 0;
      {
        // Provide explicit error message when production+profiling bundle of e.g. react-dom
        // is used with production (non-profiling) bundle of scheduler/tracing
        !(tracing$$1.__interactionsRef != null && tracing$$1.__interactionsRef.current != null) ? invariant(false, 'It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling') : void 0;
      }
      {
        didWarnAboutStateTransition = false;
        didWarnSetStateChildContext = false;
        var didWarnStateUpdateForUnmountedComponent = {};

        warnAboutUpdateOnUnmounted = function warnAboutUpdateOnUnmounted(fiber, isClass) {
          // We show the whole stack but dedupe on the top component's name because
          // the problematic code almost always lies inside that component.
          var componentName = getComponentName(fiber.type) || 'ReactComponent';

          if (didWarnStateUpdateForUnmountedComponent[componentName]) {
            return;
          }

          warningWithoutStack$1(false, "Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.%s', isClass ? 'the componentWillUnmount method' : 'a useEffect cleanup function', getStackByFiberInDevAndProd(fiber));
          didWarnStateUpdateForUnmountedComponent[componentName] = true;
        };

        warnAboutInvalidUpdates = function warnAboutInvalidUpdates(instance) {
          switch (phase) {
            case 'getChildContext':
              if (didWarnSetStateChildContext) {
                return;
              }

              warningWithoutStack$1(false, 'setState(...): Cannot call setState() inside getChildContext()');
              didWarnSetStateChildContext = true;
              break;

            case 'render':
              if (didWarnAboutStateTransition) {
                return;
              }

              warningWithoutStack$1(false, 'Cannot update during an existing state transition (such as within ' + '`render`). Render methods should be a pure function of props and state.');
              didWarnAboutStateTransition = true;
              break;
          }
        };
      } // Used to ensure computeUniqueAsyncExpiration is monotonically decreasing.

      var lastUniqueAsyncExpiration = Sync - 1; // Represents the expiration time that incoming updates should use. (If this
      // is NoWork, use the default strategy: async updates in async mode, sync
      // updates in sync mode.)

      var expirationContext = NoWork;
      var isWorking = false; // The next work in progress fiber that we're currently working on.

      var nextUnitOfWork = null;
      var nextRoot = null; // The time at which we're currently rendering work.

      var nextRenderExpirationTime = NoWork;
      var nextLatestAbsoluteTimeoutMs = -1;
      var nextRenderDidError = false; // The next fiber with an effect that we're currently committing.

      var nextEffect = null;
      var isCommitting$1 = false;
      var passiveEffectCallbackHandle = null;
      var passiveEffectCallback = null;
      var legacyErrorBoundariesThatAlreadyFailed = null; // Used for performance tracking.

      var interruptedBy = null;
      var stashedWorkInProgressProperties = void 0;
      var replayUnitOfWork = void 0;
      var mayReplayFailedUnitOfWork = void 0;
      var isReplayingFailedUnitOfWork = void 0;
      var originalReplayError = void 0;
      var rethrowOriginalError = void 0;
      {
        stashedWorkInProgressProperties = null;
        mayReplayFailedUnitOfWork = true;
        isReplayingFailedUnitOfWork = false;
        originalReplayError = null;

        replayUnitOfWork = function replayUnitOfWork(failedUnitOfWork, thrownValue, isYieldy) {
          if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
            // Don't replay promises. Treat everything else like an error.
            // TODO: Need to figure out a different strategy if/when we add
            // support for catching other types.
            return;
          } // Restore the original state of the work-in-progress


          if (stashedWorkInProgressProperties === null) {
            // This should never happen. Don't throw because this code is DEV-only.
            warningWithoutStack$1(false, 'Could not replay rendering after an error. This is likely a bug in React. ' + 'Please file an issue.');
            return;
          }

          assignFiberPropertiesInDEV(failedUnitOfWork, stashedWorkInProgressProperties);

          switch (failedUnitOfWork.tag) {
            case HostRoot:
              popHostContainer(failedUnitOfWork);
              popTopLevelContextObject(failedUnitOfWork);
              break;

            case HostComponent:
              popHostContext(failedUnitOfWork);
              break;

            case ClassComponent:
              {
                var Component = failedUnitOfWork.type;

                if (isContextProvider(Component)) {
                  popContext(failedUnitOfWork);
                }

                break;
              }

            case HostPortal:
              popHostContainer(failedUnitOfWork);
              break;

            case ContextProvider:
              popProvider(failedUnitOfWork);
              break;
          } // Replay the begin phase.


          isReplayingFailedUnitOfWork = true;
          originalReplayError = thrownValue;
          invokeGuardedCallback(null, workLoop, null, isYieldy);
          isReplayingFailedUnitOfWork = false;
          originalReplayError = null;

          if (hasCaughtError()) {
            var replayError = clearCaughtError();

            if (replayError != null && thrownValue != null) {
              try {
                // Reading the expando property is intentionally
                // inside `try` because it might be a getter or Proxy.
                if (replayError._suppressLogging) {
                  // Also suppress logging for the original error.
                  thrownValue._suppressLogging = true;
                }
              } catch (inner) {// Ignore.
              }
            }
          } else {
            // If the begin phase did not fail the second time, set this pointer
            // back to the original value.
            nextUnitOfWork = failedUnitOfWork;
          }
        };

        rethrowOriginalError = function rethrowOriginalError() {
          throw originalReplayError;
        };
      }

      function resetStack() {
        if (nextUnitOfWork !== null) {
          var interruptedWork = nextUnitOfWork.return;

          while (interruptedWork !== null) {
            unwindInterruptedWork(interruptedWork);
            interruptedWork = interruptedWork.return;
          }
        }

        {
          ReactStrictModeWarnings.discardPendingWarnings();
          checkThatStackIsEmpty();
        }
        nextRoot = null;
        nextRenderExpirationTime = NoWork;
        nextLatestAbsoluteTimeoutMs = -1;
        nextRenderDidError = false;
        nextUnitOfWork = null;
      }

      function commitAllHostEffects() {
        while (nextEffect !== null) {
          {
            setCurrentFiber(nextEffect);
          }
          recordEffect();
          var effectTag = nextEffect.effectTag;

          if (effectTag & ContentReset) {
            commitResetTextContent(nextEffect);
          }

          if (effectTag & Ref) {
            var current$$1 = nextEffect.alternate;

            if (current$$1 !== null) {
              commitDetachRef(current$$1);
            }
          } // The following switch statement is only concerned about placement,
          // updates, and deletions. To avoid needing to add a case for every
          // possible bitmap value, we remove the secondary effects from the
          // effect tag and switch on that value.


          var primaryEffectTag = effectTag & (Placement | Update | Deletion);

          switch (primaryEffectTag) {
            case Placement:
              {
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is inserted, before
                // any life-cycles like componentDidMount gets called.
                // TODO: findDOMNode doesn't rely on this any more but isMounted
                // does and isMounted is deprecated anyway so we should be able
                // to kill this.

                nextEffect.effectTag &= ~Placement;
                break;
              }

            case PlacementAndUpdate:
              {
                // Placement
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is inserted, before
                // any life-cycles like componentDidMount gets called.

                nextEffect.effectTag &= ~Placement; // Update

                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }

            case Update:
              {
                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }

            case Deletion:
              {
                commitDeletion(nextEffect);
                break;
              }
          }

          nextEffect = nextEffect.nextEffect;
        }

        {
          resetCurrentFiber();
        }
      }

      function commitBeforeMutationLifecycles() {
        while (nextEffect !== null) {
          {
            setCurrentFiber(nextEffect);
          }
          var effectTag = nextEffect.effectTag;

          if (effectTag & Snapshot) {
            recordEffect();
            var current$$1 = nextEffect.alternate;
            commitBeforeMutationLifeCycles(current$$1, nextEffect);
          }

          nextEffect = nextEffect.nextEffect;
        }

        {
          resetCurrentFiber();
        }
      }

      function commitAllLifeCycles(finishedRoot, committedExpirationTime) {
        {
          ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          ReactStrictModeWarnings.flushLegacyContextWarning();
        }

        while (nextEffect !== null) {
          var effectTag = nextEffect.effectTag;

          if (effectTag & (Update | Callback)) {
            recordEffect();
            var current$$1 = nextEffect.alternate;
            commitLifeCycles(finishedRoot, current$$1, nextEffect, committedExpirationTime);
          }

          if (effectTag & Ref) {
            recordEffect();
            commitAttachRef(nextEffect);
          }

          nextEffect = nextEffect.nextEffect;
        }
      }

      function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
      }

      function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance);
        }
      }

      function flushPassiveEffects() {
        if (passiveEffectCallback !== null) {
          scheduler$$1.unstable_cancelCallback(passiveEffectCallbackHandle); // We call the scheduled callback instead of commitPassiveEffects directly
          // to ensure tracing works correctly.

          passiveEffectCallback();
        }
      }

      function commitRoot(root, finishedWork) {
        isWorking = true;
        isCommitting$1 = true;
        startCommitTimer();
        !(root.current !== finishedWork) ? invariant(false, 'Cannot commit the same tree as before. This is probably a bug related to the return field. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        var committedExpirationTime = root.pendingCommitExpirationTime;
        !(committedExpirationTime !== NoWork) ? invariant(false, 'Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        root.pendingCommitExpirationTime = NoWork; // Update the pending priority levels to account for the work that we are
        // about to commit. This needs to happen before calling the lifecycles, since
        // they may schedule additional updates.

        var updateExpirationTimeBeforeCommit = finishedWork.expirationTime;
        var childExpirationTimeBeforeCommit = finishedWork.childExpirationTime;
        var earliestRemainingTimeBeforeCommit = childExpirationTimeBeforeCommit > updateExpirationTimeBeforeCommit ? childExpirationTimeBeforeCommit : updateExpirationTimeBeforeCommit;
        markCommittedPriorityLevels(root, earliestRemainingTimeBeforeCommit);
        var prevInteractions = null;
        {
          // Restore any pending interactions at this point,
          // So that cascading work triggered during the render phase will be accounted for.
          prevInteractions = tracing$$1.__interactionsRef.current;
          tracing$$1.__interactionsRef.current = root.memoizedInteractions;
        } // Reset this to null before calling lifecycles

        ReactCurrentOwner$1.current = null;
        var firstEffect = void 0;

        if (finishedWork.effectTag > PerformedWork) {
          // A fiber's effect list consists only of its children, not itself. So if
          // the root has an effect, we need to add it to the end of the list. The
          // resulting list is the set that would belong to the root's parent, if
          // it had one; that is, all the effects in the tree including the root.
          if (finishedWork.lastEffect !== null) {
            finishedWork.lastEffect.nextEffect = finishedWork;
            firstEffect = finishedWork.firstEffect;
          } else {
            firstEffect = finishedWork;
          }
        } else {
          // There is no effect on the root.
          firstEffect = finishedWork.firstEffect;
        }

        prepareForCommit(root.containerInfo); // Invoke instances of getSnapshotBeforeUpdate before mutation.

        nextEffect = firstEffect;
        startCommitSnapshotEffectsTimer();

        while (nextEffect !== null) {
          var didError = false;
          var error = void 0;
          {
            invokeGuardedCallback(null, commitBeforeMutationLifecycles, null);

            if (hasCaughtError()) {
              didError = true;
              error = clearCaughtError();
            }
          }

          if (didError) {
            !(nextEffect !== null) ? invariant(false, 'Should have next effect. This error is likely caused by a bug in React. Please file an issue.') : void 0;
            captureCommitPhaseError(nextEffect, error); // Clean-up

            if (nextEffect !== null) {
              nextEffect = nextEffect.nextEffect;
            }
          }
        }

        stopCommitSnapshotEffectsTimer();
        {
          // Mark the current commit time to be shared by all Profilers in this batch.
          // This enables them to be grouped later.
          recordCommitTime();
        } // Commit all the side-effects within a tree. We'll do this in two passes.
        // The first pass performs all the host insertions, updates, deletions and
        // ref unmounts.

        nextEffect = firstEffect;
        startCommitHostEffectsTimer();

        while (nextEffect !== null) {
          var _didError = false;

          var _error = void 0;

          {
            invokeGuardedCallback(null, commitAllHostEffects, null);

            if (hasCaughtError()) {
              _didError = true;
              _error = clearCaughtError();
            }
          }

          if (_didError) {
            !(nextEffect !== null) ? invariant(false, 'Should have next effect. This error is likely caused by a bug in React. Please file an issue.') : void 0;
            captureCommitPhaseError(nextEffect, _error); // Clean-up

            if (nextEffect !== null) {
              nextEffect = nextEffect.nextEffect;
            }
          }
        }

        stopCommitHostEffectsTimer();
        resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
        // the first pass of the commit phase, so that the previous tree is still
        // current during componentWillUnmount, but before the second pass, so that
        // the finished work is current during componentDidMount/Update.

        root.current = finishedWork; // In the second pass we'll perform all life-cycles and ref callbacks.
        // Life-cycles happen as a separate pass so that all placements, updates,
        // and deletions in the entire tree have already been invoked.
        // This pass also triggers any renderer-specific initial effects.

        nextEffect = firstEffect;
        startCommitLifeCyclesTimer();

        while (nextEffect !== null) {
          var _didError2 = false;

          var _error2 = void 0;

          {
            invokeGuardedCallback(null, commitAllLifeCycles, null, root, committedExpirationTime);

            if (hasCaughtError()) {
              _didError2 = true;
              _error2 = clearCaughtError();
            }
          }

          if (_didError2) {
            !(nextEffect !== null) ? invariant(false, 'Should have next effect. This error is likely caused by a bug in React. Please file an issue.') : void 0;
            captureCommitPhaseError(nextEffect, _error2);

            if (nextEffect !== null) {
              nextEffect = nextEffect.nextEffect;
            }
          }
        }

        isCommitting$1 = false;
        isWorking = false;
        stopCommitLifeCyclesTimer();
        stopCommitTimer();
        onCommitRoot(finishedWork.stateNode);
        var updateExpirationTimeAfterCommit = finishedWork.expirationTime;
        var childExpirationTimeAfterCommit = finishedWork.childExpirationTime;
        var earliestRemainingTimeAfterCommit = childExpirationTimeAfterCommit > updateExpirationTimeAfterCommit ? childExpirationTimeAfterCommit : updateExpirationTimeAfterCommit;

        if (earliestRemainingTimeAfterCommit === NoWork) {
          // If there's no remaining work, we can clear the set of already failed
          // error boundaries.
          legacyErrorBoundariesThatAlreadyFailed = null;
        }

        onCommit(root, earliestRemainingTimeAfterCommit);
        {
          tracing$$1.__interactionsRef.current = prevInteractions;
          var subscriber = void 0;

          try {
            subscriber = tracing$$1.__subscriberRef.current;

            if (subscriber !== null && root.memoizedInteractions.size > 0) {
              var threadID = computeThreadID(committedExpirationTime, root.interactionThreadID);
              subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
          } catch (error) {
            // It's not safe for commitRoot() to throw.
            // Store the error for now and we'll re-throw in finishRendering().
            if (!hasUnhandledError) {
              hasUnhandledError = true;
              unhandledError = error;
            }
          } finally {
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
              // Only decrement the pending interaction count if we're done.
              // If there's still work at the current priority,
              // That indicates that we are waiting for suspense data.
              if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
                pendingInteractionMap.delete(scheduledExpirationTime);
                scheduledInteractions.forEach(function (interaction) {
                  interaction.__count--;

                  if (subscriber !== null && interaction.__count === 0) {
                    try {
                      subscriber.onInteractionScheduledWorkCompleted(interaction);
                    } catch (error) {
                      // It's not safe for commitRoot() to throw.
                      // Store the error for now and we'll re-throw in finishRendering().
                      if (!hasUnhandledError) {
                        hasUnhandledError = true;
                        unhandledError = error;
                      }
                    }
                  }
                });
              }
            });
          }
        }
      }

      function resetChildExpirationTime(workInProgress, renderTime) {
        if (renderTime !== Never && workInProgress.childExpirationTime === Never) {
          // The children of this component are hidden. Don't bubble their
          // expiration times.
          return;
        }

        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.

        if (workInProgress.mode & ProfileMode) {
          // We're in profiling mode.
          // Let's use this same traversal to update the render durations.
          var actualDuration = workInProgress.actualDuration;
          var treeBaseDuration = workInProgress.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0.
          // This value will only be updated if work is done on the fiber (i.e. it doesn't bailout).
          // When work is done, it should bubble to the parent's actualDuration.
          // If the fiber has not been cloned though, (meaning no work was done),
          // Then this value will reflect the amount of time spent working on a previous render.
          // In that case it should not bubble.
          // We determine whether it was cloned by comparing the child pointer.

          var shouldBubbleActualDurations = workInProgress.alternate === null || workInProgress.child !== workInProgress.alternate.child;
          var child = workInProgress.child;

          while (child !== null) {
            var childUpdateExpirationTime = child.expirationTime;
            var childChildExpirationTime = child.childExpirationTime;

            if (childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childUpdateExpirationTime;
            }

            if (childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childChildExpirationTime;
            }

            if (shouldBubbleActualDurations) {
              actualDuration += child.actualDuration;
            }

            treeBaseDuration += child.treeBaseDuration;
            child = child.sibling;
          }

          workInProgress.actualDuration = actualDuration;
          workInProgress.treeBaseDuration = treeBaseDuration;
        } else {
          var _child = workInProgress.child;

          while (_child !== null) {
            var _childUpdateExpirationTime = _child.expirationTime;
            var _childChildExpirationTime = _child.childExpirationTime;

            if (_childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childUpdateExpirationTime;
            }

            if (_childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childChildExpirationTime;
            }

            _child = _child.sibling;
          }
        }

        workInProgress.childExpirationTime = newChildExpirationTime;
      }

      function completeUnitOfWork(workInProgress) {
        // Attempt to complete the current unit of work, then move to the
        // next sibling. If there are no more siblings, return to the
        // parent fiber.
        while (true) {
          // The current, flushed, state of this fiber is the alternate.
          // Ideally nothing should rely on this, but relying on it here
          // means that we don't need an additional field on the work in
          // progress.
          var current$$1 = workInProgress.alternate;
          {
            setCurrentFiber(workInProgress);
          }
          var returnFiber = workInProgress.return;
          var siblingFiber = workInProgress.sibling;

          if ((workInProgress.effectTag & Incomplete) === NoEffect) {
            {
              // Don't replay if it fails during completion phase.
              mayReplayFailedUnitOfWork = false;
            } // This fiber completed.
            // Remember we're completing this unit so we can find a boundary if it fails.

            nextUnitOfWork = workInProgress;
            {
              if (workInProgress.mode & ProfileMode) {
                startProfilerTimer(workInProgress);
              }

              nextUnitOfWork = completeWork(current$$1, workInProgress, nextRenderExpirationTime);

              if (workInProgress.mode & ProfileMode) {
                // Update render duration assuming we didn't error.
                stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
              }
            }
            {
              // We're out of completion phase so replaying is fine now.
              mayReplayFailedUnitOfWork = true;
            }
            stopWorkTimer(workInProgress);
            resetChildExpirationTime(workInProgress, nextRenderExpirationTime);
            {
              resetCurrentFiber();
            }

            if (nextUnitOfWork !== null) {
              // Completing this fiber spawned new work. Work on that next.
              return nextUnitOfWork;
            }

            if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
            (returnFiber.effectTag & Incomplete) === NoEffect) {
              // Append all the effects of the subtree and this fiber onto the effect
              // list of the parent. The completion order of the children affects the
              // side-effect order.
              if (returnFiber.firstEffect === null) {
                returnFiber.firstEffect = workInProgress.firstEffect;
              }

              if (workInProgress.lastEffect !== null) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                }

                returnFiber.lastEffect = workInProgress.lastEffect;
              } // If this fiber had side-effects, we append it AFTER the children's
              // side-effects. We can perform certain side-effects earlier if
              // needed, by doing multiple passes over the effect list. We don't want
              // to schedule our own side-effect on our own list because if end up
              // reusing children we'll schedule this effect onto itself since we're
              // at the end.


              var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect list.
              // PerformedWork effect is read by React DevTools but shouldn't be committed.

              if (effectTag > PerformedWork) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress;
                } else {
                  returnFiber.firstEffect = workInProgress;
                }

                returnFiber.lastEffect = workInProgress;
              }
            }

            if (siblingFiber !== null) {
              // If there is more work to do in this returnFiber, do that next.
              return siblingFiber;
            } else if (returnFiber !== null) {
              // If there's no more work in this returnFiber. Complete the returnFiber.
              workInProgress = returnFiber;
              continue;
            } else {
              // We've reached the root.
              return null;
            }
          } else {
            if (workInProgress.mode & ProfileMode) {
              // Record the render duration for the fiber that errored.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.

              var actualDuration = workInProgress.actualDuration;
              var child = workInProgress.child;

              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }

              workInProgress.actualDuration = actualDuration;
            } // This fiber did not complete because something threw. Pop values off
            // the stack without entering the complete phase. If this is a boundary,
            // capture values if possible.


            var next = unwindWork(workInProgress, nextRenderExpirationTime); // Because this fiber did not complete, don't reset its expiration time.

            if (workInProgress.effectTag & DidCapture) {
              // Restarting an error boundary
              stopFailedWorkTimer(workInProgress);
            } else {
              stopWorkTimer(workInProgress);
            }

            {
              resetCurrentFiber();
            }

            if (next !== null) {
              stopWorkTimer(workInProgress); // If completing this work spawned new work, do that next. We'll come
              // back here again.
              // Since we're restarting, remove anything that is not a host effect
              // from the effect tag.

              next.effectTag &= HostEffectMask;
              return next;
            }

            if (returnFiber !== null) {
              // Mark the parent fiber as incomplete and clear its effect list.
              returnFiber.firstEffect = returnFiber.lastEffect = null;
              returnFiber.effectTag |= Incomplete;
            }

            if (siblingFiber !== null) {
              // If there is more work to do in this returnFiber, do that next.
              return siblingFiber;
            } else if (returnFiber !== null) {
              // If there's no more work in this returnFiber. Complete the returnFiber.
              workInProgress = returnFiber;
              continue;
            } else {
              return null;
            }
          }
        } // Without this explicit null return Flow complains of invalid return type
        // TODO Remove the above while(true) loop
        // eslint-disable-next-line no-unreachable


        return null;
      }

      function performUnitOfWork(workInProgress) {
        // The current, flushed, state of this fiber is the alternate.
        // Ideally nothing should rely on this, but relying on it here
        // means that we don't need an additional field on the work in
        // progress.
        var current$$1 = workInProgress.alternate; // See if beginning this work spawns more work.

        startWorkTimer(workInProgress);
        {
          setCurrentFiber(workInProgress);
        }
        {
          stashedWorkInProgressProperties = assignFiberPropertiesInDEV(stashedWorkInProgressProperties, workInProgress);
        }
        var next = void 0;
        {
          if (workInProgress.mode & ProfileMode) {
            startProfilerTimer(workInProgress);
          }

          next = beginWork(current$$1, workInProgress, nextRenderExpirationTime);
          workInProgress.memoizedProps = workInProgress.pendingProps;

          if (workInProgress.mode & ProfileMode) {
            // Record the render duration assuming we didn't bailout (or error).
            stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
          }
        }
        {
          resetCurrentFiber();

          if (isReplayingFailedUnitOfWork) {
            // Currently replaying a failed unit of work. This should be unreachable,
            // because the render phase is meant to be idempotent, and it should
            // have thrown again. Since it didn't, rethrow the original error, so
            // React's internal stack is not misaligned.
            rethrowOriginalError();
          }
        }

        if (next === null) {
          // If this doesn't spawn new work, complete the current work.
          next = completeUnitOfWork(workInProgress);
        }

        ReactCurrentOwner$1.current = null;
        return next;
      }

      function workLoop(isYieldy) {
        if (!isYieldy) {
          // Flush work without yielding
          while (nextUnitOfWork !== null) {
            nextUnitOfWork = performUnitOfWork(nextUnitOfWork);
          }
        } else {
          // Flush asynchronous work until there's a higher priority event
          while (nextUnitOfWork !== null && !shouldYieldToRenderer()) {
            nextUnitOfWork = performUnitOfWork(nextUnitOfWork);
          }
        }
      }

      function renderRoot(root, isYieldy) {
        !!isWorking ? invariant(false, 'renderRoot was called recursively. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        flushPassiveEffects();
        isWorking = true;
        {
          ReactCurrentOwner$1.currentDispatcher = DispatcherWithoutHooks;
        }
        var expirationTime = root.nextExpirationTimeToWorkOn; // Check if we're starting from a fresh stack, or if we're resuming from
        // previously yielded work.

        if (expirationTime !== nextRenderExpirationTime || root !== nextRoot || nextUnitOfWork === null) {
          // Reset the stack and start working from the root.
          resetStack();
          nextRoot = root;
          nextRenderExpirationTime = expirationTime;
          nextUnitOfWork = createWorkInProgress(nextRoot.current, null, nextRenderExpirationTime);
          root.pendingCommitExpirationTime = NoWork;
          {
            // Determine which interactions this batch of work currently includes,
            // So that we can accurately attribute time spent working on it,
            var interactions = new Set();
            root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
              if (scheduledExpirationTime >= expirationTime) {
                scheduledInteractions.forEach(function (interaction) {
                  return interactions.add(interaction);
                });
              }
            }); // Store the current set of interactions on the FiberRoot for a few reasons:
            // We can re-use it in hot functions like renderRoot() without having to recalculate it.
            // We will also use it in commitWork() to pass to any Profiler onRender() hooks.
            // This also provides DevTools with a way to access it when the onCommitRoot() hook is called.

            root.memoizedInteractions = interactions;

            if (interactions.size > 0) {
              var subscriber = tracing$$1.__subscriberRef.current;

              if (subscriber !== null) {
                var threadID = computeThreadID(expirationTime, root.interactionThreadID);

                try {
                  subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                  // Work thrown by an interaction tracing subscriber should be rethrown,
                  // But only once it's safe (to avoid leaveing the scheduler in an invalid state).
                  // Store the error for now and we'll re-throw in finishRendering().
                  if (!hasUnhandledError) {
                    hasUnhandledError = true;
                    unhandledError = error;
                  }
                }
              }
            }
          }
        }

        var prevInteractions = null;
        {
          // We're about to start new traced work.
          // Restore pending interactions so cascading work triggered during the render phase will be accounted for.
          prevInteractions = tracing$$1.__interactionsRef.current;
          tracing$$1.__interactionsRef.current = root.memoizedInteractions;
        }
        var didFatal = false;
        startWorkLoopTimer(nextUnitOfWork);

        do {
          try {
            workLoop(isYieldy);
          } catch (thrownValue) {
            resetContextDependences();
            resetHooks(); // Reset in case completion throws.
            // This is only used in DEV and when replaying is on.

            var mayReplay = void 0;
            {
              mayReplay = mayReplayFailedUnitOfWork;
              mayReplayFailedUnitOfWork = true;
            }

            if (nextUnitOfWork === null) {
              // This is a fatal error.
              didFatal = true;
              onUncaughtError(thrownValue);
            } else {
              if (nextUnitOfWork.mode & ProfileMode) {
                // Record the time spent rendering before an error was thrown.
                // This avoids inaccurate Profiler durations in the case of a suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(nextUnitOfWork, true);
              }

              {
                // Reset global debug state
                // We assume this is defined in DEV
                resetCurrentlyProcessingQueue();
              }
              {
                if (mayReplay) {
                  var failedUnitOfWork = nextUnitOfWork;
                  replayUnitOfWork(failedUnitOfWork, thrownValue, isYieldy);
                }
              } // TODO: we already know this isn't true in some cases.
              // At least this shows a nicer error message until we figure out the cause.
              // https://github.com/facebook/react/issues/12449#issuecomment-386727431

              !(nextUnitOfWork !== null) ? invariant(false, 'Failed to replay rendering after an error. This is likely caused by a bug in React. Please file an issue with a reproducing case to help us find it.') : void 0;
              var sourceFiber = nextUnitOfWork;
              var returnFiber = sourceFiber.return;

              if (returnFiber === null) {
                // This is the root. The root could capture its own errors. However,
                // we don't know if it errors before or after we pushed the host
                // context. This information is needed to avoid a stack mismatch.
                // Because we're not sure, treat this as a fatal error. We could track
                // which phase it fails in, but doesn't seem worth it. At least
                // for now.
                didFatal = true;
                onUncaughtError(thrownValue);
              } else {
                throwException(root, returnFiber, sourceFiber, thrownValue, nextRenderExpirationTime);
                nextUnitOfWork = completeUnitOfWork(sourceFiber);
                continue;
              }
            }
          }

          break;
        } while (true);

        {
          // Traced work is done for now; restore the previous interactions.
          tracing$$1.__interactionsRef.current = prevInteractions;
        } // We're done performing work. Time to clean up.

        isWorking = false;
        ReactCurrentOwner$1.currentDispatcher = null;
        resetContextDependences();
        resetHooks(); // Yield back to main thread.

        if (didFatal) {
          var _didCompleteRoot = false;
          stopWorkLoopTimer(interruptedBy, _didCompleteRoot);
          interruptedBy = null; // There was a fatal error.

          {
            resetStackAfterFatalErrorInDev();
          } // `nextRoot` points to the in-progress root. A non-null value indicates
          // that we're in the middle of an async render. Set it to null to indicate
          // there's no more work to be done in the current batch.

          nextRoot = null;
          onFatal(root);
          return;
        }

        if (nextUnitOfWork !== null) {
          // There's still remaining async work in this tree, but we ran out of time
          // in the current frame. Yield back to the renderer. Unless we're
          // interrupted by a higher priority update, we'll continue later from where
          // we left off.
          var _didCompleteRoot2 = false;
          stopWorkLoopTimer(interruptedBy, _didCompleteRoot2);
          interruptedBy = null;
          onYield(root);
          return;
        } // We completed the whole tree.


        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        var rootWorkInProgress = root.current.alternate;
        !(rootWorkInProgress !== null) ? invariant(false, 'Finished root should have a work-in-progress. This error is likely caused by a bug in React. Please file an issue.') : void 0; // `nextRoot` points to the in-progress root. A non-null value indicates
        // that we're in the middle of an async render. Set it to null to indicate
        // there's no more work to be done in the current batch.

        nextRoot = null;
        interruptedBy = null;

        if (nextRenderDidError) {
          // There was an error
          if (hasLowerPriorityWork(root, expirationTime)) {
            // There's lower priority work. If so, it may have the effect of fixing
            // the exception that was just thrown. Exit without committing. This is
            // similar to a suspend, but without a timeout because we're not waiting
            // for a promise to resolve. React will restart at the lower
            // priority level.
            markSuspendedPriorityLevel(root, expirationTime);
            var suspendedExpirationTime = expirationTime;
            var rootExpirationTime = root.expirationTime;
            onSuspend(root, rootWorkInProgress, suspendedExpirationTime, rootExpirationTime, -1 // Indicates no timeout
            );
            return;
          } else if ( // There's no lower priority work, but we're rendering asynchronously.
          // Synchronsouly attempt to render the same level one more time. This is
          // similar to a suspend, but without a timeout because we're not waiting
          // for a promise to resolve.
          !root.didError && isYieldy) {
            root.didError = true;

            var _suspendedExpirationTime = root.nextExpirationTimeToWorkOn = expirationTime;

            var _rootExpirationTime = root.expirationTime = Sync;

            onSuspend(root, rootWorkInProgress, _suspendedExpirationTime, _rootExpirationTime, -1 // Indicates no timeout
            );
            return;
          }
        }

        if (isYieldy && nextLatestAbsoluteTimeoutMs !== -1) {
          // The tree was suspended.
          var _suspendedExpirationTime2 = expirationTime;
          markSuspendedPriorityLevel(root, _suspendedExpirationTime2); // Find the earliest uncommitted expiration time in the tree, including
          // work that is suspended. The timeout threshold cannot be longer than
          // the overall expiration.

          var earliestExpirationTime = findEarliestOutstandingPriorityLevel(root, expirationTime);
          var earliestExpirationTimeMs = expirationTimeToMs(earliestExpirationTime);

          if (earliestExpirationTimeMs < nextLatestAbsoluteTimeoutMs) {
            nextLatestAbsoluteTimeoutMs = earliestExpirationTimeMs;
          } // Subtract the current time from the absolute timeout to get the number
          // of milliseconds until the timeout. In other words, convert an absolute
          // timestamp to a relative time. This is the value that is passed
          // to `setTimeout`.


          var currentTimeMs = expirationTimeToMs(requestCurrentTime());
          var msUntilTimeout = nextLatestAbsoluteTimeoutMs - currentTimeMs;
          msUntilTimeout = msUntilTimeout < 0 ? 0 : msUntilTimeout; // TODO: Account for the Just Noticeable Difference

          var _rootExpirationTime2 = root.expirationTime;
          onSuspend(root, rootWorkInProgress, _suspendedExpirationTime2, _rootExpirationTime2, msUntilTimeout);
          return;
        } // Ready to commit.


        onComplete(root, rootWorkInProgress, expirationTime);
      }

      function captureCommitPhaseError(sourceFiber, value) {
        var expirationTime = Sync;
        var fiber = sourceFiber.return;

        while (fiber !== null) {
          switch (fiber.tag) {
            case ClassComponent:
              var ctor = fiber.type;
              var instance = fiber.stateNode;

              if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                var errorInfo = createCapturedValue(value, sourceFiber);
                var update = createClassErrorUpdate(fiber, errorInfo, expirationTime);
                enqueueUpdate(fiber, update);
                scheduleWork(fiber, expirationTime);
                return;
              }

              break;

            case HostRoot:
              {
                var _errorInfo = createCapturedValue(value, sourceFiber);

                var _update = createRootErrorUpdate(fiber, _errorInfo, expirationTime);

                enqueueUpdate(fiber, _update);
                scheduleWork(fiber, expirationTime);
                return;
              }
          }

          fiber = fiber.return;
        }

        if (sourceFiber.tag === HostRoot) {
          // Error was thrown at the root. There is no parent, so the root
          // itself should capture it.
          var rootFiber = sourceFiber;

          var _errorInfo2 = createCapturedValue(value, rootFiber);

          var _update2 = createRootErrorUpdate(rootFiber, _errorInfo2, expirationTime);

          enqueueUpdate(rootFiber, _update2);
          scheduleWork(rootFiber, expirationTime);
        }
      }

      function computeThreadID(expirationTime, interactionThreadID) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + interactionThreadID;
      } // Creates a unique async expiration time.


      function computeUniqueAsyncExpiration() {
        var currentTime = requestCurrentTime();
        var result = computeAsyncExpiration(currentTime);

        if (result >= lastUniqueAsyncExpiration) {
          // Since we assume the current time monotonically increases, we only hit
          // this branch when computeUniqueAsyncExpiration is fired multiple times
          // within a 200ms window (or whatever the async bucket size is).
          result = lastUniqueAsyncExpiration - 1;
        }

        lastUniqueAsyncExpiration = result;
        return lastUniqueAsyncExpiration;
      }

      function computeExpirationForFiber(currentTime, fiber) {
        var expirationTime = void 0;

        if (expirationContext !== NoWork) {
          // An explicit expiration context was set;
          expirationTime = expirationContext;
        } else if (isWorking) {
          if (isCommitting$1) {
            // Updates that occur during the commit phase should have sync priority
            // by default.
            expirationTime = Sync;
          } else {
            // Updates during the render phase should expire at the same time as
            // the work that is being rendered.
            expirationTime = nextRenderExpirationTime;
          }
        } else {
          // No explicit expiration context was set, and we're not currently
          // performing work. Calculate a new expiration time.
          if (fiber.mode & ConcurrentMode) {
            if (isBatchingInteractiveUpdates) {
              // This is an interactive update
              expirationTime = computeInteractiveExpiration(currentTime);
            } else {
              // This is an async update
              expirationTime = computeAsyncExpiration(currentTime);
            } // If we're in the middle of rendering a tree, do not update at the same
            // expiration time that is already rendering.


            if (nextRoot !== null && expirationTime === nextRenderExpirationTime) {
              expirationTime -= 1;
            }
          } else {
            // This is a sync update
            expirationTime = Sync;
          }
        }

        if (isBatchingInteractiveUpdates) {
          // This is an interactive update. Keep track of the lowest pending
          // interactive expiration time. This allows us to synchronously flush
          // all interactive updates when needed.
          if (lowestPriorityPendingInteractiveExpirationTime === NoWork || expirationTime < lowestPriorityPendingInteractiveExpirationTime) {
            lowestPriorityPendingInteractiveExpirationTime = expirationTime;
          }
        }

        return expirationTime;
      }

      function renderDidSuspend(root, absoluteTimeoutMs, suspendedTime) {
        // Schedule the timeout.
        if (absoluteTimeoutMs >= 0 && nextLatestAbsoluteTimeoutMs < absoluteTimeoutMs) {
          nextLatestAbsoluteTimeoutMs = absoluteTimeoutMs;
        }
      }

      function renderDidError() {
        nextRenderDidError = true;
      }

      function retrySuspendedRoot(root, boundaryFiber, sourceFiber, suspendedTime) {
        var retryTime = void 0;

        if (isPriorityLevelSuspended(root, suspendedTime)) {
          // Ping at the original level
          retryTime = suspendedTime;
          markPingedPriorityLevel(root, retryTime);
        } else {
          // Suspense already timed out. Compute a new expiration time
          var currentTime = requestCurrentTime();
          retryTime = computeExpirationForFiber(currentTime, boundaryFiber);
          markPendingPriorityLevel(root, retryTime);
        } // TODO: If the suspense fiber has already rendered the primary children
        // without suspending (that is, all of the promises have already resolved),
        // we should not trigger another update here. One case this happens is when
        // we are in sync mode and a single promise is thrown both on initial render
        // and on update; we attach two .then(retrySuspendedRoot) callbacks and each
        // one performs Sync work, rerendering the Suspense.


        if ((boundaryFiber.mode & ConcurrentMode) !== NoContext) {
          if (root === nextRoot && nextRenderExpirationTime === suspendedTime) {
            // Received a ping at the same priority level at which we're currently
            // rendering. Restart from the root.
            nextRoot = null;
          }
        }

        scheduleWorkToRoot(boundaryFiber, retryTime);

        if ((boundaryFiber.mode & ConcurrentMode) === NoContext) {
          // Outside of concurrent mode, we must schedule an update on the source
          // fiber, too, since it already committed in an inconsistent state and
          // therefore does not have any pending work.
          scheduleWorkToRoot(sourceFiber, retryTime);
          var sourceTag = sourceFiber.tag;

          if (sourceTag === ClassComponent && sourceFiber.stateNode !== null) {
            // When we try rendering again, we should not reuse the current fiber,
            // since it's known to be in an inconsistent state. Use a force updte to
            // prevent a bail out.
            var update = createUpdate(retryTime);
            update.tag = ForceUpdate;
            enqueueUpdate(sourceFiber, update);
          }
        }

        var rootExpirationTime = root.expirationTime;

        if (rootExpirationTime !== NoWork) {
          requestWork(root, rootExpirationTime);
        }
      }

      function scheduleWorkToRoot(fiber, expirationTime) {
        recordScheduleUpdate();
        {
          if (fiber.tag === ClassComponent) {
            var instance = fiber.stateNode;
            warnAboutInvalidUpdates(instance);
          }
        } // Update the source fiber's expiration time

        if (fiber.expirationTime < expirationTime) {
          fiber.expirationTime = expirationTime;
        }

        var alternate = fiber.alternate;

        if (alternate !== null && alternate.expirationTime < expirationTime) {
          alternate.expirationTime = expirationTime;
        } // Walk the parent path to the root and update the child expiration time.


        var node = fiber.return;
        var root = null;

        if (node === null && fiber.tag === HostRoot) {
          root = fiber.stateNode;
        } else {
          while (node !== null) {
            alternate = node.alternate;

            if (node.childExpirationTime < expirationTime) {
              node.childExpirationTime = expirationTime;

              if (alternate !== null && alternate.childExpirationTime < expirationTime) {
                alternate.childExpirationTime = expirationTime;
              }
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) {
              alternate.childExpirationTime = expirationTime;
            }

            if (node.return === null && node.tag === HostRoot) {
              root = node.stateNode;
              break;
            }

            node = node.return;
          }
        }

        {
          if (root !== null) {
            var interactions = tracing$$1.__interactionsRef.current;

            if (interactions.size > 0) {
              var pendingInteractionMap = root.pendingInteractionMap;
              var pendingInteractions = pendingInteractionMap.get(expirationTime);

              if (pendingInteractions != null) {
                interactions.forEach(function (interaction) {
                  if (!pendingInteractions.has(interaction)) {
                    // Update the pending async work count for previously unscheduled interaction.
                    interaction.__count++;
                  }

                  pendingInteractions.add(interaction);
                });
              } else {
                pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.

                interactions.forEach(function (interaction) {
                  interaction.__count++;
                });
              }

              var subscriber = tracing$$1.__subscriberRef.current;

              if (subscriber !== null) {
                var threadID = computeThreadID(expirationTime, root.interactionThreadID);
                subscriber.onWorkScheduled(interactions, threadID);
              }
            }
          }
        }
        return root;
      }

      function scheduleWork(fiber, expirationTime) {
        var root = scheduleWorkToRoot(fiber, expirationTime);

        if (root === null) {
          {
            switch (fiber.tag) {
              case ClassComponent:
                warnAboutUpdateOnUnmounted(fiber, true);
                break;

              case FunctionComponent:
              case ForwardRef:
              case MemoComponent:
              case SimpleMemoComponent:
                warnAboutUpdateOnUnmounted(fiber, false);
                break;
            }
          }
          return;
        }

        if (!isWorking && nextRenderExpirationTime !== NoWork && expirationTime > nextRenderExpirationTime) {
          // This is an interruption. (Used for performance tracking.)
          interruptedBy = fiber;
          resetStack();
        }

        markPendingPriorityLevel(root, expirationTime);

        if ( // If we're in the render phase, we don't need to schedule this root
        // for an update, because we'll do it before we exit...
        !isWorking || isCommitting$1 || // ...unless this is a different root than the one we're rendering.
        nextRoot !== root) {
          var rootExpirationTime = root.expirationTime;
          requestWork(root, rootExpirationTime);
        }

        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          // Reset this back to zero so subsequent updates don't throw.
          nestedUpdateCount = 0;
          invariant(false, 'Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.');
        }
      }

      function deferredUpdates(fn) {
        var currentTime = requestCurrentTime();
        var previousExpirationContext = expirationContext;
        var previousIsBatchingInteractiveUpdates = isBatchingInteractiveUpdates;
        expirationContext = computeAsyncExpiration(currentTime);
        isBatchingInteractiveUpdates = false;

        try {
          return fn();
        } finally {
          expirationContext = previousExpirationContext;
          isBatchingInteractiveUpdates = previousIsBatchingInteractiveUpdates;
        }
      }

      function syncUpdates(fn, a, b, c, d) {
        var previousExpirationContext = expirationContext;
        expirationContext = Sync;

        try {
          return fn(a, b, c, d);
        } finally {
          expirationContext = previousExpirationContext;
        }
      } // TODO: Everything below this is written as if it has been lifted to the
      // renderers. I'll do this in a follow-up.
      // Linked-list of roots


      var firstScheduledRoot = null;
      var lastScheduledRoot = null;
      var callbackExpirationTime = NoWork;
      var callbackID = void 0;
      var isRendering = false;
      var nextFlushedRoot = null;
      var nextFlushedExpirationTime = NoWork;
      var lowestPriorityPendingInteractiveExpirationTime = NoWork;
      var hasUnhandledError = false;
      var unhandledError = null;
      var isBatchingUpdates = false;
      var isUnbatchingUpdates = false;
      var isBatchingInteractiveUpdates = false;
      var completedBatches = null;
      var originalStartTimeMs = now();
      var currentRendererTime = msToExpirationTime(originalStartTimeMs);
      var currentSchedulerTime = currentRendererTime; // Use these to prevent an infinite loop of nested updates

      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var lastCommittedRootDuringThisBatch = null;

      function recomputeCurrentRendererTime() {
        var currentTimeMs = now() - originalStartTimeMs;
        currentRendererTime = msToExpirationTime(currentTimeMs);
      }

      function scheduleCallbackWithExpirationTime(root, expirationTime) {
        if (callbackExpirationTime !== NoWork) {
          // A callback is already scheduled. Check its expiration time (timeout).
          if (expirationTime < callbackExpirationTime) {
            // Existing callback has sufficient timeout. Exit.
            return;
          } else {
            if (callbackID !== null) {
              // Existing callback has insufficient timeout. Cancel and schedule a
              // new one.
              cancelDeferredCallback(callbackID);
            }
          } // The request callback timer is already running. Don't start a new one.

        } else {
          startRequestCallbackTimer();
        }

        callbackExpirationTime = expirationTime;
        var currentMs = now() - originalStartTimeMs;
        var expirationTimeMs = expirationTimeToMs(expirationTime);
        var timeout = expirationTimeMs - currentMs;
        callbackID = scheduleDeferredCallback(performAsyncWork, {
          timeout: timeout
        });
      } // For every call to renderRoot, one of onFatal, onComplete, onSuspend, and
      // onYield is called upon exiting. We use these in lieu of returning a tuple.
      // I've also chosen not to inline them into renderRoot because these will
      // eventually be lifted into the renderer.


      function onFatal(root) {
        root.finishedWork = null;
      }

      function onComplete(root, finishedWork, expirationTime) {
        root.pendingCommitExpirationTime = expirationTime;
        root.finishedWork = finishedWork;
      }

      function onSuspend(root, finishedWork, suspendedExpirationTime, rootExpirationTime, msUntilTimeout) {
        root.expirationTime = rootExpirationTime;

        if (msUntilTimeout === 0 && !shouldYieldToRenderer()) {
          // Don't wait an additional tick. Commit the tree immediately.
          root.pendingCommitExpirationTime = suspendedExpirationTime;
          root.finishedWork = finishedWork;
        } else if (msUntilTimeout > 0) {
          // Wait `msUntilTimeout` milliseconds before committing.
          root.timeoutHandle = scheduleTimeout(onTimeout.bind(null, root, finishedWork, suspendedExpirationTime), msUntilTimeout);
        }
      }

      function onYield(root) {
        root.finishedWork = null;
      }

      function onTimeout(root, finishedWork, suspendedExpirationTime) {
        // The root timed out. Commit it.
        root.pendingCommitExpirationTime = suspendedExpirationTime;
        root.finishedWork = finishedWork; // Read the current time before entering the commit phase. We can be
        // certain this won't cause tearing related to batching of event updates
        // because we're at the top of a timer event.

        recomputeCurrentRendererTime();
        currentSchedulerTime = currentRendererTime;
        flushRoot(root, suspendedExpirationTime);
      }

      function onCommit(root, expirationTime) {
        root.expirationTime = expirationTime;
        root.finishedWork = null;
      }

      function requestCurrentTime() {
        // requestCurrentTime is called by the scheduler to compute an expiration
        // time.
        //
        // Expiration times are computed by adding to the current time (the start
        // time). However, if two updates are scheduled within the same event, we
        // should treat their start times as simultaneous, even if the actual clock
        // time has advanced between the first and second call.
        // In other words, because expiration times determine how updates are batched,
        // we want all updates of like priority that occur within the same event to
        // receive the same expiration time. Otherwise we get tearing.
        //
        // We keep track of two separate times: the current "renderer" time and the
        // current "scheduler" time. The renderer time can be updated whenever; it
        // only exists to minimize the calls performance.now.
        //
        // But the scheduler time can only be updated if there's no pending work, or
        // if we know for certain that we're not in the middle of an event.
        if (isRendering) {
          // We're already rendering. Return the most recently read time.
          return currentSchedulerTime;
        } // Check if there's pending work.


        findHighestPriorityRoot();

        if (nextFlushedExpirationTime === NoWork || nextFlushedExpirationTime === Never) {
          // If there's no pending work, or if the pending work is offscreen, we can
          // read the current time without risk of tearing.
          recomputeCurrentRendererTime();
          currentSchedulerTime = currentRendererTime;
          return currentSchedulerTime;
        } // There's already pending work. We might be in the middle of a browser
        // event. If we were to read the current time, it could cause multiple updates
        // within the same event to receive different expiration times, leading to
        // tearing. Return the last read time. During the next idle callback, the
        // time will be updated.


        return currentSchedulerTime;
      } // requestWork is called by the scheduler whenever a root receives an update.
      // It's up to the renderer to call renderRoot at some point in the future.


      function requestWork(root, expirationTime) {
        addRootToSchedule(root, expirationTime);

        if (isRendering) {
          // Prevent reentrancy. Remaining work will be scheduled at the end of
          // the currently rendering batch.
          return;
        }

        if (isBatchingUpdates) {
          // Flush work at the end of the batch.
          if (isUnbatchingUpdates) {
            // ...unless we're inside unbatchedUpdates, in which case we should
            // flush it now.
            nextFlushedRoot = root;
            nextFlushedExpirationTime = Sync;
            performWorkOnRoot(root, Sync, false);
          }

          return;
        } // TODO: Get rid of Sync and use current time?


        if (expirationTime === Sync) {
          performSyncWork();
        } else {
          scheduleCallbackWithExpirationTime(root, expirationTime);
        }
      }

      function addRootToSchedule(root, expirationTime) {
        // Add the root to the schedule.
        // Check if this root is already part of the schedule.
        if (root.nextScheduledRoot === null) {
          // This root is not already scheduled. Add it.
          root.expirationTime = expirationTime;

          if (lastScheduledRoot === null) {
            firstScheduledRoot = lastScheduledRoot = root;
            root.nextScheduledRoot = root;
          } else {
            lastScheduledRoot.nextScheduledRoot = root;
            lastScheduledRoot = root;
            lastScheduledRoot.nextScheduledRoot = firstScheduledRoot;
          }
        } else {
          // This root is already scheduled, but its priority may have increased.
          var remainingExpirationTime = root.expirationTime;

          if (expirationTime > remainingExpirationTime) {
            // Update the priority.
            root.expirationTime = expirationTime;
          }
        }
      }

      function findHighestPriorityRoot() {
        var highestPriorityWork = NoWork;
        var highestPriorityRoot = null;

        if (lastScheduledRoot !== null) {
          var previousScheduledRoot = lastScheduledRoot;
          var root = firstScheduledRoot;

          while (root !== null) {
            var remainingExpirationTime = root.expirationTime;

            if (remainingExpirationTime === NoWork) {
              // This root no longer has work. Remove it from the scheduler.
              // TODO: This check is redudant, but Flow is confused by the branch
              // below where we set lastScheduledRoot to null, even though we break
              // from the loop right after.
              !(previousScheduledRoot !== null && lastScheduledRoot !== null) ? invariant(false, 'Should have a previous and last root. This error is likely caused by a bug in React. Please file an issue.') : void 0;

              if (root === root.nextScheduledRoot) {
                // This is the only root in the list.
                root.nextScheduledRoot = null;
                firstScheduledRoot = lastScheduledRoot = null;
                break;
              } else if (root === firstScheduledRoot) {
                // This is the first root in the list.
                var next = root.nextScheduledRoot;
                firstScheduledRoot = next;
                lastScheduledRoot.nextScheduledRoot = next;
                root.nextScheduledRoot = null;
              } else if (root === lastScheduledRoot) {
                // This is the last root in the list.
                lastScheduledRoot = previousScheduledRoot;
                lastScheduledRoot.nextScheduledRoot = firstScheduledRoot;
                root.nextScheduledRoot = null;
                break;
              } else {
                previousScheduledRoot.nextScheduledRoot = root.nextScheduledRoot;
                root.nextScheduledRoot = null;
              }

              root = previousScheduledRoot.nextScheduledRoot;
            } else {
              if (remainingExpirationTime > highestPriorityWork) {
                // Update the priority, if it's higher
                highestPriorityWork = remainingExpirationTime;
                highestPriorityRoot = root;
              }

              if (root === lastScheduledRoot) {
                break;
              }

              if (highestPriorityWork === Sync) {
                // Sync is highest priority by definition so
                // we can stop searching.
                break;
              }

              previousScheduledRoot = root;
              root = root.nextScheduledRoot;
            }
          }
        }

        nextFlushedRoot = highestPriorityRoot;
        nextFlushedExpirationTime = highestPriorityWork;
      } // TODO: This wrapper exists because many of the older tests (the ones that use
      // flushDeferredPri) rely on the number of times `shouldYield` is called. We
      // should get rid of it.


      var didYield = false;

      function shouldYieldToRenderer() {
        if (didYield) {
          return true;
        }

        if (shouldYield()) {
          didYield = true;
          return true;
        }

        return false;
      }

      function performAsyncWork() {
        try {
          if (!shouldYieldToRenderer()) {
            // The callback timed out. That means at least one update has expired.
            // Iterate through the root schedule. If they contain expired work, set
            // the next render expiration time to the current time. This has the effect
            // of flushing all expired work in a single batch, instead of flushing each
            // level one at a time.
            if (firstScheduledRoot !== null) {
              recomputeCurrentRendererTime();
              var root = firstScheduledRoot;

              do {
                didExpireAtExpirationTime(root, currentRendererTime); // The root schedule is circular, so this is never null.

                root = root.nextScheduledRoot;
              } while (root !== firstScheduledRoot);
            }
          }

          performWork(NoWork, true);
        } finally {
          didYield = false;
        }
      }

      function performSyncWork() {
        performWork(Sync, false);
      }

      function performWork(minExpirationTime, isYieldy) {
        // Keep working on roots until there's no more work, or until there's a higher
        // priority event.
        findHighestPriorityRoot();

        if (isYieldy) {
          recomputeCurrentRendererTime();
          currentSchedulerTime = currentRendererTime;
          {
            var didExpire = nextFlushedExpirationTime > currentRendererTime;
            var timeout = expirationTimeToMs(nextFlushedExpirationTime);
            stopRequestCallbackTimer(didExpire, timeout);
          }

          while (nextFlushedRoot !== null && nextFlushedExpirationTime !== NoWork && minExpirationTime <= nextFlushedExpirationTime && !(didYield && currentRendererTime > nextFlushedExpirationTime)) {
            performWorkOnRoot(nextFlushedRoot, nextFlushedExpirationTime, currentRendererTime > nextFlushedExpirationTime);
            findHighestPriorityRoot();
            recomputeCurrentRendererTime();
            currentSchedulerTime = currentRendererTime;
          }
        } else {
          while (nextFlushedRoot !== null && nextFlushedExpirationTime !== NoWork && minExpirationTime <= nextFlushedExpirationTime) {
            performWorkOnRoot(nextFlushedRoot, nextFlushedExpirationTime, false);
            findHighestPriorityRoot();
          }
        } // We're done flushing work. Either we ran out of time in this callback,
        // or there's no more work left with sufficient priority.
        // If we're inside a callback, set this to false since we just completed it.


        if (isYieldy) {
          callbackExpirationTime = NoWork;
          callbackID = null;
        } // If there's work left over, schedule a new callback.


        if (nextFlushedExpirationTime !== NoWork) {
          scheduleCallbackWithExpirationTime(nextFlushedRoot, nextFlushedExpirationTime);
        } // Clean-up.


        finishRendering();
      }

      function flushRoot(root, expirationTime) {
        !!isRendering ? invariant(false, 'work.commit(): Cannot commit while already rendering. This likely means you attempted to commit from inside a lifecycle method.') : void 0; // Perform work on root as if the given expiration time is the current time.
        // This has the effect of synchronously flushing all work up to and
        // including the given time.

        nextFlushedRoot = root;
        nextFlushedExpirationTime = expirationTime;
        performWorkOnRoot(root, expirationTime, false); // Flush any sync work that was scheduled by lifecycles

        performSyncWork();
      }

      function finishRendering() {
        nestedUpdateCount = 0;
        lastCommittedRootDuringThisBatch = null;

        if (completedBatches !== null) {
          var batches = completedBatches;
          completedBatches = null;

          for (var i = 0; i < batches.length; i++) {
            var batch = batches[i];

            try {
              batch._onComplete();
            } catch (error) {
              if (!hasUnhandledError) {
                hasUnhandledError = true;
                unhandledError = error;
              }
            }
          }
        }

        if (hasUnhandledError) {
          var error = unhandledError;
          unhandledError = null;
          hasUnhandledError = false;
          throw error;
        }
      }

      function performWorkOnRoot(root, expirationTime, isYieldy) {
        !!isRendering ? invariant(false, 'performWorkOnRoot was called recursively. This error is likely caused by a bug in React. Please file an issue.') : void 0;
        isRendering = true; // Check if this is async work or sync/expired work.

        if (!isYieldy) {
          // Flush work without yielding.
          // TODO: Non-yieldy work does not necessarily imply expired work. A renderer
          // may want to perform some work without yielding, but also without
          // requiring the root to complete (by triggering placeholders).
          var finishedWork = root.finishedWork;

          if (finishedWork !== null) {
            // This root is already complete. We can commit it.
            completeRoot(root, finishedWork, expirationTime);
          } else {
            root.finishedWork = null; // If this root previously suspended, clear its existing timeout, since
            // we're about to try rendering again.

            var timeoutHandle = root.timeoutHandle;

            if (timeoutHandle !== noTimeout) {
              root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

              cancelTimeout(timeoutHandle);
            }

            renderRoot(root, isYieldy);
            finishedWork = root.finishedWork;

            if (finishedWork !== null) {
              // We've completed the root. Commit it.
              completeRoot(root, finishedWork, expirationTime);
            }
          }
        } else {
          // Flush async work.
          var _finishedWork = root.finishedWork;

          if (_finishedWork !== null) {
            // This root is already complete. We can commit it.
            completeRoot(root, _finishedWork, expirationTime);
          } else {
            root.finishedWork = null; // If this root previously suspended, clear its existing timeout, since
            // we're about to try rendering again.

            var _timeoutHandle = root.timeoutHandle;

            if (_timeoutHandle !== noTimeout) {
              root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

              cancelTimeout(_timeoutHandle);
            }

            renderRoot(root, isYieldy);
            _finishedWork = root.finishedWork;

            if (_finishedWork !== null) {
              // We've completed the root. Check the if we should yield one more time
              // before committing.
              if (!shouldYieldToRenderer()) {
                // Still time left. Commit the root.
                completeRoot(root, _finishedWork, expirationTime);
              } else {
                // There's no time left. Mark this root as complete. We'll come
                // back and commit it later.
                root.finishedWork = _finishedWork;
              }
            }
          }
        }

        isRendering = false;
      }

      function completeRoot(root, finishedWork, expirationTime) {
        // Check if there's a batch that matches this expiration time.
        var firstBatch = root.firstBatch;

        if (firstBatch !== null && firstBatch._expirationTime >= expirationTime) {
          if (completedBatches === null) {
            completedBatches = [firstBatch];
          } else {
            completedBatches.push(firstBatch);
          }

          if (firstBatch._defer) {
            // This root is blocked from committing by a batch. Unschedule it until
            // we receive another update.
            root.finishedWork = finishedWork;
            root.expirationTime = NoWork;
            return;
          }
        } // Commit the root.


        root.finishedWork = null; // Check if this is a nested update (a sync update scheduled during the
        // commit phase).

        if (root === lastCommittedRootDuringThisBatch) {
          // If the next root is the same as the previous root, this is a nested
          // update. To prevent an infinite loop, increment the nested update count.
          nestedUpdateCount++;
        } else {
          // Reset whenever we switch roots.
          lastCommittedRootDuringThisBatch = root;
          nestedUpdateCount = 0;
        }

        commitRoot(root, finishedWork);
      }

      function onUncaughtError(error) {
        !(nextFlushedRoot !== null) ? invariant(false, 'Should be working on a root. This error is likely caused by a bug in React. Please file an issue.') : void 0; // Unschedule this root so we don't work on it again until there's
        // another update.

        nextFlushedRoot.expirationTime = NoWork;

        if (!hasUnhandledError) {
          hasUnhandledError = true;
          unhandledError = error;
        }
      } // TODO: Batching should be implemented at the renderer level, not inside
      // the reconciler.


      function batchedUpdates(fn, a) {
        var previousIsBatchingUpdates = isBatchingUpdates;
        isBatchingUpdates = true;

        try {
          return fn(a);
        } finally {
          isBatchingUpdates = previousIsBatchingUpdates;

          if (!isBatchingUpdates && !isRendering) {
            performSyncWork();
          }
        }
      } // TODO: Batching should be implemented at the renderer level, not inside
      // the reconciler.


      function unbatchedUpdates(fn, a) {
        if (isBatchingUpdates && !isUnbatchingUpdates) {
          isUnbatchingUpdates = true;

          try {
            return fn(a);
          } finally {
            isUnbatchingUpdates = false;
          }
        }

        return fn(a);
      } // TODO: Batching should be implemented at the renderer level, not within
      // the reconciler.


      function flushSync(fn, a) {
        !!isRendering ? invariant(false, 'flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.') : void 0;
        var previousIsBatchingUpdates = isBatchingUpdates;
        isBatchingUpdates = true;

        try {
          return syncUpdates(fn, a);
        } finally {
          isBatchingUpdates = previousIsBatchingUpdates;
          performSyncWork();
        }
      }

      function interactiveUpdates(fn, a, b) {
        if (isBatchingInteractiveUpdates) {
          return fn(a, b);
        } // If there are any pending interactive updates, synchronously flush them.
        // This needs to happen before we read any handlers, because the effect of
        // the previous event may influence which handlers are called during
        // this event.


        if (!isBatchingUpdates && !isRendering && lowestPriorityPendingInteractiveExpirationTime !== NoWork) {
          // Synchronously flush pending interactive updates.
          performWork(lowestPriorityPendingInteractiveExpirationTime, false);
          lowestPriorityPendingInteractiveExpirationTime = NoWork;
        }

        var previousIsBatchingInteractiveUpdates = isBatchingInteractiveUpdates;
        var previousIsBatchingUpdates = isBatchingUpdates;
        isBatchingInteractiveUpdates = true;
        isBatchingUpdates = true;

        try {
          return fn(a, b);
        } finally {
          isBatchingInteractiveUpdates = previousIsBatchingInteractiveUpdates;
          isBatchingUpdates = previousIsBatchingUpdates;

          if (!isBatchingUpdates && !isRendering) {
            performSyncWork();
          }
        }
      }

      function flushInteractiveUpdates() {
        if (!isRendering && lowestPriorityPendingInteractiveExpirationTime !== NoWork) {
          // Synchronously flush pending interactive updates.
          performWork(lowestPriorityPendingInteractiveExpirationTime, false);
          lowestPriorityPendingInteractiveExpirationTime = NoWork;
        }
      }

      function flushControlled(fn) {
        var previousIsBatchingUpdates = isBatchingUpdates;
        isBatchingUpdates = true;

        try {
          syncUpdates(fn);
        } finally {
          isBatchingUpdates = previousIsBatchingUpdates;

          if (!isBatchingUpdates && !isRendering) {
            performSyncWork();
          }
        }
      } // 0 is PROD, 1 is DEV.
      // Might add PROFILE later.


      var didWarnAboutNestedUpdates = void 0;
      var didWarnAboutFindNodeInStrictMode = void 0;
      {
        didWarnAboutNestedUpdates = false;
        didWarnAboutFindNodeInStrictMode = {};
      }

      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }

        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);

        if (fiber.tag === ClassComponent) {
          var Component = fiber.type;

          if (isContextProvider(Component)) {
            return processChildContext(fiber, Component, parentContext);
          }
        }

        return parentContext;
      }

      function scheduleRootUpdate(current$$1, element, expirationTime, callback) {
        {
          if (phase === 'render' && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            warningWithoutStack$1(false, 'Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
          }
        }
        var update = createUpdate(expirationTime); // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: element
        };
        callback = callback === undefined ? null : callback;

        if (callback !== null) {
          !(typeof callback === 'function') ? warningWithoutStack$1(false, 'render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback) : void 0;
          update.callback = callback;
        }

        flushPassiveEffects();
        enqueueUpdate(current$$1, update);
        scheduleWork(current$$1, expirationTime);
        return expirationTime;
      }

      function updateContainerAtExpirationTime(element, container, parentComponent, expirationTime, callback) {
        // TODO: If this is a nested container, this won't be the root.
        var current$$1 = container.current;
        var context = getContextForSubtree(parentComponent);

        if (container.context === null) {
          container.context = context;
        } else {
          container.pendingContext = context;
        }

        return scheduleRootUpdate(current$$1, element, expirationTime, callback);
      }

      function findHostInstance(component) {
        var fiber = get(component);

        if (fiber === undefined) {
          if (typeof component.render === 'function') {
            invariant(false, 'Unable to find node on an unmounted component.');
          } else {
            invariant(false, 'Argument appears to not be a ReactComponent. Keys: %s', Object.keys(component));
          }
        }

        var hostFiber = findCurrentHostFiber(fiber);

        if (hostFiber === null) {
          return null;
        }

        return hostFiber.stateNode;
      }

      function findHostInstanceWithWarning(component, methodName) {
        {
          var fiber = get(component);

          if (fiber === undefined) {
            if (typeof component.render === 'function') {
              invariant(false, 'Unable to find node on an unmounted component.');
            } else {
              invariant(false, 'Argument appears to not be a ReactComponent. Keys: %s', Object.keys(component));
            }
          }

          var hostFiber = findCurrentHostFiber(fiber);

          if (hostFiber === null) {
            return null;
          }

          if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';

            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
              didWarnAboutFindNodeInStrictMode[componentName] = true;

              if (fiber.mode & StrictMode) {
                warningWithoutStack$1(false, '%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference.' + '\n%s' + '\n\nLearn more about using refs safely here:' + '\nhttps://fb.me/react-strict-mode-find-node', methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
              } else {
                warningWithoutStack$1(false, '%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference.' + '\n%s' + '\n\nLearn more about using refs safely here:' + '\nhttps://fb.me/react-strict-mode-find-node', methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
              }
            }
          }

          return hostFiber.stateNode;
        }
        return findHostInstance(component);
      }

      function createContainer(containerInfo, isConcurrent, hydrate) {
        return createFiberRoot(containerInfo, isConcurrent, hydrate);
      }

      function updateContainer(element, container, parentComponent, callback) {
        var current$$1 = container.current;
        var currentTime = requestCurrentTime();
        var expirationTime = computeExpirationForFiber(currentTime, current$$1);
        return updateContainerAtExpirationTime(element, container, parentComponent, expirationTime, callback);
      }

      function getPublicRootInstance(container) {
        var containerFiber = container.current;

        if (!containerFiber.child) {
          return null;
        }

        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);

          default:
            return containerFiber.child.stateNode;
        }
      }

      function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

        if (hostFiber === null) {
          return null;
        }

        return hostFiber.stateNode;
      }

      function injectIntoDevTools(devToolsConfig) {
        var _findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        return injectInternals(_assign({}, devToolsConfig, {
          findHostInstanceByFiber: function findHostInstanceByFiber(fiber) {
            var hostFiber = findCurrentHostFiber(fiber);

            if (hostFiber === null) {
              return null;
            }

            return hostFiber.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(instance) {
            if (!_findFiberByHostInstance) {
              // Might not be implemented by the renderer.
              return null;
            }

            return _findFiberByHostInstance(instance);
          }
        }));
      }

      var ReactFiberReconciler = Object.freeze({
        updateContainerAtExpirationTime: updateContainerAtExpirationTime,
        createContainer: createContainer,
        updateContainer: updateContainer,
        flushRoot: flushRoot,
        requestWork: requestWork,
        computeUniqueAsyncExpiration: computeUniqueAsyncExpiration,
        batchedUpdates: batchedUpdates,
        unbatchedUpdates: unbatchedUpdates,
        deferredUpdates: deferredUpdates,
        syncUpdates: syncUpdates,
        interactiveUpdates: interactiveUpdates,
        flushInteractiveUpdates: flushInteractiveUpdates,
        flushControlled: flushControlled,
        flushSync: flushSync,
        getPublicRootInstance: getPublicRootInstance,
        findHostInstance: findHostInstance,
        findHostInstanceWithWarning: findHostInstanceWithWarning,
        findHostInstanceWithNoPortals: findHostInstanceWithNoPortals,
        injectIntoDevTools: injectIntoDevTools
      }); // This entry point is intentionally not typed. It exists only for third-party
      // renderers. The renderers we ship (such as React DOM) instead import a named
      // "inline" entry point (for example, `react-reconciler/inline.dom`). It uses
      // the same code, but the Flow configuration redirects the host config to its
      // real implementation so we can check it against exact intended host types.
      //
      // Only one renderer (the one you passed to `yarn flow <renderer>`) is fully
      // type-checked at any given time. The Flow config maps the
      // `react-reconciler/inline.<renderer>` import (which is *not* Flow typed) to
      // `react-reconciler/inline-typed` (which *is*) for the current renderer.
      // On CI, we run Flow checks for each renderer separately.
      // TODO: decide on the top-level export form.
      // This is hacky but makes it work with both Rollup and Jest.

      var reactReconciler = ReactFiberReconciler.default || ReactFiberReconciler;
      module.exports = reactReconciler;
      var $$$renderer = module.exports;
      module.exports = $$$reconciler;
      return $$$renderer;
    };
  }
});
var reactReconciler = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactReconciler_production_min;
  } else {
    module.exports = reactReconciler_development;
  }
});
/**
 * react-babylonjs
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var __extends$3 = undefined && undefined.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign$2 = undefined && undefined.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest$1 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}; // TODO: build a fallback mechanism when typeof React.createContext !== 'function'


var SceneContext = createContext({
  engine: null,
  canvas: null,
  scene: null
});

function withScene(Component) {
  return function BoundComponent(props) {
    return React.createElement(SceneContext.Consumer, null, function (ctx) {
      return React.createElement(Component, __assign$2({}, props, {
        sceneContext: ctx
      }));
    });
  };
}

var Scene =
/** @class */
function (_super) {
  __extends$3(Scene, _super);

  function Scene() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._scene = null;
    _this._pointerDownObservable = null;
    _this._pointerUpObservable = null;
    _this._pointerMoveObservable = null;
    _this._reactReconcilerBabylonJs = reactReconciler(ReactBabylonJSHostConfig);
    return _this;
  }

  Scene.prototype.componentDidMount = function () {
    var _this = this;

    var _a = this.props,
        babylonJSContext = _a.babylonJSContext,
        children = _a.children,
        options = __rest$1(_a, ["babylonJSContext", "children"]);

    if (!babylonJSContext) {
      // we could try to create one here with existing props (ie: backwards compat?)
      console.error('You are creating a scene without an Engine.  \'SceneOnly\' will only work as a child of Engine, use \'Scene\' otherwise.');
    } else {
      var engine = babylonJSContext.engine
      /*, canvas */
      ;
      this._scene = new BABYLON.Scene(engine);
      var updates = new FiberScenePropsHandler().getPropertyUpdates(this._scene, {}, this.props, this._scene);

      if (updates != null) {
        updates.forEach(function (propertyUpdate) {
          applyUpdateToInstance(_this._scene, propertyUpdate, 'scene');
        });
      }
    }

    if (options.clearColor) {
      this._scene.clearColor = options.clearColor;
    } // TODO: Add keypress and other PointerEventTypes:


    this._pointerDownObservable = this._scene.onPointerObservable.add(function (evt) {
      if (typeof _this.props.onScenePointerDown === 'function') {
        _this.props.onScenePointerDown(evt, _this._scene);
      }

      if (evt && evt.pickInfo && evt.pickInfo.hit && evt.pickInfo.pickedMesh) {
        var mesh = evt.pickInfo.pickedMesh;

        if (typeof _this.props.onMeshPicked === 'function') {
          _this.props.onMeshPicked(mesh, _this._scene);
        }
      }
    }, PointerEventTypes.POINTERDOWN); // can only be assigned on init

    if (typeof this.props.onScenePointerUp === 'function') {
      this._pointerUpObservable = this._scene.onPointerObservable.add(function (evt) {
        _this.props.onScenePointerUp(evt, _this._scene);
      }, PointerEventTypes.POINTERUP);
    } // can only be assigned on init


    if (typeof this.props.onScenePointerMove === 'function') {
      this._pointerMoveObservable = this._scene.onPointerObservable.add(function (evt) {
        _this.props.onScenePointerMove(evt, _this._scene);
      }, PointerEventTypes.POINTERMOVE);
    }

    if (typeof this.props.onSceneMount === 'function') {
      this.props.onSceneMount({
        scene: this._scene,
        canvas: this._scene.getEngine().getRenderingCanvas()
      }); // TODO: console.error if canvas is not attached. runRenderLoop() is expected to be part of onSceneMount().
    }

    var isAsync = false; // Disables experimental async rendering

    var container = {
      engine: this.props.babylonJSContext.engine,
      canvas: this.props.babylonJSContext.canvas,
      scene: this._scene,
      rootInstance: {
        hostInstance: null,
        children: [],
        parent: null,
        metadata: {
          className: "root"
        },
        customProps: {}
      }
    };
    this._fiberRoot = this._reactReconcilerBabylonJs.createContainer(container, isAsync, false
    /* hydrate true == better HMR? */
    );

    this._reactReconcilerBabylonJs.injectIntoDevTools({
      bundleType: process.env.NODE_ENV === 'production' ? 0 : 1,
      version: '1.0.0',
      rendererPackageName: 'react-babylonjs'
    }); // update the root Container
    // console.log("updating rootContainer (1) reactElement")


    return this._reactReconcilerBabylonJs.updateContainer(React.createElement(SceneContext.Provider, {
      value: {
        engine: this.props.babylonJSContext.engine,
        canvas: this.props.babylonJSContext.canvas,
        scene: this._scene
      }
    }, this.props.children), this._fiberRoot, undefined
    /* TODO: try to dual-write for screen readers */
    , function () {});
  };

  Scene.prototype.componentDidUpdate = function (prevProps, prevState) {
    // In the docs it is mentioned that shouldComponentUpdate() may be treated as a hint one day
    // avoid shouldComponentUpdate() => false, looks okay, but prop changes will lag behind 1 update.
    this._reactReconcilerBabylonJs.updateContainer(React.createElement(SceneContext.Provider, {
      value: {
        engine: this.props.babylonJSContext.engine,
        canvas: this.props.babylonJSContext.canvas,
        scene: this._scene
      }
    }, this.props.children), this._fiberRoot, undefined, function () {});
  };

  Scene.prototype.componentWillUnmount = function () {
    if (this._pointerDownObservable != null) {
      this._scene.onPointerObservable.remove(this._pointerDownObservable);
    }

    if (this._pointerUpObservable != null) {
      this._scene.onPointerObservable.remove(this._pointerUpObservable);
    }

    if (this._pointerMoveObservable != null) {
      this._scene.onPointerObservable.remove(this._pointerMoveObservable);
    }

    this._scene.dispose();
  };

  Scene.prototype.render = function () {
    return null;
  };

  return Scene;
}(React.Component); // TODO: export a SceneOnly without engine and have this class create a default engine when not present.
// for backwards compatibility we export a scene with an Engine.  Engine is only needed with multi-scene.


var Scene$1 = withBabylonJS(Scene);
export { Engine$1 as Engine, withBabylonJS, Scene$1 as Scene, withScene, HostWithEvents, Model, FiberNodeProps, FiberNodePropsHandler, FiberNode, FiberTransformNodeProps, FiberTransformNodePropsHandler, FiberTransformNode, FiberAbstractMeshProps, FiberAbstractMeshPropsHandler, FiberAbstractMesh, FiberMeshProps, FiberMeshPropsHandler, FiberMesh, FiberCameraProps, FiberCameraPropsHandler, FiberCamera, FiberTargetCameraProps, FiberTargetCameraPropsHandler, FiberTargetCamera, FiberArcRotateCameraProps, FiberArcRotateCameraPropsHandler, FiberArcRotateCamera, FiberVRDeviceOrientationArcRotateCameraProps, FiberVRDeviceOrientationArcRotateCameraPropsHandler, FiberVRDeviceOrientationArcRotateCamera, FiberAnaglyphArcRotateCameraProps, FiberAnaglyphArcRotateCameraPropsHandler, FiberAnaglyphArcRotateCamera, FiberStereoscopicArcRotateCameraProps, FiberStereoscopicArcRotateCameraPropsHandler, FiberStereoscopicArcRotateCamera, FiberFlyCameraProps, FiberFlyCameraPropsHandler, FiberFlyCamera, FiberFollowCameraProps, FiberFollowCameraPropsHandler, FiberFollowCamera, FiberArcFollowCameraProps, FiberArcFollowCameraPropsHandler, FiberArcFollowCamera, FiberFreeCameraProps, FiberFreeCameraPropsHandler, FiberFreeCamera, FiberDeviceOrientationCameraProps, FiberDeviceOrientationCameraPropsHandler, FiberDeviceOrientationCamera, FiberVRDeviceOrientationFreeCameraProps, FiberVRDeviceOrientationFreeCameraPropsHandler, FiberVRDeviceOrientationFreeCamera, FiberVRDeviceOrientationGamepadCameraProps, FiberVRDeviceOrientationGamepadCameraPropsHandler, FiberVRDeviceOrientationGamepadCamera, FiberTouchCameraProps, FiberTouchCameraPropsHandler, FiberTouchCamera, FiberUniversalCameraProps, FiberUniversalCameraPropsHandler, FiberUniversalCamera, FiberGamepadCameraProps, FiberGamepadCameraPropsHandler, FiberGamepadCamera, FiberAnaglyphGamepadCameraProps, FiberAnaglyphGamepadCameraPropsHandler, FiberAnaglyphGamepadCamera, FiberStereoscopicGamepadCameraProps, FiberStereoscopicGamepadCameraPropsHandler, FiberStereoscopicGamepadCamera, FiberAnaglyphUniversalCameraProps, FiberAnaglyphUniversalCameraPropsHandler, FiberAnaglyphUniversalCamera, FiberStereoscopicUniversalCameraProps, FiberStereoscopicUniversalCameraPropsHandler, FiberStereoscopicUniversalCamera, FiberVirtualJoysticksCameraProps, FiberVirtualJoysticksCameraPropsHandler, FiberVirtualJoysticksCamera, FiberWebVRFreeCameraProps, FiberWebVRFreeCameraPropsHandler, FiberWebVRFreeCamera, FiberAnaglyphFreeCameraProps, FiberAnaglyphFreeCameraPropsHandler, FiberAnaglyphFreeCamera, FiberStereoscopicFreeCameraProps, FiberStereoscopicFreeCameraPropsHandler, FiberStereoscopicFreeCamera, FiberWebXRCameraProps, FiberWebXRCameraPropsHandler, FiberWebXRCamera, FiberBox, FiberSphere, FiberDisc, FiberIcoSphere, FiberRibbon, FiberCylinder, FiberTorus, FiberTorusKnot, FiberLineSystem, FiberLines, FiberDashedLines, FiberExtrudeShape, FiberExtrudeShapeCustom, FiberLathe, FiberPlane, FiberGround, FiberTiledGround, FiberGroundFromHeightMap, FiberPolygon, FiberExtrudePolygon, FiberTube, FiberPolyhedron, FiberDecal, FiberMaterialProps, FiberMaterialPropsHandler, FiberMaterial, FiberMultiMaterialProps, FiberMultiMaterialPropsHandler, FiberMultiMaterial, FiberPushMaterialProps, FiberPushMaterialPropsHandler, FiberPushMaterial, FiberStandardMaterialProps, FiberStandardMaterialPropsHandler, FiberStandardMaterial, FiberBackgroundMaterialProps, FiberBackgroundMaterialPropsHandler, FiberBackgroundMaterial, FiberPBRBaseMaterialProps, FiberPBRBaseMaterialPropsHandler, FiberPBRBaseMaterial, FiberPBRBaseSimpleMaterialProps, FiberPBRBaseSimpleMaterialPropsHandler, FiberPBRBaseSimpleMaterial, FiberPBRMetallicRoughnessMaterialProps, FiberPBRMetallicRoughnessMaterialPropsHandler, FiberPBRMetallicRoughnessMaterial, FiberPBRSpecularGlossinessMaterialProps, FiberPBRSpecularGlossinessMaterialPropsHandler, FiberPBRSpecularGlossinessMaterial, FiberPBRMaterialProps, FiberPBRMaterialPropsHandler, FiberPBRMaterial, FiberShaderMaterialProps, FiberShaderMaterialPropsHandler, FiberShaderMaterial, FiberLightProps, FiberLightPropsHandler, FiberLight, FiberHemisphericLightProps, FiberHemisphericLightPropsHandler, FiberHemisphericLight, FiberShadowLightProps, FiberShadowLightPropsHandler, FiberShadowLight, FiberDirectionalLightProps, FiberDirectionalLightPropsHandler, FiberDirectionalLight, FiberPointLightProps, FiberPointLightPropsHandler, FiberPointLight, FiberSpotLightProps, FiberSpotLightPropsHandler, FiberSpotLight, FiberControlProps, FiberControlPropsHandler, FiberControl, FiberCheckboxProps, FiberCheckboxPropsHandler, FiberCheckbox, FiberColorPickerProps, FiberColorPickerPropsHandler, FiberColorPicker, FiberContainerProps, FiberContainerPropsHandler, FiberContainer, FiberEllipseProps, FiberEllipsePropsHandler, FiberEllipse, FiberGridProps, FiberGridPropsHandler, FiberGrid, FiberStackPanelProps, FiberStackPanelPropsHandler, FiberStackPanel, FiberVirtualKeyboardProps, FiberVirtualKeyboardPropsHandler, FiberVirtualKeyboard, FiberRectangleProps, FiberRectanglePropsHandler, FiberRectangle, FiberButtonProps, FiberButtonPropsHandler, FiberButton, FiberSelectionPanelProps, FiberSelectionPanelPropsHandler, FiberSelectionPanel, FiberScrollViewerProps, FiberScrollViewerPropsHandler, FiberScrollViewer, FiberImageProps, FiberImagePropsHandler, FiberImage, FiberInputTextProps, FiberInputTextPropsHandler, FiberInputText, FiberInputPasswordProps, FiberInputPasswordPropsHandler, FiberInputPassword, FiberLineProps, FiberLinePropsHandler, FiberLine, FiberMultiLineProps, FiberMultiLinePropsHandler, FiberMultiLine, FiberRadioButtonProps, FiberRadioButtonPropsHandler, FiberRadioButton, FiberTextBlockProps, FiberTextBlockPropsHandler, FiberTextBlock, FiberDisplayGridProps, FiberDisplayGridPropsHandler, FiberDisplayGrid, FiberBaseSliderProps, FiberBaseSliderPropsHandler, FiberBaseSlider, FiberSliderProps, FiberSliderPropsHandler, FiberSlider, FiberImageBasedSliderProps, FiberImageBasedSliderPropsHandler, FiberImageBasedSlider, FiberControl3DProps, FiberControl3DPropsHandler, FiberControl3D, FiberAbstractButton3DProps, FiberAbstractButton3DPropsHandler, FiberAbstractButton3D, FiberButton3DProps, FiberButton3DPropsHandler, FiberButton3D, FiberHolographicButtonProps, FiberHolographicButtonPropsHandler, FiberHolographicButton, FiberMeshButton3DProps, FiberMeshButton3DPropsHandler, FiberMeshButton3D, FiberContainer3DProps, FiberContainer3DPropsHandler, FiberContainer3D, FiberStackPanel3DProps, FiberStackPanel3DPropsHandler, FiberStackPanel3D, FiberVolumeBasedPanelProps, FiberVolumeBasedPanelPropsHandler, FiberVolumeBasedPanel, FiberCylinderPanelProps, FiberCylinderPanelPropsHandler, FiberCylinderPanel, FiberPlanePanelProps, FiberPlanePanelPropsHandler, FiberPlanePanel, FiberScatterPanelProps, FiberScatterPanelPropsHandler, FiberScatterPanel, FiberSpherePanelProps, FiberSpherePanelPropsHandler, FiberSpherePanel, FiberBaseTextureProps, FiberBaseTexturePropsHandler, FiberBaseTexture, FiberColorGradingTextureProps, FiberColorGradingTexturePropsHandler, FiberColorGradingTexture, FiberCubeTextureProps, FiberCubeTexturePropsHandler, FiberCubeTexture, FiberRawCubeTextureProps, FiberRawCubeTexturePropsHandler, FiberRawCubeTexture, FiberHDRCubeTextureProps, FiberHDRCubeTexturePropsHandler, FiberHDRCubeTexture, FiberTextureProps, FiberTexturePropsHandler, FiberTexture, FiberDynamicTextureProps, FiberDynamicTexturePropsHandler, FiberDynamicTexture, FiberRawTextureProps, FiberRawTexturePropsHandler, FiberRawTexture, FiberRawTexture3DProps, FiberRawTexture3DPropsHandler, FiberRawTexture3D, FiberRenderTargetTextureProps, FiberRenderTargetTexturePropsHandler, FiberRenderTargetTexture, FiberMirrorTextureProps, FiberMirrorTexturePropsHandler, FiberMirrorTexture, FiberMultiRenderTargetProps, FiberMultiRenderTargetPropsHandler, FiberMultiRenderTarget, FiberRefractionTextureProps, FiberRefractionTexturePropsHandler, FiberRefractionTexture, FiberVideoTextureProps, FiberVideoTexturePropsHandler, FiberVideoTexture, FiberProceduralTextureProps, FiberProceduralTexturePropsHandler, FiberProceduralTexture, FiberCustomProceduralTextureProps, FiberCustomProceduralTexturePropsHandler, FiberCustomProceduralTexture, FiberNoiseProceduralTextureProps, FiberNoiseProceduralTexturePropsHandler, FiberNoiseProceduralTexture, FiberAdvancedDynamicTextureProps, FiberAdvancedDynamicTexturePropsHandler, FiberAdvancedDynamicTexture, FiberGUI3DManagerProps, FiberGUI3DManagerPropsHandler, FiberGUI3DManager, FiberShadowGeneratorProps, FiberShadowGeneratorPropsHandler, FiberShadowGenerator, FiberEnvironmentHelperProps, FiberEnvironmentHelperPropsHandler, FiberEnvironmentHelper, FiberVRExperienceHelperProps, FiberVRExperienceHelperPropsHandler, FiberVRExperienceHelper, FiberSceneProps, FiberScenePropsHandler, AbstractButton3D, AbstractMesh$1 as AbstractMesh, AdvancedDynamicTexture, AnaglyphArcRotateCamera, AnaglyphFreeCamera, AnaglyphGamepadCamera, AnaglyphUniversalCamera, ArcFollowCamera, ArcRotateCamera, BackgroundMaterial, BaseSlider, BaseTexture, Box, Button, Button3D, Camera, Checkbox, ColorGradingTexture, ColorPicker, Container, Container3D, Control, Control3D, CubeTexture, CustomProceduralTexture, Cylinder, CylinderPanel, DashedLines, Decal, DeviceOrientationCamera, DirectionalLight, Disc, DisplayGrid, DynamicTexture, Ellipse, EnvironmentHelper, ExtrudePolygon, ExtrudeShape, ExtrudeShapeCustom, FlyCamera, FollowCamera, FreeCamera, GUI3DManager, GamepadCamera, Grid, Ground, GroundFromHeightMap, HDRCubeTexture, HemisphericLight, HolographicButton, IcoSphere, Image, ImageBasedSlider, InputPassword, InputText, Lathe, Light, Line, LineSystem, Lines, Material, Mesh, MeshButton3D, MirrorTexture, MultiLine, MultiMaterial, MultiRenderTarget, Node, NoiseProceduralTexture, PBRBaseMaterial, PBRBaseSimpleMaterial, PBRMaterial, PBRMetallicRoughnessMaterial, PBRSpecularGlossinessMaterial, Plane, PlanePanel, PointLight, Polygon, Polyhedron, ProceduralTexture, PushMaterial, RadioButton, RawCubeTexture, RawTexture, RawTexture3D, Rectangle, RefractionTexture, RenderTargetTexture, Ribbon, ScatterPanel, ScrollViewer, SelectionPanel, ShaderMaterial, ShadowGenerator$1 as ShadowGenerator, ShadowLight, Slider, Sphere, SpherePanel, SpotLight, StackPanel, StackPanel3D, StandardMaterial$1 as StandardMaterial, StereoscopicArcRotateCamera, StereoscopicFreeCamera, StereoscopicGamepadCamera, StereoscopicUniversalCamera, TargetCamera, TextBlock, Texture$1 as Texture, TiledGround, Torus, TorusKnot, TouchCamera, TransformNode, Tube, UniversalCamera, VRDeviceOrientationArcRotateCamera, VRDeviceOrientationFreeCamera, VRDeviceOrientationGamepadCamera, VRExperienceHelper, VideoTexture, VirtualJoysticksCamera, VirtualKeyboard, VolumeBasedPanel, WebVRFreeCamera, WebXRCamera, AdvancedDynamicTextureLifecycleListener, CameraLifecycleListener, EnvironmentHelperLifecycleListener, GUI2DControlLifecycleListener, GUI3DControlLifecycleListener, GUI3DManagerLifecycleListener, MaterialsLifecycleListener, MeshLifecycleListener, ModelLifecycleListener, AdvancedDynamicTextureLifecycleListener$1 as ShadowGeneratorLifecycleListener, Skybox, TargetPropsHandler, TexturesLifecycleListener, VRExperienceHelperLifecycleListener };